/*!
 * Chart.js
 * http://chartjs.org/
 * Version: 1.0.1
 *
 * Copyright 2015 Nick Downie
 * Released under the MIT license
 * https://github.com/nnnick/Chart.js/blob/master/LICENSE.md
 */


(function(){

	"use strict";

	//Declare root variable - window in the browser, global on the server
	var root = this,
		previous = root.Chart;

	//Occupy the global variable of Chart, and create a simple base class
	var Chart = function(context){
		var chart = this;
		this.canvas = context.canvas;

		this.ctx = context;

		//Variables global to the chart
		var computeDimension = function(element,dimension)
		{
			if (element['offset'+dimension])
			{
				return element['offset'+dimension];
			}
			else
			{
				return document.defaultView.getComputedStyle(element).getPropertyValue(dimension);
			}
		}

		var width = this.width = computeDimension(context.canvas,'Width');
		var height = this.height = computeDimension(context.canvas,'Height');

		// Firefox requires this to work correctly
		context.canvas.width  = width;
		context.canvas.height = height;

		this.aspectRatio = this.width / this.height;
		//High pixel density displays - multiply the size of the canvas height/width by the device pixel ratio, then scale.
		helpers.retinaScale(this);

		return this;
	};
	//Globally expose the defaults to allow for user updating/changing
	Chart.defaults = {
		global: {
			// Boolean - Whether to animate the chart
			animation: true,

			// Number - Number of animation steps
			animationSteps: 60,

			// String - Animation easing effect
			animationEasing: "easeOutQuart",

			// Boolean - If we should show the scale at all
			showScale: true,

			// Boolean - If we want to override with a hard coded scale
			scaleOverride: false,

			// ** Required if scaleOverride is true **
			// Number - The number of steps in a hard coded scale
			scaleSteps: null,
			// Number - The value jump in the hard coded scale
			scaleStepWidth: null,
			// Number - The scale starting value
			scaleStartValue: null,

			// String - Colour of the scale line
			scaleLineColor: "rgba(0,0,0,.1)",

			// Number - Pixel width of the scale line
			scaleLineWidth: 1,

			// Boolean - Whether to show labels on the scale
			scaleShowLabels: true,

			// Interpolated JS string - can access value
			scaleLabel: "<%=value%>",

			// Boolean - Whether the scale should stick to integers, and not show any floats even if drawing space is there
			scaleIntegersOnly: true,

			// Boolean - Whether the scale should start at zero, or an order of magnitude down from the lowest value
			scaleBeginAtZero: false,

			// String - Scale label font declaration for the scale label
			scaleFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",

			// Number - Scale label font size in pixels
			scaleFontSize: 12,

			// String - Scale label font weight style
			scaleFontStyle: "normal",

			// String - Scale label font colour
			scaleFontColor: "#666",

			// Boolean - whether or not the chart should be responsive and resize when the browser does.
			responsive: false,

			// Boolean - whether to maintain the starting aspect ratio or not when responsive, if set to false, will take up entire container
			maintainAspectRatio: true,

			// Boolean - Determines whether to draw tooltips on the canvas or not - attaches events to touchmove & mousemove
			showTooltips: true,

			// Boolean - Determines whether to draw built-in tooltip or call custom tooltip function
			customTooltips: false,

			// Array - Array of string names to attach tooltip events
			tooltipEvents: ["mousemove", "touchstart", "touchmove", "mouseout"],

			// String - Tooltip background colour
			tooltipFillColor: "rgba(0,0,0,0.8)",

			// String - Tooltip label font declaration for the scale label
			tooltipFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",

			// Number - Tooltip label font size in pixels
			tooltipFontSize: 14,

			// String - Tooltip font weight style
			tooltipFontStyle: "normal",

			// String - Tooltip label font colour
			tooltipFontColor: "#fff",

			// String - Tooltip title font declaration for the scale label
			tooltipTitleFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",

			// Number - Tooltip title font size in pixels
			tooltipTitleFontSize: 14,

			// String - Tooltip title font weight style
			tooltipTitleFontStyle: "bold",

			// String - Tooltip title font colour
			tooltipTitleFontColor: "#fff",

			// Number - pixel width of padding around tooltip text
			tooltipYPadding: 6,

			// Number - pixel width of padding around tooltip text
			tooltipXPadding: 6,

			// Number - Size of the caret on the tooltip
			tooltipCaretSize: 8,

			// Number - Pixel radius of the tooltip border
			tooltipCornerRadius: 6,

			// Number - Pixel offset from point x to tooltip edge
			tooltipXOffset: 10,

			// String - Template string for single tooltips
			tooltipTemplate: "<%if (label){%><%=label%>: <%}%><%= value %>",

			// String - Template string for single tooltips
			multiTooltipTemplate: "<%= value %>",

			// String - Colour behind the legend colour block
			multiTooltipKeyBackground: '#fff',

			// Function - Will fire on animation progression.
			onAnimationProgress: function(){},

			// Function - Will fire on animation completion.
			onAnimationComplete: function(){}

		}
	};

	//Create a dictionary of chart types, to allow for extension of existing types
	Chart.types = {};

	//Global Chart helpers object for utility methods and classes
	var helpers = Chart.helpers = {};

		//-- Basic js utility methods
	var each = helpers.each = function(loopable,callback,self){
			var additionalArgs = Array.prototype.slice.call(arguments, 3);
			// Check to see if null or undefined firstly.
			if (loopable){
				if (loopable.length === +loopable.length){
					var i;
					for (i=0; i<loopable.length; i++){
						callback.apply(self,[loopable[i], i].concat(additionalArgs));
					}
				}
				else{
					for (var item in loopable){
						callback.apply(self,[loopable[item],item].concat(additionalArgs));
					}
				}
			}
		},
		clone = helpers.clone = function(obj){
			var objClone = {};
			each(obj,function(value,key){
				if (obj.hasOwnProperty(key)) objClone[key] = value;
			});
			return objClone;
		},
		extend = helpers.extend = function(base){
			each(Array.prototype.slice.call(arguments,1), function(extensionObject) {
				each(extensionObject,function(value,key){
					if (extensionObject.hasOwnProperty(key)) base[key] = value;
				});
			});
			return base;
		},
		merge = helpers.merge = function(base,master){
			//Merge properties in left object over to a shallow clone of object right.
			var args = Array.prototype.slice.call(arguments,0);
			args.unshift({});
			return extend.apply(null, args);
		},
		indexOf = helpers.indexOf = function(arrayToSearch, item){
			if (Array.prototype.indexOf) {
				return arrayToSearch.indexOf(item);
			}
			else{
				for (var i = 0; i < arrayToSearch.length; i++) {
					if (arrayToSearch[i] === item) return i;
				}
				return -1;
			}
		},
		where = helpers.where = function(collection, filterCallback){
			var filtered = [];

			helpers.each(collection, function(item){
				if (filterCallback(item)){
					filtered.push(item);
				}
			});

			return filtered;
		},
		findNextWhere = helpers.findNextWhere = function(arrayToSearch, filterCallback, startIndex){
			// Default to start of the array
			if (!startIndex){
				startIndex = -1;
			}
			for (var i = startIndex + 1; i < arrayToSearch.length; i++) {
				var currentItem = arrayToSearch[i];
				if (filterCallback(currentItem)){
					return currentItem;
				}
			}
		},
		findPreviousWhere = helpers.findPreviousWhere = function(arrayToSearch, filterCallback, startIndex){
			// Default to end of the array
			if (!startIndex){
				startIndex = arrayToSearch.length;
			}
			for (var i = startIndex - 1; i >= 0; i--) {
				var currentItem = arrayToSearch[i];
				if (filterCallback(currentItem)){
					return currentItem;
				}
			}
		},
		inherits = helpers.inherits = function(extensions){
			//Basic javascript inheritance based on the model created in Backbone.js
			var parent = this;
			var ChartElement = (extensions && extensions.hasOwnProperty("constructor")) ? extensions.constructor : function(){ return parent.apply(this, arguments); };

			var Surrogate = function(){ this.constructor = ChartElement;};
			Surrogate.prototype = parent.prototype;
			ChartElement.prototype = new Surrogate();

			ChartElement.extend = inherits;

			if (extensions) extend(ChartElement.prototype, extensions);

			ChartElement.__super__ = parent.prototype;

			return ChartElement;
		},
		noop = helpers.noop = function(){},
		uid = helpers.uid = (function(){
			var id=0;
			return function(){
				return "chart-" + id++;
			};
		})(),
		warn = helpers.warn = function(str){
			//Method for warning of errors
			if (window.console && typeof window.console.warn == "function") console.warn(str);
		},
		amd = helpers.amd = (typeof define == 'function' && define.amd),
		//-- Math methods
		isNumber = helpers.isNumber = function(n){
			return !isNaN(parseFloat(n)) && isFinite(n);
		},
		max = helpers.max = function(array){
			return Math.max.apply( Math, array );
		},
		min = helpers.min = function(array){
			return Math.min.apply( Math, array );
		},
		cap = helpers.cap = function(valueToCap,maxValue,minValue){
			if(isNumber(maxValue)) {
				if( valueToCap > maxValue ) {
					return maxValue;
				}
			}
			else if(isNumber(minValue)){
				if ( valueToCap < minValue ){
					return minValue;
				}
			}
			return valueToCap;
		},
		getDecimalPlaces = helpers.getDecimalPlaces = function(num){
			if (num%1!==0 && isNumber(num)){
				return num.toString().split(".")[1].length;
			}
			else {
				return 0;
			}
		},
		toRadians = helpers.radians = function(degrees){
			return degrees * (Math.PI/180);
		},
		// Gets the angle from vertical upright to the point about a centre.
		getAngleFromPoint = helpers.getAngleFromPoint = function(centrePoint, anglePoint){
			var distanceFromXCenter = anglePoint.x - centrePoint.x,
				distanceFromYCenter = anglePoint.y - centrePoint.y,
				radialDistanceFromCenter = Math.sqrt( distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);


			var angle = Math.PI * 2 + Math.atan2(distanceFromYCenter, distanceFromXCenter);

			//If the segment is in the top left quadrant, we need to add another rotation to the angle
			if (distanceFromXCenter < 0 && distanceFromYCenter < 0){
				angle += Math.PI*2;
			}

			return {
				angle: angle,
				distance: radialDistanceFromCenter
			};
		},
		aliasPixel = helpers.aliasPixel = function(pixelWidth){
			return (pixelWidth % 2 === 0) ? 0 : 0.5;
		},
		splineCurve = helpers.splineCurve = function(FirstPoint,MiddlePoint,AfterPoint,t){
			//Props to Rob Spencer at scaled innovation for his post on splining between points
			//http://scaledinnovation.com/analytics/splines/aboutSplines.html
			var d01=Math.sqrt(Math.pow(MiddlePoint.x-FirstPoint.x,2)+Math.pow(MiddlePoint.y-FirstPoint.y,2)),
				d12=Math.sqrt(Math.pow(AfterPoint.x-MiddlePoint.x,2)+Math.pow(AfterPoint.y-MiddlePoint.y,2)),
				fa=t*d01/(d01+d12),// scaling factor for triangle Ta
				fb=t*d12/(d01+d12);
			return {
				inner : {
					x : MiddlePoint.x-fa*(AfterPoint.x-FirstPoint.x),
					y : MiddlePoint.y-fa*(AfterPoint.y-FirstPoint.y)
				},
				outer : {
					x: MiddlePoint.x+fb*(AfterPoint.x-FirstPoint.x),
					y : MiddlePoint.y+fb*(AfterPoint.y-FirstPoint.y)
				}
			};
		},
		calculateOrderOfMagnitude = helpers.calculateOrderOfMagnitude = function(val){
			return Math.floor(Math.log(val) / Math.LN10);
		},
		calculateScaleRange = helpers.calculateScaleRange = function(valuesArray, drawingSize, textSize, startFromZero, integersOnly){

			//Set a minimum step of two - a point at the top of the graph, and a point at the base
			var minSteps = 2,
				maxSteps = Math.floor(drawingSize/(textSize * 1.5)),
				skipFitting = (minSteps >= maxSteps);

			var maxValue = max(valuesArray),
				minValue = min(valuesArray);

			// We need some degree of seperation here to calculate the scales if all the values are the same
			// Adding/minusing 0.5 will give us a range of 1.
			if (maxValue === minValue){
				maxValue += 0.5;
				// So we don't end up with a graph with a negative start value if we've said always start from zero
				if (minValue >= 0.5 && !startFromZero){
					minValue -= 0.5;
				}
				else{
					// Make up a whole number above the values
					maxValue += 0.5;
				}
			}

			var	valueRange = Math.abs(maxValue - minValue),
				rangeOrderOfMagnitude = calculateOrderOfMagnitude(valueRange),
				graphMax = Math.ceil(maxValue / (1 * Math.pow(10, rangeOrderOfMagnitude))) * Math.pow(10, rangeOrderOfMagnitude),
				graphMin = (startFromZero) ? 0 : Math.floor(minValue / (1 * Math.pow(10, rangeOrderOfMagnitude))) * Math.pow(10, rangeOrderOfMagnitude),
				graphRange = graphMax - graphMin,
				stepValue = Math.pow(10, rangeOrderOfMagnitude),
				numberOfSteps = Math.round(graphRange / stepValue);

			//If we have more space on the graph we'll use it to give more definition to the data
			while((numberOfSteps > maxSteps || (numberOfSteps * 2) < maxSteps) && !skipFitting) {
				if(numberOfSteps > maxSteps){
					stepValue *=2;
					numberOfSteps = Math.round(graphRange/stepValue);
					// Don't ever deal with a decimal number of steps - cancel fitting and just use the minimum number of steps.
					if (numberOfSteps % 1 !== 0){
						skipFitting = true;
					}
				}
				//We can fit in double the amount of scale points on the scale
				else{
					//If user has declared ints only, and the step value isn't a decimal
					if (integersOnly && rangeOrderOfMagnitude >= 0){
						//If the user has said integers only, we need to check that making the scale more granular wouldn't make it a float
						if(stepValue/2 % 1 === 0){
							stepValue /=2;
							numberOfSteps = Math.round(graphRange/stepValue);
						}
						//If it would make it a float break out of the loop
						else{
							break;
						}
					}
					//If the scale doesn't have to be an int, make the scale more granular anyway.
					else{
						stepValue /=2;
						numberOfSteps = Math.round(graphRange/stepValue);
					}

				}
			}

			if (skipFitting){
				numberOfSteps = minSteps;
				stepValue = graphRange / numberOfSteps;
			}

			return {
				steps : numberOfSteps,
				stepValue : stepValue,
				min : graphMin,
				max	: graphMin + (numberOfSteps * stepValue)
			};

		},
		/* jshint ignore:start */
		// Blows up jshint errors based on the new Function constructor
		//Templating methods
		//Javascript micro templating by John Resig - source at http://ejohn.org/blog/javascript-micro-templating/
		template = helpers.template = function(templateString, valuesObject){

			// If templateString is function rather than string-template - call the function for valuesObject

			if(templateString instanceof Function){
			 	return templateString(valuesObject);
		 	}

			var cache = {};
			function tmpl(str, data){
				// Figure out if we're getting a template, or if we need to
				// load the template - and be sure to cache the result.
				var fn = !/\W/.test(str) ?
				cache[str] = cache[str] :

				// Generate a reusable function that will serve as a template
				// generator (and which will be cached).
				new Function("obj",
					"var p=[],print=function(){p.push.apply(p,arguments);};" +

					// Introduce the data as local variables using with(){}
					"with(obj){p.push('" +

					// Convert the template into pure JavaScript
					str
						.replace(/[\r\t\n]/g, " ")
						.split("<%").join("\t")
						.replace(/((^|%>)[^\t]*)'/g, "$1\r")
						.replace(/\t=(.*?)%>/g, "',$1,'")
						.split("\t").join("');")
						.split("%>").join("p.push('")
						.split("\r").join("\\'") +
					"');}return p.join('');"
				);

				// Provide some basic currying to the user
				return data ? fn( data ) : fn;
			}
			return tmpl(templateString,valuesObject);
		},
		/* jshint ignore:end */
		generateLabels = helpers.generateLabels = function(templateString,numberOfSteps,graphMin,stepValue){
			var labelsArray = new Array(numberOfSteps);
			if (labelTemplateString){
				each(labelsArray,function(val,index){
					labelsArray[index] = template(templateString,{value: (graphMin + (stepValue*(index+1)))});
				});
			}
			return labelsArray;
		},
		//--Animation methods
		//Easing functions adapted from Robert Penner's easing equations
		//http://www.robertpenner.com/easing/
		easingEffects = helpers.easingEffects = {
			linear: function (t) {
				return t;
			},
			easeInQuad: function (t) {
				return t * t;
			},
			easeOutQuad: function (t) {
				return -1 * t * (t - 2);
			},
			easeInOutQuad: function (t) {
				if ((t /= 1 / 2) < 1) return 1 / 2 * t * t;
				return -1 / 2 * ((--t) * (t - 2) - 1);
			},
			easeInCubic: function (t) {
				return t * t * t;
			},
			easeOutCubic: function (t) {
				return 1 * ((t = t / 1 - 1) * t * t + 1);
			},
			easeInOutCubic: function (t) {
				if ((t /= 1 / 2) < 1) return 1 / 2 * t * t * t;
				return 1 / 2 * ((t -= 2) * t * t + 2);
			},
			easeInQuart: function (t) {
				return t * t * t * t;
			},
			easeOutQuart: function (t) {
				return -1 * ((t = t / 1 - 1) * t * t * t - 1);
			},
			easeInOutQuart: function (t) {
				if ((t /= 1 / 2) < 1) return 1 / 2 * t * t * t * t;
				return -1 / 2 * ((t -= 2) * t * t * t - 2);
			},
			easeInQuint: function (t) {
				return 1 * (t /= 1) * t * t * t * t;
			},
			easeOutQuint: function (t) {
				return 1 * ((t = t / 1 - 1) * t * t * t * t + 1);
			},
			easeInOutQuint: function (t) {
				if ((t /= 1 / 2) < 1) return 1 / 2 * t * t * t * t * t;
				return 1 / 2 * ((t -= 2) * t * t * t * t + 2);
			},
			easeInSine: function (t) {
				return -1 * Math.cos(t / 1 * (Math.PI / 2)) + 1;
			},
			easeOutSine: function (t) {
				return 1 * Math.sin(t / 1 * (Math.PI / 2));
			},
			easeInOutSine: function (t) {
				return -1 / 2 * (Math.cos(Math.PI * t / 1) - 1);
			},
			easeInExpo: function (t) {
				return (t === 0) ? 1 : 1 * Math.pow(2, 10 * (t / 1 - 1));
			},
			easeOutExpo: function (t) {
				return (t === 1) ? 1 : 1 * (-Math.pow(2, -10 * t / 1) + 1);
			},
			easeInOutExpo: function (t) {
				if (t === 0) return 0;
				if (t === 1) return 1;
				if ((t /= 1 / 2) < 1) return 1 / 2 * Math.pow(2, 10 * (t - 1));
				return 1 / 2 * (-Math.pow(2, -10 * --t) + 2);
			},
			easeInCirc: function (t) {
				if (t >= 1) return t;
				return -1 * (Math.sqrt(1 - (t /= 1) * t) - 1);
			},
			easeOutCirc: function (t) {
				return 1 * Math.sqrt(1 - (t = t / 1 - 1) * t);
			},
			easeInOutCirc: function (t) {
				if ((t /= 1 / 2) < 1) return -1 / 2 * (Math.sqrt(1 - t * t) - 1);
				return 1 / 2 * (Math.sqrt(1 - (t -= 2) * t) + 1);
			},
			easeInElastic: function (t) {
				var s = 1.70158;
				var p = 0;
				var a = 1;
				if (t === 0) return 0;
				if ((t /= 1) == 1) return 1;
				if (!p) p = 1 * 0.3;
				if (a < Math.abs(1)) {
					a = 1;
					s = p / 4;
				} else s = p / (2 * Math.PI) * Math.asin(1 / a);
				return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * 1 - s) * (2 * Math.PI) / p));
			},
			easeOutElastic: function (t) {
				var s = 1.70158;
				var p = 0;
				var a = 1;
				if (t === 0) return 0;
				if ((t /= 1) == 1) return 1;
				if (!p) p = 1 * 0.3;
				if (a < Math.abs(1)) {
					a = 1;
					s = p / 4;
				} else s = p / (2 * Math.PI) * Math.asin(1 / a);
				return a * Math.pow(2, -10 * t) * Math.sin((t * 1 - s) * (2 * Math.PI) / p) + 1;
			},
			easeInOutElastic: function (t) {
				var s = 1.70158;
				var p = 0;
				var a = 1;
				if (t === 0) return 0;
				if ((t /= 1 / 2) == 2) return 1;
				if (!p) p = 1 * (0.3 * 1.5);
				if (a < Math.abs(1)) {
					a = 1;
					s = p / 4;
				} else s = p / (2 * Math.PI) * Math.asin(1 / a);
				if (t < 1) return -0.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * 1 - s) * (2 * Math.PI) / p));
				return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t * 1 - s) * (2 * Math.PI) / p) * 0.5 + 1;
			},
			easeInBack: function (t) {
				var s = 1.70158;
				return 1 * (t /= 1) * t * ((s + 1) * t - s);
			},
			easeOutBack: function (t) {
				var s = 1.70158;
				return 1 * ((t = t / 1 - 1) * t * ((s + 1) * t + s) + 1);
			},
			easeInOutBack: function (t) {
				var s = 1.70158;
				if ((t /= 1 / 2) < 1) return 1 / 2 * (t * t * (((s *= (1.525)) + 1) * t - s));
				return 1 / 2 * ((t -= 2) * t * (((s *= (1.525)) + 1) * t + s) + 2);
			},
			easeInBounce: function (t) {
				return 1 - easingEffects.easeOutBounce(1 - t);
			},
			easeOutBounce: function (t) {
				if ((t /= 1) < (1 / 2.75)) {
					return 1 * (7.5625 * t * t);
				} else if (t < (2 / 2.75)) {
					return 1 * (7.5625 * (t -= (1.5 / 2.75)) * t + 0.75);
				} else if (t < (2.5 / 2.75)) {
					return 1 * (7.5625 * (t -= (2.25 / 2.75)) * t + 0.9375);
				} else {
					return 1 * (7.5625 * (t -= (2.625 / 2.75)) * t + 0.984375);
				}
			},
			easeInOutBounce: function (t) {
				if (t < 1 / 2) return easingEffects.easeInBounce(t * 2) * 0.5;
				return easingEffects.easeOutBounce(t * 2 - 1) * 0.5 + 1 * 0.5;
			}
		},
		//Request animation polyfill - http://www.paulirish.com/2011/requestanimationframe-for-smart-animating/
		requestAnimFrame = helpers.requestAnimFrame = (function(){
			return window.requestAnimationFrame ||
				window.webkitRequestAnimationFrame ||
				window.mozRequestAnimationFrame ||
				window.oRequestAnimationFrame ||
				window.msRequestAnimationFrame ||
				function(callback) {
					return window.setTimeout(callback, 1000 / 60);
				};
		})(),
		cancelAnimFrame = helpers.cancelAnimFrame = (function(){
			return window.cancelAnimationFrame ||
				window.webkitCancelAnimationFrame ||
				window.mozCancelAnimationFrame ||
				window.oCancelAnimationFrame ||
				window.msCancelAnimationFrame ||
				function(callback) {
					return window.clearTimeout(callback, 1000 / 60);
				};
		})(),
		animationLoop = helpers.animationLoop = function(callback,totalSteps,easingString,onProgress,onComplete,chartInstance){

			var currentStep = 0,
				easingFunction = easingEffects[easingString] || easingEffects.linear;

			var animationFrame = function(){
				currentStep++;
				var stepDecimal = currentStep/totalSteps;
				var easeDecimal = easingFunction(stepDecimal);

				callback.call(chartInstance,easeDecimal,stepDecimal, currentStep);
				onProgress.call(chartInstance,easeDecimal,stepDecimal);
				if (currentStep < totalSteps){
					chartInstance.animationFrame = requestAnimFrame(animationFrame);
				} else{
					onComplete.apply(chartInstance);
				}
			};
			requestAnimFrame(animationFrame);
		},
		//-- DOM methods
		getRelativePosition = helpers.getRelativePosition = function(evt){
			var mouseX, mouseY;
			var e = evt.originalEvent || evt,
				canvas = evt.currentTarget || evt.srcElement,
				boundingRect = canvas.getBoundingClientRect();

			if (e.touches){
				mouseX = e.touches[0].clientX - boundingRect.left;
				mouseY = e.touches[0].clientY - boundingRect.top;

			}
			else{
				mouseX = e.clientX - boundingRect.left;
				mouseY = e.clientY - boundingRect.top;
			}

			return {
				x : mouseX,
				y : mouseY
			};

		},
		addEvent = helpers.addEvent = function(node,eventType,method){
			if (node.addEventListener){
				node.addEventListener(eventType,method);
			} else if (node.attachEvent){
				node.attachEvent("on"+eventType, method);
			} else {
				node["on"+eventType] = method;
			}
		},
		removeEvent = helpers.removeEvent = function(node, eventType, handler){
			if (node.removeEventListener){
				node.removeEventListener(eventType, handler, false);
			} else if (node.detachEvent){
				node.detachEvent("on"+eventType,handler);
			} else{
				node["on" + eventType] = noop;
			}
		},
		bindEvents = helpers.bindEvents = function(chartInstance, arrayOfEvents, handler){
			// Create the events object if it's not already present
			if (!chartInstance.events) chartInstance.events = {};

			each(arrayOfEvents,function(eventName){
				chartInstance.events[eventName] = function(){
					handler.apply(chartInstance, arguments);
				};
				addEvent(chartInstance.chart.canvas,eventName,chartInstance.events[eventName]);
			});
		},
		unbindEvents = helpers.unbindEvents = function (chartInstance, arrayOfEvents) {
			each(arrayOfEvents, function(handler,eventName){
				removeEvent(chartInstance.chart.canvas, eventName, handler);
			});
		},
		getMaximumWidth = helpers.getMaximumWidth = function(domNode){
			var container = domNode.parentNode;
			// TODO = check cross browser stuff with this.
			return container.clientWidth;
		},
		getMaximumHeight = helpers.getMaximumHeight = function(domNode){
			var container = domNode.parentNode;
			// TODO = check cross browser stuff with this.
			return container.clientHeight;
		},
		getMaximumSize = helpers.getMaximumSize = helpers.getMaximumWidth, // legacy support
		retinaScale = helpers.retinaScale = function(chart){
			var ctx = chart.ctx,
				width = chart.canvas.width,
				height = chart.canvas.height;

			if (window.devicePixelRatio) {
				ctx.canvas.style.width = width + "px";
				ctx.canvas.style.height = height + "px";
				ctx.canvas.height = height * window.devicePixelRatio;
				ctx.canvas.width = width * window.devicePixelRatio;
				ctx.scale(window.devicePixelRatio, window.devicePixelRatio);
			}
		},
		//-- Canvas methods
		clear = helpers.clear = function(chart){
			chart.ctx.clearRect(0,0,chart.width,chart.height);
		},
		fontString = helpers.fontString = function(pixelSize,fontStyle,fontFamily){
			return fontStyle + " " + pixelSize+"px " + fontFamily;
		},
		longestText = helpers.longestText = function(ctx,font,arrayOfStrings){
			ctx.font = font;
			var longest = 0;
			each(arrayOfStrings,function(string){
				var textWidth = ctx.measureText(string).width;
				longest = (textWidth > longest) ? textWidth : longest;
			});
			return longest;
		},
		drawRoundedRectangle = helpers.drawRoundedRectangle = function(ctx,x,y,width,height,radius){
			ctx.beginPath();
			ctx.moveTo(x + radius, y);
			ctx.lineTo(x + width - radius, y);
			ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
			ctx.lineTo(x + width, y + height - radius);
			ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
			ctx.lineTo(x + radius, y + height);
			ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
			ctx.lineTo(x, y + radius);
			ctx.quadraticCurveTo(x, y, x + radius, y);
			ctx.closePath();
		};


	//Store a reference to each instance - allowing us to globally resize chart instances on window resize.
	//Destroy method on the chart will remove the instance of the chart from this reference.
	Chart.instances = {};

	Chart.Type = function(data,options,chart){
		this.options = options;
		this.chart = chart;
		this.id = uid();
		//Add the chart instance to the global namespace
		Chart.instances[this.id] = this;

		// Initialize is always called when a chart type is created
		// By default it is a no op, but it should be extended
		if (options.responsive){
			this.resize();
		}
		this.initialize.call(this,data);
	};

	//Core methods that'll be a part of every chart type
	extend(Chart.Type.prototype,{
		initialize : function(){return this;},
		clear : function(){
			clear(this.chart);
			return this;
		},
		stop : function(){
			// Stops any current animation loop occuring
			helpers.cancelAnimFrame.call(root, this.animationFrame);
			return this;
		},
		resize : function(callback){
			this.stop();
			var canvas = this.chart.canvas,
				newWidth = getMaximumWidth(this.chart.canvas),
				newHeight = this.options.maintainAspectRatio ? newWidth / this.chart.aspectRatio : getMaximumHeight(this.chart.canvas);

			canvas.width = this.chart.width = newWidth;
			canvas.height = this.chart.height = newHeight;

			retinaScale(this.chart);

			if (typeof callback === "function"){
				callback.apply(this, Array.prototype.slice.call(arguments, 1));
			}
			return this;
		},
		reflow : noop,
		render : function(reflow){
			if (reflow){
				this.reflow();
			}
			if (this.options.animation && !reflow){
				helpers.animationLoop(
					this.draw,
					this.options.animationSteps,
					this.options.animationEasing,
					this.options.onAnimationProgress,
					this.options.onAnimationComplete,
					this
				);
			}
			else{
				this.draw();
				this.options.onAnimationComplete.call(this);
			}
			return this;
		},
		generateLegend : function(){
			return template(this.options.legendTemplate,this);
		},
		destroy : function(){
			this.clear();
			unbindEvents(this, this.events);
			var canvas = this.chart.canvas;

			// Reset canvas height/width attributes starts a fresh with the canvas context
			canvas.width = this.chart.width;
			canvas.height = this.chart.height;

			// < IE9 doesn't support removeProperty
			if (canvas.style.removeProperty) {
				canvas.style.removeProperty('width');
				canvas.style.removeProperty('height');
			} else {
				canvas.style.removeAttribute('width');
				canvas.style.removeAttribute('height');
			}

			delete Chart.instances[this.id];
		},
		showTooltip : function(ChartElements, forceRedraw){
			// Only redraw the chart if we've actually changed what we're hovering on.
			if (typeof this.activeElements === 'undefined') this.activeElements = [];

			var isChanged = (function(Elements){
				var changed = false;

				if (Elements.length !== this.activeElements.length){
					changed = true;
					return changed;
				}

				each(Elements, function(element, index){
					if (element !== this.activeElements[index]){
						changed = true;
					}
				}, this);
				return changed;
			}).call(this, ChartElements);

			if (!isChanged && !forceRedraw){
				return;
			}
			else{
				this.activeElements = ChartElements;
			}
			this.draw();
			if(this.options.customTooltips){
				this.options.customTooltips(false);
			}
			if (ChartElements.length > 0){
				// If we have multiple datasets, show a MultiTooltip for all of the data points at that index
				if (this.datasets && this.datasets.length > 1) {
					var dataArray,
						dataIndex;

					for (var i = this.datasets.length - 1; i >= 0; i--) {
						dataArray = this.datasets[i].points || this.datasets[i].bars || this.datasets[i].segments;
						dataIndex = indexOf(dataArray, ChartElements[0]);
						if (dataIndex !== -1){
							break;
						}
					}
					var tooltipLabels = [],
						tooltipColors = [],
						medianPosition = (function(index) {

							// Get all the points at that particular index
							var Elements = [],
								dataCollection,
								xPositions = [],
								yPositions = [],
								xMax,
								yMax,
								xMin,
								yMin;
							helpers.each(this.datasets, function(dataset){
								dataCollection = dataset.points || dataset.bars || dataset.segments;
								if (dataCollection[dataIndex] && dataCollection[dataIndex].hasValue()){
									Elements.push(dataCollection[dataIndex]);
								}
							});

							helpers.each(Elements, function(element) {
								xPositions.push(element.x);
								yPositions.push(element.y);


								//Include any colour information about the element
								tooltipLabels.push(helpers.template(this.options.multiTooltipTemplate, element));
								tooltipColors.push({
									fill: element._saved.fillColor || element.fillColor,
									stroke: element._saved.strokeColor || element.strokeColor
								});

							}, this);

							yMin = min(yPositions);
							yMax = max(yPositions);

							xMin = min(xPositions);
							xMax = max(xPositions);

							return {
								x: (xMin > this.chart.width/2) ? xMin : xMax,
								y: (yMin + yMax)/2
							};
						}).call(this, dataIndex);

					new Chart.MultiTooltip({
						x: medianPosition.x,
						y: medianPosition.y,
						xPadding: this.options.tooltipXPadding,
						yPadding: this.options.tooltipYPadding,
						xOffset: this.options.tooltipXOffset,
						fillColor: this.options.tooltipFillColor,
						textColor: this.options.tooltipFontColor,
						fontFamily: this.options.tooltipFontFamily,
						fontStyle: this.options.tooltipFontStyle,
						fontSize: this.options.tooltipFontSize,
						titleTextColor: this.options.tooltipTitleFontColor,
						titleFontFamily: this.options.tooltipTitleFontFamily,
						titleFontStyle: this.options.tooltipTitleFontStyle,
						titleFontSize: this.options.tooltipTitleFontSize,
						cornerRadius: this.options.tooltipCornerRadius,
						labels: tooltipLabels,
						legendColors: tooltipColors,
						legendColorBackground : this.options.multiTooltipKeyBackground,
						title: ChartElements[0].label,
						chart: this.chart,
						ctx: this.chart.ctx,
						custom: this.options.customTooltips
					}).draw();

				} else {
					each(ChartElements, function(Element) {
						var tooltipPosition = Element.tooltipPosition();
						new Chart.Tooltip({
							x: Math.round(tooltipPosition.x),
							y: Math.round(tooltipPosition.y),
							xPadding: this.options.tooltipXPadding,
							yPadding: this.options.tooltipYPadding,
							fillColor: this.options.tooltipFillColor,
							textColor: this.options.tooltipFontColor,
							fontFamily: this.options.tooltipFontFamily,
							fontStyle: this.options.tooltipFontStyle,
							fontSize: this.options.tooltipFontSize,
							caretHeight: this.options.tooltipCaretSize,
							cornerRadius: this.options.tooltipCornerRadius,
							text: template(this.options.tooltipTemplate, Element),
							chart: this.chart,
							custom: this.options.customTooltips
						}).draw();
					}, this);
				}
			}
			return this;
		},
		toBase64Image : function(){
			return this.chart.canvas.toDataURL.apply(this.chart.canvas, arguments);
		}
	});

	Chart.Type.extend = function(extensions){

		var parent = this;

		var ChartType = function(){
			return parent.apply(this,arguments);
		};

		//Copy the prototype object of the this class
		ChartType.prototype = clone(parent.prototype);
		//Now overwrite some of the properties in the base class with the new extensions
		extend(ChartType.prototype, extensions);

		ChartType.extend = Chart.Type.extend;

		if (extensions.name || parent.prototype.name){

			var chartName = extensions.name || parent.prototype.name;
			//Assign any potential default values of the new chart type

			//If none are defined, we'll use a clone of the chart type this is being extended from.
			//I.e. if we extend a line chart, we'll use the defaults from the line chart if our new chart
			//doesn't define some defaults of their own.

			var baseDefaults = (Chart.defaults[parent.prototype.name]) ? clone(Chart.defaults[parent.prototype.name]) : {};

			Chart.defaults[chartName] = extend(baseDefaults,extensions.defaults);

			Chart.types[chartName] = ChartType;

			//Register this new chart type in the Chart prototype
			Chart.prototype[chartName] = function(data,options){
				var config = merge(Chart.defaults.global, Chart.defaults[chartName], options || {});
				return new ChartType(data,config,this);
			};
		} else{
			warn("Name not provided for this chart, so it hasn't been registered");
		}
		return parent;
	};

	Chart.Element = function(configuration){
		extend(this,configuration);
		this.initialize.apply(this,arguments);
		this.save();
	};
	extend(Chart.Element.prototype,{
		initialize : function(){},
		restore : function(props){
			if (!props){
				extend(this,this._saved);
			} else {
				each(props,function(key){
					this[key] = this._saved[key];
				},this);
			}
			return this;
		},
		save : function(){
			this._saved = clone(this);
			delete this._saved._saved;
			return this;
		},
		update : function(newProps){
			each(newProps,function(value,key){
				this._saved[key] = this[key];
				this[key] = value;
			},this);
			return this;
		},
		transition : function(props,ease){
			each(props,function(value,key){
				this[key] = ((value - this._saved[key]) * ease) + this._saved[key];
			},this);
			return this;
		},
		tooltipPosition : function(){
			return {
				x : this.x,
				y : this.y
			};
		},
		hasValue: function(){
			return isNumber(this.value);
		}
	});

	Chart.Element.extend = inherits;


	Chart.Point = Chart.Element.extend({
		display: true,
		inRange: function(chartX,chartY){
			var hitDetectionRange = this.hitDetectionRadius + this.radius;
			return ((Math.pow(chartX-this.x, 2)+Math.pow(chartY-this.y, 2)) < Math.pow(hitDetectionRange,2));
		},
		draw : function(){
			if (this.display){
				var ctx = this.ctx;
				ctx.beginPath();

				ctx.arc(this.x, this.y, this.radius, 0, Math.PI*2);
				ctx.closePath();

				ctx.strokeStyle = this.strokeColor;
				ctx.lineWidth = this.strokeWidth;

				ctx.fillStyle = this.fillColor;

				ctx.fill();
				ctx.stroke();
			}


			//Quick debug for bezier curve splining
			//Highlights control points and the line between them.
			//Handy for dev - stripped in the min version.

			// ctx.save();
			// ctx.fillStyle = "black";
			// ctx.strokeStyle = "black"
			// ctx.beginPath();
			// ctx.arc(this.controlPoints.inner.x,this.controlPoints.inner.y, 2, 0, Math.PI*2);
			// ctx.fill();

			// ctx.beginPath();
			// ctx.arc(this.controlPoints.outer.x,this.controlPoints.outer.y, 2, 0, Math.PI*2);
			// ctx.fill();

			// ctx.moveTo(this.controlPoints.inner.x,this.controlPoints.inner.y);
			// ctx.lineTo(this.x, this.y);
			// ctx.lineTo(this.controlPoints.outer.x,this.controlPoints.outer.y);
			// ctx.stroke();

			// ctx.restore();



		}
	});

	Chart.Arc = Chart.Element.extend({
		inRange : function(chartX,chartY){

			var pointRelativePosition = helpers.getAngleFromPoint(this, {
				x: chartX,
				y: chartY
			});

			//Check if within the range of the open/close angle
			var betweenAngles = (pointRelativePosition.angle >= this.startAngle && pointRelativePosition.angle <= this.endAngle),
				withinRadius = (pointRelativePosition.distance >= this.innerRadius && pointRelativePosition.distance <= this.outerRadius);

			return (betweenAngles && withinRadius);
			//Ensure within the outside of the arc centre, but inside arc outer
		},
		tooltipPosition : function(){
			var centreAngle = this.startAngle + ((this.endAngle - this.startAngle) / 2),
				rangeFromCentre = (this.outerRadius - this.innerRadius) / 2 + this.innerRadius;
			return {
				x : this.x + (Math.cos(centreAngle) * rangeFromCentre),
				y : this.y + (Math.sin(centreAngle) * rangeFromCentre)
			};
		},
		draw : function(animationPercent){

			var easingDecimal = animationPercent || 1;

			var ctx = this.ctx;

			ctx.beginPath();

			ctx.arc(this.x, this.y, this.outerRadius, this.startAngle, this.endAngle);

			ctx.arc(this.x, this.y, this.innerRadius, this.endAngle, this.startAngle, true);

			ctx.closePath();
			ctx.strokeStyle = this.strokeColor;
			ctx.lineWidth = this.strokeWidth;

			ctx.fillStyle = this.fillColor;

			ctx.fill();
			ctx.lineJoin = 'bevel';

			if (this.showStroke){
				ctx.stroke();
			}
		}
	});

	Chart.Rectangle = Chart.Element.extend({
		draw : function(){
			var ctx = this.ctx,
				halfWidth = this.width/2,
				leftX = this.x - halfWidth,
				rightX = this.x + halfWidth,
				top = this.base - (this.base - this.y),
				halfStroke = this.strokeWidth / 2;

			// Canvas doesn't allow us to stroke inside the width so we can
			// adjust the sizes to fit if we're setting a stroke on the line
			if (this.showStroke){
				leftX += halfStroke;
				rightX -= halfStroke;
				top += halfStroke;
			}

			ctx.beginPath();

			ctx.fillStyle = this.fillColor;
			ctx.strokeStyle = this.strokeColor;
			ctx.lineWidth = this.strokeWidth;

			// It'd be nice to keep this class totally generic to any rectangle
			// and simply specify which border to miss out.
			ctx.moveTo(leftX, this.base);
			ctx.lineTo(leftX, top);
			ctx.lineTo(rightX, top);
			ctx.lineTo(rightX, this.base);
			ctx.fill();
			if (this.showStroke){
				ctx.stroke();
			}
		},
		height : function(){
			return this.base - this.y;
		},
		inRange : function(chartX,chartY){
			return (chartX >= this.x - this.width/2 && chartX <= this.x + this.width/2) && (chartY >= this.y && chartY <= this.base);
		}
	});

	Chart.Tooltip = Chart.Element.extend({
		draw : function(){

			var ctx = this.chart.ctx;

			ctx.font = fontString(this.fontSize,this.fontStyle,this.fontFamily);

			this.xAlign = "center";
			this.yAlign = "above";

			//Distance between the actual element.y position and the start of the tooltip caret
			var caretPadding = this.caretPadding = 2;

			var tooltipWidth = ctx.measureText(this.text).width + 2*this.xPadding,
				tooltipRectHeight = this.fontSize + 2*this.yPadding,
				tooltipHeight = tooltipRectHeight + this.caretHeight + caretPadding;

			if (this.x + tooltipWidth/2 >this.chart.width){
				this.xAlign = "left";
			} else if (this.x - tooltipWidth/2 < 0){
				this.xAlign = "right";
			}

			if (this.y - tooltipHeight < 0){
				this.yAlign = "below";
			}


			var tooltipX = this.x - tooltipWidth/2,
				tooltipY = this.y - tooltipHeight;

			ctx.fillStyle = this.fillColor;

			// Custom Tooltips
			if(this.custom){
				this.custom(this);
			}
			else{
				switch(this.yAlign)
				{
				case "above":
					//Draw a caret above the x/y
					ctx.beginPath();
					ctx.moveTo(this.x,this.y - caretPadding);
					ctx.lineTo(this.x + this.caretHeight, this.y - (caretPadding + this.caretHeight));
					ctx.lineTo(this.x - this.caretHeight, this.y - (caretPadding + this.caretHeight));
					ctx.closePath();
					ctx.fill();
					break;
				case "below":
					tooltipY = this.y + caretPadding + this.caretHeight;
					//Draw a caret below the x/y
					ctx.beginPath();
					ctx.moveTo(this.x, this.y + caretPadding);
					ctx.lineTo(this.x + this.caretHeight, this.y + caretPadding + this.caretHeight);
					ctx.lineTo(this.x - this.caretHeight, this.y + caretPadding + this.caretHeight);
					ctx.closePath();
					ctx.fill();
					break;
				}

				switch(this.xAlign)
				{
				case "left":
					tooltipX = this.x - tooltipWidth + (this.cornerRadius + this.caretHeight);
					break;
				case "right":
					tooltipX = this.x - (this.cornerRadius + this.caretHeight);
					break;
				}

				drawRoundedRectangle(ctx,tooltipX,tooltipY,tooltipWidth,tooltipRectHeight,this.cornerRadius);

				ctx.fill();

				ctx.fillStyle = this.textColor;
				ctx.textAlign = "center";
				ctx.textBaseline = "middle";
				ctx.fillText(this.text, tooltipX + tooltipWidth/2, tooltipY + tooltipRectHeight/2);
			}
		}
	});

	Chart.MultiTooltip = Chart.Element.extend({
		initialize : function(){
			this.font = fontString(this.fontSize,this.fontStyle,this.fontFamily);

			this.titleFont = fontString(this.titleFontSize,this.titleFontStyle,this.titleFontFamily);

			this.height = (this.labels.length * this.fontSize) + ((this.labels.length-1) * (this.fontSize/2)) + (this.yPadding*2) + this.titleFontSize *1.5;

			this.ctx.font = this.titleFont;

			var titleWidth = this.ctx.measureText(this.title).width,
				//Label has a legend square as well so account for this.
				labelWidth = longestText(this.ctx,this.font,this.labels) + this.fontSize + 3,
				longestTextWidth = max([labelWidth,titleWidth]);

			this.width = longestTextWidth + (this.xPadding*2);


			var halfHeight = this.height/2;

			//Check to ensure the height will fit on the canvas
			//The three is to buffer form the very
			if (this.y - halfHeight < 0 ){
				this.y = halfHeight;
			} else if (this.y + halfHeight > this.chart.height){
				this.y = this.chart.height - halfHeight;
			}

			//Decide whether to align left or right based on position on canvas
			if (this.x > this.chart.width/2){
				this.x -= this.xOffset + this.width;
			} else {
				this.x += this.xOffset;
			}


		},
		getLineHeight : function(index){
			var baseLineHeight = this.y - (this.height/2) + this.yPadding,
				afterTitleIndex = index-1;

			//If the index is zero, we're getting the title
			if (index === 0){
				return baseLineHeight + this.titleFontSize/2;
			} else{
				return baseLineHeight + ((this.fontSize*1.5*afterTitleIndex) + this.fontSize/2) + this.titleFontSize * 1.5;
			}

		},
		draw : function(){
			// Custom Tooltips
			if(this.custom){
				this.custom(this);
			}
			else{
				drawRoundedRectangle(this.ctx,this.x,this.y - this.height/2,this.width,this.height,this.cornerRadius);
				var ctx = this.ctx;
				ctx.fillStyle = this.fillColor;
				ctx.fill();
				ctx.closePath();

				ctx.textAlign = "left";
				ctx.textBaseline = "middle";
				ctx.fillStyle = this.titleTextColor;
				ctx.font = this.titleFont;

				ctx.fillText(this.title,this.x + this.xPadding, this.getLineHeight(0));

				ctx.font = this.font;
				helpers.each(this.labels,function(label,index){
					ctx.fillStyle = this.textColor;
					ctx.fillText(label,this.x + this.xPadding + this.fontSize + 3, this.getLineHeight(index + 1));

					//A bit gnarly, but clearing this rectangle breaks when using explorercanvas (clears whole canvas)
					//ctx.clearRect(this.x + this.xPadding, this.getLineHeight(index + 1) - this.fontSize/2, this.fontSize, this.fontSize);
					//Instead we'll make a white filled block to put the legendColour palette over.

					ctx.fillStyle = this.legendColorBackground;
					ctx.fillRect(this.x + this.xPadding, this.getLineHeight(index + 1) - this.fontSize/2, this.fontSize, this.fontSize);

					ctx.fillStyle = this.legendColors[index].fill;
					ctx.fillRect(this.x + this.xPadding, this.getLineHeight(index + 1) - this.fontSize/2, this.fontSize, this.fontSize);


				},this);
			}
		}
	});

	Chart.Scale = Chart.Element.extend({
		initialize : function(){
			this.fit();
		},
		buildYLabels : function(){
			this.yLabels = [];

			var stepDecimalPlaces = getDecimalPlaces(this.stepValue);

			for (var i=0; i<=this.steps; i++){
				this.yLabels.push(template(this.templateString,{value:(this.min + (i * this.stepValue)).toFixed(stepDecimalPlaces)}));
			}
			this.yLabelWidth = (this.display && this.showLabels) ? longestText(this.ctx,this.font,this.yLabels) : 0;
		},
		addXLabel : function(label){
			this.xLabels.push(label);
			this.valuesCount++;
			this.fit();
		},
		removeXLabel : function(){
			this.xLabels.shift();
			this.valuesCount--;
			this.fit();
		},
		// Fitting loop to rotate x Labels and figure out what fits there, and also calculate how many Y steps to use
		fit: function(){
			// First we need the width of the yLabels, assuming the xLabels aren't rotated

			// To do that we need the base line at the top and base of the chart, assuming there is no x label rotation
			this.startPoint = (this.display) ? this.fontSize : 0;
			this.endPoint = (this.display) ? this.height - (this.fontSize * 1.5) - 5 : this.height; // -5 to pad labels

			// Apply padding settings to the start and end point.
			this.startPoint += this.padding;
			this.endPoint -= this.padding;

			// Cache the starting height, so can determine if we need to recalculate the scale yAxis
			var cachedHeight = this.endPoint - this.startPoint,
				cachedYLabelWidth;

			// Build the current yLabels so we have an idea of what size they'll be to start
			/*
			 *	This sets what is returned from calculateScaleRange as static properties of this class:
			 *
				this.steps;
				this.stepValue;
				this.min;
				this.max;
			 *
			 */
			this.calculateYRange(cachedHeight);

			// With these properties set we can now build the array of yLabels
			// and also the width of the largest yLabel
			this.buildYLabels();

			this.calculateXLabelRotation();

			while((cachedHeight > this.endPoint - this.startPoint)){
				cachedHeight = this.endPoint - this.startPoint;
				cachedYLabelWidth = this.yLabelWidth;

				this.calculateYRange(cachedHeight);
				this.buildYLabels();

				// Only go through the xLabel loop again if the yLabel width has changed
				if (cachedYLabelWidth < this.yLabelWidth){
					this.calculateXLabelRotation();
				}
			}

		},
		calculateXLabelRotation : function(){
			//Get the width of each grid by calculating the difference
			//between x offsets between 0 and 1.

			this.ctx.font = this.font;

			var firstWidth = this.ctx.measureText(this.xLabels[0]).width,
				lastWidth = this.ctx.measureText(this.xLabels[this.xLabels.length - 1]).width,
				firstRotated,
				lastRotated;


			this.xScalePaddingRight = lastWidth/2 + 3;
			this.xScalePaddingLeft = (firstWidth/2 > this.yLabelWidth + 10) ? firstWidth/2 : this.yLabelWidth + 10;

			this.xLabelRotation = 0;
			if (this.display){
				var originalLabelWidth = longestText(this.ctx,this.font,this.xLabels),
					cosRotation,
					firstRotatedWidth;
				this.xLabelWidth = originalLabelWidth;
				//Allow 3 pixels x2 padding either side for label readability
				var xGridWidth = Math.floor(this.calculateX(1) - this.calculateX(0)) - 6;

				//Max label rotate should be 90 - also act as a loop counter
				while ((this.xLabelWidth > xGridWidth && this.xLabelRotation === 0) || (this.xLabelWidth > xGridWidth && this.xLabelRotation <= 90 && this.xLabelRotation > 0)){
					cosRotation = Math.cos(toRadians(this.xLabelRotation));

					firstRotated = cosRotation * firstWidth;
					lastRotated = cosRotation * lastWidth;

					// We're right aligning the text now.
					if (firstRotated + this.fontSize / 2 > this.yLabelWidth + 8){
						this.xScalePaddingLeft = firstRotated + this.fontSize / 2;
					}
					this.xScalePaddingRight = this.fontSize/2;


					this.xLabelRotation++;
					this.xLabelWidth = cosRotation * originalLabelWidth;

				}
				if (this.xLabelRotation > 0){
					this.endPoint -= Math.sin(toRadians(this.xLabelRotation))*originalLabelWidth + 3;
				}
			}
			else{
				this.xLabelWidth = 0;
				this.xScalePaddingRight = this.padding;
				this.xScalePaddingLeft = this.padding;
			}

		},
		// Needs to be overidden in each Chart type
		// Otherwise we need to pass all the data into the scale class
		calculateYRange: noop,
		drawingArea: function(){
			return this.startPoint - this.endPoint;
		},
		calculateY : function(value){
			var scalingFactor = this.drawingArea() / (this.min - this.max);
			return this.endPoint - (scalingFactor * (value - this.min));
		},
		calculateX : function(index){
			var isRotated = (this.xLabelRotation > 0),
				// innerWidth = (this.offsetGridLines) ? this.width - offsetLeft - this.padding : this.width - (offsetLeft + halfLabelWidth * 2) - this.padding,
				innerWidth = this.width - (this.xScalePaddingLeft + this.xScalePaddingRight),
				valueWidth = innerWidth/(this.valuesCount - ((this.offsetGridLines) ? 0 : 1)),
				valueOffset = (valueWidth * index) + this.xScalePaddingLeft;

			if (this.offsetGridLines){
				valueOffset += (valueWidth/2);
			}

			return Math.round(valueOffset);
		},
		update : function(newProps){
			helpers.extend(this, newProps);
			this.fit();
		},
		draw : function(){
			var ctx = this.ctx,
				yLabelGap = (this.endPoint - this.startPoint) / this.steps,
				xStart = Math.round(this.xScalePaddingLeft);
			if (this.display){
				ctx.fillStyle = this.textColor;
				ctx.font = this.font;
				each(this.yLabels,function(labelString,index){
					var yLabelCenter = this.endPoint - (yLabelGap * index),
						linePositionY = Math.round(yLabelCenter),
						drawHorizontalLine = this.showHorizontalLines;

					ctx.textAlign = "right";
					ctx.textBaseline = "middle";
					if (this.showLabels){
						ctx.fillText(labelString,xStart - 10,yLabelCenter);
					}

					// This is X axis, so draw it
					if (index === 0 && !drawHorizontalLine){
						drawHorizontalLine = true;
					}

					if (drawHorizontalLine){
						ctx.beginPath();
					}

					if (index > 0){
						// This is a grid line in the centre, so drop that
						ctx.lineWidth = this.gridLineWidth;
						ctx.strokeStyle = this.gridLineColor;
					} else {
						// This is the first line on the scale
						ctx.lineWidth = this.lineWidth;
						ctx.strokeStyle = this.lineColor;
					}

					linePositionY += helpers.aliasPixel(ctx.lineWidth);

					if(drawHorizontalLine){
						ctx.moveTo(xStart, linePositionY);
						ctx.lineTo(this.width, linePositionY);
						ctx.stroke();
						ctx.closePath();
					}

					ctx.lineWidth = this.lineWidth;
					ctx.strokeStyle = this.lineColor;
					ctx.beginPath();
					ctx.moveTo(xStart - 5, linePositionY);
					ctx.lineTo(xStart, linePositionY);
					ctx.stroke();
					ctx.closePath();

				},this);

				each(this.xLabels,function(label,index){
					var xPos = this.calculateX(index) + aliasPixel(this.lineWidth),
						// Check to see if line/bar here and decide where to place the line
						linePos = this.calculateX(index - (this.offsetGridLines ? 0.5 : 0)) + aliasPixel(this.lineWidth),
						isRotated = (this.xLabelRotation > 0),
						drawVerticalLine = this.showVerticalLines;

					// This is Y axis, so draw it
					if (index === 0 && !drawVerticalLine){
						drawVerticalLine = true;
					}

					if (drawVerticalLine){
						ctx.beginPath();
					}

					if (index > 0){
						// This is a grid line in the centre, so drop that
						ctx.lineWidth = this.gridLineWidth;
						ctx.strokeStyle = this.gridLineColor;
					} else {
						// This is the first line on the scale
						ctx.lineWidth = this.lineWidth;
						ctx.strokeStyle = this.lineColor;
					}

					if (drawVerticalLine){
						ctx.moveTo(linePos,this.endPoint);
						ctx.lineTo(linePos,this.startPoint - 3);
						ctx.stroke();
						ctx.closePath();
					}


					ctx.lineWidth = this.lineWidth;
					ctx.strokeStyle = this.lineColor;


					// Small lines at the bottom of the base grid line
					ctx.beginPath();
					ctx.moveTo(linePos,this.endPoint);
					ctx.lineTo(linePos,this.endPoint + 5);
					ctx.stroke();
					ctx.closePath();

					ctx.save();
					ctx.translate(xPos,(isRotated) ? this.endPoint + 12 : this.endPoint + 8);
					ctx.rotate(toRadians(this.xLabelRotation)*-1);
					ctx.font = this.font;
					ctx.textAlign = (isRotated) ? "right" : "center";
					ctx.textBaseline = (isRotated) ? "middle" : "top";
					ctx.fillText(label, 0, 0);
					ctx.restore();
				},this);

			}
		}

	});

	Chart.RadialScale = Chart.Element.extend({
		initialize: function(){
			this.size = min([this.height, this.width]);
			this.drawingArea = (this.display) ? (this.size/2) - (this.fontSize/2 + this.backdropPaddingY) : (this.size/2);
		},
		calculateCenterOffset: function(value){
			// Take into account half font size + the yPadding of the top value
			var scalingFactor = this.drawingArea / (this.max - this.min);

			return (value - this.min) * scalingFactor;
		},
		update : function(){
			if (!this.lineArc){
				this.setScaleSize();
			} else {
				this.drawingArea = (this.display) ? (this.size/2) - (this.fontSize/2 + this.backdropPaddingY) : (this.size/2);
			}
			this.buildYLabels();
		},
		buildYLabels: function(){
			this.yLabels = [];

			var stepDecimalPlaces = getDecimalPlaces(this.stepValue);

			for (var i=0; i<=this.steps; i++){
				this.yLabels.push(template(this.templateString,{value:(this.min + (i * this.stepValue)).toFixed(stepDecimalPlaces)}));
			}
		},
		getCircumference : function(){
			return ((Math.PI*2) / this.valuesCount);
		},
		setScaleSize: function(){
			/*
			 * Right, this is really confusing and there is a lot of maths going on here
			 * The gist of the problem is here: https://gist.github.com/nnnick/696cc9c55f4b0beb8fe9
			 *
			 * Reaction: https://dl.dropboxusercontent.com/u/34601363/toomuchscience.gif
			 *
			 * Solution:
			 *
			 * We assume the radius of the polygon is half the size of the canvas at first
			 * at each index we check if the text overlaps.
			 *
			 * Where it does, we store that angle and that index.
			 *
			 * After finding the largest index and angle we calculate how much we need to remove
			 * from the shape radius to move the point inwards by that x.
			 *
			 * We average the left and right distances to get the maximum shape radius that can fit in the box
			 * along with labels.
			 *
			 * Once we have that, we can find the centre point for the chart, by taking the x text protrusion
			 * on each side, removing that from the size, halving it and adding the left x protrusion width.
			 *
			 * This will mean we have a shape fitted to the canvas, as large as it can be with the labels
			 * and position it in the most space efficient manner
			 *
			 * https://dl.dropboxusercontent.com/u/34601363/yeahscience.gif
			 */


			// Get maximum radius of the polygon. Either half the height (minus the text width) or half the width.
			// Use this to calculate the offset + change. - Make sure L/R protrusion is at least 0 to stop issues with centre points
			var largestPossibleRadius = min([(this.height/2 - this.pointLabelFontSize - 5), this.width/2]),
				pointPosition,
				i,
				textWidth,
				halfTextWidth,
				furthestRight = this.width,
				furthestRightIndex,
				furthestRightAngle,
				furthestLeft = 0,
				furthestLeftIndex,
				furthestLeftAngle,
				xProtrusionLeft,
				xProtrusionRight,
				radiusReductionRight,
				radiusReductionLeft,
				maxWidthRadius;
			this.ctx.font = fontString(this.pointLabelFontSize,this.pointLabelFontStyle,this.pointLabelFontFamily);
			for (i=0;i<this.valuesCount;i++){
				// 5px to space the text slightly out - similar to what we do in the draw function.
				pointPosition = this.getPointPosition(i, largestPossibleRadius);
				textWidth = this.ctx.measureText(template(this.templateString, { value: this.labels[i] })).width + 5;
				if (i === 0 || i === this.valuesCount/2){
					// If we're at index zero, or exactly the middle, we're at exactly the top/bottom
					// of the radar chart, so text will be aligned centrally, so we'll half it and compare
					// w/left and right text sizes
					halfTextWidth = textWidth/2;
					if (pointPosition.x + halfTextWidth > furthestRight) {
						furthestRight = pointPosition.x + halfTextWidth;
						furthestRightIndex = i;
					}
					if (pointPosition.x - halfTextWidth < furthestLeft) {
						furthestLeft = pointPosition.x - halfTextWidth;
						furthestLeftIndex = i;
					}
				}
				else if (i < this.valuesCount/2) {
					// Less than half the values means we'll left align the text
					if (pointPosition.x + textWidth > furthestRight) {
						furthestRight = pointPosition.x + textWidth;
						furthestRightIndex = i;
					}
				}
				else if (i > this.valuesCount/2){
					// More than half the values means we'll right align the text
					if (pointPosition.x - textWidth < furthestLeft) {
						furthestLeft = pointPosition.x - textWidth;
						furthestLeftIndex = i;
					}
				}
			}

			xProtrusionLeft = furthestLeft;

			xProtrusionRight = Math.ceil(furthestRight - this.width);

			furthestRightAngle = this.getIndexAngle(furthestRightIndex);

			furthestLeftAngle = this.getIndexAngle(furthestLeftIndex);

			radiusReductionRight = xProtrusionRight / Math.sin(furthestRightAngle + Math.PI/2);

			radiusReductionLeft = xProtrusionLeft / Math.sin(furthestLeftAngle + Math.PI/2);

			// Ensure we actually need to reduce the size of the chart
			radiusReductionRight = (isNumber(radiusReductionRight)) ? radiusReductionRight : 0;
			radiusReductionLeft = (isNumber(radiusReductionLeft)) ? radiusReductionLeft : 0;

			this.drawingArea = largestPossibleRadius - (radiusReductionLeft + radiusReductionRight)/2;

			//this.drawingArea = min([maxWidthRadius, (this.height - (2 * (this.pointLabelFontSize + 5)))/2])
			this.setCenterPoint(radiusReductionLeft, radiusReductionRight);

		},
		setCenterPoint: function(leftMovement, rightMovement){

			var maxRight = this.width - rightMovement - this.drawingArea,
				maxLeft = leftMovement + this.drawingArea;

			this.xCenter = (maxLeft + maxRight)/2;
			// Always vertically in the centre as the text height doesn't change
			this.yCenter = (this.height/2);
		},

		getIndexAngle : function(index){
			var angleMultiplier = (Math.PI * 2) / this.valuesCount;
			// Start from the top instead of right, so remove a quarter of the circle

			return index * angleMultiplier - (Math.PI/2);
		},
		getPointPosition : function(index, distanceFromCenter){
			var thisAngle = this.getIndexAngle(index);
			return {
				x : (Math.cos(thisAngle) * distanceFromCenter) + this.xCenter,
				y : (Math.sin(thisAngle) * distanceFromCenter) + this.yCenter
			};
		},
		draw: function(){
			if (this.display){
				var ctx = this.ctx;
				each(this.yLabels, function(label, index){
					// Don't draw a centre value
					if (index > 0){
						var yCenterOffset = index * (this.drawingArea/this.steps),
							yHeight = this.yCenter - yCenterOffset,
							pointPosition;

						// Draw circular lines around the scale
						if (this.lineWidth > 0){
							ctx.strokeStyle = this.lineColor;
							ctx.lineWidth = this.lineWidth;

							if(this.lineArc){
								ctx.beginPath();
								ctx.arc(this.xCenter, this.yCenter, yCenterOffset, 0, Math.PI*2);
								ctx.closePath();
								ctx.stroke();
							} else{
								ctx.beginPath();
								for (var i=0;i<this.valuesCount;i++)
								{
									pointPosition = this.getPointPosition(i, this.calculateCenterOffset(this.min + (index * this.stepValue)));
									if (i === 0){
										ctx.moveTo(pointPosition.x, pointPosition.y);
									} else {
										ctx.lineTo(pointPosition.x, pointPosition.y);
									}
								}
								ctx.closePath();
								ctx.stroke();
							}
						}
						if(this.showLabels){
							ctx.font = fontString(this.fontSize,this.fontStyle,this.fontFamily);
							if (this.showLabelBackdrop){
								var labelWidth = ctx.measureText(label).width;
								ctx.fillStyle = this.backdropColor;
								ctx.fillRect(
									this.xCenter - labelWidth/2 - this.backdropPaddingX,
									yHeight - this.fontSize/2 - this.backdropPaddingY,
									labelWidth + this.backdropPaddingX*2,
									this.fontSize + this.backdropPaddingY*2
								);
							}
							ctx.textAlign = 'center';
							ctx.textBaseline = "middle";
							ctx.fillStyle = this.fontColor;
							ctx.fillText(label, this.xCenter, yHeight);
						}
					}
				}, this);

				if (!this.lineArc){
					ctx.lineWidth = this.angleLineWidth;
					ctx.strokeStyle = this.angleLineColor;
					for (var i = this.valuesCount - 1; i >= 0; i--) {
						if (this.angleLineWidth > 0){
							var outerPosition = this.getPointPosition(i, this.calculateCenterOffset(this.max));
							ctx.beginPath();
							ctx.moveTo(this.xCenter, this.yCenter);
							ctx.lineTo(outerPosition.x, outerPosition.y);
							ctx.stroke();
							ctx.closePath();
						}
						// Extra 3px out for some label spacing
						var pointLabelPosition = this.getPointPosition(i, this.calculateCenterOffset(this.max) + 5);
						ctx.font = fontString(this.pointLabelFontSize,this.pointLabelFontStyle,this.pointLabelFontFamily);
						ctx.fillStyle = this.pointLabelFontColor;

						var labelsCount = this.labels.length,
							halfLabelsCount = this.labels.length/2,
							quarterLabelsCount = halfLabelsCount/2,
							upperHalf = (i < quarterLabelsCount || i > labelsCount - quarterLabelsCount),
							exactQuarter = (i === quarterLabelsCount || i === labelsCount - quarterLabelsCount);
						if (i === 0){
							ctx.textAlign = 'center';
						} else if(i === halfLabelsCount){
							ctx.textAlign = 'center';
						} else if (i < halfLabelsCount){
							ctx.textAlign = 'left';
						} else {
							ctx.textAlign = 'right';
						}

						// Set the correct text baseline based on outer positioning
						if (exactQuarter){
							ctx.textBaseline = 'middle';
						} else if (upperHalf){
							ctx.textBaseline = 'bottom';
						} else {
							ctx.textBaseline = 'top';
						}

						ctx.fillText(this.labels[i], pointLabelPosition.x, pointLabelPosition.y);
					}
				}
			}
		}
	});

	// Attach global event to resize each chart instance when the browser resizes
	helpers.addEvent(window, "resize", (function(){
		// Basic debounce of resize function so it doesn't hurt performance when resizing browser.
		var timeout;
		return function(){
			clearTimeout(timeout);
			timeout = setTimeout(function(){
				each(Chart.instances,function(instance){
					// If the responsive flag is set in the chart instance config
					// Cascade the resize event down to the chart.
					if (instance.options.responsive){
						instance.resize(instance.render, true);
					}
				});
			}, 50);
		};
	})());


	if (amd) {
		define(function(){
			return Chart;
		});
	} else if (typeof module === 'object' && module.exports) {
		module.exports = Chart;
	}

	root.Chart = Chart;

	Chart.noConflict = function(){
		root.Chart = previous;
		return Chart;
	};

}).call(this);

(function(){
	"use strict";

	var root = this,
		Chart = root.Chart,
		helpers = Chart.helpers;


	var defaultConfig = {
		//Boolean - Whether the scale should start at zero, or an order of magnitude down from the lowest value
		scaleBeginAtZero : true,

		//Boolean - Whether grid lines are shown across the chart
		scaleShowGridLines : true,

		//String - Colour of the grid lines
		scaleGridLineColor : "rgba(0,0,0,.05)",

		//Number - Width of the grid lines
		scaleGridLineWidth : 1,

		//Boolean - Whether to show horizontal lines (except X axis)
		scaleShowHorizontalLines: true,

		//Boolean - Whether to show vertical lines (except Y axis)
		scaleShowVerticalLines: true,

		//Boolean - If there is a stroke on each bar
		barShowStroke : true,

		//Number - Pixel width of the bar stroke
		barStrokeWidth : 2,

		//Number - Spacing between each of the X value sets
		barValueSpacing : 5,

		//Number - Spacing between data sets within X values
		barDatasetSpacing : 1,

		//String - A legend template
		legendTemplate : "<ul class=\"<%=name.toLowerCase()%>-legend\"><% for (var i=0; i<datasets.length; i++){%><li><span style=\"background-color:<%=datasets[i].fillColor%>\"></span><%if(datasets[i].label){%><%=datasets[i].label%><%}%></li><%}%></ul>"

	};


	Chart.Type.extend({
		name: "Bar",
		defaults : defaultConfig,
		initialize:  function(data){

			//Expose options as a scope variable here so we can access it in the ScaleClass
			var options = this.options;

			this.ScaleClass = Chart.Scale.extend({
				offsetGridLines : true,
				calculateBarX : function(datasetCount, datasetIndex, barIndex){
					//Reusable method for calculating the xPosition of a given bar based on datasetIndex & width of the bar
					var xWidth = this.calculateBaseWidth(),
						xAbsolute = this.calculateX(barIndex) - (xWidth/2),
						barWidth = this.calculateBarWidth(datasetCount);

					return xAbsolute + (barWidth * datasetIndex) + (datasetIndex * options.barDatasetSpacing) + barWidth/2;
				},
				calculateBaseWidth : function(){
					return (this.calculateX(1) - this.calculateX(0)) - (2*options.barValueSpacing);
				},
				calculateBarWidth : function(datasetCount){
					//The padding between datasets is to the right of each bar, providing that there are more than 1 dataset
					var baseWidth = this.calculateBaseWidth() - ((datasetCount - 1) * options.barDatasetSpacing);

					return (baseWidth / datasetCount);
				}
			});

			this.datasets = [];

			//Set up tooltip events on the chart
			if (this.options.showTooltips){
				helpers.bindEvents(this, this.options.tooltipEvents, function(evt){
					var activeBars = (evt.type !== 'mouseout') ? this.getBarsAtEvent(evt) : [];

					this.eachBars(function(bar){
						bar.restore(['fillColor', 'strokeColor']);
					});
					helpers.each(activeBars, function(activeBar){
						activeBar.fillColor = activeBar.highlightFill;
						activeBar.strokeColor = activeBar.highlightStroke;
					});
					this.showTooltip(activeBars);
				});
			}

			//Declare the extension of the default point, to cater for the options passed in to the constructor
			this.BarClass = Chart.Rectangle.extend({
				strokeWidth : this.options.barStrokeWidth,
				showStroke : this.options.barShowStroke,
				ctx : this.chart.ctx
			});

			//Iterate through each of the datasets, and build this into a property of the chart
			helpers.each(data.datasets,function(dataset,datasetIndex){

				var datasetObject = {
					label : dataset.label || null,
					fillColor : dataset.fillColor,
					strokeColor : dataset.strokeColor,
					bars : []
				};

				this.datasets.push(datasetObject);

				helpers.each(dataset.data,function(dataPoint,index){
					//Add a new point for each piece of data, passing any required data to draw.
					datasetObject.bars.push(new this.BarClass({
						value : dataPoint,
						label : data.labels[index],
						datasetLabel: dataset.label,
						strokeColor : dataset.strokeColor,
						fillColor : dataset.fillColor,
						highlightFill : dataset.highlightFill || dataset.fillColor,
						highlightStroke : dataset.highlightStroke || dataset.strokeColor
					}));
				},this);

			},this);

			this.buildScale(data.labels);

			this.BarClass.prototype.base = this.scale.endPoint;

			this.eachBars(function(bar, index, datasetIndex){
				helpers.extend(bar, {
					width : this.scale.calculateBarWidth(this.datasets.length),
					x: this.scale.calculateBarX(this.datasets.length, datasetIndex, index),
					y: this.scale.endPoint
				});
				bar.save();
			}, this);

			this.render();
		},
		update : function(){
			this.scale.update();
			// Reset any highlight colours before updating.
			helpers.each(this.activeElements, function(activeElement){
				activeElement.restore(['fillColor', 'strokeColor']);
			});

			this.eachBars(function(bar){
				bar.save();
			});
			this.render();
		},
		eachBars : function(callback){
			helpers.each(this.datasets,function(dataset, datasetIndex){
				helpers.each(dataset.bars, callback, this, datasetIndex);
			},this);
		},
		getBarsAtEvent : function(e){
			var barsArray = [],
				eventPosition = helpers.getRelativePosition(e),
				datasetIterator = function(dataset){
					barsArray.push(dataset.bars[barIndex]);
				},
				barIndex;

			for (var datasetIndex = 0; datasetIndex < this.datasets.length; datasetIndex++) {
				for (barIndex = 0; barIndex < this.datasets[datasetIndex].bars.length; barIndex++) {
					if (this.datasets[datasetIndex].bars[barIndex].inRange(eventPosition.x,eventPosition.y)){
						helpers.each(this.datasets, datasetIterator);
						return barsArray;
					}
				}
			}

			return barsArray;
		},
		buildScale : function(labels){
			var self = this;

			var dataTotal = function(){
				var values = [];
				self.eachBars(function(bar){
					values.push(bar.value);
				});
				return values;
			};

			var scaleOptions = {
				templateString : this.options.scaleLabel,
				height : this.chart.height,
				width : this.chart.width,
				ctx : this.chart.ctx,
				textColor : this.options.scaleFontColor,
				fontSize : this.options.scaleFontSize,
				fontStyle : this.options.scaleFontStyle,
				fontFamily : this.options.scaleFontFamily,
				valuesCount : labels.length,
				beginAtZero : this.options.scaleBeginAtZero,
				integersOnly : this.options.scaleIntegersOnly,
				calculateYRange: function(currentHeight){
					var updatedRanges = helpers.calculateScaleRange(
						dataTotal(),
						currentHeight,
						this.fontSize,
						this.beginAtZero,
						this.integersOnly
					);
					helpers.extend(this, updatedRanges);
				},
				xLabels : labels,
				font : helpers.fontString(this.options.scaleFontSize, this.options.scaleFontStyle, this.options.scaleFontFamily),
				lineWidth : this.options.scaleLineWidth,
				lineColor : this.options.scaleLineColor,
				showHorizontalLines : this.options.scaleShowHorizontalLines,
				showVerticalLines : this.options.scaleShowVerticalLines,
				gridLineWidth : (this.options.scaleShowGridLines) ? this.options.scaleGridLineWidth : 0,
				gridLineColor : (this.options.scaleShowGridLines) ? this.options.scaleGridLineColor : "rgba(0,0,0,0)",
				padding : (this.options.showScale) ? 0 : (this.options.barShowStroke) ? this.options.barStrokeWidth : 0,
				showLabels : this.options.scaleShowLabels,
				display : this.options.showScale
			};

			if (this.options.scaleOverride){
				helpers.extend(scaleOptions, {
					calculateYRange: helpers.noop,
					steps: this.options.scaleSteps,
					stepValue: this.options.scaleStepWidth,
					min: this.options.scaleStartValue,
					max: this.options.scaleStartValue + (this.options.scaleSteps * this.options.scaleStepWidth)
				});
			}

			this.scale = new this.ScaleClass(scaleOptions);
		},
		addData : function(valuesArray,label){
			//Map the values array for each of the datasets
			helpers.each(valuesArray,function(value,datasetIndex){
				//Add a new point for each piece of data, passing any required data to draw.
				this.datasets[datasetIndex].bars.push(new this.BarClass({
					value : value,
					label : label,
					x: this.scale.calculateBarX(this.datasets.length, datasetIndex, this.scale.valuesCount+1),
					y: this.scale.endPoint,
					width : this.scale.calculateBarWidth(this.datasets.length),
					base : this.scale.endPoint,
					strokeColor : this.datasets[datasetIndex].strokeColor,
					fillColor : this.datasets[datasetIndex].fillColor
				}));
			},this);

			this.scale.addXLabel(label);
			//Then re-render the chart.
			this.update();
		},
		removeData : function(){
			this.scale.removeXLabel();
			//Then re-render the chart.
			helpers.each(this.datasets,function(dataset){
				dataset.bars.shift();
			},this);
			this.update();
		},
		reflow : function(){
			helpers.extend(this.BarClass.prototype,{
				y: this.scale.endPoint,
				base : this.scale.endPoint
			});
			var newScaleProps = helpers.extend({
				height : this.chart.height,
				width : this.chart.width
			});
			this.scale.update(newScaleProps);
		},
		draw : function(ease){
			var easingDecimal = ease || 1;
			this.clear();

			var ctx = this.chart.ctx;

			this.scale.draw(easingDecimal);

			//Draw all the bars for each dataset
			helpers.each(this.datasets,function(dataset,datasetIndex){
				helpers.each(dataset.bars,function(bar,index){
					if (bar.hasValue()){
						bar.base = this.scale.endPoint;
						//Transition then draw
						bar.transition({
							x : this.scale.calculateBarX(this.datasets.length, datasetIndex, index),
							y : this.scale.calculateY(bar.value),
							width : this.scale.calculateBarWidth(this.datasets.length)
						}, easingDecimal).draw();
					}
				},this);

			},this);
		}
	});


}).call(this);

(function(){
	"use strict";

	var root = this,
		Chart = root.Chart,
		//Cache a local reference to Chart.helpers
		helpers = Chart.helpers;

	var defaultConfig = {
		//Boolean - Whether we should show a stroke on each segment
		segmentShowStroke : true,

		//String - The colour of each segment stroke
		segmentStrokeColor : "#fff",

		//Number - The width of each segment stroke
		segmentStrokeWidth : 2,

		//The percentage of the chart that we cut out of the middle.
		percentageInnerCutout : 50,

		//Number - Amount of animation steps
		animationSteps : 100,

		//String - Animation easing effect
		animationEasing : "easeOutBounce",

		//Boolean - Whether we animate the rotation of the Doughnut
		animateRotate : true,

		//Boolean - Whether we animate scaling the Doughnut from the centre
		animateScale : false,

		//String - A legend template
		legendTemplate : "<ul class=\"<%=name.toLowerCase()%>-legend\"><% for (var i=0; i<segments.length; i++){%><li><span style=\"background-color:<%=segments[i].fillColor%>\"></span><%if(segments[i].label){%><%=segments[i].label%><%}%></li><%}%></ul>"

	};


	Chart.Type.extend({
		//Passing in a name registers this chart in the Chart namespace
		name: "Doughnut",
		//Providing a defaults will also register the deafults in the chart namespace
		defaults : defaultConfig,
		//Initialize is fired when the chart is initialized - Data is passed in as a parameter
		//Config is automatically merged by the core of Chart.js, and is available at this.options
		initialize:  function(data){

			//Declare segments as a static property to prevent inheriting across the Chart type prototype
			this.segments = [];
			this.outerRadius = (helpers.min([this.chart.width,this.chart.height]) -	this.options.segmentStrokeWidth/2)/2;

			this.SegmentArc = Chart.Arc.extend({
				ctx : this.chart.ctx,
				x : this.chart.width/2,
				y : this.chart.height/2
			});

			//Set up tooltip events on the chart
			if (this.options.showTooltips){
				helpers.bindEvents(this, this.options.tooltipEvents, function(evt){
					var activeSegments = (evt.type !== 'mouseout') ? this.getSegmentsAtEvent(evt) : [];

					helpers.each(this.segments,function(segment){
						segment.restore(["fillColor"]);
					});
					helpers.each(activeSegments,function(activeSegment){
						activeSegment.fillColor = activeSegment.highlightColor;
					});
					this.showTooltip(activeSegments);
				});
			}
			this.calculateTotal(data);

			helpers.each(data,function(datapoint, index){
				this.addData(datapoint, index, true);
			},this);

			this.render();
		},
		getSegmentsAtEvent : function(e){
			var segmentsArray = [];

			var location = helpers.getRelativePosition(e);

			helpers.each(this.segments,function(segment){
				if (segment.inRange(location.x,location.y)) segmentsArray.push(segment);
			},this);
			return segmentsArray;
		},
		addData : function(segment, atIndex, silent){
			var index = atIndex || this.segments.length;
			this.segments.splice(index, 0, new this.SegmentArc({
				value : segment.value,
				outerRadius : (this.options.animateScale) ? 0 : this.outerRadius,
				innerRadius : (this.options.animateScale) ? 0 : (this.outerRadius/100) * this.options.percentageInnerCutout,
				fillColor : segment.color,
				highlightColor : segment.highlight || segment.color,
				showStroke : this.options.segmentShowStroke,
				strokeWidth : this.options.segmentStrokeWidth,
				strokeColor : this.options.segmentStrokeColor,
				startAngle : Math.PI * 1.5,
				circumference : (this.options.animateRotate) ? 0 : this.calculateCircumference(segment.value),
				label : segment.label
			}));
			if (!silent){
				this.reflow();
				this.update();
			}
		},
		calculateCircumference : function(value){
			return (Math.PI*2)*(value / this.total);
		},
		calculateTotal : function(data){
			this.total = 0;
			helpers.each(data,function(segment){
				this.total += segment.value;
			},this);
		},
		update : function(){
			this.calculateTotal(this.segments);

			// Reset any highlight colours before updating.
			helpers.each(this.activeElements, function(activeElement){
				activeElement.restore(['fillColor']);
			});

			helpers.each(this.segments,function(segment){
				segment.save();
			});
			this.render();
		},

		removeData: function(atIndex){
			var indexToDelete = (helpers.isNumber(atIndex)) ? atIndex : this.segments.length-1;
			this.segments.splice(indexToDelete, 1);
			this.reflow();
			this.update();
		},

		reflow : function(){
			helpers.extend(this.SegmentArc.prototype,{
				x : this.chart.width/2,
				y : this.chart.height/2
			});
			this.outerRadius = (helpers.min([this.chart.width,this.chart.height]) -	this.options.segmentStrokeWidth/2)/2;
			helpers.each(this.segments, function(segment){
				segment.update({
					outerRadius : this.outerRadius,
					innerRadius : (this.outerRadius/100) * this.options.percentageInnerCutout
				});
			}, this);
		},
		draw : function(easeDecimal){
			var animDecimal = (easeDecimal) ? easeDecimal : 1;
			this.clear();
			helpers.each(this.segments,function(segment,index){
				segment.transition({
					circumference : this.calculateCircumference(segment.value),
					outerRadius : this.outerRadius,
					innerRadius : (this.outerRadius/100) * this.options.percentageInnerCutout
				},animDecimal);

				segment.endAngle = segment.startAngle + segment.circumference;

				segment.draw();
				if (index === 0){
					segment.startAngle = Math.PI * 1.5;
				}
				//Check to see if it's the last segment, if not get the next and update the start angle
				if (index < this.segments.length-1){
					this.segments[index+1].startAngle = segment.endAngle;
				}
			},this);

		}
	});

	Chart.types.Doughnut.extend({
		name : "Pie",
		defaults : helpers.merge(defaultConfig,{percentageInnerCutout : 0})
	});

}).call(this);
(function(){
	"use strict";

	var root = this,
		Chart = root.Chart,
		helpers = Chart.helpers;

	var defaultConfig = {

		///Boolean - Whether grid lines are shown across the chart
		scaleShowGridLines : true,

		//String - Colour of the grid lines
		scaleGridLineColor : "rgba(0,0,0,.05)",

		//Number - Width of the grid lines
		scaleGridLineWidth : 1,

		//Boolean - Whether to show horizontal lines (except X axis)
		scaleShowHorizontalLines: true,

		//Boolean - Whether to show vertical lines (except Y axis)
		scaleShowVerticalLines: true,

		//Boolean - Whether the line is curved between points
		bezierCurve : true,

		//Number - Tension of the bezier curve between points
		bezierCurveTension : 0.4,

		//Boolean - Whether to show a dot for each point
		pointDot : true,

		//Number - Radius of each point dot in pixels
		pointDotRadius : 4,

		//Number - Pixel width of point dot stroke
		pointDotStrokeWidth : 1,

		//Number - amount extra to add to the radius to cater for hit detection outside the drawn point
		pointHitDetectionRadius : 20,

		//Boolean - Whether to show a stroke for datasets
		datasetStroke : true,

		//Number - Pixel width of dataset stroke
		datasetStrokeWidth : 2,

		//Boolean - Whether to fill the dataset with a colour
		datasetFill : true,

		//String - A legend template
		legendTemplate : "<ul class=\"<%=name.toLowerCase()%>-legend\"><% for (var i=0; i<datasets.length; i++){%><li><span style=\"background-color:<%=datasets[i].strokeColor%>\"></span><%if(datasets[i].label){%><%=datasets[i].label%><%}%></li><%}%></ul>"

	};


	Chart.Type.extend({
		name: "Line",
		defaults : defaultConfig,
		initialize:  function(data){
			//Declare the extension of the default point, to cater for the options passed in to the constructor
			this.PointClass = Chart.Point.extend({
				strokeWidth : this.options.pointDotStrokeWidth,
				radius : this.options.pointDotRadius,
				display: this.options.pointDot,
				hitDetectionRadius : this.options.pointHitDetectionRadius,
				ctx : this.chart.ctx,
				inRange : function(mouseX){
					return (Math.pow(mouseX-this.x, 2) < Math.pow(this.radius + this.hitDetectionRadius,2));
				}
			});

			this.datasets = [];

			//Set up tooltip events on the chart
			if (this.options.showTooltips){
				helpers.bindEvents(this, this.options.tooltipEvents, function(evt){
					var activePoints = (evt.type !== 'mouseout') ? this.getPointsAtEvent(evt) : [];
					this.eachPoints(function(point){
						point.restore(['fillColor', 'strokeColor']);
					});
					helpers.each(activePoints, function(activePoint){
						activePoint.fillColor = activePoint.highlightFill;
						activePoint.strokeColor = activePoint.highlightStroke;
					});
					this.showTooltip(activePoints);
				});
			}

			//Iterate through each of the datasets, and build this into a property of the chart
			helpers.each(data.datasets,function(dataset){

				var datasetObject = {
					label : dataset.label || null,
					fillColor : dataset.fillColor,
					strokeColor : dataset.strokeColor,
					pointColor : dataset.pointColor,
					pointStrokeColor : dataset.pointStrokeColor,
					points : []
				};

				this.datasets.push(datasetObject);


				helpers.each(dataset.data,function(dataPoint,index){
					//Add a new point for each piece of data, passing any required data to draw.
					datasetObject.points.push(new this.PointClass({
						value : dataPoint,
						label : data.labels[index],
						datasetLabel: dataset.label,
						strokeColor : dataset.pointStrokeColor,
						fillColor : dataset.pointColor,
						highlightFill : dataset.pointHighlightFill || dataset.pointColor,
						highlightStroke : dataset.pointHighlightStroke || dataset.pointStrokeColor
					}));
				},this);

				this.buildScale(data.labels);


				this.eachPoints(function(point, index){
					helpers.extend(point, {
						x: this.scale.calculateX(index),
						y: this.scale.endPoint
					});
					point.save();
				}, this);

			},this);


			this.render();
		},
		update : function(){
			this.scale.update();
			// Reset any highlight colours before updating.
			helpers.each(this.activeElements, function(activeElement){
				activeElement.restore(['fillColor', 'strokeColor']);
			});
			this.eachPoints(function(point){
				point.save();
			});
			this.render();
		},
		eachPoints : function(callback){
			helpers.each(this.datasets,function(dataset){
				helpers.each(dataset.points,callback,this);
			},this);
		},
		getPointsAtEvent : function(e){
			var pointsArray = [],
				eventPosition = helpers.getRelativePosition(e);
			helpers.each(this.datasets,function(dataset){
				helpers.each(dataset.points,function(point){
					if (point.inRange(eventPosition.x,eventPosition.y)) pointsArray.push(point);
				});
			},this);
			return pointsArray;
		},
		buildScale : function(labels){
			var self = this;

			var dataTotal = function(){
				var values = [];
				self.eachPoints(function(point){
					values.push(point.value);
				});

				return values;
			};

			var scaleOptions = {
				templateString : this.options.scaleLabel,
				height : this.chart.height,
				width : this.chart.width,
				ctx : this.chart.ctx,
				textColor : this.options.scaleFontColor,
				fontSize : this.options.scaleFontSize,
				fontStyle : this.options.scaleFontStyle,
				fontFamily : this.options.scaleFontFamily,
				valuesCount : labels.length,
				beginAtZero : this.options.scaleBeginAtZero,
				integersOnly : this.options.scaleIntegersOnly,
				calculateYRange : function(currentHeight){
					var updatedRanges = helpers.calculateScaleRange(
						dataTotal(),
						currentHeight,
						this.fontSize,
						this.beginAtZero,
						this.integersOnly
					);
					helpers.extend(this, updatedRanges);
				},
				xLabels : labels,
				font : helpers.fontString(this.options.scaleFontSize, this.options.scaleFontStyle, this.options.scaleFontFamily),
				lineWidth : this.options.scaleLineWidth,
				lineColor : this.options.scaleLineColor,
				showHorizontalLines : this.options.scaleShowHorizontalLines,
				showVerticalLines : this.options.scaleShowVerticalLines,
				gridLineWidth : (this.options.scaleShowGridLines) ? this.options.scaleGridLineWidth : 0,
				gridLineColor : (this.options.scaleShowGridLines) ? this.options.scaleGridLineColor : "rgba(0,0,0,0)",
				padding: (this.options.showScale) ? 0 : this.options.pointDotRadius + this.options.pointDotStrokeWidth,
				showLabels : this.options.scaleShowLabels,
				display : this.options.showScale
			};

			if (this.options.scaleOverride){
				helpers.extend(scaleOptions, {
					calculateYRange: helpers.noop,
					steps: this.options.scaleSteps,
					stepValue: this.options.scaleStepWidth,
					min: this.options.scaleStartValue,
					max: this.options.scaleStartValue + (this.options.scaleSteps * this.options.scaleStepWidth)
				});
			}


			this.scale = new Chart.Scale(scaleOptions);
		},
		addData : function(valuesArray,label){
			//Map the values array for each of the datasets

			helpers.each(valuesArray,function(value,datasetIndex){
				//Add a new point for each piece of data, passing any required data to draw.
				this.datasets[datasetIndex].points.push(new this.PointClass({
					value : value,
					label : label,
					x: this.scale.calculateX(this.scale.valuesCount+1),
					y: this.scale.endPoint,
					strokeColor : this.datasets[datasetIndex].pointStrokeColor,
					fillColor : this.datasets[datasetIndex].pointColor
				}));
			},this);

			this.scale.addXLabel(label);
			//Then re-render the chart.
			this.update();
		},
		removeData : function(){
			this.scale.removeXLabel();
			//Then re-render the chart.
			helpers.each(this.datasets,function(dataset){
				dataset.points.shift();
			},this);
			this.update();
		},
		reflow : function(){
			var newScaleProps = helpers.extend({
				height : this.chart.height,
				width : this.chart.width
			});
			this.scale.update(newScaleProps);
		},
		draw : function(ease){
			var easingDecimal = ease || 1;
			this.clear();

			var ctx = this.chart.ctx;

			// Some helper methods for getting the next/prev points
			var hasValue = function(item){
				return item.value !== null;
			},
			nextPoint = function(point, collection, index){
				return helpers.findNextWhere(collection, hasValue, index) || point;
			},
			previousPoint = function(point, collection, index){
				return helpers.findPreviousWhere(collection, hasValue, index) || point;
			};

			this.scale.draw(easingDecimal);


			helpers.each(this.datasets,function(dataset){
				var pointsWithValues = helpers.where(dataset.points, hasValue);

				//Transition each point first so that the line and point drawing isn't out of sync
				//We can use this extra loop to calculate the control points of this dataset also in this loop

				helpers.each(dataset.points, function(point, index){
					if (point.hasValue()){
						point.transition({
							y : this.scale.calculateY(point.value),
							x : this.scale.calculateX(index)
						}, easingDecimal);
					}
				},this);


				// Control points need to be calculated in a seperate loop, because we need to know the current x/y of the point
				// This would cause issues when there is no animation, because the y of the next point would be 0, so beziers would be skewed
				if (this.options.bezierCurve){
					helpers.each(pointsWithValues, function(point, index){
						var tension = (index > 0 && index < pointsWithValues.length - 1) ? this.options.bezierCurveTension : 0;
						point.controlPoints = helpers.splineCurve(
							previousPoint(point, pointsWithValues, index),
							point,
							nextPoint(point, pointsWithValues, index),
							tension
						);

						// Prevent the bezier going outside of the bounds of the graph

						// Cap puter bezier handles to the upper/lower scale bounds
						if (point.controlPoints.outer.y > this.scale.endPoint){
							point.controlPoints.outer.y = this.scale.endPoint;
						}
						else if (point.controlPoints.outer.y < this.scale.startPoint){
							point.controlPoints.outer.y = this.scale.startPoint;
						}

						// Cap inner bezier handles to the upper/lower scale bounds
						if (point.controlPoints.inner.y > this.scale.endPoint){
							point.controlPoints.inner.y = this.scale.endPoint;
						}
						else if (point.controlPoints.inner.y < this.scale.startPoint){
							point.controlPoints.inner.y = this.scale.startPoint;
						}
					},this);
				}


				//Draw the line between all the points
				ctx.lineWidth = this.options.datasetStrokeWidth;
				ctx.strokeStyle = dataset.strokeColor;
				ctx.beginPath();

				helpers.each(pointsWithValues, function(point, index){
					if (index === 0){
						ctx.moveTo(point.x, point.y);
					}
					else{
						if(this.options.bezierCurve){
							var previous = previousPoint(point, pointsWithValues, index);

							ctx.bezierCurveTo(
								previous.controlPoints.outer.x,
								previous.controlPoints.outer.y,
								point.controlPoints.inner.x,
								point.controlPoints.inner.y,
								point.x,
								point.y
							);
						}
						else{
							ctx.lineTo(point.x,point.y);
						}
					}
				}, this);

				ctx.stroke();

				if (this.options.datasetFill && pointsWithValues.length > 0){
					//Round off the line by going to the base of the chart, back to the start, then fill.
					ctx.lineTo(pointsWithValues[pointsWithValues.length - 1].x, this.scale.endPoint);
					ctx.lineTo(pointsWithValues[0].x, this.scale.endPoint);
					ctx.fillStyle = dataset.fillColor;
					ctx.closePath();
					ctx.fill();
				}

				//Now draw the points over the line
				//A little inefficient double looping, but better than the line
				//lagging behind the point positions
				helpers.each(pointsWithValues,function(point){
					point.draw();
				});
			},this);
		}
	});


}).call(this);

(function(){
	"use strict";

	var root = this,
		Chart = root.Chart,
		//Cache a local reference to Chart.helpers
		helpers = Chart.helpers;

	var defaultConfig = {
		//Boolean - Show a backdrop to the scale label
		scaleShowLabelBackdrop : true,

		//String - The colour of the label backdrop
		scaleBackdropColor : "rgba(255,255,255,0.75)",

		// Boolean - Whether the scale should begin at zero
		scaleBeginAtZero : true,

		//Number - The backdrop padding above & below the label in pixels
		scaleBackdropPaddingY : 2,

		//Number - The backdrop padding to the side of the label in pixels
		scaleBackdropPaddingX : 2,

		//Boolean - Show line for each value in the scale
		scaleShowLine : true,

		//Boolean - Stroke a line around each segment in the chart
		segmentShowStroke : true,

		//String - The colour of the stroke on each segement.
		segmentStrokeColor : "#fff",

		//Number - The width of the stroke value in pixels
		segmentStrokeWidth : 2,

		//Number - Amount of animation steps
		animationSteps : 100,

		//String - Animation easing effect.
		animationEasing : "easeOutBounce",

		//Boolean - Whether to animate the rotation of the chart
		animateRotate : true,

		//Boolean - Whether to animate scaling the chart from the centre
		animateScale : false,

		//String - A legend template
		legendTemplate : "<ul class=\"<%=name.toLowerCase()%>-legend\"><% for (var i=0; i<segments.length; i++){%><li><span style=\"background-color:<%=segments[i].fillColor%>\"></span><%if(segments[i].label){%><%=segments[i].label%><%}%></li><%}%></ul>"
	};


	Chart.Type.extend({
		//Passing in a name registers this chart in the Chart namespace
		name: "PolarArea",
		//Providing a defaults will also register the deafults in the chart namespace
		defaults : defaultConfig,
		//Initialize is fired when the chart is initialized - Data is passed in as a parameter
		//Config is automatically merged by the core of Chart.js, and is available at this.options
		initialize:  function(data){
			this.segments = [];
			//Declare segment class as a chart instance specific class, so it can share props for this instance
			this.SegmentArc = Chart.Arc.extend({
				showStroke : this.options.segmentShowStroke,
				strokeWidth : this.options.segmentStrokeWidth,
				strokeColor : this.options.segmentStrokeColor,
				ctx : this.chart.ctx,
				innerRadius : 0,
				x : this.chart.width/2,
				y : this.chart.height/2
			});
			this.scale = new Chart.RadialScale({
				display: this.options.showScale,
				fontStyle: this.options.scaleFontStyle,
				fontSize: this.options.scaleFontSize,
				fontFamily: this.options.scaleFontFamily,
				fontColor: this.options.scaleFontColor,
				showLabels: this.options.scaleShowLabels,
				showLabelBackdrop: this.options.scaleShowLabelBackdrop,
				backdropColor: this.options.scaleBackdropColor,
				backdropPaddingY : this.options.scaleBackdropPaddingY,
				backdropPaddingX: this.options.scaleBackdropPaddingX,
				lineWidth: (this.options.scaleShowLine) ? this.options.scaleLineWidth : 0,
				lineColor: this.options.scaleLineColor,
				lineArc: true,
				width: this.chart.width,
				height: this.chart.height,
				xCenter: this.chart.width/2,
				yCenter: this.chart.height/2,
				ctx : this.chart.ctx,
				templateString: this.options.scaleLabel,
				valuesCount: data.length
			});

			this.updateScaleRange(data);

			this.scale.update();

			helpers.each(data,function(segment,index){
				this.addData(segment,index,true);
			},this);

			//Set up tooltip events on the chart
			if (this.options.showTooltips){
				helpers.bindEvents(this, this.options.tooltipEvents, function(evt){
					var activeSegments = (evt.type !== 'mouseout') ? this.getSegmentsAtEvent(evt) : [];
					helpers.each(this.segments,function(segment){
						segment.restore(["fillColor"]);
					});
					helpers.each(activeSegments,function(activeSegment){
						activeSegment.fillColor = activeSegment.highlightColor;
					});
					this.showTooltip(activeSegments);
				});
			}

			this.render();
		},
		getSegmentsAtEvent : function(e){
			var segmentsArray = [];

			var location = helpers.getRelativePosition(e);

			helpers.each(this.segments,function(segment){
				if (segment.inRange(location.x,location.y)) segmentsArray.push(segment);
			},this);
			return segmentsArray;
		},
		addData : function(segment, atIndex, silent){
			var index = atIndex || this.segments.length;

			this.segments.splice(index, 0, new this.SegmentArc({
				fillColor: segment.color,
				highlightColor: segment.highlight || segment.color,
				label: segment.label,
				value: segment.value,
				outerRadius: (this.options.animateScale) ? 0 : this.scale.calculateCenterOffset(segment.value),
				circumference: (this.options.animateRotate) ? 0 : this.scale.getCircumference(),
				startAngle: Math.PI * 1.5
			}));
			if (!silent){
				this.reflow();
				this.update();
			}
		},
		removeData: function(atIndex){
			var indexToDelete = (helpers.isNumber(atIndex)) ? atIndex : this.segments.length-1;
			this.segments.splice(indexToDelete, 1);
			this.reflow();
			this.update();
		},
		calculateTotal: function(data){
			this.total = 0;
			helpers.each(data,function(segment){
				this.total += segment.value;
			},this);
			this.scale.valuesCount = this.segments.length;
		},
		updateScaleRange: function(datapoints){
			var valuesArray = [];
			helpers.each(datapoints,function(segment){
				valuesArray.push(segment.value);
			});

			var scaleSizes = (this.options.scaleOverride) ?
				{
					steps: this.options.scaleSteps,
					stepValue: this.options.scaleStepWidth,
					min: this.options.scaleStartValue,
					max: this.options.scaleStartValue + (this.options.scaleSteps * this.options.scaleStepWidth)
				} :
				helpers.calculateScaleRange(
					valuesArray,
					helpers.min([this.chart.width, this.chart.height])/2,
					this.options.scaleFontSize,
					this.options.scaleBeginAtZero,
					this.options.scaleIntegersOnly
				);

			helpers.extend(
				this.scale,
				scaleSizes,
				{
					size: helpers.min([this.chart.width, this.chart.height]),
					xCenter: this.chart.width/2,
					yCenter: this.chart.height/2
				}
			);

		},
		update : function(){
			this.calculateTotal(this.segments);

			helpers.each(this.segments,function(segment){
				segment.save();
			});
			this.render();
		},
		reflow : function(){
			helpers.extend(this.SegmentArc.prototype,{
				x : this.chart.width/2,
				y : this.chart.height/2
			});
			this.updateScaleRange(this.segments);
			this.scale.update();

			helpers.extend(this.scale,{
				xCenter: this.chart.width/2,
				yCenter: this.chart.height/2
			});

			helpers.each(this.segments, function(segment){
				segment.update({
					outerRadius : this.scale.calculateCenterOffset(segment.value)
				});
			}, this);

		},
		draw : function(ease){
			var easingDecimal = ease || 1;
			//Clear & draw the canvas
			this.clear();
			helpers.each(this.segments,function(segment, index){
				segment.transition({
					circumference : this.scale.getCircumference(),
					outerRadius : this.scale.calculateCenterOffset(segment.value)
				},easingDecimal);

				segment.endAngle = segment.startAngle + segment.circumference;

				// If we've removed the first segment we need to set the first one to
				// start at the top.
				if (index === 0){
					segment.startAngle = Math.PI * 1.5;
				}

				//Check to see if it's the last segment, if not get the next and update the start angle
				if (index < this.segments.length - 1){
					this.segments[index+1].startAngle = segment.endAngle;
				}
				segment.draw();
			}, this);
			this.scale.draw();
		}
	});

}).call(this);
(function(){
	"use strict";

	var root = this,
		Chart = root.Chart,
		helpers = Chart.helpers;



	Chart.Type.extend({
		name: "Radar",
		defaults:{
			//Boolean - Whether to show lines for each scale point
			scaleShowLine : true,

			//Boolean - Whether we show the angle lines out of the radar
			angleShowLineOut : true,

			//Boolean - Whether to show labels on the scale
			scaleShowLabels : false,

			// Boolean - Whether the scale should begin at zero
			scaleBeginAtZero : true,

			//String - Colour of the angle line
			angleLineColor : "rgba(0,0,0,.1)",

			//Number - Pixel width of the angle line
			angleLineWidth : 1,

			//String - Point label font declaration
			pointLabelFontFamily : "'Arial'",

			//String - Point label font weight
			pointLabelFontStyle : "normal",

			//Number - Point label font size in pixels
			pointLabelFontSize : 10,

			//String - Point label font colour
			pointLabelFontColor : "#666",

			//Boolean - Whether to show a dot for each point
			pointDot : true,

			//Number - Radius of each point dot in pixels
			pointDotRadius : 3,

			//Number - Pixel width of point dot stroke
			pointDotStrokeWidth : 1,

			//Number - amount extra to add to the radius to cater for hit detection outside the drawn point
			pointHitDetectionRadius : 20,

			//Boolean - Whether to show a stroke for datasets
			datasetStroke : true,

			//Number - Pixel width of dataset stroke
			datasetStrokeWidth : 2,

			//Boolean - Whether to fill the dataset with a colour
			datasetFill : true,

			//String - A legend template
			legendTemplate : "<ul class=\"<%=name.toLowerCase()%>-legend\"><% for (var i=0; i<datasets.length; i++){%><li><span style=\"background-color:<%=datasets[i].strokeColor%>\"></span><%if(datasets[i].label){%><%=datasets[i].label%><%}%></li><%}%></ul>"

		},

		initialize: function(data){
			this.PointClass = Chart.Point.extend({
				strokeWidth : this.options.pointDotStrokeWidth,
				radius : this.options.pointDotRadius,
				display: this.options.pointDot,
				hitDetectionRadius : this.options.pointHitDetectionRadius,
				ctx : this.chart.ctx
			});

			this.datasets = [];

			this.buildScale(data);

			//Set up tooltip events on the chart
			if (this.options.showTooltips){
				helpers.bindEvents(this, this.options.tooltipEvents, function(evt){
					var activePointsCollection = (evt.type !== 'mouseout') ? this.getPointsAtEvent(evt) : [];

					this.eachPoints(function(point){
						point.restore(['fillColor', 'strokeColor']);
					});
					helpers.each(activePointsCollection, function(activePoint){
						activePoint.fillColor = activePoint.highlightFill;
						activePoint.strokeColor = activePoint.highlightStroke;
					});

					this.showTooltip(activePointsCollection);
				});
			}

			//Iterate through each of the datasets, and build this into a property of the chart
			helpers.each(data.datasets,function(dataset){

				var datasetObject = {
					label: dataset.label || null,
					fillColor : dataset.fillColor,
					strokeColor : dataset.strokeColor,
					pointColor : dataset.pointColor,
					pointStrokeColor : dataset.pointStrokeColor,
					points : []
				};

				this.datasets.push(datasetObject);

				helpers.each(dataset.data,function(dataPoint,index){
					//Add a new point for each piece of data, passing any required data to draw.
					var pointPosition;
					if (!this.scale.animation){
						pointPosition = this.scale.getPointPosition(index, this.scale.calculateCenterOffset(dataPoint));
					}
					datasetObject.points.push(new this.PointClass({
						value : dataPoint,
						label : data.labels[index],
						datasetLabel: dataset.label,
						x: (this.options.animation) ? this.scale.xCenter : pointPosition.x,
						y: (this.options.animation) ? this.scale.yCenter : pointPosition.y,
						strokeColor : dataset.pointStrokeColor,
						fillColor : dataset.pointColor,
						highlightFill : dataset.pointHighlightFill || dataset.pointColor,
						highlightStroke : dataset.pointHighlightStroke || dataset.pointStrokeColor
					}));
				},this);

			},this);

			this.render();
		},
		eachPoints : function(callback){
			helpers.each(this.datasets,function(dataset){
				helpers.each(dataset.points,callback,this);
			},this);
		},

		getPointsAtEvent : function(evt){
			var mousePosition = helpers.getRelativePosition(evt),
				fromCenter = helpers.getAngleFromPoint({
					x: this.scale.xCenter,
					y: this.scale.yCenter
				}, mousePosition);

			var anglePerIndex = (Math.PI * 2) /this.scale.valuesCount,
				pointIndex = Math.round((fromCenter.angle - Math.PI * 1.5) / anglePerIndex),
				activePointsCollection = [];

			// If we're at the top, make the pointIndex 0 to get the first of the array.
			if (pointIndex >= this.scale.valuesCount || pointIndex < 0){
				pointIndex = 0;
			}

			if (fromCenter.distance <= this.scale.drawingArea){
				helpers.each(this.datasets, function(dataset){
					activePointsCollection.push(dataset.points[pointIndex]);
				});
			}

			return activePointsCollection;
		},

		buildScale : function(data){
			this.scale = new Chart.RadialScale({
				display: this.options.showScale,
				fontStyle: this.options.scaleFontStyle,
				fontSize: this.options.scaleFontSize,
				fontFamily: this.options.scaleFontFamily,
				fontColor: this.options.scaleFontColor,
				showLabels: this.options.scaleShowLabels,
				showLabelBackdrop: this.options.scaleShowLabelBackdrop,
				backdropColor: this.options.scaleBackdropColor,
				backdropPaddingY : this.options.scaleBackdropPaddingY,
				backdropPaddingX: this.options.scaleBackdropPaddingX,
				lineWidth: (this.options.scaleShowLine) ? this.options.scaleLineWidth : 0,
				lineColor: this.options.scaleLineColor,
				angleLineColor : this.options.angleLineColor,
				angleLineWidth : (this.options.angleShowLineOut) ? this.options.angleLineWidth : 0,
				// Point labels at the edge of each line
				pointLabelFontColor : this.options.pointLabelFontColor,
				pointLabelFontSize : this.options.pointLabelFontSize,
				pointLabelFontFamily : this.options.pointLabelFontFamily,
				pointLabelFontStyle : this.options.pointLabelFontStyle,
				height : this.chart.height,
				width: this.chart.width,
				xCenter: this.chart.width/2,
				yCenter: this.chart.height/2,
				ctx : this.chart.ctx,
				templateString: this.options.scaleLabel,
				labels: data.labels,
				valuesCount: data.datasets[0].data.length
			});

			this.scale.setScaleSize();
			this.updateScaleRange(data.datasets);
			this.scale.buildYLabels();
		},
		updateScaleRange: function(datasets){
			var valuesArray = (function(){
				var totalDataArray = [];
				helpers.each(datasets,function(dataset){
					if (dataset.data){
						totalDataArray = totalDataArray.concat(dataset.data);
					}
					else {
						helpers.each(dataset.points, function(point){
							totalDataArray.push(point.value);
						});
					}
				});
				return totalDataArray;
			})();


			var scaleSizes = (this.options.scaleOverride) ?
				{
					steps: this.options.scaleSteps,
					stepValue: this.options.scaleStepWidth,
					min: this.options.scaleStartValue,
					max: this.options.scaleStartValue + (this.options.scaleSteps * this.options.scaleStepWidth)
				} :
				helpers.calculateScaleRange(
					valuesArray,
					helpers.min([this.chart.width, this.chart.height])/2,
					this.options.scaleFontSize,
					this.options.scaleBeginAtZero,
					this.options.scaleIntegersOnly
				);

			helpers.extend(
				this.scale,
				scaleSizes
			);

		},
		addData : function(valuesArray,label){
			//Map the values array for each of the datasets
			this.scale.valuesCount++;
			helpers.each(valuesArray,function(value,datasetIndex){
				var pointPosition = this.scale.getPointPosition(this.scale.valuesCount, this.scale.calculateCenterOffset(value));
				this.datasets[datasetIndex].points.push(new this.PointClass({
					value : value,
					label : label,
					x: pointPosition.x,
					y: pointPosition.y,
					strokeColor : this.datasets[datasetIndex].pointStrokeColor,
					fillColor : this.datasets[datasetIndex].pointColor
				}));
			},this);

			this.scale.labels.push(label);

			this.reflow();

			this.update();
		},
		removeData : function(){
			this.scale.valuesCount--;
			this.scale.labels.shift();
			helpers.each(this.datasets,function(dataset){
				dataset.points.shift();
			},this);
			this.reflow();
			this.update();
		},
		update : function(){
			this.eachPoints(function(point){
				point.save();
			});
			this.reflow();
			this.render();
		},
		reflow: function(){
			helpers.extend(this.scale, {
				width : this.chart.width,
				height: this.chart.height,
				size : helpers.min([this.chart.width, this.chart.height]),
				xCenter: this.chart.width/2,
				yCenter: this.chart.height/2
			});
			this.updateScaleRange(this.datasets);
			this.scale.setScaleSize();
			this.scale.buildYLabels();
		},
		draw : function(ease){
			var easeDecimal = ease || 1,
				ctx = this.chart.ctx;
			this.clear();
			this.scale.draw();

			helpers.each(this.datasets,function(dataset){

				//Transition each point first so that the line and point drawing isn't out of sync
				helpers.each(dataset.points,function(point,index){
					if (point.hasValue()){
						point.transition(this.scale.getPointPosition(index, this.scale.calculateCenterOffset(point.value)), easeDecimal);
					}
				},this);



				//Draw the line between all the points
				ctx.lineWidth = this.options.datasetStrokeWidth;
				ctx.strokeStyle = dataset.strokeColor;
				ctx.beginPath();
				helpers.each(dataset.points,function(point,index){
					if (index === 0){
						ctx.moveTo(point.x,point.y);
					}
					else{
						ctx.lineTo(point.x,point.y);
					}
				},this);
				ctx.closePath();
				ctx.stroke();

				ctx.fillStyle = dataset.fillColor;
				ctx.fill();

				//Now draw the points over the line
				//A little inefficient double looping, but better than the line
				//lagging behind the point positions
				helpers.each(dataset.points,function(point){
					if (point.hasValue()){
						point.draw();
					}
				});

			},this);

		}

	});





}).call(this);
/*!
 * pickadate.js v3.5.5, 2015/02/08
 * By Amsul, http://amsul.ca
 * Hosted on http://amsul.github.io/pickadate.js
 * Licensed under MIT
 */

(function (factory) {

    // AMD.
    if (typeof define == 'function' && define.amd)
        define('picker', ['jquery'], factory)

        // Node.js/browserify.
    else if (typeof exports == 'object')
        module.exports = factory(require('jquery'))

        // Browser globals.
    else this.Picker = factory(jQuery)

}(function ($) {

    var $window = $(window)
    var $document = $(document)
    var $html = $(document.documentElement)
    var supportsTransitions = document.body.style.transition != null


    /**
     * The picker constructor that creates a blank picker.
     */
    function PickerConstructor(ELEMENT, NAME, COMPONENT, OPTIONS) {

        // If there’s no element, return the picker constructor.
        if (!ELEMENT) return PickerConstructor


        var
            IS_DEFAULT_THEME = false,


            // The state of the picker.
            STATE = {
                id: ELEMENT.id || 'P' + Math.abs(~~(Math.random() * new Date()))
            },


            // Merge the defaults and options passed.
            SETTINGS = COMPONENT ? $.extend(true, {}, COMPONENT.defaults, OPTIONS) : OPTIONS || {},


            // Merge the default classes with the settings classes.
            CLASSES = $.extend({}, PickerConstructor.klasses(), SETTINGS.klass),


            // The element node wrapper into a jQuery object.
            $ELEMENT = $(ELEMENT),


            // Pseudo picker constructor.
            PickerInstance = function () {
                return this.start()
            },


            // The picker prototype.
            P = PickerInstance.prototype = {

                constructor: PickerInstance,

                $node: $ELEMENT,


                /**
                 * Initialize everything
                 */
                start: function () {

                    // If it’s already started, do nothing.
                    if (STATE && STATE.start) return P


                    // Update the picker states.
                    STATE.methods = {}
                    STATE.start = true
                    STATE.open = false
                    STATE.type = ELEMENT.type


                    // Confirm focus state, convert into text input to remove UA stylings,
                    // and set as readonly to prevent keyboard popup.
                    ELEMENT.autofocus = ELEMENT == getActiveElement()
                    ELEMENT.readOnly = !SETTINGS.editable
                    ELEMENT.id = ELEMENT.id || STATE.id
                    if (ELEMENT.type != 'text') {
                        ELEMENT.type = 'text'
                    }


                    // Create a new picker component with the settings.
                    P.component = new COMPONENT(P, SETTINGS)


                    // Create the picker root and then prepare it.
                    P.$root = $('<div class="' + CLASSES.picker + '" id="' + ELEMENT.id + '_root" />')
                    prepareElementRoot()


                    // Create the picker holder and then prepare it.
                    P.$holder = $(createWrappedComponent()).appendTo(P.$root)
                    prepareElementHolder()


                    // If there’s a format for the hidden input element, create the element.
                    if (SETTINGS.formatSubmit) {
                        prepareElementHidden()
                    }


                    // Prepare the input element.
                    prepareElement()


                    // Insert the hidden input as specified in the settings.
                    if (SETTINGS.containerHidden) $(SETTINGS.containerHidden).append(P._hidden)
                    else $ELEMENT.after(P._hidden)


                    // Insert the root as specified in the settings.
                    if (SETTINGS.container) $(SETTINGS.container).append(P.$root)
                    else $ELEMENT.after(P.$root)


                    // Bind the default component and settings events.
                    P.on({
                        start: P.component.onStart,
                        render: P.component.onRender,
                        stop: P.component.onStop,
                        open: P.component.onOpen,
                        close: P.component.onClose,
                        set: P.component.onSet
                    }).on({
                        start: SETTINGS.onStart,
                        render: SETTINGS.onRender,
                        stop: SETTINGS.onStop,
                        open: SETTINGS.onOpen,
                        close: SETTINGS.onClose,
                        set: SETTINGS.onSet
                    })


                    // Once we’re all set, check the theme in use.
                    IS_DEFAULT_THEME = isUsingDefaultTheme(P.$holder[0])


                    // If the element has autofocus, open the picker.
                    if (ELEMENT.autofocus) {
                        P.open()
                    }


                    // Trigger queued the “start” and “render” events.
                    return P.trigger('start').trigger('render')
                }, //start


                /**
                 * Render a new picker
                 */
                render: function (entireComponent) {

                    // Insert a new component holder in the root or box.
                    if (entireComponent) {
                        P.$holder = createWrappedComponent()
                        P.$root.html(P.$holder)
                    }
                    else P.$root.find('.' + CLASSES.box).html(P.component.nodes(STATE.open))

                    // Trigger the queued “render” events.
                    return P.trigger('render')
                }, //render


                /**
                 * Destroy everything
                 */
                stop: function () {

                    // If it’s already stopped, do nothing.
                    if (!STATE.start) return P

                    // Then close the picker.
                    P.close()

                    // Remove the hidden field.
                    if (P._hidden) {
                        P._hidden.parentNode.removeChild(P._hidden)
                    }

                    // Remove the root.
                    P.$root.remove()

                    // Remove the input class, remove the stored data, and unbind
                    // the events (after a tick for IE - see `P.close`).
                    $ELEMENT.removeClass(CLASSES.input).removeData(NAME)
                    setTimeout(function () {
                        $ELEMENT.off('.' + STATE.id)
                    }, 0)

                    // Restore the element state
                    ELEMENT.type = STATE.type
                    ELEMENT.readOnly = false

                    // Trigger the queued “stop” events.
                    P.trigger('stop')

                    // Reset the picker states.
                    STATE.methods = {}
                    STATE.start = false

                    return P
                }, //stop


                /**
                 * Open up the picker
                 */
                open: function (dontGiveFocus) {

                    // If it’s already open, do nothing.
                    if (STATE.open) return P

                    // Add the “active” class.
                    $ELEMENT.addClass(CLASSES.active)
                    aria(ELEMENT, 'expanded', true)

                    // * A Firefox bug, when `html` has `overflow:hidden`, results in
                    //   killing transitions :(. So add the “opened” state on the next tick.
                    //   Bug: https://bugzilla.mozilla.org/show_bug.cgi?id=625289
                    setTimeout(function () {

                        // Add the “opened” class to the picker root.
                        P.$root.addClass(CLASSES.opened)
                        aria(P.$root[0], 'hidden', false)

                    }, 0)

                    // If we have to give focus, bind the element and doc events.
                    if (dontGiveFocus !== false) {

                        // Set it as open.
                        STATE.open = true

                        // Prevent the page from scrolling.
                        if (IS_DEFAULT_THEME) {
                            $html.
                                css('overflow', 'hidden').
                                css('padding-right', '+=' + getScrollbarWidth())
                        }

                        // Pass focus to the root element’s jQuery object.
                        focusPickerOnceOpened()

                        // Bind the document events.
                        $document.on('click.' + STATE.id + ' focusin.' + STATE.id, function (event) {

                            var target = event.target

                            // If the target of the event is not the element, close the picker picker.
                            // * Don’t worry about clicks or focusins on the root because those don’t bubble up.
                            //   Also, for Firefox, a click on an `option` element bubbles up directly
                            //   to the doc. So make sure the target wasn't the doc.
                            // * In Firefox stopPropagation() doesn’t prevent right-click events from bubbling,
                            //   which causes the picker to unexpectedly close when right-clicking it. So make
                            //   sure the event wasn’t a right-click.
                            if (target != ELEMENT && target != document && event.which != 3) {

                                // If the target was the holder that covers the screen,
                                // keep the element focused to maintain tabindex.
                                P.close(target === P.$holder[0])
                            }

                        }).on('keydown.' + STATE.id, function (event) {

                            var
                                // Get the keycode.
                                keycode = event.keyCode,

                                // Translate that to a selection change.
                                keycodeToMove = P.component.key[keycode],

                                // Grab the target.
                                target = event.target


                            // On escape, close the picker and give focus.
                            if (keycode == 27) {
                                P.close(true)
                            }


                                // Check if there is a key movement or “enter” keypress on the element.
                            else if (target == P.$holder[0] && (keycodeToMove || keycode == 13)) {

                                // Prevent the default action to stop page movement.
                                event.preventDefault()

                                // Trigger the key movement action.
                                if (keycodeToMove) {
                                    PickerConstructor._.trigger(P.component.key.go, P, [PickerConstructor._.trigger(keycodeToMove)])
                                }

                                    // On “enter”, if the highlighted item isn’t disabled, set the value and close.
                                else if (!P.$root.find('.' + CLASSES.highlighted).hasClass(CLASSES.disabled)) {
                                    P.set('select', P.component.item.highlight)
                                    if (SETTINGS.closeOnSelect) {
                                        P.close(true)
                                    }
                                }
                            }


                                // If the target is within the root and “enter” is pressed,
                                // prevent the default action and trigger a click on the target instead.
                            else if ($.contains(P.$root[0], target) && keycode == 13) {
                                event.preventDefault()
                                target.click()
                            }
                        })
                    }

                    // Trigger the queued “open” events.
                    return P.trigger('open')
                }, //open


                /**
                 * Close the picker
                 */
                close: function (giveFocus) {

                    // If we need to give focus, do it before changing states.
                    if (giveFocus) {
                        if (SETTINGS.editable) {
                            ELEMENT.focus()
                        }
                        else {
                            // ....ah yes! It would’ve been incomplete without a crazy workaround for IE :|
                            // The focus is triggered *after* the close has completed - causing it
                            // to open again. So unbind and rebind the event at the next tick.
                            P.$holder.off('focus.toOpen').focus()
                            setTimeout(function () {
                                P.$holder.on('focus.toOpen', handleFocusToOpenEvent)
                            }, 0)
                        }
                    }

                    // Remove the “active” class.
                    $ELEMENT.removeClass(CLASSES.active)
                    aria(ELEMENT, 'expanded', false)

                    // * A Firefox bug, when `html` has `overflow:hidden`, results in
                    //   killing transitions :(. So remove the “opened” state on the next tick.
                    //   Bug: https://bugzilla.mozilla.org/show_bug.cgi?id=625289
                    setTimeout(function () {

                        // Remove the “opened” and “focused” class from the picker root.
                        P.$root.removeClass(CLASSES.opened + ' ' + CLASSES.focused)
                        aria(P.$root[0], 'hidden', true)

                    }, 0)

                    // If it’s already closed, do nothing more.
                    if (!STATE.open) return P

                    // Set it as closed.
                    STATE.open = false

                    // Allow the page to scroll.
                    if (IS_DEFAULT_THEME) {
                        $html.
                            css('overflow', '').
                            css('padding-right', '-=' + getScrollbarWidth())
                    }

                    // Unbind the document events.
                    $document.off('.' + STATE.id)

                    // Trigger the queued “close” events.
                    return P.trigger('close')
                }, //close


                /**
                 * Clear the values
                 */
                clear: function (options) {
                    return P.set('clear', null, options)
                }, //clear


                /**
                 * Set something
                 */
                set: function (thing, value, options) {

                    var thingItem, thingValue,
                        thingIsObject = $.isPlainObject(thing),
                        thingObject = thingIsObject ? thing : {}

                    // Make sure we have usable options.
                    options = thingIsObject && $.isPlainObject(value) ? value : options || {}

                    if (thing) {

                        // If the thing isn’t an object, make it one.
                        if (!thingIsObject) {
                            thingObject[thing] = value
                        }

                        // Go through the things of items to set.
                        for (thingItem in thingObject) {

                            // Grab the value of the thing.
                            thingValue = thingObject[thingItem]

                            // First, if the item exists and there’s a value, set it.
                            if (thingItem in P.component.item) {
                                if (thingValue === undefined) thingValue = null
                                P.component.set(thingItem, thingValue, options)
                            }

                            // Then, check to update the element value and broadcast a change.
                            if (thingItem == 'select' || thingItem == 'clear') {
                                $ELEMENT.
                                    val(thingItem == 'clear' ? '' : P.get(thingItem, SETTINGS.format)).
                                    trigger('change')
                            }
                        }

                        // Render a new picker.
                        P.render()
                    }

                    // When the method isn’t muted, trigger queued “set” events and pass the `thingObject`.
                    return options.muted ? P : P.trigger('set', thingObject)
                }, //set


                /**
                 * Get something
                 */
                get: function (thing, format) {

                    // Make sure there’s something to get.
                    thing = thing || 'value'

                    // If a picker state exists, return that.
                    if (STATE[thing] != null) {
                        return STATE[thing]
                    }

                    // Return the submission value, if that.
                    if (thing == 'valueSubmit') {
                        if (P._hidden) {
                            return P._hidden.value
                        }
                        thing = 'value'
                    }

                    // Return the value, if that.
                    if (thing == 'value') {
                        return ELEMENT.value
                    }

                    // Check if a component item exists, return that.
                    if (thing in P.component.item) {
                        if (typeof format == 'string') {
                            var thingValue = P.component.get(thing)
                            return thingValue ?
                                PickerConstructor._.trigger(
                                    P.component.formats.toString,
                                    P.component,
                                    [format, thingValue]
                                ) : ''
                        }
                        return P.component.get(thing)
                    }
                }, //get



                /**
                 * Bind events on the things.
                 */
                on: function (thing, method, internal) {

                    var thingName, thingMethod,
                        thingIsObject = $.isPlainObject(thing),
                        thingObject = thingIsObject ? thing : {}

                    if (thing) {

                        // If the thing isn’t an object, make it one.
                        if (!thingIsObject) {
                            thingObject[thing] = method
                        }

                        // Go through the things to bind to.
                        for (thingName in thingObject) {

                            // Grab the method of the thing.
                            thingMethod = thingObject[thingName]

                            // If it was an internal binding, prefix it.
                            if (internal) {
                                thingName = '_' + thingName
                            }

                            // Make sure the thing methods collection exists.
                            STATE.methods[thingName] = STATE.methods[thingName] || []

                            // Add the method to the relative method collection.
                            STATE.methods[thingName].push(thingMethod)
                        }
                    }

                    return P
                }, //on



                /**
                 * Unbind events on the things.
                 */
                off: function () {
                    var i, thingName,
                        names = arguments;
                    for (i = 0, namesCount = names.length; i < namesCount; i += 1) {
                        thingName = names[i]
                        if (thingName in STATE.methods) {
                            delete STATE.methods[thingName]
                        }
                    }
                    return P
                },


                /**
                 * Fire off method events.
                 */
                trigger: function (name, data) {
                    var _trigger = function (name) {
                        var methodList = STATE.methods[name]
                        if (methodList) {
                            methodList.map(function (method) {
                                PickerConstructor._.trigger(method, P, [data])
                            })
                        }
                    }
                    _trigger('_' + name)
                    _trigger(name)
                    return P
                } //trigger
            } //PickerInstance.prototype


        /**
         * Wrap the picker holder components together.
         */
        function createWrappedComponent() {

            // Create a picker wrapper holder
            return PickerConstructor._.node('div',

                // Create a picker wrapper node
                PickerConstructor._.node('div',

                    // Create a picker frame
                    PickerConstructor._.node('div',

                        // Create a picker box node
                        PickerConstructor._.node('div',

                            // Create the components nodes.
                            P.component.nodes(STATE.open),

                            // The picker box class
                            CLASSES.box
                        ),

                        // Picker wrap class
                        CLASSES.wrap
                    ),

                    // Picker frame class
                    CLASSES.frame
                ),

                // Picker holder class
                CLASSES.holder,

                'tabindex="-1"'
            ) //endreturn
        } //createWrappedComponent



        /**
         * Prepare the input element with all bindings.
         */
        function prepareElement() {

            $ELEMENT.

                // Store the picker data by component name.
                data(NAME, P).

                // Add the “input” class name.
                addClass(CLASSES.input).

                // If there’s a `data-value`, update the value of the element.
                val($ELEMENT.data('value') ?
                    P.get('select', SETTINGS.format) :
                    ELEMENT.value
                )


            // Only bind keydown events if the element isn’t editable.
            if (!SETTINGS.editable) {

                $ELEMENT.

                    // On focus/click, open the picker.
                    on('focus.' + STATE.id + ' click.' + STATE.id, function (event) {
                        event.preventDefault()
                        P.open()
                    }).

                    // Handle keyboard event based on the picker being opened or not.
                    on('keydown.' + STATE.id, handleKeydownEvent)
            }


            // Update the aria attributes.
            aria(ELEMENT, {
                haspopup: true,
                expanded: false,
                readonly: false,
                owns: ELEMENT.id + '_root'
            })
        }


        /**
         * Prepare the root picker element with all bindings.
         */
        function prepareElementRoot() {
            aria(P.$root[0], 'hidden', true)
        }


        /**
         * Prepare the holder picker element with all bindings.
         */
        function prepareElementHolder() {

            P.$holder.

                on({

                    // For iOS8.
                    keydown: handleKeydownEvent,

                    'focus.toOpen': handleFocusToOpenEvent,

                    blur: function () {
                        // Remove the “target” class.
                        $ELEMENT.removeClass(CLASSES.target)
                    },

                    // When something within the holder is focused, stop from bubbling
                    // to the doc and remove the “focused” state from the root.
                    focusin: function (event) {
                        P.$root.removeClass(CLASSES.focused)
                        event.stopPropagation()
                    },

                    // When something within the holder is clicked, stop it
                    // from bubbling to the doc.
                    'mousedown click': function (event) {

                        var target = event.target

                        // Make sure the target isn’t the root holder so it can bubble up.
                        if (target != P.$holder[0]) {

                            event.stopPropagation()

                            // * For mousedown events, cancel the default action in order to
                            //   prevent cases where focus is shifted onto external elements
                            //   when using things like jQuery mobile or MagnificPopup (ref: #249 & #120).
                            //   Also, for Firefox, don’t prevent action on the `option` element.
                            if (event.type == 'mousedown' && !$(target).is('input, select, textarea, button, option')) {

                                event.preventDefault()

                                // Re-focus onto the holder so that users can click away
                                // from elements focused within the picker.
                                P.$holder[0].focus()
                            }
                        }
                    }

                }).

                // If there’s a click on an actionable element, carry out the actions.
                on('click', '[data-pick], [data-nav], [data-clear], [data-close]', function () {

                    var $target = $(this),
                        targetData = $target.data(),
                        targetDisabled = $target.hasClass(CLASSES.navDisabled) || $target.hasClass(CLASSES.disabled),

                        // * For IE, non-focusable elements can be active elements as well
                        //   (http://stackoverflow.com/a/2684561).
                        activeElement = getActiveElement()
                    activeElement = activeElement && (activeElement.type || activeElement.href)

                    // If it’s disabled or nothing inside is actively focused, re-focus the element.
                    if (targetDisabled || activeElement && !$.contains(P.$root[0], activeElement)) {
                        P.$holder[0].focus()
                    }

                    // If something is superficially changed, update the `highlight` based on the `nav`.
                    if (!targetDisabled && targetData.nav) {
                        P.set('highlight', P.component.item.highlight, { nav: targetData.nav })
                    }

                        // If something is picked, set `select` then close with focus.
                    else if (!targetDisabled && 'pick' in targetData) {
                        P.set('select', targetData.pick)
                        if (SETTINGS.closeOnSelect) {
                            P.close(true)
                        }
                    }

                        // If a “clear” button is pressed, empty the values and close with focus.
                    else if (targetData.clear) {
                        P.clear()
                        if (SETTINGS.closeOnClear) {
                            P.close(true)
                        }
                    }

                    else if (targetData.close) {
                        P.close(true)
                    }

                }) //P.$holder

        }


        /**
         * Prepare the hidden input element along with all bindings.
         */
        function prepareElementHidden() {

            var name

            if (SETTINGS.hiddenName === true) {
                name = ELEMENT.name
                ELEMENT.name = ''
            }
            else {
                name = [
                    typeof SETTINGS.hiddenPrefix == 'string' ? SETTINGS.hiddenPrefix : '',
                    typeof SETTINGS.hiddenSuffix == 'string' ? SETTINGS.hiddenSuffix : '_submit'
                ]
                name = name[0] + ELEMENT.name + name[1]
            }

            P._hidden = $(
                '<input ' +
                'type=hidden ' +

                // Create the name using the original input’s with a prefix and suffix.
                'name="' + name + '"' +

                // If the element has a value, set the hidden value as well.
                (
                    $ELEMENT.data('value') || ELEMENT.value ?
                        ' value="' + P.get('select', SETTINGS.formatSubmit) + '"' :
                        ''
                ) +
                '>'
            )[0]

            $ELEMENT.

                // If the value changes, update the hidden input with the correct format.
                on('change.' + STATE.id, function () {
                    P._hidden.value = ELEMENT.value ?
                        P.get('select', SETTINGS.formatSubmit) :
                        ''
                })
        }


        // Wait for transitions to end before focusing the holder. Otherwise, while
        // using the `container` option, the view jumps to the container.
        function focusPickerOnceOpened() {

            if (IS_DEFAULT_THEME && supportsTransitions) {
                P.$holder.find('.' + CLASSES.frame).one('transitionend', function () {
                    P.$holder[0].focus()
                })
            }
            else {
                P.$holder[0].focus()
            }
        }


        function handleFocusToOpenEvent(event) {

            // Stop the event from propagating to the doc.
            event.stopPropagation()

            // Add the “target” class.
            $ELEMENT.addClass(CLASSES.target)

            // Add the “focused” class to the root.
            P.$root.addClass(CLASSES.focused)

            // And then finally open the picker.
            P.open()
        }


        // For iOS8.
        function handleKeydownEvent(event) {

            var keycode = event.keyCode,

                // Check if one of the delete keys was pressed.
                isKeycodeDelete = /^(8|46)$/.test(keycode)

            // For some reason IE clears the input value on “escape”.
            if (keycode == 27) {
                P.close(true)
                return false
            }

            // Check if `space` or `delete` was pressed or the picker is closed with a key movement.
            if (keycode == 32 || isKeycodeDelete || !STATE.open && P.component.key[keycode]) {

                // Prevent it from moving the page and bubbling to doc.
                event.preventDefault()
                event.stopPropagation()

                // If `delete` was pressed, clear the values and close the picker.
                // Otherwise open the picker.
                if (isKeycodeDelete) { P.clear().close() }
                else { P.open() }
            }
        }


        // Return a new picker instance.
        return new PickerInstance()
    } //PickerConstructor



    /**
     * The default classes and prefix to use for the HTML classes.
     */
    PickerConstructor.klasses = function (prefix) {
        prefix = prefix || 'picker'
        return {

            picker: prefix,
            opened: prefix + '--opened',
            focused: prefix + '--focused',

            input: prefix + '__input',
            active: prefix + '__input--active',
            target: prefix + '__input--target',

            holder: prefix + '__holder',

            frame: prefix + '__frame',
            wrap: prefix + '__wrap',

            box: prefix + '__box'
        }
    } //PickerConstructor.klasses



    /**
     * Check if the default theme is being used.
     */
    function isUsingDefaultTheme(element) {

        var theme,
            prop = 'position'

        // For IE.
        if (element.currentStyle) {
            theme = element.currentStyle[prop]
        }

            // For normal browsers.
        else if (window.getComputedStyle) {
            theme = getComputedStyle(element)[prop]
        }

        return theme == 'fixed'
    }



    /**
     * Get the width of the browser’s scrollbar.
     * Taken from: https://github.com/VodkaBears/Remodal/blob/master/src/jquery.remodal.js
     */
    function getScrollbarWidth() {

        if ($html.height() <= $window.height()) {
            return 0
        }

        var $outer = $('<div style="visibility:hidden;width:100px" />').
            appendTo('body')

        // Get the width without scrollbars.
        var widthWithoutScroll = $outer[0].offsetWidth

        // Force adding scrollbars.
        $outer.css('overflow', 'scroll')

        // Add the inner div.
        var $inner = $('<div style="width:100%" />').appendTo($outer)

        // Get the width with scrollbars.
        var widthWithScroll = $inner[0].offsetWidth

        // Remove the divs.
        $outer.remove()

        // Return the difference between the widths.
        return widthWithoutScroll - widthWithScroll
    }



    /**
     * PickerConstructor helper methods.
     */
    PickerConstructor._ = {

        /**
         * Create a group of nodes. Expects:
         * `
            {
                min:    {Integer},
                max:    {Integer},
                i:      {Integer},
                node:   {String},
                item:   {Function}
            }
         * `
         */
        group: function (groupObject) {

            var
                // Scope for the looped object
                loopObjectScope,

                // Create the nodes list
                nodesList = '',

                // The counter starts from the `min`
                counter = PickerConstructor._.trigger(groupObject.min, groupObject)


            // Loop from the `min` to `max`, incrementing by `i`
            for (; counter <= PickerConstructor._.trigger(groupObject.max, groupObject, [counter]) ; counter += groupObject.i) {

                // Trigger the `item` function within scope of the object
                loopObjectScope = PickerConstructor._.trigger(groupObject.item, groupObject, [counter])

                // Splice the subgroup and create nodes out of the sub nodes
                nodesList += PickerConstructor._.node(
                    groupObject.node,
                    loopObjectScope[0],   // the node
                    loopObjectScope[1],   // the classes
                    loopObjectScope[2]    // the attributes
                )
            }

            // Return the list of nodes
            return nodesList
        }, //group


        /**
         * Create a dom node string
         */
        node: function (wrapper, item, klass, attribute) {

            // If the item is false-y, just return an empty string
            if (!item) return ''

            // If the item is an array, do a join
            item = $.isArray(item) ? item.join('') : item

            // Check for the class
            klass = klass ? ' class="' + klass + '"' : ''

            // Check for any attributes
            attribute = attribute ? ' ' + attribute : ''

            // Return the wrapped item
            return '<' + wrapper + klass + attribute + '>' + item + '</' + wrapper + '>'
        }, //node


        /**
         * Lead numbers below 10 with a zero.
         */
        lead: function (number) {
            return (number < 10 ? '0' : '') + number
        },


        /**
         * Trigger a function otherwise return the value.
         */
        trigger: function (callback, scope, args) {
            return typeof callback == 'function' ? callback.apply(scope, args || []) : callback
        },


        /**
         * If the second character is a digit, length is 2 otherwise 1.
         */
        digits: function (string) {
            return (/\d/).test(string[1]) ? 2 : 1
        },


        /**
         * Tell if something is a date object.
         */
        isDate: function (value) {
            return {}.toString.call(value).indexOf('Date') > -1 && this.isInteger(value.getDate())
        },


        /**
         * Tell if something is an integer.
         */
        isInteger: function (value) {
            return {}.toString.call(value).indexOf('Number') > -1 && value % 1 === 0
        },


        /**
         * Create ARIA attribute strings.
         */
        ariaAttr: ariaAttr
    } //PickerConstructor._



    /**
     * Extend the picker with a component and defaults.
     */
    PickerConstructor.extend = function (name, Component) {

        // Extend jQuery.
        $.fn[name] = function (options, action) {

            // Grab the component data.
            var componentData = this.data(name)

            // If the picker is requested, return the data object.
            if (options == 'picker') {
                return componentData
            }

            // If the component data exists and `options` is a string, carry out the action.
            if (componentData && typeof options == 'string') {
                return PickerConstructor._.trigger(componentData[options], componentData, [action])
            }

            // Otherwise go through each matched element and if the component
            // doesn’t exist, create a new picker using `this` element
            // and merging the defaults and options with a deep copy.
            return this.each(function () {
                var $this = $(this)
                if (!$this.data(name)) {
                    new PickerConstructor(this, name, Component, options)
                }
            })
        }

        // Set the defaults.
        $.fn[name].defaults = Component.defaults
    } //PickerConstructor.extend



    function aria(element, attribute, value) {
        if ($.isPlainObject(attribute)) {
            for (var key in attribute) {
                ariaSet(element, key, attribute[key])
            }
        }
        else {
            ariaSet(element, attribute, value)
        }
    }
    function ariaSet(element, attribute, value) {
        element.setAttribute(
            (attribute == 'role' ? '' : 'aria-') + attribute,
            value
        )
    }
    function ariaAttr(attribute, data) {
        if (!$.isPlainObject(attribute)) {
            attribute = { attribute: data }
        }
        data = ''
        for (var key in attribute) {
            var attr = (key == 'role' ? '' : 'aria-') + key,
                attrVal = attribute[key]
            data += attrVal == null ? '' : attr + '="' + attribute[key] + '"'
        }
        return data
    }

    // IE8 bug throws an error for activeElements within iframes.
    function getActiveElement() {
        try {
            return document.activeElement
        } catch (err) { }
    }



    // Expose the picker constructor.
    return PickerConstructor


}));
/*!
 * Date picker for pickadate.js v3.5.0
 * http://amsul.github.io/pickadate.js/date.htm
 */

(function (factory) {

    // AMD.
    if (typeof define == 'function' && define.amd)
        define(['picker', 'jquery'], factory)

        // Node.js/browserify.
    else if (typeof exports == 'object')
        module.exports = factory(require('./picker.js'), require('jquery'))

        // Browser globals.
    else factory(Picker, jQuery)

}(function (Picker, $) {


    /**
     * Globals and constants
     */
    var DAYS_IN_WEEK = 7,
        WEEKS_IN_CALENDAR = 6,
        _ = Picker._



    /**
     * The date picker constructor
     */
    function DatePicker(picker, settings) {

        var calendar = this,
            element = picker.$node[0],
            elementValue = element.value,
            elementDataValue = picker.$node.data('value'),
            valueString = elementDataValue || elementValue,
            formatString = elementDataValue ? settings.formatSubmit : settings.format,
            isRTL = function () {

                return element.currentStyle ?

                    // For IE.
                    element.currentStyle.direction == 'rtl' :

                    // For normal browsers.
                    getComputedStyle(picker.$root[0]).direction == 'rtl'
            }

        calendar.settings = settings
        calendar.$node = picker.$node

        // The queue of methods that will be used to build item objects.
        calendar.queue = {
            min: 'measure create',
            max: 'measure create',
            now: 'now create',
            select: 'parse create validate',
            highlight: 'parse navigate create validate',
            view: 'parse create validate viewset',
            disable: 'deactivate',
            enable: 'activate'
        }

        // The component's item object.
        calendar.item = {}

        calendar.item.clear = null
        calendar.item.disable = (settings.disable || []).slice(0)
        calendar.item.enable = -(function (collectionDisabled) {
            return collectionDisabled[0] === true ? collectionDisabled.shift() : -1
        })(calendar.item.disable)

        calendar.
            set('min', settings.min).
            set('max', settings.max).
            set('now')

        // When there’s a value, set the `select`, which in turn
        // also sets the `highlight` and `view`.
        if (valueString) {
            calendar.set('select', valueString, { format: formatString })
        }

            // If there’s no value, default to highlighting “today”.
        else {
            calendar.
                set('select', null).
                set('highlight', calendar.item.now)
        }


        // The keycode to movement mapping.
        calendar.key = {
            40: 7, // Down
            38: -7, // Up
            39: function () { return isRTL() ? -1 : 1 }, // Right
            37: function () { return isRTL() ? 1 : -1 }, // Left
            go: function (timeChange) {
                var highlightedObject = calendar.item.highlight,
                    targetDate = new Date(highlightedObject.year, highlightedObject.month, highlightedObject.date + timeChange)
                calendar.set(
                    'highlight',
                    targetDate,
                    { interval: timeChange }
                )
                this.render()
            }
        }


        // Bind some picker events.
        picker.
            on('render', function () {
                picker.$root.find('.' + settings.klass.selectMonth).on('change', function () {
                    var value = this.value
                    if (value) {
                        picker.set('highlight', [picker.get('view').year, value, picker.get('highlight').date])
                        picker.$root.find('.' + settings.klass.selectMonth).trigger('focus')
                    }
                })
                picker.$root.find('.' + settings.klass.selectYear).on('change', function () {
                    var value = this.value
                    if (value) {
                        picker.set('highlight', [value, picker.get('view').month, picker.get('highlight').date])
                        picker.$root.find('.' + settings.klass.selectYear).trigger('focus')
                    }
                })
            }, 1).
            on('open', function () {
                var includeToday = ''
                if (calendar.disabled(calendar.get('now'))) {
                    includeToday = ':not(.' + settings.klass.buttonToday + ')'
                }
                picker.$root.find('button' + includeToday + ', select').attr('disabled', false)
            }, 1).
            on('close', function () {
                picker.$root.find('button, select').attr('disabled', true)
            }, 1)

    } //DatePicker


    /**
     * Set a datepicker item object.
     */
    DatePicker.prototype.set = function (type, value, options) {

        var calendar = this,
            calendarItem = calendar.item

        // If the value is `null` just set it immediately.
        if (value === null) {
            if (type == 'clear') type = 'select'
            calendarItem[type] = value
            return calendar
        }

        // Otherwise go through the queue of methods, and invoke the functions.
        // Update this as the time unit, and set the final value as this item.
        // * In the case of `enable`, keep the queue but set `disable` instead.
        //   And in the case of `flip`, keep the queue but set `enable` instead.
        calendarItem[(type == 'enable' ? 'disable' : type == 'flip' ? 'enable' : type)] = calendar.queue[type].split(' ').map(function (method) {
            value = calendar[method](type, value, options)
            return value
        }).pop()

        // Check if we need to cascade through more updates.
        if (type == 'select') {
            calendar.set('highlight', calendarItem.select, options)
        }
        else if (type == 'highlight') {
            calendar.set('view', calendarItem.highlight, options)
        }
        else if (type.match(/^(flip|min|max|disable|enable)$/)) {
            if (calendarItem.select && calendar.disabled(calendarItem.select)) {
                calendar.set('select', calendarItem.select, options)
            }
            if (calendarItem.highlight && calendar.disabled(calendarItem.highlight)) {
                calendar.set('highlight', calendarItem.highlight, options)
            }
        }

        return calendar
    } //DatePicker.prototype.set


    /**
     * Get a datepicker item object.
     */
    DatePicker.prototype.get = function (type) {
        return this.item[type]
    } //DatePicker.prototype.get


    /**
     * Create a picker date object.
     */
    DatePicker.prototype.create = function (type, value, options) {

        var isInfiniteValue,
            calendar = this

        // If there’s no value, use the type as the value.
        value = value === undefined ? type : value


        // If it’s infinity, update the value.
        if (value == -Infinity || value == Infinity) {
            isInfiniteValue = value
        }

            // If it’s an object, use the native date object.
        else if ($.isPlainObject(value) && _.isInteger(value.pick)) {
            value = value.obj
        }

            // If it’s an array, convert it into a date and make sure
            // that it’s a valid date – otherwise default to today.
        else if ($.isArray(value)) {
            value = new Date(value[0], value[1], value[2])
            value = _.isDate(value) ? value : calendar.create().obj
        }

            // If it’s a number or date object, make a normalized date.
        else if (_.isInteger(value) || _.isDate(value)) {
            value = calendar.normalize(new Date(value), options)
        }

            // If it’s a literal true or any other case, set it to now.
        else /*if ( value === true )*/ {
            value = calendar.now(type, value, options)
        }

        // Return the compiled object.
        return {
            year: isInfiniteValue || value.getFullYear(),
            month: isInfiniteValue || value.getMonth(),
            date: isInfiniteValue || value.getDate(),
            day: isInfiniteValue || value.getDay(),
            obj: isInfiniteValue || value,
            pick: isInfiniteValue || value.getTime()
        }
    } //DatePicker.prototype.create


    /**
     * Create a range limit object using an array, date object,
     * literal “true”, or integer relative to another time.
     */
    DatePicker.prototype.createRange = function (from, to) {

        var calendar = this,
            createDate = function (date) {
                if (date === true || $.isArray(date) || _.isDate(date)) {
                    return calendar.create(date)
                }
                return date
            }

        // Create objects if possible.
        if (!_.isInteger(from)) {
            from = createDate(from)
        }
        if (!_.isInteger(to)) {
            to = createDate(to)
        }

        // Create relative dates.
        if (_.isInteger(from) && $.isPlainObject(to)) {
            from = [to.year, to.month, to.date + from];
        }
        else if (_.isInteger(to) && $.isPlainObject(from)) {
            to = [from.year, from.month, from.date + to];
        }

        return {
            from: createDate(from),
            to: createDate(to)
        }
    } //DatePicker.prototype.createRange


    /**
     * Check if a date unit falls within a date range object.
     */
    DatePicker.prototype.withinRange = function (range, dateUnit) {
        range = this.createRange(range.from, range.to)
        return dateUnit.pick >= range.from.pick && dateUnit.pick <= range.to.pick
    }


    /**
     * Check if two date range objects overlap.
     */
    DatePicker.prototype.overlapRanges = function (one, two) {

        var calendar = this

        // Convert the ranges into comparable dates.
        one = calendar.createRange(one.from, one.to)
        two = calendar.createRange(two.from, two.to)

        return calendar.withinRange(one, two.from) || calendar.withinRange(one, two.to) ||
            calendar.withinRange(two, one.from) || calendar.withinRange(two, one.to)
    }


    /**
     * Get the date today.
     */
    DatePicker.prototype.now = function (type, value, options) {
        value = new Date()
        if (options && options.rel) {
            value.setDate(value.getDate() + options.rel)
        }
        return this.normalize(value, options)
    }


    /**
     * Navigate to next/prev month.
     */
    DatePicker.prototype.navigate = function (type, value, options) {

        var targetDateObject,
            targetYear,
            targetMonth,
            targetDate,
            isTargetArray = $.isArray(value),
            isTargetObject = $.isPlainObject(value),
            viewsetObject = this.item.view/*,
        safety = 100*/


        if (isTargetArray || isTargetObject) {

            if (isTargetObject) {
                targetYear = value.year
                targetMonth = value.month
                targetDate = value.date
            }
            else {
                targetYear = +value[0]
                targetMonth = +value[1]
                targetDate = +value[2]
            }

            // If we’re navigating months but the view is in a different
            // month, navigate to the view’s year and month.
            if (options && options.nav && viewsetObject && viewsetObject.month !== targetMonth) {
                targetYear = viewsetObject.year
                targetMonth = viewsetObject.month
            }

            // Figure out the expected target year and month.
            targetDateObject = new Date(targetYear, targetMonth + (options && options.nav ? options.nav : 0), 1)
            targetYear = targetDateObject.getFullYear()
            targetMonth = targetDateObject.getMonth()

            // If the month we’re going to doesn’t have enough days,
            // keep decreasing the date until we reach the month’s last date.
            while ( /*safety &&*/ new Date(targetYear, targetMonth, targetDate).getMonth() !== targetMonth) {
                targetDate -= 1
                /*safety -= 1
                if ( !safety ) {
                    throw 'Fell into an infinite loop while navigating to ' + new Date( targetYear, targetMonth, targetDate ) + '.'
                }*/
            }

            value = [targetYear, targetMonth, targetDate]
        }

        return value
    } //DatePicker.prototype.navigate


    /**
     * Normalize a date by setting the hours to midnight.
     */
    DatePicker.prototype.normalize = function (value/*, options*/) {
        value.setHours(0, 0, 0, 0)
        return value
    }


    /**
     * Measure the range of dates.
     */
    DatePicker.prototype.measure = function (type, value/*, options*/) {

        var calendar = this

        // If it’s anything false-y, remove the limits.
        if (!value) {
            value = type == 'min' ? -Infinity : Infinity
        }

            // If it’s a string, parse it.
        else if (typeof value == 'string') {
            value = calendar.parse(type, value)
        }

            // If it's an integer, get a date relative to today.
        else if (_.isInteger(value)) {
            value = calendar.now(type, value, { rel: value })
        }

        return value
    } ///DatePicker.prototype.measure


    /**
     * Create a viewset object based on navigation.
     */
    DatePicker.prototype.viewset = function (type, dateObject/*, options*/) {
        return this.create([dateObject.year, dateObject.month, 1])
    }


    /**
     * Validate a date as enabled and shift if needed.
     */
    DatePicker.prototype.validate = function (type, dateObject, options) {

        var calendar = this,

            // Keep a reference to the original date.
            originalDateObject = dateObject,

            // Make sure we have an interval.
            interval = options && options.interval ? options.interval : 1,

            // Check if the calendar enabled dates are inverted.
            isFlippedBase = calendar.item.enable === -1,

            // Check if we have any enabled dates after/before now.
            hasEnabledBeforeTarget, hasEnabledAfterTarget,

            // The min & max limits.
            minLimitObject = calendar.item.min,
            maxLimitObject = calendar.item.max,

            // Check if we’ve reached the limit during shifting.
            reachedMin, reachedMax,

            // Check if the calendar is inverted and at least one weekday is enabled.
            hasEnabledWeekdays = isFlippedBase && calendar.item.disable.filter(function (value) {

                // If there’s a date, check where it is relative to the target.
                if ($.isArray(value)) {
                    var dateTime = calendar.create(value).pick
                    if (dateTime < dateObject.pick) hasEnabledBeforeTarget = true
                    else if (dateTime > dateObject.pick) hasEnabledAfterTarget = true
                }

                // Return only integers for enabled weekdays.
                return _.isInteger(value)
            }).length/*,

        safety = 100*/



        // Cases to validate for:
        // [1] Not inverted and date disabled.
        // [2] Inverted and some dates enabled.
        // [3] Not inverted and out of range.
        //
        // Cases to **not** validate for:
        // • Navigating months.
        // • Not inverted and date enabled.
        // • Inverted and all dates disabled.
        // • ..and anything else.
        if (!options || !options.nav) if (
            /* 1 */ (!isFlippedBase && calendar.disabled(dateObject)) ||
            /* 2 */ (isFlippedBase && calendar.disabled(dateObject) && (hasEnabledWeekdays || hasEnabledBeforeTarget || hasEnabledAfterTarget)) ||
            /* 3 */ (!isFlippedBase && (dateObject.pick <= minLimitObject.pick || dateObject.pick >= maxLimitObject.pick))
        ) {


            // When inverted, flip the direction if there aren’t any enabled weekdays
            // and there are no enabled dates in the direction of the interval.
            if (isFlippedBase && !hasEnabledWeekdays && ((!hasEnabledAfterTarget && interval > 0) || (!hasEnabledBeforeTarget && interval < 0))) {
                interval *= -1
            }


            // Keep looping until we reach an enabled date.
            while ( /*safety &&*/ calendar.disabled(dateObject)) {

                /*safety -= 1
                if ( !safety ) {
                    throw 'Fell into an infinite loop while validating ' + dateObject.obj + '.'
                }*/


                // If we’ve looped into the next/prev month with a large interval, return to the original date and flatten the interval.
                if (Math.abs(interval) > 1 && (dateObject.month < originalDateObject.month || dateObject.month > originalDateObject.month)) {
                    dateObject = originalDateObject
                    interval = interval > 0 ? 1 : -1
                }


                // If we’ve reached the min/max limit, reverse the direction, flatten the interval and set it to the limit.
                if (dateObject.pick <= minLimitObject.pick) {
                    reachedMin = true
                    interval = 1
                    dateObject = calendar.create([
                        minLimitObject.year,
                        minLimitObject.month,
                        minLimitObject.date + (dateObject.pick === minLimitObject.pick ? 0 : -1)
                    ])
                }
                else if (dateObject.pick >= maxLimitObject.pick) {
                    reachedMax = true
                    interval = -1
                    dateObject = calendar.create([
                        maxLimitObject.year,
                        maxLimitObject.month,
                        maxLimitObject.date + (dateObject.pick === maxLimitObject.pick ? 0 : 1)
                    ])
                }


                // If we’ve reached both limits, just break out of the loop.
                if (reachedMin && reachedMax) {
                    break
                }


                // Finally, create the shifted date using the interval and keep looping.
                dateObject = calendar.create([dateObject.year, dateObject.month, dateObject.date + interval])
            }

        } //endif


        // Return the date object settled on.
        return dateObject
    } //DatePicker.prototype.validate


    /**
     * Check if a date is disabled.
     */
    DatePicker.prototype.disabled = function (dateToVerify) {

        var
            calendar = this,

            // Filter through the disabled dates to check if this is one.
            isDisabledMatch = calendar.item.disable.filter(function (dateToDisable) {

                // If the date is a number, match the weekday with 0index and `firstDay` check.
                if (_.isInteger(dateToDisable)) {
                    return dateToVerify.day === (calendar.settings.firstDay ? dateToDisable : dateToDisable - 1) % 7
                }

                // If it’s an array or a native JS date, create and match the exact date.
                if ($.isArray(dateToDisable) || _.isDate(dateToDisable)) {
                    return dateToVerify.pick === calendar.create(dateToDisable).pick
                }

                // If it’s an object, match a date within the “from” and “to” range.
                if ($.isPlainObject(dateToDisable)) {
                    return calendar.withinRange(dateToDisable, dateToVerify)
                }
            })

        // If this date matches a disabled date, confirm it’s not inverted.
        isDisabledMatch = isDisabledMatch.length && !isDisabledMatch.filter(function (dateToDisable) {
            return $.isArray(dateToDisable) && dateToDisable[3] == 'inverted' ||
                $.isPlainObject(dateToDisable) && dateToDisable.inverted
        }).length

        // Check the calendar “enabled” flag and respectively flip the
        // disabled state. Then also check if it’s beyond the min/max limits.
        return calendar.item.enable === -1 ? !isDisabledMatch : isDisabledMatch ||
            dateToVerify.pick < calendar.item.min.pick ||
            dateToVerify.pick > calendar.item.max.pick

    } //DatePicker.prototype.disabled


    /**
     * Parse a string into a usable type.
     */
    DatePicker.prototype.parse = function (type, value, options) {

        var calendar = this,
            parsingObject = {}

        // If it’s already parsed, we’re good.
        if (!value || typeof value != 'string') {
            return value
        }

        // We need a `.format` to parse the value with.
        if (!(options && options.format)) {
            options = options || {}
            options.format = calendar.settings.format
        }

        // Convert the format into an array and then map through it.
        calendar.formats.toArray(options.format).map(function (label) {

            var
                // Grab the formatting label.
                formattingLabel = calendar.formats[label],

                // The format length is from the formatting label function or the
                // label length without the escaping exclamation (!) mark.
                formatLength = formattingLabel ? _.trigger(formattingLabel, calendar, [value, parsingObject]) : label.replace(/^!/, '').length

            // If there's a format label, split the value up to the format length.
            // Then add it to the parsing object with appropriate label.
            if (formattingLabel) {
                parsingObject[label] = value.substr(0, formatLength)
            }

            // Update the value as the substring from format length to end.
            value = value.substr(formatLength)
        })

        // Compensate for month 0index.
        return [
            parsingObject.yyyy || parsingObject.yy,
            +(parsingObject.mm || parsingObject.m) - 1,
            parsingObject.dd || parsingObject.d
        ]
    } //DatePicker.prototype.parse


    /**
     * Various formats to display the object in.
     */
    DatePicker.prototype.formats = (function () {

        // Return the length of the first word in a collection.
        function getWordLengthFromCollection(string, collection, dateObject) {

            // Grab the first word from the string.
            var word = string.match(/\w+/)[0]

            // If there's no month index, add it to the date object
            if (!dateObject.mm && !dateObject.m) {
                dateObject.m = collection.indexOf(word) + 1
            }

            // Return the length of the word.
            return word.length
        }

        // Get the length of the first word in a string.
        function getFirstWordLength(string) {
            return string.match(/\w+/)[0].length
        }

        return {

            d: function (string, dateObject) {

                // If there's string, then get the digits length.
                // Otherwise return the selected date.
                return string ? _.digits(string) : dateObject.date
            },
            dd: function (string, dateObject) {

                // If there's a string, then the length is always 2.
                // Otherwise return the selected date with a leading zero.
                return string ? 2 : _.lead(dateObject.date)
            },
            ddd: function (string, dateObject) {

                // If there's a string, then get the length of the first word.
                // Otherwise return the short selected weekday.
                return string ? getFirstWordLength(string) : this.settings.weekdaysShort[dateObject.day]
            },
            dddd: function (string, dateObject) {

                // If there's a string, then get the length of the first word.
                // Otherwise return the full selected weekday.
                return string ? getFirstWordLength(string) : this.settings.weekdaysFull[dateObject.day]
            },
            m: function (string, dateObject) {

                // If there's a string, then get the length of the digits
                // Otherwise return the selected month with 0index compensation.
                return string ? _.digits(string) : dateObject.month + 1
            },
            mm: function (string, dateObject) {

                // If there's a string, then the length is always 2.
                // Otherwise return the selected month with 0index and leading zero.
                return string ? 2 : _.lead(dateObject.month + 1)
            },
            mmm: function (string, dateObject) {

                var collection = this.settings.monthsShort

                // If there's a string, get length of the relevant month from the short
                // months collection. Otherwise return the selected month from that collection.
                return string ? getWordLengthFromCollection(string, collection, dateObject) : collection[dateObject.month]
            },
            mmmm: function (string, dateObject) {

                var collection = this.settings.monthsFull

                // If there's a string, get length of the relevant month from the full
                // months collection. Otherwise return the selected month from that collection.
                return string ? getWordLengthFromCollection(string, collection, dateObject) : collection[dateObject.month]
            },
            yy: function (string, dateObject) {

                // If there's a string, then the length is always 2.
                // Otherwise return the selected year by slicing out the first 2 digits.
                return string ? 2 : ('' + dateObject.year).slice(2)
            },
            yyyy: function (string, dateObject) {

                // If there's a string, then the length is always 4.
                // Otherwise return the selected year.
                return string ? 4 : dateObject.year
            },

            // Create an array by splitting the formatting string passed.
            toArray: function (formatString) { return formatString.split(/(d{1,4}|m{1,4}|y{4}|yy|!.)/g) },

            // Format an object into a string using the formatting options.
            toString: function (formatString, itemObject) {
                var calendar = this
                return calendar.formats.toArray(formatString).map(function (label) {
                    return _.trigger(calendar.formats[label], calendar, [0, itemObject]) || label.replace(/^!/, '')
                }).join('')
            }
        }
    })() //DatePicker.prototype.formats




    /**
     * Check if two date units are the exact.
     */
    DatePicker.prototype.isDateExact = function (one, two) {

        var calendar = this

        // When we’re working with weekdays, do a direct comparison.
        if (
            (_.isInteger(one) && _.isInteger(two)) ||
            (typeof one == 'boolean' && typeof two == 'boolean')
         ) {
            return one === two
        }

        // When we’re working with date representations, compare the “pick” value.
        if (
            (_.isDate(one) || $.isArray(one)) &&
            (_.isDate(two) || $.isArray(two))
        ) {
            return calendar.create(one).pick === calendar.create(two).pick
        }

        // When we’re working with range objects, compare the “from” and “to”.
        if ($.isPlainObject(one) && $.isPlainObject(two)) {
            return calendar.isDateExact(one.from, two.from) && calendar.isDateExact(one.to, two.to)
        }

        return false
    }


    /**
     * Check if two date units overlap.
     */
    DatePicker.prototype.isDateOverlap = function (one, two) {

        var calendar = this,
            firstDay = calendar.settings.firstDay ? 1 : 0

        // When we’re working with a weekday index, compare the days.
        if (_.isInteger(one) && (_.isDate(two) || $.isArray(two))) {
            one = one % 7 + firstDay
            return one === calendar.create(two).day + 1
        }
        if (_.isInteger(two) && (_.isDate(one) || $.isArray(one))) {
            two = two % 7 + firstDay
            return two === calendar.create(one).day + 1
        }

        // When we’re working with range objects, check if the ranges overlap.
        if ($.isPlainObject(one) && $.isPlainObject(two)) {
            return calendar.overlapRanges(one, two)
        }

        return false
    }


    /**
     * Flip the “enabled” state.
     */
    DatePicker.prototype.flipEnable = function (val) {
        var itemObject = this.item
        itemObject.enable = val || (itemObject.enable == -1 ? 1 : -1)
    }


    /**
     * Mark a collection of dates as “disabled”.
     */
    DatePicker.prototype.deactivate = function (type, datesToDisable) {

        var calendar = this,
            disabledItems = calendar.item.disable.slice(0)


        // If we’re flipping, that’s all we need to do.
        if (datesToDisable == 'flip') {
            calendar.flipEnable()
        }

        else if (datesToDisable === false) {
            calendar.flipEnable(1)
            disabledItems = []
        }

        else if (datesToDisable === true) {
            calendar.flipEnable(-1)
            disabledItems = []
        }

            // Otherwise go through the dates to disable.
        else {

            datesToDisable.map(function (unitToDisable) {

                var matchFound

                // When we have disabled items, check for matches.
                // If something is matched, immediately break out.
                for (var index = 0; index < disabledItems.length; index += 1) {
                    if (calendar.isDateExact(unitToDisable, disabledItems[index])) {
                        matchFound = true
                        break
                    }
                }

                // If nothing was found, add the validated unit to the collection.
                if (!matchFound) {
                    if (
                        _.isInteger(unitToDisable) ||
                        _.isDate(unitToDisable) ||
                        $.isArray(unitToDisable) ||
                        ($.isPlainObject(unitToDisable) && unitToDisable.from && unitToDisable.to)
                    ) {
                        disabledItems.push(unitToDisable)
                    }
                }
            })
        }

        // Return the updated collection.
        return disabledItems
    } //DatePicker.prototype.deactivate


    /**
     * Mark a collection of dates as “enabled”.
     */
    DatePicker.prototype.activate = function (type, datesToEnable) {

        var calendar = this,
            disabledItems = calendar.item.disable,
            disabledItemsCount = disabledItems.length

        // If we’re flipping, that’s all we need to do.
        if (datesToEnable == 'flip') {
            calendar.flipEnable()
        }

        else if (datesToEnable === true) {
            calendar.flipEnable(1)
            disabledItems = []
        }

        else if (datesToEnable === false) {
            calendar.flipEnable(-1)
            disabledItems = []
        }

            // Otherwise go through the disabled dates.
        else {

            datesToEnable.map(function (unitToEnable) {

                var matchFound,
                    disabledUnit,
                    index,
                    isExactRange

                // Go through the disabled items and try to find a match.
                for (index = 0; index < disabledItemsCount; index += 1) {

                    disabledUnit = disabledItems[index]

                    // When an exact match is found, remove it from the collection.
                    if (calendar.isDateExact(disabledUnit, unitToEnable)) {
                        matchFound = disabledItems[index] = null
                        isExactRange = true
                        break
                    }

                        // When an overlapped match is found, add the “inverted” state to it.
                    else if (calendar.isDateOverlap(disabledUnit, unitToEnable)) {
                        if ($.isPlainObject(unitToEnable)) {
                            unitToEnable.inverted = true
                            matchFound = unitToEnable
                        }
                        else if ($.isArray(unitToEnable)) {
                            matchFound = unitToEnable
                            if (!matchFound[3]) matchFound.push('inverted')
                        }
                        else if (_.isDate(unitToEnable)) {
                            matchFound = [unitToEnable.getFullYear(), unitToEnable.getMonth(), unitToEnable.getDate(), 'inverted']
                        }
                        break
                    }
                }

                // If a match was found, remove a previous duplicate entry.
                if (matchFound) for (index = 0; index < disabledItemsCount; index += 1) {
                    if (calendar.isDateExact(disabledItems[index], unitToEnable)) {
                        disabledItems[index] = null
                        break
                    }
                }

                // In the event that we’re dealing with an exact range of dates,
                // make sure there are no “inverted” dates because of it.
                if (isExactRange) for (index = 0; index < disabledItemsCount; index += 1) {
                    if (calendar.isDateOverlap(disabledItems[index], unitToEnable)) {
                        disabledItems[index] = null
                        break
                    }
                }

                // If something is still matched, add it into the collection.
                if (matchFound) {
                    disabledItems.push(matchFound)
                }
            })
        }

        // Return the updated collection.
        return disabledItems.filter(function (val) { return val != null })
    } //DatePicker.prototype.activate


    /**
     * Create a string for the nodes in the picker.
     */
    DatePicker.prototype.nodes = function (isOpen) {

        var
            calendar = this,
            settings = calendar.settings,
            calendarItem = calendar.item,
            nowObject = calendarItem.now,
            selectedObject = calendarItem.select,
            highlightedObject = calendarItem.highlight,
            viewsetObject = calendarItem.view,
            disabledCollection = calendarItem.disable,
            minLimitObject = calendarItem.min,
            maxLimitObject = calendarItem.max,


            // Create the calendar table head using a copy of weekday labels collection.
            // * We do a copy so we don't mutate the original array.
            tableHead = (function (collection, fullCollection) {

                // If the first day should be Monday, move Sunday to the end.
                if (settings.firstDay) {
                    collection.push(collection.shift())
                    fullCollection.push(fullCollection.shift())
                }

                // Create and return the table head group.
                return _.node(
                    'thead',
                    _.node(
                        'tr',
                        _.group({
                            min: 0,
                            max: DAYS_IN_WEEK - 1,
                            i: 1,
                            node: 'th',
                            item: function (counter) {
                                return [
                                    collection[counter],
                                    settings.klass.weekdays,
                                    'scope=col title="' + fullCollection[counter] + '"'
                                ]
                            }
                        })
                    )
                ) //endreturn

                // Materialize modified
            })((settings.showWeekdaysFull ? settings.weekdaysFull : settings.weekdaysLetter).slice(0), settings.weekdaysFull.slice(0)), //tableHead


            // Create the nav for next/prev month.
            createMonthNav = function (next) {

                // Otherwise, return the created month tag.
                return _.node(
                    'div',
                    ' ',
                    settings.klass['nav' + (next ? 'Next' : 'Prev')] + (

                        // If the focused month is outside the range, disabled the button.
                        (next && viewsetObject.year >= maxLimitObject.year && viewsetObject.month >= maxLimitObject.month) ||
                        (!next && viewsetObject.year <= minLimitObject.year && viewsetObject.month <= minLimitObject.month) ?
                        ' ' + settings.klass.navDisabled : ''
                    ),
                    'data-nav=' + (next || -1) + ' ' +
                    _.ariaAttr({
                        role: 'button',
                        controls: calendar.$node[0].id + '_table'
                    }) + ' ' +
                    'title="' + (next ? settings.labelMonthNext : settings.labelMonthPrev) + '"'
                ) //endreturn
            }, //createMonthNav


            // Create the month label.
            //Materialize modified
            createMonthLabel = function (override) {

                var monthsCollection = settings.showMonthsShort ? settings.monthsShort : settings.monthsFull

                // Materialize modified
                if (override == "short_months") {
                    monthsCollection = settings.monthsShort;
                }

                // If there are months to select, add a dropdown menu.
                if (settings.selectMonths) {

                    return _.node('select',
                        _.group({
                            min: 0,
                            max: 11,
                            i: 1,
                            node: 'option',
                            item: function (loopedMonth) {

                                return [

                                    // The looped month and no classes.
                                    monthsCollection[loopedMonth], 0,

                                    // Set the value and selected index.
                                    'value=' + loopedMonth +
                                    (viewsetObject.month == loopedMonth ? ' selected' : '') +
                                    (
                                        (
                                            (viewsetObject.year == minLimitObject.year && loopedMonth < minLimitObject.month) ||
                                            (viewsetObject.year == maxLimitObject.year && loopedMonth > maxLimitObject.month)
                                        ) ?
                                        ' disabled' : ''
                                    )
                                ]
                            }
                        }),
                        settings.klass.selectMonth,
                        (isOpen ? '' : 'disabled') + ' ' +
                        _.ariaAttr({ controls: calendar.$node[0].id + '_table' }) + ' ' +
                        'title="' + settings.labelMonthSelect + '"'
                    )
                }

                // Materialize modified
                if (override == "short_months")
                    return _.node('div', monthsCollection[viewsetObject.month])

                // If there's a need for a month selector
                return _.node('div', monthsCollection[viewsetObject.month], settings.klass.month)
            }, //createMonthLabel


            // Create the year label.
            // Materialize modified
            createYearLabel = function (override) {

                var focusedYear = viewsetObject.year,

                // If years selector is set to a literal "true", set it to 5. Otherwise
                // divide in half to get half before and half after focused year.
                numberYears = settings.selectYears === true ? 5 : ~~(settings.selectYears / 2)

                // If there are years to select, add a dropdown menu.
                if (numberYears) {

                    var
                        minYear = minLimitObject.year,
                        maxYear = maxLimitObject.year,
                        lowestYear = focusedYear - numberYears,
                        highestYear = focusedYear + numberYears

                    // If the min year is greater than the lowest year, increase the highest year
                    // by the difference and set the lowest year to the min year.
                    if (minYear > lowestYear) {
                        highestYear += minYear - lowestYear
                        lowestYear = minYear
                    }

                    // If the max year is less than the highest year, decrease the lowest year
                    // by the lower of the two: available and needed years. Then set the
                    // highest year to the max year.
                    if (maxYear < highestYear) {

                        var availableYears = lowestYear - minYear,
                            neededYears = highestYear - maxYear

                        lowestYear -= availableYears > neededYears ? neededYears : availableYears
                        highestYear = maxYear
                    }


                    return _.node('select',
                        _.group({
                            min: lowestYear,
                            max: highestYear,
                            i: 1,
                            node: 'option',
                            item: function (loopedYear) {
                                return [

                                    // The looped year and no classes.
                                    loopedYear, 0,

                                    // Set the value and selected index.
                                    'value=' + loopedYear + (focusedYear == loopedYear ? ' selected' : '')
                                ]
                            }
                        }),
                        settings.klass.selectYear,
                        (isOpen ? '' : 'disabled') + ' ' + _.ariaAttr({ controls: calendar.$node[0].id + '_table' }) + ' ' +
                        'title="' + settings.labelYearSelect + '"'
                    )
                }

                // Materialize modified
                if (override == "raw")
                    return _.node('div', focusedYear)

                // Otherwise just return the year focused
                return _.node('div', focusedYear, settings.klass.year)
            } //createYearLabel


        // Materialize modified
        createDayLabel = function () {
            if (selectedObject != null)
                return _.node('div', selectedObject.date)
            else return _.node('div', nowObject.date)
        }
        createWeekdayLabel = function () {
            var display_day;

            if (selectedObject != null)
                display_day = selectedObject.day;
            else
                display_day = nowObject.day;
            var weekday = settings.weekdaysFull[display_day]
            return weekday
        }


        // Create and return the entire calendar.
        return _.node(
                // Date presentation View
                'div',
                    _.node(
                        'div',
                        createWeekdayLabel(),
                        "picker__weekday-display"
                    ) +
                    _.node(
                        // Div for short Month
                        'div',
                        createMonthLabel("short_months"),
                        settings.klass.month_display
                    ) +
                    _.node(
                        // Div for Day
                        'div',
                        createDayLabel(),
                        settings.klass.day_display
                    ) +
                    _.node(
                        // Div for Year
                        'div',
                        createYearLabel("raw"),
                        settings.klass.year_display
                    ),
                settings.klass.date_display
            ) +
            // Calendar container
            _.node('div',
                _.node('div',
                (settings.selectYears ? createYearLabel() + createMonthLabel() : createMonthLabel() + createYearLabel()) +
                createMonthNav() + createMonthNav(1),
                settings.klass.header
            ) + _.node(
                'table',
                tableHead +
                _.node(
                    'tbody',
                    _.group({
                        min: 0,
                        max: WEEKS_IN_CALENDAR - 1,
                        i: 1,
                        node: 'tr',
                        item: function (rowCounter) {

                            // If Monday is the first day and the month starts on Sunday, shift the date back a week.
                            var shiftDateBy = settings.firstDay && calendar.create([viewsetObject.year, viewsetObject.month, 1]).day === 0 ? -7 : 0

                            return [
                                _.group({
                                    min: DAYS_IN_WEEK * rowCounter - viewsetObject.day + shiftDateBy + 1, // Add 1 for weekday 0index
                                    max: function () {
                                        return this.min + DAYS_IN_WEEK - 1
                                    },
                                    i: 1,
                                    node: 'td',
                                    item: function (targetDate) {

                                        // Convert the time date from a relative date to a target date.
                                        targetDate = calendar.create([viewsetObject.year, viewsetObject.month, targetDate + (settings.firstDay ? 1 : 0)])

                                        var isSelected = selectedObject && selectedObject.pick == targetDate.pick,
                                            isHighlighted = highlightedObject && highlightedObject.pick == targetDate.pick,
                                            isDisabled = disabledCollection && calendar.disabled(targetDate) || targetDate.pick < minLimitObject.pick || targetDate.pick > maxLimitObject.pick,
                                            formattedDate = _.trigger(calendar.formats.toString, calendar, [settings.format, targetDate])

                                        return [
                                            _.node(
                                                'div',
                                                targetDate.date,
                                                (function (klasses) {

                                                    // Add the `infocus` or `outfocus` classes based on month in view.
                                                    klasses.push(viewsetObject.month == targetDate.month ? settings.klass.infocus : settings.klass.outfocus)

                                                    // Add the `today` class if needed.
                                                    if (nowObject.pick == targetDate.pick) {
                                                        klasses.push(settings.klass.now)
                                                    }

                                                    // Add the `selected` class if something's selected and the time matches.
                                                    if (isSelected) {
                                                        klasses.push(settings.klass.selected)
                                                    }

                                                    // Add the `highlighted` class if something's highlighted and the time matches.
                                                    if (isHighlighted) {
                                                        klasses.push(settings.klass.highlighted)
                                                    }

                                                    // Add the `disabled` class if something's disabled and the object matches.
                                                    if (isDisabled) {
                                                        klasses.push(settings.klass.disabled)
                                                    }

                                                    return klasses.join(' ')
                                                })([settings.klass.day]),
                                                'data-pick=' + targetDate.pick + ' ' + _.ariaAttr({
                                                    role: 'gridcell',
                                                    label: formattedDate,
                                                    selected: isSelected && calendar.$node.val() === formattedDate ? true : null,
                                                    activedescendant: isHighlighted ? true : null,
                                                    disabled: isDisabled ? true : null
                                                })
                                            ),
                                            '',
                                            _.ariaAttr({ role: 'presentation' })
                                        ] //endreturn
                                    }
                                })
                            ] //endreturn
                        }
                    })
                ),
                settings.klass.table,
                'id="' + calendar.$node[0].id + '_table' + '" ' + _.ariaAttr({
                    role: 'grid',
                    controls: calendar.$node[0].id,
                    readonly: true
                })
            )
            , settings.klass.calendar_container) // end calendar

             +

            // * For Firefox forms to submit, make sure to set the buttons’ `type` attributes as “button”.
            _.node(
                'div',
                _.node('button', settings.today, "btn--default picker__today",
                    'type=button data-pick=' + nowObject.pick +
                    (isOpen && !calendar.disabled(nowObject) ? '' : ' disabled') + ' ' +
                    _.ariaAttr({ controls: calendar.$node[0].id })) +
                _.node('button', settings.clear, "btn--default picker__clear",
                    'type=button data-clear=1' +
                    (isOpen ? '' : ' disabled') + ' ' +
                    _.ariaAttr({ controls: calendar.$node[0].id })) +
                _.node('button', settings.close, "btn--default picker__close",
                    'type=button data-close=true ' +
                    (isOpen ? '' : ' disabled') + ' ' +
                    _.ariaAttr({ controls: calendar.$node[0].id })),
                settings.klass.footer
            ) //endreturn
    } //DatePicker.prototype.nodes




    /**
     * The date picker defaults.
     */
    DatePicker.defaults = (function (prefix) {

        return {

            // The title label to use for the month nav buttons
            labelMonthNext: 'Next month',
            labelMonthPrev: 'Previous month',

            // The title label to use for the dropdown selectors
            labelMonthSelect: 'Select a month',
            labelYearSelect: 'Select a year',

            // Months and weekdays
            monthsFull: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
            monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
            weekdaysFull: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
            weekdaysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],

            // Materialize modified
            weekdaysLetter: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],

            // Today and clear
            today: 'Today',
            clear: 'Clear',
            close: 'Close',

            // The format to show on the `input` element
            format: 'd mmmm, yyyy',

            // Classes
            klass: {

                table: prefix + 'table',

                header: prefix + 'header',


                // Materialize Added klasses
                date_display: prefix + 'date-display',
                day_display: prefix + 'day-display',
                month_display: prefix + 'month-display',
                year_display: prefix + 'year-display',
                calendar_container: prefix + 'calendar-container',
                // end



                navPrev: prefix + 'nav--prev',
                navNext: prefix + 'nav--next',
                navDisabled: prefix + 'nav--disabled',

                month: prefix + 'month',
                year: prefix + 'year',

                selectMonth: prefix + 'select--month',
                selectYear: prefix + 'select--year',

                weekdays: prefix + 'weekday',

                day: prefix + 'day',
                disabled: prefix + 'day--disabled',
                selected: prefix + 'day--selected',
                highlighted: prefix + 'day--highlighted',
                now: prefix + 'day--today',
                infocus: prefix + 'day--infocus',
                outfocus: prefix + 'day--outfocus',

                footer: prefix + 'footer',

                buttonClear: prefix + 'button--clear',
                buttonToday: prefix + 'button--today',
                buttonClose: prefix + 'button--close'
            }
        }
    })(Picker.klasses().picker + '__')





    /**
     * Extend the picker to add the date picker.
     */
    Picker.extend('pickadate', DatePicker)


}));



/*
 * cond - v0.1 - 6/10/2009
 * http://benalman.com/projects/jquery-cond-plugin/
 * 
 * Copyright (c) 2009 "Cowboy" Ben Alman
 * Licensed under the MIT license
 * http://benalman.com/about/license/
 * 
 * Based on suggestions and sample code by Stephen Band and DBJDBJ in the
 * jquery-dev Google group: http://bit.ly/jqba1
 */
(function($){$.fn.cond=function(){var e,a=arguments,b=0,f,d,c;while(!f&&b<a.length){f=a[b++];d=a[b++];f=$.isFunction(f)?f.call(this):f;c=!d?f:f?d.call(this,f):e}return c!==e?c:this}})(jQuery);
/*!
 * # Semantic UI 1.12.1 - Checkbox
 * http://github.com/semantic-org/semantic-ui/
 *
 *
 * Copyright 2014 Contributors
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 *
 */

; (function ($, window, document, undefined) {

    "use strict";

    $.fn.checkbox = function (parameters) {
        var
          $allModules = $(this),
          moduleSelector = $allModules.selector || '',

          time = new Date().getTime(),
          performance = [],

          query = arguments[0],
          methodInvoked = (typeof query == 'string'),
          queryArguments = [].slice.call(arguments, 1),
          returnedValue
        ;

        $allModules
          .each(function () {
              var
                settings = $.extend(true, {}, $.fn.checkbox.settings, parameters),

                className = settings.className,
                namespace = settings.namespace,
                selector = settings.selector,
                error = settings.error,

                eventNamespace = '.' + namespace,
                moduleNamespace = 'module-' + namespace,

                $module = $(this),
                $label = $(this).find(selector.label).first(),
                $input = $(this).find(selector.input),

                instance = $module.data(moduleNamespace),

                observer,
                element = this,
                module
              ;

              module = {

                  initialize: function () {
                      module.verbose('Initializing checkbox', settings);

                      module.create.label();
                      module.add.events();

                      if (module.is.checked()) {
                          module.set.checked();
                          if (settings.fireOnInit) {
                              settings.onChecked.call($input.get());
                          }
                      }
                      else {
                          module.remove.checked();
                          if (settings.fireOnInit) {
                              settings.onUnchecked.call($input.get());
                          }
                      }
                      module.observeChanges();

                      module.instantiate();
                  },

                  instantiate: function () {
                      module.verbose('Storing instance of module', module);
                      instance = module;
                      $module
                        .data(moduleNamespace, module)
                      ;
                  },

                  destroy: function () {
                      module.verbose('Destroying module');
                      module.remove.events();
                      $module
                        .removeData(moduleNamespace)
                      ;
                  },

                  refresh: function () {
                      $module = $(this);
                      $label = $(this).find(selector.label).first();
                      $input = $(this).find(selector.input);
                  },

                  observeChanges: function () {
                      if ('MutationObserver' in window) {
                          observer = new MutationObserver(function (mutations) {
                              module.debug('DOM tree modified, updating selector cache');
                              module.refresh();
                          });
                          observer.observe(element, {
                              childList: true,
                              subtree: true
                          });
                          module.debug('Setting up mutation observer', observer);
                      }
                  },

                  attachEvents: function (selector, event) {
                      var
                        $element = $(selector)
                      ;
                      event = $.isFunction(module[event])
                        ? module[event]
                        : module.toggle
                      ;
                      if ($element.length > 0) {
                          module.debug('Attaching checkbox events to element', selector, event);
                          $element
                            .on('click' + eventNamespace, event)
                          ;
                      }
                      else {
                          module.error(error.notFound);
                      }
                  },

                  event: {
                      keydown: function (event) {
                          var
                            key = event.which,
                            keyCode = {
                                enter: 13,
                                space: 32,
                                escape: 27
                            }
                          ;
                          if (key == keyCode.escape) {
                              module.verbose('Escape key pressed blurring field');
                              $module
                                .blur()
                              ;
                          }
                          if (!event.ctrlKey && (key == keyCode.enter || key == keyCode.space)) {
                              module.verbose('Enter key pressed, toggling checkbox');
                              module.toggle.call(this);
                              event.preventDefault();
                          }
                      }
                  },

                  is: {
                      radio: function () {
                          return $module.hasClass(className.radio);
                      },
                      checked: function () {
                          return $input.prop('checked') !== undefined && $input.prop('checked');
                      },
                      unchecked: function () {
                          return !module.is.checked();
                      }
                  },

                  can: {
                      change: function () {
                          return !($module.hasClass(className.disabled) || $module.hasClass(className.readOnly) || $input.prop('disabled'));
                      },
                      uncheck: function () {
                          return (typeof settings.uncheckable === 'boolean')
                            ? settings.uncheckable
                            : !module.is.radio()
                          ;
                      }
                  },

                  set: {
                      checked: function () {
                          $module.addClass(className.checked);
                      },
                      tab: function () {
                          if ($input.attr('tabindex') === undefined) {
                              $input
                                .attr('tabindex', 0)
                              ;
                          }
                      }
                  },

                  create: {
                      label: function () {
                          if ($input.prevAll(selector.label).length > 0) {
                              $input.prev(selector.label).detach().insertAfter($input);
                              module.debug('Moving existing label', $label);
                          }
                          else if (!module.has.label()) {
                              $label = $('<label>').insertAfter($input);
                              module.debug('Creating label', $label);
                          }
                      }
                  },

                  has: {
                      label: function () {
                          return ($label.length > 0);
                      }
                  },

                  add: {
                      events: function () {
                          module.verbose('Attaching checkbox events');
                          $module
                            .on('click' + eventNamespace, module.toggle)
                            .on('keydown' + eventNamespace, selector.input, module.event.keydown)
                          ;
                      }
                  },

                  remove: {
                      checked: function () {
                          $module.removeClass(className.checked);
                      },
                      events: function () {
                          module.debug('Removing events');
                          $module
                            .off(eventNamespace)
                            .removeData(moduleNamespace)
                          ;
                          $input
                            .off(eventNamespace, module.event.keydown)
                          ;
                          $label
                            .off(eventNamespace)
                          ;
                      }
                  },

                  enable: function () {
                      module.debug('Enabling checkbox functionality');
                      $module.removeClass(className.disabled);
                      $input.prop('disabled', false);
                      settings.onEnabled.call($input.get());
                  },

                  disable: function () {
                      module.debug('Disabling checkbox functionality');
                      $module.addClass(className.disabled);
                      $input.prop('disabled', 'disabled');
                      settings.onDisabled.call($input.get());
                  },

                  check: function () {
                      module.debug('Enabling checkbox', $input);
                      $input
                        .prop('checked', true)
                        .trigger('change')
                      ;
                      module.set.checked();
                      $input.trigger('blur');
                      settings.onChange.call($input.get());
                      settings.onChecked.call($input.get());
                  },

                  uncheck: function () {
                      module.debug('Disabling checkbox');
                      $input
                        .prop('checked', false)
                        .trigger('change')
                      ;
                      module.remove.checked();
                      $input.trigger('blur');
                      settings.onChange.call($input.get());
                      settings.onUnchecked.call($input.get());
                  },

                  toggle: function (event) {
                      if (!module.can.change()) {
                          console.log(module.can.change());
                          module.debug('Checkbox is read-only or disabled, ignoring toggle');
                          return;
                      }
                      module.verbose('Determining new checkbox state');
                      if (module.is.unchecked()) {
                          module.check();
                      }
                      else if (module.is.checked() && module.can.uncheck()) {
                          module.uncheck();
                      }
                  },
                  setting: function (name, value) {
                      module.debug('Changing setting', name, value);
                      if ($.isPlainObject(name)) {
                          $.extend(true, settings, name);
                      }
                      else if (value !== undefined) {
                          settings[name] = value;
                      }
                      else {
                          return settings[name];
                      }
                  },
                  internal: function (name, value) {
                      if ($.isPlainObject(name)) {
                          $.extend(true, module, name);
                      }
                      else if (value !== undefined) {
                          module[name] = value;
                      }
                      else {
                          return module[name];
                      }
                  },
                  debug: function () {
                      if (settings.debug) {
                          if (settings.performance) {
                              module.performance.log(arguments);
                          }
                          else {
                              module.debug = Function.prototype.bind.call(console.info, console, settings.name + ':');
                              module.debug.apply(console, arguments);
                          }
                      }
                  },
                  verbose: function () {
                      if (settings.verbose && settings.debug) {
                          if (settings.performance) {
                              module.performance.log(arguments);
                          }
                          else {
                              module.verbose = Function.prototype.bind.call(console.info, console, settings.name + ':');
                              module.verbose.apply(console, arguments);
                          }
                      }
                  },
                  error: function () {
                      module.error = Function.prototype.bind.call(console.error, console, settings.name + ':');
                      module.error.apply(console, arguments);
                  },
                  performance: {
                      log: function (message) {
                          var
                            currentTime,
                            executionTime,
                            previousTime
                          ;
                          if (settings.performance) {
                              currentTime = new Date().getTime();
                              previousTime = time || currentTime;
                              executionTime = currentTime - previousTime;
                              time = currentTime;
                              performance.push({
                                  'Name': message[0],
                                  'Arguments': [].slice.call(message, 1) || '',
                                  'Element': element,
                                  'Execution Time': executionTime
                              });
                          }
                          clearTimeout(module.performance.timer);
                          module.performance.timer = setTimeout(module.performance.display, 100);
                      },
                      display: function () {
                          var
                            title = settings.name + ':',
                            totalTime = 0
                          ;
                          time = false;
                          clearTimeout(module.performance.timer);
                          $.each(performance, function (index, data) {
                              totalTime += data['Execution Time'];
                          });
                          title += ' ' + totalTime + 'ms';
                          if (moduleSelector) {
                              title += ' \'' + moduleSelector + '\'';
                          }
                          if ((console.group !== undefined || console.table !== undefined) && performance.length > 0) {
                              console.groupCollapsed(title);
                              if (console.table) {
                                  console.table(performance);
                              }
                              else {
                                  $.each(performance, function (index, data) {
                                      console.log(data['Name'] + ': ' + data['Execution Time'] + 'ms');
                                  });
                              }
                              console.groupEnd();
                          }
                          performance = [];
                      }
                  },
                  invoke: function (query, passedArguments, context) {
                      var
                        object = instance,
                        maxDepth,
                        found,
                        response
                      ;
                      passedArguments = passedArguments || queryArguments;
                      context = element || context;
                      if (typeof query == 'string' && object !== undefined) {
                          query = query.split(/[\. ]/);
                          maxDepth = query.length - 1;
                          $.each(query, function (depth, value) {
                              var camelCaseValue = (depth != maxDepth)
                                ? value + query[depth + 1].charAt(0).toUpperCase() + query[depth + 1].slice(1)
                                : query
                              ;
                              if ($.isPlainObject(object[camelCaseValue]) && (depth != maxDepth)) {
                                  object = object[camelCaseValue];
                              }
                              else if (object[camelCaseValue] !== undefined) {
                                  found = object[camelCaseValue];
                                  return false;
                              }
                              else if ($.isPlainObject(object[value]) && (depth != maxDepth)) {
                                  object = object[value];
                              }
                              else if (object[value] !== undefined) {
                                  found = object[value];
                                  return false;
                              }
                              else {
                                  module.error(error.method, query);
                                  return false;
                              }
                          });
                      }
                      if ($.isFunction(found)) {
                          response = found.apply(context, passedArguments);
                      }
                      else if (found !== undefined) {
                          response = found;
                      }
                      if ($.isArray(returnedValue)) {
                          returnedValue.push(response);
                      }
                      else if (returnedValue !== undefined) {
                          returnedValue = [returnedValue, response];
                      }
                      else if (response !== undefined) {
                          returnedValue = response;
                      }
                      return found;
                  }
              };

              if (methodInvoked) {
                  if (instance === undefined) {
                      module.initialize();
                  }
                  module.invoke(query);
              }
              else {
                  if (instance !== undefined) {
                      instance.invoke('destroy');
                  }
                  module.initialize();
              }
          })
        ;

        return (returnedValue !== undefined)
          ? returnedValue
          : this
        ;
    };

    $.fn.checkbox.settings = {

        name: 'Checkbox',
        namespace: 'checkbox',

        debug: false,
        verbose: true,
        performance: true,

        // delegated event context
        uncheckable: 'auto',
        fireOnInit: true,

        onChange: function () { },
        onChecked: function () { },
        onUnchecked: function () { },
        onEnabled: function () { },
        onDisabled: function () { },

        className: {
            checked: 'checked',
            disabled: 'disabled',
            radio: 'radio',
            readOnly: 'read-only'
        },

        error: {
            method: 'The method you called is not defined'
        },

        selector: {
            input: 'input[type="checkbox"], input[type="radio"]',
            label: 'label'
        }

    };

})(jQuery, window, document);

/*!
Chosen, a Select Box Enhancer for jQuery and Prototype
by Patrick Filler for Harvest, http://getharvest.com

Version 1.4.2
Full source at https://github.com/harvesthq/chosen
Copyright (c) 2011-2015 Harvest http://getharvest.com

MIT License, https://github.com/harvesthq/chosen/blob/master/LICENSE.md
This file is generated by `grunt build`, do not edit it by hand.
*/

(function () {
    var $, AbstractChosen, Chosen, SelectParser, _ref,
      __hasProp = {}.hasOwnProperty,
      __extends = function (child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

    SelectParser = (function () {
        function SelectParser() {
            this.options_index = 0;
            this.parsed = [];
        }

        SelectParser.prototype.add_node = function (child) {
            if (child.nodeName.toUpperCase() === "OPTGROUP") {
                return this.add_group(child);
            } else {
                return this.add_option(child);
            }
        };

        SelectParser.prototype.add_group = function (group) {
            var group_position, option, _i, _len, _ref, _results;
            group_position = this.parsed.length;
            this.parsed.push({
                array_index: group_position,
                group: true,
                label: this.escapeExpression(group.label),
                title: group.title ? group.title : void 0,
                children: 0,
                disabled: group.disabled,
                classes: group.className
            });
            _ref = group.childNodes;
            _results = [];
            for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                option = _ref[_i];
                _results.push(this.add_option(option, group_position, group.disabled));
            }
            return _results;
        };

        SelectParser.prototype.add_option = function (option, group_position, group_disabled) {
            if (option.nodeName.toUpperCase() === "OPTION") {
                if (option.text !== "") {
                    if (group_position != null) {
                        this.parsed[group_position].children += 1;
                    }
                    this.parsed.push({
                        array_index: this.parsed.length,
                        options_index: this.options_index,
                        value: option.value,
                        text: option.text,
                        html: option.innerHTML,
                        title: option.title ? option.title : void 0,
                        selected: option.selected,
                        disabled: group_disabled === true ? group_disabled : option.disabled,
                        group_array_index: group_position,
                        group_label: group_position != null ? this.parsed[group_position].label : null,
                        classes: option.className,
                        style: option.style.cssText
                    });
                } else {
                    this.parsed.push({
                        array_index: this.parsed.length,
                        options_index: this.options_index,
                        empty: true
                    });
                }
                return this.options_index += 1;
            }
        };

        SelectParser.prototype.escapeExpression = function (text) {
            var map, unsafe_chars;
            if ((text == null) || text === false) {
                return "";
            }
            if (!/[\&\<\>\"\'\`]/.test(text)) {
                return text;
            }
            map = {
                "<": "&lt;",
                ">": "&gt;",
                '"': "&quot;",
                "'": "&#x27;",
                "`": "&#x60;"
            };
            unsafe_chars = /&(?!\w+;)|[\<\>\"\'\`]/g;
            return text.replace(unsafe_chars, function (chr) {
                return map[chr] || "&amp;";
            });
        };

        return SelectParser;

    })();

    SelectParser.select_to_array = function (select) {
        var child, parser, _i, _len, _ref;
        parser = new SelectParser();
        _ref = select.childNodes;
        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
            child = _ref[_i];
            parser.add_node(child);
        }
        return parser.parsed;
    };

    AbstractChosen = (function () {
        function AbstractChosen(form_field, options) {
            this.form_field = form_field;
            this.options = options != null ? options : {};
            if (!AbstractChosen.browser_is_supported()) {
                return;
            }
            this.is_multiple = this.form_field.multiple;
            this.set_default_text();
            this.set_default_values();
            this.setup();
            this.set_up_html();
            this.register_observers();
            this.on_ready();
        }

        AbstractChosen.prototype.set_default_values = function () {
            var _this = this;
            this.click_test_action = function (evt) {
                return _this.test_active_click(evt);
            };
            this.activate_action = function (evt) {
                return _this.activate_field(evt);
            };
            this.active_field = false;
            this.mouse_on_container = false;
            this.results_showing = false;
            this.result_highlighted = null;
            this.allow_single_deselect = (this.options.allow_single_deselect != null) && (this.form_field.options[0] != null) && this.form_field.options[0].text === "" ? this.options.allow_single_deselect : false;
            this.disable_search_threshold = this.options.disable_search_threshold || 0;
            this.disable_search = this.options.disable_search || false;
            this.enable_split_word_search = this.options.enable_split_word_search != null ? this.options.enable_split_word_search : true;
            this.group_search = this.options.group_search != null ? this.options.group_search : true;
            this.search_contains = this.options.search_contains || false;
            this.single_backstroke_delete = this.options.single_backstroke_delete != null ? this.options.single_backstroke_delete : true;
            this.max_selected_options = this.options.max_selected_options || Infinity;
            this.inherit_select_classes = this.options.inherit_select_classes || false;
            this.display_selected_options = this.options.display_selected_options != null ? this.options.display_selected_options : true;
            this.display_disabled_options = this.options.display_disabled_options != null ? this.options.display_disabled_options : true;
            return this.include_group_label_in_selected = this.options.include_group_label_in_selected || false;
        };

        AbstractChosen.prototype.set_default_text = function () {
            if (this.form_field.getAttribute("data-placeholder")) {
                this.default_text = this.form_field.getAttribute("data-placeholder");
            } else if (this.is_multiple) {
                this.default_text = this.options.placeholder_text_multiple || this.options.placeholder_text || AbstractChosen.default_multiple_text;
            } else {
                this.default_text = this.options.placeholder_text_single || this.options.placeholder_text || AbstractChosen.default_single_text;
            }
            return this.results_none_found = this.form_field.getAttribute("data-no_results_text") || this.options.no_results_text || AbstractChosen.default_no_result_text;
        };

        AbstractChosen.prototype.choice_label = function (item) {
            if (this.include_group_label_in_selected && (item.group_label != null)) {
                return "<b class='group-name'>" + item.group_label + "</b>" + item.html;
            } else {
                return item.html;
            }
        };

        AbstractChosen.prototype.mouse_enter = function () {
            return this.mouse_on_container = true;
        };

        AbstractChosen.prototype.mouse_leave = function () {
            return this.mouse_on_container = false;
        };

        AbstractChosen.prototype.input_focus = function (evt) {
            var _this = this;
            if (this.is_multiple) {
                if (!this.active_field) {
                    return setTimeout((function () {
                        return _this.container_mousedown();
                    }), 50);
                }
            } else {
                if (!this.active_field) {
                    return this.activate_field();
                }
            }
        };

        AbstractChosen.prototype.input_blur = function (evt) {
            var _this = this;
            if (!this.mouse_on_container) {
                this.active_field = false;
                return setTimeout((function () {
                    return _this.blur_test();
                }), 100);
            }
        };

        AbstractChosen.prototype.results_option_build = function (options) {
            var content, data, _i, _len, _ref;
            content = '';
            _ref = this.results_data;
            for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                data = _ref[_i];
                if (data.group) {
                    content += this.result_add_group(data);
                } else {
                    content += this.result_add_option(data);
                }
                if (options != null ? options.first : void 0) {
                    if (data.selected && this.is_multiple) {
                        this.choice_build(data);
                    } else if (data.selected && !this.is_multiple) {
                        this.single_set_selected_text(this.choice_label(data));
                    }
                }
            }
            return content;
        };

        AbstractChosen.prototype.result_add_option = function (option) {
            var classes, option_el;
            if (!option.search_match) {
                return '';
            }
            if (!this.include_option_in_results(option)) {
                return '';
            }
            classes = [];
            if (!option.disabled && !(option.selected && this.is_multiple)) {
                classes.push("active-result");
            }
            if (option.disabled && !(option.selected && this.is_multiple)) {
                classes.push("disabled-result");
            }
            if (option.selected) {
                classes.push("result-selected");
            }
            if (option.group_array_index != null) {
                classes.push("group-option");
            }
            if (option.classes !== "") {
                classes.push(option.classes);
            }
            option_el = document.createElement("li");
            option_el.className = classes.join(" ");
            option_el.style.cssText = option.style;
            option_el.setAttribute("data-option-array-index", option.array_index);
            option_el.innerHTML = option.search_text;
            if (option.title) {
                option_el.title = option.title;
            }
            return this.outerHTML(option_el);
        };

        AbstractChosen.prototype.result_add_group = function (group) {
            var classes, group_el;
            if (!(group.search_match || group.group_match)) {
                return '';
            }
            if (!(group.active_options > 0)) {
                return '';
            }
            classes = [];
            classes.push("group-result");
            if (group.classes) {
                classes.push(group.classes);
            }
            group_el = document.createElement("li");
            group_el.className = classes.join(" ");
            group_el.innerHTML = group.search_text;
            if (group.title) {
                group_el.title = group.title;
            }
            return this.outerHTML(group_el);
        };

        AbstractChosen.prototype.results_update_field = function () {
            this.set_default_text();
            if (!this.is_multiple) {
                this.results_reset_cleanup();
            }
            this.result_clear_highlight();
            this.results_build();
            if (this.results_showing) {
                return this.winnow_results();
            }
        };

        AbstractChosen.prototype.reset_single_select_options = function () {
            var result, _i, _len, _ref, _results;
            _ref = this.results_data;
            _results = [];
            for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                result = _ref[_i];
                if (result.selected) {
                    _results.push(result.selected = false);
                } else {
                    _results.push(void 0);
                }
            }
            return _results;
        };

        AbstractChosen.prototype.results_toggle = function () {
            if (this.results_showing) {
                return this.results_hide();
            } else {
                return this.results_show();
            }
        };

        AbstractChosen.prototype.results_search = function (evt) {
            if (this.results_showing) {
                return this.winnow_results();
            } else {
                return this.results_show();
            }
        };

        AbstractChosen.prototype.winnow_results = function () {
            var escapedSearchText, option, regex, results, results_group, searchText, startpos, text, zregex, _i, _len, _ref;
            this.no_results_clear();
            results = 0;
            searchText = this.get_search_text();
            escapedSearchText = searchText.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
            zregex = new RegExp(escapedSearchText, 'i');
            regex = this.get_search_regex(escapedSearchText);
            _ref = this.results_data;
            for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                option = _ref[_i];
                option.search_match = false;
                results_group = null;
                if (this.include_option_in_results(option)) {
                    if (option.group) {
                        option.group_match = false;
                        option.active_options = 0;
                    }
                    if ((option.group_array_index != null) && this.results_data[option.group_array_index]) {
                        results_group = this.results_data[option.group_array_index];
                        if (results_group.active_options === 0 && results_group.search_match) {
                            results += 1;
                        }
                        results_group.active_options += 1;
                    }
                    option.search_text = option.group ? option.label : option.html;
                    if (!(option.group && !this.group_search)) {
                        option.search_match = this.search_string_match(option.search_text, regex);
                        if (option.search_match && !option.group) {
                            results += 1;
                        }
                        if (option.search_match) {
                            if (searchText.length) {
                                startpos = option.search_text.search(zregex);
                                text = option.search_text.substr(0, startpos + searchText.length) + '</em>' + option.search_text.substr(startpos + searchText.length);
                                option.search_text = text.substr(0, startpos) + '<em>' + text.substr(startpos);
                            }
                            if (results_group != null) {
                                results_group.group_match = true;
                            }
                        } else if ((option.group_array_index != null) && this.results_data[option.group_array_index].search_match) {
                            option.search_match = true;
                        }
                    }
                }
            }
            this.result_clear_highlight();
            if (results < 1 && searchText.length) {
                this.update_results_content("");
                return this.no_results(searchText);
            } else {
                this.update_results_content(this.results_option_build());
                return this.winnow_results_set_highlight();
            }
        };

        AbstractChosen.prototype.get_search_regex = function (escaped_search_string) {
            var regex_anchor;
            regex_anchor = this.search_contains ? "" : "^";
            return new RegExp(regex_anchor + escaped_search_string, 'i');
        };

        AbstractChosen.prototype.search_string_match = function (search_string, regex) {
            var part, parts, _i, _len;
            if (regex.test(search_string)) {
                return true;
            } else if (this.enable_split_word_search && (search_string.indexOf(" ") >= 0 || search_string.indexOf("[") === 0)) {
                parts = search_string.replace(/\[|\]/g, "").split(" ");
                if (parts.length) {
                    for (_i = 0, _len = parts.length; _i < _len; _i++) {
                        part = parts[_i];
                        if (regex.test(part)) {
                            return true;
                        }
                    }
                }
            }
        };

        AbstractChosen.prototype.choices_count = function () {
            var option, _i, _len, _ref;
            if (this.selected_option_count != null) {
                return this.selected_option_count;
            }
            this.selected_option_count = 0;
            _ref = this.form_field.options;
            for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                option = _ref[_i];
                if (option.selected) {
                    this.selected_option_count += 1;
                }
            }
            return this.selected_option_count;
        };

        AbstractChosen.prototype.choices_click = function (evt) {
            evt.preventDefault();
            if (!(this.results_showing || this.is_disabled)) {
                return this.results_show();
            }
        };

        AbstractChosen.prototype.keyup_checker = function (evt) {
            var stroke, _ref;
            stroke = (_ref = evt.which) != null ? _ref : evt.keyCode;
            this.search_field_scale();
            switch (stroke) {
                case 8:
                    if (this.is_multiple && this.backstroke_length < 1 && this.choices_count() > 0) {
                        return this.keydown_backstroke();
                    } else if (!this.pending_backstroke) {
                        this.result_clear_highlight();
                        return this.results_search();
                    }
                    break;
                case 13:
                    evt.preventDefault();
                    if (this.results_showing) {
                        return this.result_select(evt);
                    }
                    break;
                case 27:
                    if (this.results_showing) {
                        this.results_hide();
                    }
                    return true;
                case 9:
                case 38:
                case 40:
                case 16:
                case 91:
                case 17:
                    break;
                default:
                    return this.results_search();
            }
        };

        AbstractChosen.prototype.clipboard_event_checker = function (evt) {
            var _this = this;
            return setTimeout((function () {
                return _this.results_search();
            }), 50);
        };

        AbstractChosen.prototype.container_width = function () {
            if (this.options.width != null) {
                return this.options.width;
            } else {
                return "" + this.form_field.offsetWidth + "px";
            }
        };

        AbstractChosen.prototype.include_option_in_results = function (option) {
            if (this.is_multiple && (!this.display_selected_options && option.selected)) {
                return false;
            }
            if (!this.display_disabled_options && option.disabled) {
                return false;
            }
            if (option.empty) {
                return false;
            }
            return true;
        };

        AbstractChosen.prototype.search_results_touchstart = function (evt) {
            this.touch_started = true;
            return this.search_results_mouseover(evt);
        };

        AbstractChosen.prototype.search_results_touchmove = function (evt) {
            this.touch_started = false;
            return this.search_results_mouseout(evt);
        };

        AbstractChosen.prototype.search_results_touchend = function (evt) {
            if (this.touch_started) {
                return this.search_results_mouseup(evt);
            }
        };

        AbstractChosen.prototype.outerHTML = function (element) {
            var tmp;
            if (element.outerHTML) {
                return element.outerHTML;
            }
            tmp = document.createElement("div");
            tmp.appendChild(element);
            return tmp.innerHTML;
        };

        AbstractChosen.browser_is_supported = function () {
            if (window.navigator.appName === "Microsoft Internet Explorer") {
                return document.documentMode >= 8;
            }
            if (/iP(od|hone)/i.test(window.navigator.userAgent)) {
                return false;
            }
            if (/Android/i.test(window.navigator.userAgent)) {
                if (/Mobile/i.test(window.navigator.userAgent)) {
                    return false;
                }
            }
            return true;
        };

        AbstractChosen.default_multiple_text = "Select Some Options";

        AbstractChosen.default_single_text = "Select an Option";

        AbstractChosen.default_no_result_text = "No results match";

        return AbstractChosen;

    })();

    $ = jQuery;

    $.fn.extend({
        chosen: function (options) {
            if (!AbstractChosen.browser_is_supported()) {
                return this;
            }
            return this.each(function (input_field) {
                var $this, chosen;
                $this = $(this);
                chosen = $this.data('chosen');
                if (options === 'destroy' && chosen instanceof Chosen) {
                    chosen.destroy();
                } else if (!(chosen instanceof Chosen)) {
                    $this.data('chosen', new Chosen(this, options));
                }
            });
        }
    });

    Chosen = (function (_super) {
        __extends(Chosen, _super);

        function Chosen() {
            _ref = Chosen.__super__.constructor.apply(this, arguments);
            return _ref;
        }

        Chosen.prototype.setup = function () {
            this.form_field_jq = $(this.form_field);
            this.current_selectedIndex = this.form_field.selectedIndex;
            return this.is_rtl = this.form_field_jq.hasClass("chosen-rtl");
        };

        Chosen.prototype.set_up_html = function () {
            var container_classes, container_props;
            container_classes = ["chosen-container"];
            container_classes.push("chosen-container-" + (this.is_multiple ? "multi" : "single"));
            if (this.inherit_select_classes && this.form_field.className) {
                container_classes.push(this.form_field.className);
            }
            if (this.is_rtl) {
                container_classes.push("chosen-rtl");
            }
            container_props = {
                'class': container_classes.join(' '),
                'style': "width: " + (this.container_width()) + ";",
                'title': this.form_field.title
            };
            if (this.form_field.id.length) {
                container_props.id = this.form_field.id.replace(/[^\w]/g, '_') + "_chosen";
            }
            this.container = $("<div />", container_props);
            if (this.is_multiple) {
                this.container.html('<ul class="chosen-choices"><li class="search-field"><input type="text" value="' + this.default_text + '" class="default" autocomplete="off" style="width:25px;" /></li></ul><div class="chosen-drop"><ul class="chosen-results"></ul></div>');
            } else {
                this.container.html('<a class="chosen-single chosen-default" tabindex="-1"><span>' + this.default_text + '</span><div><b></b></div></a><div class="chosen-drop"><div class="chosen-search"><input type="text" autocomplete="off" /></div><ul class="chosen-results"></ul></div>');
            }
            this.form_field_jq.hide().after(this.container);
            this.dropdown = this.container.find('div.chosen-drop').first();
            this.search_field = this.container.find('input').first();
            this.search_results = this.container.find('ul.chosen-results').first();
            this.search_field_scale();
            this.search_no_results = this.container.find('li.no-results').first();
            if (this.is_multiple) {
                this.search_choices = this.container.find('ul.chosen-choices').first();
                this.search_container = this.container.find('li.search-field').first();
            } else {
                this.search_container = this.container.find('div.chosen-search').first();
                this.selected_item = this.container.find('.chosen-single').first();
            }
            this.results_build();
            this.set_tab_index();
            return this.set_label_behavior();
        };

        Chosen.prototype.on_ready = function () {
            return this.form_field_jq.trigger("chosen:ready", {
                chosen: this
            });
        };

        Chosen.prototype.register_observers = function () {
            var _this = this;
            this.container.bind('touchstart.chosen', function (evt) {
                _this.container_mousedown(evt);
                return evt.preventDefault();
            });
            this.container.bind('touchend.chosen', function (evt) {
                _this.container_mouseup(evt);
                return evt.preventDefault();
            });
            this.container.bind('mousedown.chosen', function (evt) {
                _this.container_mousedown(evt);
            });
            this.container.bind('mouseup.chosen', function (evt) {
                _this.container_mouseup(evt);
            });
            this.container.bind('mouseenter.chosen', function (evt) {
                _this.mouse_enter(evt);
            });
            this.container.bind('mouseleave.chosen', function (evt) {
                _this.mouse_leave(evt);
            });
            this.search_results.bind('mouseup.chosen', function (evt) {
                _this.search_results_mouseup(evt);
            });
            this.search_results.bind('mouseover.chosen', function (evt) {
                _this.search_results_mouseover(evt);
            });
            this.search_results.bind('mouseout.chosen', function (evt) {
                _this.search_results_mouseout(evt);
            });
            this.search_results.bind('mousewheel.chosen DOMMouseScroll.chosen', function (evt) {
                _this.search_results_mousewheel(evt);
            });
            this.search_results.bind('touchstart.chosen', function (evt) {
                _this.search_results_touchstart(evt);
            });
            this.search_results.bind('touchmove.chosen', function (evt) {
                _this.search_results_touchmove(evt);
            });
            this.search_results.bind('touchend.chosen', function (evt) {
                _this.search_results_touchend(evt);
            });
            this.form_field_jq.bind("chosen:updated.chosen", function (evt) {
                _this.results_update_field(evt);
            });
            this.form_field_jq.bind("chosen:activate.chosen", function (evt) {
                _this.activate_field(evt);
            });
            this.form_field_jq.bind("chosen:open.chosen", function (evt) {
                _this.container_mousedown(evt);
            });
            this.form_field_jq.bind("chosen:close.chosen", function (evt) {
                _this.input_blur(evt);
            });
            this.search_field.bind('blur.chosen', function (evt) {
                _this.input_blur(evt);
            });
            this.search_field.bind('keyup.chosen', function (evt) {
                _this.keyup_checker(evt);
            });
            this.search_field.bind('keydown.chosen', function (evt) {
                _this.keydown_checker(evt);
            });
            this.search_field.bind('focus.chosen', function (evt) {
                _this.input_focus(evt);
            });
            this.search_field.bind('cut.chosen', function (evt) {
                _this.clipboard_event_checker(evt);
            });
            this.search_field.bind('paste.chosen', function (evt) {
                _this.clipboard_event_checker(evt);
            });
            if (this.is_multiple) {
                return this.search_choices.bind('click.chosen', function (evt) {
                    _this.choices_click(evt);
                });
            } else {
                return this.container.bind('click.chosen', function (evt) {
                    evt.preventDefault();
                });
            }
        };

        Chosen.prototype.destroy = function () {
            $(this.container[0].ownerDocument).unbind("click.chosen", this.click_test_action);
            if (this.search_field[0].tabIndex) {
                this.form_field_jq[0].tabIndex = this.search_field[0].tabIndex;
            }
            this.container.remove();
            this.form_field_jq.removeData('chosen');
            return this.form_field_jq.show();
        };

        Chosen.prototype.search_field_disabled = function () {
            this.is_disabled = this.form_field_jq[0].disabled;
            if (this.is_disabled) {
                this.container.addClass('chosen-disabled');
                this.search_field[0].disabled = true;
                if (!this.is_multiple) {
                    this.selected_item.unbind("focus.chosen", this.activate_action);
                }
                return this.close_field();
            } else {
                this.container.removeClass('chosen-disabled');
                this.search_field[0].disabled = false;
                if (!this.is_multiple) {
                    return this.selected_item.bind("focus.chosen", this.activate_action);
                }
            }
        };

        Chosen.prototype.container_mousedown = function (evt) {
            if (!this.is_disabled) {
                if (evt && evt.type === "mousedown" && !this.results_showing) {
                    evt.preventDefault();
                }
                if (!((evt != null) && ($(evt.target)).hasClass("search-choice-close"))) {
                    if (!this.active_field) {
                        if (this.is_multiple) {
                            this.search_field.val("");
                        }
                        $(this.container[0].ownerDocument).bind('click.chosen', this.click_test_action);
                        this.results_show();
                    } else if (!this.is_multiple && evt && (($(evt.target)[0] === this.selected_item[0]) || $(evt.target).parents("a.chosen-single").length)) {
                        evt.preventDefault();
                        this.results_toggle();
                    }
                    return this.activate_field();
                }
            }
        };

        Chosen.prototype.container_mouseup = function (evt) {
            if (evt.target.nodeName === "ABBR" && !this.is_disabled) {
                return this.results_reset(evt);
            }
        };

        Chosen.prototype.search_results_mousewheel = function (evt) {
            var delta;
            if (evt.originalEvent) {
                delta = evt.originalEvent.deltaY || -evt.originalEvent.wheelDelta || evt.originalEvent.detail;
            }
            if (delta != null) {
                evt.preventDefault();
                if (evt.type === 'DOMMouseScroll') {
                    delta = delta * 40;
                }
                return this.search_results.scrollTop(delta + this.search_results.scrollTop());
            }
        };

        Chosen.prototype.blur_test = function (evt) {
            if (!this.active_field && this.container.hasClass("chosen-container-active")) {
                return this.close_field();
            }
        };

        Chosen.prototype.close_field = function () {
            $(this.container[0].ownerDocument).unbind("click.chosen", this.click_test_action);
            this.active_field = false;
            this.results_hide();
            this.container.removeClass("chosen-container-active");
            this.clear_backstroke();
            this.show_search_field_default();
            return this.search_field_scale();
        };

        Chosen.prototype.activate_field = function () {
            this.container.addClass("chosen-container-active");
            this.active_field = true;
            this.search_field.val(this.search_field.val());
            return this.search_field.focus();
        };

        Chosen.prototype.test_active_click = function (evt) {
            var active_container;
            active_container = $(evt.target).closest('.chosen-container');
            if (active_container.length && this.container[0] === active_container[0]) {
                return this.active_field = true;
            } else {
                return this.close_field();
            }
        };

        Chosen.prototype.results_build = function () {
            this.parsing = true;
            this.selected_option_count = null;
            this.results_data = SelectParser.select_to_array(this.form_field);
            if (this.is_multiple) {
                this.search_choices.find("li.search-choice").remove();
            } else if (!this.is_multiple) {
                this.single_set_selected_text();
                if (this.disable_search || this.form_field.options.length <= this.disable_search_threshold) {
                    this.search_field[0].readOnly = true;
                    this.container.addClass("chosen-container-single-nosearch");
                } else {
                    this.search_field[0].readOnly = false;
                    this.container.removeClass("chosen-container-single-nosearch");
                }
            }
            this.update_results_content(this.results_option_build({
                first: true
            }));
            this.search_field_disabled();
            this.show_search_field_default();
            this.search_field_scale();
            return this.parsing = false;
        };

        Chosen.prototype.result_do_highlight = function (el) {
            var high_bottom, high_top, maxHeight, visible_bottom, visible_top;
            if (el.length) {
                this.result_clear_highlight();
                this.result_highlight = el;
                this.result_highlight.addClass("highlighted");
                maxHeight = parseInt(this.search_results.css("maxHeight"), 10);
                visible_top = this.search_results.scrollTop();
                visible_bottom = maxHeight + visible_top;
                high_top = this.result_highlight.position().top + this.search_results.scrollTop();
                high_bottom = high_top + this.result_highlight.outerHeight();
                if (high_bottom >= visible_bottom) {
                    return this.search_results.scrollTop((high_bottom - maxHeight) > 0 ? high_bottom - maxHeight : 0);
                } else if (high_top < visible_top) {
                    return this.search_results.scrollTop(high_top);
                }
            }
        };

        Chosen.prototype.result_clear_highlight = function () {
            if (this.result_highlight) {
                this.result_highlight.removeClass("highlighted");
            }
            return this.result_highlight = null;
        };

        Chosen.prototype.results_show = function () {
            if (this.is_multiple && this.max_selected_options <= this.choices_count()) {
                this.form_field_jq.trigger("chosen:maxselected", {
                    chosen: this
                });
                return false;
            }
            this.container.addClass("chosen-with-drop");
            this.results_showing = true;
            this.search_field.focus();
            this.search_field.val(this.search_field.val());
            this.winnow_results();
            return this.form_field_jq.trigger("chosen:showing_dropdown", {
                chosen: this
            });
        };

        Chosen.prototype.update_results_content = function (content) {
            return this.search_results.html(content);
        };

        Chosen.prototype.results_hide = function () {
            if (this.results_showing) {
                this.result_clear_highlight();
                this.container.removeClass("chosen-with-drop");
                this.form_field_jq.trigger("chosen:hiding_dropdown", {
                    chosen: this
                });
            }
            return this.results_showing = false;
        };

        Chosen.prototype.set_tab_index = function (el) {
            var ti;
            if (this.form_field.tabIndex) {
                ti = this.form_field.tabIndex;
                this.form_field.tabIndex = -1;
                return this.search_field[0].tabIndex = ti;
            }
        };

        Chosen.prototype.set_label_behavior = function () {
            var _this = this;
            this.form_field_label = this.form_field_jq.parents("label");
            if (!this.form_field_label.length && this.form_field.id.length) {
                this.form_field_label = $("label[for='" + this.form_field.id + "']");
            }
            if (this.form_field_label.length > 0) {
                return this.form_field_label.bind('click.chosen', function (evt) {
                    if (_this.is_multiple) {
                        return _this.container_mousedown(evt);
                    } else {
                        return _this.activate_field();
                    }
                });
            }
        };

        Chosen.prototype.show_search_field_default = function () {
            if (this.is_multiple && this.choices_count() < 1 && !this.active_field) {
                this.search_field.val(this.default_text);
                return this.search_field.addClass("default");
            } else {
                this.search_field.val("");
                return this.search_field.removeClass("default");
            }
        };

        Chosen.prototype.search_results_mouseup = function (evt) {
            var target;
            target = $(evt.target).hasClass("active-result") ? $(evt.target) : $(evt.target).parents(".active-result").first();
            if (target.length) {
                this.result_highlight = target;
                this.result_select(evt);
                return this.search_field.focus();
            }
        };

        Chosen.prototype.search_results_mouseover = function (evt) {
            var target;
            target = $(evt.target).hasClass("active-result") ? $(evt.target) : $(evt.target).parents(".active-result").first();
            if (target) {
                return this.result_do_highlight(target);
            }
        };

        Chosen.prototype.search_results_mouseout = function (evt) {
            if ($(evt.target).hasClass("active-result" || $(evt.target).parents('.active-result').first())) {
                return this.result_clear_highlight();
            }
        };

        Chosen.prototype.choice_build = function (item) {
            var choice, close_link,
              _this = this;
            choice = $('<li />', {
                "class": "search-choice"
            }).html("<span>" + (this.choice_label(item)) + "</span>");
            if (item.disabled) {
                choice.addClass('search-choice-disabled');
            } else {
                close_link = $('<a />', {
                    "class": 'search-choice-close',
                    'data-option-array-index': item.array_index
                });
                close_link.bind('click.chosen', function (evt) {
                    return _this.choice_destroy_link_click(evt);
                });
                choice.append(close_link);
            }
            return this.search_container.before(choice);
        };

        Chosen.prototype.choice_destroy_link_click = function (evt) {
            evt.preventDefault();
            evt.stopPropagation();
            if (!this.is_disabled) {
                return this.choice_destroy($(evt.target));
            }
        };

        Chosen.prototype.choice_destroy = function (link) {
            if (this.result_deselect(link[0].getAttribute("data-option-array-index"))) {
                this.show_search_field_default();
                if (this.is_multiple && this.choices_count() > 0 && this.search_field.val().length < 1) {
                    this.results_hide();
                }
                link.parents('li').first().remove();
                return this.search_field_scale();
            }
        };

        Chosen.prototype.results_reset = function () {
            this.reset_single_select_options();
            this.form_field.options[0].selected = true;
            this.single_set_selected_text();
            this.show_search_field_default();
            this.results_reset_cleanup();
            this.form_field_jq.trigger("change");
            if (this.active_field) {
                return this.results_hide();
            }
        };

        Chosen.prototype.results_reset_cleanup = function () {
            this.current_selectedIndex = this.form_field.selectedIndex;
            return this.selected_item.find("abbr").remove();
        };

        Chosen.prototype.result_select = function (evt) {
            var high, item;
            if (this.result_highlight) {
                high = this.result_highlight;
                this.result_clear_highlight();
                if (this.is_multiple && this.max_selected_options <= this.choices_count()) {
                    this.form_field_jq.trigger("chosen:maxselected", {
                        chosen: this
                    });
                    return false;
                }
                if (this.is_multiple) {
                    high.removeClass("active-result");
                } else {
                    this.reset_single_select_options();
                }
                high.addClass("result-selected");
                item = this.results_data[high[0].getAttribute("data-option-array-index")];
                item.selected = true;
                this.form_field.options[item.options_index].selected = true;
                this.selected_option_count = null;
                if (this.is_multiple) {
                    this.choice_build(item);
                } else {
                    this.single_set_selected_text(this.choice_label(item));
                }
                if (!((evt.metaKey || evt.ctrlKey) && this.is_multiple)) {
                    this.results_hide();
                }
                this.search_field.val("");
                if (this.is_multiple || this.form_field.selectedIndex !== this.current_selectedIndex) {
                    this.form_field_jq.trigger("change", {
                        'selected': this.form_field.options[item.options_index].value
                    });
                }
                this.current_selectedIndex = this.form_field.selectedIndex;
                evt.preventDefault();
                return this.search_field_scale();
            }
        };

        Chosen.prototype.single_set_selected_text = function (text) {
            if (text == null) {
                text = this.default_text;
            }
            if (text === this.default_text) {
                this.selected_item.addClass("chosen-default");
            } else {
                this.single_deselect_control_build();
                this.selected_item.removeClass("chosen-default");
            }
            return this.selected_item.find("span").html(text);
        };

        Chosen.prototype.result_deselect = function (pos) {
            var result_data;
            result_data = this.results_data[pos];
            if (!this.form_field.options[result_data.options_index].disabled) {
                result_data.selected = false;
                this.form_field.options[result_data.options_index].selected = false;
                this.selected_option_count = null;
                this.result_clear_highlight();
                if (this.results_showing) {
                    this.winnow_results();
                }
                this.form_field_jq.trigger("change", {
                    deselected: this.form_field.options[result_data.options_index].value
                });
                this.search_field_scale();
                return true;
            } else {
                return false;
            }
        };

        Chosen.prototype.single_deselect_control_build = function () {
            if (!this.allow_single_deselect) {
                return;
            }
            if (!this.selected_item.find("abbr").length) {
                this.selected_item.find("span").first().after("<abbr class=\"search-choice-close\"></abbr>");
            }
            return this.selected_item.addClass("chosen-single-with-deselect");
        };

        Chosen.prototype.get_search_text = function () {
            return $('<div/>').text($.trim(this.search_field.val())).html();
        };

        Chosen.prototype.winnow_results_set_highlight = function () {
            var do_high, selected_results;
            selected_results = !this.is_multiple ? this.search_results.find(".result-selected.active-result") : [];
            do_high = selected_results.length ? selected_results.first() : this.search_results.find(".active-result").first();
            if (do_high != null) {
                return this.result_do_highlight(do_high);
            }
        };

        Chosen.prototype.no_results = function (terms) {
            var no_results_html;
            no_results_html = $('<li class="no-results">' + this.results_none_found + ' "<span></span>"</li>');
            no_results_html.find("span").first().html(terms);
            this.search_results.append(no_results_html);
            return this.form_field_jq.trigger("chosen:no_results", {
                chosen: this
            });
        };

        Chosen.prototype.no_results_clear = function () {
            return this.search_results.find(".no-results").remove();
        };

        Chosen.prototype.keydown_arrow = function () {
            var next_sib;
            if (this.results_showing && this.result_highlight) {
                next_sib = this.result_highlight.nextAll("li.active-result").first();
                if (next_sib) {
                    return this.result_do_highlight(next_sib);
                }
            } else {
                return this.results_show();
            }
        };

        Chosen.prototype.keyup_arrow = function () {
            var prev_sibs;
            if (!this.results_showing && !this.is_multiple) {
                return this.results_show();
            } else if (this.result_highlight) {
                prev_sibs = this.result_highlight.prevAll("li.active-result");
                if (prev_sibs.length) {
                    return this.result_do_highlight(prev_sibs.first());
                } else {
                    if (this.choices_count() > 0) {
                        this.results_hide();
                    }
                    return this.result_clear_highlight();
                }
            }
        };

        Chosen.prototype.keydown_backstroke = function () {
            var next_available_destroy;
            if (this.pending_backstroke) {
                this.choice_destroy(this.pending_backstroke.find("a").first());
                return this.clear_backstroke();
            } else {
                next_available_destroy = this.search_container.siblings("li.search-choice").last();
                if (next_available_destroy.length && !next_available_destroy.hasClass("search-choice-disabled")) {
                    this.pending_backstroke = next_available_destroy;
                    if (this.single_backstroke_delete) {
                        return this.keydown_backstroke();
                    } else {
                        return this.pending_backstroke.addClass("search-choice-focus");
                    }
                }
            }
        };

        Chosen.prototype.clear_backstroke = function () {
            if (this.pending_backstroke) {
                this.pending_backstroke.removeClass("search-choice-focus");
            }
            return this.pending_backstroke = null;
        };

        Chosen.prototype.keydown_checker = function (evt) {
            var stroke, _ref1;
            stroke = (_ref1 = evt.which) != null ? _ref1 : evt.keyCode;
            this.search_field_scale();
            if (stroke !== 8 && this.pending_backstroke) {
                this.clear_backstroke();
            }
            switch (stroke) {
                case 8:
                    this.backstroke_length = this.search_field.val().length;
                    break;
                case 9:
                    if (this.results_showing && !this.is_multiple) {
                        this.result_select(evt);
                    }
                    this.mouse_on_container = false;
                    break;
                case 13:
                    if (this.results_showing) {
                        evt.preventDefault();
                    }
                    break;
                case 32:
                    if (this.disable_search) {
                        evt.preventDefault();
                    }
                    break;
                case 38:
                    evt.preventDefault();
                    this.keyup_arrow();
                    break;
                case 40:
                    evt.preventDefault();
                    this.keydown_arrow();
                    break;
            }
        };

        Chosen.prototype.search_field_scale = function () {
            var div, f_width, h, style, style_block, styles, w, _i, _len;
            if (this.is_multiple) {
                h = 0;
                w = 0;
                style_block = "position:absolute; left: -1000px; top: -1000px; display:none;";
                styles = ['font-size', 'font-style', 'font-weight', 'font-family', 'line-height', 'text-transform', 'letter-spacing'];
                for (_i = 0, _len = styles.length; _i < _len; _i++) {
                    style = styles[_i];
                    style_block += style + ":" + this.search_field.css(style) + ";";
                }
                div = $('<div />', {
                    'style': style_block
                });
                div.text(this.search_field.val());
                $('body').append(div);
                w = div.width() + 25;
                div.remove();
                f_width = this.container.outerWidth();
                if (w > f_width - 10) {
                    w = f_width - 10;
                }
                return this.search_field.css({
                    'width': w + 'px'
                });
            }
        };

        return Chosen;

    })(AbstractChosen);

}).call(this);

/*!
 * classie - class helper functions
 * from bonzo https://github.com/ded/bonzo
 * 
 * classie.has( elem, 'my-class' ) -> true/false
 * classie.add( elem, 'my-new-class' )
 * classie.remove( elem, 'my-unwanted-class' )
 * classie.toggle( elem, 'my-class' )
 */

/*jshint browser: true, strict: true, undef: true */
/*global define: false */

( function( window ) {

'use strict';

// class helper functions from bonzo https://github.com/ded/bonzo

function classReg( className ) {
  return new RegExp("(^|\\s+)" + className + "(\\s+|$)");
}

// classList support for class management
// altho to be fair, the api sucks because it won't accept multiple classes at once
var hasClass, addClass, removeClass;

if ( 'classList' in document.documentElement ) {
  hasClass = function( elem, c ) {
    return elem.classList.contains( c );
  };
  addClass = function( elem, c ) {
    elem.classList.add( c );
  };
  removeClass = function( elem, c ) {
    elem.classList.remove( c );
  };
}
else {
  hasClass = function( elem, c ) {
    return classReg( c ).test( elem.className );
  };
  addClass = function( elem, c ) {
    if ( !hasClass( elem, c ) ) {
      elem.className = elem.className + ' ' + c;
    }
  };
  removeClass = function( elem, c ) {
    elem.className = elem.className.replace( classReg( c ), ' ' );
  };
}

function toggleClass( elem, c ) {
  var fn = hasClass( elem, c ) ? removeClass : addClass;
  fn( elem, c );
}

var classie = {
  // full names
  hasClass: hasClass,
  addClass: addClass,
  removeClass: removeClass,
  toggleClass: toggleClass,
  // short names
  has: hasClass,
  add: addClass,
  remove: removeClass,
  toggle: toggleClass
};

// transport
if ( typeof define === 'function' && define.amd ) {
  // AMD
  define( classie );
} else {
  // browser global
  window.classie = classie;
}

})( window );

(function($) {
	var	aux		= {
			// navigates left / right
			navigate	: function( dir, $el, $wrapper, opts, cache ) {
				
				var scroll		= opts.scroll,
					factor		= 1,
					idxClicked	= 0;
					
				if( cache.expanded ) {
					scroll		= 1; // scroll is always 1 in full mode
					factor		= 3; // the width of the expanded item will be 3 times bigger than 1 collapsed item	
					idxClicked	= cache.idxClicked; // the index of the clicked item
				}
				
				// clone the elements on the right / left and append / prepend them according to dir and scroll
				if( dir === 1 ) {
					$wrapper.find('div.ca-item:lt(' + scroll + ')').each(function(i) {
						$(this).clone(true).css( 'left', ( cache.totalItems - idxClicked + i ) * cache.itemW * factor + 'px' ).appendTo( $wrapper );
					});
				}
				else {
					var $first	= $wrapper.children().eq(0);
					
					$wrapper.find('div.ca-item:gt(' + ( cache.totalItems  - 1 - scroll ) + ')').each(function(i) {
						// insert before $first so they stay in the right order
						$(this).clone(true).css( 'left', - ( scroll - i + idxClicked ) * cache.itemW * factor + 'px' ).insertBefore( $first );
					});
				}
				
				// animate the left of each item
				// the calculations are dependent on dir and on the cache.expanded value
				$wrapper.find('div.ca-item').each(function(i) {
					var $item	= $(this);
					$item.stop().animate({
						left	:  ( dir === 1 ) ? '-=' + ( cache.itemW * factor * scroll ) + 'px' : '+=' + ( cache.itemW * factor * scroll ) + 'px'
					}, opts.sliderSpeed, opts.sliderEasing, function() {
						if( ( dir === 1 && $item.position().left < - idxClicked * cache.itemW * factor ) || ( dir === -1 && $item.position().left > ( ( cache.totalItems - 1 - idxClicked ) * cache.itemW * factor ) ) ) {
							// remove the item that was cloned
							$item.remove();
						}						
						cache.isAnimating	= false;
					});
				});
				
			},
			// opens an item (animation) -> opens all the others
			openItem	: function( $wrapper, $item, opts, cache ) {
				cache.idxClicked	= $item.index();
				// the item's position (1, 2, or 3) on the viewport (the visible items) 
				cache.winpos		= aux.getWinPos( $item.position().left, cache );
				$wrapper.find('div.ca-item').not( $item ).hide();
				$item.find('div.ca-content-wrapper').css( 'left', cache.itemW + 'px' ).stop().animate({
					width	: cache.itemW * 2 + 'px',
					left	: cache.itemW + 'px'
				}, opts.itemSpeed, opts.itemEasing)
				.end()
				.stop()
				.animate({
					left	: '0px'
				}, opts.itemSpeed, opts.itemEasing, function() {
					cache.isAnimating	= false;
					cache.expanded		= true;
					
					aux.openItems( $wrapper, $item, opts, cache );
				});
						
			},
			// opens all the items
			openItems	: function( $wrapper, $openedItem, opts, cache ) {
				var openedIdx	= $openedItem.index();
				
				$wrapper.find('div.ca-item').each(function(i) {
					var $item	= $(this),
						idx		= $item.index();
					
					if( idx !== openedIdx ) {
						$item.css( 'left', - ( openedIdx - idx ) * ( cache.itemW * 3 ) + 'px' ).show().find('div.ca-content-wrapper').css({
							left	: cache.itemW + 'px',
							width	: cache.itemW * 2 + 'px'
						});
						
						// hide more link
						aux.toggleMore( $item, false );
					}
				});
			},
			// show / hide the item's more button
			toggleMore	: function( $item, show ) {
				( show ) ? $item.find('a.ca-more').show() : $item.find('a.ca-more').hide();	
			},
			// close all the items
			// the current one is animated
			closeItems	: function( $wrapper, $openedItem, opts, cache ) {
				var openedIdx	= $openedItem.index();
				
				$openedItem.find('div.ca-content-wrapper').stop().animate({
					width	: '0px'
				}, opts.itemSpeed, opts.itemEasing)
				.end()
				.stop()
				.animate({
					left	: cache.itemW * ( cache.winpos - 1 ) + 'px'
				}, opts.itemSpeed, opts.itemEasing, function() {
					cache.isAnimating	= false;
					cache.expanded		= false;
				});
				
				// show more link
				aux.toggleMore( $openedItem, true );
				
				$wrapper.find('div.ca-item').each(function(i) {
					var $item	= $(this),
						idx		= $item.index();
					
					if( idx !== openedIdx ) {
						$item.find('div.ca-content-wrapper').css({
							width	: '0px'
						})
						.end()
						.css( 'left', ( ( cache.winpos - 1 ) - ( openedIdx - idx ) ) * cache.itemW + 'px' )
						.show();
						
						// show more link
						aux.toggleMore( $item, true );
					}
				});
			},
			// gets the item's position (1, 2, or 3) on the viewport (the visible items)
			// val is the left of the item
			getWinPos	: function( val, cache ) {
				switch( val ) {
					case 0 					: return 1; break;
					case cache.itemW 		: return 2; break;
					case cache.itemW * 2 	: return 3; break;
				}
			}
		},
		methods = {
			init 		: function( options ) {
				
				if( this.length ) {
					
					var settings = {
						sliderSpeed		: 500,			// speed for the sliding animation
						sliderEasing	: 'easeOutExpo',// easing for the sliding animation
						itemSpeed		: 500,			// speed for the item animation (open / close)
						itemEasing		: 'easeOutExpo',// easing for the item animation (open / close)
						scroll			: 1				// number of items to scroll at a time
					};
					
					return this.each(function() {
						
						// if options exist, lets merge them with our default settings
						if ( options ) {
							$.extend( settings, options );
						}
						
						var $el 			= $(this),
							$wrapper		= $el.find('div.ca-wrapper'),
							$items			= $wrapper.children('div.ca-item'),
							cache			= {};
						
						// save the with of one item	
						cache.itemW			= $items.width();
						// save the number of total items
						cache.totalItems	= $items.length;
						
						// add navigation buttons
						if( cache.totalItems > 3 )	
							$el.prepend('<div class="ca-nav"><span class="ca-nav-prev">Previous</span><span class="ca-nav-next">Next</span></div>')	
						
						// control the scroll value
						if( settings.scroll < 1 )
							settings.scroll = 1;
						else if( settings.scroll > 3 )
							settings.scroll = 3;	
						
						var $navPrev		= $el.find('span.ca-nav-prev'),
							$navNext		= $el.find('span.ca-nav-next');
						
						// hide the items except the first 3
						$wrapper.css( 'overflow', 'hidden' );
						
						// the items will have position absolute 
						// calculate the left of each item
						$items.each(function(i) {
							$(this).css({
								position	: 'absolute',
								left		: i * cache.itemW + 'px'
							});
						});
						
						
						// navigate left
						$navPrev.bind('click.contentcarousel', function( event ) {
							if( cache.isAnimating ) return false;
							cache.isAnimating	= true;
							aux.navigate( -1, $el, $wrapper, settings, cache );
						});
						
						// navigate right
						$navNext.bind('click.contentcarousel', function( event ) {
							if( cache.isAnimating ) return false;
							cache.isAnimating	= true;
							aux.navigate( 1, $el, $wrapper, settings, cache );
						});
						
						// adds events to the mouse
						$el.bind('mousewheel.contentcarousel', function(e, delta) {
							if(delta > 0) {
								if( cache.isAnimating ) return false;
								cache.isAnimating	= true;
								aux.navigate( -1, $el, $wrapper, settings, cache );
							}	
							else {
								if( cache.isAnimating ) return false;
								cache.isAnimating	= true;
								aux.navigate( 1, $el, $wrapper, settings, cache );
							}	
							return false;
						});
						
					});
				}
			}
		};
	
	$.fn.contentcarousel = function(method) {
		if ( methods[method] ) {
			return methods[method].apply( this, Array.prototype.slice.call( arguments, 1 ));
		} else if ( typeof method === 'object' || ! method ) {
			return methods.init.apply( this, arguments );
		} else {
			$.error( 'Method ' +  method + ' does not exist on jQuery.contentcarousel' );
		}
	};
	
})(jQuery);
/* ========================================================================
 * Bootstrap: dropdown.js v3.3.2
 * http://getbootstrap.com/javascript/#dropdowns
 * ========================================================================
 * Copyright 2011-2015 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // DROPDOWN CLASS DEFINITION
  // =========================

  var backdrop = '.dropdown-backdrop'
  var toggle   = '[data-toggle="dropdown"]'
  var Dropdown = function (element) {
    $(element).on('click.bs.dropdown', this.toggle)
  }

  Dropdown.VERSION = '3.3.2'

  Dropdown.prototype.toggle = function (e) {
    var $this = $(this)

    if ($this.is('.disabled, :disabled')) return

    var $parent  = getParent($this)
    var isActive = $parent.hasClass('open')

    clearMenus()

    if (!isActive) {
      if ('ontouchstart' in document.documentElement && !$parent.closest('.navbar-nav').length) {
        // if mobile we use a backdrop because click events don't delegate
        $('<div class="dropdown-backdrop"/>').insertAfter($(this)).on('click', clearMenus)
      }

      var relatedTarget = { relatedTarget: this }
      $parent.trigger(e = $.Event('show.bs.dropdown', relatedTarget))

      if (e.isDefaultPrevented()) return

      $this
        .trigger('focus')
        .attr('aria-expanded', 'true')

      $parent
        .toggleClass('open')
        .trigger('shown.bs.dropdown', relatedTarget)
    }

    return false
  }

  Dropdown.prototype.keydown = function (e) {
    if (!/(38|40|27|32)/.test(e.which) || /input|textarea/i.test(e.target.tagName)) return

    var $this = $(this)

    e.preventDefault()
    e.stopPropagation()

    if ($this.is('.disabled, :disabled')) return

    var $parent  = getParent($this)
    var isActive = $parent.hasClass('open')

    if ((!isActive && e.which != 27) || (isActive && e.which == 27)) {
      if (e.which == 27) $parent.find(toggle).trigger('focus')
      return $this.trigger('click')
    }

    var desc = ' li:not(.divider):visible a'
    var $items = $parent.find('[role="menu"]' + desc + ', [role="listbox"]' + desc)

    if (!$items.length) return

    var index = $items.index(e.target)

    if (e.which == 38 && index > 0)                 index--                        // up
    if (e.which == 40 && index < $items.length - 1) index++                        // down
    if (!~index)                                      index = 0

    $items.eq(index).trigger('focus')
  }

  function clearMenus(e) {
    if (e && e.which === 3) return
    $(backdrop).remove()
    $(toggle).each(function () {
      var $this         = $(this)
      var $parent       = getParent($this)
      var relatedTarget = { relatedTarget: this }

      if (!$parent.hasClass('open')) return

      $parent.trigger(e = $.Event('hide.bs.dropdown', relatedTarget))

      if (e.isDefaultPrevented()) return

      $this.attr('aria-expanded', 'false')
      $parent.removeClass('open').trigger('hidden.bs.dropdown', relatedTarget)
    })
  }

  function getParent($this) {
    var selector = $this.attr('data-target')

    if (!selector) {
      selector = $this.attr('href')
      selector = selector && /#[A-Za-z]/.test(selector) && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
    }

    var $parent = selector && $(selector)

    return $parent && $parent.length ? $parent : $this.parent()
  }


  // DROPDOWN PLUGIN DEFINITION
  // ==========================

  function Plugin(option) {
    return this.each(function () {
      var $this = $(this)
      var data  = $this.data('bs.dropdown')

      if (!data) $this.data('bs.dropdown', (data = new Dropdown(this)))
      if (typeof option == 'string') data[option].call($this)
    })
  }

  var old = $.fn.dropdown

  $.fn.dropdown             = Plugin
  $.fn.dropdown.Constructor = Dropdown


  // DROPDOWN NO CONFLICT
  // ====================

  $.fn.dropdown.noConflict = function () {
    $.fn.dropdown = old
    return this
  }


  // APPLY TO STANDARD DROPDOWN ELEMENTS
  // ===================================

  $(document)
    .on('click.bs.dropdown.data-api', clearMenus)
    .on('click.bs.dropdown.data-api', '.dropdown form', function (e) { e.stopPropagation() })
    .on('click.bs.dropdown.data-api', toggle, Dropdown.prototype.toggle)
    .on('keydown.bs.dropdown.data-api', toggle, Dropdown.prototype.keydown)
    .on('keydown.bs.dropdown.data-api', '[role="menu"]', Dropdown.prototype.keydown)
    .on('keydown.bs.dropdown.data-api', '[role="listbox"]', Dropdown.prototype.keydown)

}(jQuery);

/*
 * jQuery Easing v1.3 - http://gsgd.co.uk/sandbox/jquery/easing/
 *
 * Uses the built in easing capabilities added In jQuery 1.1
 * to offer multiple easing options
 *
 * TERMS OF USE - jQuery Easing
 * 
 * Open source under the BSD License. 
 * 
 * Copyright © 2008 George McGinley Smith
 * All rights reserved.
 * 
 * Redistribution and use in source and binary forms, with or without modification, 
 * are permitted provided that the following conditions are met:
 * 
 * Redistributions of source code must retain the above copyright notice, this list of 
 * conditions and the following disclaimer.
 * Redistributions in binary form must reproduce the above copyright notice, this list 
 * of conditions and the following disclaimer in the documentation and/or other materials 
 * provided with the distribution.
 * 
 * Neither the name of the author nor the names of contributors may be used to endorse 
 * or promote products derived from this software without specific prior written permission.
 * 
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY 
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF
 * MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE
 *  COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
 *  EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE
 *  GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED 
 * AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 *  NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED 
 * OF THE POSSIBILITY OF SUCH DAMAGE. 
 *
*/

// t: current time, b: begInnIng value, c: change In value, d: duration
jQuery.easing['jswing'] = jQuery.easing['swing'];

jQuery.extend( jQuery.easing,
{
	def: 'easeOutQuad',
	swing: function (x, t, b, c, d) {
		//alert(jQuery.easing.default);
		return jQuery.easing[jQuery.easing.def](x, t, b, c, d);
	},
	easeInQuad: function (x, t, b, c, d) {
		return c*(t/=d)*t + b;
	},
	easeOutQuad: function (x, t, b, c, d) {
		return -c *(t/=d)*(t-2) + b;
	},
	easeInOutQuad: function (x, t, b, c, d) {
		if ((t/=d/2) < 1) return c/2*t*t + b;
		return -c/2 * ((--t)*(t-2) - 1) + b;
	},
	easeInCubic: function (x, t, b, c, d) {
		return c*(t/=d)*t*t + b;
	},
	easeOutCubic: function (x, t, b, c, d) {
		return c*((t=t/d-1)*t*t + 1) + b;
	},
	easeInOutCubic: function (x, t, b, c, d) {
		if ((t/=d/2) < 1) return c/2*t*t*t + b;
		return c/2*((t-=2)*t*t + 2) + b;
	},
	easeInQuart: function (x, t, b, c, d) {
		return c*(t/=d)*t*t*t + b;
	},
	easeOutQuart: function (x, t, b, c, d) {
		return -c * ((t=t/d-1)*t*t*t - 1) + b;
	},
	easeInOutQuart: function (x, t, b, c, d) {
		if ((t/=d/2) < 1) return c/2*t*t*t*t + b;
		return -c/2 * ((t-=2)*t*t*t - 2) + b;
	},
	easeInQuint: function (x, t, b, c, d) {
		return c*(t/=d)*t*t*t*t + b;
	},
	easeOutQuint: function (x, t, b, c, d) {
		return c*((t=t/d-1)*t*t*t*t + 1) + b;
	},
	easeInOutQuint: function (x, t, b, c, d) {
		if ((t/=d/2) < 1) return c/2*t*t*t*t*t + b;
		return c/2*((t-=2)*t*t*t*t + 2) + b;
	},
	easeInSine: function (x, t, b, c, d) {
		return -c * Math.cos(t/d * (Math.PI/2)) + c + b;
	},
	easeOutSine: function (x, t, b, c, d) {
		return c * Math.sin(t/d * (Math.PI/2)) + b;
	},
	easeInOutSine: function (x, t, b, c, d) {
		return -c/2 * (Math.cos(Math.PI*t/d) - 1) + b;
	},
	easeInExpo: function (x, t, b, c, d) {
		return (t==0) ? b : c * Math.pow(2, 10 * (t/d - 1)) + b;
	},
	easeOutExpo: function (x, t, b, c, d) {
		return (t==d) ? b+c : c * (-Math.pow(2, -10 * t/d) + 1) + b;
	},
	easeInOutExpo: function (x, t, b, c, d) {
		if (t==0) return b;
		if (t==d) return b+c;
		if ((t/=d/2) < 1) return c/2 * Math.pow(2, 10 * (t - 1)) + b;
		return c/2 * (-Math.pow(2, -10 * --t) + 2) + b;
	},
	easeInCirc: function (x, t, b, c, d) {
		return -c * (Math.sqrt(1 - (t/=d)*t) - 1) + b;
	},
	easeOutCirc: function (x, t, b, c, d) {
		return c * Math.sqrt(1 - (t=t/d-1)*t) + b;
	},
	easeInOutCirc: function (x, t, b, c, d) {
		if ((t/=d/2) < 1) return -c/2 * (Math.sqrt(1 - t*t) - 1) + b;
		return c/2 * (Math.sqrt(1 - (t-=2)*t) + 1) + b;
	},
	easeInElastic: function (x, t, b, c, d) {
		var s=1.70158;var p=0;var a=c;
		if (t==0) return b;  if ((t/=d)==1) return b+c;  if (!p) p=d*.3;
		if (a < Math.abs(c)) { a=c; var s=p/4; }
		else var s = p/(2*Math.PI) * Math.asin (c/a);
		return -(a*Math.pow(2,10*(t-=1)) * Math.sin( (t*d-s)*(2*Math.PI)/p )) + b;
	},
	easeOutElastic: function (x, t, b, c, d) {
		var s=1.70158;var p=0;var a=c;
		if (t==0) return b;  if ((t/=d)==1) return b+c;  if (!p) p=d*.3;
		if (a < Math.abs(c)) { a=c; var s=p/4; }
		else var s = p/(2*Math.PI) * Math.asin (c/a);
		return a*Math.pow(2,-10*t) * Math.sin( (t*d-s)*(2*Math.PI)/p ) + c + b;
	},
	easeInOutElastic: function (x, t, b, c, d) {
		var s=1.70158;var p=0;var a=c;
		if (t==0) return b;  if ((t/=d/2)==2) return b+c;  if (!p) p=d*(.3*1.5);
		if (a < Math.abs(c)) { a=c; var s=p/4; }
		else var s = p/(2*Math.PI) * Math.asin (c/a);
		if (t < 1) return -.5*(a*Math.pow(2,10*(t-=1)) * Math.sin( (t*d-s)*(2*Math.PI)/p )) + b;
		return a*Math.pow(2,-10*(t-=1)) * Math.sin( (t*d-s)*(2*Math.PI)/p )*.5 + c + b;
	},
	easeInBack: function (x, t, b, c, d, s) {
		if (s == undefined) s = 1.70158;
		return c*(t/=d)*t*((s+1)*t - s) + b;
	},
	easeOutBack: function (x, t, b, c, d, s) {
		if (s == undefined) s = 1.70158;
		return c*((t=t/d-1)*t*((s+1)*t + s) + 1) + b;
	},
	easeInOutBack: function (x, t, b, c, d, s) {
		if (s == undefined) s = 1.70158; 
		if ((t/=d/2) < 1) return c/2*(t*t*(((s*=(1.525))+1)*t - s)) + b;
		return c/2*((t-=2)*t*(((s*=(1.525))+1)*t + s) + 2) + b;
	},
	easeInBounce: function (x, t, b, c, d) {
		return c - jQuery.easing.easeOutBounce (x, d-t, 0, c, d) + b;
	},
	easeOutBounce: function (x, t, b, c, d) {
		if ((t/=d) < (1/2.75)) {
			return c*(7.5625*t*t) + b;
		} else if (t < (2/2.75)) {
			return c*(7.5625*(t-=(1.5/2.75))*t + .75) + b;
		} else if (t < (2.5/2.75)) {
			return c*(7.5625*(t-=(2.25/2.75))*t + .9375) + b;
		} else {
			return c*(7.5625*(t-=(2.625/2.75))*t + .984375) + b;
		}
	},
	easeInOutBounce: function (x, t, b, c, d) {
		if (t < d/2) return jQuery.easing.easeInBounce (x, t*2, 0, c, d) * .5 + b;
		return jQuery.easing.easeOutBounce (x, t*2-d, 0, c, d) * .5 + c*.5 + b;
	}
});

/*
 *
 * TERMS OF USE - EASING EQUATIONS
 * 
 * Open source under the BSD License. 
 * 
 * Copyright © 2001 Robert Penner
 * All rights reserved.
 * 
 * Redistribution and use in source and binary forms, with or without modification, 
 * are permitted provided that the following conditions are met:
 * 
 * Redistributions of source code must retain the above copyright notice, this list of 
 * conditions and the following disclaimer.
 * Redistributions in binary form must reproduce the above copyright notice, this list 
 * of conditions and the following disclaimer in the documentation and/or other materials 
 * provided with the distribution.
 * 
 * Neither the name of the author nor the names of contributors may be used to endorse 
 * or promote products derived from this software without specific prior written permission.
 * 
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY 
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF
 * MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE
 *  COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
 *  EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE
 *  GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED 
 * AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 *  NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED 
 * OF THE POSSIBILITY OF SUCH DAMAGE. 
 *
 */
/*!
 * Fotorama 4.6.3 | http://fotorama.io/license/
 */
fotoramaVersion = '4.6.3';
(function (window, document, location, $, undefined) {
    "use strict";
    var _fotoramaClass = 'fotorama',
        _fullscreenClass = 'fullscreen',

        wrapClass = _fotoramaClass + '__wrap',
        wrapCss2Class = wrapClass + '--css2',
        wrapCss3Class = wrapClass + '--css3',
        wrapVideoClass = wrapClass + '--video',
        wrapFadeClass = wrapClass + '--fade',
        wrapSlideClass = wrapClass + '--slide',
        wrapNoControlsClass = wrapClass + '--no-controls',
        wrapNoShadowsClass = wrapClass + '--no-shadows',
        wrapPanYClass = wrapClass + '--pan-y',
        wrapRtlClass = wrapClass + '--rtl',
        wrapOnlyActiveClass = wrapClass + '--only-active',
        wrapNoCaptionsClass = wrapClass + '--no-captions',
        wrapToggleArrowsClass = wrapClass + '--toggle-arrows',

        stageClass = _fotoramaClass + '__stage',
        stageFrameClass = stageClass + '__frame',
        stageFrameVideoClass = stageFrameClass + '--video',
        stageShaftClass = stageClass + '__shaft',

        grabClass = _fotoramaClass + '__grab',
        pointerClass = _fotoramaClass + '__pointer',

        arrClass = _fotoramaClass + '__arr',
        arrDisabledClass = arrClass + '--disabled',
        arrPrevClass = arrClass + '--prev',
        arrNextClass = arrClass + '--next',
        arrArrClass = arrClass + '__arr',

        navClass = _fotoramaClass + '__nav',
        navWrapClass = navClass + '-wrap',
        navShaftClass = navClass + '__shaft',
        navDotsClass = navClass + '--dots',
        navThumbsClass = navClass + '--thumbs',
        navFrameClass = navClass + '__frame',
        navFrameDotClass = navFrameClass + '--dot',
        navFrameThumbClass = navFrameClass + '--thumb',

        fadeClass = _fotoramaClass + '__fade',
        fadeFrontClass = fadeClass + '-front',
        fadeRearClass = fadeClass + '-rear',

        shadowClass = _fotoramaClass + '__shadow',
        shadowsClass = shadowClass + 's',
        shadowsLeftClass = shadowsClass + '--left',
        shadowsRightClass = shadowsClass + '--right',

        activeClass = _fotoramaClass + '__active',
        selectClass = _fotoramaClass + '__select',

        hiddenClass = _fotoramaClass + '--hidden',

        fullscreenClass = _fotoramaClass + '--fullscreen',
        fullscreenIconClass = _fotoramaClass + '__fullscreen-icon',

        errorClass = _fotoramaClass + '__error',
        loadingClass = _fotoramaClass + '__loading',
        loadedClass = _fotoramaClass + '__loaded',
        loadedFullClass = loadedClass + '--full',
        loadedImgClass = loadedClass + '--img',

        grabbingClass = _fotoramaClass + '__grabbing',

        imgClass = _fotoramaClass + '__img',
        imgFullClass = imgClass + '--full',

        dotClass = _fotoramaClass + '__dot',
        thumbClass = _fotoramaClass + '__thumb',
        thumbBorderClass = thumbClass + '-border',

        htmlClass = _fotoramaClass + '__html',

        videoClass = _fotoramaClass + '__video',
        videoPlayClass = videoClass + '-play',
        videoCloseClass = videoClass + '-close',

        captionClass = _fotoramaClass + '__caption',
        captionWrapClass = _fotoramaClass + '__caption__wrap',

        spinnerClass = _fotoramaClass + '__spinner',

        buttonAttributes = '" tabindex="0" role="button';
    var JQUERY_VERSION = $ && $.fn.jquery.split('.');

    if (!JQUERY_VERSION
        || JQUERY_VERSION[0] < 1
        || (JQUERY_VERSION[0] == 1 && JQUERY_VERSION[1] < 8)) {
        throw 'Fotorama requires jQuery 1.8 or later and will not run without it.';
    }
    // My Underscore :-)
    var _ = {};
    /* Modernizr 2.6.2 (Custom Build) | MIT & BSD
     * Build: http://modernizr.com/download/#-csstransforms3d-prefixed-teststyles-testprop-testallprops-prefixes-domprefixes
     */

    var Modernizr = (function (window, document, undefined) {

        var version = '2.6.2',

            Modernizr = {},

            docElement = document.documentElement,

            mod = 'modernizr',
            modElem = document.createElement(mod),
            mStyle = modElem.style,

            inputElem,

            toString = {}.toString,

            prefixes = ' -webkit- -moz- -o- -ms- '.split(' '),

            omPrefixes = 'Webkit Moz O ms',

            cssomPrefixes = omPrefixes.split(' '),

            domPrefixes = omPrefixes.toLowerCase().split(' '),

            tests = {},
            inputs = {},
            attrs = {},

            classes = [],

            slice = classes.slice,

            featureName,

            injectElementWithStyles = function (rule, callback, nodes, testnames) {

                var style, ret, node, docOverflow,
                    div = document.createElement('div'),
                    body = document.body,
                    fakeBody = body || document.createElement('body');

                if (parseInt(nodes, 10)) {
                    while (nodes--) {
                        node = document.createElement('div');
                        node.id = testnames ? testnames[nodes] : mod + (nodes + 1);
                        div.appendChild(node);
                    }
                }

                style = ['&#173;', '<style id="s', mod, '">', rule, '</style>'].join('');
                div.id = mod;
                (body ? div : fakeBody).innerHTML += style;
                fakeBody.appendChild(div);
                if (!body) {
                    fakeBody.style.background = '';
                    fakeBody.style.overflow = 'hidden';
                    docOverflow = docElement.style.overflow;
                    docElement.style.overflow = 'hidden';
                    docElement.appendChild(fakeBody);
                }

                ret = callback(div, rule);
                if (!body) {
                    fakeBody.parentNode.removeChild(fakeBody);
                    docElement.style.overflow = docOverflow;
                } else {
                    div.parentNode.removeChild(div);
                }

                return !!ret;

            },
            _hasOwnProperty = ({}).hasOwnProperty, hasOwnProp;

        if (!is(_hasOwnProperty, 'undefined') && !is(_hasOwnProperty.call, 'undefined')) {
            hasOwnProp = function (object, property) {
                return _hasOwnProperty.call(object, property);
            };
        }
        else {
            hasOwnProp = function (object, property) {
                return ((property in object) && is(object.constructor.prototype[property], 'undefined'));
            };
        }


        if (!Function.prototype.bind) {
            Function.prototype.bind = function bind(that) {

                var target = this;

                if (typeof target != "function") {
                    throw new TypeError();
                }

                var args = slice.call(arguments, 1),
                    bound = function () {

                        if (this instanceof bound) {

                            var F = function () {
                            };
                            F.prototype = target.prototype;
                            var self = new F();

                            var result = target.apply(
                                self,
                                args.concat(slice.call(arguments))
                            );
                            if (Object(result) === result) {
                                return result;
                            }
                            return self;

                        } else {

                            return target.apply(
                                that,
                                args.concat(slice.call(arguments))
                            );

                        }

                    };

                return bound;
            };
        }

        function setCss(str) {
            mStyle.cssText = str;
        }

        function setCssAll(str1, str2) {
            return setCss(prefixes.join(str1 + ';') + (str2 || ''));
        }

        function is(obj, type) {
            return typeof obj === type;
        }

        function contains(str, substr) {
            return !!~('' + str).indexOf(substr);
        }

        function testProps(props, prefixed) {
            for (var i in props) {
                var prop = props[i];
                if (!contains(prop, "-") && mStyle[prop] !== undefined) {
                    return prefixed == 'pfx' ? prop : true;
                }
            }
            return false;
        }

        function testDOMProps(props, obj, elem) {
            for (var i in props) {
                var item = obj[props[i]];
                if (item !== undefined) {

                    if (elem === false) return props[i];

                    if (is(item, 'function')) {
                        return item.bind(elem || obj);
                    }

                    return item;
                }
            }
            return false;
        }

        function testPropsAll(prop, prefixed, elem) {

            var ucProp = prop.charAt(0).toUpperCase() + prop.slice(1),
                props = (prop + ' ' + cssomPrefixes.join(ucProp + ' ') + ucProp).split(' ');

            if (is(prefixed, "string") || is(prefixed, "undefined")) {
                return testProps(props, prefixed);

            } else {
                props = (prop + ' ' + (domPrefixes).join(ucProp + ' ') + ucProp).split(' ');
                return testDOMProps(props, prefixed, elem);
            }
        }

        tests['csstransforms3d'] = function () {

            var ret = !!testPropsAll('perspective');

            // Chrome fails that test, ignore
            //		if (ret && 'webkitPerspective' in docElement.style) {
            //
            //			injectElementWithStyles('@media (transform-3d),(-webkit-transform-3d){#modernizr{left:9px;position:absolute;height:3px;}}', function (node, rule) {
            //				ret = node.offsetLeft === 9 && node.offsetHeight === 3;
            //			});
            //		}
            return ret;
        };

        for (var feature in tests) {
            if (hasOwnProp(tests, feature)) {
                featureName = feature.toLowerCase();
                Modernizr[featureName] = tests[feature]();

                classes.push((Modernizr[featureName] ? '' : 'no-') + featureName);
            }
        }

        Modernizr.addTest = function (feature, test) {
            if (typeof feature == 'object') {
                for (var key in feature) {
                    if (hasOwnProp(feature, key)) {
                        Modernizr.addTest(key, feature[key]);
                    }
                }
            } else {

                feature = feature.toLowerCase();

                if (Modernizr[feature] !== undefined) {
                    return Modernizr;
                }

                test = typeof test == 'function' ? test() : test;

                if (typeof enableClasses !== "undefined" && enableClasses) {
                    docElement.className += ' ' + (test ? '' : 'no-') + feature;
                }
                Modernizr[feature] = test;

            }

            return Modernizr;
        };


        setCss('');
        modElem = inputElem = null;


        Modernizr._version = version;

        Modernizr._prefixes = prefixes;
        Modernizr._domPrefixes = domPrefixes;
        Modernizr._cssomPrefixes = cssomPrefixes;

        Modernizr.testProp = function (prop) {
            return testProps([prop]);
        };

        Modernizr.testAllProps = testPropsAll;

        Modernizr.testStyles = injectElementWithStyles;
        Modernizr.prefixed = function (prop, obj, elem) {
            if (!obj) {
                return testPropsAll(prop, 'pfx');
            } else {
                return testPropsAll(prop, obj, elem);
            }
        };

        return Modernizr;
    })(window, document);
    var fullScreenApi = {
        ok: false,
        is: function () {
            return false;
        },
        request: function () {
        },
        cancel: function () {
        },
        event: '',
        prefix: ''
    },
        browserPrefixes = 'webkit moz o ms khtml'.split(' ');

    // check for native support
    if (typeof document.cancelFullScreen != 'undefined') {
        fullScreenApi.ok = true;
    } else {
        // check for fullscreen support by vendor prefix
        for (var i = 0, il = browserPrefixes.length; i < il; i++) {
            fullScreenApi.prefix = browserPrefixes[i];
            if (typeof document[fullScreenApi.prefix + 'CancelFullScreen'] != 'undefined') {
                fullScreenApi.ok = true;
                break;
            }
        }
    }

    // update methods to do something useful
    if (fullScreenApi.ok) {
        fullScreenApi.event = fullScreenApi.prefix + 'fullscreenchange';
        fullScreenApi.is = function () {
            switch (this.prefix) {
                case '':
                    return document.fullScreen;
                case 'webkit':
                    return document.webkitIsFullScreen;
                default:
                    return document[this.prefix + 'FullScreen'];
            }
        };
        fullScreenApi.request = function (el) {
            return (this.prefix === '') ? el.requestFullScreen() : el[this.prefix + 'RequestFullScreen']();
        };
        fullScreenApi.cancel = function (el) {
            return (this.prefix === '') ? document.cancelFullScreen() : document[this.prefix + 'CancelFullScreen']();
        };
    }
    //fgnass.github.com/spin.js#v1.3.2

    /**
     * Copyright (c) 2011-2013 Felix Gnass
     * Licensed under the MIT license
     */

    var Spinner,
        spinnerDefaults = {
            lines: 12, // The number of lines to draw
            length: 5, // The length of each line
            width: 2, // The line thickness
            radius: 7, // The radius of the inner circle
            corners: 1, // Corner roundness (0..1)
            rotate: 15, // The rotation offset
            color: 'rgba(128, 128, 128, .75)',
            hwaccel: true
        },
        spinnerOverride = {
            top: 'auto',
            left: 'auto',
            className: ''
        };

    (function (root, factory) {

        /* CommonJS */
        //if (typeof exports == 'object')  module.exports = factory()

        /* AMD module */
        //else if (typeof define == 'function' && define.amd) define(factory)

        /* Browser global */
        //else root.Spinner = factory()

        Spinner = factory();
    }
    (this, function () {
        "use strict";

        var prefixes = ['webkit', 'Moz', 'ms', 'O'] /* Vendor prefixes */
          , animations = {} /* Animation rules keyed by their name */
          , useCssAnimations /* Whether to use CSS animations or setTimeout */

        /**
         * Utility function to create elements. If no tag name is given,
         * a DIV is created. Optionally properties can be passed.
         */
        function createEl(tag, prop) {
            var el = document.createElement(tag || 'div')
              , n

            for (n in prop) el[n] = prop[n]
            return el
        }

        /**
         * Appends children and returns the parent.
         */
        function ins(parent /* child1, child2, ...*/) {
            for (var i = 1, n = arguments.length; i < n; i++)
                parent.appendChild(arguments[i])

            return parent
        }

        /**
         * Insert a new stylesheet to hold the @keyframe or VML rules.
         */
        var sheet = (function () {
            var el = createEl('style', { type: 'text/css' })
            ins(document.getElementsByTagName('head')[0], el)
            return el.sheet || el.styleSheet
        }())

        /**
         * Creates an opacity keyframe animation rule and returns its name.
         * Since most mobile Webkits have timing issues with animation-delay,
         * we create separate rules for each line/segment.
         */
        function addAnimation(alpha, trail, i, lines) {
            var name = ['opacity', trail, ~~(alpha * 100), i, lines].join('-')
              , start = 0.01 + i / lines * 100
              , z = Math.max(1 - (1 - alpha) / trail * (100 - start), alpha)
              , prefix = useCssAnimations.substring(0, useCssAnimations.indexOf('Animation')).toLowerCase()
              , pre = prefix && '-' + prefix + '-' || ''

            if (!animations[name]) {
                sheet.insertRule(
                  '@' + pre + 'keyframes ' + name + '{' +
                  '0%{opacity:' + z + '}' +
                  start + '%{opacity:' + alpha + '}' +
                  (start + 0.01) + '%{opacity:1}' +
                  (start + trail) % 100 + '%{opacity:' + alpha + '}' +
                  '100%{opacity:' + z + '}' +
                  '}', sheet.cssRules.length)

                animations[name] = 1
            }

            return name
        }

        /**
         * Tries various vendor prefixes and returns the first supported property.
         */
        function vendor(el, prop) {
            var s = el.style
              , pp
              , i

            prop = prop.charAt(0).toUpperCase() + prop.slice(1)
            for (i = 0; i < prefixes.length; i++) {
                pp = prefixes[i] + prop
                if (s[pp] !== undefined) return pp
            }
            if (s[prop] !== undefined) return prop
        }

        /**
         * Sets multiple style properties at once.
         */
        function css(el, prop) {
            for (var n in prop)
                el.style[vendor(el, n) || n] = prop[n]

            return el
        }

        /**
         * Fills in default values.
         */
        function merge(obj) {
            for (var i = 1; i < arguments.length; i++) {
                var def = arguments[i]
                for (var n in def)
                    if (obj[n] === undefined) obj[n] = def[n]
            }
            return obj
        }

        /**
         * Returns the absolute page-offset of the given element.
         */
        function pos(el) {
            var o = { x: el.offsetLeft, y: el.offsetTop }
            while ((el = el.offsetParent))
                o.x += el.offsetLeft, o.y += el.offsetTop

            return o
        }

        /**
         * Returns the line color from the given string or array.
         */
        function getColor(color, idx) {
            return typeof color == 'string' ? color : color[idx % color.length]
        }

        // Built-in defaults

        var defaults = {
            lines: 12,            // The number of lines to draw
            length: 7,            // The length of each line
            width: 5,             // The line thickness
            radius: 10,           // The radius of the inner circle
            rotate: 0,            // Rotation offset
            corners: 1,           // Roundness (0..1)
            color: '#000',        // #rgb or #rrggbb
            direction: 1,         // 1: clockwise, -1: counterclockwise
            speed: 1,             // Rounds per second
            trail: 100,           // Afterglow percentage
            opacity: 1 / 4,         // Opacity of the lines
            fps: 20,              // Frames per second when using setTimeout()
            zIndex: 2e9,          // Use a high z-index by default
            className: 'spinner', // CSS class to assign to the element
            top: 'auto',          // center vertically
            left: 'auto',         // center horizontally
            position: 'relative'  // element position
        }

        /** The constructor */
        function Spinner(o) {
            if (typeof this == 'undefined') return new Spinner(o)
            this.opts = merge(o || {}, Spinner.defaults, defaults)
        }

        // Global defaults that override the built-ins:
        Spinner.defaults = {}

        merge(Spinner.prototype, {

            /**
             * Adds the spinner to the given target element. If this instance is already
             * spinning, it is automatically removed from its previous target b calling
             * stop() internally.
             */
            spin: function (target) {
                this.stop()

                var self = this
                  , o = self.opts
                  , el = self.el = css(createEl(0, { className: o.className }), { position: o.position, width: 0, zIndex: o.zIndex })
                  , mid = o.radius + o.length + o.width
                  , ep // element position
                  , tp // target position

                if (target) {
                    target.insertBefore(el, target.firstChild || null)
                    tp = pos(target)
                    ep = pos(el)
                    css(el, {
                        left: (o.left == 'auto' ? tp.x - ep.x + (target.offsetWidth >> 1) : parseInt(o.left, 10) + mid) + 'px',
                        top: (o.top == 'auto' ? tp.y - ep.y + (target.offsetHeight >> 1) : parseInt(o.top, 10) + mid) + 'px'
                    })
                }

                el.setAttribute('role', 'progressbar')
                self.lines(el, self.opts)

                if (!useCssAnimations) {
                    // No CSS animation support, use setTimeout() instead
                    var i = 0
                      , start = (o.lines - 1) * (1 - o.direction) / 2
                      , alpha
                      , fps = o.fps
                      , f = fps / o.speed
                      , ostep = (1 - o.opacity) / (f * o.trail / 100)
                      , astep = f / o.lines

                    ; (function anim() {
                        i++;
                        for (var j = 0; j < o.lines; j++) {
                            alpha = Math.max(1 - (i + (o.lines - j) * astep) % f * ostep, o.opacity)

                            self.opacity(el, j * o.direction + start, alpha, o)
                        }
                        self.timeout = self.el && setTimeout(anim, ~~(1000 / fps))
                    })()
                }
                return self
            },

            /**
             * Stops and removes the Spinner.
             */
            stop: function () {
                var el = this.el
                if (el) {
                    clearTimeout(this.timeout)
                    if (el.parentNode) el.parentNode.removeChild(el)
                    this.el = undefined
                }
                return this
            },

            /**
             * Internal method that draws the individual lines. Will be overwritten
             * in VML fallback mode below.
             */
            lines: function (el, o) {
                var i = 0
                  , start = (o.lines - 1) * (1 - o.direction) / 2
                  , seg

                function fill(color, shadow) {
                    return css(createEl(), {
                        position: 'absolute',
                        width: (o.length + o.width) + 'px',
                        height: o.width + 'px',
                        background: color,
                        boxShadow: shadow,
                        transformOrigin: 'left',
                        transform: 'rotate(' + ~~(360 / o.lines * i + o.rotate) + 'deg) translate(' + o.radius + 'px' + ',0)',
                        borderRadius: (o.corners * o.width >> 1) + 'px'
                    })
                }

                for (; i < o.lines; i++) {
                    seg = css(createEl(), {
                        position: 'absolute',
                        top: 1 + ~(o.width / 2) + 'px',
                        transform: o.hwaccel ? 'translate3d(0,0,0)' : '',
                        opacity: o.opacity,
                        animation: useCssAnimations && addAnimation(o.opacity, o.trail, start + i * o.direction, o.lines) + ' ' + 1 / o.speed + 's linear infinite'
                    })

                    if (o.shadow) ins(seg, css(fill('#000', '0 0 4px ' + '#000'), { top: 2 + 'px' }))
                    ins(el, ins(seg, fill(getColor(o.color, i), '0 0 1px rgba(0,0,0,.1)')))
                }
                return el
            },

            /**
             * Internal method that adjusts the opacity of a single line.
             * Will be overwritten in VML fallback mode below.
             */
            opacity: function (el, i, val) {
                if (i < el.childNodes.length) el.childNodes[i].style.opacity = val
            }

        })


        function initVML() {

            /* Utility function to create a VML tag */
            function vml(tag, attr) {
                return createEl('<' + tag + ' xmlns="urn:schemas-microsoft.com:vml" class="spin-vml">', attr)
            }

            // No CSS transforms but VML support, add a CSS rule for VML elements:
            sheet.addRule('.spin-vml', 'behavior:url(#default#VML)')

            Spinner.prototype.lines = function (el, o) {
                var r = o.length + o.width
                  , s = 2 * r

                function grp() {
                    return css(
                      vml('group', {
                          coordsize: s + ' ' + s,
                          coordorigin: -r + ' ' + -r
                      }),
                      { width: s, height: s }
                    )
                }

                var margin = -(o.width + o.length) * 2 + 'px'
                  , g = css(grp(), { position: 'absolute', top: margin, left: margin })
                  , i

                function seg(i, dx, filter) {
                    ins(g,
                      ins(css(grp(), { rotation: 360 / o.lines * i + 'deg', left: ~~dx }),
                        ins(css(vml('roundrect', { arcsize: o.corners }), {
                            width: r,
                            height: o.width,
                            left: o.radius,
                            top: -o.width >> 1,
                            filter: filter
                        }),
                          vml('fill', { color: getColor(o.color, i), opacity: o.opacity }),
                          vml('stroke', { opacity: 0 }) // transparent stroke to fix color bleeding upon opacity change
                        )
                      )
                    )
                }

                if (o.shadow)
                    for (i = 1; i <= o.lines; i++)
                        seg(i, -2, 'progid:DXImageTransform.Microsoft.Blur(pixelradius=2,makeshadow=1,shadowopacity=.3)')

                for (i = 1; i <= o.lines; i++) seg(i)
                return ins(el, g)
            }

            Spinner.prototype.opacity = function (el, i, val, o) {
                var c = el.firstChild
                o = o.shadow && o.lines || 0
                if (c && i + o < c.childNodes.length) {
                    c = c.childNodes[i + o]; c = c && c.firstChild; c = c && c.firstChild
                    if (c) c.opacity = val
                }
            }
        }

        var probe = css(createEl('group'), { behavior: 'url(#default#VML)' })

        if (!vendor(probe, 'transform') && probe.adj) initVML()
        else useCssAnimations = vendor(probe, 'animation')

        return Spinner

    }));

    /* Bez v1.0.10-g5ae0136
     * http://github.com/rdallasgray/bez
     *
     * A plugin to convert CSS3 cubic-bezier co-ordinates to jQuery-compatible easing functions
     *
     * With thanks to Nikolay Nemshilov for clarification on the cubic-bezier maths
     * See http://st-on-it.blogspot.com/2011/05/calculating-cubic-bezier-function.html
     *
     * Copyright 2011 Robert Dallas Gray. All rights reserved.
     * Provided under the FreeBSD license: https://github.com/rdallasgray/bez/blob/master/LICENSE.txt
     */
    function bez(coOrdArray) {
        var encodedFuncName = "bez_" + $.makeArray(arguments).join("_").replace(".", "p");
        if (typeof $['easing'][encodedFuncName] !== "function") {
            var polyBez = function (p1, p2) {
                var A = [null, null],
                    B = [null, null],
                    C = [null, null],
                    bezCoOrd = function (t, ax) {
                        C[ax] = 3 * p1[ax];
                        B[ax] = 3 * (p2[ax] - p1[ax]) - C[ax];
                        A[ax] = 1 - C[ax] - B[ax];
                        return t * (C[ax] + t * (B[ax] + t * A[ax]));
                    },
                    xDeriv = function (t) {
                        return C[0] + t * (2 * B[0] + 3 * A[0] * t);
                    },
                    xForT = function (t) {
                        var x = t, i = 0, z;
                        while (++i < 14) {
                            z = bezCoOrd(x, 0) - t;
                            if (Math.abs(z) < 1e-3) break;
                            x -= z / xDeriv(x);
                        }
                        return x;
                    };
                return function (t) {
                    return bezCoOrd(xForT(t), 1);
                }
            };
            $['easing'][encodedFuncName] = function (x, t, b, c, d) {
                return c * polyBez([coOrdArray[0], coOrdArray[1]], [coOrdArray[2], coOrdArray[3]])(t / d) + b;
            }
        }
        return encodedFuncName;
    }
    var $WINDOW = $(window),
        $DOCUMENT = $(document),
        $HTML,
        $BODY,

        QUIRKS_FORCE = location.hash.replace('#', '') === 'quirks',
        TRANSFORMS3D = Modernizr.csstransforms3d,
        CSS3 = TRANSFORMS3D && !QUIRKS_FORCE,
        COMPAT = TRANSFORMS3D || document.compatMode === 'CSS1Compat',
        FULLSCREEN = fullScreenApi.ok,

        MOBILE = navigator.userAgent.match(/Android|webOS|iPhone|iPad|iPod|BlackBerry|Windows Phone/i),
        SLOW = !CSS3 || MOBILE,

        MS_POINTER = navigator.msPointerEnabled,

        WHEEL = "onwheel" in document.createElement("div") ? "wheel" : document.onmousewheel !== undefined ? "mousewheel" : "DOMMouseScroll",

        TOUCH_TIMEOUT = 250,
        TRANSITION_DURATION = 300,

        SCROLL_LOCK_TIMEOUT = 1400,

        AUTOPLAY_INTERVAL = 5000,
        MARGIN = 2,
        THUMB_SIZE = 64,

        WIDTH = 500,
        HEIGHT = 333,

        STAGE_FRAME_KEY = '$stageFrame',
        NAV_DOT_FRAME_KEY = '$navDotFrame',
        NAV_THUMB_FRAME_KEY = '$navThumbFrame',

        AUTO = 'auto',

        BEZIER = bez([.1, 0, .25, 1]),

        MAX_WIDTH = 99999,

        FIFTYFIFTY = '50%',

        OPTIONS = {
            // dimensions
            width: null, // 500 || '100%'
            minwidth: null,
            maxwidth: '100%', // '100%'
            height: null,
            minheight: null,
            maxheight: null,

            ratio: null, // '16/9' || 500/333 || 1.5

            margin: MARGIN,
            glimpse: 0,

            fit: 'contain', // 'cover' || 'scaledown' || 'none'

            position: FIFTYFIFTY,
            thumbposition: FIFTYFIFTY,

            // navigation, thumbs
            nav: 'dots', // 'thumbs' || false
            navposition: 'bottom', // 'top'
            navwidth: null,
            thumbwidth: THUMB_SIZE,
            thumbheight: THUMB_SIZE,
            thumbmargin: MARGIN,
            thumbborderwidth: MARGIN,
            thumbfit: 'cover', // 'contain' || 'scaledown' || 'none'

            allowfullscreen: false, // true || 'native'

            transition: 'slide', // 'crossfade' || 'dissolve'
            clicktransition: null,
            transitionduration: TRANSITION_DURATION,

            captions: true,

            hash: false,
            startindex: 0,

            loop: false,

            autoplay: false,
            stopautoplayontouch: true,

            keyboard: false,

            arrows: true,
            click: true,
            swipe: true,
            trackpad: false,

            enableifsingleframe: false,

            controlsonstart: true,

            shuffle: false,

            direction: 'ltr', // 'rtl'

            shadows: true,
            spinner: null
        },

        KEYBOARD_OPTIONS = {
            left: true,
            right: true,
            down: false,
            up: false,
            space: false,
            home: false,
            end: false
        };
    function noop() { }

    function minMaxLimit(value, min, max) {
        return Math.max(isNaN(min) ? -Infinity : min, Math.min(isNaN(max) ? Infinity : max, value));
    }

    function readTransform(css) {
        return css.match(/ma/) && css.match(/-?\d+(?!d)/g)[css.match(/3d/) ? 12 : 4];
    }

    function readPosition($el) {
        if (CSS3) {
            return +readTransform($el.css('transform'));
        } else {
            return +$el.css('left').replace('px', '');
        }
    }

    function getTranslate(pos/*, _001*/) {
        var obj = {};
        if (CSS3) {
            obj.transform = 'translate3d(' + (pos/* + (_001 ? 0.001 : 0)*/) + 'px,0,0)'; // 0.001 to remove Retina artifacts
        } else {
            obj.left = pos;
        }
        return obj;
    }

    function getDuration(time) {
        return { 'transition-duration': time + 'ms' };
    }

    function unlessNaN(value, alternative) {
        return isNaN(value) ? alternative : value;
    }

    function numberFromMeasure(value, measure) {
        return unlessNaN(+String(value).replace(measure || 'px', ''));
    }

    function numberFromPercent(value) {
        return /%$/.test(value) ? numberFromMeasure(value, '%') : undefined;
    }

    function numberFromWhatever(value, whole) {
        return unlessNaN(numberFromPercent(value) / 100 * whole, numberFromMeasure(value));
    }

    function measureIsValid(value) {
        return (!isNaN(numberFromMeasure(value)) || !isNaN(numberFromMeasure(value, '%'))) && value;
    }

    function getPosByIndex(index, side, margin, baseIndex) {
        //console.log('getPosByIndex', index, side, margin, baseIndex);
        //console.log((index - (baseIndex || 0)) * (side + (margin || 0)));

        return (index - (baseIndex || 0)) * (side + (margin || 0));
    }

    function getIndexByPos(pos, side, margin, baseIndex) {
        return -Math.round(pos / (side + (margin || 0)) - (baseIndex || 0));
    }

    function bindTransitionEnd($el) {
        var elData = $el.data();

        if (elData.tEnd) return;

        var el = $el[0],
            transitionEndEvent = {
                WebkitTransition: 'webkitTransitionEnd',
                MozTransition: 'transitionend',
                OTransition: 'oTransitionEnd otransitionend',
                msTransition: 'MSTransitionEnd',
                transition: 'transitionend'
            };
        addEvent(el, transitionEndEvent[Modernizr.prefixed('transition')], function (e) {
            elData.tProp && e.propertyName.match(elData.tProp) && elData.onEndFn();
        });
        elData.tEnd = true;
    }

    function afterTransition($el, property, fn, time) {
        var ok,
            elData = $el.data();

        if (elData) {
            elData.onEndFn = function () {
                if (ok) return;
                ok = true;
                clearTimeout(elData.tT);
                fn();
            };
            elData.tProp = property;

            // Passive call, just in case of fail of native transition-end event
            clearTimeout(elData.tT);
            elData.tT = setTimeout(function () {
                elData.onEndFn();
            }, time * 1.5);

            bindTransitionEnd($el);
        }
    }


    function stop($el, left/*, _001*/) {
        if ($el.length) {
            var elData = $el.data();
            if (CSS3) {
                $el.css(getDuration(0));
                elData.onEndFn = noop;
                clearTimeout(elData.tT);
            } else {
                $el.stop();
            }
            var lockedLeft = getNumber(left, function () {
                return readPosition($el);
            });

            $el.css(getTranslate(lockedLeft/*, _001*/));//.width(); // `.width()` for reflow
            return lockedLeft;
        }
    }

    function getNumber() {
        var number;
        for (var _i = 0, _l = arguments.length; _i < _l; _i++) {
            number = _i ? arguments[_i]() : arguments[_i];
            if (typeof number === 'number') {
                break;
            }
        }

        return number;
    }

    function edgeResistance(pos, edge) {
        return Math.round(pos + ((edge - pos) / 1.5));
    }

    function getProtocol() {
        getProtocol.p = getProtocol.p || (location.protocol === 'https:' ? 'https://' : 'http://');
        return getProtocol.p;
    }

    function parseHref(href) {
        var a = document.createElement('a');
        a.href = href;
        return a;
    }

    function findVideoId(href, forceVideo) {
        if (typeof href !== 'string') return href;
        href = parseHref(href);

        var id,
            type;

        if (href.host.match(/youtube\.com/) && href.search) {
            //.log();
            id = href.search.split('v=')[1];
            if (id) {
                var ampersandPosition = id.indexOf('&');
                if (ampersandPosition !== -1) {
                    id = id.substring(0, ampersandPosition);
                }
                type = 'youtube';
            }
        } else if (href.host.match(/youtube\.com|youtu\.be/)) {
            id = href.pathname.replace(/^\/(embed\/|v\/)?/, '').replace(/\/.*/, '');
            type = 'youtube';
        } else if (href.host.match(/vimeo\.com/)) {
            type = 'vimeo';
            id = href.pathname.replace(/^\/(video\/)?/, '').replace(/\/.*/, '');
        }

        if ((!id || !type) && forceVideo) {
            id = href.href;
            type = 'custom';
        }

        return id ? { id: id, type: type, s: href.search.replace(/^\?/, ''), p: getProtocol() } : false;
    }

    function getVideoThumbs(dataFrame, data, fotorama) {
        var img, thumb, video = dataFrame.video;
        if (video.type === 'youtube') {
            thumb = getProtocol() + 'img.youtube.com/vi/' + video.id + '/default.jpg';
            img = thumb.replace(/\/default.jpg$/, '/hqdefault.jpg');
            dataFrame.thumbsReady = true;
        } else if (video.type === 'vimeo') {
            $.ajax({
                url: getProtocol() + 'vimeo.com/api/v2/video/' + video.id + '.json',
                dataType: 'jsonp',
                success: function (json) {
                    dataFrame.thumbsReady = true;
                    updateData(data, { img: json[0].thumbnail_large, thumb: json[0].thumbnail_small }, dataFrame.i, fotorama);
                }
            });
        } else {
            dataFrame.thumbsReady = true;
        }

        return {
            img: img,
            thumb: thumb
        }
    }

    function updateData(data, _dataFrame, i, fotorama) {
        for (var _i = 0, _l = data.length; _i < _l; _i++) {
            var dataFrame = data[_i];

            if (dataFrame.i === i && dataFrame.thumbsReady) {
                var clear = { videoReady: true };
                clear[STAGE_FRAME_KEY] = clear[NAV_THUMB_FRAME_KEY] = clear[NAV_DOT_FRAME_KEY] = false;

                fotorama.splice(_i, 1, $.extend(
                    {},
                    dataFrame,
                    clear,
                    _dataFrame
                ));

                break;
            }
        }
    }

    function getDataFromHtml($el) {
        var data = [];

        function getDataFromImg($img, imgData, checkVideo) {
            var $child = $img.children('img').eq(0),
                _imgHref = $img.attr('href'),
                _imgSrc = $img.attr('src'),
                _thumbSrc = $child.attr('src'),
                _video = imgData.video,
                video = checkVideo ? findVideoId(_imgHref, _video === true) : false;

            if (video) {
                _imgHref = false;
            } else {
                video = _video;
            }

            getDimensions($img, $child, $.extend(imgData, {
                video: video,
                img: imgData.img || _imgHref || _imgSrc || _thumbSrc,
                thumb: imgData.thumb || _thumbSrc || _imgSrc || _imgHref
            }));
        }

        function getDimensions($img, $child, imgData) {
            var separateThumbFLAG = imgData.thumb && imgData.img !== imgData.thumb,
                width = numberFromMeasure(imgData.width || $img.attr('width')),
                height = numberFromMeasure(imgData.height || $img.attr('height'));

            $.extend(imgData, {
                width: width,
                height: height,
                thumbratio: getRatio(imgData.thumbratio || (numberFromMeasure(imgData.thumbwidth || ($child && $child.attr('width')) || separateThumbFLAG || width) / numberFromMeasure(imgData.thumbheight || ($child && $child.attr('height')) || separateThumbFLAG || height)))
            });
        }

        $el.children().each(function () {
            var $this = $(this),
                dataFrame = optionsToLowerCase($.extend($this.data(), { id: $this.attr('id') }));
            if ($this.is('a, img')) {
                getDataFromImg($this, dataFrame, true);
            } else if (!$this.is(':empty')) {
                getDimensions($this, null, $.extend(dataFrame, {
                    html: this,
                    _html: $this.html() // Because of IE
                }));
            } else return;

            data.push(dataFrame);
        });

        return data;
    }

    function isHidden(el) {
        return el.offsetWidth === 0 && el.offsetHeight === 0;
    }

    function isDetached(el) {
        return !$.contains(document.documentElement, el);
    }

    function waitFor(test, fn, timeout, i) {
        if (!waitFor.i) {
            waitFor.i = 1;
            waitFor.ii = [true];
        }

        i = i || waitFor.i;

        if (typeof waitFor.ii[i] === 'undefined') {
            waitFor.ii[i] = true;
        }

        if (test()) {
            fn();
        } else {
            waitFor.ii[i] && setTimeout(function () {
                waitFor.ii[i] && waitFor(test, fn, timeout, i);
            }, timeout || 100);
        }

        return waitFor.i++;
    }

    waitFor.stop = function (i) {
        waitFor.ii[i] = false;
    };

    function setHash(hash) {
        ////console.time('setHash ' + hash);
        location.replace(location.protocol
            + '//'
            + location.host
            + location.pathname.replace(/^\/?/, '/')
            + location.search
            + '#' + hash);
        ////console.timeEnd('setHash ' + hash);
    }

    function fit($el, measuresToFit, method, position) {
        var elData = $el.data(),
            measures = elData.measures;

        if (measures && (!elData.l ||
            elData.l.W !== measures.width ||
            elData.l.H !== measures.height ||
            elData.l.r !== measures.ratio ||
            elData.l.w !== measuresToFit.w ||
            elData.l.h !== measuresToFit.h ||
            elData.l.m !== method ||
            elData.l.p !== position)) {

            //console.log('fit');

            var width = measures.width,
                height = measures.height,
                ratio = measuresToFit.w / measuresToFit.h,
                biggerRatioFLAG = measures.ratio >= ratio,
                fitFLAG = method === 'scaledown',
                containFLAG = method === 'contain',
                coverFLAG = method === 'cover',
                pos = parsePosition(position);

            if (biggerRatioFLAG && (fitFLAG || containFLAG) || !biggerRatioFLAG && coverFLAG) {
                width = minMaxLimit(measuresToFit.w, 0, fitFLAG ? width : Infinity);
                height = width / measures.ratio;
            } else if (biggerRatioFLAG && coverFLAG || !biggerRatioFLAG && (fitFLAG || containFLAG)) {
                height = minMaxLimit(measuresToFit.h, 0, fitFLAG ? height : Infinity);
                width = height * measures.ratio;
            }

            $el.css({
                width: width,
                height: height,
                left: numberFromWhatever(pos.x, measuresToFit.w - width),
                top: numberFromWhatever(pos.y, measuresToFit.h - height)
            });

            elData.l = {
                W: measures.width,
                H: measures.height,
                r: measures.ratio,
                w: measuresToFit.w,
                h: measuresToFit.h,
                m: method,
                p: position
            };
        }

        return true;
    }

    function setStyle($el, style) {
        var el = $el[0];
        if (el.styleSheet) {
            el.styleSheet.cssText = style;
        } else {
            $el.html(style);
        }
    }

    function findShadowEdge(pos, min, max) {
        return min === max ? false : pos <= min ? 'left' : pos >= max ? 'right' : 'left right';
    }

    function getIndexFromHash(hash, data, ok, startindex) {
        if (!ok) return false;
        if (!isNaN(hash)) return hash - (startindex ? 0 : 1);

        var index;

        for (var _i = 0, _l = data.length; _i < _l; _i++) {
            var dataFrame = data[_i];

            if (dataFrame.id === hash) {
                index = _i;
                break;
            }
        }

        return index;
    }

    function smartClick($el, fn, _options) {
        _options = _options || {};

        $el.each(function () {
            var $this = $(this),
                thisData = $this.data(),
                startEvent;

            if (thisData.clickOn) return;

            thisData.clickOn = true;

            $.extend(touch($this, {
                onStart: function (e) {
                    startEvent = e;
                    (_options.onStart || noop).call(this, e);
                },
                onMove: _options.onMove || noop,
                onTouchEnd: _options.onTouchEnd || noop,
                onEnd: function (result) {
                    //console.log('smartClick → result.moved', result.moved);
                    if (result.moved) return;
                    fn.call(this, startEvent);
                }
            }), { noMove: true });
        });
    }

    function div(classes, child) {
        return '<div class="' + classes + '">' + (child || '') + '</div>';
    }

    // Fisher–Yates Shuffle
    // http://bost.ocks.org/mike/shuffle/
    function shuffle(array) {
        // While there remain elements to shuffle
        var l = array.length;
        while (l) {
            // Pick a remaining element
            var i = Math.floor(Math.random() * l--);

            // And swap it with the current element
            var t = array[l];
            array[l] = array[i];
            array[i] = t;
        }

        return array;
    }

    function clone(array) {
        return Object.prototype.toString.call(array) == '[object Array]'
            && $.map(array, function (frame) {
                return $.extend({}, frame);
            });
    }

    function lockScroll($el, left, top) {
        $el
          .scrollLeft(left || 0)
          .scrollTop(top || 0);
    }

    function optionsToLowerCase(options) {
        if (options) {
            var opts = {};
            $.each(options, function (key, value) {
                opts[key.toLowerCase()] = value;
            });

            return opts;
        }
    }

    function getRatio(_ratio) {
        if (!_ratio) return;
        var ratio = +_ratio;
        if (!isNaN(ratio)) {
            return ratio;
        } else {
            ratio = _ratio.split('/');
            return +ratio[0] / +ratio[1] || undefined;
        }
    }

    function addEvent(el, e, fn, bool) {
        if (!e) return;
        el.addEventListener ? el.addEventListener(e, fn, !!bool) : el.attachEvent('on' + e, fn);
    }

    function elIsDisabled(el) {
        return !!el.getAttribute('disabled');
    }

    function disableAttr(FLAG) {
        return { tabindex: FLAG * -1 + '', disabled: FLAG };
    }

    function addEnterUp(el, fn) {
        addEvent(el, 'keyup', function (e) {
            elIsDisabled(el) || e.keyCode == 13 && fn.call(el, e);
        });
    }

    function addFocus(el, fn) {
        addEvent(el, 'focus', el.onfocusin = function (e) {
            fn.call(el, e);
        }, true);
    }

    function stopEvent(e, stopPropagation) {
        e.preventDefault ? e.preventDefault() : (e.returnValue = false);
        stopPropagation && e.stopPropagation && e.stopPropagation();
    }

    function getDirectionSign(forward) {
        return forward ? '>' : '<';
    }

    function parsePosition(rule) {
        rule = (rule + '').split(/\s+/);
        return {
            x: measureIsValid(rule[0]) || FIFTYFIFTY,
            y: measureIsValid(rule[1]) || FIFTYFIFTY
        }
    }
    function slide($el, options) {
        var elData = $el.data(),
            elPos = Math.round(options.pos),
            onEndFn = function () {
                elData.sliding = false;
                (options.onEnd || noop)();
            };

        if (typeof options.overPos !== 'undefined' && options.overPos !== options.pos) {
            elPos = options.overPos;
            onEndFn = function () {
                slide($el, $.extend({}, options, { overPos: options.pos, time: Math.max(TRANSITION_DURATION, options.time / 2) }))
            };
        }

        //////console.time('var translate = $.extend');
        var translate = $.extend(getTranslate(elPos/*, options._001*/), options.width && { width: options.width });
        //////console.timeEnd('var translate = $.extend');

        elData.sliding = true;

        if (CSS3) {
            $el.css($.extend(getDuration(options.time), translate));
            if (options.time > 10) {
                //////console.time('afterTransition');
                afterTransition($el, 'transform', onEndFn, options.time);
                //////console.timeEnd('afterTransition');
            } else {
                onEndFn();
            }
        } else {
            $el.stop().animate(translate, options.time, BEZIER, onEndFn);
        }
    }

    function fade($el1, $el2, $frames, options, fadeStack, chain) {
        var chainedFLAG = typeof chain !== 'undefined';
        if (!chainedFLAG) {
            fadeStack.push(arguments);
            Array.prototype.push.call(arguments, fadeStack.length);
            if (fadeStack.length > 1) return;
        }

        $el1 = $el1 || $($el1);
        $el2 = $el2 || $($el2);

        var _$el1 = $el1[0],
            _$el2 = $el2[0],
            crossfadeFLAG = options.method === 'crossfade',
            onEndFn = function () {
                if (!onEndFn.done) {
                    onEndFn.done = true;
                    var args = (chainedFLAG || fadeStack.shift()) && fadeStack.shift();
                    args && fade.apply(this, args);
                    (options.onEnd || noop)(!!args);
                }
            },
            time = options.time / (chain || 1);

        $frames.removeClass(fadeRearClass + ' ' + fadeFrontClass);

        $el1
            .stop()
            .addClass(fadeRearClass);
        $el2
            .stop()
            .addClass(fadeFrontClass);

        crossfadeFLAG && _$el2 && $el1.fadeTo(0, 0);

        $el1.fadeTo(crossfadeFLAG ? time : 0, 1, crossfadeFLAG && onEndFn);
        $el2.fadeTo(time, 0, onEndFn);

        (_$el1 && crossfadeFLAG) || _$el2 || onEndFn();
    }
    var lastEvent,
        moveEventType,
        preventEvent,
        preventEventTimeout;

    function extendEvent(e) {
        var touch = (e.touches || [])[0] || e;
        e._x = touch.pageX;
        e._y = touch.clientY;
        e._now = $.now();
    }

    function touch($el, options) {
        var el = $el[0],
            tail = {},
            touchEnabledFLAG,
            startEvent,
            $target,
            controlTouch,
            touchFLAG,
            targetIsSelectFLAG,
            targetIsLinkFlag,
            tolerance,
            moved;

        function onStart(e) {
            $target = $(e.target);
            tail.checked = targetIsSelectFLAG = targetIsLinkFlag = moved = false;

            if (touchEnabledFLAG
                || tail.flow
                || (e.touches && e.touches.length > 1)
                || e.which > 1
                || (lastEvent && lastEvent.type !== e.type && preventEvent)
                || (targetIsSelectFLAG = options.select && $target.is(options.select, el))) return targetIsSelectFLAG;

            touchFLAG = e.type === 'touchstart';
            targetIsLinkFlag = $target.is('a, a *', el);
            controlTouch = tail.control;

            tolerance = (tail.noMove || tail.noSwipe || controlTouch) ? 16 : !tail.snap ? 4 : 0;

            extendEvent(e);

            startEvent = lastEvent = e;
            moveEventType = e.type.replace(/down|start/, 'move').replace(/Down/, 'Move');

            (options.onStart || noop).call(el, e, { control: controlTouch, $target: $target });

            touchEnabledFLAG = tail.flow = true;

            if (!touchFLAG || tail.go) stopEvent(e);
        }

        function onMove(e) {
            if ((e.touches && e.touches.length > 1)
                || (MS_POINTER && !e.isPrimary)
                || moveEventType !== e.type
                || !touchEnabledFLAG) {
                touchEnabledFLAG && onEnd();
                (options.onTouchEnd || noop)();
                return;
            }

            extendEvent(e);

            var xDiff = Math.abs(e._x - startEvent._x), // opt _x → _pageX
                yDiff = Math.abs(e._y - startEvent._y),
                xyDiff = xDiff - yDiff,
                xWin = (tail.go || tail.x || xyDiff >= 0) && !tail.noSwipe,
                yWin = xyDiff < 0;

            if (touchFLAG && !tail.checked) {
                if (touchEnabledFLAG = xWin) {
                    stopEvent(e);
                }
            } else {
                //console.log('onMove e.preventDefault');
                stopEvent(e);
                (options.onMove || noop).call(el, e, { touch: touchFLAG });
            }

            if (!moved && Math.sqrt(Math.pow(xDiff, 2) + Math.pow(yDiff, 2)) > tolerance) {
                moved = true;
            }

            tail.checked = tail.checked || xWin || yWin;
        }

        function onEnd(e) {
            ////console.time('touch.js onEnd');

            (options.onTouchEnd || noop)();

            var _touchEnabledFLAG = touchEnabledFLAG;
            tail.control = touchEnabledFLAG = false;

            if (_touchEnabledFLAG) {
                tail.flow = false;
            }

            if (!_touchEnabledFLAG || (targetIsLinkFlag && !tail.checked)) return;

            e && stopEvent(e);

            preventEvent = true;
            clearTimeout(preventEventTimeout);
            preventEventTimeout = setTimeout(function () {
                preventEvent = false;
            }, 1000);

            (options.onEnd || noop).call(el, { moved: moved, $target: $target, control: controlTouch, touch: touchFLAG, startEvent: startEvent, aborted: !e || e.type === 'MSPointerCancel' });
            ////console.timeEnd('touch.js onEnd');
        }

        function onOtherStart() {
            if (tail.flow) return;
            setTimeout(function () {
                tail.flow = true;
            }, 10);
        }

        function onOtherEnd() {
            if (!tail.flow) return;
            setTimeout(function () {
                tail.flow = false;
            }, TOUCH_TIMEOUT);
        }

        if (MS_POINTER) {
            addEvent(el, 'MSPointerDown', onStart);
            addEvent(document, 'MSPointerMove', onMove);
            addEvent(document, 'MSPointerCancel', onEnd);
            addEvent(document, 'MSPointerUp', onEnd);
        } else {
            addEvent(el, 'touchstart', onStart);
            addEvent(el, 'touchmove', onMove);
            addEvent(el, 'touchend', onEnd);

            addEvent(document, 'touchstart', onOtherStart);
            addEvent(document, 'touchend', onOtherEnd);
            addEvent(document, 'touchcancel', onOtherEnd);

            $WINDOW.on('scroll', onOtherEnd);

            $el.on('mousedown', onStart);
            $DOCUMENT
                .on('mousemove', onMove)
                .on('mouseup', onEnd);
        }

        $el.on('click', 'a', function (e) {
            tail.checked && stopEvent(e);
        });

        return tail;
    }

    function moveOnTouch($el, options) {
        var el = $el[0],
            elData = $el.data(),
            tail = {},
            startCoo,
            coo,
            startElPos,
            moveElPos,
            edge,
            moveTrack,
            startTime,
            endTime,
            min,
            max,
            snap,
            slowFLAG,
            controlFLAG,
            moved,
            tracked;

        function startTracking(e, noStop) {
            tracked = true;
            startCoo = coo = e._x;
            startTime = e._now;

            moveTrack = [
              [startTime, startCoo]
            ];

            startElPos = moveElPos = tail.noMove || noStop ? 0 : stop($el, (options.getPos || noop)()/*, options._001*/);

            (options.onStart || noop).call(el, e);
        }

        function onStart(e, result) {
            min = tail.min;
            max = tail.max;
            snap = tail.snap;

            slowFLAG = e.altKey;
            tracked = moved = false;

            controlFLAG = result.control;

            if (!controlFLAG && !elData.sliding) {
                startTracking(e);
            }
        }

        function onMove(e, result) {
            if (!tail.noSwipe) {
                if (!tracked) {
                    startTracking(e);
                }

                coo = e._x;

                moveTrack.push([e._now, coo]);

                moveElPos = startElPos - (startCoo - coo);

                edge = findShadowEdge(moveElPos, min, max);

                if (moveElPos <= min) {
                    moveElPos = edgeResistance(moveElPos, min);
                } else if (moveElPos >= max) {
                    moveElPos = edgeResistance(moveElPos, max);
                }

                if (!tail.noMove) {
                    $el.css(getTranslate(moveElPos/*, options._001*/));
                    if (!moved) {
                        moved = true;
                        // only for mouse
                        result.touch || MS_POINTER || $el.addClass(grabbingClass);
                    }

                    (options.onMove || noop).call(el, e, { pos: moveElPos, edge: edge });
                }
            }
        }

        function onEnd(result) {
            ////console.time('moveontouch.js onEnd');
            if (tail.noSwipe && result.moved) return;

            if (!tracked) {
                startTracking(result.startEvent, true);
            }

            //console.log('onEnd');

            result.touch || MS_POINTER || $el.removeClass(grabbingClass);

            endTime = $.now();

            var _backTimeIdeal = endTime - TOUCH_TIMEOUT,
                _backTime,
                _timeDiff,
                _timeDiffLast,
                backTime = null,
                backCoo,
                virtualPos,
                limitPos,
                newPos,
                overPos,
                time = TRANSITION_DURATION,
                speed,
                friction = options.friction;

            for (var _i = moveTrack.length - 1; _i >= 0; _i--) {
                _backTime = moveTrack[_i][0];
                _timeDiff = Math.abs(_backTime - _backTimeIdeal);
                if (backTime === null || _timeDiff < _timeDiffLast) {
                    backTime = _backTime;
                    backCoo = moveTrack[_i][1];
                } else if (backTime === _backTimeIdeal || _timeDiff > _timeDiffLast) {
                    break;
                }
                _timeDiffLast = _timeDiff;
            }

            newPos = minMaxLimit(moveElPos, min, max);

            var cooDiff = backCoo - coo,
                forwardFLAG = cooDiff >= 0,
                timeDiff = endTime - backTime,
                longTouchFLAG = timeDiff > TOUCH_TIMEOUT,
                swipeFLAG = !longTouchFLAG && moveElPos !== startElPos && newPos === moveElPos;

            if (snap) {
                newPos = minMaxLimit(Math[swipeFLAG ? (forwardFLAG ? 'floor' : 'ceil') : 'round'](moveElPos / snap) * snap, min, max);
                min = max = newPos;
            }

            if (swipeFLAG && (snap || newPos === moveElPos)) {
                speed = -(cooDiff / timeDiff);
                time *= minMaxLimit(Math.abs(speed), options.timeLow, options.timeHigh);
                virtualPos = Math.round(moveElPos + speed * time / friction);

                if (!snap) {
                    newPos = virtualPos;
                }

                if (!forwardFLAG && virtualPos > max || forwardFLAG && virtualPos < min) {
                    limitPos = forwardFLAG ? min : max;
                    overPos = virtualPos - limitPos;
                    if (!snap) {
                        newPos = limitPos;
                    }
                    overPos = minMaxLimit(newPos + overPos * .03, limitPos - 50, limitPos + 50);
                    time = Math.abs((moveElPos - overPos) / (speed / friction));
                }
            }

            time *= slowFLAG ? 10 : 1;

            (options.onEnd || noop).call(el, $.extend(result, { moved: result.moved || longTouchFLAG && snap, pos: moveElPos, newPos: newPos, overPos: overPos, time: time }));
        }

        tail = $.extend(touch(options.$wrap, $.extend({}, options, {
            onStart: onStart,
            onMove: onMove,
            onEnd: onEnd
        })), tail);

        return tail;
    }
    function wheel($el, options) {
        var el = $el[0],
            lockFLAG,
            lastDirection,
            lastNow,
            tail = {
                prevent: {}
            };

        addEvent(el, WHEEL, function (e) {
            var yDelta = e.wheelDeltaY || -1 * e.deltaY || 0,
                xDelta = e.wheelDeltaX || -1 * e.deltaX || 0,
                xWin = Math.abs(xDelta) && !Math.abs(yDelta),
                direction = getDirectionSign(xDelta < 0),
                sameDirection = lastDirection === direction,
                now = $.now(),
                tooFast = now - lastNow < TOUCH_TIMEOUT;

            lastDirection = direction;
            lastNow = now;

            if (!xWin || !tail.ok || tail.prevent[direction] && !lockFLAG) {
                return;
            } else {
                stopEvent(e, true);
                if (lockFLAG && sameDirection && tooFast) {
                    return;
                }
            }

            if (options.shift) {
                lockFLAG = true;
                clearTimeout(tail.t);
                tail.t = setTimeout(function () {
                    lockFLAG = false;
                }, SCROLL_LOCK_TIMEOUT);
            }

            (options.onEnd || noop)(e, options.shift ? direction : xDelta);

        });

        return tail;
    }
    jQuery.Fotorama = function ($fotorama, opts) {
        $HTML = $('html');
        $BODY = $('body');

        var that = this,
            stamp = $.now(),
            stampClass = _fotoramaClass + stamp,
            fotorama = $fotorama[0],
            data,
            dataFrameCount = 1,
            fotoramaData = $fotorama.data(),
            size,

            $style = $('<style></style>'),

            $anchor = $(div(hiddenClass)),
            $wrap = $(div(wrapClass)),
            $stage = $(div(stageClass)).appendTo($wrap),
            stage = $stage[0],

            $stageShaft = $(div(stageShaftClass)).appendTo($stage),
            $stageFrame = $(),
            $arrPrev = $(div(arrClass + ' ' + arrPrevClass + buttonAttributes)),
            $arrNext = $(div(arrClass + ' ' + arrNextClass + buttonAttributes)),
            $arrs = $arrPrev.add($arrNext).appendTo($stage),
            $navWrap = $(div(navWrapClass)),
            $nav = $(div(navClass)).appendTo($navWrap),
            $navShaft = $(div(navShaftClass)).appendTo($nav),
            $navFrame,
            $navDotFrame = $(),
            $navThumbFrame = $(),

            stageShaftData = $stageShaft.data(),
            navShaftData = $navShaft.data(),

            $thumbBorder = $(div(thumbBorderClass)).appendTo($navShaft),

            $fullscreenIcon = $(div(fullscreenIconClass + buttonAttributes)),
            fullscreenIcon = $fullscreenIcon[0],
            $videoPlay = $(div(videoPlayClass)),
            $videoClose = $(div(videoCloseClass)).appendTo($stage),
            videoClose = $videoClose[0],

            spinner,
            $spinner = $(div(spinnerClass)),

            $videoPlaying,

            activeIndex = false,
            activeFrame,
            activeIndexes,
            repositionIndex,
            dirtyIndex,
            lastActiveIndex,
            prevIndex,
            nextIndex,
            nextAutoplayIndex,
            startIndex,

            o_loop,
            o_nav,
            o_navThumbs,
            o_navTop,
            o_allowFullScreen,
            o_nativeFullScreen,
            o_fade,
            o_thumbSide,
            o_thumbSide2,
            o_transitionDuration,
            o_transition,
            o_shadows,
            o_rtl,
            o_keyboard,
            lastOptions = {},

            measures = {},
            measuresSetFLAG,

            stageShaftTouchTail = {},
            stageWheelTail = {},
            navShaftTouchTail = {},
            navWheelTail = {},

            scrollTop,
            scrollLeft,

            showedFLAG,
            pausedAutoplayFLAG,
            stoppedAutoplayFLAG,

            toDeactivate = {},
            toDetach = {},

            measuresStash,

            touchedFLAG,

            hoverFLAG,

            navFrameKey,
            stageLeft = 0,

            fadeStack = [];

        $wrap[STAGE_FRAME_KEY] = $(div(stageFrameClass));
        $wrap[NAV_THUMB_FRAME_KEY] = $(div(navFrameClass + ' ' + navFrameThumbClass + buttonAttributes, div(thumbClass)));
        $wrap[NAV_DOT_FRAME_KEY] = $(div(navFrameClass + ' ' + navFrameDotClass + buttonAttributes, div(dotClass)));

        toDeactivate[STAGE_FRAME_KEY] = [];
        toDeactivate[NAV_THUMB_FRAME_KEY] = [];
        toDeactivate[NAV_DOT_FRAME_KEY] = [];
        toDetach[STAGE_FRAME_KEY] = {};

        $wrap
            .addClass(CSS3 ? wrapCss3Class : wrapCss2Class)
            .toggleClass(wrapNoControlsClass, !opts.controlsonstart);

        fotoramaData.fotorama = this;

        function checkForVideo() {
            $.each(data, function (i, dataFrame) {
                if (!dataFrame.i) {
                    dataFrame.i = dataFrameCount++;
                    var video = findVideoId(dataFrame.video, true);
                    if (video) {
                        var thumbs = {};
                        dataFrame.video = video;
                        if (!dataFrame.img && !dataFrame.thumb) {
                            thumbs = getVideoThumbs(dataFrame, data, that);
                        } else {
                            dataFrame.thumbsReady = true;
                        }
                        updateData(data, { img: thumbs.img, thumb: thumbs.thumb }, dataFrame.i, that);
                    }
                }
            });
        }

        function allowKey(key) {
            return o_keyboard[key] || that.fullScreen;
        }

        function bindGlobalEvents(FLAG) {
            var keydownCommon = 'keydown.' + _fotoramaClass,
                localStamp = _fotoramaClass + stamp,
                keydownLocal = 'keydown.' + localStamp,
                resizeLocal = 'resize.' + localStamp + ' ' + 'orientationchange.' + localStamp;

            if (FLAG) {
                $DOCUMENT
                    .on(keydownLocal, function (e) {
                        var catched,
                            index;

                        if ($videoPlaying && e.keyCode === 27) {
                            catched = true;
                            unloadVideo($videoPlaying, true, true);
                        } else if (that.fullScreen || (opts.keyboard && !that.index)) {
                            if (e.keyCode === 27) {
                                catched = true;
                                that.cancelFullScreen();
                            } else if ((e.shiftKey && e.keyCode === 32 && allowKey('space')) || (e.keyCode === 37 && allowKey('left')) || (e.keyCode === 38 && allowKey('up'))) {
                                index = '<';
                            } else if ((e.keyCode === 32 && allowKey('space')) || (e.keyCode === 39 && allowKey('right')) || (e.keyCode === 40 && allowKey('down'))) {
                                index = '>';
                            } else if (e.keyCode === 36 && allowKey('home')) {
                                index = '<<';
                            } else if (e.keyCode === 35 && allowKey('end')) {
                                index = '>>';
                            }
                        }

                        (catched || index) && stopEvent(e);
                        index && that.show({ index: index, slow: e.altKey, user: true });
                    });

                if (!that.index) {
                    $DOCUMENT
                        .off(keydownCommon)
                        .on(keydownCommon, 'textarea, input, select', function (e) {
                            !$BODY.hasClass(_fullscreenClass) && e.stopPropagation();
                        });
                }

                $WINDOW.on(resizeLocal, that.resize);
            } else {
                $DOCUMENT.off(keydownLocal);
                $WINDOW.off(resizeLocal);
            }
        }

        function appendElements(FLAG) {
            if (FLAG === appendElements.f) return;

            if (FLAG) {
                $fotorama
                    .html('')
                    .addClass(_fotoramaClass + ' ' + stampClass)
                    .append($wrap)
                    .before($style)
                    .before($anchor);

                addInstance(that);
            } else {
                $wrap.detach();
                $style.detach();
                $anchor.detach();
                $fotorama
                    .html(fotoramaData.urtext)
                    .removeClass(stampClass);

                hideInstance(that);
            }

            bindGlobalEvents(FLAG);
            appendElements.f = FLAG;
        }

        function setData() {
            data = that.data = data || clone(opts.data) || getDataFromHtml($fotorama);
            size = that.size = data.length;

            !ready.ok && opts.shuffle && shuffle(data);

            checkForVideo();

            activeIndex = limitIndex(activeIndex);

            size && appendElements(true);
        }

        function stageNoMove() {
            var _noMove = (size < 2 && !opts.enableifsingleframe) || $videoPlaying;
            stageShaftTouchTail.noMove = _noMove || o_fade;
            stageShaftTouchTail.noSwipe = _noMove || !opts.swipe;

            !o_transition && $stageShaft.toggleClass(grabClass, !opts.click && !stageShaftTouchTail.noMove && !stageShaftTouchTail.noSwipe);
            MS_POINTER && $wrap.toggleClass(wrapPanYClass, !stageShaftTouchTail.noSwipe);
        }

        function setAutoplayInterval(interval) {
            if (interval === true) interval = '';
            opts.autoplay = Math.max(+interval || AUTOPLAY_INTERVAL, o_transitionDuration * 1.5);
        }

        /**
         * Options on the fly
         * */
        function setOptions() {
            that.options = opts = optionsToLowerCase(opts);

            o_fade = (opts.transition === 'crossfade' || opts.transition === 'dissolve');

            o_loop = opts.loop && (size > 2 || (o_fade && (!o_transition || o_transition !== 'slide')));

            o_transitionDuration = +opts.transitionduration || TRANSITION_DURATION;

            o_rtl = opts.direction === 'rtl';

            o_keyboard = $.extend({}, opts.keyboard && KEYBOARD_OPTIONS, opts.keyboard);

            var classes = { add: [], remove: [] };

            function addOrRemoveClass(FLAG, value) {
                classes[FLAG ? 'add' : 'remove'].push(value);
            }

            if (size > 1 || opts.enableifsingleframe) {
                o_nav = opts.nav;
                o_navTop = opts.navposition === 'top';
                classes.remove.push(selectClass);

                $arrs.toggle(!!opts.arrows);
            } else {
                o_nav = false;
                $arrs.hide();
            }

            spinnerStop();
            spinner = new Spinner($.extend(spinnerDefaults, opts.spinner, spinnerOverride, { direction: o_rtl ? -1 : 1 }));

            arrsUpdate();
            stageWheelUpdate();

            if (opts.autoplay) setAutoplayInterval(opts.autoplay);

            o_thumbSide = numberFromMeasure(opts.thumbwidth) || THUMB_SIZE;
            o_thumbSide2 = numberFromMeasure(opts.thumbheight) || THUMB_SIZE;

            stageWheelTail.ok = navWheelTail.ok = opts.trackpad && !SLOW;

            stageNoMove();

            extendMeasures(opts, [measures]);

            o_navThumbs = o_nav === 'thumbs';

            if (o_navThumbs) {
                frameDraw(size, 'navThumb');

                $navFrame = $navThumbFrame;
                navFrameKey = NAV_THUMB_FRAME_KEY;

                setStyle($style, $.Fotorama.jst.style({ w: o_thumbSide, h: o_thumbSide2, b: opts.thumbborderwidth, m: opts.thumbmargin, s: stamp, q: !COMPAT }));

                $nav
                    .addClass(navThumbsClass)
                    .removeClass(navDotsClass);
            } else if (o_nav === 'dots') {
                frameDraw(size, 'navDot');

                $navFrame = $navDotFrame;
                navFrameKey = NAV_DOT_FRAME_KEY;

                $nav
                    .addClass(navDotsClass)
                    .removeClass(navThumbsClass);
            } else {
                o_nav = false;
                $nav.removeClass(navThumbsClass + ' ' + navDotsClass);
            }

            if (o_nav) {
                if (o_navTop) {
                    $navWrap.insertBefore($stage);
                } else {
                    $navWrap.insertAfter($stage);
                }
                frameAppend.nav = false;
                frameAppend($navFrame, $navShaft, 'nav');
            }

            o_allowFullScreen = opts.allowfullscreen;

            if (o_allowFullScreen) {
                $fullscreenIcon.prependTo($stage);
                o_nativeFullScreen = FULLSCREEN && o_allowFullScreen === 'native';
            } else {
                $fullscreenIcon.detach();
                o_nativeFullScreen = false;
            }

            addOrRemoveClass(o_fade, wrapFadeClass);
            addOrRemoveClass(!o_fade, wrapSlideClass);
            addOrRemoveClass(!opts.captions, wrapNoCaptionsClass);
            addOrRemoveClass(o_rtl, wrapRtlClass);
            addOrRemoveClass(opts.arrows !== 'always', wrapToggleArrowsClass);

            o_shadows = opts.shadows && !SLOW;
            addOrRemoveClass(!o_shadows, wrapNoShadowsClass);

            $wrap
                .addClass(classes.add.join(' '))
                .removeClass(classes.remove.join(' '));

            lastOptions = $.extend({}, opts);
        }

        function normalizeIndex(index) {
            return index < 0 ? (size + (index % size)) % size : index >= size ? index % size : index;
        }

        function limitIndex(index) {
            return minMaxLimit(index, 0, size - 1);
        }

        function edgeIndex(index) {
            return o_loop ? normalizeIndex(index) : limitIndex(index);
        }

        function getPrevIndex(index) {
            return index > 0 || o_loop ? index - 1 : false;
        }

        function getNextIndex(index) {
            return index < size - 1 || o_loop ? index + 1 : false;
        }

        function setStageShaftMinmaxAndSnap() {
            stageShaftTouchTail.min = o_loop ? -Infinity : -getPosByIndex(size - 1, measures.w, opts.margin, repositionIndex);
            stageShaftTouchTail.max = o_loop ? Infinity : -getPosByIndex(0, measures.w, opts.margin, repositionIndex);
            stageShaftTouchTail.snap = measures.w + opts.margin;
        }

        function setNavShaftMinMax() {
            //////console.log('setNavShaftMinMax', measures.nw);
            navShaftTouchTail.min = Math.min(0, measures.nw - $navShaft.width());
            navShaftTouchTail.max = 0;
            $navShaft.toggleClass(grabClass, !(navShaftTouchTail.noMove = navShaftTouchTail.min === navShaftTouchTail.max));
        }

        function eachIndex(indexes, type, fn) {
            if (typeof indexes === 'number') {
                indexes = new Array(indexes);
                var rangeFLAG = true;
            }
            return $.each(indexes, function (i, index) {
                if (rangeFLAG) index = i;
                if (typeof index === 'number') {
                    var dataFrame = data[normalizeIndex(index)];

                    if (dataFrame) {
                        var key = '$' + type + 'Frame',
                            $frame = dataFrame[key];

                        fn.call(this, i, index, dataFrame, $frame, key, $frame && $frame.data());
                    }
                }
            });
        }

        function setMeasures(width, height, ratio, index) {
            if (!measuresSetFLAG || (measuresSetFLAG === '*' && index === startIndex)) {

                ////console.log('setMeasures', index, opts.width, opts.height);

                width = measureIsValid(opts.width) || measureIsValid(width) || WIDTH;
                height = measureIsValid(opts.height) || measureIsValid(height) || HEIGHT;
                that.resize({
                    width: width,
                    ratio: opts.ratio || ratio || width / height
                }, 0, index !== startIndex && '*');
            }
        }

        function loadImg(indexes, type, specialMeasures, method, position, again) {
            eachIndex(indexes, type, function (i, index, dataFrame, $frame, key, frameData) {

                if (!$frame) return;

                var fullFLAG = that.fullScreen && dataFrame.full && dataFrame.full !== dataFrame.img && !frameData.$full && type === 'stage';

                if (frameData.$img && !again && !fullFLAG) return;

                var img = new Image(),
                    $img = $(img),
                    imgData = $img.data();

                frameData[fullFLAG ? '$full' : '$img'] = $img;

                var srcKey = type === 'stage' ? (fullFLAG ? 'full' : 'img') : 'thumb',
                    src = dataFrame[srcKey],
                    dummy = fullFLAG ? null : dataFrame[type === 'stage' ? 'thumb' : 'img'];

                if (type === 'navThumb') $frame = frameData.$wrap;

                function triggerTriggerEvent(event) {
                    var _index = normalizeIndex(index);
                    triggerEvent(event, {
                        index: _index,
                        src: src,
                        frame: data[_index]
                    });
                }

                function error() {
                    $img.remove();

                    $.Fotorama.cache[src] = 'error';

                    if ((!dataFrame.html || type !== 'stage') && dummy && dummy !== src) {
                        dataFrame[srcKey] = src = dummy;
                        loadImg([index], type, specialMeasures, method, position, true);
                    } else {
                        if (src && !dataFrame.html && !fullFLAG) {
                            $frame
                                .trigger('f:error')
                                .removeClass(loadingClass)
                                .addClass(errorClass);

                            triggerTriggerEvent('error');
                        } else if (type === 'stage') {
                            $frame
                                .trigger('f:load')
                                .removeClass(loadingClass + ' ' + errorClass)
                                .addClass(loadedClass);

                            triggerTriggerEvent('load');
                            setMeasures();
                        }

                        frameData.state = 'error';

                        if (size > 1 && data[index] === dataFrame && !dataFrame.html && !dataFrame.deleted && !dataFrame.video && !fullFLAG) {
                            dataFrame.deleted = true;
                            that.splice(index, 1);
                        }
                    }
                }

                function loaded() {
                    ////console.log('loaded: ' + src);

                    //console.log('$.Fotorama.measures[src]', $.Fotorama.measures[src]);

                    $.Fotorama.measures[src] = imgData.measures = $.Fotorama.measures[src] || {
                        width: img.width,
                        height: img.height,
                        ratio: img.width / img.height
                    };

                    setMeasures(imgData.measures.width, imgData.measures.height, imgData.measures.ratio, index);

                    $img
                        .off('load error')
                        .addClass(imgClass + (fullFLAG ? ' ' + imgFullClass : ''))
                        .prependTo($frame);

                    fit($img, ($.isFunction(specialMeasures) ? specialMeasures() : specialMeasures) || measures, method || dataFrame.fit || opts.fit, position || dataFrame.position || opts.position);

                    $.Fotorama.cache[src] = frameData.state = 'loaded';

                    setTimeout(function () {
                        $frame
                            .trigger('f:load')
                            .removeClass(loadingClass + ' ' + errorClass)
                            .addClass(loadedClass + ' ' + (fullFLAG ? loadedFullClass : loadedImgClass));

                        if (type === 'stage') {
                            triggerTriggerEvent('load');
                        } else if (dataFrame.thumbratio === AUTO || !dataFrame.thumbratio && opts.thumbratio === AUTO) {
                            // danger! reflow for all thumbnails
                            dataFrame.thumbratio = imgData.measures.ratio;
                            reset();
                        }
                    }, 0);
                }

                if (!src) {
                    error();
                    return;
                }

                function waitAndLoad() {
                    var _i = 10;
                    waitFor(function () {
                        return !touchedFLAG || !_i-- && !SLOW;
                    }, function () {
                        loaded();
                    });
                }

                if (!$.Fotorama.cache[src]) {
                    $.Fotorama.cache[src] = '*';

                    $img
                        .on('load', waitAndLoad)
                        .on('error', error);
                } else {
                    (function justWait() {
                        if ($.Fotorama.cache[src] === 'error') {
                            error();
                        } else if ($.Fotorama.cache[src] === 'loaded') {
                            //console.log('take from cache: ' + src);
                            setTimeout(waitAndLoad, 0);
                        } else {
                            setTimeout(justWait, 100);
                        }
                    })();
                }

                frameData.state = '';
                img.src = src;
            });
        }

        function spinnerSpin($el) {
            $spinner.append(spinner.spin().el).appendTo($el);
        }

        function spinnerStop() {
            $spinner.detach();
            spinner && spinner.stop();
        }

        function updateFotoramaState() {
            var $frame = activeFrame[STAGE_FRAME_KEY];

            if ($frame && !$frame.data().state) {
                spinnerSpin($frame);
                $frame.on('f:load f:error', function () {
                    $frame.off('f:load f:error');
                    spinnerStop();
                });
            }
        }

        function addNavFrameEvents(frame) {
            addEnterUp(frame, onNavFrameClick);
            addFocus(frame, function () {

                setTimeout(function () {
                    lockScroll($nav);
                }, 0);
                slideNavShaft({ time: o_transitionDuration, guessIndex: $(this).data().eq, minMax: navShaftTouchTail });
            });
        }

        function frameDraw(indexes, type) {
            eachIndex(indexes, type, function (i, index, dataFrame, $frame, key, frameData) {
                if ($frame) return;

                $frame = dataFrame[key] = $wrap[key].clone();
                frameData = $frame.data();
                frameData.data = dataFrame;
                var frame = $frame[0];

                if (type === 'stage') {

                    if (dataFrame.html) {
                        $('<div class="' + htmlClass + '"></div>')
                            .append(
                                dataFrame._html ? $(dataFrame.html)
                                    .removeAttr('id')
                                    .html(dataFrame._html) // Because of IE
                                : dataFrame.html
                            )
                            .appendTo($frame);
                    }

                    dataFrame.caption && $(div(captionClass, div(captionWrapClass, dataFrame.caption))).appendTo($frame);

                    dataFrame.video && $frame
                      .addClass(stageFrameVideoClass)
                      .append($videoPlay.clone());

                    // This solves tabbing problems
                    addFocus(frame, function () {
                        setTimeout(function () {
                            lockScroll($stage);
                        }, 0);
                        clickToShow({ index: frameData.eq, user: true });
                    });

                    $stageFrame = $stageFrame.add($frame);
                } else if (type === 'navDot') {
                    addNavFrameEvents(frame);
                    $navDotFrame = $navDotFrame.add($frame);
                } else if (type === 'navThumb') {
                    addNavFrameEvents(frame);
                    frameData.$wrap = $frame.children(':first');
                    $navThumbFrame = $navThumbFrame.add($frame);
                    if (dataFrame.video) {
                        frameData.$wrap.append($videoPlay.clone());
                    }
                }
            });
        }

        function callFit($img, measuresToFit, method, position) {
            return $img && $img.length && fit($img, measuresToFit, method, position);
        }

        function stageFramePosition(indexes) {
            eachIndex(indexes, 'stage', function (i, index, dataFrame, $frame, key, frameData) {
                if (!$frame) return;

                var normalizedIndex = normalizeIndex(index),
                    method = dataFrame.fit || opts.fit,
                    position = dataFrame.position || opts.position;
                frameData.eq = normalizedIndex;

                toDetach[STAGE_FRAME_KEY][normalizedIndex] = $frame.css($.extend({ left: o_fade ? 0 : getPosByIndex(index, measures.w, opts.margin, repositionIndex) }, o_fade && getDuration(0)));

                if (isDetached($frame[0])) {
                    $frame.appendTo($stageShaft);
                    unloadVideo(dataFrame.$video);
                }

                callFit(frameData.$img, measures, method, position);
                callFit(frameData.$full, measures, method, position);
            });
        }

        function thumbsDraw(pos, loadFLAG) {
            if (o_nav !== 'thumbs' || isNaN(pos)) return;

            var leftLimit = -pos,
                rightLimit = -pos + measures.nw;

            $navThumbFrame.each(function () {
                var $this = $(this),
                    thisData = $this.data(),
                    eq = thisData.eq,
                    getSpecialMeasures = function () {
                        return {
                            h: o_thumbSide2,
                            w: thisData.w
                        }
                    },
                    specialMeasures = getSpecialMeasures(),
                    dataFrame = data[eq] || {},
                    method = dataFrame.thumbfit || opts.thumbfit,
                    position = dataFrame.thumbposition || opts.thumbposition;

                specialMeasures.w = thisData.w;

                if (thisData.l + thisData.w < leftLimit
                    || thisData.l > rightLimit
                    || callFit(thisData.$img, specialMeasures, method, position)) return;

                loadFLAG && loadImg([eq], 'navThumb', getSpecialMeasures, method, position);
            });
        }

        function frameAppend($frames, $shaft, type) {
            if (!frameAppend[type]) {

                var thumbsFLAG = type === 'nav' && o_navThumbs,
                    left = 0;

                $shaft.append(
                  $frames
                      .filter(function () {
                          var actual,
                              $this = $(this),
                              frameData = $this.data();
                          for (var _i = 0, _l = data.length; _i < _l; _i++) {
                              if (frameData.data === data[_i]) {
                                  actual = true;
                                  frameData.eq = _i;
                                  break;
                              }
                          }
                          return actual || $this.remove() && false;
                      })
                      .sort(function (a, b) {
                          return $(a).data().eq - $(b).data().eq;
                      })
                      .each(function () {

                          if (!thumbsFLAG) return;

                          var $this = $(this),
                              frameData = $this.data(),
                              thumbwidth = Math.round(o_thumbSide2 * frameData.data.thumbratio) || o_thumbSide;

                          frameData.l = left;
                          frameData.w = thumbwidth;

                          $this.css({ width: thumbwidth });

                          left += thumbwidth + opts.thumbmargin;
                      })
                );

                frameAppend[type] = true;
            }
        }

        function getDirection(x) {
            return x - stageLeft > measures.w / 3;
        }

        function disableDirrection(i) {
            return !o_loop && (!(activeIndex + i) || !(activeIndex - size + i)) && !$videoPlaying;
        }

        function arrsUpdate() {
            var disablePrev = disableDirrection(0),
                disableNext = disableDirrection(1);
            $arrPrev
                .toggleClass(arrDisabledClass, disablePrev)
                .attr(disableAttr(disablePrev));
            $arrNext
                .toggleClass(arrDisabledClass, disableNext)
                .attr(disableAttr(disableNext));
        }

        function stageWheelUpdate() {
            if (stageWheelTail.ok) {
                stageWheelTail.prevent = { '<': disableDirrection(0), '>': disableDirrection(1) };
            }
        }

        function getNavFrameBounds($navFrame) {
            var navFrameData = $navFrame.data(),
                left,
                width;

            if (o_navThumbs) {
                left = navFrameData.l;
                width = navFrameData.w;
            } else {
                left = $navFrame.position().left;
                width = $navFrame.width();
            }

            return {
                c: left + width / 2,
                min: -left + opts.thumbmargin * 10,
                max: -left + measures.w - width - opts.thumbmargin * 10
            };
        }

        function slideThumbBorder(time) {
            var navFrameData = activeFrame[navFrameKey].data();
            slide($thumbBorder, {
                time: time * 1.2,
                pos: navFrameData.l,
                width: navFrameData.w - opts.thumbborderwidth * 2
            });
        }

        function slideNavShaft(options) {
            //console.log('slideNavShaft', options.guessIndex, options.keep, slideNavShaft.l);
            var $guessNavFrame = data[options.guessIndex][navFrameKey];
            if ($guessNavFrame) {
                var overflowFLAG = navShaftTouchTail.min !== navShaftTouchTail.max,
                    minMax = options.minMax || overflowFLAG && getNavFrameBounds(activeFrame[navFrameKey]),
                    l = overflowFLAG && (options.keep && slideNavShaft.l ? slideNavShaft.l : minMaxLimit((options.coo || measures.nw / 2) - getNavFrameBounds($guessNavFrame).c, minMax.min, minMax.max)),
                    pos = overflowFLAG && minMaxLimit(l, navShaftTouchTail.min, navShaftTouchTail.max),
                    time = options.time * 1.1;

                slide($navShaft, {
                    time: time,
                    pos: pos || 0,
                    onEnd: function () {
                        thumbsDraw(pos, true);
                    }
                });

                //if (time) thumbsDraw(pos);

                setShadow($nav, findShadowEdge(pos, navShaftTouchTail.min, navShaftTouchTail.max));
                slideNavShaft.l = l;
            }
        }

        function navUpdate() {
            deactivateFrames(navFrameKey);
            toDeactivate[navFrameKey].push(activeFrame[navFrameKey].addClass(activeClass));
        }

        function deactivateFrames(key) {
            var _toDeactivate = toDeactivate[key];

            while (_toDeactivate.length) {
                _toDeactivate.shift().removeClass(activeClass);
            }
        }

        function detachFrames(key) {
            var _toDetach = toDetach[key];

            ////console.log('_toDetach', _toDetach);
            ////console.log('activeIndexes', activeIndexes);

            $.each(activeIndexes, function (i, index) {
                delete _toDetach[normalizeIndex(index)];
            });

            $.each(_toDetach, function (index, $frame) {
                delete _toDetach[index];
                ////console.log('Detach', index);
                $frame.detach();
            });
        }

        function stageShaftReposition(skipOnEnd) {

            repositionIndex = dirtyIndex = activeIndex;

            var $frame = activeFrame[STAGE_FRAME_KEY];

            if ($frame) {
                deactivateFrames(STAGE_FRAME_KEY);
                toDeactivate[STAGE_FRAME_KEY].push($frame.addClass(activeClass));

                skipOnEnd || that.show.onEnd(true);
                stop($stageShaft, 0, true);

                detachFrames(STAGE_FRAME_KEY);
                stageFramePosition(activeIndexes);
                setStageShaftMinmaxAndSnap();
                setNavShaftMinMax();
            }
        }

        function extendMeasures(options, measuresArray) {
            if (!options) return;

            $.each(measuresArray, function (i, measures) {
                if (!measures) return;

                $.extend(measures, {
                    width: options.width || measures.width,
                    height: options.height,
                    minwidth: options.minwidth,
                    maxwidth: options.maxwidth,
                    minheight: options.minheight,
                    maxheight: options.maxheight,
                    ratio: getRatio(options.ratio)
                })
            });
        }

        function triggerEvent(event, extra) {
            $fotorama.trigger(_fotoramaClass + ':' + event, [that, extra]);
        }

        function onTouchStart() {
            clearTimeout(onTouchEnd.t);
            touchedFLAG = 1;

            if (opts.stopautoplayontouch) {
                that.stopAutoplay();
            } else {
                pausedAutoplayFLAG = true;
            }
        }

        function onTouchEnd() {
            if (!touchedFLAG) return;
            if (!opts.stopautoplayontouch) {
                releaseAutoplay();
                changeAutoplay();
            }

            onTouchEnd.t = setTimeout(function () {
                touchedFLAG = 0;
            }, TRANSITION_DURATION + TOUCH_TIMEOUT);
            ////console.timeEnd('onTouchEnd');
        }

        function releaseAutoplay() {
            //console.log('releaseAutoplay');
            pausedAutoplayFLAG = !!($videoPlaying || stoppedAutoplayFLAG);
        }

        function changeAutoplay() {
            //console.log('changeAutoplay');

            clearTimeout(changeAutoplay.t);
            waitFor.stop(changeAutoplay.w);

            if (!opts.autoplay || pausedAutoplayFLAG) {
                if (that.autoplay) {
                    that.autoplay = false;
                    triggerEvent('stopautoplay');
                }

                return;
            }

            //console.log('changeAutoplay continue');

            if (!that.autoplay) {
                that.autoplay = true;
                triggerEvent('startautoplay');
            }

            var _activeIndex = activeIndex;


            var frameData = activeFrame[STAGE_FRAME_KEY].data();
            changeAutoplay.w = waitFor(function () {
                //console.log('wait for the state of the current frame');
                return frameData.state || _activeIndex !== activeIndex;
            }, function () {
                //console.log('the current frame is ready');
                changeAutoplay.t = setTimeout(function () {
                    //console.log('changeAutoplay.t setTimeout', pausedAutoplayFLAG, _activeIndex !== activeIndex);
                    if (pausedAutoplayFLAG || _activeIndex !== activeIndex) return;

                    var _nextAutoplayIndex = nextAutoplayIndex,
                        nextFrameData = data[_nextAutoplayIndex][STAGE_FRAME_KEY].data();

                    changeAutoplay.w = waitFor(function () {
                        //console.log('wait for the state of the next frame');
                        return nextFrameData.state || _nextAutoplayIndex !== nextAutoplayIndex;
                    }, function () {
                        if (pausedAutoplayFLAG || _nextAutoplayIndex !== nextAutoplayIndex) return;
                        that.show(o_loop ? getDirectionSign(!o_rtl) : nextAutoplayIndex);
                    });
                }, opts.autoplay);
            });

        }

        that.startAutoplay = function (interval) {
            if (that.autoplay) return this;
            pausedAutoplayFLAG = stoppedAutoplayFLAG = false;
            setAutoplayInterval(interval || opts.autoplay);
            changeAutoplay();

            return this;
        };

        that.stopAutoplay = function () {
            if (that.autoplay) {
                pausedAutoplayFLAG = stoppedAutoplayFLAG = true;
                changeAutoplay();
            }
            return this;
        };

        that.show = function (options) {
            //console.log('that.show');
            ////console.time('that.show prepare');
            var index;

            if (typeof options !== 'object') {
                index = options;
                options = {};
            } else {
                index = options.index;
            }

            index = index === '>' ? dirtyIndex + 1 : index === '<' ? dirtyIndex - 1 : index === '<<' ? 0 : index === '>>' ? size - 1 : index;
            index = isNaN(index) ? getIndexFromHash(index, data, true) : index;
            index = typeof index === 'undefined' ? activeIndex || 0 : index;

            that.activeIndex = activeIndex = edgeIndex(index);
            prevIndex = getPrevIndex(activeIndex);
            nextIndex = getNextIndex(activeIndex);
            nextAutoplayIndex = normalizeIndex(activeIndex + (o_rtl ? -1 : 1));
            activeIndexes = [activeIndex, prevIndex, nextIndex];

            dirtyIndex = o_loop ? index : activeIndex;

            var diffIndex = Math.abs(lastActiveIndex - dirtyIndex),
                time = getNumber(options.time, function () {
                    return Math.min(o_transitionDuration * (1 + (diffIndex - 1) / 12), o_transitionDuration * 2);
                }),
                overPos = options.overPos;

            if (options.slow) time *= 10;

            var _activeFrame = activeFrame;
            that.activeFrame = activeFrame = data[activeIndex];
            ////console.timeEnd('that.show prepare');

            var silent = _activeFrame === activeFrame && !options.user;

            //setTimeout(function () {
            ////console.time('unloadVideo');
            unloadVideo($videoPlaying, activeFrame.i !== data[normalizeIndex(repositionIndex)].i);
            ////console.timeEnd('unloadVideo');
            ////console.time('frameDraw');
            frameDraw(activeIndexes, 'stage');
            ////console.timeEnd('frameDraw');
            ////console.time('stageFramePosition');
            stageFramePosition(SLOW ? [dirtyIndex] : [dirtyIndex, getPrevIndex(dirtyIndex), getNextIndex(dirtyIndex)]);
            ////console.timeEnd('stageFramePosition');
            ////console.time('updateTouchTails');
            updateTouchTails('go', true);
            ////console.timeEnd('updateTouchTails');
            ////console.time('triggerEvent');

            silent || triggerEvent('show', {
                user: options.user,
                time: time
            });
            ////console.timeEnd('triggerEvent');
            //}, 0);

            ////console.time('bind onEnd');

            pausedAutoplayFLAG = true;

            var onEnd = that.show.onEnd = function (skipReposition) {
                if (onEnd.ok) return;
                onEnd.ok = true;

                skipReposition || stageShaftReposition(true);

                if (!silent) {
                    triggerEvent('showend', {
                        user: options.user
                    });
                }

                //console.log('o_transition', o_transition);

                if (!skipReposition && o_transition && o_transition !== opts.transition) {
                    //console.log('set transition back to: ' + o_transition);
                    that.setOptions({ transition: o_transition });
                    o_transition = false;
                    return;
                }

                updateFotoramaState();
                loadImg(activeIndexes, 'stage');

                updateTouchTails('go', false);
                stageWheelUpdate();

                stageCursor();
                releaseAutoplay();
                changeAutoplay();
            };
            ////console.timeEnd('bind onEnd');

            if (!o_fade) {
                ////console.time('slide');
                slide($stageShaft, {
                    pos: -getPosByIndex(dirtyIndex, measures.w, opts.margin, repositionIndex),
                    overPos: overPos,
                    time: time,
                    onEnd: onEnd/*,
        _001: true*/
                });
                ////console.timeEnd('slide');
            } else {
                var $activeFrame = activeFrame[STAGE_FRAME_KEY],
                    $prevActiveFrame = activeIndex !== lastActiveIndex ? data[lastActiveIndex][STAGE_FRAME_KEY] : null;

                fade($activeFrame, $prevActiveFrame, $stageFrame, {
                    time: time,
                    method: opts.transition,
                    onEnd: onEnd
                }, fadeStack);
            }

            ////console.time('arrsUpdate');
            arrsUpdate();
            ////console.timeEnd('arrsUpdate');

            if (o_nav) {
                ////console.time('navUpdate');
                navUpdate();
                ////console.timeEnd('navUpdate');

                ////console.time('slideNavShaft');
                var guessIndex = limitIndex(activeIndex + minMaxLimit(dirtyIndex - lastActiveIndex, -1, 1));
                slideNavShaft({ time: time, coo: guessIndex !== activeIndex && options.coo, guessIndex: typeof options.coo !== 'undefined' ? guessIndex : activeIndex, keep: silent });
                ////console.timeEnd('slideNavShaft');

                ////console.time('slideThumbBorder');
                if (o_navThumbs) slideThumbBorder(time);
                ////console.timeEnd('slideThumbBorder');
            }

            ////console.time('that.show end');
            showedFLAG = typeof lastActiveIndex !== 'undefined' && lastActiveIndex !== activeIndex;
            lastActiveIndex = activeIndex;
            opts.hash && showedFLAG && !that.eq && setHash(activeFrame.id || activeIndex + 1);
            ////console.timeEnd('that.show end');

            ////console.timeEnd('that.show');

            return this;
        };

        that.requestFullScreen = function () {
            if (o_allowFullScreen && !that.fullScreen) {
                scrollTop = $WINDOW.scrollTop();
                scrollLeft = $WINDOW.scrollLeft();

                lockScroll($WINDOW);

                updateTouchTails('x', true);

                measuresStash = $.extend({}, measures);

                $fotorama
                    .addClass(fullscreenClass)
                    .appendTo($BODY.addClass(_fullscreenClass));

                $HTML.addClass(_fullscreenClass);

                unloadVideo($videoPlaying, true, true);

                that.fullScreen = true;

                if (o_nativeFullScreen) {
                    fullScreenApi.request(fotorama);
                }

                that.resize();
                loadImg(activeIndexes, 'stage');
                updateFotoramaState();

                triggerEvent('fullscreenenter');
            }

            return this;
        };

        function cancelFullScreen() {
            if (that.fullScreen) {
                that.fullScreen = false;

                if (FULLSCREEN) {
                    fullScreenApi.cancel(fotorama);
                }

                $BODY.removeClass(_fullscreenClass);
                $HTML.removeClass(_fullscreenClass);

                $fotorama
                    .removeClass(fullscreenClass)
                    .insertAfter($anchor);

                measures = $.extend({}, measuresStash);

                unloadVideo($videoPlaying, true, true);

                updateTouchTails('x', false);

                that.resize();
                loadImg(activeIndexes, 'stage');

                lockScroll($WINDOW, scrollLeft, scrollTop);

                triggerEvent('fullscreenexit');
            }
        }

        that.cancelFullScreen = function () {
            if (o_nativeFullScreen && fullScreenApi.is()) {
                fullScreenApi.cancel(document);
            } else {
                cancelFullScreen();
            }

            return this;
        };

        that.toggleFullScreen = function () {
            return that[(that.fullScreen ? 'cancel' : 'request') + 'FullScreen']();
        };

        addEvent(document, fullScreenApi.event, function () {
            if (data && !fullScreenApi.is() && !$videoPlaying) {
                cancelFullScreen();
            }
        });

        that.resize = function (options) {
            if (!data) return this;

            var time = arguments[1] || 0,
                setFLAG = arguments[2];

            extendMeasures(!that.fullScreen ? optionsToLowerCase(options) : { width: '100%', maxwidth: null, minwidth: null, height: '100%', maxheight: null, minheight: null }, [measures, setFLAG || that.fullScreen || opts]);

            var width = measures.width,
                height = measures.height,
                ratio = measures.ratio,
                windowHeight = $WINDOW.height() - (o_nav ? $nav.height() : 0);

            if (measureIsValid(width)) {
                $wrap
                    .addClass(wrapOnlyActiveClass)
                    .css({ width: width, minWidth: measures.minwidth || 0, maxWidth: measures.maxwidth || MAX_WIDTH });

                width = measures.W = measures.w = $wrap.width();
                measures.nw = o_nav && numberFromWhatever(opts.navwidth, width) || width;

                if (opts.glimpse) {
                    // Glimpse
                    measures.w -= Math.round((numberFromWhatever(opts.glimpse, width) || 0) * 2);
                }

                $stageShaft.css({ width: measures.w, marginLeft: (measures.W - measures.w) / 2 });

                ////console.log('measures.W', measures.W);
                ////console.log('measures.w', measures.w);

                height = numberFromWhatever(height, windowHeight);

                height = height || (ratio && width / ratio);

                if (height) {
                    width = Math.round(width);
                    height = measures.h = Math.round(minMaxLimit(height, numberFromWhatever(measures.minheight, windowHeight), numberFromWhatever(measures.maxheight, windowHeight)));

                    $stage
                        .stop()
                        .animate({ width: width, height: height }, time, function () {
                            $wrap.removeClass(wrapOnlyActiveClass);
                        });

                    stageShaftReposition();

                    if (o_nav) {
                        $nav
                            .stop()
                            .animate({ width: measures.nw }, time);

                        slideNavShaft({ guessIndex: activeIndex, time: time, keep: true });
                        if (o_navThumbs && frameAppend.nav) slideThumbBorder(time);
                    }

                    measuresSetFLAG = setFLAG || true;

                    ready();
                }
            }

            stageLeft = $stage.offset().left;

            return this;
        };

        that.setOptions = function (options) {
            $.extend(opts, options);
            reset();
            return this;
        };

        that.shuffle = function () {
            data && shuffle(data) && reset();
            return this;
        };

        function setShadow($el, edge) {
            ////console.time('setShadow');
            if (o_shadows) {
                $el.removeClass(shadowsLeftClass + ' ' + shadowsRightClass);
                edge && !$videoPlaying && $el.addClass(edge.replace(/^|\s/g, ' ' + shadowsClass + '--'));
            }
            ////console.timeEnd('setShadow');
        }

        that.destroy = function () {
            that.cancelFullScreen();
            that.stopAutoplay();

            data = that.data = null;

            appendElements();

            activeIndexes = [];
            detachFrames(STAGE_FRAME_KEY);

            reset.ok = false;

            return this;
        };

        that.playVideo = function () {
            var dataFrame = activeFrame,
                video = dataFrame.video,
                _activeIndex = activeIndex;

            if (typeof video === 'object' && dataFrame.videoReady) {
                o_nativeFullScreen && that.fullScreen && that.cancelFullScreen();

                waitFor(function () {
                    return !fullScreenApi.is() || _activeIndex !== activeIndex;
                }, function () {
                    if (_activeIndex === activeIndex) {
                        dataFrame.$video = dataFrame.$video || $($.Fotorama.jst.video(video));
                        dataFrame.$video.appendTo(dataFrame[STAGE_FRAME_KEY]);

                        $wrap.addClass(wrapVideoClass);
                        $videoPlaying = dataFrame.$video;

                        stageNoMove();

                        $arrs.blur();
                        $fullscreenIcon.blur();

                        triggerEvent('loadvideo');
                    }
                });
            }

            return this;
        };

        that.stopVideo = function () {
            unloadVideo($videoPlaying, true, true);
            return this;
        };

        function unloadVideo($video, unloadActiveFLAG, releaseAutoplayFLAG) {
            if (unloadActiveFLAG) {
                $wrap.removeClass(wrapVideoClass);
                $videoPlaying = false;

                stageNoMove();
            }

            if ($video && $video !== $videoPlaying) {
                $video.remove();
                triggerEvent('unloadvideo');
            }

            if (releaseAutoplayFLAG) {
                releaseAutoplay();
                changeAutoplay();
            }
        }

        function toggleControlsClass(FLAG) {
            $wrap.toggleClass(wrapNoControlsClass, FLAG);
        }

        function stageCursor(e) {
            if (stageShaftTouchTail.flow) return;

            var x = e ? e.pageX : stageCursor.x,
                pointerFLAG = x && !disableDirrection(getDirection(x)) && opts.click;

            if (stageCursor.p !== pointerFLAG
                && $stage.toggleClass(pointerClass, pointerFLAG)) {
                stageCursor.p = pointerFLAG;
                stageCursor.x = x;
            }
        }

        $stage.on('mousemove', stageCursor);

        function clickToShow(showOptions) {
            clearTimeout(clickToShow.t);

            if (opts.clicktransition && opts.clicktransition !== opts.transition) {
                //console.log('change transition to: ' + opts.clicktransition);

                // this timeout is for yield events flow
                setTimeout(function () {
                    // save original transition for later
                    var _o_transition = opts.transition;

                    that.setOptions({ transition: opts.clicktransition });

                    // now safe to pass base transition to o_transition, so that.show will restor it
                    o_transition = _o_transition;
                    // this timeout is here to prevent jerking in some browsers
                    clickToShow.t = setTimeout(function () {
                        that.show(showOptions);
                    }, 10);
                }, 0);
            } else {
                that.show(showOptions);
            }
        }

        function onStageTap(e, toggleControlsFLAG) {
            ////console.time('onStageTap');
            var target = e.target,
                $target = $(target);

            if ($target.hasClass(videoPlayClass)) {
                that.playVideo();
            } else if (target === fullscreenIcon) {
                that.toggleFullScreen();
            } else if ($videoPlaying) {
                target === videoClose && unloadVideo($videoPlaying, true, true);
            } else {
                if (toggleControlsFLAG) {
                    toggleControlsClass();
                } else if (opts.click) {

                    clickToShow({ index: e.shiftKey || getDirectionSign(getDirection(e._x)), slow: e.altKey, user: true });
                }
            }
            ////console.timeEnd('onStageTap');
        }

        function updateTouchTails(key, value) {
            stageShaftTouchTail[key] = navShaftTouchTail[key] = value;
        }

        stageShaftTouchTail = moveOnTouch($stageShaft, {
            onStart: onTouchStart,
            onMove: function (e, result) {
                setShadow($stage, result.edge);
            },
            onTouchEnd: onTouchEnd,
            onEnd: function (result) {
                ////console.time('stageShaftTouchTail.onEnd');
                setShadow($stage);

                ////console.log('result', result);

                var toggleControlsFLAG = (MS_POINTER && !hoverFLAG || result.touch) && opts.arrows && opts.arrows !== 'always';

                if (result.moved || (toggleControlsFLAG && result.pos !== result.newPos && !result.control)) {
                    var index = getIndexByPos(result.newPos, measures.w, opts.margin, repositionIndex);
                    that.show({
                        index: index,
                        time: o_fade ? o_transitionDuration : result.time,
                        overPos: result.overPos,
                        user: true
                    });
                } else if (!result.aborted && !result.control) {
                    onStageTap(result.startEvent, toggleControlsFLAG);
                }
                ////console.timeEnd('stageShaftTouchTail.onEnd');
            },
            //    getPos: function () {
            //      return -getPosByIndex(dirtyIndex, measures.w, opts.margin, repositionIndex);
            //    },
            //_001: true,
            timeLow: 1,
            timeHigh: 1,
            friction: 2,
            select: '.' + selectClass + ', .' + selectClass + ' *',
            $wrap: $stage
        });

        navShaftTouchTail = moveOnTouch($navShaft, {
            onStart: onTouchStart,
            onMove: function (e, result) {
                setShadow($nav, result.edge);
            },
            onTouchEnd: onTouchEnd,
            onEnd: function (result) {

                function onEnd() {
                    slideNavShaft.l = result.newPos;
                    releaseAutoplay();
                    changeAutoplay();
                    thumbsDraw(result.newPos, true);
                }

                if (!result.moved) {
                    var target = result.$target.closest('.' + navFrameClass, $navShaft)[0];
                    target && onNavFrameClick.call(target, result.startEvent);
                } else if (result.pos !== result.newPos) {
                    pausedAutoplayFLAG = true;
                    slide($navShaft, {
                        time: result.time,
                        pos: result.newPos,
                        overPos: result.overPos,
                        onEnd: onEnd
                    });
                    thumbsDraw(result.newPos);
                    o_shadows && setShadow($nav, findShadowEdge(result.newPos, navShaftTouchTail.min, navShaftTouchTail.max));
                } else {
                    onEnd();
                }
            },
            timeLow: .5,
            timeHigh: 2,
            friction: 5,
            $wrap: $nav
        });

        stageWheelTail = wheel($stage, {
            shift: true,
            onEnd: function (e, direction) {
                ////console.log('wheel $stage onEnd', direction);
                onTouchStart();
                onTouchEnd();
                that.show({ index: direction, slow: e.altKey })
            }
        });

        navWheelTail = wheel($nav, {
            onEnd: function (e, direction) {
                ////console.log('wheel $nav onEnd', direction);
                onTouchStart();
                onTouchEnd();
                var newPos = stop($navShaft) + direction * .25;
                $navShaft.css(getTranslate(minMaxLimit(newPos, navShaftTouchTail.min, navShaftTouchTail.max)));
                o_shadows && setShadow($nav, findShadowEdge(newPos, navShaftTouchTail.min, navShaftTouchTail.max));
                navWheelTail.prevent = { '<': newPos >= navShaftTouchTail.max, '>': newPos <= navShaftTouchTail.min };
                clearTimeout(navWheelTail.t);
                navWheelTail.t = setTimeout(function () {
                    slideNavShaft.l = newPos;
                    thumbsDraw(newPos, true)
                }, TOUCH_TIMEOUT);
                thumbsDraw(newPos);
            }
        });

        $wrap.hover(
            function () {
                setTimeout(function () {
                    if (touchedFLAG) return;
                    toggleControlsClass(!(hoverFLAG = true));
                }, 0);
            }, function () {
                if (!hoverFLAG) return;
                toggleControlsClass(!(hoverFLAG = false));
            }
        );

        function onNavFrameClick(e) {
            var index = $(this).data().eq;
            clickToShow({ index: index, slow: e.altKey, user: true, coo: e._x - $nav.offset().left });
        }

        function onArrClick(e) {
            clickToShow({ index: $arrs.index(this) ? '>' : '<', slow: e.altKey, user: true });
        }

        smartClick($arrs, function (e) {
            stopEvent(e);
            onArrClick.call(this, e);
        }, {
            onStart: function () {
                onTouchStart();
                stageShaftTouchTail.control = true;
            },
            onTouchEnd: onTouchEnd
        });

        function addFocusOnControls(el) {
            addFocus(el, function () {
                setTimeout(function () {
                    lockScroll($stage);
                }, 0);
                toggleControlsClass(false);
            });
        }

        $arrs.each(function () {
            addEnterUp(this, function (e) {
                onArrClick.call(this, e);
            });
            addFocusOnControls(this);
        });

        addEnterUp(fullscreenIcon, that.toggleFullScreen);
        addFocusOnControls(fullscreenIcon);

        function reset() {
            setData();
            setOptions();

            if (!reset.i) {
                reset.i = true;
                // Only once
                var _startindex = opts.startindex;
                if (_startindex || opts.hash && location.hash) {
                    startIndex = getIndexFromHash(_startindex || location.hash.replace(/^#/, ''), data, that.index === 0 || _startindex, _startindex);
                }
                activeIndex = repositionIndex = dirtyIndex = lastActiveIndex = startIndex = edgeIndex(startIndex) || 0;/*(o_rtl ? size - 1 : 0)*///;
            }

            if (size) {
                if (changeToRtl()) return;

                if ($videoPlaying) {
                    unloadVideo($videoPlaying, true);
                }

                activeIndexes = [];
                detachFrames(STAGE_FRAME_KEY);

                reset.ok = true;

                that.show({ index: activeIndex, time: 0 });
                that.resize();
            } else {
                that.destroy();
            }
        }

        function changeToRtl() {
            ////console.log('changeToRtl');
            if (!changeToRtl.f === o_rtl) {
                changeToRtl.f = o_rtl;
                activeIndex = size - 1 - activeIndex;
                ////console.log('changeToRtl execute, activeIndex is', activeIndex);
                that.reverse();

                return true;
            }
        }

        $.each('load push pop shift unshift reverse sort splice'.split(' '), function (i, method) {
            that[method] = function () {
                data = data || [];
                if (method !== 'load') {
                    Array.prototype[method].apply(data, arguments);
                } else if (arguments[0] && typeof arguments[0] === 'object' && arguments[0].length) {
                    data = clone(arguments[0]);
                }
                reset();
                return that;
            }
        });

        function ready() {
            if (!ready.ok) {
                ready.ok = true;
                triggerEvent('ready');
            }
        }

        reset();
    };


    $.fn.fotorama = function (opts) {
        return this.each(function () {
            var that = this,
                $fotorama = $(this),
                fotoramaData = $fotorama.data(),
                fotorama = fotoramaData.fotorama;

            if (!fotorama) {
                waitFor(function () {
                    return !isHidden(that);
                }, function () {
                    fotoramaData.urtext = $fotorama.html();
                    new $.Fotorama($fotorama,
                        /* Priority for options:
                         * 1. <div data-loop="true"></div>
                         * 2. $('div').fotorama({loop: false})
                         * 3. Defaults */
                        $.extend(
                            {},
                            OPTIONS,
                            window.fotoramaDefaults,
                            opts,
                            fotoramaData
                        )
                    );
                });
            } else {
                fotorama.setOptions(opts, true);
            }
        });
    };
    $.Fotorama.instances = [];

    function calculateIndexes() {
        $.each($.Fotorama.instances, function (index, instance) {
            instance.index = index;
        });
    }

    function addInstance(instance) {
        $.Fotorama.instances.push(instance);
        calculateIndexes();
    }

    function hideInstance(instance) {
        $.Fotorama.instances.splice(instance.index, 1);
        calculateIndexes();
    }
    $.Fotorama.cache = {};
    $.Fotorama.measures = {};
    $ = $ || {};
    $.Fotorama = $.Fotorama || {};
    $.Fotorama.jst = $.Fotorama.jst || {};

    $.Fotorama.jst.style = function (v) {
        var __t, __p = '', __e = _.escape;
        __p += '.fotorama' +
        ((__t = (v.s)) == null ? '' : __t) +
        ' .fotorama__nav--thumbs .fotorama__nav__frame{\npadding:' +
        ((__t = (v.m)) == null ? '' : __t) +
        'px;\nheight:' +
        ((__t = (v.h)) == null ? '' : __t) +
        'px}\n.fotorama' +
        ((__t = (v.s)) == null ? '' : __t) +
        ' .fotorama__thumb-border{\nheight:' +
        ((__t = (v.h - v.b * (v.q ? 0 : 2))) == null ? '' : __t) +
        'px;\nborder-width:' +
        ((__t = (v.b)) == null ? '' : __t) +
        'px;\nmargin-top:' +
        ((__t = (v.m)) == null ? '' : __t) +
        'px}';
        return __p
    };

    $.Fotorama.jst.video = function (v) {
        var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
        function print() { __p += __j.call(arguments, '') }
        __p += '<div class="fotorama__video"><iframe src="';
        print((v.type == 'youtube' ? v.p + 'youtube.com/embed/' + v.id + '?autoplay=1' : v.type == 'vimeo' ? v.p + 'player.vimeo.com/video/' + v.id + '?autoplay=1&badge=0' : v.id) + (v.s && v.type != 'custom' ? '&' + v.s : ''));
        __p += '" frameborder="0" allowfullscreen></iframe></div>\n';
        return __p
    };
    $(function () {
        $('.' + _fotoramaClass + ':not([data-auto="false"])').fotorama();
    });
})(window, document, location, typeof jQuery !== 'undefined' && jQuery);
$(document).ready(function () {

    $('.tooltip').each(function () {
        var $this = $(this);
        $this.tooltipster({
            theme: 'tooltipster-default',
            trigger: ($this.attr('data-tooltipaction') ? $this.attr('data-tooltipaction') : 'click'),
            interactive: 'true',
            contentAsHTML: 'true',
            maxWidth: '400'
        });
    });

    $('.datepicker').pickadate({
        formatSubmit: 'yyyy/mm/dd',
        // min: [2015, 7, 14],
        // editable: true,
        closeOnSelect: false,
        closeOnClear: false,
    })

    var $text = $('#priceChange');
    var $input = $('#minprice');
    $input.on('keydown', function () {
        setTimeout(function () {
            $text.html($input.value);
        }, 0);
    });

    // Hide detailsAlert if stored in cookie
    if ($.cookie('noShowAlert')) $('#detailsAlert').hide();
    else {
        $('#detailsAlert').removeClass("hide-details-alert");
        $("#close-alert").click(function () {
            $("#detailsAlert").fadeOut(1000);
            $.cookie('noShowAlert', true);
        });
    }
    $(".cta-fav").click(function () {
        $(this).hide();
        $('#alert-content').html('This home was saved to your notebook! <a href="/notebook"><u>Go to your Notebook</u></a>');
    });
    $(".cta-share").click(function () {
        $(this).hide();
        $('#alert-content').html('This home was successfully shared!');
    });

    var mobile = (/iphone|ipod|android|blackberry|mini|windows\sce|palm/i.test(navigator.userAgent.toLowerCase()));
    if (mobile) { $(".notebook-actions").remove(); }

    $('.update').hover(function () {
        $(this).toggleClass("hover");
    });

    $('.range-slider').jRange({
        from: '$',
        to: '$$$',
        step: 50000,
        scale: ['$', '$$$'],
        format: '%s',
        width: 768,
        showLabels: true,
        isRange: true
    });
    $('.chosen-select').chosen();

    //$('.js-sumoselect').SumoSelect();

    $('.ui.checkbox').checkbox();

    $('.ui.radio.checkbox').checkbox();

    $('.ui.dropdown').dropdown({
        on: 'hover'
    });

    $(':radio[name=rating]').change(function () {
        $('.choice').text(this.value);
    });

    $('#toggle').click(function () {
        $(this).next('.nav').toggleClass("is-collapsed-mobile");
    });
    $('#popup').click(function () {
        $('.offcanvas').toggleClass("is-collapsed-mobile");
    });

    $(".open-panel").click(function () {
        $("html").addClass("openNav");
    });

    $(".close-panel, #content").click(function () {
        $("html").removeClass("openNav");
    });





    // Scorecard Inline Editor
    $.fn.inlineEdit = function (replaceWith, connectWith) {

        $(this).hover(function () {
            $(this).addClass('hover');
        }, function () {
            $(this).removeClass('hover');
        });

        $(this).click(function () {

            var elem = $(this);

            elem.hide();
            elem.after(replaceWith);
            replaceWith.focus();

            replaceWith.blur(function () {

                if ($(this).val() != "") {
                    connectWith.val($(this).val()).change();
                    elem.text($(this).val());
                }

                $(this).remove();
                elem.show();
            });
        });
    };

    var replaceWith = $('<input name="temp" type="text" />'),
        connectWith = $('input[name="hiddenField"]');

    $('.scorecard-procon').inlineEdit(replaceWith, connectWith);

    // Organizer (Notebook) Nav
    $("#org__nav li").on('click', function (event) {
        $("#org__nav li").removeClass('current');
        $(this).addClass('current');
    });

    // Search Filter

    $(".filter").hide();

    // Share and Note Toggles

    function toggleExpand() {
        $('.expand').hide();
        $('body').on('click', '.toggler', function (e) {
            ToggleExpand($(this));
        });
        $('body').on('click', '.closeExpand', function () {
            $(this).parent().hide('slow');
            var relatedToggler = 'toggler-' + $(this).parent().attr('id');
            $('#' + relatedToggler).removeClass('expandExpanded');
        });
    };

    var ToggleExpand = function (target) {
        var id = target.attr('id');
        var widgetId = id.substring(id.indexOf('-') + 1, id.length);
        $('#' + widgetId).siblings('.expand').slideUp();
        $('#' + widgetId).delay().slideToggle();
        $(this).toggleClass('expandExpanded');
    };

    toggleExpand();

    //Accordion Tabs

    $('.accordion-tabs-minimal').each(function (index) {
        $(this).children('li').first().children('a').addClass('is-active').next().addClass('is-open').show();
    });

    $('.accordion-tabs-minimal').on('click', 'li > a', function (event) {
        if (!$(this).hasClass('is-active')) {
            event.preventDefault();
            var accordionTabs = $(this).closest('.accordion-tabs-minimal')
            accordionTabs.find('.is-open').removeClass('is-open').hide();

            $(this).next().toggleClass('is-open').toggle();
            accordionTabs.find('.is-active').removeClass('is-active');
            $(this).addClass('is-active');
        } else {
            event.preventDefault();
        }
    });

    // Basic Tabs

    $('.tab-list').each(function () {                   // Find lists of tabs
        var $this = $(this);                            // Store this list
        var $tab = $this.find('li.active');             // Get the active list item
        var $link = $tab.find('a');                     // Get link from active tab
        var $panel = $($link.attr('href'));             // Get active panel

        $this.on('click', '.tab-control', function (e) { // When click on a tab
            e.preventDefault();                           // Prevent link behavior
            var $link = $(this),                          // Store the current link
                id = this.hash;                           // Get href of clicked tab 

            if (id && !$link.is('.active')) {             // If not currently active
                $panel.removeClass('active');               // Make panel inactive
                $tab.removeClass('active');                 // Make tab inactive

                $panel = $(id).addClass('active');          // Make new panel active
                $tab = $link.parent().addClass('active');   // Make new tab active 
            }
        });
    });

    //Signin Toggle

    $('.toggleSignup').on('click', function (e) {
        e.preventDefault();
        if ($('.js-signinform').is(':visible')) {
            $('.js-signupform').show();
            $('.js-signinform').hide();
            if (typeof ga !== "undefined" && ga !== null) {
            }

            var socialButtons = $('.js-socialsignin-buttons');
            if (socialButtons.hasClass('hidden')) {
                socialButtons.removeClass('hidden');
                socialButtons.find('iframe[data-src]').each(function () {
                    $(this).attr('src', $(this).attr('data-src'));
                    $(this).attr('data-src', null);
                });
            }
        }
        else {
            $('.js-signinform').show();
            $('.js-signupform').hide();
        }
    });

    $(function () {
        $("#modal-1").on("change", function () {
            if ($(this).is(":checked")) {
                $("body").addClass("modal-open");
            } else {
                $("body").removeClass("modal-open");
            }
        });

        $(".modal-window").on("click", function () {
            if ($(this).hasClass('non-dismissable')) return;

            $(".modal-state:checked").prop("checked", false).change();
        });

        $(".modal-inner").on("click", function (e) {
            if ($(e.target).hasClass('toggleSignup') && CINC && CINC.Facebook && CINC.Facebook.SignupFormEvent) {
                CINC.Facebook.SignupFormEvent();
            }

            e.stopPropagation();
        });

    });

    // Common Scripts

    $('.range-slider2').jRange({
        from: 1900,
        to: 2015,
        step: 5,
        scale: [1900, 2015],
        format: '%s',
        width: 768,
        showLabels: true,
        isRange: true
    });
    $('#ca-container').contentcarousel({
        // speed for the sliding animation
        sliderSpeed: 1000,
        // easing for the sliding animation
        sliderEasing: 'easeOutExpo',
        // speed for the item animation (open / close)
        itemSpeed: 500,
        // easing for the item animation (open / close)
        itemEasing: 'easeOutExpo',
        // number of items to scroll at a time
        scroll: 1
    });
    $('.datepicker').pickadate({
        min: new Date(),
        format: 'yyyy/mm/dd',
        close: 'OK',
        closeOnSelect: false,
        closeOnClear: false,
        onClose: function () {
            $('.js-scheduleshowing').focus();
        }
    });

    if (CINC.CincProduct !== 'Houses' && !CINC.Site.IsBrandedSite && CINC.ControllerName !== 'SellerSuite') {
        function nlform() {
            var nlform = new NLForm(document.getElementById('nl-form'));
        }
        $(function () {
            nlform();
        });

        function chatWidget() {
            $(".chat-header").on("click", function (event) {
                $(".chat").toggleClass('opened');
            });
        }
        $(function () {
            chatWidget();
        });

    }

});


// ==========================================================================
// Number animations for market reports
// ==========================================================================

(function ($) {
    "use strict";

    $.fn.counterUp = function (options) {

        // Defaults
        var settings = $.extend({
            'time': 400,
            'delay': 10
        }, options);

        return this.each(function () {

            // Store the object
            var $this = $(this);
            var $settings = settings;

            var counterUpper = function () {
                var nums = [];
                var divisions = $settings.time / $settings.delay;
                var num = $this.text();
                var isComma = /[0-9]+,[0-9]+/.test(num);
                num = num.replace(/,/g, '');
                var isInt = /^[0-9]+$/.test(num);
                var isFloat = /^[0-9]+\.[0-9]+$/.test(num);
                var decimalPlaces = isFloat ? (num.split('.')[1] || []).length : 0;

                // Generate list of incremental numbers to display
                for (var i = divisions; i >= 1; i--) {

                    // Preserve as int if input was int
                    var newNum = parseInt(num / divisions * i);

                    // Preserve float if input was float
                    if (isFloat) {
                        newNum = parseFloat(num / divisions * i).toFixed(decimalPlaces);
                    }

                    // Preserve commas if input had commas
                    if (isComma) {
                        while (/(\d+)(\d{3})/.test(newNum.toString())) {
                            newNum = newNum.toString().replace(/(\d+)(\d{3})/, '$1' + ',' + '$2');
                        }
                    }

                    nums.unshift(newNum);
                }

                $this.data('counterup-nums', nums);
                $this.text('0');

                // Updates the number until we're done
                var f = function () {
                    $this.text($this.data('counterup-nums').shift());
                    if ($this.data('counterup-nums').length) {
                        setTimeout($this.data('counterup-func'), $settings.delay);
                    } else {
                        delete $this.data('counterup-nums');
                        $this.data('counterup-nums', null);
                        $this.data('counterup-func', null);
                    }
                };
                $this.data('counterup-func', f);

                // Start the count up
                setTimeout($this.data('counterup-func'), $settings.delay);
            };

            // Perform counts when the element gets into view
            $this.waypoint(counterUpper, { offset: '100%', triggerOnce: true });
        });

    };

})(jQuery);

/*jshint multistr:true, curly: false */
/*global jQuery:false, define: false */
/**
 * jRange - Awesome range control
 *
 * Written by
 * ----------
 * Nitin Hayaran (nitinhayaran@gmail.com)
 *
 * Licensed under the MIT (MIT-LICENSE.txt).
 *
 * @author Nitin Hayaran
 * @version 0.1-RELEASE
 *
 * Dependencies
 * ------------
 * jQuery (http://jquery.com)
 *
 **/
;
(function ($, window, document, undefined) {
    'use strict';

    var jRange = function () {
        return this.init.apply(this, arguments);
    };
    jRange.prototype = {
        defaults: {
            onstatechange: function () { },
            isRange: false,
            showLabels: true,
            showScale: true,
            step: 1,
            format: '%s',
            theme: 'theme-green',
            disable: false
        },
        template: '<div class="slider-container">\
      <div class="back-bar">\
                <div class="selected-bar"></div>\
                <div class="pointer low"></div><div class="pointer-label">123456</div>\
                <div class="pointer high"></div><div class="pointer-label">456789</div>\
                <div class="clickable-dummy"></div>\
            </div>\
            <div class="scale"></div>\
    </div>',
        init: function (node, options) {
            this.options = $.extend({}, this.defaults, options);
            this.inputNode = $(node);
            this.options.value = this.inputNode.val() || (this.options.isRange ? this.options.from + ',' + this.options.from : this.options.from);
            this.domNode = $(this.template);
            this.domNode.addClass(this.options.theme);
            this.inputNode.after(this.domNode);
            this.domNode.on('change', this.onChange);
            this.pointers = $('.pointer', this.domNode);
            this.lowPointer = this.pointers.first();
            this.highPointer = this.pointers.last();
            this.labels = $('.pointer-label', this.domNode);
            this.lowLabel = this.labels.first();
            this.highLabel = this.labels.last();
            this.scale = $('.scale', this.domNode);
            this.bar = $('.selected-bar', this.domNode);
            this.clickableBar = this.domNode.find('.clickable-dummy');
            this.interval = this.options.to - this.options.from;
            this.render();
        },
        render: function () {
            // Check if inputNode is visible, and have some width, so that we can set slider width accordingly.
            if (this.inputNode.width() === 0 && !this.options.width) {
                console.log('jRange : no width found, returning');
                return;
            } else {
                this.domNode.width(this.options.width || this.inputNode.width());
                this.inputNode.hide();
            }

            if (this.isSingle()) {
                this.lowPointer.hide();
                this.lowLabel.hide();
            }
            if (!this.options.showLabels) {
                this.labels.hide();
            }
            this.attachEvents();
            if (this.options.showScale) {
                this.renderScale();
            }
            this.setValue(this.options.value);
        },
        isSingle: function () {
            if (typeof (this.options.value) === 'number') {
                return true;
            }
            return (this.options.value.indexOf(',') !== -1 || this.options.isRange) ?
                false : true;
        },
        attachEvents: function () {
            this.clickableBar.click($.proxy(this.barClicked, this));
            this.pointers.on('mousedown touchstart', $.proxy(this.onDragStart, this));
            this.pointers.bind('dragstart', function (event) {
                event.preventDefault();
            });
        },
        onDragStart: function (e) {
            if (this.options.disable || (e.type === 'mousedown' && e.which !== 1)) {
                return;
            }
            e.stopPropagation();
            e.preventDefault();
            var pointer = $(e.target);
            this.pointers.removeClass('last-active');
            pointer.addClass('focused last-active');
            this[(pointer.hasClass('low') ? 'low' : 'high') + 'Label'].addClass('focused');
            $(document).on('mousemove.slider touchmove.slider', $.proxy(this.onDrag, this, pointer));
            $(document).on('mouseup.slider touchend.slider touchcancel.slider', $.proxy(this.onDragEnd, this));
        },
        onDrag: function (pointer, e) {
            e.stopPropagation();
            e.preventDefault();

            if (e.originalEvent.touches && e.originalEvent.touches.length) {
                e = e.originalEvent.touches[0];
            } else if (e.originalEvent.changedTouches && e.originalEvent.changedTouches.length) {
                e = e.originalEvent.changedTouches[0];
            }

            var position = e.clientX - this.domNode.offset().left;
            this.domNode.trigger('change', [this, pointer, position]);
        },
        onDragEnd: function (e) {
            this.pointers.removeClass('focused');
            this.labels.removeClass('focused');
            $(document).off('.slider');
        },
        barClicked: function (e) {
            if (this.options.disable) return;
            var x = e.pageX - this.clickableBar.offset().left;
            if (this.isSingle())
                this.setPosition(this.pointers.last(), x, true, true);
            else {
                var pointer = Math.abs(parseInt(this.pointers.first().css('left'), 10) - x + this.pointers.first().width() / 2) < Math.abs(parseInt(this.pointers.last().css('left'), 10) - x + this.pointers.first().width() / 2) ?
                    this.pointers.first() : this.pointers.last();
                this.setPosition(pointer, x, true, true);
            }
        },
        onChange: function (e, self, pointer, position) {
            var min, max;
            if (self.isSingle()) {
                min = 0;
                max = self.domNode.width();
            } else {
                min = pointer.hasClass('high') ? self.lowPointer.position().left + self.lowPointer.width() / 2 : 0;
                max = pointer.hasClass('low') ? self.highPointer.position().left + self.highPointer.width() / 2 : self.domNode.width();
            }
            var value = Math.min(Math.max(position, min), max);
            self.setPosition(pointer, value, true);
        },
        setPosition: function (pointer, position, isPx, animate) {
            var leftPos,
                lowPos = this.lowPointer.position().left,
                highPos = this.highPointer.position().left,
                circleWidth = this.highPointer.width() / 2;
            if (!isPx) {
                position = this.prcToPx(position);
            }
            if (pointer[0] === this.highPointer[0]) {
                highPos = Math.round(position - circleWidth);
            } else {
                lowPos = Math.round(position - circleWidth);
            }
            pointer[animate ? 'animate' : 'css']({
                'left': Math.round(position - circleWidth)
            });
            if (this.isSingle()) {
                leftPos = 0;
            } else {
                leftPos = lowPos + circleWidth;
            }
            this.bar[animate ? 'animate' : 'css']({
                'width': Math.round(highPos + circleWidth - leftPos),
                'left': leftPos
            });
            this.showPointerValue(pointer, position, animate);
            this.isReadonly();
        },
        // will be called from outside
        setValue: function (value) {
            var values = value.toString().split(',');
            this.options.value = value;
            var prc = this.valuesToPrc(values.length === 2 ? values : [0, values[0]]);
            if (this.isSingle()) {
                this.setPosition(this.highPointer, prc[1]);
            } else {
                this.setPosition(this.lowPointer, prc[0]);
                this.setPosition(this.highPointer, prc[1]);
            }
        },
        renderScale: function () {
            var s = this.options.scale || [this.options.from, this.options.to];
            var prc = Math.round((100 / (s.length - 1)) * 10) / 10;
            var str = '';
            for (var i = 0; i < s.length; i++) {
                str += '<span style="left: ' + i * prc + '%">' + (s[i] != '|' ? '<ins>' + s[i] + '</ins>' : '') + '</span>';
            }
            this.scale.html(str);

            $('ins', this.scale).each(function () {
                $(this).css({
                    marginLeft: -$(this).outerWidth() / 2
                });
            });
        },
        getBarWidth: function () {
            var values = this.options.value.split(',');
            if (values.length > 1) {
                return parseInt(values[1], 10) - parseInt(values[0], 10);
            } else {
                return parseInt(values[0], 10);
            }
        },
        showPointerValue: function (pointer, position, animate) {
            var label = $('.pointer-label', this.domNode)[pointer.hasClass('low') ? 'first' : 'last']();
            var text;
            var value = this.positionToValue(position);
            if ($.isFunction(this.options.format)) {
                var type = this.isSingle() ? undefined : (pointer.hasClass('low') ? 'low' : 'high');
                text = this.options.format(value, type);
            } else {
                text = this.options.format.replace('%s', value);
            }

            var width = label.html(text).width(),
                left = position - width / 2;
            left = Math.min(Math.max(left, 0), this.options.width - width);
            label[animate ? 'animate' : 'css']({
                left: left
            });
            this.setInputValue(pointer, value);
        },
        valuesToPrc: function (values) {
            var lowPrc = ((values[0] - this.options.from) * 100 / this.interval),
                highPrc = ((values[1] - this.options.from) * 100 / this.interval);
            return [lowPrc, highPrc];
        },
        prcToPx: function (prc) {
            return (this.domNode.width() * prc) / 100;
        },
        positionToValue: function (pos) {
            var value = (pos / this.domNode.width()) * this.interval;
            value = value + this.options.from;
            return Math.round(value / this.options.step) * this.options.step;
        },
        setInputValue: function (pointer, v) {
            // if(!isChanged) return;
            if (this.isSingle()) {
                this.options.value = v.toString();
            } else {
                var values = this.options.value.split(',');
                if (pointer.hasClass('low')) {
                    this.options.value = v + ',' + values[1];
                } else {
                    this.options.value = values[0] + ',' + v;
                }
            }
            if (this.inputNode.val() !== this.options.value) {
                this.inputNode.val(this.options.value);
                this.options.onstatechange.call(this, this.options.value);
            }
        },
        getValue: function () {
            return this.options.value;
        },
        isReadonly: function () {
            this.domNode.toggleClass('slider-readonly', this.options.disable);
        },
        disable: function () {
            this.options.disable = true;
            this.isReadonly();
        },
        enable: function () {
            this.options.disable = false;
            this.isReadonly();
        },
        toggleDisable: function () {
            this.options.disable = !this.options.disable;
            this.isReadonly();
        }
    };

    /*$.jRange = function (node, options) {
      var jNode = $(node);
      if(!jNode.data('jrange')){
        jNode.data('jrange', new jRange(node, options));
      }
      return jNode.data('jrange');
    };
    $.fn.jRange = function (options) {
      return this.each(function(){
        $.jRange(this, options);
      });
    };*/

    var pluginName = 'jRange';
    // A really lightweight plugin wrapper around the constructor,
    // preventing against multiple instantiations
    $.fn[pluginName] = function (option) {
        var args = arguments,
            result;

        this.each(function () {
            var $this = $(this),
                data = $.data(this, 'plugin_' + pluginName),
                options = typeof option === 'object' && option;
            if (!data) {
                $this.data('plugin_' + pluginName, (data = new jRange(this, options)));
                $(window).resize(function () {
                    data.setValue(data.getValue());
                }); // Update slider position when window is resized to keep it in sync with scale
            }
            // if first argument is a string, call silimarly named function
            // this gives flexibility to call functions of the plugin e.g.
            //   - $('.dial').plugin('destroy');
            //   - $('.dial').plugin('render', $('.new-child'));
            if (typeof option === 'string') {
                result = data[option].apply(data, Array.prototype.slice.call(args, 1));
            }
        });

        // To enable plugin returns values
        return result || this;
    };

})(jQuery, window, document);

(function () {

    var bodyEl = document.body,
        content = document.querySelector('.content-wrap'),
        openbtn = document.getElementById('open-button'),
        closebtn = document.getElementById('close-button'),
        isOpen = false;

    function init() {
        initEvents();
    }

    function initEvents() {
        if (openbtn) {
            openbtn.addEventListener('click', toggleMenu);
        }
        if (closebtn) {
            closebtn.addEventListener('click', toggleMenu);
        }
        // close the menu element if the target is not the menu element or one of its descendants..
        if (content) {
            content.addEventListener('click', function (ev) {
                var target = ev.target;
                if (isOpen && target !== openbtn) {
                    toggleMenu();
                }
            });
        }
    }

    function toggleMenu() {
        if (isOpen) {
            classie.remove(bodyEl, 'show-menu');
        }
        else {
            classie.add(bodyEl, 'show-menu');
        }
        isOpen = !isOpen;
    }

    init();

})();

(function () {
    var onInputChange = function (e) {
        var $el = $(this);
        if ($el.is(':focus') || $.trim($el.val()) !== '') {
            $el.parent().addClass('input--filled');
        }
        else {
            $el.parent().removeClass('input--filled');
        }
    };
    var onInputFocus = function (e) {
        $(this).parent().addClass('input--filled');
    }
    var onInputBlur = function (e) {
        var $el = $(this);
        if ($.trim($el.val()) === '') {
            $el.parent().removeClass('input--filled');
        }
    }
    $('input.input__field').each(function (el) {
        var $el = $(this);
        if ($.trim($el.val()) !== '') {
            $el.parent().addClass('input--filled');
        }
        $el.on('focus', onInputFocus);
        $el.on('blur', onInputBlur);
        $el.on('change', onInputChange);
    });
}());

(function ($) {
    var $window = $(window);
    var windowHeight = $window.height();

    $window.resize(function () {
        windowHeight = $window.height();
    });

    $.fn.parallax = function (xpos, speedFactor, outerHeight) {
        var $this = $(this);
        var getHeight;
        var firstTop;
        var paddingTop = 0;

        //get the starting position of each element to have parallax applied to it		
        $this.each(function () {
            firstTop = $this.offset().top;
        });

        if (outerHeight) {
            getHeight = function (jqo) {
                return jqo.outerHeight(true);
            };
        } else {
            getHeight = function (jqo) {
                return jqo.height();
            };
        }

        // setup defaults if arguments aren't specified
        if (arguments.length < 1 || xpos === null) xpos = "50%";
        if (arguments.length < 2 || speedFactor === null) speedFactor = 0.1;
        if (arguments.length < 3 || outerHeight === null) outerHeight = true;

        // function to be called whenever the window is scrolled or resized
        function update() {
            var pos = $window.scrollTop();

            $this.each(function () {
                var $element = $(this);
                var top = $element.offset().top;
                var height = getHeight($element);

                // Check if totally above or totally below viewport
                if (top + height < pos || top > pos + windowHeight) {
                    return;
                }

                $this.css('backgroundPosition', xpos + " " + Math.round((firstTop - pos) * speedFactor) + "px");
            });
        }

        $window.bind('scroll', update).resize(update);
        update();
    };
})(jQuery);





/*
 * jQuery Final Tiles Grid Gallery
 * Version 2.0
 * by GreenTreeLabs
 * http://greentreelabs.net
 * 
 * http://codecanyon.net/item/final-tiles-grid-gallery/4734090?ref=GreenTreeLabs
 */


//credits James Padolsey http://james.padolsey.com/
var qualifyURL = function (url) {
    var img = document.createElement('img');
    img.src = url; // set string url
    url = img.src; // get qualified url
    img.src = null; // no server request
    return url;
};

(function ($, window, document, undefined) {

    $.fn.visible = function (partial) {

        if (!$(this).offset())
            return true;

        var $t = $(this),
            $w = $(window),
            viewTop = $w.scrollTop(),
            viewBottom = viewTop + $w.height(),
            _top = $t.offset().top,
            _bottom = _top + $t.height(),
            compareTop = partial === true ? _bottom : _top,
            compareBottom = partial === true ? _top : _bottom;

        return ((compareBottom <= viewBottom) && (compareTop >= viewTop));

    };

    var pluginName = "finalTilesGallery",
        defaults = {
            margin: 10,
            minTileWidth: 200,
            ignoreImageAttributes: true,
            imageSizeFactor: [
                [4000, .9],
                [1024, .8],
                [800, .7],
                [600, .6],
                [480, .5],
                [320, .3]
            ],
            gridSize: 12,
            allowEnlargement: true,
            autoLoadURL: null,
            autoLoadOffset: 50,
            onComplete: function () { },
            onUpdate: function () { },
            debug: false
        };

    // The actual plugin constructor
    function Plugin(element, options) {
        this.element = element;
        this.$element = $(element);
        this.settings = $.extend({}, defaults, options);
        if (!this.settings.gridSize)
            this.settings.gridSize = 5;
        this._defaults = defaults;
        this._name = pluginName;
        this.tiles = [];
        this._loadedImages = 0;
        this.edges = [];
        this.currentWidth = 0;
        this.currentImageSizeFactor = 1;
        this.ajaxComplete = false;
        this.isLoading = false;
        this.currentPage = 1;
        this.init();
    }

    // Avoid Plugin.prototype conflicts
    $.extend(Plugin.prototype, {
        print: function (text) {
            if (this.settings.debug)
                console.log(text);
        },
        setCurrentImageSizeFactor: function () {
            this.currentImageSizeFactor = 1;
            var ww = $(window).width();
            for (var i = 0; i < this.settings.imageSizeFactor.length; i++) {
                if (this.settings.imageSizeFactor[i][0] >= ww)
                    this.currentImageSizeFactor = this.settings.imageSizeFactor[i][1];
            }
            if (!this.currentImageSizeFactor)
                this.currentImageSizeFactor = 1;
            this.print("current image size factor: " + this.currentImageSizeFactor + " (" + ww + ")");
        },
        init: function () {
            var instance = this;
            this.$element.find(".ftg-items").css({
                position: 'relative',
                height: 500
            });
            this.tiles = this.$element.find('.tile').not('.ftg-hidden');

            this.tiles.css({
                transition: 'all .3s'
            });
            this.currentWidth = this.$element.width();
            this.print("this.currentWidth: " + this.currentWidth);

            var _resizeTo = 0;
            this.setCurrentImageSizeFactor();
            $(window).resize(function () {
                _resizeTo = setTimeout(function () {
                    if (instance.currentWidth != instance.$element.width()) {
                        clearTimeout(_resizeTo);
                        instance.print("this.currentWidth", this.currentWidth);
                        instance.currentWidth = instance.$element.width();
                        instance.setCurrentImageSizeFactor();
                        instance.refresh();
                    }
                }, 500);
            });

            if (instance.settings.autoLoadURL) {
                $(window).scroll(function () {
                    if (!instance.ajaxComplete && !instance.isLoading) {
                        if ($(window).scrollTop() >= $(document).height() - $(window).height() - instance.settings.autoLoadOffset) {
                            instance.isLoading = true;
                            $.get(instance.settings.autoLoadURL, { page: ++instance.currentPage }, function (html) {
                                if ($.trim(html).length == 0) {
                                    instance.ajaxComplete = true;
                                } else {
                                    instance.$element.find(".ftg-items").append(html);
                                    instance.tiles = instance.$element.find('.tile')
                                    instance.loadImage();
                                }
                            });
                        }
                    }
                });
            }

            /*$(window).scroll(function (event) {
                instance.tiles.each(function (i, el) {
                    var $el = instance.tiles.eq(i);
                    if ($el.visible(true)) {
                        instance.tiles
                            .splice(i, 1);
                        $el
                            .addClass("effect-" + instance.settings.scrollEffect)
                            .removeClass('module');
                    }
                });
            });*/
            this.setupFilters();
            this.edges.push({ left: 0, top: 0, width: this.currentWidth, index: 0 });
            this.loadImage();
        },
        setupFilters: function () {
            var instance = this;
            instance.$element.find(".ftg-filters a").click(function (e) {
                e.preventDefault();

                instance.$element.find(".ftg-filters a").removeClass("selected");
                $(this).addClass("selected");

                var ft = $(this).attr("href").replace("#ftg-set-", "");
                if (ft == "ftgall") {
                    instance.$element.find(".tile").removeClass("ftg-hidden");
                } else {
                    instance.$element
                                .find(".tile")
                                .not(".ftg-set-" + ft)
                                .addClass("ftg-hidden")
                                .end()
                                .filter(".ftg-set-" + ft)
                                .removeClass("ftg-hidden");
                }
                instance.refresh();
            });
        },
        printEdges: function () {
            this.$element.find(".edge").remove();
            for (i = 0; i < this.edges.length; i++) {
                var $e = $("<div class='edge' />");
                $e.append("top: " + this.edges[i].top + "<br>");
                $e.append("left: " + this.edges[i].left + "<br>");
                $e.append("width: " + this.edges[i].width + "<br>");
                $e.css({
                    left: this.edges[i].left,
                    top: this.edges[i].top,
                    marginTop: -25,
                    marginLeft: 20
                });
                this.$element.append($e);
            }
        },
        printEdge: function (edge) {
            var $e = $("<div class='edge enlarged-" + edge.enlarged + "' />");
            $e.append("<b>" + edge.index + " " + edge['case'] + "</b><br>");
            $e.append("t: " + Math.round(edge.top) + " l: " + edge.left + "<br>");
            $e.append("width: " + edge.width + "<br>");
            $e.append("idx: " + edge.tileIndex + "<br>");

            $e.css({
                left: edge.left,
                top: edge.top,
                marginTop: -25,
                marginLeft: 20
            });
            this.$element.append($e);
        },
        refresh: function () {
            this.$element.find(".edge").remove();
            this.edges = [
                { left: 0, top: 0, width: this.currentWidth }
            ];
            this.tiles.removeClass("ftg-loaded ftg-enlarged");
            this.tiles = this.$element.find('.tile').not('.ftg-hidden');
            this._loadedImages = 0;
            this.loadImage();
        },
        loadImage: function () {
            var instance = this;
            var $tile = this.tiles.eq(this._loadedImages);

            if ($tile.children("iframe").length)
                $tile.children("iframe").addClass("item");

            var $item = $tile.find('.item');
            function next() {
                instance.add(instance._loadedImages);

                if (++instance._loadedImages < instance.tiles.length) {
                    instance.loadImage();
                } else {
                    var height = instance.lowerEdgeTop();
                    instance.print("lower edge top: " + height);
                    instance.$element.find(".ftg-items").height(height);
                    instance.isLoading = false;
                    instance.settings.onComplete();
                }
            }

            switch ($item.get(0).tagName.toLowerCase()) {
                case "img":
                    var img = new Image();
                    img.onload = function () {
                        var iFactor = instance.currentImageSizeFactor;
                        if ($tile.data("ftg-ignore-size-factor"))
                            iFactor = 1;

                        $item.attr("src", this.src);
                        $item.data("width", img.width * iFactor);
                        $item.data("height", img.height * iFactor);
                        $item.data("owidth", img.width);
                        $item.data("oheight", img.height);
                        next();
                    }
                    img.onerror = function () {
                        instance.print("error loading image: " + img.src);
                        next();
                    }
                    img.src = $item.data("src");
                    $tile.data("ftg-type", "image");
                    break;
                case "iframe":
                    $item.data("width", parseInt($item.attr("width")));
                    $item.data("height", parseInt($item.attr("height")));
                    $item.data("owidth", parseInt($item.attr("width")));
                    $item.data("oheight", parseInt($item.attr("height")));
                    $tile.data("ftg-type", "iframe");
                    next();
                    break;
                default:
                    $item.data("width", $item.data("width"));
                    $item.data("height", $item.data("height"));
                    $item.data("owidth", $item.data("width"));
                    $item.data("oheight", $item.data("height"));
                    $tile.data("ftg-type", "generic");
                    next();
                    break;
            }
        },
        higherEdge: function () {
            var left = 0;
            var _top = 100000;
            var _left = 0;
            var found = 0;

            for (var i = 0; i < this.edges.length; i++) {
                if (this.edges[i].top < _top) {
                    found = i;
                    _top = this.edges[i].top;
                }
            }

            return this.edges[found];
        },
        lowerEdgeTop: function () {
            var min = 0;
            for (var i = 0; i < this.edges.length; i++) {
                if (this.edges[i].top > min) {
                    min = this.edges[i].top;
                }
            }

            return min;
        },
        alignEdge: function (edge, index) {
            //look left
            for (var i = 0; i < this.edges.length; i++) {
                if (this.edges[i].left + this.edges[i].width + this.settings.margin == edge.left) {
                    this.print("found edge on left", i);
                    //adjust edge
                    if (edge.top == this.edges[i].top) {
                        this.print("edges can be aligned [1]");
                        return { side: 'left', edge: this.edges[i] };
                    }
                }
            }
            //TODO look right
            for (var i = 0; i < this.edges.length; i++) {
                if (this.edges[i].left - this.settings.margin == edge.left + edge.width) {
                    this.print("found edge on right", i);
                    //adjust edge
                    if (edge.top == this.edges[i].top) {
                        this.print("edges can be aligned [2]");
                        return { side: 'right', edge: this.edges[i] };
                    }
                }
            }

            return null;
        },
        removeEdge: function (edge) {
            var tmp = [];
            for (var i = 0; i < this.edges.length; i++) {
                if (this.edges[i] != edge)
                    tmp.push(this.edges[i]);
            }
            this.edges = tmp;
        },
        add: function (tileIndex) {
            var $t = this.tiles.eq(tileIndex);

            var $item = $t.find('.item');
            var w = $item.data('width');
            var h = $item.data('height');

            var hEdge = this.higherEdge();
            this.print(hEdge);
            hEdge.tileIndex = tileIndex;

            this.print(tileIndex + " [" + $t.data("ftg-type") + "] (" + w + "x" + h + ")");

            if (hEdge.top > 0) {
                hEdge.top += this.settings.margin;
            }

            $t.css({
                left: hEdge.left,
                top: hEdge.top,
                position: 'absolute'
            });

            hEdge.enlarged = false;

            //is the tile wider than the current edge?
            console.log("=> ", hEdge.width, w, this.settings.margin);
            if (hEdge.width < w + this.settings.margin) {
                hEdge['case'] = 'Te';
                this.print('Te', hEdge.width);
                //edge smaller than the image
                var w2 = hEdge.width;
                var h2 = (h / w) * w2;

                if (w2 + hEdge.left - this.settings.margin == this.currentWidth) {
                    this.print("END");
                    w2 -= this.settings.margin;
                    h2 = (h / w) * w2;
                }

                w = w2;
                h = h2;
            } else if (hEdge.width > w) {
                this.print('tE');
                //break the edge
                //is the new edge wider than minTileWidth?
                if (hEdge.width - w >= this.settings.minTileWidth) {
                    hEdge['case'] = 'tE';
                    this.print('tE1', hEdge.width, hEdge.left, this.currentWidth);

                    var newEdge = {
                        left: hEdge.left + w + this.settings.margin,
                        top: hEdge.top - (hEdge.top > 0 ? this.settings.margin : 0),
                        width: hEdge.width - w - this.settings.margin,
                        marginLeft: true,
                        'case': 'NEW',
                        index: hEdge.index + 1
                    }

                    //console.log("newEdge", newEdge);
                    this.edges.push(newEdge);
                    //this.printEdge(newEdge);
                } else {
                    hEdge['case'] = 'tE2';
                    this.print('tE2');
                    //not enough space for the next tile
                    //enlargement
                    this.print("enlargement", hEdge.width, hEdge.left, this.currentWidth);
                    var m = hEdge.left + hEdge.width == this.currentWidth ? 0 : this.settings.margin;
                    //var w2 = hEdge.width - m;
                    var w2 = hEdge.width;
                    var h2 = this.settings.allowEnlargement ? (h / w) * w2 : h;

                    if (this.settings.allowEnlargement) {
                        $t.addClass("ftg-enlarged");
                        hEdge.enlarged = true;
                    } else {
                        $t.find(".item").css({
                            width: w,
                            height: h
                        });
                    }

                    w = w2;
                    h = h2;
                }
            }

            hEdge.top += h;
            var diff = hEdge.top % this.settings.gridSize;
            hEdge.top -= diff;
            h -= diff;

            hEdge.left = hEdge.left;
            hEdge.width = w;
            //hEdge.index = tileIndex + 1;

            var printEdge = true;

            var aligned = this.alignEdge(hEdge, tileIndex);
            if (aligned) {
                if (aligned.side == 'left') {
                    this.removeEdge(hEdge);
                    aligned.edge.width += w + this.settings.margin;
                    h = h - (hEdge.top - aligned.edge.top);
                    hEdge.top -= h;
                    printEdge = false;
                } else {
                    this.removeEdge(aligned.edge);
                    hEdge.width += this.settings.margin + aligned.edge.width;
                    printEdge = false;
                }

                $t.height(h);
            }

            if (this.$element.find(".ftg-items").height() < hEdge.top)
                this.$element.find(".ftg-items").height(hEdge.top);

            if (this.settings.debug && printEdge) {
                this.printEdge(hEdge);
            }

            if ($t.data("ftg-type") == "iframe") {
                $t.find("iframe").height(h);
            }

            this.print(w + "x" + h);
            this.print("----");

            $t.css({
                width: w,
                height: h
            });

            var ratio = w / $item.data("width");

            var hdiff = ($item.data("height") * ratio) - h;
            $item.css({
                top: 0 - (hdiff / 2)
            });
            $t.addClass("ftg-loaded");
        }
    });

    $.fn[pluginName] = function (options) {
        this.each(function () {
            if (!$.data(this, "plugin_" + pluginName)) {
                $.data(this, "plugin_" + pluginName, new Plugin(this, options));
            }
        });

        // chain jQuery functions
        return this;
    };

    $(function () {
        $(".ftg-social a").click(function (e) {

            e.preventDefault();
            var social = $(this).data("social");
            var $tile = $(this).parents(".tile").first();
            var image = $tile.data("big");
            if (!image)
                image = $tile.find(".item").attr("src");

            var text = $.trim($tile.find(".caption").text());
            if (!text.length)
                text = document.title;

            if (social == "facebook") {
                var url = "https://www.facebook.com/dialog/feed?app_id=1447224948871585&" +
                            "link=" + encodeURIComponent(location.href) + "&" +
                            "display=popup&" +
                            "name=" + encodeURIComponent(document.title) + "&" +
                            "caption=&" +
                            "description=" + encodeURIComponent(text) + "&" +
                            "picture=" + encodeURIComponent(qualifyURL(image)) + "&" +
                            "ref=share&" +
                            "actions={%22name%22:%22View%20the%20gallery%22,%20%22link%22:%22" + encodeURIComponent(location.href) + "%22}&" +
                            "redirect_uri=http://final-tiles-gallery.com/facebook_redirect.html";

                var w = window.open(url, "ftgw", "location=1,status=1,scrollbars=1,width=600,height=400");
                w.moveTo((screen.width / 2) - (300), (screen.height / 2) - (200));
            }

            if (social == "twitter") {
                var w = window.open("https://twitter.com/intent/tweet?url=" + encodeURI(location.href.split('#')[0]) + "&text=" + encodeURI(text), "ftgw", "location=1,status=1,scrollbars=1,width=600,height=400");
                w.moveTo((screen.width / 2) - (300), (screen.height / 2) - (200));
            }

            if (social == "pinterest") {
                var url = "http://pinterest.com/pin/create/button/?url=" + encodeURIComponent(location.href) + "&description=" + encodeURI(text);

                url += ("&media=" + encodeURIComponent(qualifyURL(image)));

                var w = window.open(url, "ftgw", "location=1,status=1,scrollbars=1,width=600,height=400");
                w.moveTo((screen.width / 2) - (300), (screen.height / 2) - (200));
            }
        });
    });
})(jQuery, window, document);
/**
 * jquery.slitslider.js v1.1.0
 * http://www.codrops.com
 *
 * Licensed under the MIT license.
 * http://www.opensource.org/licenses/mit-license.php
 * 
 * Copyright 2012, Codrops
 * http://www.codrops.com
 */

;( function( $, window, undefined ) {
	
	'use strict';

	/*
	* debouncedresize: special jQuery event that happens once after a window resize
	*
	* latest version and complete README available on Github:
	* https://github.com/louisremi/jquery-smartresize/blob/master/jquery.debouncedresize.js
	*
	* Copyright 2011 @louis_remi
	* Licensed under the MIT license.
	*/
	var $event = $.event,
	$special,
	resizeTimeout;

	$special = $event.special.debouncedresize = {
		setup: function() {
			$( this ).on( "resize", $special.handler );
		},
		teardown: function() {
			$( this ).off( "resize", $special.handler );
		},
		handler: function( event, execAsap ) {
			// Save the context
			var context = this,
				args = arguments,
				dispatch = function() {
					// set correct event type
					event.type = "debouncedresize";
					$event.dispatch.apply( context, args );
				};

			if ( resizeTimeout ) {
				clearTimeout( resizeTimeout );
			}

			execAsap ?
				dispatch() :
				resizeTimeout = setTimeout( dispatch, $special.threshold );
		},
		threshold: 20
	};

	// global
	var $window = $( window ),
		$document = $( document ),
		Modernizr = window.Modernizr;

	$.Slitslider = function( options, element ) {
		
		this.$elWrapper = $( element );
		this._init( options );
		
	};

	$.Slitslider.defaults = {
		// transitions speed
		speed : 800,
		// if true the item's slices will also animate the opacity value
		optOpacity : false,
		// amount (%) to translate both slices - adjust as necessary
		translateFactor : 230,
		// maximum possible angle
		maxAngle : 25,
		// maximum possible scale
		maxScale : 2,
		// slideshow on / off
		autoplay : false,
		// keyboard navigation
		keyboard : true,
		// time between transitions
		interval : 4000,
		// callbacks
		onBeforeChange : function( slide, idx ) { return false; },
		onAfterChange : function( slide, idx ) { return false; }
	};

	$.Slitslider.prototype = {

		_init : function( options ) {
			
			// options
			this.options = $.extend( true, {}, $.Slitslider.defaults, options );

			// https://github.com/twitter/bootstrap/issues/2870
			this.transEndEventNames = {
				'WebkitTransition' : 'webkitTransitionEnd',
				'MozTransition' : 'transitionend',
				'OTransition' : 'oTransitionEnd',
				'msTransition' : 'MSTransitionEnd',
				'transition' : 'transitionend'
			};
			this.transEndEventName = this.transEndEventNames[ Modernizr.prefixed( 'transition' ) ];
			// suport for css 3d transforms and css transitions
			this.support = Modernizr.csstransitions && Modernizr.csstransforms3d;
			// the slider
			this.$el = this.$elWrapper.children( '.sl-slider' );
			// the slides
			this.$slides = this.$el.children( '.sl-slide' ).hide();
			// total slides
			this.slidesCount = this.$slides.length;
			// current slide
			this.current = 0;
			// control if it's animating
			this.isAnimating = false;
			// get container size
			this._getSize();
			// layout
			this._layout();
			// load some events
			this._loadEvents();
			// slideshow
			if( this.options.autoplay ) {
			
				this._startSlideshow();
			
			}

		},
		// gets the current container width & height
		_getSize : function() {

			this.size = {
				width : this.$elWrapper.outerWidth( true ),
				height : this.$elWrapper.outerHeight( true )
			};

		},
		_layout : function() {
			
			this.$slideWrapper = $( '<div class="sl-slides-wrapper" />' );
			
			// wrap the slides
			this.$slides.wrapAll( this.$slideWrapper ).each( function( i ) {
				
				var $slide = $( this ),
					// vertical || horizontal
					orientation = $slide.data( 'orientation' );
					
				$slide.addClass( 'sl-slide-' + orientation )
					  .children()
					  .wrapAll( '<div class="sl-content-wrapper" />' )
					  .wrapAll( '<div class="sl-content" />' );
			
			} );
			
			// set the right size of the slider/slides for the current window size
			this._setSize();
			// show first slide
			this.$slides.eq( this.current ).show();
			
		},
		_navigate : function( dir, pos ) {
			
			if( this.isAnimating || this.slidesCount < 2 ) {
			
				return false;
			
			}

			this.isAnimating = true;

			var self = this,
				$currentSlide = this.$slides.eq( this.current );

			// if position is passed
			if( pos !== undefined ) {

				this.current = pos;

			}
			// if not check the boundaries
			else if( dir === 'next' ) {

				this.current = this.current < this.slidesCount - 1 ? ++this.current : 0;

			}
			else if( dir === 'prev' ) {

				this.current = this.current > 0 ? --this.current : this.slidesCount - 1;

			}

			this.options.onBeforeChange( $currentSlide, this.current );
			
			// next slide to be shown
			var $nextSlide = this.$slides.eq( this.current ),
				// the slide we want to cut and animate
				$movingSlide = ( dir === 'next' ) ? $currentSlide : $nextSlide,
				
				// the following are the data attrs set for each slide
				configData = $movingSlide.data(),
				config = {};
			
			config.orientation = configData.orientation || 'horizontal',
			config.slice1angle = configData.slice1Rotation || 0,
			config.slice1scale = configData.slice1Scale || 1,
			config.slice2angle = configData.slice2Rotation || 0,
			config.slice2scale = configData.slice2Scale || 1;
				
			this._validateValues( config );
			
			var cssStyle = config.orientation === 'horizontal' ? {
					marginTop : -this.size.height / 2
				} : {
					marginLeft : -this.size.width / 2
				},
				// default slide's slices style
				resetStyle = {
					'transform' : 'translate(0%,0%) rotate(0deg) scale(1)',
					opacity : 1 
				},
				// slice1 style
				slice1Style	= config.orientation === 'horizontal' ? {
					'transform' : 'translateY(-' + this.options.translateFactor + '%) rotate(' + config.slice1angle + 'deg) scale(' + config.slice1scale + ')'
				} : {
					'transform' : 'translateX(-' + this.options.translateFactor + '%) rotate(' + config.slice1angle + 'deg) scale(' + config.slice1scale + ')'
				},
				// slice2 style
				slice2Style	= config.orientation === 'horizontal' ? {
					'transform' : 'translateY(' + this.options.translateFactor + '%) rotate(' + config.slice2angle + 'deg) scale(' + config.slice2scale + ')'
				} : {
					'transform' : 'translateX(' + this.options.translateFactor + '%) rotate(' + config.slice2angle + 'deg) scale(' + config.slice2scale + ')'
				};
			
			if( this.options.optOpacity ) {
			
				slice1Style.opacity = 0;
				slice2Style.opacity = 0;
			
			}
			
			// we are adding the classes sl-trans-elems and sl-trans-back-elems to the slide that is either coming "next"
			// or going "prev" according to the direction.
			// the idea is to make it more interesting by giving some animations to the respective slide's elements
			//( dir === 'next' ) ? $nextSlide.addClass( 'sl-trans-elems' ) : $currentSlide.addClass( 'sl-trans-back-elems' );
			
			$currentSlide.removeClass( 'sl-trans-elems' );

			var transitionProp = {
				'transition' : 'all ' + this.options.speed + 'ms ease-in-out'
			};

			// add the 2 slices and animate them
			$movingSlide.css( 'z-index', this.slidesCount )
						.find( 'div.sl-content-wrapper' )
						.wrap( $( '<div class="sl-content-slice" />' ).css( transitionProp ) )
						.parent()
						.cond(
							dir === 'prev', 
							function() {
							
								var slice = this;
								this.css( slice1Style );
								setTimeout( function() {
									
									slice.css( resetStyle );

								}, 50 );
										 
							}, 
							function() {
								
								var slice = this;
								setTimeout( function() {
									
									slice.css( slice1Style );

								}, 50 );
						
							}
						)
						.clone()
						.appendTo( $movingSlide )
						.cond(
							dir === 'prev', 
							function() {
								
								var slice = this;
								this.css( slice2Style );
								setTimeout( function() {

									$currentSlide.addClass( 'sl-trans-back-elems' );

									if( self.support ) {

										slice.css( resetStyle ).on( self.transEndEventName, function() {

											self._onEndNavigate( slice, $currentSlide, dir );

										} );

									}
									else {

										self._onEndNavigate( slice, $currentSlide, dir );

									}

								}, 50 );
						
							},
							function() {
								
								var slice = this;
								setTimeout( function() {

									$nextSlide.addClass( 'sl-trans-elems' );
									
									if( self.support ) {

										slice.css( slice2Style ).on( self.transEndEventName, function() {

											self._onEndNavigate( slice, $currentSlide, dir );

										} );

									}
									else {

										self._onEndNavigate( slice, $currentSlide, dir );

									}

								}, 50 );
								
							}
						)
						.find( 'div.sl-content-wrapper' )
						.css( cssStyle );
			
			$nextSlide.show();
			
		},
		_validateValues : function( config ) {
			
			// OK, so we are restricting the angles and scale values here.
			// This is to avoid the slices wrong sides to be shown.
			// you can adjust these values as you wish but make sure you also ajust the
			// paddings of the slides and also the options.translateFactor value and scale data attrs
			if( config.slice1angle > this.options.maxAngle || config.slice1angle < -this.options.maxAngle ) {
				
				config.slice1angle = this.options.maxAngle;
			
			}
			if( config.slice2angle > this.options.maxAngle  || config.slice2angle < -this.options.maxAngle ) {
				
				config.slice2angle = this.options.maxAngle;
			
			}
			if( config.slice1scale > this.options.maxScale || config.slice1scale <= 0 ) {
			
				config.slice1scale = this.options.maxScale;
			
			}
			if( config.slice2scale > this.options.maxScale || config.slice2scale <= 0 ) {
				
				config.slice2scale = this.options.maxScale;
			
			}
			if( config.orientation !== 'vertical' && config.orientation !== 'horizontal' ) {
			
				config.orientation = 'horizontal'
			
			}
			
		},
		_onEndNavigate : function( $slice, $oldSlide, dir ) {
			
			// reset previous slide's style after next slide is shown
			var $slide = $slice.parent(),
				removeClasses = 'sl-trans-elems sl-trans-back-elems';
			
			// remove second slide's slice
			$slice.remove();
			// unwrap..
			$slide.css( 'z-index', 1 )
				  .find( 'div.sl-content-wrapper' )
				  .unwrap();
			
			// hide previous current slide
			$oldSlide.hide().removeClass( removeClasses );
			$slide.removeClass( removeClasses );
			// now we can navigate again..
			this.isAnimating = false;
			this.options.onAfterChange( $slide, this.current );
			
		},
		_setSize : function() {
		
			// the slider and content wrappers will have the window's width and height
			var cssStyle = {
				width : this.size.width,
				height : this.size.height
			};
			
			this.$el.css( cssStyle ).find( 'div.sl-content-wrapper' ).css( cssStyle );
		
		},
		_loadEvents : function() {
			
			var self = this;
			
			$window.on( 'debouncedresize.slitslider', function( event ) {
				
				// update size values
				self._getSize();
				// set the sizes again
				self._setSize();
				
			} );

			if ( this.options.keyboard ) {
				
				$document.on( 'keydown.slitslider', function(e) {

					var keyCode = e.keyCode || e.which,
						arrow = {
							left: 37,
							up: 38,
							right: 39,
							down: 40
						};

					switch (keyCode) {
						
						case arrow.left :

							self._stopSlideshow();
							self._navigate( 'prev' );
							break;
						
						case arrow.right :
							
							self._stopSlideshow();
							self._navigate( 'next' );
							break;

					}

				} );

			}
		
		},
		_startSlideshow: function() {

			var self = this;

			this.slideshow = setTimeout( function() {

				self._navigate( 'next' );

				if ( self.options.autoplay ) {

					self._startSlideshow();

				}

			}, this.options.interval );

		},
		_stopSlideshow: function() {

			if ( this.options.autoplay ) {

				clearTimeout( this.slideshow );
				this.isPlaying = false;
				this.options.autoplay = false;

			}

		},
		_destroy : function( callback ) {
			
			this.$el.off( '.slitslider' ).removeData( 'slitslider' );
			$window.off( '.slitslider' );
			$document.off( '.slitslider' );
			this.$slides.each( function( i ) {

				var $slide = $( this ),
					$content = $slide.find( 'div.sl-content' ).children();

				$content.appendTo( $slide );
				$slide.children( 'div.sl-content-wrapper' ).remove();

			} );
			this.$slides.unwrap( this.$slideWrapper ).hide();
			this.$slides.eq( 0 ).show();
			if( callback ) {

				callback.call();

			}

		},
		// public methos: adds more slides to the slider
		add : function( $slides, callback ) {

			this.$slides = this.$slides.add( $slides );

			var self = this;
			
			
			$slides.each( function( i ) {

				var $slide = $( this ),
					// vertical || horizontal
					orientation = $slide.data( 'orientation' );

				$slide.hide().addClass( 'sl-slide-' + orientation )
					  .children()
					  .wrapAll( '<div class="sl-content-wrapper" />' )
					  .wrapAll( '<div class="sl-content" />' )
					  .end()
					  .appendTo( self.$el.find( 'div.sl-slides-wrapper' ) );

			} );

			this._setSize();

			this.slidesCount = this.$slides.length;
			
			if ( callback ) {

				callback.call( $items );

			}

		},
		// public method: shows next slide
		next : function() {

			this._stopSlideshow();
			this._navigate( 'next' );

		},
		// public method: shows previous slide
		previous : function() {

			this._stopSlideshow();
			this._navigate( 'prev' );

		},
		// public method: goes to a specific slide
		jump : function( pos ) {

			pos -= 1;

			if( pos === this.current || pos >= this.slidesCount || pos < 0 ) {

				return false;

			}

			this._stopSlideshow();
			this._navigate( pos > this.current ? 'next' : 'prev', pos );

		},
		// public method: starts the slideshow
		// any call to next(), previous() or jump() will stop the slideshow
		play : function() {

			if( !this.isPlaying ) {

				this.isPlaying = true;

				this._navigate( 'next' );
				this.options.autoplay = true;
				this._startSlideshow();

			}

		},
		// public method: pauses the slideshow
		pause : function() {

			if( this.isPlaying ) {

				this._stopSlideshow();

			}

		},
		// public method: check if isAnimating is true
		isActive : function() {

			return this.isAnimating;

		},
		// publicc methos: destroys the slicebox instance
		destroy : function( callback ) {

			this._destroy( callback );
		
		}

	};
	
	var logError = function( message ) {

		if ( window.console ) {

			window.console.error( message );
		
		}

	};
	
	$.fn.slitslider = function( options ) {

		var self = $.data( this, 'slitslider' );
		
		if ( typeof options === 'string' ) {
			
			var args = Array.prototype.slice.call( arguments, 1 );
			
			this.each(function() {
			
				if ( !self ) {

					logError( "cannot call methods on slitslider prior to initialization; " +
					"attempted to call method '" + options + "'" );
					return;
				
				}
				
				if ( !$.isFunction( self[options] ) || options.charAt(0) === "_" ) {

					logError( "no such method '" + options + "' for slitslider self" );
					return;
				
				}
				
				self[ options ].apply( self, args );
			
			});
		
		} 
		else {
		
			this.each(function() {
				
				if ( self ) {

					self._init();
				
				}
				else {

					self = $.data( this, 'slitslider', new $.Slitslider( options, this ) );
				
				}

			});
		
		}
		
		return self;
		
	};
	
} )( jQuery, window );

/*!
 * jquery.sumoselect - v3.0.2
 * http://hemantnegi.github.io/jquery.sumoselect
 * 2014-04-08
 *
 * Copyright 2015 Hemant Negi
 * Email : hemant.frnz@gmail.com
 * Compressor http://refresh-sf.com/
 */

(function ($) {

    'namespace sumo';
    $.fn.SumoSelect = function (options) {

        // This is the easiest way to have default options.
        var settings = $.extend({
            placeholder: 'Select Here',   // Dont change it here.
            csvDispCount: 3,              // display no. of items in multiselect. 0 to display all.
            captionFormat: '{0} Selected', // format of caption text. you can set your locale.
            captionFormatAllSelected: '{0} all selected!', // format of caption text when all elements are selected. set null to use captionFormat. It will not work if there are disabled elements in select.
            floatWidth: 400,              // Screen width of device at which the list is rendered in floating popup fashion.
            forceCustomRendering: false,  // force the custom modal on all devices below floatWidth resolution.
            nativeOnDevice: ['Android', 'BlackBerry', 'iPhone', 'iPad', 'iPod', 'Opera Mini', 'IEMobile', 'Silk'], //
            outputAsCSV: false,           // true to POST data as csv ( false for Html control array ie. default select )
            csvSepChar: ',',              // separation char in csv mode
            okCancelInMulti: false,       // display ok cancel buttons in desktop mode multiselect also.
            triggerChangeCombined: true,  // im multi select mode wether to trigger change event on individual selection or combined selection.
            selectAll: false,             // to display select all button in multiselect mode.|| also select all will not be available on mobile devices.

            search: false,                // to display input for filtering content. selectAlltext will be input text placeholder
            searchText: 'Search...',      // placeholder for search input
            noMatch: 'No matches for "{0}"',
            prefix: '',                   // some prefix usually the field name. eg. '<b>Hello</b>'
            locale: ['OK', 'Cancel', 'Select All'],  // all text that is used. don't change the index.
            up: false                     // set true to open upside.
        }, options);

        var ret = this.each(function () {
            var selObj = this; // the original select object.
            if (this.sumo || !$(this).is('select')) return; //already initialized

            this.sumo = {
                E: $(selObj),   //the jquery object of original select element.
                is_multi: $(selObj).attr('multiple'),  //if its a multiple select
                select: '',
                caption: '',
                placeholder: '',
                optDiv: '',
                CaptionCont: '',
                ul: '',
                is_floating: false,
                is_opened: false,
                //backdrop: '',
                mob: false, // if to open device default select
                Pstate: [],

                createElems: function () {
                    var O = this;
                    O.E.wrap('<div class="SumoSelect" tabindex="0">');
                    O.select = O.E.parent();
                    O.caption = $('<span>');
                    O.CaptionCont = $('<p class="CaptionCont"><label><i></i></label></p>').addClass('SelectBox').attr('style', O.E.attr('style')).prepend(O.caption);
                    O.select.append(O.CaptionCont);

                    // default turn off if no multiselect
                    if (!O.is_multi) settings.okCancelInMulti = false

                    if (O.E.attr('disabled'))
                        O.select.addClass('disabled').removeAttr('tabindex');

                    //if output as csv and is a multiselect.
                    if (settings.outputAsCSV && O.is_multi && O.E.attr('name')) {
                        //create a hidden field to store csv value.
                        O.select.append($('<input class="HEMANT123" type="hidden" />').attr('name', O.E.attr('name')).val(O.getSelStr()));

                        // so it can not post the original select.
                        O.E.removeAttr('name');
                    }

                    //break for mobile rendring.. if forceCustomRendering is false
                    if (O.isMobile() && !settings.forceCustomRendering) {
                        O.setNativeMobile();
                        return;
                    }

                    // if there is a name attr in select add a class to container div
                    if (O.E.attr('name')) O.select.addClass('sumo_' + O.E.attr('name'))

                    //hide original select
                    O.E.addClass('SumoUnder').attr('tabindex', '-1');

                    //## Creating the list...
                    O.optDiv = $('<div class="optWrapper ' + (settings.up ? 'up' : '') + '">');

                    //branch for floating list in low res devices.
                    O.floatingList();

                    //Creating the markup for the available options
                    O.ul = $('<ul class="options">');
                    O.optDiv.append(O.ul);

                    // Select all functionality
                    if (settings.selectAll) O.SelAll();

                    // search functionality
                    if (settings.search) O.Search();

                    O.ul.append(O.prepItems(O.E.children()));

                    //if multiple then add the class multiple and add OK / CANCEL button
                    if (O.is_multi) O.multiSelelect();

                    O.select.append(O.optDiv);
                    O.basicEvents();
                    O.selAllState();
                },

                prepItems: function (opts, d) {
                    var lis = [], O = this;
                    $(opts).each(function (i, opt) {       // parsing options to li
                        opt = $(opt);
                        lis.push(opt.is('optgroup') ?
                            $('<li class="group ' + (opt[0].disabled ? 'disabled' : '') + '"><label>' + opt.attr('label') + '</label><ul></ul><li>')
                            .find('ul')
                            .append(O.prepItems(opt.children(), opt[0].disabled))
                            .end()
                            :
                            O.createLi(opt, d)
                            );
                    });
                    return lis;
                },

                //## Creates a LI element from a given option and binds events to it
                //## returns the jquery instance of li (not inserted in dom)
                createLi: function (opt, d) {
                    var O = this;

                    if (!opt.attr('value')) opt.attr('value', opt.val());
                    // todo: remove this data val 
                    li = $('<li class="opt"><label>' + opt.text() + '</label></li>');//.data('val',opt.val());
                    li.data('opt', opt);    // store a direct reference to option.
                    opt.data('li', li);    // store a direct reference to list item.
                    if (O.is_multi) li.prepend('<span><i></i></span>');

                    if (opt[0].disabled || d)
                        li = li.addClass('disabled');

                    O.onOptClick(li);

                    if (opt[0].selected)
                        li.addClass('selected');

                    if (opt.attr('class'))
                        li.addClass(opt.attr('class'));

                    return li;
                },

                //## Returns the selected items as string in a Multiselect.
                getSelStr: function () {
                    // get the pre selected items.
                    sopt = [];
                    this.E.find('option:selected').each(function () { sopt.push($(this).val()); });
                    return sopt.join(settings.csvSepChar);
                },

                //## THOSE OK/CANCEL BUTTONS ON MULTIPLE SELECT.
                multiSelelect: function () {
                    var O = this;
                    O.optDiv.addClass('multiple');
                    O.okbtn = $('<p class="btnOk">' + settings.locale[0] + '</p>').click(function () {

                        //if combined change event is set.
                        if (settings.triggerChangeCombined) {

                            //check for a change in the selection.
                            changed = false;
                            if (O.E.find('option:selected').length != O.Pstate.length) {
                                changed = true;
                            }
                            else {
                                O.E.find('option').each(function (i, e) {
                                    if (e.selected && O.Pstate.indexOf(i) < 0) changed = true;
                                });
                            }

                            if (changed) {
                                O.callChange();
                                O.setText();
                            }
                        }
                        O.hideOpts();
                    });
                    O.cancelBtn = $('<p class="btnCancel">' + settings.locale[1] + '</p>').click(function () {
                        O._cnbtn();
                        O.hideOpts();
                    });
                    O.optDiv.append($('<div class="MultiControls">').append(O.okbtn).append(O.cancelBtn));
                },

                _cnbtn: function () {
                    var O = this;
                    //remove all selections
                    O.E.find('option:selected').each(function () { this.selected = false; });
                    O.optDiv.find('li.selected').removeClass('selected')

                    //restore selections from saved state.
                    for (var i = 0; i < O.Pstate.length; i++) {
                        O.E.find('option')[O.Pstate[i]].selected = true;
                        O.ul.find('li.opt').eq(O.Pstate[i]).addClass('selected');
                    }
                    O.selAllState();
                },

                SelAll: function () {
                    var O = this;
                    if (!O.is_multi) return;
                    O.selAll = $('<p class="select-all"><span><i></i></span><label>' + settings.locale[2] + '</label></p>');
                    O.selAll.on('click', function () {
                        //O.toggSelAll(!);
                        O.selAll.toggleClass('selected');
                        O.optDiv.find('li.opt').not('.hidden').each(function (ix, e) {
                            e = $(e);
                            if (O.selAll.hasClass('selected')) {
                                if (!e.hasClass('selected')) e.trigger('click');
                            }
                            else
                                if (e.hasClass('selected')) e.trigger('click');
                        });
                    });

                    O.optDiv.prepend(O.selAll);
                },

                // search module (can be removed if not required.)
                Search: function () {
                    var O = this,
                        cc = O.CaptionCont.addClass('search'),
                        P = $('<p class="no-match">');

                    O.ftxt = $('<input type="text" class="search-txt" value="" placeholder="' + settings.searchText + '">')
                        .on('click', function (e) {
                            e.stopPropagation();
                        });
                    cc.append(O.ftxt);
                    O.optDiv.children('ul').after(P);

                    O.ftxt.on('keyup.sumo', function () {
                        var hid = O.optDiv.find('ul.options li.opt').each(function (ix, e) {
                            e = $(e);
                            if (e.text().toLowerCase().indexOf(O.ftxt.val().toLowerCase()) > -1)
                                e.removeClass('hidden');
                            else
                                e.addClass('hidden');
                        }).not('.hidden');

                        P.html(settings.noMatch.replace(/\{0\}/g, O.ftxt.val())).toggle(!hid.length);

                        O.selAllState();
                    });
                },

                selAllState: function () {
                    var O = this;
                    if (settings.selectAll) {
                        var sc = 0, vc = 0;
                        O.optDiv.find('li.opt').not('.hidden').each(function (ix, e) {
                            if ($(e).hasClass('selected')) sc++;
                            if (!$(e).hasClass('disabled')) vc++;
                        });
                        //select all checkbox state change.
                        if (sc == vc) O.selAll.removeClass('partial').addClass('selected');
                        else if (sc == 0) O.selAll.removeClass('selected partial');
                        else O.selAll.addClass('partial')//.removeClass('selected');
                    }
                },

                showOpts: function () {
                    var O = this;
                    if (O.E.attr('disabled')) return; // if select is disabled then retrun
                    O.is_opened = true;
                    O.select.addClass('open');

                    if (O.ftxt) O.ftxt.focus();
                    else O.select.focus();

                    // hide options on click outside.
                    $(document).on('click.sumo', function (e) {
                        if (!O.select.is(e.target)                  // if the target of the click isn't the container...
                            && O.select.has(e.target).length === 0) { // ... nor a descendant of the container
                            if (!O.is_opened) return;
                            O.hideOpts();
                            if (settings.okCancelInMulti) O._cnbtn();
                        }
                    });

                    if (O.is_floating) {
                        H = O.optDiv.children('ul').outerHeight() + 2;  // +2 is clear fix
                        if (O.is_multi) H = H + parseInt(O.optDiv.css('padding-bottom'));
                        O.optDiv.css('height', H);
                        $('body').addClass('sumoStopScroll');
                    }

                    O.setPstate();
                },

                //maintain state when ok/cancel buttons are available storing the indexes.
                setPstate: function () {
                    var O = this;
                    if (O.is_multi && (O.is_floating || settings.okCancelInMulti)) {
                        O.Pstate = [];
                        // assuming that find returns elements in tree order
                        O.E.find('option').each(function (i, e) { if (e.selected) O.Pstate.push(i); });
                    }
                },

                callChange: function () {
                    this.E.trigger('change').trigger('click');
                },

                hideOpts: function () {
                    var O = this;
                    if (O.is_opened) {
                        O.is_opened = false;
                        O.select.removeClass('open').find('ul li.sel').removeClass('sel');
                        $(document).off('click.sumo');
                        O.select.focus();
                        $('body').removeClass('sumoStopScroll');

                        // clear the search
                        if (settings.search) {
                            O.ftxt.val('');
                            O.optDiv.find('ul.options li').removeClass('hidden');
                            O.optDiv.find('.no-match').toggle(false);
                        }
                    }
                },
                setOnOpen: function () {
                    var O = this,
                        li = O.optDiv.find('li.opt:not(.hidden)').eq(settings.search ? 0 : O.E[0].selectedIndex);

                    O.optDiv.find('li.sel').removeClass('sel');
                    li.addClass('sel');
                    O.showOpts();
                },
                nav: function (up) {
                    var O = this, c,
                    s = O.ul.find('li.opt:not(.disabled, .hidden)'),
                    sel = O.ul.find('li.opt.sel:not(.hidden)'),
                    idx = s.index(sel);
                    if (O.is_opened && sel.length) {

                        if (up && idx > 0)
                            c = s.eq(idx - 1);
                        else if (!up && idx < s.length - 1 && idx > -1)
                            c = s.eq(idx + 1);
                        else return; // if no items before or after

                        sel.removeClass('sel');
                        sel = c.addClass('sel');

                        // setting sel item to visible view.
                        var ul = O.ul,
                            st = ul.scrollTop(),
                            t = sel.position().top + st;
                        if (t >= st + ul.height() - sel.outerHeight())
                            ul.scrollTop(t - ul.height() + sel.outerHeight());
                        if (t < st)
                            ul.scrollTop(t);

                    }
                    else
                        O.setOnOpen();
                },

                basicEvents: function () {
                    var O = this;
                    O.CaptionCont.click(function (evt) {
                        O.E.trigger('click');
                        if (O.is_opened) O.hideOpts(); else O.showOpts();
                        evt.stopPropagation();
                    });

                    O.select.on('keydown.sumo', function (e) {
                        switch (e.which) {
                            case 38: // up
                                O.nav(true);
                                break;

                            case 40: // down
                                O.nav(false);
                                break;

                            case 32: // space
                                if (settings.search && O.ftxt.is(e.target)) return;
                            case 13: // enter
                                if (O.is_opened)
                                    O.optDiv.find('ul li.sel').trigger('click');
                                else
                                    O.setOnOpen();
                                break;
                            case 9:	 //tab
                            case 27: // esc
                                if (settings.okCancelInMulti) O._cnbtn();
                                O.hideOpts();
                                return;

                            default:
                                return; // exit this handler for other keys
                        }
                        e.preventDefault(); // prevent the default action (scroll / move caret)
                    });

                    $(window).on('resize.sumo', function () {
                        O.floatingList();
                    });
                },

                onOptClick: function (li) {
                    var O = this;
                    li.click(function () {
                        var li = $(this);
                        if (li.hasClass('disabled')) return;
                        txt = "";
                        if (O.is_multi) {
                            li.toggleClass('selected');
                            li.data('opt')[0].selected = li.hasClass('selected');
                            O.selAllState();
                        }
                        else {
                            li.parent().find('li.selected').removeClass('selected'); //if not multiselect then remove all selections from this list
                            li.toggleClass('selected');
                            li.data('opt')[0].selected = true;
                        }

                        //branch for combined change event.
                        if (!(O.is_multi && settings.triggerChangeCombined && (O.is_floating || settings.okCancelInMulti))) {
                            O.setText();
                            O.callChange();
                        }

                        if (!O.is_multi) O.hideOpts(); //if its not a multiselect then hide on single select.
                    });
                },

                setText: function () {
                    var O = this;
                    O.placeholder = "";
                    if (O.is_multi) {
                        sels = O.E.find(':selected').not(':disabled'); //selected options.

                        for (i = 0; i < sels.length; i++) {
                            if (i + 1 >= settings.csvDispCount && settings.csvDispCount) {
                                if (sels.length == O.E.find('option').length && settings.captionFormatAllSelected) {
                                    O.placeholder = settings.captionFormatAllSelected.replace(/\{0\}/g, sels.length) + ',';
                                } else {
                                    O.placeholder = settings.captionFormat.replace(/\{0\}/g, sels.length) + ',';
                                }

                                break;
                            }
                            else O.placeholder += $(sels[i]).text() + ", ";
                        }
                        O.placeholder = O.placeholder.replace(/,([^,]*)$/, '$1'); //remove unexpected "," from last.
                    }
                    else {
                        O.placeholder = O.E.find(':selected').not(':disabled').text();
                    }

                    is_placeholder = false;

                    if (!O.placeholder) {

                        is_placeholder = true;

                        O.placeholder = O.E.attr('placeholder');
                        if (!O.placeholder)                  //if placeholder is there then set it
                            O.placeholder = O.E.find('option:disabled:selected').text();
                    }

                    O.placeholder = O.placeholder ? (settings.prefix + ' ' + O.placeholder) : settings.placeholder

                    //set display text
                    O.caption.html(O.placeholder);
                    O.CaptionCont.attr('title', O.placeholder);

                    //set the hidden field if post as csv is true.
                    csvField = O.select.find('input.HEMANT123');
                    if (csvField.length) csvField.val(O.getSelStr());

                    //add class placeholder if its a placeholder text.
                    if (is_placeholder) O.caption.addClass('placeholder'); else O.caption.removeClass('placeholder');
                    return O.placeholder;
                },

                isMobile: function () {

                    // Adapted from http://www.detectmobilebrowsers.com
                    var ua = navigator.userAgent || navigator.vendor || window.opera;

                    // Checks for iOs, Android, Blackberry, Opera Mini, and Windows mobile devices
                    for (var i = 0; i < settings.nativeOnDevice.length; i++) if (ua.toString().toLowerCase().indexOf(settings.nativeOnDevice[i].toLowerCase()) > 0) return settings.nativeOnDevice[i];
                    return false;
                },

                setNativeMobile: function () {
                    var O = this;
                    O.E.addClass('SelectClass')//.css('height', O.select.outerHeight());
                    O.mob = true;
                    O.E.change(function () {
                        O.setText();
                    });
                },

                floatingList: function () {
                    var O = this;
                    //called on init and also on resize.
                    //O.is_floating = true if window width is < specified float width
                    O.is_floating = $(window).width() <= settings.floatWidth;

                    //set class isFloating
                    O.optDiv.toggleClass('isFloating', O.is_floating);

                    //remove height if not floating
                    if (!O.is_floating) O.optDiv.css('height', '');

                    //toggle class according to okCancelInMulti flag only when it is not floating
                    O.optDiv.toggleClass('okCancelInMulti', settings.okCancelInMulti && !O.is_floating);
                },

                //HELPERS FOR OUTSIDERS
                // validates range of given item operations
                vRange: function (i) {
                    var O = this;
                    opts = O.E.find('option');
                    if (opts.length <= i || i < 0) throw "index out of bounds"
                    return O;
                },

                //toggles selection on c as boolean.
                toggSel: function (c, i) {
                    var O = this;
                    if (typeof (i) === "number") {
                        O.vRange(i);
                        opt = O.E.find('option')[i];
                    }
                    else {
                        opt = O.E.find('option[value="' + i + '"]')[0] || 0;
                    }
                    if (!opt || opt.disabled)
                        return;

                    if (opt.selected != c) {
                        opt.selected = c;
                        if (!O.mob) $(opt).data('li').toggleClass('selected', c);

                        O.callChange();
                        O.setPstate();
                        O.setText();
                        O.selAllState();
                    }
                },

                //toggles disabled on c as boolean.
                toggDis: function (c, i) {
                    var O = this.vRange(i);
                    O.E.find('option')[i].disabled = c;
                    if (c) O.E.find('option')[i].selected = false;
                    if (!O.mob) O.optDiv.find('ul.options li').eq(i).toggleClass('disabled', c).removeClass('selected');
                    O.setText();
                },

                // toggle disable/enable on complete select control
                toggSumo: function (val) {
                    var O = this;
                    O.enabled = val;
                    O.select.toggleClass('disabled', val);

                    if (val) {
                        O.E.attr('disabled', 'disabled');
                        O.select.removeAttr('tabindex');
                    }
                    else {
                        O.E.removeAttr('disabled');
                        O.select.attr('tabindex', '0');
                    }

                    return O;
                },

                //toggles alloption on c as boolean.
                toggSelAll: function (c) {
                    var O = this;
                    O.E.find('option').each(function (ix, el) {
                        if (O.E.find('option')[$(this).index()].disabled) return;
                        O.E.find('option')[$(this).index()].selected = c;
                        if (!O.mob)
                            O.optDiv.find('ul.options li').eq($(this).index()).toggleClass('selected', c);
                        O.setText();
                    });
                    if (!O.mob && O.selAll) O.selAll.removeClass('partial').toggleClass('selected', c);
                    O.callChange();
                    O.setPstate();
                },

                /* outside accessibility options
                   which can be accessed from the element instance.
                */
                reload: function () {
                    var elm = this.unload();
                    return $(elm).SumoSelect(settings);
                },

                unload: function () {
                    var O = this;
                    O.select.before(O.E);
                    O.E.show();

                    if (settings.outputAsCSV && O.is_multi && O.select.find('input.HEMANT123').length) {
                        O.E.attr('name', O.select.find('input.HEMANT123').attr('name')); // restore the name;
                    }
                    O.select.remove();
                    delete selObj.sumo;
                    return selObj;
                },

                //## add a new option to select at a given index.
                add: function (val, txt, i) {
                    if (typeof val == "undefined") throw "No value to add"

                    var O = this;
                    opts = O.E.find('option')
                    if (typeof txt == "number") { i = txt; txt = val; }
                    if (typeof txt == "undefined") { txt = val; }

                    opt = $("<option></option>").val(val).html(txt);

                    if (opts.length < i) throw "index out of bounds"

                    if (typeof i == "undefined" || opts.length == i) { // add it to the last if given index is last no or no index provides.
                        O.E.append(opt);
                        if (!O.mob) O.ul.append(O.createLi(opt));
                    }
                    else {
                        opts.eq(i).before(opt);
                        if (!O.mob) O.ul.find('li.opt').eq(i).before(O.createLi(opt));
                    }

                    return selObj;
                },

                //## removes an item at a given index.
                remove: function (i) {
                    var O = this.vRange(i);
                    O.E.find('option').eq(i).remove();
                    if (!O.mob) O.optDiv.find('ul.options li').eq(i).remove();
                    O.setText();
                },

                //## Select an item at a given index.
                selectItem: function (i) { this.toggSel(true, i); },

                //## UnSelect an iten at a given index.
                unSelectItem: function (i) { this.toggSel(false, i); },

                //## Select all items  of the select.
                selectAll: function () { this.toggSelAll(true); },

                //## UnSelect all items of the select.
                unSelectAll: function () { this.toggSelAll(false); },

                //## Disable an iten at a given index.
                disableItem: function (i) { this.toggDis(true, i) },

                //## Removes disabled an iten at a given index.
                enableItem: function (i) { this.toggDis(false, i) },

                //## New simple methods as getter and setter are not working fine in ie8-
                //## variable to check state of control if enabled or disabled.
                enabled: true,
                //## Enables the control
                enable: function () { return this.toggSumo(false) },

                //## Disables the control
                disable: function () { return this.toggSumo(true) },


                init: function () {
                    var O = this;
                    O.createElems();
                    O.setText();
                    return O
                }

            };

            selObj.sumo.init();
        });

        return ret.length == 1 ? ret[0] : ret;
    };


}(jQuery));
/*

Tooltipster 3.3.0 | 2014-11-08
A rockin' custom tooltip jQuery plugin

Developed by Caleb Jacob under the MIT license http://opensource.org/licenses/MIT

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/

; (function ($, window, document) {

    var pluginName = "tooltipster",
		defaults = {
		    animation: 'fade',
		    arrow: true,
		    arrowColor: '',
		    autoClose: true,
		    content: null,
		    contentAsHTML: false,
		    contentCloning: true,
		    debug: true,
		    delay: 200,
		    minWidth: 0,
		    maxWidth: null,
		    functionInit: function (origin, content) { },
		    functionBefore: function (origin, continueTooltip) {
		        continueTooltip();
		    },
		    functionReady: function (origin, tooltip) { },
		    functionAfter: function (origin) { },
		    hideOnClick: false,
		    icon: '(?)',
		    iconCloning: true,
		    iconDesktop: false,
		    iconTouch: false,
		    iconTheme: 'tooltipster-icon',
		    interactive: false,
		    interactiveTolerance: 350,
		    multiple: false,
		    offsetX: 0,
		    offsetY: 0,
		    onlyOne: false,
		    position: 'top',
		    positionTracker: false,
		    positionTrackerCallback: function (origin) {
		        // the default tracker callback will close the tooltip when the trigger is
		        // 'hover' (see https://github.com/iamceege/tooltipster/pull/253)
		        if (this.option('trigger') == 'hover' && this.option('autoClose')) {
		            this.hide();
		        }
		    },
		    restoration: 'current',
		    speed: 350,
		    timer: 0,
		    theme: 'tooltipster-default',
		    touchDevices: true,
		    trigger: 'hover',
		    updateAnimation: true
		};

    function Plugin(element, options) {

        // list of instance variables

        this.bodyOverflowX;
        // stack of custom callbacks provided as parameters to API methods
        this.callbacks = {
            hide: [],
            show: []
        };
        this.checkInterval = null;
        // this will be the user content shown in the tooltip. A capital "C" is used because there is also a method called content()
        this.Content;
        // this is the original element which is being applied the tooltipster plugin
        this.$el = $(element);
        // this will be the element which triggers the appearance of the tooltip on hover/click/custom events.
        // it will be the same as this.$el if icons are not used (see in the options), otherwise it will correspond to the created icon
        this.$elProxy;
        this.elProxyPosition;
        this.enabled = true;
        this.options = $.extend({}, defaults, options);
        this.mouseIsOverProxy = false;
        // a unique namespace per instance, for easy selective unbinding
        this.namespace = 'tooltipster-' + Math.round(Math.random() * 100000);
        // Status (capital S) can be either : appearing, shown, disappearing, hidden
        this.Status = 'hidden';
        this.timerHide = null;
        this.timerShow = null;
        // this will be the tooltip element (jQuery wrapped HTML element)
        this.$tooltip;

        // for backward compatibility
        this.options.iconTheme = this.options.iconTheme.replace('.', '');
        this.options.theme = this.options.theme.replace('.', '');

        // launch

        this._init();
    }

    Plugin.prototype = {

        _init: function () {

            var self = this;

            // disable the plugin on old browsers (including IE7 and lower)
            if (document.querySelector) {

                // note : the content is null (empty) by default and can stay that way if the plugin remains initialized but not fed any content. The tooltip will just not appear.

                // let's save the initial value of the title attribute for later restoration if need be.
                var initialTitle = null;
                // it will already have been saved in case of multiple tooltips
                if (self.$el.data('tooltipster-initialTitle') === undefined) {

                    initialTitle = self.$el.attr('title');

                    // we do not want initialTitle to have the value "undefined" because of how jQuery's .data() method works
                    if (initialTitle === undefined) initialTitle = null;

                    self.$el.data('tooltipster-initialTitle', initialTitle);
                }

                // if content is provided in the options, its has precedence over the title attribute.
                // Note : an empty string is considered content, only 'null' represents the absence of content.
                // Also, an existing title="" attribute will result in an empty string content
                if (self.options.content !== null) {
                    self._content_set(self.options.content);
                }
                else {
                    self._content_set(initialTitle);
                }

                var c = self.options.functionInit.call(self.$el, self.$el, self.Content);
                if (typeof c !== 'undefined') self._content_set(c);

                self.$el
					// strip the title off of the element to prevent the default tooltips from popping up
					.removeAttr('title')
					// to be able to find all instances on the page later (upon window events in particular)
					.addClass('tooltipstered');

                // detect if we're changing the tooltip origin to an icon
                // note about this condition : if the device has touch capability and self.options.iconTouch is false, you'll have no icons event though you may consider your device as a desktop if it also has a mouse. Not sure why someone would have this use case though.
                if ((!deviceHasTouchCapability && self.options.iconDesktop) || (deviceHasTouchCapability && self.options.iconTouch)) {

                    // TODO : the tooltip should be automatically be given an absolute position to be near the origin. Otherwise, when the origin is floating or what, it's going to be nowhere near it and disturb the position flow of the page elements. It will imply that the icon also detects when its origin moves, to follow it : not trivial.
                    // Until it's done, the icon feature does not really make sense since the user still has most of the work to do by himself

                    // if the icon provided is in the form of a string
                    if (typeof self.options.icon === 'string') {
                        // wrap it in a span with the icon class
                        self.$elProxy = $('<span class="' + self.options.iconTheme + '"></span>');
                        self.$elProxy.text(self.options.icon);
                    }
                        // if it is an object (sensible choice)
                    else {
                        // (deep) clone the object if iconCloning == true, to make sure every instance has its own proxy. We use the icon without wrapping, no need to. We do not give it a class either, as the user will undoubtedly style the object on his own and since our css properties may conflict with his own
                        if (self.options.iconCloning) self.$elProxy = self.options.icon.clone(true);
                        else self.$elProxy = self.options.icon;
                    }

                    self.$elProxy.insertAfter(self.$el);
                }
                else {
                    self.$elProxy = self.$el;
                }

                // for 'click' and 'hover' triggers : bind on events to open the tooltip. Closing is now handled in _showNow() because of its bindings.
                // Notes about touch events :
                // - mouseenter, mouseleave and clicks happen even on pure touch devices because they are emulated. deviceIsPureTouch() is a simple attempt to detect them.
                // - on hybrid devices, we do not prevent touch gesture from opening tooltips. It would be too complex to differentiate real mouse events from emulated ones.
                // - we check deviceIsPureTouch() at each event rather than prior to binding because the situation may change during browsing
                if (self.options.trigger == 'hover') {

                    // these binding are for mouse interaction only
                    self.$elProxy
						.on('mouseenter.' + self.namespace, function () {
						    if (!deviceIsPureTouch() || self.options.touchDevices) {
						        self.mouseIsOverProxy = true;
						        self._show();
						    }
						})
						.on('mouseleave.' + self.namespace, function () {
						    if (!deviceIsPureTouch() || self.options.touchDevices) {
						        self.mouseIsOverProxy = false;
						    }
						});

                    // for touch interaction only
                    if (deviceHasTouchCapability && self.options.touchDevices) {

                        // for touch devices, we immediately display the tooltip because we cannot rely on mouseleave to handle the delay
                        self.$elProxy.on('touchstart.' + self.namespace, function () {
                            self._showNow();
                        });
                    }
                }
                else if (self.options.trigger == 'click') {

                    // note : for touch devices, we do not bind on touchstart, we only rely on the emulated clicks (triggered by taps)
                    self.$elProxy.on('click.' + self.namespace, function () {
                        if (!deviceIsPureTouch() || self.options.touchDevices) {
                            self._show();
                        }
                    });
                }
            }
        },

        // this function will schedule the opening of the tooltip after the delay, if there is one
        _show: function () {

            var self = this;

            if (self.Status != 'shown' && self.Status != 'appearing') {

                if (self.options.delay) {
                    self.timerShow = setTimeout(function () {

                        // for hover trigger, we check if the mouse is still over the proxy, otherwise we do not show anything
                        if (self.options.trigger == 'click' || (self.options.trigger == 'hover' && self.mouseIsOverProxy)) {
                            self._showNow();
                        }
                    }, self.options.delay);
                }
                else self._showNow();
            }
        },

        // this function will open the tooltip right away
        _showNow: function (callback) {

            var self = this;

            // call our constructor custom function before continuing
            self.options.functionBefore.call(self.$el, self.$el, function () {

                // continue only if the tooltip is enabled and has any content
                if (self.enabled && self.Content !== null) {

                    // save the method callback and cancel hide method callbacks
                    if (callback) self.callbacks.show.push(callback);
                    self.callbacks.hide = [];

                    //get rid of any appearance timer
                    clearTimeout(self.timerShow);
                    self.timerShow = null;
                    clearTimeout(self.timerHide);
                    self.timerHide = null;

                    // if we only want one tooltip open at a time, close all auto-closing tooltips currently open and not already disappearing
                    if (self.options.onlyOne) {
                        $('.tooltipstered').not(self.$el).each(function (i, el) {

                            var $el = $(el),
								nss = $el.data('tooltipster-ns');

                            // iterate on all tooltips of the element
                            $.each(nss, function (i, ns) {
                                var instance = $el.data(ns),
									// we have to use the public methods here
									s = instance.status(),
									ac = instance.option('autoClose');

                                if (s !== 'hidden' && s !== 'disappearing' && ac) {
                                    instance.hide();
                                }
                            });
                        });
                    }

                    var finish = function () {
                        self.Status = 'shown';

                        // trigger any show method custom callbacks and reset them
                        $.each(self.callbacks.show, function (i, c) { c.call(self.$el); });
                        self.callbacks.show = [];
                    };

                    // if this origin already has its tooltip open
                    if (self.Status !== 'hidden') {

                        // the timer (if any) will start (or restart) right now
                        var extraTime = 0;

                        // if it was disappearing, cancel that
                        if (self.Status === 'disappearing') {

                            self.Status = 'appearing';

                            if (supportsTransitions()) {

                                self.$tooltip
									.clearQueue()
									.removeClass('tooltipster-dying')
									.addClass('tooltipster-' + self.options.animation + '-show');

                                if (self.options.speed > 0) self.$tooltip.delay(self.options.speed);

                                self.$tooltip.queue(finish);
                            }
                            else {
                                // in case the tooltip was currently fading out, bring it back to life
                                self.$tooltip
									.stop()
									.fadeIn(finish);
                            }
                        }
                            // if the tooltip is already open, we still need to trigger the method custom callback
                        else if (self.Status === 'shown') {
                            finish();
                        }
                    }
                        // if the tooltip isn't already open, open that sucker up!
                    else {

                        self.Status = 'appearing';

                        // the timer (if any) will start when the tooltip has fully appeared after its transition
                        var extraTime = self.options.speed;

                        // disable horizontal scrollbar to keep overflowing tooltips from jacking with it and then restore it to its previous value
                        self.bodyOverflowX = $('body').css('overflow-x');
                        $('body').css('overflow-x', 'hidden');

                        // get some other settings related to building the tooltip
                        var animation = 'tooltipster-' + self.options.animation,
							animationSpeed = '-webkit-transition-duration: ' + self.options.speed + 'ms; -webkit-animation-duration: ' + self.options.speed + 'ms; -moz-transition-duration: ' + self.options.speed + 'ms; -moz-animation-duration: ' + self.options.speed + 'ms; -o-transition-duration: ' + self.options.speed + 'ms; -o-animation-duration: ' + self.options.speed + 'ms; -ms-transition-duration: ' + self.options.speed + 'ms; -ms-animation-duration: ' + self.options.speed + 'ms; transition-duration: ' + self.options.speed + 'ms; animation-duration: ' + self.options.speed + 'ms;',
							minWidth = self.options.minWidth ? 'min-width:' + Math.round(self.options.minWidth) + 'px;' : '',
							maxWidth = self.options.maxWidth ? 'max-width:' + Math.round(self.options.maxWidth) + 'px;' : '',
							pointerEvents = self.options.interactive ? 'pointer-events: auto;' : '';

                        // build the base of our tooltip
                        self.$tooltip = $('<div class="tooltipster-base ' + self.options.theme + '" style="' + minWidth + ' ' + maxWidth + ' ' + pointerEvents + ' ' + animationSpeed + '"><div class="tooltipster-content"></div></div>');

                        // only add the animation class if the user has a browser that supports animations
                        if (supportsTransitions()) self.$tooltip.addClass(animation);

                        // insert the content
                        self._content_insert();

                        // attach
                        self.$tooltip.appendTo('body');

                        // do all the crazy calculations and positioning
                        self.reposition();

                        // call our custom callback since the content of the tooltip is now part of the DOM
                        self.options.functionReady.call(self.$el, self.$el, self.$tooltip);

                        // animate in the tooltip
                        if (supportsTransitions()) {

                            self.$tooltip.addClass(animation + '-show');

                            if (self.options.speed > 0) self.$tooltip.delay(self.options.speed);

                            self.$tooltip.queue(finish);
                        }
                        else {
                            self.$tooltip.css('display', 'none').fadeIn(self.options.speed, finish);
                        }

                        // will check if our tooltip origin is removed while the tooltip is shown
                        self._interval_set();

                        // reposition on scroll (otherwise position:fixed element's tooltips will move away form their origin) and on resize (in case position can/has to be changed)
                        $(window).on('scroll.' + self.namespace + ' resize.' + self.namespace, function () {
                            self.reposition();
                        });

                        // auto-close bindings
                        if (self.options.autoClose) {

                            // in case a listener is already bound for autoclosing (mouse or touch, hover or click), unbind it first
                            $('body').off('.' + self.namespace);

                            // here we'll have to set different sets of bindings for both touch and mouse
                            if (self.options.trigger == 'hover') {

                                // if the user touches the body, hide
                                if (deviceHasTouchCapability) {
                                    // timeout 0 : explanation below in click section
                                    setTimeout(function () {
                                        // we don't want to bind on click here because the initial touchstart event has not yet triggered its click event, which is thus about to happen
                                        $('body').on('touchstart.' + self.namespace, function () {
                                            self.hide();
                                        });
                                    }, 0);
                                }

                                // if we have to allow interaction
                                if (self.options.interactive) {

                                    // touch events inside the tooltip must not close it
                                    if (deviceHasTouchCapability) {
                                        self.$tooltip.on('touchstart.' + self.namespace, function (event) {
                                            event.stopPropagation();
                                        });
                                    }

                                    // as for mouse interaction, we get rid of the tooltip only after the mouse has spent some time out of it
                                    var tolerance = null;

                                    self.$elProxy.add(self.$tooltip)
										// hide after some time out of the proxy and the tooltip
										.on('mouseleave.' + self.namespace + '-autoClose', function () {
										    clearTimeout(tolerance);
										    tolerance = setTimeout(function () {
										        self.hide();
										    }, self.options.interactiveTolerance);
										})
										// suspend timeout when the mouse is over the proxy or the tooltip
										.on('mouseenter.' + self.namespace + '-autoClose', function () {
										    clearTimeout(tolerance);
										});
                                }
                                    // if this is a non-interactive tooltip, get rid of it if the mouse leaves
                                else {
                                    self.$elProxy.on('mouseleave.' + self.namespace + '-autoClose', function () {
                                        self.hide();
                                    });
                                }

                                // close the tooltip when the proxy gets a click (common behavior of native tooltips)
                                if (self.options.hideOnClick) {

                                    self.$elProxy.on('click.' + self.namespace + '-autoClose', function () {
                                        self.hide();
                                    });
                                }
                            }
                                // here we'll set the same bindings for both clicks and touch on the body to hide the tooltip
                            else if (self.options.trigger == 'click') {

                                // use a timeout to prevent immediate closing if the method was called on a click event and if options.delay == 0 (because of bubbling)
                                setTimeout(function () {
                                    $('body').on('click.' + self.namespace + ' touchstart.' + self.namespace, function () {
                                        self.hide();
                                    });
                                }, 0);

                                // if interactive, we'll stop the events that were emitted from inside the tooltip to stop autoClosing
                                if (self.options.interactive) {

                                    // note : the touch events will just not be used if the plugin is not enabled on touch devices
                                    self.$tooltip.on('click.' + self.namespace + ' touchstart.' + self.namespace, function (event) {
                                        event.stopPropagation();
                                    });
                                }
                            }
                        }
                    }

                    // if we have a timer set, let the countdown begin
                    if (self.options.timer > 0) {

                        self.timerHide = setTimeout(function () {
                            self.timerHide = null;
                            self.hide();
                        }, self.options.timer + extraTime);
                    }
                }
            });
        },

        _interval_set: function () {

            var self = this;

            self.checkInterval = setInterval(function () {

                // if the tooltip and/or its interval should be stopped
                if (
                    // if the origin has been removed
						$('body').find(self.$el).length === 0
                    // if the elProxy has been removed
					|| $('body').find(self.$elProxy).length === 0
                    // if the tooltip has been closed
					|| self.Status == 'hidden'
                    // if the tooltip has somehow been removed
					|| $('body').find(self.$tooltip).length === 0
				) {
                    // remove the tooltip if it's still here
                    if (self.Status == 'shown' || self.Status == 'appearing') self.hide();

                    // clear this interval as it is no longer necessary
                    self._interval_cancel();
                }
                    // if everything is alright
                else {
                    // compare the former and current positions of the elProxy to reposition the tooltip if need be
                    if (self.options.positionTracker) {

                        var p = self._repositionInfo(self.$elProxy),
							identical = false;

                        // compare size first (a change requires repositioning too)
                        if (areEqual(p.dimension, self.elProxyPosition.dimension)) {

                            // for elements with a fixed position, we track the top and left properties (relative to window)
                            if (self.$elProxy.css('position') === 'fixed') {
                                if (areEqual(p.position, self.elProxyPosition.position)) identical = true;
                            }
                                // otherwise, track total offset (relative to document)
                            else {
                                if (areEqual(p.offset, self.elProxyPosition.offset)) identical = true;
                            }
                        }

                        if (!identical) {
                            self.reposition();
                            self.options.positionTrackerCallback.call(self, self.$el);
                        }
                    }
                }
            }, 200);
        },

        _interval_cancel: function () {
            clearInterval(this.checkInterval);
            // clean delete
            this.checkInterval = null;
        },

        _content_set: function (content) {
            // clone if asked. Cloning the object makes sure that each instance has its own version of the content (in case a same object were provided for several instances)
            // reminder : typeof null === object
            if (typeof content === 'object' && content !== null && this.options.contentCloning) {
                content = content.clone(true);
            }
            this.Content = content;
        },

        _content_insert: function () {

            var self = this,
				$d = this.$tooltip.find('.tooltipster-content');

            if (typeof self.Content === 'string' && !self.options.contentAsHTML) {
                $d.text(self.Content);
            }
            else {
                $d
					.empty()
					.append(self.Content);
            }
        },

        _update: function (content) {

            var self = this;

            // change the content
            self._content_set(content);

            if (self.Content !== null) {

                // update the tooltip if it is open
                if (self.Status !== 'hidden') {

                    // reset the content in the tooltip
                    self._content_insert();

                    // reposition and resize the tooltip
                    self.reposition();

                    // if we want to play a little animation showing the content changed
                    if (self.options.updateAnimation) {

                        if (supportsTransitions()) {

                            self.$tooltip.css({
                                'width': '',
                                '-webkit-transition': 'all ' + self.options.speed + 'ms, width 0ms, height 0ms, left 0ms, top 0ms',
                                '-moz-transition': 'all ' + self.options.speed + 'ms, width 0ms, height 0ms, left 0ms, top 0ms',
                                '-o-transition': 'all ' + self.options.speed + 'ms, width 0ms, height 0ms, left 0ms, top 0ms',
                                '-ms-transition': 'all ' + self.options.speed + 'ms, width 0ms, height 0ms, left 0ms, top 0ms',
                                'transition': 'all ' + self.options.speed + 'ms, width 0ms, height 0ms, left 0ms, top 0ms'
                            }).addClass('tooltipster-content-changing');

                            // reset the CSS transitions and finish the change animation
                            setTimeout(function () {

                                if (self.Status != 'hidden') {

                                    self.$tooltip.removeClass('tooltipster-content-changing');

                                    // after the changing animation has completed, reset the CSS transitions
                                    setTimeout(function () {

                                        if (self.Status !== 'hidden') {
                                            self.$tooltip.css({
                                                '-webkit-transition': self.options.speed + 'ms',
                                                '-moz-transition': self.options.speed + 'ms',
                                                '-o-transition': self.options.speed + 'ms',
                                                '-ms-transition': self.options.speed + 'ms',
                                                'transition': self.options.speed + 'ms'
                                            });
                                        }
                                    }, self.options.speed);
                                }
                            }, self.options.speed);
                        }
                        else {
                            self.$tooltip.fadeTo(self.options.speed, 0.5, function () {
                                if (self.Status != 'hidden') {
                                    self.$tooltip.fadeTo(self.options.speed, 1);
                                }
                            });
                        }
                    }
                }
            }
            else {
                self.hide();
            }
        },

        _repositionInfo: function ($el) {
            return {
                dimension: {
                    height: $el.outerHeight(false),
                    width: $el.outerWidth(false)
                },
                offset: $el.offset(),
                position: {
                    left: parseInt($el.css('left')),
                    top: parseInt($el.css('top'))
                }
            };
        },

        hide: function (callback) {

            var self = this;

            // save the method custom callback and cancel any show method custom callbacks
            if (callback) self.callbacks.hide.push(callback);
            self.callbacks.show = [];

            // get rid of any appearance timeout
            clearTimeout(self.timerShow);
            self.timerShow = null;
            clearTimeout(self.timerHide);
            self.timerHide = null;

            var finishCallbacks = function () {
                // trigger any hide method custom callbacks and reset them
                $.each(self.callbacks.hide, function (i, c) { c.call(self.$el); });
                self.callbacks.hide = [];
            };

            // hide
            if (self.Status == 'shown' || self.Status == 'appearing') {

                self.Status = 'disappearing';

                var finish = function () {

                    self.Status = 'hidden';

                    // detach our content object first, so the next jQuery's remove() call does not unbind its event handlers
                    if (typeof self.Content == 'object' && self.Content !== null) {
                        self.Content.detach();
                    }

                    self.$tooltip.remove();
                    self.$tooltip = null;

                    // unbind orientationchange, scroll and resize listeners
                    $(window).off('.' + self.namespace);

                    $('body')
						// unbind any auto-closing click/touch listeners
						.off('.' + self.namespace)
						.css('overflow-x', self.bodyOverflowX);

                    // unbind any auto-closing click/touch listeners
                    $('body').off('.' + self.namespace);

                    // unbind any auto-closing hover listeners
                    self.$elProxy.off('.' + self.namespace + '-autoClose');

                    // call our constructor custom callback function
                    self.options.functionAfter.call(self.$el, self.$el);

                    // call our method custom callbacks functions
                    finishCallbacks();
                };

                if (supportsTransitions()) {

                    self.$tooltip
						.clearQueue()
						.removeClass('tooltipster-' + self.options.animation + '-show')
						// for transitions only
						.addClass('tooltipster-dying');

                    if (self.options.speed > 0) self.$tooltip.delay(self.options.speed);

                    self.$tooltip.queue(finish);
                }
                else {
                    self.$tooltip
						.stop()
						.fadeOut(self.options.speed, finish);
                }
            }
                // if the tooltip is already hidden, we still need to trigger the method custom callback
            else if (self.Status == 'hidden') {
                finishCallbacks();
            }

            return self;
        },

        // the public show() method is actually an alias for the private showNow() method
        show: function (callback) {
            this._showNow(callback);
            return this;
        },

        // 'update' is deprecated in favor of 'content' but is kept for backward compatibility
        update: function (c) {
            return this.content(c);
        },
        content: function (c) {
            // getter method
            if (typeof c === 'undefined') {
                return this.Content;
            }
                // setter method
            else {
                this._update(c);
                return this;
            }
        },

        reposition: function () {

            var self = this;

            // in case the tooltip has been removed from DOM manually
            if ($('body').find(self.$tooltip).length !== 0) {

                // reset width
                self.$tooltip.css('width', '');

                // find variables to determine placement
                self.elProxyPosition = self._repositionInfo(self.$elProxy);
                var arrowReposition = null,
					windowWidth = $(window).width(),
					// shorthand
					proxy = self.elProxyPosition,
					tooltipWidth = self.$tooltip.outerWidth(false),
					tooltipInnerWidth = self.$tooltip.innerWidth() + 1, // this +1 stops FireFox from sometimes forcing an additional text line
					tooltipHeight = self.$tooltip.outerHeight(false);

                // if this is an <area> tag inside a <map>, all hell breaks loose. Recalculate all the measurements based on coordinates
                if (self.$elProxy.is('area')) {
                    var areaShape = self.$elProxy.attr('shape'),
						mapName = self.$elProxy.parent().attr('name'),
						map = $('img[usemap="#' + mapName + '"]'),
						mapOffsetLeft = map.offset().left,
						mapOffsetTop = map.offset().top,
						areaMeasurements = self.$elProxy.attr('coords') !== undefined ? self.$elProxy.attr('coords').split(',') : undefined;

                    if (areaShape == 'circle') {
                        var areaLeft = parseInt(areaMeasurements[0]),
							areaTop = parseInt(areaMeasurements[1]),
							areaWidth = parseInt(areaMeasurements[2]);
                        proxy.dimension.height = areaWidth * 2;
                        proxy.dimension.width = areaWidth * 2;
                        proxy.offset.top = mapOffsetTop + areaTop - areaWidth;
                        proxy.offset.left = mapOffsetLeft + areaLeft - areaWidth;
                    }
                    else if (areaShape == 'rect') {
                        var areaLeft = parseInt(areaMeasurements[0]),
							areaTop = parseInt(areaMeasurements[1]),
							areaRight = parseInt(areaMeasurements[2]),
							areaBottom = parseInt(areaMeasurements[3]);
                        proxy.dimension.height = areaBottom - areaTop;
                        proxy.dimension.width = areaRight - areaLeft;
                        proxy.offset.top = mapOffsetTop + areaTop;
                        proxy.offset.left = mapOffsetLeft + areaLeft;
                    }
                    else if (areaShape == 'poly') {
                        var areaXs = [],
							areaYs = [],
							areaSmallestX = 0,
							areaSmallestY = 0,
							areaGreatestX = 0,
							areaGreatestY = 0,
							arrayAlternate = 'even';

                        for (var i = 0; i < areaMeasurements.length; i++) {
                            var areaNumber = parseInt(areaMeasurements[i]);

                            if (arrayAlternate == 'even') {
                                if (areaNumber > areaGreatestX) {
                                    areaGreatestX = areaNumber;
                                    if (i === 0) {
                                        areaSmallestX = areaGreatestX;
                                    }
                                }

                                if (areaNumber < areaSmallestX) {
                                    areaSmallestX = areaNumber;
                                }

                                arrayAlternate = 'odd';
                            }
                            else {
                                if (areaNumber > areaGreatestY) {
                                    areaGreatestY = areaNumber;
                                    if (i == 1) {
                                        areaSmallestY = areaGreatestY;
                                    }
                                }

                                if (areaNumber < areaSmallestY) {
                                    areaSmallestY = areaNumber;
                                }

                                arrayAlternate = 'even';
                            }
                        }

                        proxy.dimension.height = areaGreatestY - areaSmallestY;
                        proxy.dimension.width = areaGreatestX - areaSmallestX;
                        proxy.offset.top = mapOffsetTop + areaSmallestY;
                        proxy.offset.left = mapOffsetLeft + areaSmallestX;
                    }
                    else {
                        proxy.dimension.height = map.outerHeight(false);
                        proxy.dimension.width = map.outerWidth(false);
                        proxy.offset.top = mapOffsetTop;
                        proxy.offset.left = mapOffsetLeft;
                    }
                }

                // our function and global vars for positioning our tooltip
                var myLeft = 0,
					myLeftMirror = 0,
					myTop = 0,
					offsetY = parseInt(self.options.offsetY),
					offsetX = parseInt(self.options.offsetX),
					// this is the arrow position that will eventually be used. It may differ from the position option if the tooltip cannot be displayed in this position
					practicalPosition = self.options.position;

                // a function to detect if the tooltip is going off the screen horizontally. If so, reposition the crap out of it!
                function dontGoOffScreenX() {

                    var windowLeft = $(window).scrollLeft();

                    // if the tooltip goes off the left side of the screen, line it up with the left side of the window
                    if ((myLeft - windowLeft) < 0) {
                        arrowReposition = myLeft - windowLeft;
                        myLeft = windowLeft;
                    }

                    // if the tooltip goes off the right of the screen, line it up with the right side of the window
                    if (((myLeft + tooltipWidth) - windowLeft) > windowWidth) {
                        arrowReposition = myLeft - ((windowWidth + windowLeft) - tooltipWidth);
                        myLeft = (windowWidth + windowLeft) - tooltipWidth;
                    }
                }

                // a function to detect if the tooltip is going off the screen vertically. If so, switch to the opposite!
                function dontGoOffScreenY(switchTo, switchFrom) {
                    // if it goes off the top off the page
                    if (((proxy.offset.top - $(window).scrollTop() - tooltipHeight - offsetY - 12) < 0) && (switchFrom.indexOf('top') > -1)) {
                        practicalPosition = switchTo;
                    }

                    // if it goes off the bottom of the page
                    if (((proxy.offset.top + proxy.dimension.height + tooltipHeight + 12 + offsetY) > ($(window).scrollTop() + $(window).height())) && (switchFrom.indexOf('bottom') > -1)) {
                        practicalPosition = switchTo;
                        myTop = (proxy.offset.top - tooltipHeight) - offsetY - 12;
                    }
                }

                if (practicalPosition == 'top') {
                    var leftDifference = (proxy.offset.left + tooltipWidth) - (proxy.offset.left + proxy.dimension.width);
                    myLeft = (proxy.offset.left + offsetX) - (leftDifference / 2);
                    myTop = (proxy.offset.top - tooltipHeight) - offsetY - 12;
                    dontGoOffScreenX();
                    dontGoOffScreenY('bottom', 'top');
                }

                if (practicalPosition == 'top-left') {
                    myLeft = proxy.offset.left + offsetX;
                    myTop = (proxy.offset.top - tooltipHeight) - offsetY - 12;
                    dontGoOffScreenX();
                    dontGoOffScreenY('bottom-left', 'top-left');
                }

                if (practicalPosition == 'top-right') {
                    myLeft = (proxy.offset.left + proxy.dimension.width + offsetX) - tooltipWidth;
                    myTop = (proxy.offset.top - tooltipHeight) - offsetY - 12;
                    dontGoOffScreenX();
                    dontGoOffScreenY('bottom-right', 'top-right');
                }

                if (practicalPosition == 'bottom') {
                    var leftDifference = (proxy.offset.left + tooltipWidth) - (proxy.offset.left + proxy.dimension.width);
                    myLeft = proxy.offset.left - (leftDifference / 2) + offsetX;
                    myTop = (proxy.offset.top + proxy.dimension.height) + offsetY + 12;
                    dontGoOffScreenX();
                    dontGoOffScreenY('top', 'bottom');
                }

                if (practicalPosition == 'bottom-left') {
                    myLeft = proxy.offset.left + offsetX;
                    myTop = (proxy.offset.top + proxy.dimension.height) + offsetY + 12;
                    dontGoOffScreenX();
                    dontGoOffScreenY('top-left', 'bottom-left');
                }

                if (practicalPosition == 'bottom-right') {
                    myLeft = (proxy.offset.left + proxy.dimension.width + offsetX) - tooltipWidth;
                    myTop = (proxy.offset.top + proxy.dimension.height) + offsetY + 12;
                    dontGoOffScreenX();
                    dontGoOffScreenY('top-right', 'bottom-right');
                }

                if (practicalPosition == 'left') {
                    myLeft = proxy.offset.left - offsetX - tooltipWidth - 12;
                    myLeftMirror = proxy.offset.left + offsetX + proxy.dimension.width + 12;
                    var topDifference = (proxy.offset.top + tooltipHeight) - (proxy.offset.top + proxy.dimension.height);
                    myTop = proxy.offset.top - (topDifference / 2) - offsetY;

                    // if the tooltip goes off boths sides of the page
                    if ((myLeft < 0) && ((myLeftMirror + tooltipWidth) > windowWidth)) {
                        var borderWidth = parseFloat(self.$tooltip.css('border-width')) * 2,
							newWidth = (tooltipWidth + myLeft) - borderWidth;
                        self.$tooltip.css('width', newWidth + 'px');

                        tooltipHeight = self.$tooltip.outerHeight(false);
                        myLeft = proxy.offset.left - offsetX - newWidth - 12 - borderWidth;
                        topDifference = (proxy.offset.top + tooltipHeight) - (proxy.offset.top + proxy.dimension.height);
                        myTop = proxy.offset.top - (topDifference / 2) - offsetY;
                    }

                        // if it only goes off one side, flip it to the other side
                    else if (myLeft < 0) {
                        myLeft = proxy.offset.left + offsetX + proxy.dimension.width + 12;
                        arrowReposition = 'left';
                    }
                }

                if (practicalPosition == 'right') {
                    myLeft = proxy.offset.left + offsetX + proxy.dimension.width + 12;
                    myLeftMirror = proxy.offset.left - offsetX - tooltipWidth - 12;
                    var topDifference = (proxy.offset.top + tooltipHeight) - (proxy.offset.top + proxy.dimension.height);
                    myTop = proxy.offset.top - (topDifference / 2) - offsetY;

                    // if the tooltip goes off boths sides of the page
                    if (((myLeft + tooltipWidth) > windowWidth) && (myLeftMirror < 0)) {
                        var borderWidth = parseFloat(self.$tooltip.css('border-width')) * 2,
							newWidth = (windowWidth - myLeft) - borderWidth;
                        self.$tooltip.css('width', newWidth + 'px');

                        tooltipHeight = self.$tooltip.outerHeight(false);
                        topDifference = (proxy.offset.top + tooltipHeight) - (proxy.offset.top + proxy.dimension.height);
                        myTop = proxy.offset.top - (topDifference / 2) - offsetY;
                    }

                        // if it only goes off one side, flip it to the other side
                    else if ((myLeft + tooltipWidth) > windowWidth) {
                        myLeft = proxy.offset.left - offsetX - tooltipWidth - 12;
                        arrowReposition = 'right';
                    }
                }

                // if arrow is set true, style it and append it
                if (self.options.arrow) {

                    var arrowClass = 'tooltipster-arrow-' + practicalPosition;

                    // set color of the arrow
                    if (self.options.arrowColor.length < 1) {
                        var arrowColor = self.$tooltip.css('background-color');
                    }
                    else {
                        var arrowColor = self.options.arrowColor;
                    }

                    // if the tooltip was going off the page and had to re-adjust, we need to update the arrow's position
                    if (!arrowReposition) {
                        arrowReposition = '';
                    }
                    else if (arrowReposition == 'left') {
                        arrowClass = 'tooltipster-arrow-right';
                        arrowReposition = '';
                    }
                    else if (arrowReposition == 'right') {
                        arrowClass = 'tooltipster-arrow-left';
                        arrowReposition = '';
                    }
                    else {
                        arrowReposition = 'left:' + Math.round(arrowReposition) + 'px;';
                    }

                    // building the logic to create the border around the arrow of the tooltip
                    if ((practicalPosition == 'top') || (practicalPosition == 'top-left') || (practicalPosition == 'top-right')) {
                        var tooltipBorderWidth = parseFloat(self.$tooltip.css('border-bottom-width')),
							tooltipBorderColor = self.$tooltip.css('border-bottom-color');
                    }
                    else if ((practicalPosition == 'bottom') || (practicalPosition == 'bottom-left') || (practicalPosition == 'bottom-right')) {
                        var tooltipBorderWidth = parseFloat(self.$tooltip.css('border-top-width')),
							tooltipBorderColor = self.$tooltip.css('border-top-color');
                    }
                    else if (practicalPosition == 'left') {
                        var tooltipBorderWidth = parseFloat(self.$tooltip.css('border-right-width')),
							tooltipBorderColor = self.$tooltip.css('border-right-color');
                    }
                    else if (practicalPosition == 'right') {
                        var tooltipBorderWidth = parseFloat(self.$tooltip.css('border-left-width')),
							tooltipBorderColor = self.$tooltip.css('border-left-color');
                    }
                    else {
                        var tooltipBorderWidth = parseFloat(self.$tooltip.css('border-bottom-width')),
							tooltipBorderColor = self.$tooltip.css('border-bottom-color');
                    }

                    if (tooltipBorderWidth > 1) {
                        tooltipBorderWidth++;
                    }

                    var arrowBorder = '';
                    if (tooltipBorderWidth !== 0) {
                        var arrowBorderSize = '',
							arrowBorderColor = 'border-color: ' + tooltipBorderColor + ';';
                        if (arrowClass.indexOf('bottom') !== -1) {
                            arrowBorderSize = 'margin-top: -' + Math.round(tooltipBorderWidth) + 'px;';
                        }
                        else if (arrowClass.indexOf('top') !== -1) {
                            arrowBorderSize = 'margin-bottom: -' + Math.round(tooltipBorderWidth) + 'px;';
                        }
                        else if (arrowClass.indexOf('left') !== -1) {
                            arrowBorderSize = 'margin-right: -' + Math.round(tooltipBorderWidth) + 'px;';
                        }
                        else if (arrowClass.indexOf('right') !== -1) {
                            arrowBorderSize = 'margin-left: -' + Math.round(tooltipBorderWidth) + 'px;';
                        }
                        arrowBorder = '<span class="tooltipster-arrow-border" style="' + arrowBorderSize + ' ' + arrowBorderColor + ';"></span>';
                    }

                    // if the arrow already exists, remove and replace it
                    self.$tooltip.find('.tooltipster-arrow').remove();

                    // build out the arrow and append it		
                    var arrowConstruct = '<div class="' + arrowClass + ' tooltipster-arrow" style="' + arrowReposition + '">' + arrowBorder + '<span style="border-color:' + arrowColor + ';"></span></div>';
                    self.$tooltip.append(arrowConstruct);
                }

                // position the tooltip
                self.$tooltip.css({ 'top': Math.round(myTop) + 'px', 'left': Math.round(myLeft) + 'px' });
            }

            return self;
        },

        enable: function () {
            this.enabled = true;
            return this;
        },

        disable: function () {
            // hide first, in case the tooltip would not disappear on its own (autoClose false)
            this.hide();
            this.enabled = false;
            return this;
        },

        destroy: function () {

            var self = this;

            self.hide();

            // remove the icon, if any
            if (self.$el[0] !== self.$elProxy[0]) {
                self.$elProxy.remove();
            }

            self.$el
				.removeData(self.namespace)
				.off('.' + self.namespace);

            var ns = self.$el.data('tooltipster-ns');

            // if there are no more tooltips on this element
            if (ns.length === 1) {

                // optional restoration of a title attribute
                var title = null;
                if (self.options.restoration === 'previous') {
                    title = self.$el.data('tooltipster-initialTitle');
                }
                else if (self.options.restoration === 'current') {

                    // old school technique to stringify when outerHTML is not supported
                    title =
						(typeof self.Content === 'string') ?
						self.Content :
						$('<div></div>').append(self.Content).html();
                }

                if (title) {
                    self.$el.attr('title', title);
                }

                // final cleaning
                self.$el
					.removeClass('tooltipstered')
					.removeData('tooltipster-ns')
					.removeData('tooltipster-initialTitle');
            }
            else {
                // remove the instance namespace from the list of namespaces of tooltips present on the element
                ns = $.grep(ns, function (el, i) {
                    return el !== self.namespace;
                });
                self.$el.data('tooltipster-ns', ns);
            }

            return self;
        },

        elementIcon: function () {
            return (this.$el[0] !== this.$elProxy[0]) ? this.$elProxy[0] : undefined;
        },

        elementTooltip: function () {
            return this.$tooltip ? this.$tooltip[0] : undefined;
        },

        // public methods but for internal use only
        // getter if val is ommitted, setter otherwise
        option: function (o, val) {
            if (typeof val == 'undefined') return this.options[o];
            else {
                this.options[o] = val;
                return this;
            }
        },
        status: function () {
            return this.Status;
        }
    };

    $.fn[pluginName] = function () {

        // for using in closures
        var args = arguments;

        // if we are not in the context of jQuery wrapped HTML element(s) :
        // this happens when calling static methods in the form $.fn.tooltipster('methodName'), or when calling $(sel).tooltipster('methodName or options') where $(sel) does not match anything
        if (this.length === 0) {

            // if the first argument is a method name
            if (typeof args[0] === 'string') {

                var methodIsStatic = true;

                // list static methods here (usable by calling $.fn.tooltipster('methodName');)
                switch (args[0]) {

                    case 'setDefaults':
                        // change default options for all future instances
                        $.extend(defaults, args[1]);
                        break;

                    default:
                        methodIsStatic = false;
                        break;
                }

                // $.fn.tooltipster('methodName') calls will return true
                if (methodIsStatic) return true;
                    // $(sel).tooltipster('methodName') calls will return the list of objects event though it's empty because chaining should work on empty lists
                else return this;
            }
                // the first argument is undefined or an object of options : we are initalizing but there is no element matched by selector
            else {
                // still chainable : same as above
                return this;
            }
        }
            // this happens when calling $(sel).tooltipster('methodName or options') where $(sel) matches one or more elements
        else {

            // method calls
            if (typeof args[0] === 'string') {

                var v = '#*$~&';

                this.each(function () {

                    // retrieve the namepaces of the tooltip(s) that exist on that element. We will interact with the first tooltip only.
                    var ns = $(this).data('tooltipster-ns'),
						// self represents the instance of the first tooltipster plugin associated to the current HTML object of the loop
						self = ns ? $(this).data(ns[0]) : null;

                    // if the current element holds a tooltipster instance
                    if (self) {

                        if (typeof self[args[0]] === 'function') {
                            // note : args[1] and args[2] may not be defined
                            var resp = self[args[0]](args[1], args[2]);
                        }
                        else {
                            throw new Error('Unknown method .tooltipster("' + args[0] + '")');
                        }

                        // if the function returned anything other than the instance itself (which implies chaining)
                        if (resp !== self) {
                            v = resp;
                            // return false to stop .each iteration on the first element matched by the selector
                            return false;
                        }
                    }
                    else {
                        throw new Error('You called Tooltipster\'s "' + args[0] + '" method on an uninitialized element');
                    }
                });

                return (v !== '#*$~&') ? v : this;
            }
                // first argument is undefined or an object : the tooltip is initializing
            else {

                var instances = [],
					// is there a defined value for the multiple option in the options object ?
					multipleIsSet = args[0] && typeof args[0].multiple !== 'undefined',
					// if the multiple option is set to true, or if it's not defined but set to true in the defaults
					multiple = (multipleIsSet && args[0].multiple) || (!multipleIsSet && defaults.multiple),
					// same for debug
					debugIsSet = args[0] && typeof args[0].debug !== 'undefined',
					debug = (debugIsSet && args[0].debug) || (!debugIsSet && defaults.debug);

                // initialize a tooltipster instance for each element if it doesn't already have one or if the multiple option is set, and attach the object to it
                this.each(function () {

                    var go = false,
						ns = $(this).data('tooltipster-ns'),
						instance = null;

                    if (!ns) {
                        go = true;
                    }
                    else if (multiple) {
                        go = true;
                    }
                    else if (debug) {
                        console.log('Tooltipster: one or more tooltips are already attached to this element: ignoring. Use the "multiple" option to attach more tooltips.');
                    }

                    if (go) {
                        instance = new Plugin(this, args[0]);

                        // save the reference of the new instance
                        if (!ns) ns = [];
                        ns.push(instance.namespace);
                        $(this).data('tooltipster-ns', ns)

                        // save the instance itself
                        $(this).data(instance.namespace, instance);
                    }

                    instances.push(instance);
                });

                if (multiple) return instances;
                else return this;
            }
        }
    };

    // quick & dirty compare function (not bijective nor multidimensional)
    function areEqual(a, b) {
        var same = true;
        $.each(a, function (i, el) {
            if (typeof b[i] === 'undefined' || a[i] !== b[i]) {
                same = false;
                return false;
            }
        });
        return same;
    }

    // detect if this device can trigger touch events
    var deviceHasTouchCapability = !!('ontouchstart' in window);

    // we'll assume the device has no mouse until we detect any mouse movement
    var deviceHasMouse = false;
    $('body').one('mousemove', function () {
        deviceHasMouse = true;
    });

    function deviceIsPureTouch() {
        return (!deviceHasMouse && deviceHasTouchCapability);
    }

    // detecting support for CSS transitions
    function supportsTransitions() {
        var b = document.body || document.documentElement,
			s = b.style,
			p = 'transition';

        if (typeof s[p] == 'string') { return true; }

        v = ['Moz', 'Webkit', 'Khtml', 'O', 'ms'],
		p = p.charAt(0).toUpperCase() + p.substr(1);
        for (var i = 0; i < v.length; i++) {
            if (typeof s[v[i] + p] == 'string') { return true; }
        }
        return false;
    }
})(jQuery, window, document);

/*! Copyright (c) 2010 Brandon Aaron (http://brandonaaron.net)
 * Licensed under the MIT License (LICENSE.txt).
 *
 * Thanks to: http://adomas.org/javascript-mouse-wheel/ for some pointers.
 * Thanks to: Mathias Bank(http://www.mathias-bank.de) for a scope bug fix.
 * Thanks to: Seamus Leahy for adding deltaX and deltaY
 *
 * Version: 3.0.4
 * 
 * Requires: 1.2.2+
 */

(function($) {

var types = ['DOMMouseScroll', 'mousewheel'];

$.event.special.mousewheel = {
    setup: function() {
        if ( this.addEventListener ) {
            for ( var i=types.length; i; ) {
                this.addEventListener( types[--i], handler, false );
            }
        } else {
            this.onmousewheel = handler;
        }
    },
    
    teardown: function() {
        if ( this.removeEventListener ) {
            for ( var i=types.length; i; ) {
                this.removeEventListener( types[--i], handler, false );
            }
        } else {
            this.onmousewheel = null;
        }
    }
};

$.fn.extend({
    mousewheel: function(fn) {
        return fn ? this.bind("mousewheel", fn) : this.trigger("mousewheel");
    },
    
    unmousewheel: function(fn) {
        return this.unbind("mousewheel", fn);
    }
});


function handler(event) {
    var orgEvent = event || window.event, args = [].slice.call( arguments, 1 ), delta = 0, returnValue = true, deltaX = 0, deltaY = 0;
    event = $.event.fix(orgEvent);
    event.type = "mousewheel";
    
    // Old school scrollwheel delta
    if ( event.wheelDelta ) { delta = event.wheelDelta/120; }
    if ( event.detail     ) { delta = -event.detail/3; }
    
    // New school multidimensional scroll (touchpads) deltas
    deltaY = delta;
    
    // Gecko
    if ( orgEvent.axis !== undefined && orgEvent.axis === orgEvent.HORIZONTAL_AXIS ) {
        deltaY = 0;
        deltaX = -1*delta;
    }
    
    // Webkit
    if ( orgEvent.wheelDeltaY !== undefined ) { deltaY = orgEvent.wheelDeltaY/120; }
    if ( orgEvent.wheelDeltaX !== undefined ) { deltaX = -1*orgEvent.wheelDeltaX/120; }
    
    // Add event and delta to the front of the arguments
    args.unshift(event, delta, deltaX, deltaY);
    
    return $.event.handle.apply(this, args);
}

})(jQuery);
/**
 * nlform.js v1.0.0
 * http://www.codrops.com
 *
 * Licensed under the MIT license.
 * http://www.opensource.org/licenses/mit-license.php
 * 
 * Copyright 2013, Codrops
 * http://www.codrops.com
 */
; (function (window) {

    'use strict';

    var document = window.document;

    if (!String.prototype.trim) {
        String.prototype.trim = function () { return this.replace(/^\s+|\s+$/g, ''); };
    }

    function NLForm(el) {
        if (el !== null) {
            this.el = el;
            this.overlay = this.el.querySelector('.nl-overlay');
            this.fields = [];
            this.fldOpen = -1;
            this._init();
        }
    }

    NLForm.prototype = {
        _init: function () {
            var self = this;
            Array.prototype.slice.call(this.el.querySelectorAll('select')).forEach(function (el, i) {
                self.fldOpen++;
                self.fields.push(new NLField(self, el, 'dropdown', self.fldOpen));
            });
            Array.prototype.slice.call(this.el.querySelectorAll('input')).forEach(function (el, i) {
                self.fldOpen++;
                self.fields.push(new NLField(self, el, 'input', self.fldOpen));
            });
            this.overlay.addEventListener('click', function (ev) { self._closeFlds(); });
            this.overlay.addEventListener('touchstart', function (ev) { self._closeFlds(); });
        },
        _closeFlds: function () {
            if (this.fldOpen !== -1) {
                this.fields[this.fldOpen].close();
            }
        }
    }

    function NLField(form, el, type, idx) {
        this.form = form;
        this.elOriginal = el;
        this.pos = idx;
        this.type = type;
        this._create();
        this._initEvents();
    }

    NLField.prototype = {
        _create: function () {
            if (this.type === 'dropdown') {
                this._createDropDown();
            }
            else if (this.type === 'input') {
                this._createInput();
            }
        },
        _createDropDown: function () {
            var self = this;
            this.fld = document.createElement('div');
            this.fld.className = 'nl-field nl-dd';
            this.toggle = document.createElement('a');
            this.toggle.innerHTML = this.elOriginal.options[this.elOriginal.selectedIndex].innerHTML;
            this.toggle.className = 'nl-field-toggle';
            this.optionsList = document.createElement('ul');
            var ihtml = '';
            Array.prototype.slice.call(this.elOriginal.querySelectorAll('option')).forEach(function (el, i) {
                ihtml += self.elOriginal.selectedIndex === i ? '<li class="nl-dd-checked">' + el.innerHTML + '</li>' : '<li>' + el.innerHTML + '</li>';
                // selected index value
                if (self.elOriginal.selectedIndex === i) {
                    self.selectedIdx = i;
                }
            });
            this.optionsList.innerHTML = ihtml;
            this.fld.appendChild(this.toggle);
            this.fld.appendChild(this.optionsList);
            this.elOriginal.parentNode.insertBefore(this.fld, this.elOriginal);
            this.elOriginal.style.display = 'none';
        },
        _createInput: function () {
            var self = this;
            this.fld = document.createElement('div');
            this.fld.className = 'nl-field nl-ti-text';
            this.toggle = document.createElement('a');
            this.toggle.innerHTML = this.elOriginal.getAttribute('placeholder');
            this.toggle.className = 'nl-field-toggle';
            this.optionsList = document.createElement('ul');
            this.getinput = document.createElement('input');
            this.getinput.setAttribute('type', 'text');
            this.getinput.setAttribute('placeholder', this.elOriginal.getAttribute('placeholder'));
            this.getinputWrapper = document.createElement('li');
            this.getinputWrapper.className = 'nl-ti-input';
            this.inputsubmit = document.createElement('button');
            this.inputsubmit.className = 'nl-field-go';
            this.inputsubmit.innerHTML = 'Go';
            this.getinputWrapper.appendChild(this.getinput);
            this.getinputWrapper.appendChild(this.inputsubmit);
            this.example = document.createElement('li');
            this.example.className = 'nl-ti-example';
            this.example.innerHTML = this.elOriginal.getAttribute('data-subline');
            this.optionsList.appendChild(this.getinputWrapper);
            this.optionsList.appendChild(this.example);
            this.fld.appendChild(this.toggle);
            this.fld.appendChild(this.optionsList);
            this.elOriginal.parentNode.insertBefore(this.fld, this.elOriginal);
            this.elOriginal.style.display = 'none';
        },
        _initEvents: function () {
            var self = this;
            this.toggle.addEventListener('click', function (ev) { ev.preventDefault(); ev.stopPropagation(); self._open(); });
            this.toggle.addEventListener('touchstart', function (ev) { ev.preventDefault(); ev.stopPropagation(); self._open(); });

            if (this.type === 'dropdown') {
                var opts = Array.prototype.slice.call(this.optionsList.querySelectorAll('li'));
                opts.forEach(function (el, i) {
                    el.addEventListener('click', function (ev) { ev.preventDefault(); self.close(el, opts.indexOf(el)); });
                    el.addEventListener('touchstart', function (ev) { ev.preventDefault(); self.close(el, opts.indexOf(el)); });
                });
            }
            else if (this.type === 'input') {
                this.getinput.addEventListener('keydown', function (ev) {
                    if (ev.keyCode == 13) {
                        self.close();
                    }
                });
                this.inputsubmit.addEventListener('click', function (ev) { ev.preventDefault(); self.close(); });
                this.inputsubmit.addEventListener('touchstart', function (ev) { ev.preventDefault(); self.close(); });
            }

        },
        _open: function () {
            if (this.open) {
                return false;
            }
            this.open = true;
            this.form.fldOpen = this.pos;
            var self = this;
            this.fld.className += ' nl-field-open';
        },
        close: function (opt, idx) {
            if (!this.open) {
                return false;
            }
            this.open = false;
            this.form.fldOpen = -1;
            this.fld.className = this.fld.className.replace(/\b nl-field-open\b/, '');

            if (this.type === 'dropdown') {
                if (opt) {
                    // remove class nl-dd-checked from previous option
                    var selectedopt = this.optionsList.children[this.selectedIdx];
                    selectedopt.className = '';
                    opt.className = 'nl-dd-checked';
                    this.toggle.innerHTML = opt.innerHTML;
                    // update selected index value
                    this.selectedIdx = idx;
                    // update original select element´s value
                    this.elOriginal.value = this.elOriginal.children[this.selectedIdx].value;
                }
            }
            else if (this.type === 'input') {
                this.getinput.blur();
                this.toggle.innerHTML = this.getinput.value.trim() !== '' ? this.getinput.value : this.getinput.getAttribute('placeholder');
                this.elOriginal.value = this.getinput.value;
            }
        }
    }

    // add to global namespace
    window.NLForm = NLForm;

})(window);
/**
 * Prism: Lightweight, robust, elegant syntax highlighting
 * MIT license http://www.opensource.org/licenses/mit-license.php/
 * @author Lea Verou http://lea.verou.me
 */
(function () {
    var e = /\blang(?:uage)?-(?!\*)(\w+)\b/i, t = self.Prism = {
        util: {
            type: function (e) {
                return Object.prototype.toString.call(e).match(/\[object (\w+)\]/)[1]
            },
            clone: function (e) {
                var n = t.util.type(e);
                switch (n) {
                    case "Object":
                        var r = {};
                        for (var i in e)
                            e.hasOwnProperty(i) && (r[i] = t.util.clone(e[i]));
                        return r;
                    case "Array":
                        return e.slice()
                }
                return e
            }
        },
        languages: {
            extend: function (e, n) {
                var r = t.util.clone(t.languages[e]);
                for (var i in n)
                    r[i] = n[i];
                return r
            },
            insertBefore: function (e, n, r, i) {
                i = i || t.languages;
                var s = i[e], o = {};
                for (var u in s)
                    if (s.hasOwnProperty(u)) {
                        if (u == n)
                            for (var a in r)
                                r.hasOwnProperty(a) && (o[a] = r[a]);
                        o[u] = s[u]
                    }
                return i[e] = o
            },
            DFS: function (e, n) {
                for (var r in e) {
                    n.call(e, r, e[r]);
                    t.util.type(e) === "Object" && t.languages.DFS(e[r], n)
                }
            }
        },
        highlightAll: function (e, n) {
            var r = document.querySelectorAll('code[class*="language-"], [class*="language-"] code, code[class*="lang-"], [class*="lang-"] code');
            for (var i = 0, s; s = r[i++];)
                t.highlightElement(s, e === !0, n)
        },
        highlightElement: function (r, i, s) {
            var o, u, a = r;
            while (a && !e.test(a.className))
                a = a.parentNode;
            if (a) {
                o = (a.className.match(e) || [, ""])[1];
                u = t.languages[o]
            }
            if (!u)
                return;
            r.className = r.className.replace(e, "").replace(/\s+/g, " ") + " language-" + o;
            a = r.parentNode;
            /pre/i.test(a.nodeName) && (a.className = a.className.replace(e, "").replace(/\s+/g, " ") + " language-" + o);
            var f = r.textContent;
            if (!f)
                return;
            f = f.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/\u00a0/g, " ");
            var l = {
                element: r,
                language: o,
                grammar: u,
                code: f
            };
            t.hooks.run("before-highlight", l);
            if (i && self.Worker) {
                var c = new Worker(t.filename);
                c.onmessage = function (e) {
                    l.highlightedCode = n.stringify(JSON.parse(e.data), o);
                    t.hooks.run("before-insert", l);
                    l.element.innerHTML = l.highlightedCode;
                    s && s.call(l.element);
                    t.hooks.run("after-highlight", l)
                };
                c.postMessage(JSON.stringify({
                    language: l.language,
                    code: l.code
                }))
            } else {
                l.highlightedCode = t.highlight(l.code, l.grammar, l.language);
                t.hooks.run("before-insert", l);
                l.element.innerHTML = l.highlightedCode;
                s && s.call(r);
                t.hooks.run("after-highlight", l)
            }
        },
        highlight: function (e, r, i) {
            return n.stringify(t.tokenize(e, r), i)
        },
        tokenize: function (e, n, r) {
            var i = t.Token, s = [e], o = n.rest;
            if (o) {
                for (var u in o)
                    n[u] = o[u];
                delete n.rest
            }
            e: for (var u in n) {
                if (!n.hasOwnProperty(u) || !n[u])
                    continue;
                var a = n[u], f = a.inside, l = !!a.lookbehind, c = 0;
                a = a.pattern || a;
                for (var h = 0; h < s.length; h++) {
                    var p = s[h];
                    if (s.length > e.length)
                        break e;
                    if (p instanceof i)
                        continue;
                    a.lastIndex = 0;
                    var d = a.exec(p);
                    if (d) {
                        l && (c = d[1].length);
                        var v = d.index - 1 + c, d = d[0].slice(c), m = d.length, g = v + m, y = p.slice(0, v + 1), b = p.slice(g + 1), w = [h, 1];
                        y && w.push(y);
                        var E = new i(u, f ? t.tokenize(d, f) : d);
                        w.push(E);
                        b && w.push(b);
                        Array.prototype.splice.apply(s, w)
                    }
                }
            }
            return s
        },
        hooks: {
            all: {},
            add: function (e, n) {
                var r = t.hooks.all;
                r[e] = r[e] || [];
                r[e].push(n)
            },
            run: function (e, n) {
                var r = t.hooks.all[e];
                if (!r || !r.length)
                    return;
                for (var i = 0, s; s = r[i++];)
                    s(n)
            }
        }
    }, n = t.Token = function (e, t) {
        this.type = e;
        this.content = t
    };
    n.stringify = function (e, r, i) {
        if (typeof e == "string")
            return e;
        if (Object.prototype.toString.call(e) == "[object Array]")
            return e.map(function (t) {
                return n.stringify(t, r, e)
            }).join("");
        var s = {
            type: e.type,
            content: n.stringify(e.content, r, i),
            tag: "span",
            classes: ["token", e.type],
            attributes: {},
            language: r,
            parent: i
        };
        s.type == "comment" && (s.attributes.spellcheck = "true");
        t.hooks.run("wrap", s);
        var o = "";
        for (var u in s.attributes)
            o += u + '="' + (s.attributes[u] || "") + '"';
        return "<" + s.tag + ' class="' + s.classes.join(" ") + '" ' + o + ">" + s.content + "</" + s.tag + ">"
    };
    if (!self.document) {
        self.addEventListener("message", function (e) {
            var n = JSON.parse(e.data), r = n.language, i = n.code;
            self.postMessage(JSON.stringify(t.tokenize(i, t.languages[r])));
            self.close()
        }, !1);
        return
    }
    var r = document.getElementsByTagName("script");
    r = r[r.length - 1];
    if (r) {
        t.filename = r.src;
        document.addEventListener && !r.hasAttribute("data-manual") && document.addEventListener("DOMContentLoaded", t.highlightAll)
    }
})();;
Prism.languages.markup = {
    comment: /&lt;!--[\w\W]*?-->/g,
    prolog: /&lt;\?.+?\?>/,
    doctype: /&lt;!DOCTYPE.+?>/,
    cdata: /&lt;!\[CDATA\[[\w\W]*?]]>/i,
    tag: {
        pattern: /&lt;\/?[\w:-]+\s*(?:\s+[\w:-]+(?:=(?:("|')(\\?[\w\W])*?\1|\w+))?\s*)*\/?>/gi,
        inside: {
            tag: {
                pattern: /^&lt;\/?[\w:-]+/i,
                inside: {
                    punctuation: /^&lt;\/?/,
                    namespace: /^[\w-]+?:/
                }
            },
            "attr-value": {
                pattern: /=(?:('|")[\w\W]*?(\1)|[^\s>]+)/gi,
                inside: {
                    punctuation: /=|>|"/g
                }
            },
            punctuation: /\/?>/g,
            "attr-name": {
                pattern: /[\w:-]+/g,
                inside: {
                    namespace: /^[\w-]+?:/
                }
            }
        }
    },
    entity: /&amp;#?[\da-z]{1,8};/gi
};
Prism.hooks.add("wrap", function (e) {
    e.type === "entity" && (e.attributes.title = e.content.replace(/&amp;/, "&"))
});;
Prism.languages.css = {
    comment: /\/\*[\w\W]*?\*\//g,
    atrule: {
        pattern: /@[\w-]+?.*?(;|(?=\s*{))/gi,
        inside: {
            punctuation: /[;:]/g
        }
    },
    url: /url\((["']?).*?\1\)/gi,
    selector: /[^\{\}\s][^\{\};]*(?=\s*\{)/g,
    property: /(\b|\B)[\w-]+(?=\s*:)/ig,
    string: /("|')(\\?.)*?\1/g,
    important: /\B!important\b/gi,
    ignore: /&(lt|gt|amp);/gi,
    punctuation: /[\{\};:]/g
};
Prism.languages.markup && Prism.languages.insertBefore("markup", "tag", {
    style: {
        pattern: /(&lt;|<)style[\w\W]*?(>|&gt;)[\w\W]*?(&lt;|<)\/style(>|&gt;)/ig,
        inside: {
            tag: {
                pattern: /(&lt;|<)style[\w\W]*?(>|&gt;)|(&lt;|<)\/style(>|&gt;)/ig,
                inside: Prism.languages.markup.tag.inside
            },
            rest: Prism.languages.css
        }
    }
});;
Prism.languages.clike = {
    comment: {
        pattern: /(^|[^\\])(\/\*[\w\W]*?\*\/|(^|[^:])\/\/.*?(\r?\n|$))/g,
        lookbehind: !0
    },
    string: /("|')(\\?.)*?\1/g,
    "class-name": {
        pattern: /((?:(?:class|interface|extends|implements|trait|instanceof|new)\s+)|(?:catch\s+\())[a-z0-9_\.\\]+/ig,
        lookbehind: !0,
        inside: {
            punctuation: /(\.|\\)/
        }
    },
    keyword: /\b(if|else|while|do|for|return|in|instanceof|function|new|try|catch|finally|null|break|continue)\b/g,
    "boolean": /\b(true|false)\b/g,
    "function": {
        pattern: /[a-z0-9_]+\(/ig,
        inside: {
            punctuation: /\(/
        }
    },
    number: /\b-?(0x[\dA-Fa-f]+|\d*\.?\d+([Ee]-?\d+)?)\b/g,
    operator: /[-+]{1,2}|!|&lt;=?|>=?|={1,3}|(&amp;){1,2}|\|?\||\?|\*|\/|\~|\^|\%/g,
    ignore: /&(lt|gt|amp);/gi,
    punctuation: /[{}[\];(),.:]/g
};;
Prism.languages.javascript = Prism.languages.extend("clike", {
    keyword: /\b(var|let|if|else|while|do|for|return|in|instanceof|function|new|with|typeof|try|catch|finally|null|break|continue)\b/g,
    number: /\b-?(0x[\dA-Fa-f]+|\d*\.?\d+([Ee]-?\d+)?|NaN|-?Infinity)\b/g
});
Prism.languages.insertBefore("javascript", "keyword", {
    regex: {
        pattern: /(^|[^/])\/(?!\/)(\[.+?]|\\.|[^/\r\n])+\/[gim]{0,3}(?=\s*($|[\r\n,.;})]))/g,
        lookbehind: !0
    }
});
Prism.languages.markup && Prism.languages.insertBefore("markup", "tag", {
    script: {
        pattern: /(&lt;|<)script[\w\W]*?(>|&gt;)[\w\W]*?(&lt;|<)\/script(>|&gt;)/ig,
        inside: {
            tag: {
                pattern: /(&lt;|<)script[\w\W]*?(>|&gt;)|(&lt;|<)\/script(>|&gt;)/ig,
                inside: Prism.languages.markup.tag.inside
            },
            rest: Prism.languages.javascript
        }
    }
});;



/*!
 * Salvattore 1.0.9 by @rnmp and @ppold
 * https://github.com/rnmp/salvattore
 */
(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        define([], factory);
    } else if (typeof exports === 'object') {
        module.exports = factory();
    } else {
        root.salvattore = factory();
    }
}(this, function () {
    /*! matchMedia() polyfill - Test a CSS media type/query in JS. Authors & copyright (c) 2012: Scott Jehl, Paul Irish, Nicholas Zakas, David Knight. Dual MIT/BSD license */

    if (!window.matchMedia) {
        window.matchMedia = function () {
            "use strict";

            // For browsers that support matchMedium api such as IE 9 and webkit
            var styleMedia = (window.styleMedia || window.media);

            // For those that don't support matchMedium
            if (!styleMedia) {
                var style = document.createElement('style'),
                    script = document.getElementsByTagName('script')[0],
                    info = null;

                style.type = 'text/css';
                style.id = 'matchmediajs-test';

                script.parentNode.insertBefore(style, script);

                // 'style.currentStyle' is used by IE <= 8 and 'window.getComputedStyle' for all other browsers
                info = ('getComputedStyle' in window) && window.getComputedStyle(style, null) || style.currentStyle;

                styleMedia = {
                    matchMedium: function (media) {
                        var text = '@media ' + media + '{ #matchmediajs-test { width: 1px; } }';

                        // 'style.styleSheet' is used by IE <= 8 and 'style.textContent' for all other browsers
                        if (style.styleSheet) {
                            style.styleSheet.cssText = text;
                        } else {
                            style.textContent = text;
                        }

                        // Test if media query is true or false
                        return info.width === '1px';
                    }
                };
            }

            return function (media) {
                return {
                    matches: styleMedia.matchMedium(media || 'all'),
                    media: media || 'all'
                };
            };
        }();
    }

    /*! matchMedia() polyfill addListener/removeListener extension. Author & copyright (c) 2012: Scott Jehl. Dual MIT/BSD license */
    (function () {
        "use strict";

        // Bail out for browsers that have addListener support
        if (window.matchMedia && window.matchMedia('all').addListener) {
            return false;
        }

        var localMatchMedia = window.matchMedia,
            hasMediaQueries = localMatchMedia('only all').matches,
            isListening = false,
            timeoutID = 0,    // setTimeout for debouncing 'handleChange'
            queries = [],   // Contains each 'mql' and associated 'listeners' if 'addListener' is used
            handleChange = function (evt) {
                // Debounce
                clearTimeout(timeoutID);

                timeoutID = setTimeout(function () {
                    for (var i = 0, il = queries.length; i < il; i++) {
                        var mql = queries[i].mql,
                            listeners = queries[i].listeners || [],
                            matches = localMatchMedia(mql.media).matches;

                        // Update mql.matches value and call listeners
                        // Fire listeners only if transitioning to or from matched state
                        if (matches !== mql.matches) {
                            mql.matches = matches;

                            for (var j = 0, jl = listeners.length; j < jl; j++) {
                                listeners[j].call(window, mql);
                            }
                        }
                    }
                }, 30);
            };

        window.matchMedia = function (media) {
            var mql = localMatchMedia(media),
                listeners = [],
                index = 0;

            mql.addListener = function (listener) {
                // Changes would not occur to css media type so return now (Affects IE <= 8)
                if (!hasMediaQueries) {
                    return;
                }

                // Set up 'resize' listener for browsers that support CSS3 media queries (Not for IE <= 8)
                // There should only ever be 1 resize listener running for performance
                if (!isListening) {
                    isListening = true;
                    window.addEventListener('resize', handleChange, true);
                }

                // Push object only if it has not been pushed already
                if (index === 0) {
                    index = queries.push({
                        mql: mql,
                        listeners: listeners
                    });
                }

                listeners.push(listener);
            };

            mql.removeListener = function (listener) {
                for (var i = 0, il = listeners.length; i < il; i++) {
                    if (listeners[i] === listener) {
                        listeners.splice(i, 1);
                    }
                }
            };

            return mql;
        };
    }());

    // http://paulirish.com/2011/requestanimationframe-for-smart-animating/
    // http://my.opera.com/emoller/blog/2011/12/20/requestanimationframe-for-smart-er-animating

    // requestAnimationFrame polyfill by Erik Möller. fixes from Paul Irish and Tino Zijdel

    // MIT license

    (function () {
        "use strict";

        var lastTime = 0;
        var vendors = ['ms', 'moz', 'webkit', 'o'];
        for (var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
            window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
            window.cancelAnimationFrame = window[vendors[x] + 'CancelAnimationFrame'] ||
                window[vendors[x] + 'CancelRequestAnimationFrame'];
        }

        if (!window.requestAnimationFrame)
            window.requestAnimationFrame = function (callback, element) {
                var currTime = new Date().getTime();
                var timeToCall = Math.max(0, 16 - (currTime - lastTime));
                var id = window.setTimeout(function () { callback(currTime + timeToCall); },
                  timeToCall);
                lastTime = currTime + timeToCall;
                return id;
            };

        if (!window.cancelAnimationFrame)
            window.cancelAnimationFrame = function (id) {
                clearTimeout(id);
            };
    }());

    // https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent

    if (typeof window.CustomEvent !== "function") {
        (function () {
            "use strict";
            function CustomEvent(event, params) {
                params = params || { bubbles: false, cancelable: false, detail: undefined };
                var evt = document.createEvent('CustomEvent');
                evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
                return evt;
            }

            CustomEvent.prototype = window.Event.prototype;

            window.CustomEvent = CustomEvent;
        })();
    }

    /* jshint laxcomma: true */
    var salvattore = (function (global, document, undefined) {
        "use strict";

        var self = {},
            grids = [],
            mediaRules = [],
            mediaQueries = [],
            add_to_dataset = function (element, key, value) {
                // uses dataset function or a fallback for <ie10
                if (element.dataset) {
                    element.dataset[key] = value;
                } else {
                    element.setAttribute("data-" + key, value);
                }
                return;
            };

        self.obtainGridSettings = function obtainGridSettings(element) {
            // returns the number of columns and the classes a column should have,
            // from computing the style of the ::before pseudo-element of the grid.

            var computedStyle = global.getComputedStyle(element, ":before")
              , content = computedStyle.getPropertyValue("content").slice(1, -1)
              , matchResult = content.match(/^\s*(\d+)(?:\s?\.(.+))?\s*$/)
              , numberOfColumns = 1
              , columnClasses = []
            ;

            if (matchResult) {
                numberOfColumns = matchResult[1];
                columnClasses = matchResult[2];
                columnClasses = columnClasses ? columnClasses.split(".") : ["column"];
            } else {
                matchResult = content.match(/^\s*\.(.+)\s+(\d+)\s*$/);
                if (matchResult) {
                    columnClasses = matchResult[1];
                    numberOfColumns = matchResult[2];
                    if (numberOfColumns) {
                        numberOfColumns = numberOfColumns.split(".");
                    }
                }
            }

            return {
                numberOfColumns: numberOfColumns,
                columnClasses: columnClasses
            };
        };


        self.addColumns = function addColumns(grid, items) {
            // from the settings obtained, it creates columns with
            // the configured classes and adds to them a list of items.

            var settings = self.obtainGridSettings(grid)
              , numberOfColumns = settings.numberOfColumns
              , columnClasses = settings.columnClasses
              , columnsItems = new Array(+numberOfColumns)
              , columnsFragment = document.createDocumentFragment()
              , i = numberOfColumns
              , selector
            ;

            while (i-- !== 0) {
                selector = "[data-columns] > *:nth-child(" + numberOfColumns + "n-" + i + ")";
                columnsItems.push(items.querySelectorAll(selector));
            }

            columnsItems.forEach(function append_to_grid_fragment(rows) {
                var column = document.createElement("div")
                  , rowsFragment = document.createDocumentFragment()
                ;

                column.className = columnClasses.join(" ");

                Array.prototype.forEach.call(rows, function append_to_column(row) {
                    rowsFragment.appendChild(row);
                });
                column.appendChild(rowsFragment);
                columnsFragment.appendChild(column);
            });

            grid.appendChild(columnsFragment);
            add_to_dataset(grid, 'columns', numberOfColumns);
        };


        self.removeColumns = function removeColumns(grid) {
            // removes all the columns from a grid, and returns a list
            // of items sorted by the ordering of columns.

            var range = document.createRange();
            range.selectNodeContents(grid);

            var columns = Array.prototype.filter.call(range.extractContents().childNodes, function filter_elements(node) {
                return node instanceof global.HTMLElement;
            });

            var numberOfColumns = columns.length
              , numberOfRowsInFirstColumn = columns[0].childNodes.length
              , sortedRows = new Array(numberOfRowsInFirstColumn * numberOfColumns)
            ;

            Array.prototype.forEach.call(columns, function iterate_columns(column, columnIndex) {
                Array.prototype.forEach.call(column.children, function iterate_rows(row, rowIndex) {
                    sortedRows[rowIndex * numberOfColumns + columnIndex] = row;
                });
            });

            var container = document.createElement("div");
            add_to_dataset(container, 'columns', 0);

            sortedRows.filter(function filter_non_null(child) {
                return !!child;
            }).forEach(function append_row(child) {
                container.appendChild(child);
            });

            return container;
        };


        self.recreateColumns = function recreateColumns(grid) {
            // removes all the columns from the grid, and adds them again,
            // it is used when the number of columns change.

            global.requestAnimationFrame(function render_after_css_mediaQueryChange() {
                self.addColumns(grid, self.removeColumns(grid));
                var columnsChange = new CustomEvent("columnsChange");
                grid.dispatchEvent(columnsChange);
            });
        };


        self.mediaQueryChange = function mediaQueryChange(mql) {
            // recreates the columns when a media query matches the current state
            // of the browser.

            if (mql.matches) {
                Array.prototype.forEach.call(grids, self.recreateColumns);
            }
        };


        self.getCSSRules = function getCSSRules(stylesheet) {
            // returns a list of css rules from a stylesheet

            var cssRules;
            try {
                cssRules = stylesheet.sheet.cssRules || stylesheet.sheet.rules;
            } catch (e) {
                return [];
            }

            return cssRules || [];
        };


        self.getStylesheets = function getStylesheets() {
            // returns a list of all the styles in the document (that are accessible).

            var inlineStyleBlocks = Array.prototype.slice.call(document.querySelectorAll("style"));
            inlineStyleBlocks.forEach(function (stylesheet, idx) {
                if (stylesheet.type !== 'text/css' && stylesheet.type !== '') {
                    inlineStyleBlocks.splice(idx, 1);
                }
            });

            return Array.prototype.concat.call(
              inlineStyleBlocks,
              Array.prototype.slice.call(document.querySelectorAll("link[rel='stylesheet']"))
            );
        };


        self.mediaRuleHasColumnsSelector = function mediaRuleHasColumnsSelector(rules) {
            // checks if a media query css rule has in its contents a selector that
            // styles the grid.

            var i, rule;

            try {
                i = rules.length;
            }
            catch (e) {
                i = 0;
            }

            while (i--) {
                rule = rules[i];
                if (rule.selectorText && rule.selectorText.match(/\[data-columns\](.*)::?before$/)) {
                    return true;
                }
            }

            return false;
        };


        self.scanMediaQueries = function scanMediaQueries() {
            // scans all the stylesheets for selectors that style grids,
            // if the matchMedia API is supported.

            var newMediaRules = [];

            if (!global.matchMedia) {
                return;
            }

            self.getStylesheets().forEach(function extract_rules(stylesheet) {
                Array.prototype.forEach.call(self.getCSSRules(stylesheet), function filter_by_column_selector(rule) {
                    // rule.media throws an 'not implemented error' in ie9 for import rules occasionally
                    try {
                        if (rule.media && rule.cssRules && self.mediaRuleHasColumnsSelector(rule.cssRules)) {
                            newMediaRules.push(rule);
                        }
                    } catch (e) { }
                });
            });

            // remove matchMedia listeners from the old rules
            var oldRules = mediaRules.filter(function (el) {
                return newMediaRules.indexOf(el) === -1;
            });
            mediaQueries.filter(function (el) {
                return oldRules.indexOf(el.rule) !== -1;
            }).forEach(function (el) {
                el.mql.removeListener(self.mediaQueryChange);
            });
            mediaQueries = mediaQueries.filter(function (el) {
                return oldRules.indexOf(el.rule) === -1;
            });

            // add matchMedia listeners to the new rules
            newMediaRules.filter(function (el) {
                return mediaRules.indexOf(el) == -1;
            }).forEach(function (rule) {
                var mql = global.matchMedia(rule.media.mediaText);
                mql.addListener(self.mediaQueryChange);
                mediaQueries.push({ rule: rule, mql: mql });
            });

            // swap mediaRules with the new set
            mediaRules.length = 0;
            mediaRules = newMediaRules;
        };


        self.rescanMediaQueries = function rescanMediaQueries() {
            self.scanMediaQueries();
            Array.prototype.forEach.call(grids, self.recreateColumns);
        };


        self.nextElementColumnIndex = function nextElementColumnIndex(grid, fragments) {
            // returns the index of the column where the given element must be added.

            var children = grid.children
              , m = children.length
              , lowestRowCount = 0
              , child
              , currentRowCount
              , i
              , index = 0
            ;
            for (i = 0; i < m; i++) {
                child = children[i];
                currentRowCount = child.children.length + (fragments[i].children || fragments[i].childNodes).length;
                if (lowestRowCount === 0) {
                    lowestRowCount = currentRowCount;
                }
                if (currentRowCount < lowestRowCount) {
                    index = i;
                    lowestRowCount = currentRowCount;
                }
            }

            return index;
        };


        self.createFragmentsList = function createFragmentsList(quantity) {
            // returns a list of fragments

            var fragments = new Array(quantity)
              , i = 0
            ;

            while (i !== quantity) {
                fragments[i] = document.createDocumentFragment();
                i++;
            }

            return fragments;
        };


        self.appendElements = function appendElements(grid, elements) {
            // adds a list of elements to the end of a grid

            var columns = grid.children
              , numberOfColumns = columns.length
              , fragments = self.createFragmentsList(numberOfColumns)
            ;

            Array.prototype.forEach.call(elements, function append_to_next_fragment(element) {
                var columnIndex = self.nextElementColumnIndex(grid, fragments);
                fragments[columnIndex].appendChild(element);
            });

            Array.prototype.forEach.call(columns, function insert_column(column, index) {
                column.appendChild(fragments[index]);
            });
        };


        self.prependElements = function prependElements(grid, elements) {
            // adds a list of elements to the start of a grid

            var columns = grid.children
              , numberOfColumns = columns.length
              , fragments = self.createFragmentsList(numberOfColumns)
              , columnIndex = numberOfColumns - 1
            ;

            elements.forEach(function append_to_next_fragment(element) {
                var fragment = fragments[columnIndex];
                fragment.insertBefore(element, fragment.firstChild);
                if (columnIndex === 0) {
                    columnIndex = numberOfColumns - 1;
                } else {
                    columnIndex--;
                }
            });

            Array.prototype.forEach.call(columns, function insert_column(column, index) {
                column.insertBefore(fragments[index], column.firstChild);
            });

            // populates a fragment with n columns till the right
            var fragment = document.createDocumentFragment()
              , numberOfColumnsToExtract = elements.length % numberOfColumns
            ;

            while (numberOfColumnsToExtract-- !== 0) {
                fragment.appendChild(grid.lastChild);
            }

            // adds the fragment to the left
            grid.insertBefore(fragment, grid.firstChild);
        };


        self.registerGrid = function registerGrid(grid) {
            if (global.getComputedStyle(grid).display === "none") {
                return;
            }

            // retrieve the list of items from the grid itself
            var range = document.createRange();
            range.selectNodeContents(grid);

            var items = document.createElement("div");
            items.appendChild(range.extractContents());


            add_to_dataset(items, 'columns', 0);
            self.addColumns(grid, items);
            grids.push(grid);
        };


        self.init = function init() {
            // adds required CSS rule to hide 'content' based
            // configuration.

            var css = document.createElement("style");
            css.innerHTML = "[data-columns]::before{display:block;visibility:hidden;position:absolute;font-size:1px;}";
            document.head.appendChild(css);

            // scans all the grids in the document and generates
            // columns from their configuration.

            var gridElements = document.querySelectorAll("[data-columns]");
            Array.prototype.forEach.call(gridElements, self.registerGrid);
            self.scanMediaQueries();
        };

        self.init();

        return {
            appendElements: self.appendElements,
            prependElements: self.prependElements,
            registerGrid: self.registerGrid,
            recreateColumns: self.recreateColumns,
            rescanMediaQueries: self.rescanMediaQueries,
            init: self.init,

            // maintains backwards compatibility with underscore style method names
            append_elements: self.appendElements,
            prepend_elements: self.prependElements,
            register_grid: self.registerGrid,
            recreate_columns: self.recreateColumns,
            rescan_media_queries: self.rescanMediaQueries
        };

    })(window, window.document);

    return salvattore;
}));
/*
* # Semantic UI - 1.12.1
* https://github.com/Semantic-Org/Semantic-UI
* http://www.semantic-ui.com/
*
* Copyright 2014 Contributors
* Released under the MIT license
* http://opensource.org/licenses/MIT
*
*/
/*!
 * # Semantic UI 1.12.1 - Site
 * http://github.com/semantic-org/semantic-ui/
 *
 *
 * Copyright 2014 Contributors
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 *
 */
; (function ($, window, document, undefined) {

    $.site = $.fn.site = function (parameters) {
        var
          time = new Date().getTime(),
          performance = [],

          query = arguments[0],
          methodInvoked = (typeof query == 'string'),
          queryArguments = [].slice.call(arguments, 1),

          settings = ($.isPlainObject(parameters))
            ? $.extend(true, {}, $.site.settings, parameters)
            : $.extend({}, $.site.settings),

          namespace = settings.namespace,
          error = settings.error,

          eventNamespace = '.' + namespace,
          moduleNamespace = 'module-' + namespace,

          $document = $(document),
          $module = $document,
          element = this,
          instance = $module.data(moduleNamespace),

          module,
          returnedValue
        ;
        module = {

            initialize: function () {
                module.instantiate();
            },

            instantiate: function () {
                module.verbose('Storing instance of site', module);
                instance = module;
                $module
                  .data(moduleNamespace, module)
                ;
            },

            normalize: function () {
                module.fix.console();
                module.fix.requestAnimationFrame();
            },

            fix: {
                console: function () {
                    module.debug('Normalizing window.console');
                    if (console === undefined || console.log === undefined) {
                        module.verbose('Console not available, normalizing events');
                        module.disable.console();
                    }
                    if (typeof console.group == 'undefined' || typeof console.groupEnd == 'undefined' || typeof console.groupCollapsed == 'undefined') {
                        module.verbose('Console group not available, normalizing events');
                        window.console.group = function () { };
                        window.console.groupEnd = function () { };
                        window.console.groupCollapsed = function () { };
                    }
                    if (typeof console.markTimeline == 'undefined') {
                        module.verbose('Mark timeline not available, normalizing events');
                        window.console.markTimeline = function () { };
                    }
                },
                consoleClear: function () {
                    module.debug('Disabling programmatic console clearing');
                    window.console.clear = function () { };
                },
                requestAnimationFrame: function () {
                    module.debug('Normalizing requestAnimationFrame');
                    if (window.requestAnimationFrame === undefined) {
                        module.debug('RequestAnimationFrame not available, normailizing event');
                        window.requestAnimationFrame = window.requestAnimationFrame
                          || window.mozRequestAnimationFrame
                          || window.webkitRequestAnimationFrame
                          || window.msRequestAnimationFrame
                          || function (callback) { setTimeout(callback, 0); }
                        ;
                    }
                }
            },

            moduleExists: function (name) {
                return ($.fn[name] !== undefined && $.fn[name].settings !== undefined);
            },

            enabled: {
                modules: function (modules) {
                    var
                      enabledModules = []
                    ;
                    modules = modules || settings.modules;
                    $.each(modules, function (index, name) {
                        if (module.moduleExists(name)) {
                            enabledModules.push(name);
                        }
                    });
                    return enabledModules;
                }
            },

            disabled: {
                modules: function (modules) {
                    var
                      disabledModules = []
                    ;
                    modules = modules || settings.modules;
                    $.each(modules, function (index, name) {
                        if (!module.moduleExists(name)) {
                            disabledModules.push(name);
                        }
                    });
                    return disabledModules;
                }
            },

            change: {
                setting: function (setting, value, modules, modifyExisting) {
                    modules = (typeof modules === 'string')
                      ? (modules === 'all')
                        ? settings.modules
                        : [modules]
                      : modules || settings.modules
                    ;
                    modifyExisting = (modifyExisting !== undefined)
                      ? modifyExisting
                      : true
                    ;
                    $.each(modules, function (index, name) {
                        var
                          namespace = (module.moduleExists(name))
                            ? $.fn[name].settings.namespace || false
                            : true,
                          $existingModules
                        ;
                        if (module.moduleExists(name)) {
                            module.verbose('Changing default setting', setting, value, name);
                            $.fn[name].settings[setting] = value;
                            if (modifyExisting && namespace) {
                                $existingModules = $(':data(module-' + namespace + ')');
                                if ($existingModules.length > 0) {
                                    module.verbose('Modifying existing settings', $existingModules);
                                    $existingModules[name]('setting', setting, value);
                                }
                            }
                        }
                    });
                },
                settings: function (newSettings, modules, modifyExisting) {
                    modules = (typeof modules === 'string')
                      ? [modules]
                      : modules || settings.modules
                    ;
                    modifyExisting = (modifyExisting !== undefined)
                      ? modifyExisting
                      : true
                    ;
                    $.each(modules, function (index, name) {
                        var
                          $existingModules
                        ;
                        if (module.moduleExists(name)) {
                            module.verbose('Changing default setting', newSettings, name);
                            $.extend(true, $.fn[name].settings, newSettings);
                            if (modifyExisting && namespace) {
                                $existingModules = $(':data(module-' + namespace + ')');
                                if ($existingModules.length > 0) {
                                    module.verbose('Modifying existing settings', $existingModules);
                                    $existingModules[name]('setting', newSettings);
                                }
                            }
                        }
                    });
                }
            },

            enable: {
                console: function () {
                    module.console(true);
                },
                debug: function (modules, modifyExisting) {
                    modules = modules || settings.modules;
                    module.debug('Enabling debug for modules', modules);
                    module.change.setting('debug', true, modules, modifyExisting);
                },
                verbose: function (modules, modifyExisting) {
                    modules = modules || settings.modules;
                    module.debug('Enabling verbose debug for modules', modules);
                    module.change.setting('verbose', true, modules, modifyExisting);
                }
            },
            disable: {
                console: function () {
                    module.console(false);
                },
                debug: function (modules, modifyExisting) {
                    modules = modules || settings.modules;
                    module.debug('Disabling debug for modules', modules);
                    module.change.setting('debug', false, modules, modifyExisting);
                },
                verbose: function (modules, modifyExisting) {
                    modules = modules || settings.modules;
                    module.debug('Disabling verbose debug for modules', modules);
                    module.change.setting('verbose', false, modules, modifyExisting);
                }
            },

            console: function (enable) {
                if (enable) {
                    if (instance.cache.console === undefined) {
                        module.error(error.console);
                        return;
                    }
                    module.debug('Restoring console function');
                    window.console = instance.cache.console;
                }
                else {
                    module.debug('Disabling console function');
                    instance.cache.console = window.console;
                    window.console = {
                        clear: function () { },
                        error: function () { },
                        group: function () { },
                        groupCollapsed: function () { },
                        groupEnd: function () { },
                        info: function () { },
                        log: function () { },
                        markTimeline: function () { },
                        warn: function () { }
                    };
                }
            },

            destroy: function () {
                module.verbose('Destroying previous site for', $module);
                $module
                  .removeData(moduleNamespace)
                ;
            },

            cache: {},

            setting: function (name, value) {
                if ($.isPlainObject(name)) {
                    $.extend(true, settings, name);
                }
                else if (value !== undefined) {
                    settings[name] = value;
                }
                else {
                    return settings[name];
                }
            },
            internal: function (name, value) {
                if ($.isPlainObject(name)) {
                    $.extend(true, module, name);
                }
                else if (value !== undefined) {
                    module[name] = value;
                }
                else {
                    return module[name];
                }
            },
            debug: function () {
                if (settings.debug) {
                    if (settings.performance) {
                        module.performance.log(arguments);
                    }
                    else {
                        module.debug = Function.prototype.bind.call(console.info, console, settings.name + ':');
                        module.debug.apply(console, arguments);
                    }
                }
            },
            verbose: function () {
                if (settings.verbose && settings.debug) {
                    if (settings.performance) {
                        module.performance.log(arguments);
                    }
                    else {
                        module.verbose = Function.prototype.bind.call(console.info, console, settings.name + ':');
                        module.verbose.apply(console, arguments);
                    }
                }
            },
            error: function () {
                module.error = Function.prototype.bind.call(console.error, console, settings.name + ':');
                module.error.apply(console, arguments);
            },
            performance: {
                log: function (message) {
                    var
                      currentTime,
                      executionTime,
                      previousTime
                    ;
                    if (settings.performance) {
                        currentTime = new Date().getTime();
                        previousTime = time || currentTime;
                        executionTime = currentTime - previousTime;
                        time = currentTime;
                        performance.push({
                            'Element': element,
                            'Name': message[0],
                            'Arguments': [].slice.call(message, 1) || '',
                            'Execution Time': executionTime
                        });
                    }
                    clearTimeout(module.performance.timer);
                    module.performance.timer = setTimeout(module.performance.display, 100);
                },
                display: function () {
                    var
                      title = settings.name + ':',
                      totalTime = 0
                    ;
                    time = false;
                    clearTimeout(module.performance.timer);
                    $.each(performance, function (index, data) {
                        totalTime += data['Execution Time'];
                    });
                    title += ' ' + totalTime + 'ms';
                    if ((console.group !== undefined || console.table !== undefined) && performance.length > 0) {
                        console.groupCollapsed(title);
                        if (console.table) {
                            console.table(performance);
                        }
                        else {
                            $.each(performance, function (index, data) {
                                console.log(data['Name'] + ': ' + data['Execution Time'] + 'ms');
                            });
                        }
                        console.groupEnd();
                    }
                    performance = [];
                }
            },
            invoke: function (query, passedArguments, context) {
                var
                  object = instance,
                  maxDepth,
                  found,
                  response
                ;
                passedArguments = passedArguments || queryArguments;
                context = element || context;
                if (typeof query == 'string' && object !== undefined) {
                    query = query.split(/[\. ]/);
                    maxDepth = query.length - 1;
                    $.each(query, function (depth, value) {
                        var camelCaseValue = (depth != maxDepth)
                          ? value + query[depth + 1].charAt(0).toUpperCase() + query[depth + 1].slice(1)
                          : query
                        ;
                        if ($.isPlainObject(object[camelCaseValue]) && (depth != maxDepth)) {
                            object = object[camelCaseValue];
                        }
                        else if (object[camelCaseValue] !== undefined) {
                            found = object[camelCaseValue];
                            return false;
                        }
                        else if ($.isPlainObject(object[value]) && (depth != maxDepth)) {
                            object = object[value];
                        }
                        else if (object[value] !== undefined) {
                            found = object[value];
                            return false;
                        }
                        else {
                            module.error(error.method, query);
                            return false;
                        }
                    });
                }
                if ($.isFunction(found)) {
                    response = found.apply(context, passedArguments);
                }
                else if (found !== undefined) {
                    response = found;
                }
                if ($.isArray(returnedValue)) {
                    returnedValue.push(response);
                }
                else if (returnedValue !== undefined) {
                    returnedValue = [returnedValue, response];
                }
                else if (response !== undefined) {
                    returnedValue = response;
                }
                return found;
            }
        };

        if (methodInvoked) {
            if (instance === undefined) {
                module.initialize();
            }
            module.invoke(query);
        }
        else {
            if (instance !== undefined) {
                module.destroy();
            }
            module.initialize();
        }
        return (returnedValue !== undefined)
          ? returnedValue
          : this
        ;
    };

    $.site.settings = {

        name: 'Site',
        namespace: 'site',

        error: {
            console: 'Console cannot be restored, most likely it was overwritten outside of module',
            method: 'The method you called is not defined.'
        },

        debug: false,
        verbose: true,
        performance: true,

        modules: [
          'accordion',
          'api',
          'checkbox',
          'dimmer',
          'dropdown',
          'form',
          'modal',
          'nag',
          'popup',
          'rating',
          'shape',
          'sidebar',
          'state',
          'sticky',
          'tab',
          'transition',
          'video',
          'visit',
          'visibility'
        ],

        siteNamespace: 'site',
        namespaceStub: {
            cache: {},
            config: {},
            sections: {},
            section: {},
            utilities: {}
        }

    };

    // allows for selection of elements with data attributes
    $.extend($.expr[":"], {
        data: ($.expr.createPseudo)
          ? $.expr.createPseudo(function (dataName) {
              return function (elem) {
                  return !!$.data(elem, dataName);
              };
          })
          : function (elem, i, match) {
              // support: jQuery < 1.8
              return !!$.data(elem, match[3]);
          }
    });


})(jQuery, window, document);
/*!
 * # Semantic UI 1.12.1 - Form Validation
 * http://github.com/semantic-org/semantic-ui/
 *
 *
 * Copyright 2014 Contributors
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 *
 */

; (function ($, window, document, undefined) {

    "use strict";

    $.fn.form = function (fields, parameters) {
        var
          $allModules = $(this),

          settings = $.extend(true, {}, $.fn.form.settings, parameters),
          validation = $.extend({}, $.fn.form.settings.defaults, fields),

          namespace = settings.namespace,
          metadata = settings.metadata,
          selector = settings.selector,
          className = settings.className,
          error = settings.error,

          eventNamespace = '.' + namespace,
          moduleNamespace = 'module-' + namespace,

          moduleSelector = $allModules.selector || '',

          time = new Date().getTime(),
          performance = [],

          query = arguments[0],
          methodInvoked = (typeof query == 'string'),
          queryArguments = [].slice.call(arguments, 1),
          returnedValue
        ;
        $allModules
          .each(function () {
              var
                $module = $(this),
                $field = $(this).find(selector.field),
                $group = $(this).find(selector.group),
                $message = $(this).find(selector.message),
                $prompt = $(this).find(selector.prompt),

                $submit = $(this).find(selector.submit),
                $clear = $(this).find(selector.clear),
                $reset = $(this).find(selector.reset),

                formErrors = [],
                keyHeldDown = false,

                element = this,
                instance = $module.data(moduleNamespace),
                module
              ;

              module = {

                  initialize: function () {
                      module.verbose('Initializing form validation', $module, validation, settings);
                      module.bindEvents();
                      module.set.defaults();
                      module.instantiate();
                  },

                  instantiate: function () {
                      module.verbose('Storing instance of module', module);
                      instance = module;
                      $module
                        .data(moduleNamespace, module)
                      ;
                  },

                  destroy: function () {
                      module.verbose('Destroying previous module', instance);
                      module.removeEvents();
                      $module
                        .removeData(moduleNamespace)
                      ;
                  },

                  refresh: function () {
                      module.verbose('Refreshing selector cache');
                      $field = $module.find(selector.field);
                  },

                  submit: function () {
                      module.verbose('Submitting form', $module);
                      $module
                        .submit()
                      ;
                  },

                  attachEvents: function (selector, action) {
                      action = action || 'submit';
                      $(selector)
                        .on('click', function (event) {
                            module[action]();
                            event.preventDefault();
                        })
                      ;
                  },

                  bindEvents: function () {
                      if (settings.keyboardShortcuts) {
                          $field
                            .on('keydown' + eventNamespace, module.event.field.keydown)
                          ;
                      }
                      $module
                        .on('submit' + eventNamespace, module.validate.form)
                      ;
                      $field
                        .on('blur' + eventNamespace, module.event.field.blur)
                      ;

                      // attach events to common elements
                      module.attachEvents($submit, 'submit');
                      module.attachEvents($reset, 'reset');
                      module.attachEvents($clear, 'clear');

                      $field
                        .each(function () {
                            var
                              type = $(this).prop('type'),
                              inputEvent = module.get.changeEvent(type)
                            ;
                            $(this)
                              .on(inputEvent + eventNamespace, module.event.field.change)
                            ;
                        })
                      ;
                  },

                  clear: function () {
                      $field
                        .each(function () {
                            var
                              $field = $(this),
                              $element = $field.parent(),
                              $fieldGroup = $field.closest($group),
                              $prompt = $fieldGroup.find(selector.prompt),
                              defaultValue = $field.data(metadata.defaultValue) || '',
                              isCheckbox = $element.is(selector.uiCheckbox),
                              isDropdown = $element.is(selector.uiDropdown),
                              isErrored = $fieldGroup.hasClass(className.error)
                            ;
                            if (isErrored) {
                                module.verbose('Resetting error on field', $fieldGroup);
                                $fieldGroup.removeClass(className.error);
                                $prompt.remove();
                            }
                            if (isDropdown) {
                                module.verbose('Resetting dropdown value', $element, defaultValue);
                                $element.dropdown('clear');
                            }
                            else if (isCheckbox) {
                                $element.checkbox('uncheck');
                            }
                            else {
                                module.verbose('Resetting field value', $field, defaultValue);
                                $field.val('');
                            }
                        })
                      ;
                  },

                  reset: function () {
                      $field
                        .each(function () {
                            var
                              $field = $(this),
                              $element = $field.parent(),
                              $fieldGroup = $field.closest($group),
                              $prompt = $fieldGroup.find(selector.prompt),
                              defaultValue = $field.data(metadata.defaultValue) || '',
                              isCheckbox = $element.is(selector.uiCheckbox),
                              isDropdown = $element.is(selector.uiDropdown),
                              isErrored = $fieldGroup.hasClass(className.error)
                            ;
                            if (isErrored) {
                                module.verbose('Resetting error on field', $fieldGroup);
                                $fieldGroup.removeClass(className.error);
                                $prompt.remove();
                            }
                            if (isDropdown) {
                                module.verbose('Resetting dropdown value', $element, defaultValue);
                                $element.dropdown('restore defaults');
                            }
                            else if (isCheckbox) {
                                module.verbose('Resetting checkbox value', $element, defaultValue);
                                if (defaultValue === true) {
                                    $element.checkbox('check');
                                }
                                else {
                                    $element.checkbox('uncheck');
                                }
                            }
                            else {
                                module.verbose('Resetting field value', $field, defaultValue);
                                $field.val(defaultValue);
                            }
                        })
                      ;
                  },

                  removeEvents: function () {
                      $module
                        .off(eventNamespace)
                      ;
                      $field
                        .off(eventNamespace)
                      ;
                      $submit
                        .off(eventNamespace)
                      ;
                      $field
                        .off(eventNamespace)
                      ;
                  },

                  event: {
                      field: {
                          keydown: function (event) {
                              var
                                $field = $(this),
                                key = event.which,
                                keyCode = {
                                    enter: 13,
                                    escape: 27
                                }
                              ;
                              if (key == keyCode.escape) {
                                  module.verbose('Escape key pressed blurring field');
                                  $field
                                    .blur()
                                  ;
                              }
                              if (!event.ctrlKey && key == keyCode.enter && $field.is(selector.input) && $field.not(selector.checkbox).length > 0) {
                                  $submit
                                    .addClass(className.pressed)
                                  ;
                                  if (!keyHeldDown) {
                                      $field
                                        .one('keyup' + eventNamespace, module.event.field.keyup)
                                      ;
                                      module.submit();
                                      module.debug('Enter pressed on input submitting form');
                                  }
                                  keyHeldDown = true;
                              }
                          },
                          keyup: function () {
                              keyHeldDown = false;
                              $submit.removeClass(className.pressed);
                          },
                          blur: function () {
                              var
                                $field = $(this),
                                $fieldGroup = $field.closest($group)
                              ;
                              if ($fieldGroup.hasClass(className.error)) {
                                  module.debug('Revalidating field', $field, module.get.validation($field));
                                  module.validate.field(module.get.validation($field));
                              }
                              else if (settings.on == 'blur' || settings.on == 'change') {
                                  module.validate.field(module.get.validation($field));
                              }
                          },
                          change: function () {
                              var
                                $field = $(this),
                                $fieldGroup = $field.closest($group)
                              ;
                              if (settings.on == 'change' || ($fieldGroup.hasClass(className.error) && settings.revalidate)) {
                                  clearTimeout(module.timer);
                                  module.timer = setTimeout(function () {
                                      module.debug('Revalidating field', $field, module.get.validation($field));
                                      module.validate.field(module.get.validation($field));
                                  }, settings.delay);
                              }
                          }
                      }

                  },

                  get: {
                      changeEvent: function (type) {
                          if (type == 'checkbox' || type == 'radio' || type == 'hidden') {
                              return 'change';
                          }
                          else {
                              return module.get.inputEvent();
                          }
                      },
                      inputEvent: function () {
                          return (document.createElement('input').oninput !== undefined)
                            ? 'input'
                            : (document.createElement('input').onpropertychange !== undefined)
                              ? 'propertychange'
                              : 'keyup'
                          ;
                      },
                      field: function (identifier) {
                          module.verbose('Finding field with identifier', identifier);
                          if ($field.filter('#' + identifier).length > 0) {
                              return $field.filter('#' + identifier);
                          }
                          else if ($field.filter('[name="' + identifier + '"]').length > 0) {
                              return $field.filter('[name="' + identifier + '"]');
                          }
                          else if ($field.filter('[name="' + identifier + '[]"]').length > 0) {
                              return $field.filter('[name="' + identifier + '[]"]');
                          }
                          else if ($field.filter('[data-' + metadata.validate + '="' + identifier + '"]').length > 0) {
                              return $field.filter('[data-' + metadata.validate + '="' + identifier + '"]');
                          }
                          return $('<input/>');
                      },
                      fields: function (fields) {
                          var
                            $fields = $()
                          ;
                          $.each(fields, function (index, name) {
                              $fields = $fields.add(module.get.field(name));
                          });
                          return $fields;
                      },
                      validation: function ($field) {
                          var
                            rules
                          ;
                          $.each(validation, function (fieldName, field) {
                              if (module.get.field(field.identifier).get(0) == $field.get(0)) {
                                  rules = field;
                              }
                          });
                          return rules || false;
                      },
                      value: function (field) {
                          var
                            fields = [],
                            results
                          ;
                          fields.push(field);
                          results = module.get.values.call(element, fields);
                          return results[field];
                      },
                      values: function (fields) {
                          var
                            $fields = $.isArray(fields)
                              ? module.get.fields(fields)
                              : $field,
                            values = {}
                          ;
                          $fields.each(function (index, field) {
                              var
                                $field = $(field),
                                type = $field.prop('type'),
                                name = $field.prop('name'),
                                value = $field.val(),
                                isCheckbox = $field.is(selector.checkbox),
                                isRadio = $field.is(selector.radio),
                                isMultiple = (name.indexOf('[]') !== -1),
                                isChecked = (isCheckbox)
                                  ? $field.is(':checked')
                                  : false
                              ;
                              if (name) {
                                  if (isMultiple) {
                                      name = name.replace('[]', '');
                                      if (!values[name]) {
                                          values[name] = [];
                                      }
                                      if (isCheckbox) {
                                          if (isChecked) {
                                              values[name].push(value)
                                          }
                                          else {
                                              module.debug('Omitted unchecked checkbox', $field);
                                              return true;
                                          }
                                      }
                                      else {
                                          values[name].push(value);
                                      }
                                  }
                                  else {
                                      if (isRadio) {
                                          if (isChecked) {
                                              values[name] = value;
                                          }
                                      }
                                      else if (isCheckbox) {
                                          if (isChecked) {
                                              values[name] = true;
                                          }
                                          else {
                                              module.debug('Omitted unchecked checkbox', $field);
                                              return true;
                                          }
                                      }
                                      else {
                                          values[name] = value;
                                      }
                                  }
                              }
                          });
                          return values;
                      }
                  },

                  has: {

                      field: function (identifier) {
                          module.verbose('Checking for existence of a field with identifier', identifier);
                          if ($field.filter('#' + identifier).length > 0) {
                              return true;
                          }
                          else if ($field.filter('[name="' + identifier + '"]').length > 0) {
                              return true;
                          }
                          else if ($field.filter('[data-' + metadata.validate + '="' + identifier + '"]').length > 0) {
                              return true;
                          }
                          return false;
                      }

                  },

                  add: {
                      prompt: function (identifier, errors) {
                          var
                            $field = module.get.field(identifier),
                            $fieldGroup = $field.closest($group),
                            $prompt = $fieldGroup.children(selector.prompt),
                            promptExists = ($prompt.length !== 0)
                          ;
                          errors = (typeof errors == 'string')
                            ? [errors]
                            : errors
                          ;
                          module.verbose('Adding field error state', identifier);
                          $fieldGroup
                            .addClass(className.error)
                          ;
                          if (settings.inline) {
                              if (!promptExists) {
                                  $prompt = settings.templates.prompt(errors);
                                  $prompt
                                    .appendTo($fieldGroup)
                                  ;
                              }
                              $prompt
                                .html(errors[0])
                              ;
                              if (!promptExists) {
                                  if (settings.transition && $.fn.transition !== undefined && $module.transition('is supported')) {
                                      module.verbose('Displaying error with css transition', settings.transition);
                                      $prompt.transition(settings.transition + ' in', settings.duration);
                                  }
                                  else {
                                      module.verbose('Displaying error with fallback javascript animation');
                                      $prompt
                                        .fadeIn(settings.duration)
                                      ;
                                  }
                              }
                              else {
                                  module.verbose('Inline errors are disabled, no inline error added', identifier);
                              }
                          }
                      },
                      errors: function (errors) {
                          module.debug('Adding form error messages', errors);
                          $message
                            .html(settings.templates.error(errors))
                          ;
                      }
                  },

                  remove: {
                      prompt: function (field) {
                          var
                            $field = module.get.field(field.identifier),
                            $fieldGroup = $field.closest($group),
                            $prompt = $fieldGroup.children(selector.prompt)
                          ;
                          $fieldGroup
                            .removeClass(className.error)
                          ;
                          if (settings.inline && $prompt.is(':visible')) {
                              module.verbose('Removing prompt for field', field);
                              if (settings.transition && $.fn.transition !== undefined && $module.transition('is supported')) {
                                  $prompt.transition(settings.transition + ' out', settings.duration, function () {
                                      $prompt.remove();
                                  });
                              }
                              else {
                                  $prompt
                                    .fadeOut(settings.duration, function () {
                                        $prompt.remove();
                                    })
                                  ;
                              }
                          }
                      }
                  },

                  set: {
                      success: function () {
                          $module
                            .removeClass(className.error)
                            .addClass(className.success)
                          ;
                      },
                      defaults: function () {
                          $field
                            .each(function () {
                                var
                                  $field = $(this),
                                  isCheckbox = ($field.filter(selector.checkbox).length > 0),
                                  value = (isCheckbox)
                                    ? $field.is(':checked')
                                    : $field.val()
                                ;
                                $field.data(metadata.defaultValue, value);
                            })
                          ;
                      },
                      error: function () {
                          $module
                            .removeClass(className.success)
                            .addClass(className.error)
                          ;
                      },
                      value: function (field, value) {
                          var
                            fields = {}
                          ;
                          fields[field] = value;
                          return module.set.values.call(element, fields);
                      },
                      values: function (fields) {
                          if ($.isEmptyObject(fields)) {
                              return;
                          }
                          $.each(fields, function (key, value) {
                              var
                                $field = module.get.field(key),
                                $element = $field.parent(),
                                isMultiple = $.isArray(value),
                                isCheckbox = $element.is(selector.uiCheckbox),
                                isDropdown = $element.is(selector.uiDropdown),
                                isRadio = ($field.is(selector.radio) && isCheckbox),
                                fieldExists = ($field.length > 0),
                                $multipleField
                              ;
                              if (fieldExists) {
                                  if (isMultiple && isCheckbox) {
                                      module.verbose('Selecting multiple', value, $field);
                                      $element.checkbox('uncheck');
                                      $.each(value, function (index, value) {
                                          $multipleField = $field.filter('[value="' + value + '"]');
                                          $element = $multipleField.parent();
                                          if ($multipleField.length > 0) {
                                              $element.checkbox('check');
                                          }
                                      });
                                  }
                                  else if (isRadio) {
                                      module.verbose('Selecting radio value', value, $field);
                                      $field.filter('[value="' + value + '"]')
                                        .parent(selector.uiCheckbox)
                                          .checkbox('check')
                                      ;
                                  }
                                  else if (isCheckbox) {
                                      module.verbose('Setting checkbox value', value, $element);
                                      if (value === true) {
                                          $element.checkbox('check');
                                      }
                                      else {
                                          $element.checkbox('uncheck');
                                      }
                                  }
                                  else if (isDropdown) {
                                      module.verbose('Setting dropdown value', value, $element);
                                      $element.dropdown('set selected', value);
                                  }
                                  else {
                                      module.verbose('Setting field value', value, $field);
                                      $field.val(value);
                                  }
                              }
                          });
                          module.validate.form();
                      }
                  },

                  validate: {

                      form: function (event) {
                          var
                            allValid = true,
                            apiRequest
                          ;

                          // input keydown event will fire submit repeatedly by browser default
                          if (keyHeldDown) {
                              return false;
                          }

                          // reset errors
                          formErrors = [];
                          $.each(validation, function (fieldName, field) {
                              if (!(module.validate.field(field))) {
                                  allValid = false;
                              }
                          });
                          if (allValid) {
                              module.debug('Form has no validation errors, submitting');
                              module.set.success();
                              return settings.onSuccess.call(element, event);
                          }
                          else {
                              module.debug('Form has errors');
                              module.set.error();
                              if (!settings.inline) {
                                  module.add.errors(formErrors);
                              }
                              // prevent ajax submit
                              if ($module.data('moduleApi') !== undefined) {
                                  event.stopImmediatePropagation();
                              }
                              return settings.onFailure.call(element, formErrors);
                          }
                      },

                      // takes a validation object and returns whether field passes validation
                      field: function (field) {
                          var
                            $field = module.get.field(field.identifier),
                            fieldValid = true,
                            fieldErrors = []
                          ;
                          if ($field.prop('disabled')) {
                              module.debug('Field is disabled. Skipping', field.identifier);
                              fieldValid = true;
                          }
                          else if (field.optional && $.trim($field.val()) === '') {
                              module.debug('Field is optional and empty. Skipping', field.identifier);
                              fieldValid = true;
                          }
                          else if (field.rules !== undefined) {
                              $.each(field.rules, function (index, rule) {
                                  if (module.has.field(field.identifier) && !(module.validate.rule(field, rule))) {
                                      module.debug('Field is invalid', field.identifier, rule.type);
                                      fieldErrors.push(rule.prompt);
                                      fieldValid = false;
                                  }
                              });
                          }
                          if (fieldValid) {
                              module.remove.prompt(field, fieldErrors);
                              settings.onValid.call($field);
                          }
                          else {
                              formErrors = formErrors.concat(fieldErrors);
                              module.add.prompt(field.identifier, fieldErrors);
                              settings.onInvalid.call($field, fieldErrors);
                              return false;
                          }
                          return true;
                      },

                      // takes validation rule and returns whether field passes rule
                      rule: function (field, validation) {
                          var
                            $field = module.get.field(field.identifier),
                            type = validation.type,
                            value = $.trim($field.val() + ''),

                            bracketRegExp = /\[(.*)\]/i,
                            bracket = bracketRegExp.exec(type),
                            isValid = true,
                            ancillary,
                            functionType
                          ;
                          // if bracket notation is used, pass in extra parameters
                          if (bracket !== undefined && bracket !== null) {
                              ancillary = '' + bracket[1];
                              functionType = type.replace(bracket[0], '');
                              isValid = settings.rules[functionType].call(element, value, ancillary);
                          }
                              // normal notation
                          else {
                              isValid = settings.rules[type].call($field, value);
                          }
                          return isValid;
                      }
                  },

                  setting: function (name, value) {
                      if ($.isPlainObject(name)) {
                          $.extend(true, settings, name);
                      }
                      else if (value !== undefined) {
                          settings[name] = value;
                      }
                      else {
                          return settings[name];
                      }
                  },
                  internal: function (name, value) {
                      if ($.isPlainObject(name)) {
                          $.extend(true, module, name);
                      }
                      else if (value !== undefined) {
                          module[name] = value;
                      }
                      else {
                          return module[name];
                      }
                  },
                  debug: function () {
                      if (settings.debug) {
                          if (settings.performance) {
                              module.performance.log(arguments);
                          }
                          else {
                              module.debug = Function.prototype.bind.call(console.info, console, settings.name + ':');
                              module.debug.apply(console, arguments);
                          }
                      }
                  },
                  verbose: function () {
                      if (settings.verbose && settings.debug) {
                          if (settings.performance) {
                              module.performance.log(arguments);
                          }
                          else {
                              module.verbose = Function.prototype.bind.call(console.info, console, settings.name + ':');
                              module.verbose.apply(console, arguments);
                          }
                      }
                  },
                  error: function () {
                      module.error = Function.prototype.bind.call(console.error, console, settings.name + ':');
                      module.error.apply(console, arguments);
                  },
                  performance: {
                      log: function (message) {
                          var
                            currentTime,
                            executionTime,
                            previousTime
                          ;
                          if (settings.performance) {
                              currentTime = new Date().getTime();
                              previousTime = time || currentTime;
                              executionTime = currentTime - previousTime;
                              time = currentTime;
                              performance.push({
                                  'Name': message[0],
                                  'Arguments': [].slice.call(message, 1) || '',
                                  'Element': element,
                                  'Execution Time': executionTime
                              });
                          }
                          clearTimeout(module.performance.timer);
                          module.performance.timer = setTimeout(module.performance.display, 100);
                      },
                      display: function () {
                          var
                            title = settings.name + ':',
                            totalTime = 0
                          ;
                          time = false;
                          clearTimeout(module.performance.timer);
                          $.each(performance, function (index, data) {
                              totalTime += data['Execution Time'];
                          });
                          title += ' ' + totalTime + 'ms';
                          if (moduleSelector) {
                              title += ' \'' + moduleSelector + '\'';
                          }
                          if ($allModules.length > 1) {
                              title += ' ' + '(' + $allModules.length + ')';
                          }
                          if ((console.group !== undefined || console.table !== undefined) && performance.length > 0) {
                              console.groupCollapsed(title);
                              if (console.table) {
                                  console.table(performance);
                              }
                              else {
                                  $.each(performance, function (index, data) {
                                      console.log(data['Name'] + ': ' + data['Execution Time'] + 'ms');
                                  });
                              }
                              console.groupEnd();
                          }
                          performance = [];
                      }
                  },
                  invoke: function (query, passedArguments, context) {
                      var
                        object = instance,
                        maxDepth,
                        found,
                        response
                      ;
                      passedArguments = passedArguments || queryArguments;
                      context = element || context;
                      if (typeof query == 'string' && object !== undefined) {
                          query = query.split(/[\. ]/);
                          maxDepth = query.length - 1;
                          $.each(query, function (depth, value) {
                              var camelCaseValue = (depth != maxDepth)
                                ? value + query[depth + 1].charAt(0).toUpperCase() + query[depth + 1].slice(1)
                                : query
                              ;
                              if ($.isPlainObject(object[camelCaseValue]) && (depth != maxDepth)) {
                                  object = object[camelCaseValue];
                              }
                              else if (object[camelCaseValue] !== undefined) {
                                  found = object[camelCaseValue];
                                  return false;
                              }
                              else if ($.isPlainObject(object[value]) && (depth != maxDepth)) {
                                  object = object[value];
                              }
                              else if (object[value] !== undefined) {
                                  found = object[value];
                                  return false;
                              }
                              else {
                                  return false;
                              }
                          });
                      }
                      if ($.isFunction(found)) {
                          response = found.apply(context, passedArguments);
                      }
                      else if (found !== undefined) {
                          response = found;
                      }
                      if ($.isArray(returnedValue)) {
                          returnedValue.push(response);
                      }
                      else if (returnedValue !== undefined) {
                          returnedValue = [returnedValue, response];
                      }
                      else if (response !== undefined) {
                          returnedValue = response;
                      }
                      return found;
                  }
              };
              if (methodInvoked) {
                  if (instance === undefined) {
                      module.initialize();
                  }
                  module.invoke(query);
              }
              else {
                  if (instance !== undefined) {
                      instance.invoke('destroy');
                  }
                  module.initialize();
              }

          })
        ;

        return (returnedValue !== undefined)
          ? returnedValue
          : this
        ;
    };

    $.fn.form.settings = {

        name: 'Form',
        namespace: 'form',

        debug: false,
        verbose: true,
        performance: true,


        keyboardShortcuts: true,
        on: 'submit',
        inline: false,

        delay: 200,
        revalidate: true,

        transition: 'scale',
        duration: 200,

        onValid: function () { },
        onInvalid: function () { },
        onSuccess: function () { return true; },
        onFailure: function () { return false; },

        metadata: {
            defaultValue: 'default',
            validate: 'validate'
        },

        selector: {
            checkbox: 'input[type="checkbox"], input[type="radio"]',
            clear: '.clear',
            field: 'input, textarea, select',
            group: '.field',
            input: 'input',
            message: '.error.message',
            prompt: '.prompt.label',
            radio: 'input[type="radio"]',
            reset: '.reset',
            submit: '.submit',
            uiCheckbox: '.ui.checkbox',
            uiDropdown: '.ui.dropdown'
        },

        className: {
            error: 'error',
            label: 'ui prompt label',
            pressed: 'down',
            success: 'success'
        },

        error: {
            method: 'The method you called is not defined.'
        },

        templates: {

            // template that produces error message
            error: function (errors) {
                var
                  html = '<ul class="list">'
                ;
                $.each(errors, function (index, value) {
                    html += '<li>' + value + '</li>';
                });
                html += '</ul>';
                return $(html);
            },

            // template that produces label
            prompt: function (errors) {
                return $('<div/>')
                  .addClass('ui red pointing prompt label')
                  .html(errors[0])
                ;
            }
        },

        rules: {

            // checkbox checked
            checked: function () {
                return ($(this).filter(':checked').length > 0);
            },

            // value contains text (insensitive)
            contains: function (value, text) {
                // escape regex characters
                text = text.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
                return (value.search(new RegExp(text, 'i')) !== -1);
            },

            // value contains text (case sensitive)
            containsExactly: function (value, text) {
                // escape regex characters
                text = text.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
                return (value.search(new RegExp(text)) !== -1);
            },

            // is most likely an email
            email: function (value) {
                var
                  emailRegExp = new RegExp("[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?", "i")
                ;
                return emailRegExp.test(value);
            },

            // is not empty or blank string
            empty: function (value) {
                return !(value === undefined || '' === value);
            },

            // is valid integer
            integer: function (value, range) {
                var
                  intRegExp = /^\-?\d+$/,
                  min,
                  max,
                  parts
                ;
                if (range === undefined || range === '' || range === '..') {
                    // do nothing
                }
                else if (range.indexOf('..') == -1) {
                    if (intRegExp.test(range)) {
                        min = max = range - 0;
                    }
                }
                else {
                    parts = range.split('..', 2);
                    if (intRegExp.test(parts[0])) {
                        min = parts[0] - 0;
                    }
                    if (intRegExp.test(parts[1])) {
                        max = parts[1] - 0;
                    }
                }
                return (
                  intRegExp.test(value) &&
                  (min === undefined || value >= min) &&
                  (max === undefined || value <= max)
                );
            },

            // is value (case insensitive)
            is: function (value, text) {
                text = (typeof text == 'string')
                  ? text.toLowerCase()
                  : text
                ;
                value = (typeof value == 'string')
                  ? value.toLowerCase()
                  : value
                ;
                return (value == text);
            },

            // is value
            isExactly: function (value, text) {
                return (value == text);
            },

            // is at least string length
            length: function (value, requiredLength) {
                return (value !== undefined)
                  ? (value.length >= requiredLength)
                  : false
                ;
            },

            // matches another field
            match: function (value, fieldIdentifier) {
                // use either id or name of field
                var
                  $form = $(this),
                  matchingValue
                ;
                if ($form.find('#' + fieldIdentifier).length > 0) {
                    matchingValue = $form.find('#' + fieldIdentifier).val();
                }
                else if ($form.find('[name="' + fieldIdentifier + '"]').length > 0) {
                    matchingValue = $form.find('[name="' + fieldIdentifier + '"]').val();
                }
                else if ($form.find('[data-validate="' + fieldIdentifier + '"]').length > 0) {
                    matchingValue = $form.find('[data-validate="' + fieldIdentifier + '"]').val();
                }
                return (matchingValue !== undefined)
                  ? (value.toString() == matchingValue.toString())
                  : false
                ;
            },

            // string length is less than max length
            maxLength: function (value, maxLength) {
                return (value !== undefined)
                  ? (value.length <= maxLength)
                  : false
                ;
            },

            // value is not value (case insensitive)
            not: function (value, notValue) {
                value = (typeof value == 'string')
                  ? value.toLowerCase()
                  : value
                ;
                notValue = (typeof notValue == 'string')
                  ? notValue.toLowerCase()
                  : notValue
                ;
                return (value != notValue);
            },

            // value is not value (case sensitive)
            notExactly: function (value, notValue) {
                return (value != notValue);
            },

            // value is most likely url
            url: function (value) {
                var
                  urlRegExp = /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/
                ;
                return urlRegExp.test(value);
            }
        }

    };

})(jQuery, window, document);

/*!
 * # Semantic UI 1.12.1 - Accordion
 * http://github.com/semantic-org/semantic-ui/
 *
 *
 * Copyright 2014 Contributors
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 *
 */

; (function ($, window, document, undefined) {

    "use strict";

    $.fn.accordion = function (parameters) {
        var
          $allModules = $(this),

          time = new Date().getTime(),
          performance = [],

          query = arguments[0],
          methodInvoked = (typeof query == 'string'),
          queryArguments = [].slice.call(arguments, 1),

          requestAnimationFrame = window.requestAnimationFrame
            || window.mozRequestAnimationFrame
            || window.webkitRequestAnimationFrame
            || window.msRequestAnimationFrame
            || function (callback) { setTimeout(callback, 0); },

          returnedValue
        ;
        $allModules
          .each(function () {
              var
                settings = ($.isPlainObject(parameters))
                  ? $.extend(true, {}, $.fn.accordion.settings, parameters)
                  : $.extend({}, $.fn.accordion.settings),

                className = settings.className,
                namespace = settings.namespace,
                selector = settings.selector,
                error = settings.error,

                eventNamespace = '.' + namespace,
                moduleNamespace = 'module-' + namespace,
                moduleSelector = $allModules.selector || '',

                $module = $(this),
                $title = $module.find(selector.title),
                $content = $module.find(selector.content),

                element = this,
                instance = $module.data(moduleNamespace),
                observer,
                module
              ;

              module = {

                  initialize: function () {
                      module.debug('Initializing', $module);
                      module.bind.events();
                      module.observeChanges();
                      module.instantiate();
                  },

                  instantiate: function () {
                      instance = module;
                      $module
                        .data(moduleNamespace, module)
                      ;
                  },

                  destroy: function () {
                      module.debug('Destroying previous instance', $module);
                      $module
                        .off(eventNamespace)
                        .removeData(moduleNamespace)
                      ;
                  },

                  refresh: function () {
                      $title = $module.find(selector.title);
                      $content = $module.find(selector.content);
                  },

                  observeChanges: function () {
                      if ('MutationObserver' in window) {
                          observer = new MutationObserver(function (mutations) {
                              module.debug('DOM tree modified, updating selector cache');
                              module.refresh();
                          });
                          observer.observe(element, {
                              childList: true,
                              subtree: true
                          });
                          module.debug('Setting up mutation observer', observer);
                      }
                  },

                  bind: {
                      events: function () {
                          module.debug('Binding delegated events');
                          $module
                            .on('click' + eventNamespace, selector.trigger, module.event.click)
                          ;
                      }
                  },

                  event: {
                      click: function () {
                          module.toggle.call(this);
                      }
                  },

                  toggle: function (query) {
                      var
                        $activeTitle = (query !== undefined)
                          ? (typeof query === 'number')
                            ? $title.eq(query)
                            : $(query).closest(selector.title)
                          : $(this).closest(selector.title),
                        $activeContent = $activeTitle.next($content),
                        isAnimating = $activeContent.hasClass(className.animating),
                        isActive = $activeContent.hasClass(className.active),
                        isOpen = (isActive && !isAnimating),
                        isOpening = (!isActive && isAnimating)
                      ;
                      module.debug('Toggling visibility of content', $activeTitle);
                      if (isOpen || isOpening) {
                          if (settings.collapsible) {
                              module.close.call($activeTitle);
                          }
                          else {
                              module.debug('Cannot close accordion content collapsing is disabled');
                          }
                      }
                      else {
                          module.open.call($activeTitle);
                      }
                  },

                  open: function (query) {
                      var
                        $activeTitle = (query !== undefined)
                          ? (typeof query === 'number')
                            ? $title.eq(query)
                            : $(query).closest(selector.title)
                          : $(this).closest(selector.title),
                        $activeContent = $activeTitle.next($content),
                        isAnimating = $activeContent.hasClass(className.animating),
                        isActive = $activeContent.hasClass(className.active),
                        isUnopen = (!isActive && !isAnimating)
                      ;
                      if (isUnopen) {
                          module.debug('Opening accordion content', $activeTitle);
                          if (settings.exclusive) {
                              module.closeOthers.call($activeTitle);
                          }
                          $activeTitle
                            .addClass(className.active)
                          ;
                          $activeContent.addClass(className.animating);
                          if (settings.animateChildren) {
                              if ($.fn.transition !== undefined && $module.transition('is supported')) {
                                  $activeContent
                                    .children()
                                      .transition({
                                          animation: 'fade in',
                                          queue: false,
                                          useFailSafe: true,
                                          debug: settings.debug,
                                          verbose: settings.verbose,
                                          duration: settings.duration
                                      })
                                  ;
                              }
                              else {
                                  $activeContent
                                    .children()
                                      .stop(true)
                                      .animate({
                                          opacity: 1
                                      }, settings.duration, module.resetOpacity)
                                  ;
                              }
                          }
                          $activeContent
                            .stop(true)
                            .slideDown(settings.duration, settings.easing, function () {
                                $activeContent
                                  .removeClass(className.animating)
                                  .addClass(className.active)
                                ;
                                module.reset.display.call(this);
                                settings.onOpen.call(this);
                                settings.onChange.call(this);
                            })
                          ;
                      }
                  },

                  close: function (query) {
                      var
                        $activeTitle = (query !== undefined)
                          ? (typeof query === 'number')
                            ? $title.eq(query)
                            : $(query).closest(selector.title)
                          : $(this).closest(selector.title),
                        $activeContent = $activeTitle.next($content),
                        isAnimating = $activeContent.hasClass(className.animating),
                        isActive = $activeContent.hasClass(className.active),
                        isOpening = (!isActive && isAnimating),
                        isClosing = (isActive && isAnimating)
                      ;
                      if ((isActive || isOpening) && !isClosing) {
                          module.debug('Closing accordion content', $activeContent);
                          $activeTitle
                            .removeClass(className.active)
                          ;
                          $activeContent
                            .addClass(className.animating)
                          ;
                          if (settings.animateChildren) {
                              if ($.fn.transition !== undefined && $module.transition('is supported')) {
                                  $activeContent
                                    .children()
                                      .transition({
                                          animation: 'fade out',
                                          queue: false,
                                          useFailSafe: true,
                                          debug: settings.debug,
                                          verbose: settings.verbose,
                                          duration: settings.duration
                                      })
                                  ;
                              }
                              else {
                                  $activeContent
                                    .children()
                                      .stop(true)
                                      .animate({
                                          opacity: 0
                                      }, settings.duration, module.resetOpacity)
                                  ;
                              }
                          }
                          $activeContent
                            .stop(true)
                            .slideUp(settings.duration, settings.easing, function () {
                                $activeContent
                                  .removeClass(className.animating)
                                  .removeClass(className.active)
                                ;
                                module.reset.display.call(this);
                                settings.onClose.call(this);
                                settings.onChange.call(this);
                            })
                          ;
                      }
                  },

                  closeOthers: function (index) {
                      var
                        $activeTitle = (index !== undefined)
                          ? $title.eq(index)
                          : $(this).closest(selector.title),
                        $parentTitles = $activeTitle.parents(selector.content).prev(selector.title),
                        $activeAccordion = $activeTitle.closest(selector.accordion),
                        activeSelector = selector.title + '.' + className.active + ':visible',
                        activeContent = selector.content + '.' + className.active + ':visible',
                        $openTitles,
                        $nestedTitles,
                        $openContents
                      ;
                      if (settings.closeNested) {
                          $openTitles = $activeAccordion.find(activeSelector).not($parentTitles);
                          $openContents = $openTitles.next($content);
                      }
                      else {
                          $openTitles = $activeAccordion.find(activeSelector).not($parentTitles);
                          $nestedTitles = $activeAccordion.find(activeContent).find(activeSelector).not($parentTitles);
                          $openTitles = $openTitles.not($nestedTitles);
                          $openContents = $openTitles.next($content);
                      }
                      if (($openTitles.length > 0)) {
                          module.debug('Exclusive enabled, closing other content', $openTitles);
                          $openTitles
                            .removeClass(className.active)
                          ;
                          if (settings.animateChildren) {
                              if ($.fn.transition !== undefined && $module.transition('is supported')) {
                                  $openContents
                                    .children()
                                      .transition({
                                          animation: 'fade out',
                                          useFailSafe: true,
                                          debug: settings.debug,
                                          verbose: settings.verbose,
                                          duration: settings.duration
                                      })
                                  ;
                              }
                              else {
                                  $openContents
                                    .children()
                                      .stop()
                                      .animate({
                                          opacity: 0
                                      }, settings.duration, module.resetOpacity)
                                  ;
                              }
                          }
                          $openContents
                            .stop()
                            .slideUp(settings.duration, settings.easing, function () {
                                $(this).removeClass(className.active);
                                module.reset.display.call(this);
                            })
                          ;
                      }
                  },

                  reset: {

                      display: function () {
                          module.verbose('Removing inline display from element', this);
                          $(this).css('display', '');
                          if ($(this).attr('style') === '') {
                              $(this)
                                .attr('style', '')
                                .removeAttr('style')
                              ;
                          }
                      },

                      opacity: function () {
                          module.verbose('Removing inline opacity from element', this);
                          $(this).css('opacity', '');
                          if ($(this).attr('style') === '') {
                              $(this)
                                .attr('style', '')
                                .removeAttr('style')
                              ;
                          }
                      },

                  },

                  setting: function (name, value) {
                      module.debug('Changing setting', name, value);
                      if ($.isPlainObject(name)) {
                          $.extend(true, settings, name);
                      }
                      else if (value !== undefined) {
                          settings[name] = value;
                      }
                      else {
                          return settings[name];
                      }
                  },
                  internal: function (name, value) {
                      module.debug('Changing internal', name, value);
                      if (value !== undefined) {
                          if ($.isPlainObject(name)) {
                              $.extend(true, module, name);
                          }
                          else {
                              module[name] = value;
                          }
                      }
                      else {
                          return module[name];
                      }
                  },
                  debug: function () {
                      if (settings.debug) {
                          if (settings.performance) {
                              module.performance.log(arguments);
                          }
                          else {
                              module.debug = Function.prototype.bind.call(console.info, console, settings.name + ':');
                              module.debug.apply(console, arguments);
                          }
                      }
                  },
                  verbose: function () {
                      if (settings.verbose && settings.debug) {
                          if (settings.performance) {
                              module.performance.log(arguments);
                          }
                          else {
                              module.verbose = Function.prototype.bind.call(console.info, console, settings.name + ':');
                              module.verbose.apply(console, arguments);
                          }
                      }
                  },
                  error: function () {
                      module.error = Function.prototype.bind.call(console.error, console, settings.name + ':');
                      module.error.apply(console, arguments);
                  },
                  performance: {
                      log: function (message) {
                          var
                            currentTime,
                            executionTime,
                            previousTime
                          ;
                          if (settings.performance) {
                              currentTime = new Date().getTime();
                              previousTime = time || currentTime;
                              executionTime = currentTime - previousTime;
                              time = currentTime;
                              performance.push({
                                  'Name': message[0],
                                  'Arguments': [].slice.call(message, 1) || '',
                                  'Element': element,
                                  'Execution Time': executionTime
                              });
                          }
                          clearTimeout(module.performance.timer);
                          module.performance.timer = setTimeout(module.performance.display, 100);
                      },
                      display: function () {
                          var
                            title = settings.name + ':',
                            totalTime = 0
                          ;
                          time = false;
                          clearTimeout(module.performance.timer);
                          $.each(performance, function (index, data) {
                              totalTime += data['Execution Time'];
                          });
                          title += ' ' + totalTime + 'ms';
                          if (moduleSelector) {
                              title += ' \'' + moduleSelector + '\'';
                          }
                          if ((console.group !== undefined || console.table !== undefined) && performance.length > 0) {
                              console.groupCollapsed(title);
                              if (console.table) {
                                  console.table(performance);
                              }
                              else {
                                  $.each(performance, function (index, data) {
                                      console.log(data['Name'] + ': ' + data['Execution Time'] + 'ms');
                                  });
                              }
                              console.groupEnd();
                          }
                          performance = [];
                      }
                  },
                  invoke: function (query, passedArguments, context) {
                      var
                        object = instance,
                        maxDepth,
                        found,
                        response
                      ;
                      passedArguments = passedArguments || queryArguments;
                      context = element || context;
                      if (typeof query == 'string' && object !== undefined) {
                          query = query.split(/[\. ]/);
                          maxDepth = query.length - 1;
                          $.each(query, function (depth, value) {
                              var camelCaseValue = (depth != maxDepth)
                                ? value + query[depth + 1].charAt(0).toUpperCase() + query[depth + 1].slice(1)
                                : query
                              ;
                              if ($.isPlainObject(object[camelCaseValue]) && (depth != maxDepth)) {
                                  object = object[camelCaseValue];
                              }
                              else if (object[camelCaseValue] !== undefined) {
                                  found = object[camelCaseValue];
                                  return false;
                              }
                              else if ($.isPlainObject(object[value]) && (depth != maxDepth)) {
                                  object = object[value];
                              }
                              else if (object[value] !== undefined) {
                                  found = object[value];
                                  return false;
                              }
                              else {
                                  module.error(error.method, query);
                                  return false;
                              }
                          });
                      }
                      if ($.isFunction(found)) {
                          response = found.apply(context, passedArguments);
                      }
                      else if (found !== undefined) {
                          response = found;
                      }
                      if ($.isArray(returnedValue)) {
                          returnedValue.push(response);
                      }
                      else if (returnedValue !== undefined) {
                          returnedValue = [returnedValue, response];
                      }
                      else if (response !== undefined) {
                          returnedValue = response;
                      }
                      return found;
                  }
              };
              if (methodInvoked) {
                  if (instance === undefined) {
                      module.initialize();
                  }
                  module.invoke(query);
              }
              else {
                  if (instance !== undefined) {
                      instance.invoke('destroy');
                  }
                  module.initialize();
              }
          })
        ;
        return (returnedValue !== undefined)
          ? returnedValue
          : this
        ;
    };

    $.fn.accordion.settings = {

        name: 'Accordion',
        namespace: 'accordion',

        debug: false,
        verbose: true,
        performance: true,

        exclusive: true,
        collapsible: true,
        closeNested: false,
        animateChildren: true,

        duration: 350,
        easing: 'easeOutQuad',

        onOpen: function () { },
        onClose: function () { },
        onChange: function () { },

        error: {
            method: 'The method you called is not defined'
        },

        className: {
            active: 'active',
            animating: 'animating'
        },

        selector: {
            accordion: '.accordion',
            title: '.title',
            trigger: '.title',
            content: '.content'
        }

    };

    // Adds easing
    $.extend($.easing, {
        easeOutQuad: function (x, t, b, c, d) {
            return -c * (t /= d) * (t - 2) + b;
        }
    });

})(jQuery, window, document);


/*!
 * # Semantic UI 1.12.1 - Checkbox
 * http://github.com/semantic-org/semantic-ui/
 *
 *
 * Copyright 2014 Contributors
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 *
 */

; (function ($, window, document, undefined) {

    "use strict";

    $.fn.checkbox = function (parameters) {
        var
          $allModules = $(this),
          moduleSelector = $allModules.selector || '',

          time = new Date().getTime(),
          performance = [],

          query = arguments[0],
          methodInvoked = (typeof query == 'string'),
          queryArguments = [].slice.call(arguments, 1),
          returnedValue
        ;

        $allModules
          .each(function () {
              var
                settings = $.extend(true, {}, $.fn.checkbox.settings, parameters),

                className = settings.className,
                namespace = settings.namespace,
                selector = settings.selector,
                error = settings.error,

                eventNamespace = '.' + namespace,
                moduleNamespace = 'module-' + namespace,

                $module = $(this),
                $label = $(this).find(selector.label).first(),
                $input = $(this).find(selector.input),

                instance = $module.data(moduleNamespace),

                observer,
                element = this,
                module
              ;

              module = {

                  initialize: function () {
                      module.verbose('Initializing checkbox', settings);

                      module.create.label();
                      module.add.events();

                      if (module.is.checked()) {
                          module.set.checked();
                          if (settings.fireOnInit) {
                              settings.onChecked.call($input.get());
                          }
                      }
                      else {
                          module.remove.checked();
                          if (settings.fireOnInit) {
                              settings.onUnchecked.call($input.get());
                          }
                      }
                      module.observeChanges();

                      module.instantiate();
                  },

                  instantiate: function () {
                      module.verbose('Storing instance of module', module);
                      instance = module;
                      $module
                        .data(moduleNamespace, module)
                      ;
                  },

                  destroy: function () {
                      module.verbose('Destroying module');
                      module.remove.events();
                      $module
                        .removeData(moduleNamespace)
                      ;
                  },

                  refresh: function () {
                      $module = $(this);
                      $label = $(this).find(selector.label).first();
                      $input = $(this).find(selector.input);
                  },

                  observeChanges: function () {
                      if ('MutationObserver' in window) {
                          observer = new MutationObserver(function (mutations) {
                              module.debug('DOM tree modified, updating selector cache');
                              module.refresh();
                          });
                          observer.observe(element, {
                              childList: true,
                              subtree: true
                          });
                          module.debug('Setting up mutation observer', observer);
                      }
                  },

                  attachEvents: function (selector, event) {
                      var
                        $element = $(selector)
                      ;
                      event = $.isFunction(module[event])
                        ? module[event]
                        : module.toggle
                      ;
                      if ($element.length > 0) {
                          module.debug('Attaching checkbox events to element', selector, event);
                          $element
                            .on('click' + eventNamespace, event)
                          ;
                      }
                      else {
                          module.error(error.notFound);
                      }
                  },

                  event: {
                      keydown: function (event) {
                          var
                            key = event.which,
                            keyCode = {
                                enter: 13,
                                space: 32,
                                escape: 27
                            }
                          ;
                          if (key == keyCode.escape) {
                              module.verbose('Escape key pressed blurring field');
                              $module
                                .blur()
                              ;
                          }
                          if (!event.ctrlKey && (key == keyCode.enter || key == keyCode.space)) {
                              module.verbose('Enter key pressed, toggling checkbox');
                              module.toggle.call(this);
                              event.preventDefault();
                          }
                      }
                  },

                  is: {
                      radio: function () {
                          return $module.hasClass(className.radio);
                      },
                      checked: function () {
                          return $input.prop('checked') !== undefined && $input.prop('checked');
                      },
                      unchecked: function () {
                          return !module.is.checked();
                      }
                  },

                  can: {
                      change: function () {
                          return !($module.hasClass(className.disabled) || $module.hasClass(className.readOnly) || $input.prop('disabled'));
                      },
                      uncheck: function () {
                          return (typeof settings.uncheckable === 'boolean')
                            ? settings.uncheckable
                            : !module.is.radio()
                          ;
                      }
                  },

                  set: {
                      checked: function () {
                          $module.addClass(className.checked);
                      },
                      tab: function () {
                          if ($input.attr('tabindex') === undefined) {
                              $input
                                .attr('tabindex', 0)
                              ;
                          }
                      }
                  },

                  create: {
                      label: function () {
                          if ($input.prevAll(selector.label).length > 0) {
                              $input.prev(selector.label).detach().insertAfter($input);
                              module.debug('Moving existing label', $label);
                          }
                          else if (!module.has.label()) {
                              $label = $('<label>').insertAfter($input);
                              module.debug('Creating label', $label);
                          }
                      }
                  },

                  has: {
                      label: function () {
                          return ($label.length > 0);
                      }
                  },

                  add: {
                      events: function () {
                          module.verbose('Attaching checkbox events');
                          $module
                            .on('click' + eventNamespace, module.toggle)
                            .on('keydown' + eventNamespace, selector.input, module.event.keydown)
                          ;
                      }
                  },

                  remove: {
                      checked: function () {
                          $module.removeClass(className.checked);
                      },
                      events: function () {
                          module.debug('Removing events');
                          $module
                            .off(eventNamespace)
                            .removeData(moduleNamespace)
                          ;
                          $input
                            .off(eventNamespace, module.event.keydown)
                          ;
                          $label
                            .off(eventNamespace)
                          ;
                      }
                  },

                  enable: function () {
                      module.debug('Enabling checkbox functionality');
                      $module.removeClass(className.disabled);
                      $input.prop('disabled', false);
                      settings.onEnabled.call($input.get());
                  },

                  disable: function () {
                      module.debug('Disabling checkbox functionality');
                      $module.addClass(className.disabled);
                      $input.prop('disabled', 'disabled');
                      settings.onDisabled.call($input.get());
                  },

                  check: function () {
                      module.debug('Enabling checkbox', $input);
                      $input
                        .prop('checked', true)
                        .trigger('change')
                      ;
                      module.set.checked();
                      $input.trigger('blur');
                      settings.onChange.call($input.get());
                      settings.onChecked.call($input.get());
                  },

                  uncheck: function () {
                      module.debug('Disabling checkbox');
                      $input
                        .prop('checked', false)
                        .trigger('change')
                      ;
                      module.remove.checked();
                      $input.trigger('blur');
                      settings.onChange.call($input.get());
                      settings.onUnchecked.call($input.get());
                  },

                  toggle: function (event) {
                      if (!module.can.change()) {
                          console.log(module.can.change());
                          module.debug('Checkbox is read-only or disabled, ignoring toggle');
                          return;
                      }
                      module.verbose('Determining new checkbox state');
                      if (module.is.unchecked()) {
                          module.check();
                      }
                      else if (module.is.checked() && module.can.uncheck()) {
                          module.uncheck();
                      }
                  },
                  setting: function (name, value) {
                      module.debug('Changing setting', name, value);
                      if ($.isPlainObject(name)) {
                          $.extend(true, settings, name);
                      }
                      else if (value !== undefined) {
                          settings[name] = value;
                      }
                      else {
                          return settings[name];
                      }
                  },
                  internal: function (name, value) {
                      if ($.isPlainObject(name)) {
                          $.extend(true, module, name);
                      }
                      else if (value !== undefined) {
                          module[name] = value;
                      }
                      else {
                          return module[name];
                      }
                  },
                  debug: function () {
                      if (settings.debug) {
                          if (settings.performance) {
                              module.performance.log(arguments);
                          }
                          else {
                              module.debug = Function.prototype.bind.call(console.info, console, settings.name + ':');
                              module.debug.apply(console, arguments);
                          }
                      }
                  },
                  verbose: function () {
                      if (settings.verbose && settings.debug) {
                          if (settings.performance) {
                              module.performance.log(arguments);
                          }
                          else {
                              module.verbose = Function.prototype.bind.call(console.info, console, settings.name + ':');
                              module.verbose.apply(console, arguments);
                          }
                      }
                  },
                  error: function () {
                      module.error = Function.prototype.bind.call(console.error, console, settings.name + ':');
                      module.error.apply(console, arguments);
                  },
                  performance: {
                      log: function (message) {
                          var
                            currentTime,
                            executionTime,
                            previousTime
                          ;
                          if (settings.performance) {
                              currentTime = new Date().getTime();
                              previousTime = time || currentTime;
                              executionTime = currentTime - previousTime;
                              time = currentTime;
                              performance.push({
                                  'Name': message[0],
                                  'Arguments': [].slice.call(message, 1) || '',
                                  'Element': element,
                                  'Execution Time': executionTime
                              });
                          }
                          clearTimeout(module.performance.timer);
                          module.performance.timer = setTimeout(module.performance.display, 100);
                      },
                      display: function () {
                          var
                            title = settings.name + ':',
                            totalTime = 0
                          ;
                          time = false;
                          clearTimeout(module.performance.timer);
                          $.each(performance, function (index, data) {
                              totalTime += data['Execution Time'];
                          });
                          title += ' ' + totalTime + 'ms';
                          if (moduleSelector) {
                              title += ' \'' + moduleSelector + '\'';
                          }
                          if ((console.group !== undefined || console.table !== undefined) && performance.length > 0) {
                              console.groupCollapsed(title);
                              if (console.table) {
                                  console.table(performance);
                              }
                              else {
                                  $.each(performance, function (index, data) {
                                      console.log(data['Name'] + ': ' + data['Execution Time'] + 'ms');
                                  });
                              }
                              console.groupEnd();
                          }
                          performance = [];
                      }
                  },
                  invoke: function (query, passedArguments, context) {
                      var
                        object = instance,
                        maxDepth,
                        found,
                        response
                      ;
                      passedArguments = passedArguments || queryArguments;
                      context = element || context;
                      if (typeof query == 'string' && object !== undefined) {
                          query = query.split(/[\. ]/);
                          maxDepth = query.length - 1;
                          $.each(query, function (depth, value) {
                              var camelCaseValue = (depth != maxDepth)
                                ? value + query[depth + 1].charAt(0).toUpperCase() + query[depth + 1].slice(1)
                                : query
                              ;
                              if ($.isPlainObject(object[camelCaseValue]) && (depth != maxDepth)) {
                                  object = object[camelCaseValue];
                              }
                              else if (object[camelCaseValue] !== undefined) {
                                  found = object[camelCaseValue];
                                  return false;
                              }
                              else if ($.isPlainObject(object[value]) && (depth != maxDepth)) {
                                  object = object[value];
                              }
                              else if (object[value] !== undefined) {
                                  found = object[value];
                                  return false;
                              }
                              else {
                                  module.error(error.method, query);
                                  return false;
                              }
                          });
                      }
                      if ($.isFunction(found)) {
                          response = found.apply(context, passedArguments);
                      }
                      else if (found !== undefined) {
                          response = found;
                      }
                      if ($.isArray(returnedValue)) {
                          returnedValue.push(response);
                      }
                      else if (returnedValue !== undefined) {
                          returnedValue = [returnedValue, response];
                      }
                      else if (response !== undefined) {
                          returnedValue = response;
                      }
                      return found;
                  }
              };

              if (methodInvoked) {
                  if (instance === undefined) {
                      module.initialize();
                  }
                  module.invoke(query);
              }
              else {
                  if (instance !== undefined) {
                      instance.invoke('destroy');
                  }
                  module.initialize();
              }
          })
        ;

        return (returnedValue !== undefined)
          ? returnedValue
          : this
        ;
    };

    $.fn.checkbox.settings = {

        name: 'Checkbox',
        namespace: 'checkbox',

        debug: false,
        verbose: true,
        performance: true,

        // delegated event context
        uncheckable: 'auto',
        fireOnInit: true,

        onChange: function () { },
        onChecked: function () { },
        onUnchecked: function () { },
        onEnabled: function () { },
        onDisabled: function () { },

        className: {
            checked: 'checked',
            disabled: 'disabled',
            radio: 'radio',
            readOnly: 'read-only'
        },

        error: {
            method: 'The method you called is not defined'
        },

        selector: {
            input: 'input[type="checkbox"], input[type="radio"]',
            label: 'label'
        }

    };

})(jQuery, window, document);

/*!
 * # Semantic UI 1.12.1 - Dimmer
 * http://github.com/semantic-org/semantic-ui/
 *
 *
 * Copyright 2014 Contributors
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 *
 */

; (function ($, window, document, undefined) {

    "use strict";

    $.fn.dimmer = function (parameters) {
        var
          $allModules = $(this),

          time = new Date().getTime(),
          performance = [],

          query = arguments[0],
          methodInvoked = (typeof query == 'string'),
          queryArguments = [].slice.call(arguments, 1),

          returnedValue
        ;

        $allModules
          .each(function () {
              var
                settings = ($.isPlainObject(parameters))
                  ? $.extend(true, {}, $.fn.dimmer.settings, parameters)
                  : $.extend({}, $.fn.dimmer.settings),

                selector = settings.selector,
                namespace = settings.namespace,
                className = settings.className,
                error = settings.error,

                eventNamespace = '.' + namespace,
                moduleNamespace = 'module-' + namespace,
                moduleSelector = $allModules.selector || '',

                clickEvent = ('ontouchstart' in document.documentElement)
                  ? 'touchstart'
                  : 'click',

                $module = $(this),
                $dimmer,
                $dimmable,

                element = this,
                instance = $module.data(moduleNamespace),
                module
              ;

              module = {

                  preinitialize: function () {
                      if (module.is.dimmer()) {
                          $dimmable = $module.parent();
                          $dimmer = $module;
                      }
                      else {
                          $dimmable = $module;
                          if (module.has.dimmer()) {
                              if (settings.dimmerName) {
                                  $dimmer = $dimmable.children(selector.dimmer).filter('.' + settings.dimmerName);
                              }
                              else {
                                  $dimmer = $dimmable.children(selector.dimmer);
                              }
                          }
                          else {
                              $dimmer = module.create();
                          }
                      }
                  },

                  initialize: function () {
                      module.debug('Initializing dimmer', settings);
                      if (settings.on == 'hover') {
                          $dimmable
                            .on('mouseenter' + eventNamespace, module.show)
                            .on('mouseleave' + eventNamespace, module.hide)
                          ;
                      }
                      else if (settings.on == 'click') {
                          $dimmable
                            .on(clickEvent + eventNamespace, module.toggle)
                          ;
                      }
                      if (module.is.page()) {
                          module.debug('Setting as a page dimmer', $dimmable);
                          module.set.pageDimmer();
                      }

                      if (module.is.closable()) {
                          module.verbose('Adding dimmer close event', $dimmer);
                          $dimmer
                            .on(clickEvent + eventNamespace, module.event.click)
                          ;
                      }
                      module.set.dimmable();
                      module.instantiate();
                  },

                  instantiate: function () {
                      module.verbose('Storing instance of module', module);
                      instance = module;
                      $module
                        .data(moduleNamespace, instance)
                      ;
                  },

                  destroy: function () {
                      module.verbose('Destroying previous module', $dimmer);
                      $module
                        .removeData(moduleNamespace)
                      ;
                      $dimmable
                        .off(eventNamespace)
                      ;
                      $dimmer
                        .off(eventNamespace)
                      ;
                  },

                  event: {
                      click: function (event) {
                          module.verbose('Determining if event occured on dimmer', event);
                          if ($dimmer.find(event.target).length === 0 || $(event.target).is(selector.content)) {
                              module.hide();
                              event.stopImmediatePropagation();
                          }
                      }
                  },

                  addContent: function (element) {
                      var
                        $content = $(element)
                      ;
                      module.debug('Add content to dimmer', $content);
                      if ($content.parent()[0] !== $dimmer[0]) {
                          $content.detach().appendTo($dimmer);
                      }
                  },

                  create: function () {
                      var
                        $element = $(settings.template.dimmer())
                      ;
                      if (settings.variation) {
                          module.debug('Creating dimmer with variation', settings.variation);
                          $element.addClass(settings.variation);
                      }
                      if (settings.dimmerName) {
                          module.debug('Creating named dimmer', settings.dimmerName);
                          $element.addClass(settings.dimmerName);
                      }
                      $element
                        .appendTo($dimmable)
                      ;
                      return $element;
                  },

                  show: function (callback) {
                      callback = $.isFunction(callback)
                        ? callback
                        : function () { }
                      ;
                      module.debug('Showing dimmer', $dimmer, settings);
                      if ((!module.is.dimmed() || module.is.animating()) && module.is.enabled()) {
                          module.animate.show(callback);
                          settings.onShow.call(element);
                          settings.onChange.call(element);
                      }
                      else {
                          module.debug('Dimmer is already shown or disabled');
                      }
                  },

                  hide: function (callback) {
                      callback = $.isFunction(callback)
                        ? callback
                        : function () { }
                      ;
                      if (module.is.dimmed() || module.is.animating()) {
                          module.debug('Hiding dimmer', $dimmer);
                          module.animate.hide(callback);
                          settings.onHide.call(element);
                          settings.onChange.call(element);
                      }
                      else {
                          module.debug('Dimmer is not visible');
                      }
                  },

                  toggle: function () {
                      module.verbose('Toggling dimmer visibility', $dimmer);
                      if (!module.is.dimmed()) {
                          module.show();
                      }
                      else {
                          module.hide();
                      }
                  },

                  animate: {
                      show: function (callback) {
                          callback = $.isFunction(callback)
                            ? callback
                            : function () { }
                          ;
                          if (settings.useCSS && $.fn.transition !== undefined && $dimmer.transition('is supported')) {
                              if (settings.opacity !== 'auto') {
                                  module.set.opacity();
                              }
                              $dimmer
                                .transition({
                                    animation: settings.transition + ' in',
                                    queue: false,
                                    duration: module.get.duration(),
                                    useFailSafe: true,
                                    onStart: function () {
                                        module.set.dimmed();
                                    },
                                    onComplete: function () {
                                        module.set.active();
                                        callback();
                                    }
                                })
                              ;
                          }
                          else {
                              module.verbose('Showing dimmer animation with javascript');
                              module.set.dimmed();
                              if (settings.opacity == 'auto') {
                                  settings.opacity = 0.8;
                              }
                              $dimmer
                                .stop()
                                .css({
                                    opacity: 0,
                                    width: '100%',
                                    height: '100%'
                                })
                                .fadeTo(module.get.duration(), settings.opacity, function () {
                                    $dimmer.removeAttr('style');
                                    module.set.active();
                                    callback();
                                })
                              ;
                          }
                      },
                      hide: function (callback) {
                          callback = $.isFunction(callback)
                            ? callback
                            : function () { }
                          ;
                          if (settings.useCSS && $.fn.transition !== undefined && $dimmer.transition('is supported')) {
                              module.verbose('Hiding dimmer with css');
                              $dimmer
                                .transition({
                                    animation: settings.transition + ' out',
                                    queue: false,
                                    duration: module.get.duration(),
                                    useFailSafe: true,
                                    onStart: function () {
                                        module.remove.dimmed();
                                    },
                                    onComplete: function () {
                                        module.remove.active();
                                        callback();
                                    }
                                })
                              ;
                          }
                          else {
                              module.verbose('Hiding dimmer with javascript');
                              module.remove.dimmed();
                              $dimmer
                                .stop()
                                .fadeOut(module.get.duration(), function () {
                                    module.remove.active();
                                    $dimmer.removeAttr('style');
                                    callback();
                                })
                              ;
                          }
                      }
                  },

                  get: {
                      dimmer: function () {
                          return $dimmer;
                      },
                      duration: function () {
                          if (typeof settings.duration == 'object') {
                              if (module.is.active()) {
                                  return settings.duration.hide;
                              }
                              else {
                                  return settings.duration.show;
                              }
                          }
                          return settings.duration;
                      }
                  },

                  has: {
                      dimmer: function () {
                          if (settings.dimmerName) {
                              return ($module.children(selector.dimmer).filter('.' + settings.dimmerName).length > 0);
                          }
                          else {
                              return ($module.children(selector.dimmer).length > 0);
                          }
                      }
                  },

                  is: {
                      active: function () {
                          return $dimmer.hasClass(className.active);
                      },
                      animating: function () {
                          return ($dimmer.is(':animated') || $dimmer.hasClass(className.animating));
                      },
                      closable: function () {
                          if (settings.closable == 'auto') {
                              if (settings.on == 'hover') {
                                  return false;
                              }
                              return true;
                          }
                          return settings.closable;
                      },
                      dimmer: function () {
                          return $module.is(selector.dimmer);
                      },
                      dimmable: function () {
                          return $module.is(selector.dimmable);
                      },
                      dimmed: function () {
                          return $dimmable.hasClass(className.dimmed);
                      },
                      disabled: function () {
                          return $dimmable.hasClass(className.disabled);
                      },
                      enabled: function () {
                          return !module.is.disabled();
                      },
                      page: function () {
                          return $dimmable.is('body');
                      },
                      pageDimmer: function () {
                          return $dimmer.hasClass(className.pageDimmer);
                      }
                  },

                  can: {
                      show: function () {
                          return !$dimmer.hasClass(className.disabled);
                      }
                  },

                  set: {
                      opacity: function (opacity) {
                          var
                            opacity = settings.opacity || opacity,
                            color = $dimmer.css('background-color'),
                            colorArray = color.split(','),
                            isRGBA = (colorArray && colorArray.length == 4)
                          ;
                          if (isRGBA) {
                              colorArray[3] = opacity + ')';
                              color = colorArray.join(',');
                          }
                          else {
                              color = 'rgba(0, 0, 0, ' + opacity + ')';
                          }
                          module.debug('Setting opacity to', opacity);
                          $dimmer.css('background-color', color);
                      },
                      active: function () {
                          $dimmer.addClass(className.active);
                      },
                      dimmable: function () {
                          $dimmable.addClass(className.dimmable);
                      },
                      dimmed: function () {
                          $dimmable.addClass(className.dimmed);
                      },
                      pageDimmer: function () {
                          $dimmer.addClass(className.pageDimmer);
                      },
                      disabled: function () {
                          $dimmer.addClass(className.disabled);
                      }
                  },

                  remove: {
                      active: function () {
                          $dimmer
                            .removeClass(className.active)
                          ;
                      },
                      dimmed: function () {
                          $dimmable.removeClass(className.dimmed);
                      },
                      disabled: function () {
                          $dimmer.removeClass(className.disabled);
                      }
                  },

                  setting: function (name, value) {
                      module.debug('Changing setting', name, value);
                      if ($.isPlainObject(name)) {
                          $.extend(true, settings, name);
                      }
                      else if (value !== undefined) {
                          settings[name] = value;
                      }
                      else {
                          return settings[name];
                      }
                  },
                  internal: function (name, value) {
                      if ($.isPlainObject(name)) {
                          $.extend(true, module, name);
                      }
                      else if (value !== undefined) {
                          module[name] = value;
                      }
                      else {
                          return module[name];
                      }
                  },
                  debug: function () {
                      if (settings.debug) {
                          if (settings.performance) {
                              module.performance.log(arguments);
                          }
                          else {
                              module.debug = Function.prototype.bind.call(console.info, console, settings.name + ':');
                              module.debug.apply(console, arguments);
                          }
                      }
                  },
                  verbose: function () {
                      if (settings.verbose && settings.debug) {
                          if (settings.performance) {
                              module.performance.log(arguments);
                          }
                          else {
                              module.verbose = Function.prototype.bind.call(console.info, console, settings.name + ':');
                              module.verbose.apply(console, arguments);
                          }
                      }
                  },
                  error: function () {
                      module.error = Function.prototype.bind.call(console.error, console, settings.name + ':');
                      module.error.apply(console, arguments);
                  },
                  performance: {
                      log: function (message) {
                          var
                            currentTime,
                            executionTime,
                            previousTime
                          ;
                          if (settings.performance) {
                              currentTime = new Date().getTime();
                              previousTime = time || currentTime;
                              executionTime = currentTime - previousTime;
                              time = currentTime;
                              performance.push({
                                  'Name': message[0],
                                  'Arguments': [].slice.call(message, 1) || '',
                                  'Element': element,
                                  'Execution Time': executionTime
                              });
                          }
                          clearTimeout(module.performance.timer);
                          module.performance.timer = setTimeout(module.performance.display, 100);
                      },
                      display: function () {
                          var
                            title = settings.name + ':',
                            totalTime = 0
                          ;
                          time = false;
                          clearTimeout(module.performance.timer);
                          $.each(performance, function (index, data) {
                              totalTime += data['Execution Time'];
                          });
                          title += ' ' + totalTime + 'ms';
                          if (moduleSelector) {
                              title += ' \'' + moduleSelector + '\'';
                          }
                          if ($allModules.length > 1) {
                              title += ' ' + '(' + $allModules.length + ')';
                          }
                          if ((console.group !== undefined || console.table !== undefined) && performance.length > 0) {
                              console.groupCollapsed(title);
                              if (console.table) {
                                  console.table(performance);
                              }
                              else {
                                  $.each(performance, function (index, data) {
                                      console.log(data['Name'] + ': ' + data['Execution Time'] + 'ms');
                                  });
                              }
                              console.groupEnd();
                          }
                          performance = [];
                      }
                  },
                  invoke: function (query, passedArguments, context) {
                      var
                        object = instance,
                        maxDepth,
                        found,
                        response
                      ;
                      passedArguments = passedArguments || queryArguments;
                      context = element || context;
                      if (typeof query == 'string' && object !== undefined) {
                          query = query.split(/[\. ]/);
                          maxDepth = query.length - 1;
                          $.each(query, function (depth, value) {
                              var camelCaseValue = (depth != maxDepth)
                                ? value + query[depth + 1].charAt(0).toUpperCase() + query[depth + 1].slice(1)
                                : query
                              ;
                              if ($.isPlainObject(object[camelCaseValue]) && (depth != maxDepth)) {
                                  object = object[camelCaseValue];
                              }
                              else if (object[camelCaseValue] !== undefined) {
                                  found = object[camelCaseValue];
                                  return false;
                              }
                              else if ($.isPlainObject(object[value]) && (depth != maxDepth)) {
                                  object = object[value];
                              }
                              else if (object[value] !== undefined) {
                                  found = object[value];
                                  return false;
                              }
                              else {
                                  module.error(error.method, query);
                                  return false;
                              }
                          });
                      }
                      if ($.isFunction(found)) {
                          response = found.apply(context, passedArguments);
                      }
                      else if (found !== undefined) {
                          response = found;
                      }
                      if ($.isArray(returnedValue)) {
                          returnedValue.push(response);
                      }
                      else if (returnedValue !== undefined) {
                          returnedValue = [returnedValue, response];
                      }
                      else if (response !== undefined) {
                          returnedValue = response;
                      }
                      return found;
                  }
              };

              module.preinitialize();

              if (methodInvoked) {
                  if (instance === undefined) {
                      module.initialize();
                  }
                  module.invoke(query);
              }
              else {
                  if (instance !== undefined) {
                      instance.invoke('destroy');
                  }
                  module.initialize();
              }
          })
        ;

        return (returnedValue !== undefined)
          ? returnedValue
          : this
        ;
    };

    $.fn.dimmer.settings = {

        name: 'Dimmer',
        namespace: 'dimmer',

        debug: false,
        verbose: true,
        performance: true,

        // name to distinguish between multiple dimmers in context
        dimmerName: false,

        // whether to add a variation type
        variation: false,

        // whether to bind close events
        closable: 'auto',

        // whether to use css animations
        useCSS: true,

        // css animation to use
        transition: 'fade',

        // event to bind to
        on: false,

        // overriding opacity value
        opacity: 'auto',

        // transition durations
        duration: {
            show: 500,
            hide: 500
        },

        onChange: function () { },
        onShow: function () { },
        onHide: function () { },

        error: {
            method: 'The method you called is not defined.'
        },

        selector: {
            dimmable: '.dimmable',
            dimmer: '.ui.dimmer',
            content: '.ui.dimmer > .content, .ui.dimmer > .content > .center'
        },

        template: {
            dimmer: function () {
                return $('<div />').attr('class', 'ui dimmer');
            }
        },

        className: {
            active: 'active',
            animating: 'animating',
            dimmable: 'dimmable',
            dimmed: 'dimmed',
            disabled: 'disabled',
            hide: 'hide',
            pageDimmer: 'page',
            show: 'show'
        }

    };

})(jQuery, window, document);
/*!
 * # Semantic UI 1.12.1 - Dropdown
 * http://github.com/semantic-org/semantic-ui/
 *
 *
 * Copyright 2014 Contributors
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 *
 */

; (function ($, window, document, undefined) {

    "use strict";

    $.fn.dropdown = function (parameters) {
        var
          $allModules = $(this),
          $document = $(document),

          moduleSelector = $allModules.selector || '',

          hasTouch = ('ontouchstart' in document.documentElement),
          time = new Date().getTime(),
          performance = [],

          query = arguments[0],
          methodInvoked = (typeof query == 'string'),
          queryArguments = [].slice.call(arguments, 1),
          returnedValue
        ;

        $allModules
          .each(function () {
              var
                settings = ($.isPlainObject(parameters))
                  ? $.extend(true, {}, $.fn.dropdown.settings, parameters)
                  : $.extend({}, $.fn.dropdown.settings),

                className = settings.className,
                metadata = settings.metadata,
                namespace = settings.namespace,
                selector = settings.selector,
                error = settings.error,

                eventNamespace = '.' + namespace,
                moduleNamespace = 'module-' + namespace,

                $module = $(this),
                $text = $module.find(selector.text),
                $search = $module.find(selector.search),
                $input = $module.find(selector.input),

                $combo = ($module.prev().find(selector.text).length > 0)
                  ? $module.prev().find(selector.text)
                  : $module.prev(),

                $menu = $module.children(selector.menu),
                $item = $menu.find(selector.item),

                activated = false,
                itemActivated = false,
                element = this,
                instance = $module.data(moduleNamespace),

                elementNamespace,
                id,
                observer,
                module
              ;

              module = {

                  initialize: function () {
                      module.debug('Initializing dropdown', settings);

                      if (module.is.alreadySetup()) {
                          module.setup.reference();
                      }
                      else {
                          module.setup.layout();

                          module.save.defaults();
                          module.set.selected();

                          module.create.id();

                          if (hasTouch) {
                              module.bind.touchEvents();
                          }
                          module.bind.mouseEvents();
                          module.bind.keyboardEvents();

                          module.observeChanges();
                          module.instantiate();
                      }
                  },

                  instantiate: function () {
                      module.verbose('Storing instance of dropdown', module);
                      instance = module;
                      $module
                        .data(moduleNamespace, module)
                      ;
                  },

                  destroy: function () {
                      module.verbose('Destroying previous dropdown for', $module);
                      module.remove.tabbable();
                      $module
                        .off(eventNamespace)
                        .removeData(moduleNamespace)
                      ;
                      $menu
                        .off(eventNamespace)
                      ;
                      $document
                        .off(elementNamespace)
                      ;
                  },

                  observeChanges: function () {
                      if ('MutationObserver' in window) {
                          observer = new MutationObserver(function (mutations) {
                              if (module.is.selectMutation(mutations)) {
                                  module.debug('<select> modified, recreating menu');
                                  module.setup.select();
                              }
                              else {
                                  module.debug('DOM tree modified, updating selector cache');
                                  module.refresh();
                              }
                          });
                          observer.observe(element, {
                              childList: true,
                              subtree: true
                          });
                          module.debug('Setting up mutation observer', observer);
                      }
                  },

                  create: {
                      id: function () {
                          id = (Math.random().toString(16) + '000000000').substr(2, 8);
                          elementNamespace = '.' + id;
                          module.verbose('Creating unique id for element', id);
                      }
                  },

                  search: function () {
                      var
                        query
                      ;
                      query = $search.val();

                      module.verbose('Searching for query', query);
                      module.filter(query);
                      if (module.is.searchSelection() && module.can.show()) {
                          module.show();
                      }
                  },

                  setup: {
                      layout: function () {
                          if ($module.is('select')) {
                              module.setup.select();
                          }
                          if (module.is.search() && !module.is.searchable()) {
                              $search = $('<input />')
                                .addClass(className.search)
                                .insertBefore($text)
                              ;
                          }
                          if (settings.allowTab) {
                              module.set.tabbable();
                          }
                      },
                      select: function () {
                          var
                            selectValues = module.get.selectValues()
                          ;
                          module.debug('Dropdown initialized on a select', selectValues);
                          if ($module.is('select')) {
                              $input = $module;
                          }
                          // see if select is placed correctly already
                          if ($input.parent(selector.dropdown).length > 0) {
                              module.debug('UI dropdown already exists. Creating dropdown menu only');
                              $module = $input.closest(selector.dropdown);
                              $menu = $module.children(selector.menu);
                              if ($menu.length === 0) {
                                  $menu = $('<div />')
                                    .addClass(className.menu)
                                    .appendTo($module)
                                  ;
                              }
                              $menu.html(settings.templates.menu(selectValues));
                          }
                          else {
                              module.debug('Creating entire dropdown from select');
                              $module = $('<div />')
                                .attr('class', $input.attr('class'))
                                .addClass(className.selection)
                                .addClass(className.dropdown)
                                .html(settings.templates.dropdown(selectValues))
                                .insertBefore($input)
                              ;
                              $input
                                .removeAttr('class')
                                .prependTo($module)
                              ;
                          }
                          module.refresh();
                      },
                      reference: function () {
                          var
                            index = $allModules.index($module),
                            $firstModules,
                            $lastModules
                          ;
                          module.debug('Dropdown behavior was called on select, replacing with closest dropdown');
                          // replace module reference
                          $module = $module.parent(selector.dropdown);
                          module.refresh();
                          // adjust all modules
                          $firstModules = $allModules.slice(0, index);
                          $lastModules = $allModules.slice(index + 1);
                          $allModules = $firstModules.add($module).add($lastModules);
                          // invoke method in context of current instance
                          if (methodInvoked) {
                              instance = module;
                              module.invoke(query);
                          }
                      }
                  },

                  refresh: function () {
                      module.verbose('Refreshing selector cache');
                      $text = $module.find(selector.text);
                      $search = $module.find(selector.search);
                      $input = $module.find(selector.input);
                      $combo = ($module.prev().find(selector.text).length > 0)
                        ? $module.prev().find(selector.text)
                        : $module.prev()
                      ;
                      $menu = $module.children(selector.menu);
                      $item = $menu.find(selector.item);
                  },

                  toggle: function () {
                      module.verbose('Toggling menu visibility');
                      if (!module.is.active()) {
                          module.show();
                      }
                      else {
                          module.hide();
                      }
                  },

                  show: function (callback) {
                      callback = $.isFunction(callback)
                        ? callback
                        : function () { }
                      ;
                      if (module.is.searchSelection() && module.is.allFiltered()) {
                          return;
                      }
                      if (module.can.show() && !module.is.active()) {
                          module.debug('Showing dropdown');
                          module.animate.show(function () {
                              if (module.can.click()) {
                                  module.bind.intent();
                              }
                              module.set.visible();
                              callback.call(element);
                          });
                          settings.onShow.call(element);
                      }
                  },

                  hide: function (callback) {
                      callback = $.isFunction(callback)
                        ? callback
                        : function () { }
                      ;
                      if (module.is.active()) {
                          module.debug('Hiding dropdown');
                          module.animate.hide(function () {
                              module.remove.visible();
                              callback.call(element);
                          });
                          settings.onHide.call(element);
                      }
                  },

                  hideOthers: function () {
                      module.verbose('Finding other dropdowns to hide');
                      $allModules
                        .not($module)
                          .has(selector.menu + ':visible:not(.' + className.animating + ')')
                            .dropdown('hide')
                      ;
                  },

                  hideSubMenus: function () {
                      var
                        $subMenus = $menu.find(selector.menu)
                      ;
                      $subMenus.transition('hide');
                  },

                  bind: {
                      keyboardEvents: function () {
                          module.debug('Binding keyboard events');
                          $module
                            .on('keydown' + eventNamespace, module.event.keydown)
                          ;
                          if (module.is.searchable()) {
                              $module
                                .on(module.get.inputEvent(), selector.search, module.event.input)
                              ;
                          }
                      },
                      touchEvents: function () {
                          module.debug('Touch device detected binding additional touch events');
                          if (module.is.searchSelection()) {
                              // do nothing special yet
                          }
                          else {
                              $module
                                .on('touchstart' + eventNamespace, module.event.test.toggle)
                              ;
                          }
                          $menu
                            .on('touchstart' + eventNamespace, selector.item, module.event.item.mouseenter)
                          ;
                      },
                      mouseEvents: function () {
                          module.verbose('Mouse detected binding mouse events');
                          if (module.is.searchSelection()) {
                              $module
                                .on('mousedown' + eventNamespace, selector.menu, module.event.menu.activate)
                                .on('mouseup' + eventNamespace, selector.menu, module.event.menu.deactivate)
                                .on('click' + eventNamespace, selector.search, module.show)
                                .on('focus' + eventNamespace, selector.search, module.event.searchFocus)
                                .on('blur' + eventNamespace, selector.search, module.event.searchBlur)
                                .on('click' + eventNamespace, selector.text, module.event.searchTextFocus)
                              ;
                          }
                          else {
                              if (settings.on == 'click') {
                                  $module
                                    .on('click' + eventNamespace, module.event.test.toggle)
                                  ;
                              }
                              else if (settings.on == 'hover') {
                                  $module
                                    .on('mouseenter' + eventNamespace, module.delay.show)
                                    .on('mouseleave' + eventNamespace, module.delay.hide)
                                  ;
                              }
                              else {
                                  $module
                                    .on(settings.on + eventNamespace, module.toggle)
                                  ;
                              }
                              $module
                                .on('mousedown' + eventNamespace, module.event.mousedown)
                                .on('mouseup' + eventNamespace, module.event.mouseup)
                                .on('focus' + eventNamespace, module.event.focus)
                                .on('blur' + eventNamespace, module.event.blur)
                              ;
                          }
                          $menu
                            .on('mouseenter' + eventNamespace, selector.item, module.event.item.mouseenter)
                            .on('mouseleave' + eventNamespace, selector.item, module.event.item.mouseleave)
                            .on('click' + eventNamespace, selector.item, module.event.item.click)
                          ;
                      },
                      intent: function () {
                          module.verbose('Binding hide intent event to document');
                          if (hasTouch) {
                              $document
                                .on('touchstart' + elementNamespace, module.event.test.touch)
                                .on('touchmove' + elementNamespace, module.event.test.touch)
                              ;
                          }
                          $document
                            .on('click' + elementNamespace, module.event.test.hide)
                          ;
                      }
                  },

                  unbind: {
                      intent: function () {
                          module.verbose('Removing hide intent event from document');
                          if (hasTouch) {
                              $document
                                .off('touchstart' + elementNamespace)
                                .off('touchmove' + elementNamespace)
                              ;
                          }
                          $document
                            .off('click' + elementNamespace)
                          ;
                      }
                  },

                  filter: function (searchTerm) {
                      var
                        $results = $(),
                        escapedTerm = module.escape.regExp(searchTerm),
                        exactRegExp = new RegExp('^' + escapedTerm, 'igm'),
                        fullTextRegExp = new RegExp(escapedTerm, 'ig'),
                        allItemsFiltered
                      ;
                      module.verbose('Searching for matching values');
                      $item
                        .each(function () {
                            var
                              $choice = $(this),
                              text = String(module.get.choiceText($choice, false)),
                              value = String(module.get.choiceValue($choice, text))
                            ;
                            if (text.match(exactRegExp) || value.match(exactRegExp)) {
                                $results = $results.add($choice);
                            }
                            else if (settings.fullTextSearch) {
                                if (text.match(fullTextRegExp) || value.match(fullTextRegExp)) {
                                    $results = $results.add($choice);
                                }
                            }
                        })
                      ;

                      module.debug('Setting filter', searchTerm);
                      module.remove.filteredItem();
                      $item
                        .not($results)
                        .addClass(className.filtered)
                      ;

                      module.verbose('Selecting first non-filtered element');
                      module.remove.selectedItem();
                      $item
                        .not('.' + className.filtered)
                          .eq(0)
                          .addClass(className.selected)
                      ;
                      if (module.is.allFiltered()) {
                          module.debug('All items filtered, hiding dropdown', searchTerm);
                          if (module.is.searchSelection()) {
                              module.hide();
                          }
                          settings.onNoResults.call(element, searchTerm);
                      }
                  },

                  focusSearch: function () {
                      if (module.is.search()) {
                          $search
                            .focus()
                          ;
                      }
                  },

                  forceSelection: function () {
                      var
                        $currentlySelected = $item.not(className.filtered).filter('.' + className.selected).eq(0),
                        $activeItem = $item.filter('.' + className.active).eq(0),
                        $selectedItem = ($currentlySelected.length > 0)
                          ? $currentlySelected
                          : $activeItem,
                        hasSelected = ($selectedItem.size() > 0)
                      ;
                      if (hasSelected) {
                          module.event.item.click.call($selectedItem);
                          module.remove.filteredItem();
                      }
                      else {
                          module.hide();
                      }
                  },

                  event: {
                      // prevents focus callback from occuring on mousedown
                      mousedown: function () {
                          activated = true;
                      },
                      mouseup: function () {
                          activated = false;
                      },
                      focus: function () {
                          if (!activated && module.is.hidden()) {
                              module.show();
                          }
                      },
                      blur: function (event) {
                          var
                            pageLostFocus = (document.activeElement === this)
                          ;
                          if (!activated && !pageLostFocus) {
                              module.hide();
                          }
                      },
                      searchFocus: function () {
                          activated = true;
                          module.show();
                      },
                      searchBlur: function (event) {
                          var
                            pageLostFocus = (document.activeElement === this)
                          ;
                          if (!itemActivated && !pageLostFocus) {
                              if (settings.forceSelection) {
                                  module.forceSelection();
                              }
                              else {
                                  module.hide();
                              }
                          }
                      },
                      searchTextFocus: function (event) {
                          activated = true;
                          $search.focus();
                      },
                      input: function (event) {
                          if (module.is.searchSelection()) {
                              module.set.filtered();
                          }
                          clearTimeout(module.timer);
                          module.timer = setTimeout(module.search, settings.delay.search);
                      },
                      keydown: function (event) {
                          var
                            $currentlySelected = $item.not(className.filtered).filter('.' + className.selected).eq(0),
                            $activeItem = $menu.children('.' + className.active).eq(0),
                            $selectedItem = ($currentlySelected.length > 0)
                              ? $currentlySelected
                              : $activeItem,
                            $visibleItems = ($selectedItem.length > 0)
                              ? $selectedItem.siblings(':not(.' + className.filtered + ')').andSelf()
                              : $menu.children(':not(.' + className.filtered + ')'),
                            $subMenu = $selectedItem.children(selector.menu),
                            $parentMenu = $selectedItem.closest(selector.menu),
                            isSubMenuItem = $parentMenu[0] !== $menu[0],
                            inVisibleMenu = $parentMenu.is(':visible'),
                            pressedKey = event.which,
                            keys = {
                                enter: 13,
                                escape: 27,
                                leftArrow: 37,
                                upArrow: 38,
                                rightArrow: 39,
                                downArrow: 40
                            },
                            hasSubMenu = ($subMenu.length > 0),
                            hasSelectedItem = ($selectedItem.length > 0),
                            lastVisibleIndex = ($visibleItems.size() - 1),
                            $nextItem,
                            newIndex
                          ;
                          // visible menu keyboard shortcuts
                          if (module.is.visible()) {
                              // enter (select or sub-menu)
                              if (pressedKey == keys.enter && hasSelectedItem) {
                                  if (hasSubMenu && !settings.allowCategorySelection) {
                                      module.verbose('Pressed enter on unselectable category, opening sub menu');
                                      pressedKey = keys.rightArrow;
                                  }
                                  else {
                                      module.verbose('Enter key pressed, choosing selected item');
                                      module.event.item.click.call($selectedItem, event);
                                  }
                              }
                              // left arrow (hide sub-menu)
                              if (pressedKey == keys.leftArrow) {
                                  if (isSubMenuItem) {
                                      module.verbose('Left key pressed, closing sub-menu');
                                      module.animate.hide(false, $parentMenu);
                                      $selectedItem
                                        .removeClass(className.selected)
                                      ;
                                      $parentMenu
                                        .closest(selector.item)
                                          .addClass(className.selected)
                                      ;
                                  }
                                  event.preventDefault();
                              }
                              // right arrow (show sub-menu)
                              if (pressedKey == keys.rightArrow) {
                                  if (hasSubMenu) {
                                      module.verbose('Right key pressed, opening sub-menu');
                                      module.animate.show(false, $subMenu);
                                      $selectedItem
                                        .removeClass(className.selected)
                                      ;
                                      $subMenu
                                        .find(selector.item).eq(0)
                                          .addClass(className.selected)
                                      ;
                                  }
                                  event.preventDefault();
                              }
                              // up arrow (traverse menu up)
                              if (pressedKey == keys.upArrow) {
                                  $nextItem = (hasSelectedItem && inVisibleMenu)
                                    ? $selectedItem.prevAll(selector.item + ':not(.' + className.filtered + ')').eq(0)
                                    : $item.eq(0)
                                  ;
                                  if ($visibleItems.index($nextItem) < 0) {
                                      module.verbose('Up key pressed but reached top of current menu');
                                      return;
                                  }
                                  else {
                                      module.verbose('Up key pressed, changing active item');
                                      $selectedItem
                                        .removeClass(className.selected)
                                      ;
                                      $nextItem
                                        .addClass(className.selected)
                                      ;
                                      module.set.scrollPosition($nextItem);
                                  }
                                  event.preventDefault();
                              }
                              // down arrow (traverse menu down)
                              if (pressedKey == keys.downArrow) {
                                  $nextItem = (hasSelectedItem && inVisibleMenu)
                                    ? $nextItem = $selectedItem.nextAll(selector.item + ':not(.' + className.filtered + ')').eq(0)
                                    : $item.eq(0)
                                  ;
                                  if ($nextItem.length === 0) {
                                      module.verbose('Down key pressed but reached bottom of current menu');
                                      return;
                                  }
                                  else {
                                      module.verbose('Down key pressed, changing active item');
                                      $item
                                        .removeClass(className.selected)
                                      ;
                                      $nextItem
                                        .addClass(className.selected)
                                      ;
                                      module.set.scrollPosition($nextItem);
                                  }
                                  event.preventDefault();
                              }
                          }
                          else {
                              // enter (open menu)
                              if (pressedKey == keys.enter) {
                                  module.verbose('Enter key pressed, showing dropdown');
                                  module.show();
                              }
                              // escape (close menu)
                              if (pressedKey == keys.escape) {
                                  module.verbose('Escape key pressed, closing dropdown');
                                  module.hide();
                              }
                              // down arrow (open menu)
                              if (pressedKey == keys.downArrow) {
                                  module.verbose('Down key pressed, showing dropdown');
                                  module.show();
                              }
                          }
                      },
                      test: {
                          toggle: function (event) {
                              if (module.determine.eventInMenu(event, module.toggle)) {
                                  event.preventDefault();
                              }
                          },
                          touch: function (event) {
                              module.determine.eventInMenu(event, function () {
                                  if (event.type == 'touchstart') {
                                      module.timer = setTimeout(module.hide, settings.delay.touch);
                                  }
                                  else if (event.type == 'touchmove') {
                                      clearTimeout(module.timer);
                                  }
                              });
                              event.stopPropagation();
                          },
                          hide: function (event) {
                              module.determine.eventInModule(event, module.hide);
                          }
                      },

                      menu: {
                          activate: function () {
                              itemActivated = true;
                          },
                          deactivate: function () {
                              itemActivated = false;
                          }
                      },
                      item: {
                          mouseenter: function (event) {
                              var
                                $subMenu = $(this).children(selector.menu),
                                $otherMenus = $(this).siblings(selector.item).children(selector.menu)
                              ;
                              if ($subMenu.length > 0) {
                                  clearTimeout(module.itemTimer);
                                  module.itemTimer = setTimeout(function () {
                                      module.verbose('Showing sub-menu', $subMenu);
                                      $.each($otherMenus, function () {
                                          module.animate.hide(false, $(this));
                                      });
                                      module.animate.show(false, $subMenu);
                                  }, settings.delay.show);
                                  event.preventDefault();
                              }
                          },
                          mouseleave: function (event) {
                              var
                                $subMenu = $(this).children(selector.menu)
                              ;
                              if ($subMenu.length > 0) {
                                  clearTimeout(module.itemTimer);
                                  module.itemTimer = setTimeout(function () {
                                      module.verbose('Hiding sub-menu', $subMenu);
                                      module.animate.hide(false, $subMenu);
                                  }, settings.delay.hide);
                              }
                          },
                          click: function (event) {
                              var
                                $choice = $(this),
                                $target = (event)
                                  ? $(event.target)
                                  : $(''),
                                $subMenu = $choice.find(selector.menu),
                                text = module.get.choiceText($choice),
                                value = module.get.choiceValue($choice, text),
                                callback = function () {
                                    module.remove.searchTerm();
                                    module.determine.selectAction(text, value);
                                },
                                hasSubMenu = ($subMenu.length > 0),
                                isBubbledEvent = ($subMenu.find($target).length > 0)
                              ;
                              if (!isBubbledEvent && (!hasSubMenu || settings.allowCategorySelection)) {
                                  callback();
                              }
                          }
                      },
                      resetStyle: function () {
                          $(this).removeAttr('style');
                      }
                  },

                  determine: {
                      selectAction: function (text, value) {
                          module.verbose('Determining action', settings.action);
                          if ($.isFunction(module.action[settings.action])) {
                              module.verbose('Triggering preset action', settings.action, text, value);
                              module.action[settings.action](text, value);
                          }
                          else if ($.isFunction(settings.action)) {
                              module.verbose('Triggering user action', settings.action, text, value);
                              settings.action(text, value);
                          }
                          else {
                              module.error(error.action, settings.action);
                          }
                      },
                      eventInModule: function (event, callback) {
                          callback = $.isFunction(callback)
                            ? callback
                            : function () { }
                          ;
                          if ($(event.target).closest($module).length === 0) {
                              module.verbose('Triggering event', callback);
                              callback();
                              return true;
                          }
                          else {
                              module.verbose('Event occurred in dropdown, canceling callback');
                              return false;
                          }
                      },
                      eventInMenu: function (event, callback) {
                          callback = $.isFunction(callback)
                            ? callback
                            : function () { }
                          ;
                          if ($(event.target).closest($menu).length === 0) {
                              module.verbose('Triggering event', callback);
                              callback();
                              return true;
                          }
                          else {
                              module.verbose('Event occurred in dropdown menu, canceling callback');
                              return false;
                          }
                      }
                  },

                  action: {

                      nothing: function () { },

                      activate: function (text, value) {
                          value = (value !== undefined)
                            ? value
                            : text
                          ;
                          module.set.selected(value);
                          module.hide(function () {
                              module.remove.filteredItem();
                          });
                      },

                      select: function (text, value) {
                          value = (value !== undefined)
                            ? value
                            : text
                          ;
                          module.set.selected(value);
                          module.hide(function () {
                              module.remove.filteredItem();
                          });
                      },

                      combo: function (text, value) {
                          value = (value !== undefined)
                            ? value
                            : text
                          ;
                          module.set.selected(value);
                          module.hide(function () {
                              module.remove.filteredItem();
                          });
                      },

                      hide: function () {
                          module.hide(function () {
                              module.remove.filteredItem();
                          });
                      }

                  },

                  get: {
                      id: function () {
                          return id;
                      },
                      text: function () {
                          return $text.text();
                      },
                      value: function () {
                          return ($input.length > 0)
                            ? $input.val()
                            : $module.data(metadata.value)
                          ;
                      },
                      choiceText: function ($choice, preserveHTML) {
                          preserveHTML = (preserveHTML !== undefined)
                            ? preserveHTML
                            : settings.preserveHTML
                          ;
                          if ($choice !== undefined) {
                              if ($choice.find(selector.menu).length > 0) {
                                  module.verbose('Retreiving text of element with sub-menu');
                                  $choice = $choice.clone();
                                  $choice.find(selector.menu).remove();
                                  $choice.find(selector.menuIcon).remove();
                              }
                              return ($choice.data(metadata.text) !== undefined)
                                ? $choice.data(metadata.text)
                                : (preserveHTML)
                                  ? $choice.html().trim()
                                  : $choice.text().trim()
                              ;
                          }
                      },
                      choiceValue: function ($choice, choiceText) {
                          choiceText = choiceText || module.get.choiceText($choice);
                          return ($choice.data(metadata.value) !== undefined)
                            ? $choice.data(metadata.value)
                            : (typeof choiceText === 'string')
                              ? choiceText.toLowerCase().trim()
                              : choiceText.trim()
                          ;
                      },
                      inputEvent: function () {
                          var
                            input = $search[0]
                          ;
                          if (input) {
                              return (input.oninput !== undefined)
                                ? 'input'
                                : (input.onpropertychange !== undefined)
                                  ? 'propertychange'
                                  : 'keyup'
                              ;
                          }
                          return false;
                      },
                      selectValues: function () {
                          var
                            select = {}
                          ;
                          select.values = (settings.sortSelect)
                            ? {} // properties will be sorted in object when re-accessed
                            : [] // properties will keep original order in array
                          ;
                          $module
                            .find('option')
                              .each(function () {
                                  var
                                    name = $(this).html(),
                                    value = ($(this).attr('value') !== undefined)
                                      ? $(this).attr('value')
                                      : name
                                  ;
                                  if (value === '') {
                                      select.placeholder = name;
                                  }
                                  else {
                                      if (settings.sortSelect) {
                                          select.values[value] = {
                                              name: name,
                                              value: value
                                          };
                                      }
                                      else {
                                          select.values.push({
                                              name: name,
                                              value: value
                                          });
                                      }
                                  }
                              })
                          ;
                          if (settings.sortSelect) {
                              module.debug('Retrieved and sorted values from select', select);
                          }
                          else {
                              module.debug('Retreived values from select', select);
                          }
                          return select;
                      },
                      activeItem: function () {
                          return $item.filter('.' + className.active);
                      },
                      item: function (value, strict) {
                          var
                            $selectedItem = false
                          ;
                          value = (value !== undefined)
                            ? value
                            : (module.get.value() !== undefined)
                              ? module.get.value()
                              : module.get.text()
                          ;
                          strict = (value === '' || value === 0)
                            ? true
                            : strict || false
                          ;
                          if (value !== undefined) {
                              $item
                                .each(function () {
                                    var
                                      $choice = $(this),
                                      optionText = module.get.choiceText($choice),
                                      optionValue = module.get.choiceValue($choice, optionText)
                                    ;
                                    if (strict) {
                                        module.verbose('Ambiguous dropdown value using strict type check', $choice, value);
                                        if (optionValue === value) {
                                            $selectedItem = $(this);
                                            return true;
                                        }
                                        else if (!$selectedItem && optionText === value) {
                                            $selectedItem = $(this);
                                            return true;
                                        }
                                    }
                                    else {
                                        if (optionValue == value) {
                                            module.verbose('Found select item by value', optionValue, value);
                                            $selectedItem = $(this);
                                            return true;
                                        }
                                        else if (!$selectedItem && optionText == value) {
                                            module.verbose('Found select item by text', optionText, value);
                                            $selectedItem = $(this);
                                            return true;
                                        }
                                    }
                                })
                              ;
                          }
                          else {
                              value = module.get.text();
                          }
                          return $selectedItem || false;
                      }
                  },

                  restore: {
                      defaults: function () {
                          module.restore.defaultText();
                          module.restore.defaultValue();
                      },
                      defaultText: function () {
                          var
                            defaultText = $module.data(metadata.defaultText)
                          ;
                          module.debug('Restoring default text', defaultText);
                          module.set.text(defaultText);
                          $text.addClass(className.placeholder);
                      },
                      defaultValue: function () {
                          var
                            defaultValue = $module.data(metadata.defaultValue)
                          ;
                          if (defaultValue !== undefined) {
                              module.debug('Restoring default value', defaultValue);
                              if (defaultValue.length) {
                                  module.set.selected(defaultValue);
                              }
                              else {
                                  module.remove.activeItem();
                                  module.remove.selectedItem();
                              }
                          }
                      }
                  },

                  save: {
                      defaults: function () {
                          module.save.defaultText();
                          module.save.placeholderText();
                          module.save.defaultValue();
                      },
                      defaultValue: function () {
                          $module.data(metadata.defaultValue, module.get.value());
                      },
                      defaultText: function () {
                          $module.data(metadata.defaultText, $text.text());
                      },
                      placeholderText: function () {
                          if ($text.hasClass(className.placeholder)) {
                              $module.data(metadata.placeholderText, $text.text());
                          }
                      }
                  },

                  clear: function () {
                      var
                        placeholderText = $module.data(metadata.placeholderText)
                      ;
                      module.set.text(placeholderText);
                      module.set.value('');
                      module.remove.activeItem();
                      module.remove.selectedItem();
                      $text.addClass(className.placeholder);
                  },

                  set: {
                      filtered: function () {
                          var
                            searchValue = $search.val(),
                            hasSearchValue = (typeof searchValue === 'string' && searchValue.length > 0)
                          ;
                          if (hasSearchValue) {
                              $text.addClass(className.filtered);
                          }
                          else {
                              $text.removeClass(className.filtered);
                          }
                      },
                      tabbable: function () {
                          if (module.is.searchable()) {
                              module.debug('Searchable dropdown initialized');
                              $search
                                .val('')
                                .attr('tabindex', 0)
                              ;
                              $menu
                                .attr('tabindex', '-1')
                              ;
                          }
                          else {
                              module.debug('Simple selection dropdown initialized');
                              if (!$module.attr('tabindex')) {
                                  $module
                                    .attr('tabindex', 0)
                                  ;
                                  $menu
                                    .attr('tabindex', '-1')
                                  ;
                              }
                          }
                      },
                      scrollPosition: function ($item, forceScroll) {
                          var
                            edgeTolerance = 5,
                            hasActive,
                            offset,
                            itemHeight,
                            itemOffset,
                            menuOffset,
                            menuScroll,
                            menuHeight,
                            abovePage,
                            belowPage
                          ;

                          $item = $item || module.get.activeItem();
                          hasActive = ($item && $item.length > 0);
                          forceScroll = (forceScroll !== undefined)
                            ? forceScroll
                            : false
                          ;

                          if ($item && hasActive) {

                              if (!$menu.hasClass(className.visible)) {
                                  $menu.addClass(className.loading);
                              }

                              menuHeight = $menu.height();
                              itemHeight = $item.height();
                              menuScroll = $menu.scrollTop();
                              menuOffset = $menu.offset().top;
                              itemOffset = $item.offset().top;
                              offset = menuScroll - menuOffset + itemOffset;
                              belowPage = menuScroll + menuHeight < (offset + edgeTolerance);
                              abovePage = ((offset - edgeTolerance) < menuScroll);
                              module.debug('Scrolling to active item', offset);
                              if (abovePage || belowPage || forceScroll) {
                                  $menu
                                    .scrollTop(offset)
                                    .removeClass(className.loading)
                                  ;
                              }
                          }
                      },
                      text: function (text) {
                          if (settings.action == 'combo') {
                              module.debug('Changing combo button text', text, $combo);
                              if (settings.preserveHTML) {
                                  $combo.html(text);
                              }
                              else {
                                  $combo.text(text);
                              }
                          }
                          else if (settings.action !== 'select') {
                              module.debug('Changing text', text, $text);
                              $text
                                .removeClass(className.filtered)
                                .removeClass(className.placeholder)
                              ;
                              if (settings.preserveHTML) {
                                  $text.html(text);
                              }
                              else {
                                  $text.text(text);
                              }
                          }
                      },
                      value: function (value) {
                          module.debug('Adding selected value to hidden input', value, $input);
                          if ($input.length > 0) {
                              $input
                                .val(value)
                                .trigger('change')
                              ;
                          }
                          else {
                              $module.data(metadata.value, value);
                          }
                      },
                      active: function () {
                          $module
                            .addClass(className.active)
                          ;
                      },
                      visible: function () {
                          $module.addClass(className.visible);
                      },
                      selected: function (value) {
                          var
                            $selectedItem = module.get.item(value),
                            selectedText,
                            selectedValue
                          ;
                          if ($selectedItem && !$selectedItem.hasClass(className.active)) {
                              module.debug('Setting selected menu item to', $selectedItem);
                              module.remove.activeItem();
                              module.remove.selectedItem();
                              $selectedItem
                                .addClass(className.active)
                                .addClass(className.selected)
                              ;
                              selectedText = module.get.choiceText($selectedItem);
                              selectedValue = module.get.choiceValue($selectedItem, selectedText);
                              module.set.text(selectedText);
                              module.set.value(selectedValue);
                              settings.onChange.call(element, value, selectedText, $selectedItem);
                          }
                      }
                  },

                  remove: {
                      active: function () {
                          $module.removeClass(className.active);
                      },
                      visible: function () {
                          $module.removeClass(className.visible);
                      },
                      activeItem: function () {
                          $item.removeClass(className.active);
                      },
                      filteredItem: function () {
                          $item.removeClass(className.filtered);
                      },
                      searchTerm: function () {
                          $search.val('');
                      },
                      selectedItem: function () {
                          $item.removeClass(className.selected);
                      },
                      tabbable: function () {
                          if (module.is.searchable()) {
                              module.debug('Searchable dropdown initialized');
                              $search
                                .attr('tabindex', '-1')
                              ;
                              $menu
                                .attr('tabindex', '-1')
                              ;
                          }
                          else {
                              module.debug('Simple selection dropdown initialized');
                              $module
                                .attr('tabindex', '-1')
                              ;
                              $menu
                                .attr('tabindex', '-1')
                              ;
                          }
                      }
                  },

                  is: {
                      active: function () {
                          return $module.hasClass(className.active);
                      },
                      alreadySetup: function () {
                          return ($module.is('select') && $module.parent(selector.dropdown).length > 0);
                      },
                      animating: function ($subMenu) {
                          return ($subMenu)
                            ? $subMenu.is(':animated') || $subMenu.transition && $subMenu.transition('is animating')
                            : $menu.is(':animated') || $menu.transition && $menu.transition('is animating')
                          ;
                      },
                      allFiltered: function () {
                          return ($item.filter('.' + className.filtered).length === $item.length);
                      },
                      hidden: function ($subMenu) {
                          return ($subMenu)
                            ? $subMenu.is(':hidden')
                            : $menu.is(':hidden')
                          ;
                      },
                      selectMutation: function (mutations) {
                          var
                            selectChanged = false
                          ;
                          $.each(mutations, function (index, mutation) {
                              if (mutation.target && $(mutation.target).is('select')) {
                                  selectChanged = true;
                                  return true;
                              }
                          });
                          return selectChanged;
                      },
                      search: function () {
                          return $module.hasClass(className.search);
                      },
                      searchable: function () {
                          return ($search.length > 0);
                      },
                      searchSelection: function () {
                          return (module.is.searchable() && $search.parent().is($module));
                      },
                      selection: function () {
                          return $module.hasClass(className.selection);
                      },
                      upward: function () {
                          return $module.hasClass(className.upward);
                      },
                      visible: function ($subMenu) {
                          return ($subMenu)
                            ? $subMenu.is(':visible')
                            : $menu.is(':visible')
                          ;
                      }
                  },

                  can: {
                      click: function () {
                          return (hasTouch || settings.on == 'click');
                      },
                      show: function () {
                          return !$module.hasClass(className.disabled);
                      }
                  },

                  animate: {
                      show: function (callback, $subMenu) {
                          var
                            $currentMenu = $subMenu || $menu,
                            start = ($subMenu)
                              ? function () { }
                              : function () {
                                  module.hideSubMenus();
                                  module.hideOthers();
                                  module.set.active();
                              }
                          ;
                          callback = $.isFunction(callback)
                            ? callback
                            : function () { }
                          ;
                          module.set.scrollPosition(module.get.activeItem(), true);
                          module.verbose('Doing menu show animation', $currentMenu);
                          if (module.is.hidden($currentMenu) || module.is.animating($currentMenu)) {

                              if (settings.transition == 'auto') {
                                  settings.transition = module.is.upward()
                                    ? 'slide up'
                                    : 'slide down'
                                  ;
                                  module.verbose('Automatically determining animation based on animation direction', settings.transition);
                              }
                              if (settings.transition == 'none') {
                                  callback.call(element);
                              }
                              else if ($.fn.transition !== undefined && $module.transition('is supported')) {
                                  $currentMenu
                                    .transition({
                                        animation: settings.transition + ' in',
                                        debug: settings.debug,
                                        verbose: settings.verbose,
                                        duration: settings.duration,
                                        queue: true,
                                        onStart: start,
                                        onComplete: function () {
                                            callback.call(element);
                                        }
                                    })
                                  ;
                              }
                              else if (settings.transition == 'slide down') {
                                  start();
                                  $currentMenu
                                    .hide()
                                    .clearQueue()
                                    .children()
                                      .clearQueue()
                                      .css('opacity', 0)
                                      .delay(50)
                                      .animate({
                                          opacity: 1
                                      }, settings.duration, 'easeOutQuad', module.event.resetStyle)
                                      .end()
                                    .slideDown(100, 'easeOutQuad', function () {
                                        module.event.resetStyle.call(this);
                                        callback.call(element);
                                    })
                                  ;
                              }
                              else if (settings.transition == 'fade') {
                                  start();
                                  $currentMenu
                                    .hide()
                                    .clearQueue()
                                    .fadeIn(settings.duration, function () {
                                        module.event.resetStyle.call(this);
                                        callback.call(element);
                                    })
                                  ;
                              }
                              else {
                                  module.error(error.transition, settings.transition);
                              }
                          }
                      },
                      hide: function (callback, $subMenu) {
                          var
                            $currentMenu = $subMenu || $menu,
                            duration = ($subMenu)
                              ? (settings.duration * 0.9)
                              : settings.duration,
                            start = ($subMenu)
                              ? function () { }
                              : function () {
                                  if (module.can.click()) {
                                      module.unbind.intent();
                                  }
                                  module.focusSearch();
                                  module.remove.active();
                              }
                          ;
                          callback = $.isFunction(callback)
                            ? callback
                            : function () { }
                          ;
                          if (module.is.visible($currentMenu) || module.is.animating($currentMenu)) {
                              module.verbose('Doing menu hide animation', $currentMenu);

                              if (settings.transition == 'auto') {
                                  settings.transition = module.is.upward()
                                    ? 'slide up'
                                    : 'slide down'
                                  ;
                              }

                              $input.trigger('blur');

                              if (settings.transition == 'none') {
                                  callback.call(element);
                              }
                              else if ($.fn.transition !== undefined && $module.transition('is supported')) {
                                  $currentMenu
                                    .transition({
                                        animation: settings.transition + ' out',
                                        duration: settings.duration,
                                        debug: settings.debug,
                                        verbose: settings.verbose,
                                        queue: true,
                                        onStart: start,
                                        onComplete: function () {
                                            callback.call(element);
                                        }
                                    })
                                  ;
                              }
                              else if (settings.transition == 'slide down') {
                                  start();
                                  $currentMenu
                                    .show()
                                    .clearQueue()
                                    .children()
                                      .clearQueue()
                                      .css('opacity', 1)
                                      .animate({
                                          opacity: 0
                                      }, 100, 'easeOutQuad', module.event.resetStyle)
                                      .end()
                                    .delay(50)
                                    .slideUp(100, 'easeOutQuad', function () {
                                        module.event.resetStyle.call(this);
                                        callback.call(element);
                                    })
                                  ;
                              }
                              else if (settings.transition == 'fade') {
                                  start();
                                  $currentMenu
                                    .show()
                                    .clearQueue()
                                    .fadeOut(150, function () {
                                        module.event.resetStyle.call(this);
                                        callback.call(element);
                                    })
                                  ;
                              }
                              else {
                                  module.error(error.transition);
                              }
                          }
                      }
                  },

                  delay: {
                      show: function () {
                          module.verbose('Delaying show event to ensure user intent');
                          clearTimeout(module.timer);
                          module.timer = setTimeout(module.show, settings.delay.show);
                      },
                      hide: function () {
                          module.verbose('Delaying hide event to ensure user intent');
                          clearTimeout(module.timer);
                          module.timer = setTimeout(module.hide, settings.delay.hide);
                      }
                  },

                  escape: {
                      regExp: function (text) {
                          text = String(text);
                          return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
                      }
                  },

                  setting: function (name, value) {
                      module.debug('Changing setting', name, value);
                      if ($.isPlainObject(name)) {
                          $.extend(true, settings, name);
                      }
                      else if (value !== undefined) {
                          settings[name] = value;
                      }
                      else {
                          return settings[name];
                      }
                  },
                  internal: function (name, value) {
                      if ($.isPlainObject(name)) {
                          $.extend(true, module, name);
                      }
                      else if (value !== undefined) {
                          module[name] = value;
                      }
                      else {
                          return module[name];
                      }
                  },
                  debug: function () {
                      if (settings.debug) {
                          if (settings.performance) {
                              module.performance.log(arguments);
                          }
                          else {
                              module.debug = Function.prototype.bind.call(console.info, console, settings.name + ':');
                              module.debug.apply(console, arguments);
                          }
                      }
                  },
                  verbose: function () {
                      if (settings.verbose && settings.debug) {
                          if (settings.performance) {
                              module.performance.log(arguments);
                          }
                          else {
                              module.verbose = Function.prototype.bind.call(console.info, console, settings.name + ':');
                              module.verbose.apply(console, arguments);
                          }
                      }
                  },
                  error: function () {
                      module.error = Function.prototype.bind.call(console.error, console, settings.name + ':');
                      module.error.apply(console, arguments);
                  },
                  performance: {
                      log: function (message) {
                          var
                            currentTime,
                            executionTime,
                            previousTime
                          ;
                          if (settings.performance) {
                              currentTime = new Date().getTime();
                              previousTime = time || currentTime;
                              executionTime = currentTime - previousTime;
                              time = currentTime;
                              performance.push({
                                  'Name': message[0],
                                  'Arguments': [].slice.call(message, 1) || '',
                                  'Element': element,
                                  'Execution Time': executionTime
                              });
                          }
                          clearTimeout(module.performance.timer);
                          module.performance.timer = setTimeout(module.performance.display, 500);
                      },
                      display: function () {
                          var
                            title = settings.name + ':',
                            totalTime = 0
                          ;
                          time = false;
                          clearTimeout(module.performance.timer);
                          $.each(performance, function (index, data) {
                              totalTime += data['Execution Time'];
                          });
                          title += ' ' + totalTime + 'ms';
                          if (moduleSelector) {
                              title += ' \'' + moduleSelector + '\'';
                          }
                          if ((console.group !== undefined || console.table !== undefined) && performance.length > 0) {
                              console.groupCollapsed(title);
                              if (console.table) {
                                  console.table(performance);
                              }
                              else {
                                  $.each(performance, function (index, data) {
                                      console.log(data['Name'] + ': ' + data['Execution Time'] + 'ms');
                                  });
                              }
                              console.groupEnd();
                          }
                          performance = [];
                      }
                  },
                  invoke: function (query, passedArguments, context) {
                      var
                        object = instance,
                        maxDepth,
                        found,
                        response
                      ;
                      passedArguments = passedArguments || queryArguments;
                      context = element || context;
                      if (typeof query == 'string' && object !== undefined) {
                          query = query.split(/[\. ]/);
                          maxDepth = query.length - 1;
                          $.each(query, function (depth, value) {
                              var camelCaseValue = (depth != maxDepth)
                                ? value + query[depth + 1].charAt(0).toUpperCase() + query[depth + 1].slice(1)
                                : query
                              ;
                              if ($.isPlainObject(object[camelCaseValue]) && (depth != maxDepth)) {
                                  object = object[camelCaseValue];
                              }
                              else if (object[camelCaseValue] !== undefined) {
                                  found = object[camelCaseValue];
                                  return false;
                              }
                              else if ($.isPlainObject(object[value]) && (depth != maxDepth)) {
                                  object = object[value];
                              }
                              else if (object[value] !== undefined) {
                                  found = object[value];
                                  return false;
                              }
                              else {
                                  module.error(error.method, query);
                                  return false;
                              }
                          });
                      }
                      if ($.isFunction(found)) {
                          response = found.apply(context, passedArguments);
                      }
                      else if (found !== undefined) {
                          response = found;
                      }
                      if ($.isArray(returnedValue)) {
                          returnedValue.push(response);
                      }
                      else if (returnedValue !== undefined) {
                          returnedValue = [returnedValue, response];
                      }
                      else if (response !== undefined) {
                          returnedValue = response;
                      }
                      return found;
                  }
              };

              if (methodInvoked) {
                  if (instance === undefined) {
                      module.initialize();
                  }
                  module.invoke(query);
              }
              else {
                  if (instance !== undefined) {
                      instance.invoke('destroy');
                  }
                  module.initialize();
              }
          })
        ;
        return (returnedValue !== undefined)
          ? returnedValue
          : $allModules
        ;
    };

    $.fn.dropdown.settings = {

        debug: false,
        verbose: true,
        performance: true,

        on: 'click',
        action: 'activate',

        allowTab: true,
        fullTextSearch: false,
        preserveHTML: true,
        sortSelect: false,

        allowCategorySelection: false,

        delay: {
            hide: 300,
            show: 200,
            search: 50,
            touch: 50
        },

        forceSelection: true,

        transition: 'auto',
        duration: 250,

        /* Callbacks */
        onNoResults: function (searchTerm) { },
        onChange: function (value, text) { },
        onShow: function () { },
        onHide: function () { },

        /* Component */

        name: 'Dropdown',
        namespace: 'dropdown',

        error: {
            action: 'You called a dropdown action that was not defined',
            alreadySetup: 'Once a select has been initialized behaviors must be called on the created ui dropdown',
            method: 'The method you called is not defined.',
            transition: 'The requested transition was not found'
        },

        metadata: {
            defaultText: 'defaultText',
            defaultValue: 'defaultValue',
            placeholderText: 'placeholderText',
            text: 'text',
            value: 'value'
        },

        selector: {
            dropdown: '.ui.dropdown',
            input: '> input[type="hidden"], > select',
            item: '.item',
            menu: '.menu',
            menuIcon: '.dropdown.icon',
            search: '> input.search, .menu > .search > input, .menu > input.search',
            text: '> .text:not(.icon)'
        },

        className: {
            active: 'active',
            animating: 'animating',
            disabled: 'disabled',
            dropdown: 'ui dropdown',
            filtered: 'filtered',
            loading: 'loading',
            menu: 'menu',
            placeholder: 'default',
            search: 'search',
            selected: 'selected',
            selection: 'selection',
            upward: 'upward',
            visible: 'visible'
        }

    };

    /* Templates */
    $.fn.dropdown.settings.templates = {
        menu: function (select) {
            var
              placeholder = select.placeholder || false,
              values = select.values || {},
              html = ''
            ;
            $.each(select.values, function (index, option) {
                html += '<div class="item" data-value="' + option.value + '">' + option.name + '</div>';
            });
            return html;
        },
        dropdown: function (select) {
            var
              placeholder = select.placeholder || false,
              values = select.values || {},
              html = ''
            ;
            html += '<i class="dropdown icon"></i>';
            if (select.placeholder) {
                html += '<div class="default text">' + placeholder + '</div>';
            }
            else {
                html += '<div class="text"></div>';
            }
            html += '<div class="menu">';
            $.each(select.values, function (index, option) {
                html += '<div class="item" data-value="' + option.value + '">' + option.name + '</div>';
            });
            html += '</div>';
            return html;
        }
    };


    /* Dependencies */
    $.extend($.easing, {
        easeOutQuad: function (x, t, b, c, d) {
            return -c * (t /= d) * (t - 2) + b;
        },
    });


})(jQuery, window, document);

/*!
 * # Semantic UI 1.12.1 - Modal
 * http://github.com/semantic-org/semantic-ui/
 *
 *
 * Copyright 2014 Contributors
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 *
 */

; (function ($, window, document, undefined) {

    "use strict";

    $.fn.modal = function (parameters) {
        var
          $allModules = $(this),
          $window = $(window),
          $document = $(document),
          $body = $('body'),

          moduleSelector = $allModules.selector || '',

          time = new Date().getTime(),
          performance = [],

          query = arguments[0],
          methodInvoked = (typeof query == 'string'),
          queryArguments = [].slice.call(arguments, 1),

          requestAnimationFrame = window.requestAnimationFrame
            || window.mozRequestAnimationFrame
            || window.webkitRequestAnimationFrame
            || window.msRequestAnimationFrame
            || function (callback) { setTimeout(callback, 0); },

          returnedValue
        ;

        $allModules
          .each(function () {
              var
                settings = ($.isPlainObject(parameters))
                  ? $.extend(true, {}, $.fn.modal.settings, parameters)
                  : $.extend({}, $.fn.modal.settings),

                selector = settings.selector,
                className = settings.className,
                namespace = settings.namespace,
                error = settings.error,

                eventNamespace = '.' + namespace,
                moduleNamespace = 'module-' + namespace,

                $module = $(this),
                $context = $(settings.context),
                $close = $module.find(selector.close),

                $allModals,
                $otherModals,
                $focusedElement,
                $dimmable,
                $dimmer,

                element = this,
                instance = $module.data(moduleNamespace),

                elementNamespace,
                id,
                observer,
                module
              ;
              module = {

                  initialize: function () {
                      module.verbose('Initializing dimmer', $context);

                      module.create.id();
                      module.create.dimmer();
                      module.refreshModals();

                      module.verbose('Attaching close events', $close);
                      module.bind.events();
                      module.observeChanges();
                      module.instantiate();
                  },

                  instantiate: function () {
                      module.verbose('Storing instance of modal');
                      instance = module;
                      $module
                        .data(moduleNamespace, instance)
                      ;
                  },

                  create: {
                      dimmer: function () {
                          var
                            defaultSettings = {
                                debug: settings.debug,
                                dimmerName: 'modals',
                                duration: {
                                    show: settings.duration,
                                    hide: settings.duration
                                }
                            },
                            dimmerSettings = $.extend(true, defaultSettings, settings.dimmerSettings)
                          ;
                          if ($.fn.dimmer === undefined) {
                              module.error(error.dimmer);
                              return;
                          }
                          module.debug('Creating dimmer with settings', dimmerSettings);
                          $dimmable = $context.dimmer(dimmerSettings);
                          if (settings.detachable) {
                              module.verbose('Modal is detachable, moving content into dimmer');
                              $dimmable.dimmer('add content', $module);
                          }
                          $dimmer = $dimmable.dimmer('get dimmer');
                      },
                      id: function () {
                          id = (Math.random().toString(16) + '000000000').substr(2, 8);
                          elementNamespace = '.' + id;
                          module.verbose('Creating unique id for element', id);
                      }
                  },

                  destroy: function () {
                      module.verbose('Destroying previous modal');
                      $module
                        .removeData(moduleNamespace)
                        .off(eventNamespace)
                      ;
                      $window.off(elementNamespace);
                      $close.off(eventNamespace);
                      $context.dimmer('destroy');
                  },

                  observeChanges: function () {
                      if ('MutationObserver' in window) {
                          observer = new MutationObserver(function (mutations) {
                              module.debug('DOM tree modified, refreshing');
                              module.refresh();
                          });
                          observer.observe(element, {
                              childList: true,
                              subtree: true
                          });
                          module.debug('Setting up mutation observer', observer);
                      }
                  },

                  refresh: function () {
                      module.remove.scrolling();
                      module.cacheSizes();
                      module.set.screenHeight();
                      module.set.type();
                      module.set.position();
                  },

                  refreshModals: function () {
                      $otherModals = $module.siblings(selector.modal);
                      $allModals = $otherModals.add($module);
                  },

                  attachEvents: function (selector, event) {
                      var
                        $toggle = $(selector)
                      ;
                      event = $.isFunction(module[event])
                        ? module[event]
                        : module.toggle
                      ;
                      if ($toggle.length > 0) {
                          module.debug('Attaching modal events to element', selector, event);
                          $toggle
                            .off(eventNamespace)
                            .on('click' + eventNamespace, event)
                          ;
                      }
                      else {
                          module.error(error.notFound, selector);
                      }
                  },

                  bind: {
                      events: function () {
                          $close.on('click' + eventNamespace, module.event.close);
                          $window.on('resize' + elementNamespace, module.event.resize);
                      }
                  },

                  get: {
                      id: function () {
                          return (Math.random().toString(16) + '000000000').substr(2, 8);
                      }
                  },

                  event: {
                      close: function () {
                          module.verbose('Closing element pressed');
                          if ($(this).is(selector.approve)) {
                              if (settings.onApprove.call(element) !== false) {
                                  module.hide();
                              }
                              else {
                                  module.verbose('Approve callback returned false cancelling hide');
                              }
                          }
                          else if ($(this).is(selector.deny)) {
                              if (settings.onDeny.call(element) !== false) {
                                  module.hide();
                              }
                              else {
                                  module.verbose('Deny callback returned false cancelling hide');
                              }
                          }
                          else {
                              module.hide();
                          }
                      },
                      click: function (event) {
                          if ($(event.target).closest($module).length === 0) {
                              module.debug('Dimmer clicked, hiding all modals');
                              if (module.is.active()) {
                                  module.remove.clickaway();
                                  if (settings.allowMultiple) {
                                      module.hide();
                                  }
                                  else {
                                      module.hideAll();
                                  }
                              }
                          }
                      },
                      debounce: function (method, delay) {
                          clearTimeout(module.timer);
                          module.timer = setTimeout(method, delay);
                      },
                      keyboard: function (event) {
                          var
                            keyCode = event.which,
                            escapeKey = 27
                          ;
                          if (keyCode == escapeKey) {
                              if (settings.closable) {
                                  module.debug('Escape key pressed hiding modal');
                                  module.hide();
                              }
                              else {
                                  module.debug('Escape key pressed, but closable is set to false');
                              }
                              event.preventDefault();
                          }
                      },
                      resize: function () {
                          if ($dimmable.dimmer('is active')) {
                              requestAnimationFrame(module.refresh);
                          }
                      }
                  },

                  toggle: function () {
                      if (module.is.active() || module.is.animating()) {
                          module.hide();
                      }
                      else {
                          module.show();
                      }
                  },

                  show: function (callback) {
                      callback = $.isFunction(callback)
                        ? callback
                        : function () { }
                      ;
                      module.refreshModals();
                      module.showModal(callback);
                  },

                  hide: function (callback) {
                      callback = $.isFunction(callback)
                        ? callback
                        : function () { }
                      ;
                      module.refreshModals();
                      module.hideModal(callback);
                  },

                  showModal: function (callback) {
                      callback = $.isFunction(callback)
                        ? callback
                        : function () { }
                      ;
                      if (module.is.animating() || !module.is.active()) {

                          module.showDimmer();
                          module.cacheSizes();
                          module.set.position();
                          module.set.screenHeight();
                          module.set.type();
                          module.set.clickaway();

                          if (!settings.allowMultiple && $otherModals.filter('.' + className.active).length > 0) {
                              module.debug('Other modals visible, queueing show animation');
                              module.hideOthers(module.showModal);
                          }
                          else {
                              settings.onShow.call(element);
                              if (settings.transition && $.fn.transition !== undefined && $module.transition('is supported')) {
                                  module.debug('Showing modal with css animations');
                                  $module
                                    .transition({
                                        debug: settings.debug,
                                        animation: settings.transition + ' in',
                                        queue: settings.queue,
                                        duration: settings.duration,
                                        useFailSafe: true,
                                        onComplete: function () {
                                            settings.onVisible.apply(element);
                                            module.add.keyboardShortcuts();
                                            module.save.focus();
                                            module.set.active();
                                            module.set.autofocus();
                                            callback();
                                        }
                                    })
                                  ;
                              }
                              else {
                                  module.debug('Showing modal with javascript');
                                  $module
                                    .fadeIn(settings.duration, settings.easing, function () {
                                        settings.onVisible.apply(element);
                                        module.add.keyboardShortcuts();
                                        module.save.focus();
                                        module.set.active();
                                        callback();
                                    })
                                  ;
                              }
                          }
                      }
                      else {
                          module.debug('Modal is already visible');
                      }
                  },

                  hideModal: function (callback, keepDimmed) {
                      callback = $.isFunction(callback)
                        ? callback
                        : function () { }
                      ;
                      module.debug('Hiding modal');
                      settings.onHide.call(element);

                      if (module.is.animating() || module.is.active()) {
                          if (settings.transition && $.fn.transition !== undefined && $module.transition('is supported')) {
                              module.remove.active();
                              $module
                                .transition({
                                    debug: settings.debug,
                                    animation: settings.transition + ' out',
                                    queue: settings.queue,
                                    duration: settings.duration,
                                    useFailSafe: true,
                                    onStart: function () {
                                        if (!module.othersActive() && !keepDimmed) {
                                            module.hideDimmer();
                                        }
                                        module.remove.keyboardShortcuts();
                                    },
                                    onComplete: function () {
                                        settings.onHidden.call(element);
                                        module.restore.focus();
                                        callback();
                                    }
                                })
                              ;
                          }
                          else {
                              module.remove.active();
                              if (!module.othersActive()) {
                                  module.hideDimmer();
                              }
                              module.remove.keyboardShortcuts();
                              $module
                                .fadeOut(settings.duration, settings.easing, function () {
                                    settings.onHidden.call(element);
                                    module.restore.focus();
                                    callback();
                                })
                              ;
                          }
                      }
                  },

                  showDimmer: function () {
                      if ($dimmable.dimmer('is animating') || !$dimmable.dimmer('is active')) {
                          module.debug('Showing dimmer');
                          $dimmable.dimmer('show');
                      }
                      else {
                          module.debug('Dimmer already visible');
                      }
                  },

                  hideDimmer: function () {
                      if ($dimmable.dimmer('is animating') || ($dimmable.dimmer('is active'))) {
                          $dimmable.dimmer('hide', function () {
                              if (settings.transition && $.fn.transition !== undefined && $module.transition('is supported')) {
                                  module.remove.clickaway();
                                  module.remove.screenHeight();
                              }
                          });
                      }
                      else {
                          module.debug('Dimmer is not visible cannot hide');
                          return;
                      }
                  },

                  hideAll: function (callback) {
                      var
                        $visibleModals = $allModals.filter(':visible')
                      ;
                      callback = $.isFunction(callback)
                        ? callback
                        : function () { }
                      ;
                      if ($visibleModals.length > 0) {
                          module.debug('Hiding all visible modals');
                          module.hideDimmer();
                          $visibleModals
                            .modal('hide modal', callback)
                          ;
                      }
                  },

                  hideOthers: function (callback) {
                      var
                        $visibleModals = $otherModals.filter(':visible')
                      ;
                      callback = $.isFunction(callback)
                        ? callback
                        : function () { }
                      ;
                      if ($visibleModals.length > 0) {
                          module.debug('Hiding other modals', $otherModals);
                          $visibleModals
                            .modal('hide modal', callback, true)
                          ;
                      }
                  },

                  othersActive: function () {
                      return ($otherModals.filter('.' + className.active).length > 0);
                  },

                  add: {
                      keyboardShortcuts: function () {
                          module.verbose('Adding keyboard shortcuts');
                          $document
                            .on('keyup' + eventNamespace, module.event.keyboard)
                          ;
                      }
                  },

                  save: {
                      focus: function () {
                          $focusedElement = $(document.activeElement).blur();
                      }
                  },

                  restore: {
                      focus: function () {
                          if ($focusedElement && $focusedElement.length > 0) {
                              $focusedElement.focus();
                          }
                      }
                  },

                  remove: {
                      active: function () {
                          $module.removeClass(className.active);
                      },
                      clickaway: function () {
                          if (settings.closable) {
                              $dimmer
                                .off('click' + elementNamespace)
                              ;
                          }
                      },
                      screenHeight: function () {
                          if (module.cache.height > module.cache.pageHeight) {
                              module.debug('Removing page height');
                              $body
                                .css('height', '')
                              ;
                          }
                      },
                      keyboardShortcuts: function () {
                          module.verbose('Removing keyboard shortcuts');
                          $document
                            .off('keyup' + eventNamespace)
                          ;
                      },
                      scrolling: function () {
                          $dimmable.removeClass(className.scrolling);
                          $module.removeClass(className.scrolling);
                      }
                  },

                  cacheSizes: function () {
                      var
                        modalHeight = $module.outerHeight()
                      ;
                      if (module.cache === undefined || modalHeight !== 0) {
                          module.cache = {
                              pageHeight: $(document).outerHeight(),
                              height: modalHeight + settings.offset,
                              contextHeight: (settings.context == 'body')
                                ? $(window).height()
                                : $dimmable.height()
                          };
                      }
                      module.debug('Caching modal and container sizes', module.cache);
                  },

                  can: {
                      fit: function () {
                          return ((module.cache.height + (settings.padding * 2)) < module.cache.contextHeight);
                      }
                  },

                  is: {
                      active: function () {
                          return $module.hasClass(className.active);
                      },
                      animating: function () {
                          return $module.transition('is supported')
                            ? $module.transition('is animating')
                            : $module.is(':visible')
                          ;
                      },
                      scrolling: function () {
                          return $dimmable.hasClass(className.scrolling);
                      },
                      modernBrowser: function () {
                          // appName for IE11 reports 'Netscape' can no longer use
                          return !(window.ActiveXObject || "ActiveXObject" in window);
                      }
                  },

                  set: {
                      autofocus: function () {
                          if (settings.autofocus) {
                              var
                                $inputs = $module.find(':input:visible'),
                                $autofocus = $inputs.filter('[autofocus]'),
                                $input = ($autofocus.length > 0)
                                  ? $autofocus
                                  : $inputs
                              ;
                              $input.first().focus();
                          }
                      },
                      clickaway: function () {
                          if (settings.closable) {
                              $dimmer
                                .on('click' + elementNamespace, module.event.click)
                              ;
                          }
                      },
                      screenHeight: function () {
                          if (module.can.fit()) {
                              $body.css('height', '');
                          }
                          else {
                              module.debug('Modal is taller than page content, resizing page height');
                              $body
                                .css('height', module.cache.height + (settings.padding / 2))
                              ;
                          }
                      },
                      active: function () {
                          $module.addClass(className.active);
                      },
                      scrolling: function () {
                          $dimmable.addClass(className.scrolling);
                          $module.addClass(className.scrolling);
                      },
                      type: function () {
                          if (module.can.fit()) {
                              module.verbose('Modal fits on screen');
                              if (!module.othersActive) {
                                  module.remove.scrolling();
                              }
                          }
                          else {
                              module.verbose('Modal cannot fit on screen setting to scrolling');
                              module.set.scrolling();
                          }
                      },
                      position: function () {
                          module.verbose('Centering modal on page', module.cache);
                          if (module.can.fit()) {
                              $module
                                .css({
                                    top: '',
                                    marginTop: -(module.cache.height / 2)
                                })
                              ;
                          }
                          else {
                              $module
                                .css({
                                    marginTop: '',
                                    top: $document.scrollTop()
                                })
                              ;
                          }
                      }
                  },

                  setting: function (name, value) {
                      module.debug('Changing setting', name, value);
                      if ($.isPlainObject(name)) {
                          $.extend(true, settings, name);
                      }
                      else if (value !== undefined) {
                          settings[name] = value;
                      }
                      else {
                          return settings[name];
                      }
                  },
                  internal: function (name, value) {
                      if ($.isPlainObject(name)) {
                          $.extend(true, module, name);
                      }
                      else if (value !== undefined) {
                          module[name] = value;
                      }
                      else {
                          return module[name];
                      }
                  },
                  debug: function () {
                      if (settings.debug) {
                          if (settings.performance) {
                              module.performance.log(arguments);
                          }
                          else {
                              module.debug = Function.prototype.bind.call(console.info, console, settings.name + ':');
                              module.debug.apply(console, arguments);
                          }
                      }
                  },
                  verbose: function () {
                      if (settings.verbose && settings.debug) {
                          if (settings.performance) {
                              module.performance.log(arguments);
                          }
                          else {
                              module.verbose = Function.prototype.bind.call(console.info, console, settings.name + ':');
                              module.verbose.apply(console, arguments);
                          }
                      }
                  },
                  error: function () {
                      module.error = Function.prototype.bind.call(console.error, console, settings.name + ':');
                      module.error.apply(console, arguments);
                  },
                  performance: {
                      log: function (message) {
                          var
                            currentTime,
                            executionTime,
                            previousTime
                          ;
                          if (settings.performance) {
                              currentTime = new Date().getTime();
                              previousTime = time || currentTime;
                              executionTime = currentTime - previousTime;
                              time = currentTime;
                              performance.push({
                                  'Name': message[0],
                                  'Arguments': [].slice.call(message, 1) || '',
                                  'Element': element,
                                  'Execution Time': executionTime
                              });
                          }
                          clearTimeout(module.performance.timer);
                          module.performance.timer = setTimeout(module.performance.display, 100);
                      },
                      display: function () {
                          var
                            title = settings.name + ':',
                            totalTime = 0
                          ;
                          time = false;
                          clearTimeout(module.performance.timer);
                          $.each(performance, function (index, data) {
                              totalTime += data['Execution Time'];
                          });
                          title += ' ' + totalTime + 'ms';
                          if (moduleSelector) {
                              title += ' \'' + moduleSelector + '\'';
                          }
                          if ((console.group !== undefined || console.table !== undefined) && performance.length > 0) {
                              console.groupCollapsed(title);
                              if (console.table) {
                                  console.table(performance);
                              }
                              else {
                                  $.each(performance, function (index, data) {
                                      console.log(data['Name'] + ': ' + data['Execution Time'] + 'ms');
                                  });
                              }
                              console.groupEnd();
                          }
                          performance = [];
                      }
                  },
                  invoke: function (query, passedArguments, context) {
                      var
                        object = instance,
                        maxDepth,
                        found,
                        response
                      ;
                      passedArguments = passedArguments || queryArguments;
                      context = element || context;
                      if (typeof query == 'string' && object !== undefined) {
                          query = query.split(/[\. ]/);
                          maxDepth = query.length - 1;
                          $.each(query, function (depth, value) {
                              var camelCaseValue = (depth != maxDepth)
                                ? value + query[depth + 1].charAt(0).toUpperCase() + query[depth + 1].slice(1)
                                : query
                              ;
                              if ($.isPlainObject(object[camelCaseValue]) && (depth != maxDepth)) {
                                  object = object[camelCaseValue];
                              }
                              else if (object[camelCaseValue] !== undefined) {
                                  found = object[camelCaseValue];
                                  return false;
                              }
                              else if ($.isPlainObject(object[value]) && (depth != maxDepth)) {
                                  object = object[value];
                              }
                              else if (object[value] !== undefined) {
                                  found = object[value];
                                  return false;
                              }
                              else {
                                  return false;
                              }
                          });
                      }
                      if ($.isFunction(found)) {
                          response = found.apply(context, passedArguments);
                      }
                      else if (found !== undefined) {
                          response = found;
                      }
                      if ($.isArray(returnedValue)) {
                          returnedValue.push(response);
                      }
                      else if (returnedValue !== undefined) {
                          returnedValue = [returnedValue, response];
                      }
                      else if (response !== undefined) {
                          returnedValue = response;
                      }
                      return found;
                  }
              };

              if (methodInvoked) {
                  if (instance === undefined) {
                      module.initialize();
                  }
                  module.invoke(query);
              }
              else {
                  if (instance !== undefined) {
                      instance.invoke('destroy');
                  }
                  module.initialize();
              }
          })
        ;

        return (returnedValue !== undefined)
          ? returnedValue
          : this
        ;
    };

    $.fn.modal.settings = {

        name: 'Modal',
        namespace: 'modal',

        debug: false,
        verbose: true,
        performance: true,

        allowMultiple: false,
        detachable: true,
        closable: true,
        autofocus: true,

        dimmerSettings: {
            closable: false,
            useCSS: true
        },

        context: 'body',

        queue: false,
        duration: 500,
        easing: 'easeOutExpo',
        offset: 0,
        transition: 'scale',

        padding: 50,

        onShow: function () { },
        onHide: function () { },

        onVisible: function () { },
        onHidden: function () { },

        onApprove: function () { return true; },
        onDeny: function () { return true; },

        selector: {
            close: '.close, .actions .button',
            approve: '.actions .positive, .actions .approve, .actions .ok',
            deny: '.actions .negative, .actions .deny, .actions .cancel',
            modal: '.ui.modal'
        },
        error: {
            dimmer: 'UI Dimmer, a required component is not included in this page',
            method: 'The method you called is not defined.',
            notFound: 'The element you specified could not be found'
        },
        className: {
            active: 'active',
            animating: 'animating',
            scrolling: 'scrolling'
        }
    };


})(jQuery, window, document);

/*!
 * # Semantic UI 1.12.1 - Nag
 * http://github.com/semantic-org/semantic-ui/
 *
 *
 * Copyright 2014 Contributors
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 *
 */

; (function ($, window, document, undefined) {

    "use strict";

    $.fn.nag = function (parameters) {
        var
          $allModules = $(this),
          moduleSelector = $allModules.selector || '',

          time = new Date().getTime(),
          performance = [],

          query = arguments[0],
          methodInvoked = (typeof query == 'string'),
          queryArguments = [].slice.call(arguments, 1),
          returnedValue
        ;
        $allModules
          .each(function () {
              var
                settings = ($.isPlainObject(parameters))
                  ? $.extend(true, {}, $.fn.nag.settings, parameters)
                  : $.extend({}, $.fn.nag.settings),

                className = settings.className,
                selector = settings.selector,
                error = settings.error,
                namespace = settings.namespace,

                eventNamespace = '.' + namespace,
                moduleNamespace = namespace + '-module',

                $module = $(this),

                $close = $module.find(selector.close),
                $context = (settings.context)
                  ? $(settings.context)
                  : $('body'),

                element = this,
                instance = $module.data(moduleNamespace),

                moduleOffset,
                moduleHeight,

                contextWidth,
                contextHeight,
                contextOffset,

                yOffset,
                yPosition,

                timer,
                module,

                requestAnimationFrame = window.requestAnimationFrame
                  || window.mozRequestAnimationFrame
                  || window.webkitRequestAnimationFrame
                  || window.msRequestAnimationFrame
                  || function (callback) { setTimeout(callback, 0); }
              ;
              module = {

                  initialize: function () {
                      module.verbose('Initializing element');

                      $module
                        .data(moduleNamespace, module)
                      ;
                      $close
                        .on('click' + eventNamespace, module.dismiss)
                      ;

                      if (settings.detachable && $module.parent()[0] !== $context[0]) {
                          $module
                            .detach()
                            .prependTo($context)
                          ;
                      }

                      if (settings.displayTime > 0) {
                          setTimeout(module.hide, settings.displayTime);
                      }
                      module.show();
                  },

                  destroy: function () {
                      module.verbose('Destroying instance');
                      $module
                        .removeData(moduleNamespace)
                        .off(eventNamespace)
                      ;
                  },

                  show: function () {
                      if (module.should.show() && !$module.is(':visible')) {
                          module.debug('Showing nag', settings.animation.show);
                          if (settings.animation.show == 'fade') {
                              $module
                                .fadeIn(settings.duration, settings.easing)
                              ;
                          }
                          else {
                              $module
                                .slideDown(settings.duration, settings.easing)
                              ;
                          }
                      }
                  },

                  hide: function () {
                      module.debug('Showing nag', settings.animation.hide);
                      if (settings.animation.show == 'fade') {
                          $module
                            .fadeIn(settings.duration, settings.easing)
                          ;
                      }
                      else {
                          $module
                            .slideUp(settings.duration, settings.easing)
                          ;
                      }
                  },

                  onHide: function () {
                      module.debug('Removing nag', settings.animation.hide);
                      $module.remove();
                      if (settings.onHide) {
                          settings.onHide();
                      }
                  },

                  dismiss: function (event) {
                      if (settings.storageMethod) {
                          module.storage.set(settings.key, settings.value);
                      }
                      module.hide();
                      event.stopImmediatePropagation();
                      event.preventDefault();
                  },

                  should: {
                      show: function () {
                          if (settings.persist) {
                              module.debug('Persistent nag is set, can show nag');
                              return true;
                          }
                          if (module.storage.get(settings.key) != settings.value.toString()) {
                              module.debug('Stored value is not set, can show nag', module.storage.get(settings.key));
                              return true;
                          }
                          module.debug('Stored value is set, cannot show nag', module.storage.get(settings.key));
                          return false;
                      }
                  },

                  get: {
                      storageOptions: function () {
                          var
                            options = {}
                          ;
                          if (settings.expires) {
                              options.expires = settings.expires;
                          }
                          if (settings.domain) {
                              options.domain = settings.domain;
                          }
                          if (settings.path) {
                              options.path = settings.path;
                          }
                          return options;
                      }
                  },

                  clear: function () {
                      module.storage.remove(settings.key);
                  },

                  storage: {
                      set: function (key, value) {
                          var
                            options = module.get.storageOptions()
                          ;
                          if (settings.storageMethod == 'localstorage' && window.localStorage !== undefined) {
                              window.localStorage.setItem(key, value);
                              module.debug('Value stored using local storage', key, value);
                          }
                          else if ($.cookie !== undefined) {
                              $.cookie(key, value, options);
                              module.debug('Value stored using cookie', key, value, options);
                          }
                          else {
                              module.error(error.noCookieStorage);
                              return;
                          }
                      },
                      get: function (key, value) {
                          var
                            storedValue
                          ;
                          if (settings.storageMethod == 'localstorage' && window.localStorage !== undefined) {
                              storedValue = window.localStorage.getItem(key);
                          }
                              // get by cookie
                          else if ($.cookie !== undefined) {
                              storedValue = $.cookie(key);
                          }
                          else {
                              module.error(error.noCookieStorage);
                          }
                          if (storedValue == 'undefined' || storedValue == 'null' || storedValue === undefined || storedValue === null) {
                              storedValue = undefined;
                          }
                          return storedValue;
                      },
                      remove: function (key) {
                          var
                            options = module.get.storageOptions()
                          ;
                          if (settings.storageMethod == 'local' && window.store !== undefined) {
                              window.localStorage.removeItem(key);
                          }
                              // store by cookie
                          else if ($.cookie !== undefined) {
                              $.removeCookie(key, options);
                          }
                          else {
                              module.error(error.noStorage);
                          }
                      }
                  },

                  setting: function (name, value) {
                      module.debug('Changing setting', name, value);
                      if ($.isPlainObject(name)) {
                          $.extend(true, settings, name);
                      }
                      else if (value !== undefined) {
                          settings[name] = value;
                      }
                      else {
                          return settings[name];
                      }
                  },
                  internal: function (name, value) {
                      if ($.isPlainObject(name)) {
                          $.extend(true, module, name);
                      }
                      else if (value !== undefined) {
                          module[name] = value;
                      }
                      else {
                          return module[name];
                      }
                  },
                  debug: function () {
                      if (settings.debug) {
                          if (settings.performance) {
                              module.performance.log(arguments);
                          }
                          else {
                              module.debug = Function.prototype.bind.call(console.info, console, settings.name + ':');
                              module.debug.apply(console, arguments);
                          }
                      }
                  },
                  verbose: function () {
                      if (settings.verbose && settings.debug) {
                          if (settings.performance) {
                              module.performance.log(arguments);
                          }
                          else {
                              module.verbose = Function.prototype.bind.call(console.info, console, settings.name + ':');
                              module.verbose.apply(console, arguments);
                          }
                      }
                  },
                  error: function () {
                      module.error = Function.prototype.bind.call(console.error, console, settings.name + ':');
                      module.error.apply(console, arguments);
                  },
                  performance: {
                      log: function (message) {
                          var
                            currentTime,
                            executionTime,
                            previousTime
                          ;
                          if (settings.performance) {
                              currentTime = new Date().getTime();
                              previousTime = time || currentTime;
                              executionTime = currentTime - previousTime;
                              time = currentTime;
                              performance.push({
                                  'Name': message[0],
                                  'Arguments': [].slice.call(message, 1) || '',
                                  'Element': element,
                                  'Execution Time': executionTime
                              });
                          }
                          clearTimeout(module.performance.timer);
                          module.performance.timer = setTimeout(module.performance.display, 100);
                      },
                      display: function () {
                          var
                            title = settings.name + ':',
                            totalTime = 0
                          ;
                          time = false;
                          clearTimeout(module.performance.timer);
                          $.each(performance, function (index, data) {
                              totalTime += data['Execution Time'];
                          });
                          title += ' ' + totalTime + 'ms';
                          if (moduleSelector) {
                              title += ' \'' + moduleSelector + '\'';
                          }
                          if ((console.group !== undefined || console.table !== undefined) && performance.length > 0) {
                              console.groupCollapsed(title);
                              if (console.table) {
                                  console.table(performance);
                              }
                              else {
                                  $.each(performance, function (index, data) {
                                      console.log(data['Name'] + ': ' + data['Execution Time'] + 'ms');
                                  });
                              }
                              console.groupEnd();
                          }
                          performance = [];
                      }
                  },
                  invoke: function (query, passedArguments, context) {
                      var
                        object = instance,
                        maxDepth,
                        found,
                        response
                      ;
                      passedArguments = passedArguments || queryArguments;
                      context = element || context;
                      if (typeof query == 'string' && object !== undefined) {
                          query = query.split(/[\. ]/);
                          maxDepth = query.length - 1;
                          $.each(query, function (depth, value) {
                              var camelCaseValue = (depth != maxDepth)
                                ? value + query[depth + 1].charAt(0).toUpperCase() + query[depth + 1].slice(1)
                                : query
                              ;
                              if ($.isPlainObject(object[camelCaseValue]) && (depth != maxDepth)) {
                                  object = object[camelCaseValue];
                              }
                              else if (object[camelCaseValue] !== undefined) {
                                  found = object[camelCaseValue];
                                  return false;
                              }
                              else if ($.isPlainObject(object[value]) && (depth != maxDepth)) {
                                  object = object[value];
                              }
                              else if (object[value] !== undefined) {
                                  found = object[value];
                                  return false;
                              }
                              else {
                                  module.error(error.method, query);
                                  return false;
                              }
                          });
                      }
                      if ($.isFunction(found)) {
                          response = found.apply(context, passedArguments);
                      }
                      else if (found !== undefined) {
                          response = found;
                      }
                      if ($.isArray(returnedValue)) {
                          returnedValue.push(response);
                      }
                      else if (returnedValue !== undefined) {
                          returnedValue = [returnedValue, response];
                      }
                      else if (response !== undefined) {
                          returnedValue = response;
                      }
                      return found;
                  }
              };

              if (methodInvoked) {
                  if (instance === undefined) {
                      module.initialize();
                  }
                  module.invoke(query);
              }
              else {
                  if (instance !== undefined) {
                      instance.invoke('destroy');
                  }
                  module.initialize();
              }
          })
        ;

        return (returnedValue !== undefined)
          ? returnedValue
          : this
        ;
    };

    $.fn.nag.settings = {

        name: 'Nag',

        debug: false,
        verbose: true,
        performance: true,

        namespace: 'Nag',

        // allows cookie to be overriden
        persist: false,

        // set to zero to require manually dismissal, otherwise hides on its own
        displayTime: 0,

        animation: {
            show: 'slide',
            hide: 'slide'
        },

        context: false,
        detachable: false,

        expires: 30,
        domain: false,
        path: '/',

        // type of storage to use
        storageMethod: 'cookie',

        // value to store in dismissed localstorage/cookie
        key: 'nag',
        value: 'dismiss',

        error: {
            noStorage: 'Neither $.cookie or store is defined. A storage solution is required for storing state',
            method: 'The method you called is not defined.'
        },

        className: {
            bottom: 'bottom',
            fixed: 'fixed'
        },

        selector: {
            close: '.close.icon'
        },

        speed: 500,
        easing: 'easeOutQuad',

        onHide: function () { }

    };

})(jQuery, window, document);

/*!
 * # Semantic UI 1.12.1 - Popup
 * http://github.com/semantic-org/semantic-ui/
 *
 *
 * Copyright 2014 Contributors
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 *
 */

; (function ($, window, document, undefined) {

    "use strict";

    $.fn.popup = function (parameters) {
        var
          $allModules = $(this),
          $document = $(document),

          moduleSelector = $allModules.selector || '',

          hasTouch = ('ontouchstart' in document.documentElement),
          time = new Date().getTime(),
          performance = [],

          query = arguments[0],
          methodInvoked = (typeof query == 'string'),
          queryArguments = [].slice.call(arguments, 1),

          returnedValue
        ;
        $allModules
          .each(function () {
              var
                settings = ($.isPlainObject(parameters))
                  ? $.extend(true, {}, $.fn.popup.settings, parameters)
                  : $.extend({}, $.fn.popup.settings),

                selector = settings.selector,
                className = settings.className,
                error = settings.error,
                metadata = settings.metadata,
                namespace = settings.namespace,

                eventNamespace = '.' + settings.namespace,
                moduleNamespace = 'module-' + namespace,

                $module = $(this),
                $context = $(settings.context),
                $target = (settings.target)
                  ? $(settings.target)
                  : $module,

                $window = $(window),
                $body = $('body'),
                $popup,
                $offsetParent,

                searchDepth = 0,
                triedPositions = false,

                element = this,
                instance = $module.data(moduleNamespace),

                elementNamespace,
                id,
                module
              ;

              module = {

                  // binds events
                  initialize: function () {
                      module.debug('Initializing', $module);
                      module.createID();
                      module.bind.events();
                      if (!module.exists() && settings.preserve) {
                          module.create();
                      }
                      module.instantiate();
                  },

                  instantiate: function () {
                      module.verbose('Storing instance', module);
                      instance = module;
                      $module
                        .data(moduleNamespace, instance)
                      ;
                  },

                  refresh: function () {
                      if (settings.popup) {
                          $popup = $(settings.popup).eq(0);
                      }
                      else {
                          if (settings.inline) {
                              $popup = $target.next(selector.popup).eq(0);
                          }
                      }
                      if (settings.popup) {
                          $popup.addClass(className.loading);
                          $offsetParent = module.get.offsetParent();
                          $popup.removeClass(className.loading);
                          if (settings.movePopup && module.has.popup() && module.get.offsetParent($popup)[0] !== $offsetParent[0]) {
                              module.debug('Moving popup to the same offset parent as activating element');
                              $popup
                                .detach()
                                .appendTo($offsetParent)
                              ;
                          }
                      }
                      else {
                          $offsetParent = (settings.inline)
                            ? module.get.offsetParent($target)
                            : module.has.popup()
                              ? module.get.offsetParent($popup)
                              : $body
                          ;
                      }
                      if ($offsetParent.is('html')) {
                          module.debug('Setting page as offset parent');
                          $offsetParent = $body;
                      }
                  },

                  reposition: function () {
                      module.refresh();
                      module.set.position();
                  },

                  destroy: function () {
                      module.debug('Destroying previous module');
                      // remove element only if was created dynamically
                      if ($popup && !settings.preserve) {
                          module.removePopup();
                      }
                      // clear all timeouts
                      clearTimeout(module.hideTimer);
                      clearTimeout(module.showTimer);
                      // remove events
                      $window.off(elementNamespace);
                      $module
                        .off(eventNamespace)
                        .removeData(moduleNamespace)
                      ;
                  },

                  event: {
                      start: function (event) {
                          var
                            delay = ($.isPlainObject(settings.delay))
                              ? settings.delay.show
                              : settings.delay
                          ;
                          clearTimeout(module.hideTimer);
                          module.showTimer = setTimeout(function () {
                              if (module.is.hidden() && !(module.is.active() && module.is.dropdown())) {
                                  module.show();
                              }
                          }, delay);
                      },
                      end: function () {
                          var
                            delay = ($.isPlainObject(settings.delay))
                              ? settings.delay.hide
                              : settings.delay
                          ;
                          clearTimeout(module.showTimer);
                          module.hideTimer = setTimeout(function () {
                              if (module.is.visible()) {
                                  module.hide();
                              }
                          }, delay);
                      },
                      resize: function () {
                          if (module.is.visible()) {
                              module.set.position();
                          }
                      }
                  },

                  // generates popup html from metadata
                  create: function () {
                      var
                        html = $module.data(metadata.html) || settings.html,
                        variation = $module.data(metadata.variation) || settings.variation,
                        title = $module.data(metadata.title) || settings.title,
                        content = $module.data(metadata.content) || $module.attr('title') || settings.content
                      ;
                      if (html || content || title) {
                          module.debug('Creating pop-up html');
                          if (!html) {
                              html = settings.templates.popup({
                                  title: title,
                                  content: content
                              });
                          }
                          $popup = $('<div/>')
                            .addClass(className.popup)
                            .addClass(variation)
                            .data(metadata.activator, $module)
                            .html(html)
                          ;
                          if (variation) {
                              $popup
                                .addClass(variation)
                              ;
                          }
                          if (settings.inline) {
                              module.verbose('Inserting popup element inline', $popup);
                              $popup
                                .insertAfter($module)
                              ;
                          }
                          else {
                              module.verbose('Appending popup element to body', $popup);
                              $popup
                                .appendTo($context)
                              ;
                          }
                          module.refresh();
                          if (settings.hoverable) {
                              module.bind.popup();
                          }
                          settings.onCreate.call($popup, element);
                      }
                      else if ($target.next(selector.popup).length !== 0) {
                          module.verbose('Pre-existing popup found');
                          settings.inline = true;
                          settings.popup = $target.next(selector.popup).data(metadata.activator, $module);
                          module.refresh();
                          if (settings.hoverable) {
                              module.bind.popup();
                          }
                      }
                      else if (settings.popup) {
                          settings.popup.data(metadata.activator, $module);
                          module.verbose('Used popup specified in settings');
                          module.refresh();
                          if (settings.hoverable) {
                              module.bind.popup();
                          }
                      }
                      else {
                          module.debug('No content specified skipping display', element);
                      }
                  },

                  createID: function () {
                      id = (Math.random().toString(16) + '000000000').substr(2, 8);
                      elementNamespace = '.' + id;
                      module.verbose('Creating unique id for element', id);
                  },

                  // determines popup state
                  toggle: function () {
                      module.debug('Toggling pop-up');
                      if (module.is.hidden()) {
                          module.debug('Popup is hidden, showing pop-up');
                          module.unbind.close();
                          module.show();
                      }
                      else {
                          module.debug('Popup is visible, hiding pop-up');
                          module.hide();
                      }
                  },

                  show: function (callback) {
                      callback = $.isFunction(callback) ? callback : function () { };
                      module.debug('Showing pop-up', settings.transition);
                      if (!module.exists()) {
                          module.create();
                      }
                      else if (!settings.preserve && !settings.popup) {
                          module.refresh();
                      }
                      if ($popup && module.set.position()) {
                          module.save.conditions();
                          if (settings.exclusive) {
                              module.hideAll();
                          }
                          module.animate.show(callback);
                      }
                  },


                  hide: function (callback) {
                      callback = $.isFunction(callback) ? callback : function () { };
                      module.remove.visible();
                      module.unbind.close();
                      if (module.is.visible()) {
                          module.restore.conditions();
                          module.animate.hide(callback);
                      }
                  },

                  hideAll: function () {
                      $(selector.popup)
                        .filter('.' + className.visible)
                        .each(function () {
                            $(this)
                              .data(metadata.activator)
                              .popup('hide')
                            ;
                        })
                      ;
                  },

                  hideGracefully: function (event) {
                      // don't close on clicks inside popup
                      if (event && $(event.target).closest(selector.popup).length === 0) {
                          module.debug('Click occurred outside popup hiding popup');
                          module.hide();
                      }
                      else {
                          module.debug('Click was inside popup, keeping popup open');
                      }
                  },

                  exists: function () {
                      if (!$popup) {
                          return false;
                      }
                      if (settings.inline || settings.popup) {
                          return (module.has.popup());
                      }
                      else {
                          return ($popup.closest($context).length >= 1)
                            ? true
                            : false
                          ;
                      }
                  },

                  removePopup: function () {
                      module.debug('Removing popup', $popup);
                      if (module.has.popup() && !settings.popup) {
                          $popup.remove();
                          $popup = undefined;
                      }
                      settings.onRemove.call($popup, element);
                  },

                  save: {
                      conditions: function () {
                          module.cache = {
                              title: $module.attr('title')
                          };
                          if (module.cache.title) {
                              $module.removeAttr('title');
                          }
                          module.verbose('Saving original attributes', module.cache.title);
                      }
                  },
                  restore: {
                      conditions: function () {
                          if (module.cache && module.cache.title) {
                              $module.attr('title', module.cache.title);
                              module.verbose('Restoring original attributes', module.cache.title);
                          }
                          return true;
                      }
                  },
                  animate: {
                      show: function (callback) {
                          callback = $.isFunction(callback) ? callback : function () { };
                          if (settings.transition && $.fn.transition !== undefined && $module.transition('is supported')) {
                              module.set.visible();
                              $popup
                                .transition({
                                    animation: settings.transition + ' in',
                                    queue: false,
                                    debug: settings.debug,
                                    verbose: settings.verbose,
                                    duration: settings.duration,
                                    onComplete: function () {
                                        module.bind.close();
                                        callback.call($popup, element);
                                        settings.onVisible.call($popup, element);
                                    }
                                })
                              ;
                          }
                          else {
                              module.set.visible();
                              $popup
                                .stop()
                                .fadeIn(settings.duration, settings.easing, function () {
                                    module.bind.close();
                                    callback.call($popup, element);
                                    settings.onVisible.call($popup, element);
                                })
                              ;
                          }
                          settings.onShow.call($popup, element);
                      },
                      hide: function (callback) {
                          callback = $.isFunction(callback) ? callback : function () { };
                          module.debug('Hiding pop-up');
                          if (settings.transition && $.fn.transition !== undefined && $module.transition('is supported')) {
                              $popup
                                .transition({
                                    animation: settings.transition + ' out',
                                    queue: false,
                                    duration: settings.duration,
                                    debug: settings.debug,
                                    verbose: settings.verbose,
                                    onComplete: function () {
                                        module.reset();
                                        callback.call($popup, element);
                                        settings.onHidden.call($popup, element);
                                    }
                                })
                              ;
                          }
                          else {
                              $popup
                                .stop()
                                .fadeOut(settings.duration, settings.easing, function () {
                                    module.reset();
                                    callback.call($popup, element);
                                    settings.onHidden.call($popup, element);
                                })
                              ;
                          }
                          settings.onHide.call($popup, element);
                      }
                  },

                  get: {
                      id: function () {
                          return id;
                      },
                      startEvent: function () {
                          if (settings.on == 'hover') {
                              return (hasTouch)
                                ? 'touchstart mouseenter'
                                : 'mouseenter'
                              ;
                          }
                          else if (settings.on == 'focus') {
                              return 'focus';
                          }
                          return false;
                      },
                      scrollEvent: function () {
                          return (hasTouch)
                            ? 'touchmove scroll'
                            : 'scroll'
                          ;
                      },
                      endEvent: function () {
                          if (settings.on == 'hover') {
                              return 'mouseleave';
                          }
                          else if (settings.on == 'focus') {
                              return 'blur';
                          }
                          return false;
                      },
                      offsetParent: function ($target) {
                          var
                            element = ($target !== undefined)
                              ? $target[0]
                              : $module[0],
                            parentNode = element.parentNode,
                            $node = $(parentNode)
                          ;
                          if (parentNode) {
                              var
                                is2D = ($node.css('transform') === 'none'),
                                isStatic = ($node.css('position') === 'static'),
                                isHTML = $node.is('html')
                              ;
                              while (parentNode && !isHTML && isStatic && is2D) {
                                  parentNode = parentNode.parentNode;
                                  $node = $(parentNode);
                                  is2D = ($node.css('transform') === 'none');
                                  isStatic = ($node.css('position') === 'static');
                                  isHTML = $node.is('html');
                              }
                          }
                          return ($node && $node.length > 0)
                            ? $node
                            : $()
                          ;
                      },
                      offstagePosition: function (position) {
                          var
                            boundary = {
                                top: $(window).scrollTop(),
                                bottom: $(window).scrollTop() + $(window).height(),
                                left: 0,
                                right: $(window).width()
                            },
                            popup = {
                                width: $popup.width(),
                                height: $popup.height(),
                                offset: $popup.offset()
                            },
                            offstage = {},
                            offstagePositions = []
                          ;
                          position = position || false;
                          if (popup.offset && position) {
                              module.verbose('Checking if outside viewable area', popup.offset);
                              offstage = {
                                  top: (popup.offset.top < boundary.top),
                                  bottom: (popup.offset.top + popup.height > boundary.bottom),
                                  right: (popup.offset.left + popup.width > boundary.right),
                                  left: (popup.offset.left < boundary.left)
                              };
                          }
                          // return only boundaries that have been surpassed
                          $.each(offstage, function (direction, isOffstage) {
                              if (isOffstage) {
                                  offstagePositions.push(direction);
                              }
                          });
                          return (offstagePositions.length > 0)
                            ? offstagePositions.join(' ')
                            : false
                          ;
                      },
                      positions: function () {
                          return {
                              'top left': false,
                              'top center': false,
                              'top right': false,
                              'bottom left': false,
                              'bottom center': false,
                              'bottom right': false,
                              'left center': false,
                              'right center': false
                          };
                      },
                      nextPosition: function (position) {
                          var
                            positions = position.split(' '),
                            verticalPosition = positions[0],
                            horizontalPosition = positions[1],
                            opposite = {
                                top: 'bottom',
                                bottom: 'top',
                                left: 'right',
                                right: 'left'
                            },
                            adjacent = {
                                left: 'center',
                                center: 'right',
                                right: 'left'
                            },
                            backup = {
                                'top left': 'top center',
                                'top center': 'top right',
                                'top right': 'right center',
                                'right center': 'bottom right',
                                'bottom right': 'bottom center',
                                'bottom center': 'bottom left',
                                'bottom left': 'left center',
                                'left center': 'top left'
                            },
                            adjacentsAvailable = (verticalPosition == 'top' || verticalPosition == 'bottom'),
                            oppositeTried = false,
                            adjacentTried = false,
                            nextPosition = false
                          ;
                          if (!triedPositions) {
                              module.verbose('All available positions available');
                              triedPositions = module.get.positions();
                          }

                          module.debug('Recording last position tried', position);
                          triedPositions[position] = true;

                          if (settings.prefer === 'opposite') {
                              nextPosition = [opposite[verticalPosition], horizontalPosition];
                              nextPosition = nextPosition.join(' ');
                              oppositeTried = (triedPositions[nextPosition] === true);
                              module.debug('Trying opposite strategy', nextPosition);
                          }
                          if ((settings.prefer === 'adjacent') && adjacentsAvailable) {
                              nextPosition = [verticalPosition, adjacent[horizontalPosition]];
                              nextPosition = nextPosition.join(' ');
                              adjacentTried = (triedPositions[nextPosition] === true);
                              module.debug('Trying adjacent strategy', nextPosition);
                          }
                          if (adjacentTried || oppositeTried) {
                              module.debug('Using backup position', nextPosition);
                              nextPosition = backup[position];
                          }
                          return nextPosition;
                      }
                  },

                  set: {
                      position: function (position, arrowOffset) {
                          var
                            windowWidth = $(window).width(),
                            windowHeight = $(window).height(),

                            targetWidth = $target.outerWidth(),
                            targetHeight = $target.outerHeight(),

                            popupWidth = $popup.outerWidth(),
                            popupHeight = $popup.outerHeight(),

                            parentWidth = $offsetParent.outerWidth(),
                            parentHeight = $offsetParent.outerHeight(),

                            distanceAway = settings.distanceAway,

                            targetElement = $target[0],

                            marginTop = (settings.inline)
                              ? parseInt(window.getComputedStyle(targetElement).getPropertyValue('margin-top'), 10)
                              : 0,
                            marginLeft = (settings.inline)
                              ? parseInt(window.getComputedStyle(targetElement).getPropertyValue(module.is.rtl() ? 'margin-right' : 'margin-left'), 10)
                              : 0,

                            target = (settings.inline || settings.popup)
                              ? $target.position()
                              : $target.offset(),

                            computedPosition,
                            positioning,
                            offstagePosition
                          ;
                          position = position || $module.data(metadata.position) || settings.position;
                          arrowOffset = arrowOffset || $module.data(metadata.offset) || settings.offset;

                          if (searchDepth == settings.maxSearchDepth && settings.lastResort) {
                              module.debug('Using last resort position to display', settings.lastResort);
                              position = settings.lastResort;
                          }

                          if (settings.inline) {
                              module.debug('Adding targets margin to calculation');
                              if (position == 'left center' || position == 'right center') {
                                  arrowOffset += marginTop;
                                  distanceAway += -marginLeft;
                              }
                              else if (position == 'top left' || position == 'top center' || position == 'top right') {
                                  arrowOffset += marginLeft;
                                  distanceAway -= marginTop;
                              }
                              else {
                                  arrowOffset += marginLeft;
                                  distanceAway += marginTop;
                              }
                          }
                          module.debug('Calculating popup positioning', position);

                          computedPosition = position;
                          if (module.is.rtl()) {
                              computedPosition = computedPosition.replace(/left|right/g, function (match) {
                                  return (match == 'left')
                                    ? 'right'
                                    : 'left'
                                  ;
                              });
                              module.debug('RTL: Popup positioning updated', computedPosition);
                          }
                          switch (computedPosition) {
                              case 'top left':
                                  positioning = {
                                      top: 'auto',
                                      bottom: parentHeight - target.top + distanceAway,
                                      left: target.left + arrowOffset,
                                      right: 'auto'
                                  };
                                  break;
                              case 'top center':
                                  positioning = {
                                      bottom: parentHeight - target.top + distanceAway,
                                      left: target.left + (targetWidth / 2) - (popupWidth / 2) + arrowOffset,
                                      top: 'auto',
                                      right: 'auto'
                                  };
                                  break;
                              case 'top right':
                                  positioning = {
                                      bottom: parentHeight - target.top + distanceAway,
                                      right: parentWidth - target.left - targetWidth - arrowOffset,
                                      top: 'auto',
                                      left: 'auto'
                                  };
                                  break;
                              case 'left center':
                                  positioning = {
                                      top: target.top + (targetHeight / 2) - (popupHeight / 2) + arrowOffset,
                                      right: parentWidth - target.left + distanceAway,
                                      left: 'auto',
                                      bottom: 'auto'
                                  };
                                  break;
                              case 'right center':
                                  positioning = {
                                      top: target.top + (targetHeight / 2) - (popupHeight / 2) + arrowOffset,
                                      left: target.left + targetWidth + distanceAway,
                                      bottom: 'auto',
                                      right: 'auto'
                                  };
                                  break;
                              case 'bottom left':
                                  positioning = {
                                      top: target.top + targetHeight + distanceAway,
                                      left: target.left + arrowOffset,
                                      bottom: 'auto',
                                      right: 'auto'
                                  };
                                  break;
                              case 'bottom center':
                                  positioning = {
                                      top: target.top + targetHeight + distanceAway,
                                      left: target.left + (targetWidth / 2) - (popupWidth / 2) + arrowOffset,
                                      bottom: 'auto',
                                      right: 'auto'
                                  };
                                  break;
                              case 'bottom right':
                                  positioning = {
                                      top: target.top + targetHeight + distanceAway,
                                      right: parentWidth - target.left - targetWidth - arrowOffset,
                                      left: 'auto',
                                      bottom: 'auto'
                                  };
                                  break;
                          }
                          if (positioning === undefined) {
                              module.error(error.invalidPosition, position);
                          }

                          module.debug('Calculated popup positioning values', positioning);

                          // tentatively place on stage
                          $popup
                            .css(positioning)
                            .removeClass(className.position)
                            .addClass(position)
                            .addClass(className.loading)
                          ;
                          // check if is offstage
                          offstagePosition = module.get.offstagePosition(position);

                          // recursively find new positioning
                          if (offstagePosition) {
                              module.debug('Popup cant fit into viewport', offstagePosition);
                              if (searchDepth < settings.maxSearchDepth) {
                                  searchDepth++;
                                  position = module.get.nextPosition(position);
                                  module.debug('Trying new position', position);
                                  return ($popup)
                                    ? module.set.position(position)
                                    : false
                                  ;
                              }
                              else if (!settings.lastResort) {
                                  module.debug('Popup could not find a position in view', $popup);
                                  // module.error(error.cannotPlace, element);
                                  module.remove.attempts();
                                  module.remove.loading();
                                  module.reset();
                                  return false;
                              }
                          }

                          module.debug('Position is on stage', position);
                          module.remove.attempts();
                          module.set.fluidWidth();
                          module.remove.loading();
                          return true;
                      },

                      fluidWidth: function () {
                          if (settings.setFluidWidth && $popup.hasClass(className.fluid)) {
                              $popup.css('width', $offsetParent.width());
                          }
                      },

                      visible: function () {
                          $module.addClass(className.visible);
                      }
                  },

                  remove: {
                      loading: function () {
                          $popup.removeClass(className.loading);
                      },
                      visible: function () {
                          $module.removeClass(className.visible);
                      },
                      attempts: function () {
                          module.verbose('Resetting all searched positions');
                          searchDepth = 0;
                          triedPositions = false;
                      }
                  },

                  bind: {
                      events: function () {
                          module.debug('Binding popup events to module');
                          if (settings.on == 'click') {
                              $module
                                .on('click' + eventNamespace, module.toggle)
                              ;
                          }
                          else if (module.get.startEvent()) {
                              $module
                                .on(module.get.startEvent() + eventNamespace, module.event.start)
                                .on(module.get.endEvent() + eventNamespace, module.event.end)
                              ;
                          }
                          if (settings.target) {
                              module.debug('Target set to element', $target);
                          }
                          $window.on('resize' + elementNamespace, module.event.resize);
                      },
                      popup: function () {
                          module.verbose('Allowing hover events on popup to prevent closing');
                          if ($popup && module.has.popup()) {
                              $popup
                                .on('mouseenter' + eventNamespace, module.event.start)
                                .on('mouseleave' + eventNamespace, module.event.end)
                              ;
                          }
                      },
                      close: function () {
                          if (settings.hideOnScroll === true || settings.hideOnScroll == 'auto' && settings.on != 'click') {
                              $document
                                .one(module.get.scrollEvent() + elementNamespace, module.hideGracefully)
                              ;
                              $context
                                .one(module.get.scrollEvent() + elementNamespace, module.hideGracefully)
                              ;
                          }
                          if (settings.on == 'click' && settings.closable) {
                              module.verbose('Binding popup close event to document');
                              $document
                                .on('click' + elementNamespace, function (event) {
                                    module.verbose('Pop-up clickaway intent detected');
                                    module.hideGracefully.call(element, event);
                                })
                              ;
                          }
                      }
                  },

                  unbind: {
                      close: function () {
                          if (settings.hideOnScroll === true || settings.hideOnScroll == 'auto' && settings.on != 'click') {
                              $document
                                .off('scroll' + elementNamespace, module.hide)
                              ;
                              $context
                                .off('scroll' + elementNamespace, module.hide)
                              ;
                          }
                          if (settings.on == 'click' && settings.closable) {
                              module.verbose('Removing close event from document');
                              $document
                                .off('click' + elementNamespace)
                              ;
                          }
                      }
                  },

                  has: {
                      popup: function () {
                          return ($popup && $popup.length > 0);
                      }
                  },

                  is: {
                      active: function () {
                          return $module.hasClass(className.active);
                      },
                      animating: function () {
                          return ($popup && $popup.is(':animated') || $popup.hasClass(className.animating));
                      },
                      visible: function () {
                          return $popup && $popup.is(':visible');
                      },
                      dropdown: function () {
                          return $module.hasClass(className.dropdown);
                      },
                      hidden: function () {
                          return !module.is.visible();
                      },
                      rtl: function () {
                          return $module.css('direction') == 'rtl';
                      }
                  },

                  reset: function () {
                      module.remove.visible();
                      if (settings.preserve) {
                          if ($.fn.transition !== undefined) {
                              $popup
                                .transition('remove transition')
                              ;
                          }
                      }
                      else {
                          module.removePopup();
                      }
                  },

                  setting: function (name, value) {
                      if ($.isPlainObject(name)) {
                          $.extend(true, settings, name);
                      }
                      else if (value !== undefined) {
                          settings[name] = value;
                      }
                      else {
                          return settings[name];
                      }
                  },
                  internal: function (name, value) {
                      if ($.isPlainObject(name)) {
                          $.extend(true, module, name);
                      }
                      else if (value !== undefined) {
                          module[name] = value;
                      }
                      else {
                          return module[name];
                      }
                  },
                  debug: function () {
                      if (settings.debug) {
                          if (settings.performance) {
                              module.performance.log(arguments);
                          }
                          else {
                              module.debug = Function.prototype.bind.call(console.info, console, settings.name + ':');
                              module.debug.apply(console, arguments);
                          }
                      }
                  },
                  verbose: function () {
                      if (settings.verbose && settings.debug) {
                          if (settings.performance) {
                              module.performance.log(arguments);
                          }
                          else {
                              module.verbose = Function.prototype.bind.call(console.info, console, settings.name + ':');
                              module.verbose.apply(console, arguments);
                          }
                      }
                  },
                  error: function () {
                      module.error = Function.prototype.bind.call(console.error, console, settings.name + ':');
                      module.error.apply(console, arguments);
                  },
                  performance: {
                      log: function (message) {
                          var
                            currentTime,
                            executionTime,
                            previousTime
                          ;
                          if (settings.performance) {
                              currentTime = new Date().getTime();
                              previousTime = time || currentTime;
                              executionTime = currentTime - previousTime;
                              time = currentTime;
                              performance.push({
                                  'Name': message[0],
                                  'Arguments': [].slice.call(message, 1) || '',
                                  'Element': element,
                                  'Execution Time': executionTime
                              });
                          }
                          clearTimeout(module.performance.timer);
                          module.performance.timer = setTimeout(module.performance.display, 100);
                      },
                      display: function () {
                          var
                            title = settings.name + ':',
                            totalTime = 0
                          ;
                          time = false;
                          clearTimeout(module.performance.timer);
                          $.each(performance, function (index, data) {
                              totalTime += data['Execution Time'];
                          });
                          title += ' ' + totalTime + 'ms';
                          if (moduleSelector) {
                              title += ' \'' + moduleSelector + '\'';
                          }
                          if ((console.group !== undefined || console.table !== undefined) && performance.length > 0) {
                              console.groupCollapsed(title);
                              if (console.table) {
                                  console.table(performance);
                              }
                              else {
                                  $.each(performance, function (index, data) {
                                      console.log(data['Name'] + ': ' + data['Execution Time'] + 'ms');
                                  });
                              }
                              console.groupEnd();
                          }
                          performance = [];
                      }
                  },
                  invoke: function (query, passedArguments, context) {
                      var
                        object = instance,
                        maxDepth,
                        found,
                        response
                      ;
                      passedArguments = passedArguments || queryArguments;
                      context = element || context;
                      if (typeof query == 'string' && object !== undefined) {
                          query = query.split(/[\. ]/);
                          maxDepth = query.length - 1;
                          $.each(query, function (depth, value) {
                              var camelCaseValue = (depth != maxDepth)
                                ? value + query[depth + 1].charAt(0).toUpperCase() + query[depth + 1].slice(1)
                                : query
                              ;
                              if ($.isPlainObject(object[camelCaseValue]) && (depth != maxDepth)) {
                                  object = object[camelCaseValue];
                              }
                              else if (object[camelCaseValue] !== undefined) {
                                  found = object[camelCaseValue];
                                  return false;
                              }
                              else if ($.isPlainObject(object[value]) && (depth != maxDepth)) {
                                  object = object[value];
                              }
                              else if (object[value] !== undefined) {
                                  found = object[value];
                                  return false;
                              }
                              else {
                                  return false;
                              }
                          });
                      }
                      if ($.isFunction(found)) {
                          response = found.apply(context, passedArguments);
                      }
                      else if (found !== undefined) {
                          response = found;
                      }
                      if ($.isArray(returnedValue)) {
                          returnedValue.push(response);
                      }
                      else if (returnedValue !== undefined) {
                          returnedValue = [returnedValue, response];
                      }
                      else if (response !== undefined) {
                          returnedValue = response;
                      }
                      return found;
                  }
              };

              if (methodInvoked) {
                  if (instance === undefined) {
                      module.initialize();
                  }
                  module.invoke(query);
              }
              else {
                  if (instance !== undefined) {
                      instance.invoke('destroy');
                  }
                  module.initialize();
              }
          })
        ;

        return (returnedValue !== undefined)
          ? returnedValue
          : this
        ;
    };

    $.fn.popup.settings = {

        name: 'Popup',

        debug: false,
        verbose: true,
        performance: true,
        namespace: 'popup',

        onCreate: function () { },
        onRemove: function () { },

        onShow: function () { },
        onVisible: function () { },
        onHide: function () { },
        onHidden: function () { },

        variation: '',
        content: false,
        html: false,
        title: false,

        on: 'hover',
        closable: true,
        hideOnScroll: 'auto',
        exclusive: true,

        context: 'body',

        position: 'top left',
        prefer: 'opposite',
        lastResort: false,

        delay: {
            show: 30,
            hide: 0
        },

        setFluidWidth: true,
        movePopup: true,

        target: false,
        popup: false,
        inline: false,
        preserve: false,
        hoverable: false,

        duration: 200,
        easing: 'easeOutQuint',
        transition: 'scale',

        distanceAway: 0,
        offset: 0,
        maxSearchDepth: 20,

        error: {
            invalidPosition: 'The position you specified is not a valid position',
            cannotPlace: 'No visible position could be found for the popup',
            method: 'The method you called is not defined.'
        },

        metadata: {
            activator: 'activator',
            content: 'content',
            html: 'html',
            offset: 'offset',
            position: 'position',
            title: 'title',
            variation: 'variation'
        },

        className: {
            active: 'active',
            animating: 'animating',
            dropdown: 'dropdown',
            fluid: 'fluid',
            loading: 'loading',
            popup: 'ui popup',
            position: 'top left center bottom right',
            visible: 'visible'
        },

        selector: {
            popup: '.ui.popup'
        },

        templates: {
            escape: function (string) {
                var
                  badChars = /[&<>"'`]/g,
                  shouldEscape = /[&<>"'`]/,
                  escape = {
                      "&": "&amp;",
                      "<": "&lt;",
                      ">": "&gt;",
                      '"': "&quot;",
                      "'": "&#x27;",
                      "`": "&#x60;"
                  },
                  escapedChar = function (chr) {
                      return escape[chr];
                  }
                ;
                if (shouldEscape.test(string)) {
                    return string.replace(badChars, escapedChar);
                }
                return string;
            },
            popup: function (text) {
                var
                  html = '',
                  escape = $.fn.popup.settings.templates.escape
                ;
                if (typeof text !== undefined) {
                    if (typeof text.title !== undefined && text.title) {
                        text.title = escape(text.title);
                        html += '<div class="header">' + text.title + '</div>';
                    }
                    if (typeof text.content !== undefined && text.content) {
                        text.content = escape(text.content);
                        html += '<div class="content">' + text.content + '</div>';
                    }
                }
                return html;
            }
        }

    };

    // Adds easing
    $.extend($.easing, {
        easeOutQuad: function (x, t, b, c, d) {
            return -c * (t /= d) * (t - 2) + b;
        }
    });


})(jQuery, window, document);

/*!
 * # Semantic UI 1.12.1 - Progress
 * http://github.com/semantic-org/semantic-ui/
 *
 *
 * Copyright 2014 Contributors
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 *
 */

; (function ($, window, document, undefined) {

    "use strict";

    $.fn.progress = function (parameters) {
        var
          $allModules = $(this),

          moduleSelector = $allModules.selector || '',

          time = new Date().getTime(),
          performance = [],

          query = arguments[0],
          methodInvoked = (typeof query == 'string'),
          queryArguments = [].slice.call(arguments, 1),

          returnedValue
        ;

        $allModules
          .each(function () {
              var
                settings = ($.isPlainObject(parameters))
                  ? $.extend(true, {}, $.fn.progress.settings, parameters)
                  : $.extend({}, $.fn.progress.settings),

                className = settings.className,
                metadata = settings.metadata,
                namespace = settings.namespace,
                selector = settings.selector,
                error = settings.error,

                eventNamespace = '.' + namespace,
                moduleNamespace = 'module-' + namespace,

                $module = $(this),
                $bar = $(this).find(selector.bar),
                $progress = $(this).find(selector.progress),
                $label = $(this).find(selector.label),

                element = this,
                instance = $module.data(moduleNamespace),

                animating = false,
                transitionEnd,
                module
              ;

              module = {

                  initialize: function () {
                      module.debug('Initializing progress bar', settings);

                      transitionEnd = module.get.transitionEnd();

                      module.read.metadata();
                      module.set.duration();
                      module.set.initials();
                      module.instantiate();
                  },

                  instantiate: function () {
                      module.verbose('Storing instance of progress', module);
                      instance = module;
                      $module
                        .data(moduleNamespace, module)
                      ;
                  },
                  destroy: function () {
                      module.verbose('Destroying previous progress for', $module);
                      clearInterval(instance.interval);
                      module.remove.state();
                      $module.removeData(moduleNamespace);
                      instance = undefined;
                  },

                  reset: function () {
                      module.set.percent(0);
                  },

                  complete: function () {
                      if (module.percent === undefined || module.percent < 100) {
                          module.set.percent(100);
                      }
                  },

                  read: {
                      metadata: function () {
                          if ($module.data(metadata.percent)) {
                              module.verbose('Current percent value set from metadata');
                              module.percent = $module.data(metadata.percent);
                          }
                          if ($module.data(metadata.total)) {
                              module.verbose('Total value set from metadata');
                              module.total = $module.data(metadata.total);
                          }
                          if ($module.data(metadata.value)) {
                              module.verbose('Current value set from metadata');
                              module.value = $module.data(metadata.value);
                          }
                      },
                      currentValue: function () {
                          return (module.value !== undefined)
                            ? module.value
                            : false
                          ;
                      }
                  },

                  increment: function (incrementValue) {
                      var
                        total = module.total || false,
                        edgeValue,
                        startValue,
                        newValue
                      ;
                      if (total) {
                          startValue = module.value || 0;
                          incrementValue = incrementValue || 1;
                          newValue = startValue + incrementValue;
                          edgeValue = module.total;
                          module.debug('Incrementing value by', incrementValue, startValue, edgeValue);
                          if (newValue > edgeValue) {
                              module.debug('Value cannot increment above total', edgeValue);
                              newValue = edgeValue;
                          }
                          module.set.progress(newValue);
                      }
                      else {
                          startValue = module.percent || 0;
                          incrementValue = incrementValue || module.get.randomValue();
                          newValue = startValue + incrementValue;
                          edgeValue = 100;
                          module.debug('Incrementing percentage by', incrementValue, startValue);
                          if (newValue > edgeValue) {
                              module.debug('Value cannot increment above 100 percent');
                              newValue = edgeValue;
                          }
                          module.set.progress(newValue);
                      }
                  },
                  decrement: function (decrementValue) {
                      var
                        total = module.total || false,
                        edgeValue = 0,
                        startValue,
                        newValue
                      ;
                      if (total) {
                          startValue = module.value || 0;
                          decrementValue = decrementValue || 1;
                          newValue = startValue - decrementValue;
                          module.debug('Decrementing value by', decrementValue, startValue);
                      }
                      else {
                          startValue = module.percent || 0;
                          decrementValue = decrementValue || module.get.randomValue();
                          newValue = startValue - decrementValue;
                          module.debug('Decrementing percentage by', decrementValue, startValue);
                      }

                      if (newValue < edgeValue) {
                          module.debug('Value cannot decrement below 0');
                          newValue = 0;
                      }
                      module.set.progress(newValue);
                  },

                  get: {
                      text: function (templateText) {
                          var
                            value = module.value || 0,
                            total = module.total || 0,
                            percent = (module.is.visible() && animating)
                              ? module.get.displayPercent()
                              : module.percent || 0,
                            left = (module.total > 0)
                              ? (total - value)
                              : (100 - percent)
                          ;
                          templateText = templateText || '';
                          templateText = templateText
                            .replace('{value}', value)
                            .replace('{total}', total)
                            .replace('{left}', left)
                            .replace('{percent}', percent)
                          ;
                          module.debug('Adding variables to progress bar text', templateText);
                          return templateText;
                      },
                      randomValue: function () {
                          module.debug('Generating random increment percentage');
                          return Math.floor((Math.random() * settings.random.max) + settings.random.min);
                      },

                      transitionEnd: function () {
                          var
                            element = document.createElement('element'),
                            transitions = {
                                'transition': 'transitionend',
                                'OTransition': 'oTransitionEnd',
                                'MozTransition': 'transitionend',
                                'WebkitTransition': 'webkitTransitionEnd'
                            },
                            transition
                          ;
                          for (transition in transitions) {
                              if (element.style[transition] !== undefined) {
                                  return transitions[transition];
                              }
                          }
                      },

                      // gets current displayed percentage (if animating values this is the intermediary value)
                      displayPercent: function () {
                          var
                            barWidth = $bar.width(),
                            totalWidth = $module.width(),
                            minDisplay = parseInt($bar.css('min-width'), 10),
                            displayPercent = (barWidth > minDisplay)
                              ? (barWidth / totalWidth * 100)
                              : module.percent
                          ;
                          if (settings.precision === 0) {
                              return Math.round(displayPercent);
                          }
                          return Math.round(displayPercent * (10 * settings.precision)) / (10 * settings.precision);
                      },

                      percent: function () {
                          return module.percent || 0;
                      },
                      value: function () {
                          return module.value || false;
                      },
                      total: function () {
                          return module.total || false;
                      }
                  },

                  is: {
                      success: function () {
                          return $module.hasClass(className.success);
                      },
                      warning: function () {
                          return $module.hasClass(className.warning);
                      },
                      error: function () {
                          return $module.hasClass(className.error);
                      },
                      active: function () {
                          return $module.hasClass(className.active);
                      },
                      visible: function () {
                          return $module.is(':visible');
                      }
                  },

                  remove: {
                      state: function () {
                          module.verbose('Removing stored state');
                          delete module.total;
                          delete module.percent;
                          delete module.value;
                      },
                      active: function () {
                          module.verbose('Removing active state');
                          $module.removeClass(className.active);
                      },
                      success: function () {
                          module.verbose('Removing success state');
                          $module.removeClass(className.success);
                      },
                      warning: function () {
                          module.verbose('Removing warning state');
                          $module.removeClass(className.warning);
                      },
                      error: function () {
                          module.verbose('Removing error state');
                          $module.removeClass(className.error);
                      }
                  },

                  set: {
                      barWidth: function (value) {
                          if (value > 100) {
                              module.error(error.tooHigh, value);
                          }
                          else if (value < 0) {
                              module.error(error.tooLow, value);
                          }
                          else {
                              $bar
                                .css('width', value + '%')
                              ;
                              $module
                                .attr('data-percent', parseInt(value, 10))
                              ;
                          }
                      },
                      duration: function (duration) {
                          duration = duration || settings.duration;
                          duration = (typeof duration == 'number')
                            ? duration + 'ms'
                            : duration
                          ;
                          module.verbose('Setting progress bar transition duration', duration);
                          $bar
                            .css({
                                '-webkit-transition-duration': duration,
                                '-moz-transition-duration': duration,
                                '-ms-transition-duration': duration,
                                '-o-transition-duration': duration,
                                'transition-duration': duration
                            })
                          ;
                      },
                      initials: function () {
                          if (settings.total !== false) {
                              module.verbose('Current total set in settings', settings.total);
                              module.total = settings.total;
                          }
                          if (settings.value !== false) {
                              module.verbose('Current value set in settings', settings.value);
                              module.value = settings.value;
                          }
                          if (settings.percent !== false) {
                              module.verbose('Current percent set in settings', settings.percent);
                              module.percent = settings.percent;
                          }
                          if (module.percent !== undefined) {
                              module.set.percent(module.percent);
                          }
                          else if (module.value !== undefined) {
                              module.set.progress(module.value);
                          }
                      },
                      percent: function (percent) {
                          percent = (typeof percent == 'string')
                            ? +(percent.replace('%', ''))
                            : percent
                          ;
                          if (percent > 0 && percent < 1) {
                              module.verbose('Module percentage passed as decimal, converting');
                              percent = percent * 100;
                          }
                          // round percentage
                          if (settings.precision === 0) {
                              percent = Math.round(percent);
                          }
                          else {
                              percent = Math.round(percent * (10 * settings.precision)) / (10 * settings.precision);
                          }
                          module.percent = percent;
                          if (module.total) {
                              module.value = Math.round((percent / 100) * module.total * (10 * settings.precision)) / (10 * settings.precision);
                          }
                          else if (settings.limitValues) {
                              module.value = (module.value > 100)
                                ? 100
                                : (module.value < 0)
                                  ? 0
                                  : module.value
                              ;
                          }
                          module.set.barWidth(percent);
                          if (module.is.visible()) {
                              module.set.labelInterval();
                          }
                          module.set.labels();
                          settings.onChange.call(element, percent, module.value, module.total);
                      },
                      labelInterval: function () {
                          var
                            animationCallback = function () {
                                module.verbose('Bar finished animating, removing continuous label updates');
                                clearInterval(module.interval);
                                animating = false;
                                module.set.labels();
                            }
                          ;
                          clearInterval(module.interval);
                          $bar.one(transitionEnd + eventNamespace, animationCallback);
                          module.timer = setTimeout(animationCallback, settings.duration + 100);
                          animating = true;
                          module.interval = setInterval(module.set.labels, settings.framerate);
                      },
                      labels: function () {
                          module.verbose('Setting both bar progress and outer label text');
                          module.set.barLabel();
                          module.set.state();
                      },
                      label: function (text) {
                          text = text || '';
                          if (text) {
                              text = module.get.text(text);
                              module.debug('Setting label to text', text);
                              $label.text(text);
                          }
                      },
                      state: function (percent) {
                          percent = (percent !== undefined)
                            ? percent
                            : module.percent
                          ;
                          if (percent === 100) {
                              if (settings.autoSuccess && !(module.is.warning() || module.is.error())) {
                                  module.set.success();
                                  module.debug('Automatically triggering success at 100%');
                              }
                              else {
                                  module.verbose('Reached 100% removing active state');
                                  module.remove.active();
                              }
                          }
                          else if (percent > 0) {
                              module.verbose('Adjusting active progress bar label', percent);
                              module.set.active();
                          }
                          else {
                              module.remove.active();
                              module.set.label(settings.text.active);
                          }
                      },
                      barLabel: function (text) {
                          if (text !== undefined) {
                              $progress.text(module.get.text(text));
                          }
                          else if (settings.label == 'ratio' && module.total) {
                              module.debug('Adding ratio to bar label');
                              $progress.text(module.get.text(settings.text.ratio));
                          }
                          else if (settings.label == 'percent') {
                              module.debug('Adding percentage to bar label');
                              $progress.text(module.get.text(settings.text.percent));
                          }
                      },
                      active: function (text) {
                          text = text || settings.text.active;
                          module.debug('Setting active state');
                          if (settings.showActivity && !module.is.active()) {
                              $module.addClass(className.active);
                          }
                          module.remove.warning();
                          module.remove.error();
                          module.remove.success();
                          if (text) {
                              module.set.label(text);
                          }
                          settings.onActive.call(element, module.value, module.total);
                      },
                      success: function (text) {
                          text = text || settings.text.success;
                          module.debug('Setting success state');
                          $module.addClass(className.success);
                          module.remove.active();
                          module.remove.warning();
                          module.remove.error();
                          module.complete();
                          if (text) {
                              module.set.label(text);
                          }
                          settings.onSuccess.call(element, module.total);
                      },
                      warning: function (text) {
                          text = text || settings.text.warning;
                          module.debug('Setting warning state');
                          $module.addClass(className.warning);
                          module.remove.active();
                          module.remove.success();
                          module.remove.error();
                          module.complete();
                          if (text) {
                              module.set.label(text);
                          }
                          settings.onWarning.call(element, module.value, module.total);
                      },
                      error: function (text) {
                          text = text || settings.text.error;
                          module.debug('Setting error state');
                          $module.addClass(className.error);
                          module.remove.active();
                          module.remove.success();
                          module.remove.warning();
                          module.complete();
                          if (text) {
                              module.set.label(text);
                          }
                          settings.onError.call(element, module.value, module.total);
                      },
                      total: function (totalValue) {
                          module.total = totalValue;
                      },
                      progress: function (value) {
                          var
                            numericValue = (typeof value === 'string')
                              ? (value.replace(/[^\d.]/g, '') !== '')
                                ? +(value.replace(/[^\d.]/g, ''))
                                : false
                              : value,
                            percentComplete
                          ;
                          if (numericValue === false) {
                              module.error(error.nonNumeric, value);
                          }
                          if (module.total) {
                              module.value = numericValue;
                              percentComplete = (numericValue / module.total) * 100;
                              module.debug('Calculating percent complete from total', percentComplete);
                              module.set.percent(percentComplete);
                          }
                          else {
                              percentComplete = numericValue;
                              module.debug('Setting value to exact percentage value', percentComplete);
                              module.set.percent(percentComplete);
                          }
                      }
                  },

                  setting: function (name, value) {
                      module.debug('Changing setting', name, value);
                      if ($.isPlainObject(name)) {
                          $.extend(true, settings, name);
                      }
                      else if (value !== undefined) {
                          settings[name] = value;
                      }
                      else {
                          return settings[name];
                      }
                  },
                  internal: function (name, value) {
                      if ($.isPlainObject(name)) {
                          $.extend(true, module, name);
                      }
                      else if (value !== undefined) {
                          module[name] = value;
                      }
                      else {
                          return module[name];
                      }
                  },
                  debug: function () {
                      if (settings.debug) {
                          if (settings.performance) {
                              module.performance.log(arguments);
                          }
                          else {
                              module.debug = Function.prototype.bind.call(console.info, console, settings.name + ':');
                              module.debug.apply(console, arguments);
                          }
                      }
                  },
                  verbose: function () {
                      if (settings.verbose && settings.debug) {
                          if (settings.performance) {
                              module.performance.log(arguments);
                          }
                          else {
                              module.verbose = Function.prototype.bind.call(console.info, console, settings.name + ':');
                              module.verbose.apply(console, arguments);
                          }
                      }
                  },
                  error: function () {
                      module.error = Function.prototype.bind.call(console.error, console, settings.name + ':');
                      module.error.apply(console, arguments);
                  },
                  performance: {
                      log: function (message) {
                          var
                            currentTime,
                            executionTime,
                            previousTime
                          ;
                          if (settings.performance) {
                              currentTime = new Date().getTime();
                              previousTime = time || currentTime;
                              executionTime = currentTime - previousTime;
                              time = currentTime;
                              performance.push({
                                  'Name': message[0],
                                  'Arguments': [].slice.call(message, 1) || '',
                                  'Element': element,
                                  'Execution Time': executionTime
                              });
                          }
                          clearTimeout(module.performance.timer);
                          module.performance.timer = setTimeout(module.performance.display, 100);
                      },
                      display: function () {
                          var
                            title = settings.name + ':',
                            totalTime = 0
                          ;
                          time = false;
                          clearTimeout(module.performance.timer);
                          $.each(performance, function (index, data) {
                              totalTime += data['Execution Time'];
                          });
                          title += ' ' + totalTime + 'ms';
                          if (moduleSelector) {
                              title += ' \'' + moduleSelector + '\'';
                          }
                          if ((console.group !== undefined || console.table !== undefined) && performance.length > 0) {
                              console.groupCollapsed(title);
                              if (console.table) {
                                  console.table(performance);
                              }
                              else {
                                  $.each(performance, function (index, data) {
                                      console.log(data['Name'] + ': ' + data['Execution Time'] + 'ms');
                                  });
                              }
                              console.groupEnd();
                          }
                          performance = [];
                      }
                  },
                  invoke: function (query, passedArguments, context) {
                      var
                        object = instance,
                        maxDepth,
                        found,
                        response
                      ;
                      passedArguments = passedArguments || queryArguments;
                      context = element || context;
                      if (typeof query == 'string' && object !== undefined) {
                          query = query.split(/[\. ]/);
                          maxDepth = query.length - 1;
                          $.each(query, function (depth, value) {
                              var camelCaseValue = (depth != maxDepth)
                                ? value + query[depth + 1].charAt(0).toUpperCase() + query[depth + 1].slice(1)
                                : query
                              ;
                              if ($.isPlainObject(object[camelCaseValue]) && (depth != maxDepth)) {
                                  object = object[camelCaseValue];
                              }
                              else if (object[camelCaseValue] !== undefined) {
                                  found = object[camelCaseValue];
                                  return false;
                              }
                              else if ($.isPlainObject(object[value]) && (depth != maxDepth)) {
                                  object = object[value];
                              }
                              else if (object[value] !== undefined) {
                                  found = object[value];
                                  return false;
                              }
                              else {
                                  module.error(error.method, query);
                                  return false;
                              }
                          });
                      }
                      if ($.isFunction(found)) {
                          response = found.apply(context, passedArguments);
                      }
                      else if (found !== undefined) {
                          response = found;
                      }
                      if ($.isArray(returnedValue)) {
                          returnedValue.push(response);
                      }
                      else if (returnedValue !== undefined) {
                          returnedValue = [returnedValue, response];
                      }
                      else if (response !== undefined) {
                          returnedValue = response;
                      }
                      return found;
                  }
              };

              if (methodInvoked) {
                  if (instance === undefined) {
                      module.initialize();
                  }
                  module.invoke(query);
              }
              else {
                  if (instance !== undefined) {
                      instance.invoke('destroy');
                  }
                  module.initialize();
              }
          })
        ;

        return (returnedValue !== undefined)
          ? returnedValue
          : this
        ;
    };

    $.fn.progress.settings = {

        name: 'Progress',
        namespace: 'progress',

        debug: false,
        verbose: true,
        performance: true,

        random: {
            min: 2,
            max: 5
        },

        duration: 300,

        autoSuccess: true,
        showActivity: true,
        limitValues: true,

        label: 'percent',
        precision: 1,
        framerate: (1000 / 30), /// 30 fps

        percent: false,
        total: false,
        value: false,

        onChange: function (percent, value, total) { },
        onSuccess: function (total) { },
        onActive: function (value, total) { },
        onError: function (value, total) { },
        onWarning: function (value, total) { },

        error: {
            method: 'The method you called is not defined.',
            nonNumeric: 'Progress value is non numeric',
            tooHigh: 'Value specified is above 100%',
            tooLow: 'Value specified is below 0%'
        },

        regExp: {
            variable: /\{\$*[A-z0-9]+\}/g
        },

        metadata: {
            percent: 'percent',
            total: 'total',
            value: 'value'
        },

        selector: {
            bar: '> .bar',
            label: '> .label',
            progress: '.bar > .progress'
        },

        text: {
            active: false,
            error: false,
            success: false,
            warning: false,
            percent: '{percent}%',
            ratio: '{value} of {total}'
        },

        className: {
            active: 'active',
            error: 'error',
            success: 'success',
            warning: 'warning'
        }

    };


})(jQuery, window, document);
/*!
 * # Semantic UI 1.12.1 - Rating
 * http://github.com/semantic-org/semantic-ui/
 *
 *
 * Copyright 2014 Contributors
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 *
 */

; (function ($, window, document, undefined) {

    "use strict";

    $.fn.rating = function (parameters) {
        var
          $allModules = $(this),
          moduleSelector = $allModules.selector || '',

          time = new Date().getTime(),
          performance = [],

          query = arguments[0],
          methodInvoked = (typeof query == 'string'),
          queryArguments = [].slice.call(arguments, 1),
          returnedValue
        ;
        $allModules
          .each(function () {
              var
                settings = ($.isPlainObject(parameters))
                  ? $.extend(true, {}, $.fn.rating.settings, parameters)
                  : $.extend({}, $.fn.rating.settings),

                namespace = settings.namespace,
                className = settings.className,
                metadata = settings.metadata,
                selector = settings.selector,
                error = settings.error,

                eventNamespace = '.' + namespace,
                moduleNamespace = 'module-' + namespace,

                element = this,
                instance = $(this).data(moduleNamespace),

                $module = $(this),
                $icon = $module.find(selector.icon),

                module
              ;

              module = {

                  initialize: function () {
                      module.verbose('Initializing rating module', settings);

                      if ($icon.length === 0) {
                          module.setup.layout();
                      }

                      if (settings.interactive) {
                          module.enable();
                      }
                      else {
                          module.disable();
                      }
                      if (settings.initialRating) {
                          module.debug('Setting initial rating');
                          module.setRating(settings.initialRating);
                      }
                      if ($module.data(metadata.rating)) {
                          module.debug('Rating found in metadata');
                          module.setRating($module.data(metadata.rating));
                      }
                      module.instantiate();
                  },

                  instantiate: function () {
                      module.verbose('Instantiating module', settings);
                      instance = module;
                      $module
                        .data(moduleNamespace, module)
                      ;
                  },

                  destroy: function () {
                      module.verbose('Destroying previous instance', instance);
                      $module
                        .removeData(moduleNamespace)
                      ;
                      $icon
                        .off(eventNamespace)
                      ;
                  },

                  refresh: function () {
                      $icon = $module.find(selector.icon);
                  },

                  setup: {
                      layout: function () {
                          var
                            maxRating = $module.data(metadata.maxRating) || settings.maxRating
                          ;
                          module.debug('Generating icon html dynamically');
                          $module
                            .html($.fn.rating.settings.templates.icon(maxRating))
                          ;
                          module.refresh();
                      }
                  },

                  event: {
                      mouseenter: function () {
                          var
                            $activeIcon = $(this)
                          ;
                          $activeIcon
                            .nextAll()
                              .removeClass(className.selected)
                          ;
                          $module
                            .addClass(className.selected)
                          ;
                          $activeIcon
                            .addClass(className.selected)
                              .prevAll()
                              .addClass(className.selected)
                          ;
                      },
                      mouseleave: function () {
                          $module
                            .removeClass(className.selected)
                          ;
                          $icon
                            .removeClass(className.selected)
                          ;
                      },
                      click: function () {
                          var
                            $activeIcon = $(this),
                            currentRating = module.getRating(),
                            rating = $icon.index($activeIcon) + 1,
                            canClear = (settings.clearable == 'auto')
                             ? ($icon.length === 1)
                             : settings.clearable
                          ;
                          if (canClear && currentRating == rating) {
                              module.clearRating();
                          }
                          else {
                              module.setRating(rating);
                          }
                      }
                  },

                  clearRating: function () {
                      module.debug('Clearing current rating');
                      module.setRating(0);
                  },

                  getRating: function () {
                      var
                        currentRating = $icon.filter('.' + className.active).length
                      ;
                      module.verbose('Current rating retrieved', currentRating);
                      return currentRating;
                  },

                  enable: function () {
                      module.debug('Setting rating to interactive mode');
                      $icon
                        .on('mouseenter' + eventNamespace, module.event.mouseenter)
                        .on('mouseleave' + eventNamespace, module.event.mouseleave)
                        .on('click' + eventNamespace, module.event.click)
                      ;
                      $module
                        .removeClass(className.disabled)
                      ;
                  },

                  disable: function () {
                      module.debug('Setting rating to read-only mode');
                      $icon
                        .off(eventNamespace)
                      ;
                      $module
                        .addClass(className.disabled)
                      ;
                  },

                  setRating: function (rating) {
                      var
                        ratingIndex = (rating - 1 >= 0)
                          ? (rating - 1)
                          : 0,
                        $activeIcon = $icon.eq(ratingIndex)
                      ;
                      $module
                        .removeClass(className.selected)
                      ;
                      $icon
                        .removeClass(className.selected)
                        .removeClass(className.active)
                      ;
                      if (rating > 0) {
                          module.verbose('Setting current rating to', rating);
                          $activeIcon
                            .prevAll()
                            .andSelf()
                              .addClass(className.active)
                          ;
                      }
                      settings.onRate.call(element, rating);
                  },

                  setting: function (name, value) {
                      module.debug('Changing setting', name, value);
                      if ($.isPlainObject(name)) {
                          $.extend(true, settings, name);
                      }
                      else if (value !== undefined) {
                          settings[name] = value;
                      }
                      else {
                          return settings[name];
                      }
                  },
                  internal: function (name, value) {
                      if ($.isPlainObject(name)) {
                          $.extend(true, module, name);
                      }
                      else if (value !== undefined) {
                          module[name] = value;
                      }
                      else {
                          return module[name];
                      }
                  },
                  debug: function () {
                      if (settings.debug) {
                          if (settings.performance) {
                              module.performance.log(arguments);
                          }
                          else {
                              module.debug = Function.prototype.bind.call(console.info, console, settings.name + ':');
                              module.debug.apply(console, arguments);
                          }
                      }
                  },
                  verbose: function () {
                      if (settings.verbose && settings.debug) {
                          if (settings.performance) {
                              module.performance.log(arguments);
                          }
                          else {
                              module.verbose = Function.prototype.bind.call(console.info, console, settings.name + ':');
                              module.verbose.apply(console, arguments);
                          }
                      }
                  },
                  error: function () {
                      module.error = Function.prototype.bind.call(console.error, console, settings.name + ':');
                      module.error.apply(console, arguments);
                  },
                  performance: {
                      log: function (message) {
                          var
                            currentTime,
                            executionTime,
                            previousTime
                          ;
                          if (settings.performance) {
                              currentTime = new Date().getTime();
                              previousTime = time || currentTime;
                              executionTime = currentTime - previousTime;
                              time = currentTime;
                              performance.push({
                                  'Name': message[0],
                                  'Arguments': [].slice.call(message, 1) || '',
                                  'Element': element,
                                  'Execution Time': executionTime
                              });
                          }
                          clearTimeout(module.performance.timer);
                          module.performance.timer = setTimeout(module.performance.display, 100);
                      },
                      display: function () {
                          var
                            title = settings.name + ':',
                            totalTime = 0
                          ;
                          time = false;
                          clearTimeout(module.performance.timer);
                          $.each(performance, function (index, data) {
                              totalTime += data['Execution Time'];
                          });
                          title += ' ' + totalTime + 'ms';
                          if (moduleSelector) {
                              title += ' \'' + moduleSelector + '\'';
                          }
                          if ($allModules.length > 1) {
                              title += ' ' + '(' + $allModules.length + ')';
                          }
                          if ((console.group !== undefined || console.table !== undefined) && performance.length > 0) {
                              console.groupCollapsed(title);
                              if (console.table) {
                                  console.table(performance);
                              }
                              else {
                                  $.each(performance, function (index, data) {
                                      console.log(data['Name'] + ': ' + data['Execution Time'] + 'ms');
                                  });
                              }
                              console.groupEnd();
                          }
                          performance = [];
                      }
                  },
                  invoke: function (query, passedArguments, context) {
                      var
                        object = instance,
                        maxDepth,
                        found,
                        response
                      ;
                      passedArguments = passedArguments || queryArguments;
                      context = element || context;
                      if (typeof query == 'string' && object !== undefined) {
                          query = query.split(/[\. ]/);
                          maxDepth = query.length - 1;
                          $.each(query, function (depth, value) {
                              var camelCaseValue = (depth != maxDepth)
                                ? value + query[depth + 1].charAt(0).toUpperCase() + query[depth + 1].slice(1)
                                : query
                              ;
                              if ($.isPlainObject(object[camelCaseValue]) && (depth != maxDepth)) {
                                  object = object[camelCaseValue];
                              }
                              else if (object[camelCaseValue] !== undefined) {
                                  found = object[camelCaseValue];
                                  return false;
                              }
                              else if ($.isPlainObject(object[value]) && (depth != maxDepth)) {
                                  object = object[value];
                              }
                              else if (object[value] !== undefined) {
                                  found = object[value];
                                  return false;
                              }
                              else {
                                  return false;
                              }
                          });
                      }
                      if ($.isFunction(found)) {
                          response = found.apply(context, passedArguments);
                      }
                      else if (found !== undefined) {
                          response = found;
                      }
                      if ($.isArray(returnedValue)) {
                          returnedValue.push(response);
                      }
                      else if (returnedValue !== undefined) {
                          returnedValue = [returnedValue, response];
                      }
                      else if (response !== undefined) {
                          returnedValue = response;
                      }
                      return found;
                  }
              };
              if (methodInvoked) {
                  if (instance === undefined) {
                      module.initialize();
                  }
                  module.invoke(query);
              }
              else {
                  if (instance !== undefined) {
                      instance.invoke('destroy');
                  }
                  module.initialize();
              }
          })
        ;

        return (returnedValue !== undefined)
          ? returnedValue
          : this
        ;
    };

    $.fn.rating.settings = {

        name: 'Rating',
        namespace: 'rating',

        debug: false,
        verbose: true,
        performance: true,

        initialRating: 0,
        interactive: true,
        maxRating: 4,
        clearable: 'auto',

        onRate: function (rating) { },

        error: {
            method: 'The method you called is not defined',
            noMaximum: 'No maximum rating specified. Cannot generate HTML automatically'
        },


        metadata: {
            rating: 'rating',
            maxRating: 'maxRating'
        },

        className: {
            active: 'active',
            disabled: 'disabled',
            selected: 'selected',
            loading: 'loading'
        },

        selector: {
            icon: '.icon'
        },

        templates: {
            icon: function (maxRating) {
                var
                  icon = 1,
                  html = ''
                ;
                while (icon <= maxRating) {
                    html += '<i class="icon"></i>';
                    icon++;
                }
                return html;
            }
        }

    };

})(jQuery, window, document);

/*!
 * # Semantic UI 1.12.1 - Search
 * http://github.com/semantic-org/semantic-ui/
 *
 *
 * Copyright 2014 Contributors
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 *
 */

; (function ($, window, document, undefined) {

    "use strict";

    $.fn.search = function (parameters) {
        var
          $allModules = $(this),
          moduleSelector = $allModules.selector || '',

          time = new Date().getTime(),
          performance = [],

          query = arguments[0],
          methodInvoked = (typeof query == 'string'),
          queryArguments = [].slice.call(arguments, 1),
          returnedValue
        ;
        $(this)
          .each(function () {
              var
                settings = $.extend(true, {}, $.fn.search.settings, parameters),

                className = settings.className,
                metadata = settings.metadata,
                regExp = settings.regExp,
                selector = settings.selector,
                error = settings.error,
                namespace = settings.namespace,

                eventNamespace = '.' + namespace,
                moduleNamespace = namespace + '-module',

                $module = $(this),
                $prompt = $module.find(selector.prompt),
                $searchButton = $module.find(selector.searchButton),
                $results = $module.find(selector.results),
                $result = $module.find(selector.result),
                $category = $module.find(selector.category),

                element = this,
                instance = $module.data(moduleNamespace),

                module
              ;
              module = {

                  initialize: function () {
                      module.verbose('Initializing module');
                      var
                        prompt = $prompt[0],
                        inputEvent = (prompt !== undefined && prompt.oninput !== undefined)
                          ? 'input'
                          : (prompt !== undefined && prompt.onpropertychange !== undefined)
                            ? 'propertychange'
                            : 'keyup'
                      ;
                      if (settings.automatic) {
                          $prompt
                            .on(inputEvent + eventNamespace, module.throttle)
                            .attr('autocomplete', 'off')
                          ;
                      }
                      $prompt
                        .on('focus' + eventNamespace, module.event.focus)
                        .on('blur' + eventNamespace, module.event.blur)
                        .on('keydown' + eventNamespace, module.handleKeyboard)
                      ;
                      $searchButton
                        .on('click' + eventNamespace, module.query)
                      ;
                      $results
                        .on('mousedown' + eventNamespace, module.event.result.mousedown)
                        .on('mouseup' + eventNamespace, module.event.result.mouseup)
                        .on('click' + eventNamespace, selector.result, module.event.result.click)
                      ;
                      module.instantiate();
                  },
                  instantiate: function () {
                      module.verbose('Storing instance of module', module);
                      instance = module;
                      $module
                        .data(moduleNamespace, module)
                      ;
                  },
                  destroy: function () {
                      module.verbose('Destroying instance');
                      $module
                        .removeData(moduleNamespace)
                      ;
                      $prompt
                        .off(eventNamespace)
                      ;
                      $searchButton
                        .off(eventNamespace)
                      ;
                      $results
                        .off(eventNamespace)
                      ;
                  },
                  event: {
                      focus: function () {
                          module.set.focus();
                          clearTimeout(module.timer);
                          module.throttle();
                          if (module.has.minimumCharacters()) {
                              module.showResults();
                          }
                      },
                      blur: function (event) {
                          var
                            pageLostFocus = (document.activeElement === this)
                          ;
                          if (!pageLostFocus && !module.resultsClicked) {
                              module.cancel.query();
                              module.remove.focus();
                              module.timer = setTimeout(module.hideResults, settings.hideDelay);
                          }
                      },
                      result: {
                          mousedown: function () {
                              module.resultsClicked = true;
                          },
                          mouseup: function () {
                              module.resultsClicked = false;
                          },
                          click: function (event) {
                              module.debug('Search result selected');
                              var
                                $result = $(this),
                                $title = $result.find(selector.title).eq(0),
                                $link = $result.find('a[href]').eq(0),
                                href = $link.attr('href') || false,
                                target = $link.attr('target') || false,
                                title = $title.html(),
                                name = ($title.length > 0)
                                  ? $title.text()
                                  : false,
                                results = module.get.results(),
                                result = module.get.result(name, results),
                                returnedValue
                              ;
                              if ($.isFunction(settings.onSelect)) {
                                  if (settings.onSelect.call(element, result, results) === false) {
                                      module.debug('Custom onSelect callback cancelled default select action');
                                      return;
                                  }
                              }
                              module.hideResults();
                              if (name) {
                                  module.set.value(name);
                              }
                              if (href) {
                                  module.verbose('Opening search link found in result', $link);
                                  if (target == '_blank' || event.ctrlKey) {
                                      window.open(href);
                                  }
                                  else {
                                      window.location.href = (href);
                                  }
                              }
                          }
                      }
                  },
                  handleKeyboard: function (event) {
                      var
                        // force selector refresh
                        $result = $module.find(selector.result),
                        $category = $module.find(selector.category),
                        currentIndex = $result.index($result.filter('.' + className.active)),
                        resultSize = $result.length,

                        keyCode = event.which,
                        keys = {
                            backspace: 8,
                            enter: 13,
                            escape: 27,
                            upArrow: 38,
                            downArrow: 40
                        },
                        newIndex
                      ;
                      // search shortcuts
                      if (keyCode == keys.escape) {
                          module.verbose('Escape key pressed, blurring search field');
                          $prompt
                            .trigger('blur')
                          ;
                      }
                      if (module.is.visible()) {
                          if (keyCode == keys.enter) {
                              module.verbose('Enter key pressed, selecting active result');
                              if ($result.filter('.' + className.active).length > 0) {
                                  module.event.result.click.call($result.filter('.' + className.active), event);
                                  event.preventDefault();
                                  return false;
                              }
                          }
                          else if (keyCode == keys.upArrow) {
                              module.verbose('Up key pressed, changing active result');
                              newIndex = (currentIndex - 1 < 0)
                                ? currentIndex
                                : currentIndex - 1
                              ;
                              $category
                                .removeClass(className.active)
                              ;
                              $result
                                .removeClass(className.active)
                                .eq(newIndex)
                                  .addClass(className.active)
                                  .closest($category)
                                    .addClass(className.active)
                              ;
                              event.preventDefault();
                          }
                          else if (keyCode == keys.downArrow) {
                              module.verbose('Down key pressed, changing active result');
                              newIndex = (currentIndex + 1 >= resultSize)
                                ? currentIndex
                                : currentIndex + 1
                              ;
                              $category
                                .removeClass(className.active)
                              ;
                              $result
                                .removeClass(className.active)
                                .eq(newIndex)
                                  .addClass(className.active)
                                  .closest($category)
                                    .addClass(className.active)
                              ;
                              event.preventDefault();
                          }
                      }
                      else {
                          // query shortcuts
                          if (keyCode == keys.enter) {
                              module.verbose('Enter key pressed, executing query');
                              module.query();
                              module.set.buttonPressed();
                              $prompt.one('keyup', module.remove.buttonFocus);
                          }
                      }
                  },

                  setup: {
                      api: function () {
                          var
                            apiSettings = {
                                on: false,
                                action: 'search',
                                onFailure: module.error
                            },
                            searchHTML
                          ;
                          module.verbose('First request, initializing API');
                          $module.api(apiSettings);
                      }
                  },

                  can: {
                      useAPI: function () {
                          return $.fn.api !== undefined;
                      },
                      transition: function () {
                          return settings.transition && $.fn.transition !== undefined && $module.transition('is supported');
                      }
                  },

                  is: {
                      empty: function () {
                          return ($results.html() === '');
                      },
                      visible: function () {
                          return ($results.filter(':visible').length > 0);
                      },
                      focused: function () {
                          return ($prompt.filter(':focus').length > 0);
                      }
                  },

                  get: {
                      value: function () {
                          return $prompt.val();
                      },
                      results: function () {
                          var
                            results = $module.data(metadata.results)
                          ;
                          return results;
                      },
                      result: function (value, results) {
                          var
                            result = false
                          ;
                          value = value || module.get.value();
                          results = results || module.get.results();
                          if (settings.type === 'category') {
                              module.debug('Finding result that matches', value);
                              $.each(results, function (index, category) {
                                  if ($.isArray(category.results)) {
                                      result = module.search.object(value, category.results)[0];
                                      if (result && result.length > 0) {
                                          return true;
                                      }
                                  }
                              });
                          }
                          else {
                              module.debug('Finding result in results object', value);
                              result = module.search.object(value, results)[0];
                          }
                          return result;
                      },
                  },

                  set: {
                      focus: function () {
                          $module.addClass(className.focus);
                      },
                      loading: function () {
                          $module.addClass(className.loading);
                      },
                      value: function (value) {
                          module.verbose('Setting search input value', value);
                          $prompt.val(value);
                          module.query();
                      },
                      buttonPressed: function () {
                          $searchButton.addClass(className.pressed);
                      }
                  },

                  remove: {
                      loading: function () {
                          $module.removeClass(className.loading);
                      },
                      focus: function () {
                          $module.removeClass(className.focus);
                      },
                      buttonPressed: function () {
                          $searchButton.removeClass(className.pressed);
                      }
                  },

                  query: function () {
                      var
                        searchTerm = module.get.value(),
                        cache = module.read.cache(searchTerm)
                      ;
                      if (cache) {
                          module.debug('Reading result for ' + searchTerm + ' from cache');
                          module.save.results(cache.results);
                          module.addResults(cache.html);
                      }
                      else {
                          module.debug('Querying for ' + searchTerm);
                          if ($.isPlainObject(settings.source) || $.isArray(settings.source)) {
                              module.search.local(searchTerm);
                          }
                          else if (module.can.useAPI()) {
                              if (settings.apiSettings) {
                                  module.debug('Searching with specified API settings', settings.apiSettings);
                                  module.search.remote(searchTerm);
                              }
                              else if ($.api.settings.api.search !== undefined) {
                                  module.debug('Searching with default search API endpoint');
                                  module.search.remote(searchTerm);
                              }
                              else {
                                  module.error(error.noEndpoint);
                              }
                          }
                          else {
                              module.error(error.source);
                          }
                          settings.onSearchQuery.call(element, searchTerm);
                      }
                  },

                  search: {
                      local: function (searchTerm) {
                          var
                            searchResults = module.search.object(searchTerm, settings.content),
                            searchHTML
                          ;
                          module.set.loading();
                          module.save.results(searchResults);
                          module.debug('Returned local search results', searchResults);

                          searchHTML = module.generateResults({
                              results: searchResults
                          });
                          module.remove.loading();
                          module.write.cache(searchTerm, {
                              html: searchHTML,
                              results: searchResults
                          });
                          module.addResults(searchHTML);
                      },
                      remote: function (searchTerm) {
                          var
                            apiSettings = {
                                onSuccess: function (response) {
                                    module.parse.response.call(element, response, searchTerm);
                                },
                                urlData: {
                                    query: searchTerm
                                }
                            }
                          ;
                          if (!$module.api('get request')) {
                              module.setup.api();
                          }
                          $.extend(true, apiSettings, settings.apiSettings);
                          module.debug('Executing search', apiSettings);
                          module.cancel.query();
                          $module
                            .api('setting', apiSettings)
                            .api('query')
                          ;
                      },
                      object: function (searchTerm, source) {
                          var
                            results = [],
                            fullTextResults = [],
                            searchFields = $.isArray(settings.searchFields)
                              ? settings.searchFields
                              : [settings.searchFields],
                            searchExp = searchTerm.replace(regExp.escape, '\\$&'),
                            searchRegExp = new RegExp(regExp.exact + searchExp, 'i')
                          ;

                          source = source || settings.source;

                          // exit conditions on no source
                          if (source === undefined) {
                              module.error(error.source);
                              return [];
                          }

                          // iterate through search fields in array order
                          $.each(searchFields, function (index, field) {
                              $.each(source, function (label, content) {
                                  var
                                    fieldExists = (typeof content[field] == 'string'),
                                    notAlreadyResult = ($.inArray(content, results) == -1 && $.inArray(content, fullTextResults) == -1)
                                  ;
                                  if (fieldExists && notAlreadyResult) {
                                      if (content[field].match(searchRegExp)) {
                                          results.push(content);
                                      }
                                      else if (settings.searchFullText && module.fuzzySearch(searchTerm, content[field])) {
                                          fullTextResults.push(content);
                                      }
                                  }
                              });
                          });
                          return $.merge(results, fullTextResults);
                      }
                  },

                  fuzzySearch: function (query, term) {
                      var
                        termLength = term.length,
                        queryLength = query.length
                      ;
                      query = query.toLowerCase();
                      term = term.toLowerCase();
                      if (queryLength > termLength) {
                          return false;
                      }
                      if (queryLength === termLength) {
                          return (query === term);
                      }
                      search: for (var characterIndex = 0, nextCharacterIndex = 0; characterIndex < queryLength; characterIndex++) {
                          var
                            queryCharacter = query.charCodeAt(characterIndex)
                          ;
                          while (nextCharacterIndex < termLength) {
                              if (term.charCodeAt(nextCharacterIndex++) === queryCharacter) {
                                  continue search;
                              }
                          }
                          return false;
                      }
                      return true;
                  },

                  parse: {
                      response: function (response, searchTerm) {
                          var
                            searchHTML = module.generateResults(response)
                          ;
                          module.verbose('Parsing server response', response);
                          if (response !== undefined) {
                              if (searchTerm !== undefined && response.results !== undefined) {
                                  module.write.cache(searchTerm, {
                                      html: searchHTML,
                                      results: response.results
                                  });
                                  module.save.results(response.results);
                                  module.addResults(searchHTML);
                              }
                          }
                      }
                  },

                  throttle: function () {
                      clearTimeout(module.timer);
                      if (module.has.minimumCharacters()) {
                          module.timer = setTimeout(module.query, settings.searchDelay);
                      }
                      else {
                          module.hideResults();
                      }
                  },

                  cancel: {
                      query: function () {
                          if (module.can.useAPI()) {
                              $module.api('abort');
                          }
                      }
                  },

                  has: {
                      minimumCharacters: function () {
                          var
                            searchTerm = module.get.value(),
                            numCharacters = searchTerm.length
                          ;
                          return (numCharacters >= settings.minCharacters);
                      }
                  },

                  read: {
                      cache: function (name) {
                          var
                            cache = $module.data(metadata.cache)
                          ;
                          if (settings.cache) {
                              module.verbose('Checking cache for generated html for query', name);
                              return (typeof cache == 'object') && (cache[name] !== undefined)
                                ? cache[name]
                                : false
                              ;
                          }
                          return false;
                      }
                  },

                  save: {
                      results: function (results) {
                          module.verbose('Saving current search results to metadata', results);
                          $module.data(metadata.results, results);
                      }
                  },

                  write: {
                      cache: function (name, value) {
                          var
                            cache = ($module.data(metadata.cache) !== undefined)
                              ? $module.data(metadata.cache)
                              : {}
                          ;
                          if (settings.cache) {
                              module.verbose('Writing generated html to cache', name, value);
                              cache[name] = value;
                              $module
                                .data(metadata.cache, cache)
                              ;
                          }
                      }
                  },

                  addResults: function (html) {
                      if ($.isFunction(settings.onResultsAdd)) {
                          if (settings.onResultsAdd.call($results, html) === false) {
                              module.debug('onResultsAdd callback cancelled default action');
                              return false;
                          }
                      }
                      $results
                        .html(html)
                      ;
                      module.showResults();
                  },

                  showResults: function () {
                      if (!module.is.visible() && module.is.focused() && !module.is.empty()) {
                          if (module.can.transition()) {
                              module.debug('Showing results with css animations');
                              $results
                                .transition({
                                    animation: settings.transition + ' in',
                                    duration: settings.duration,
                                    queue: true
                                })
                              ;
                          }
                          else {
                              module.debug('Showing results with javascript');
                              $results
                                .stop()
                                .fadeIn(settings.duration, settings.easing)
                              ;
                          }
                          settings.onResultsOpen.call($results);
                      }
                  },
                  hideResults: function () {
                      if (module.is.visible()) {
                          if (module.can.transition()) {
                              module.debug('Hiding results with css animations');
                              $results
                                .transition({
                                    animation: settings.transition + ' out',
                                    duration: settings.duration,
                                    queue: true
                                })
                              ;
                          }
                          else {
                              module.debug('Hiding results with javascript');
                              $results
                                .stop()
                                .fadeOut(settings.duration, settings.easing)
                              ;
                          }
                          settings.onResultsClose.call($results);
                      }
                  },

                  generateResults: function (response) {
                      module.debug('Generating html from response', response);
                      var
                        template = settings.templates[settings.type],
                        isProperObject = ($.isPlainObject(response.results) && !$.isEmptyObject(response.results)),
                        isProperArray = ($.isArray(response.results) && response.results.length > 0),
                        html = ''
                      ;
                      if (isProperObject || isProperArray) {
                          if (settings.maxResults > 0) {
                              if (isProperObject) {
                                  if (settings.type == 'standard') {
                                      module.error(error.maxResults);
                                  }
                              }
                              else {
                                  response.results = response.results.slice(0, settings.maxResults);
                              }
                          }
                          if ($.isFunction(template)) {
                              html = template(response);
                          }
                          else {
                              module.error(error.noTemplate, false);
                          }
                      }
                      else {
                          html = module.displayMessage(error.noResults, 'empty');
                      }
                      settings.onResults.call(element, response);
                      return html;
                  },

                  displayMessage: function (text, type) {
                      type = type || 'standard';
                      module.debug('Displaying message', text, type);
                      module.addResults(settings.templates.message(text, type));
                      return settings.templates.message(text, type);
                  },

                  setting: function (name, value) {
                      if ($.isPlainObject(name)) {
                          $.extend(true, settings, name);
                      }
                      else if (value !== undefined) {
                          settings[name] = value;
                      }
                      else {
                          return settings[name];
                      }
                  },
                  internal: function (name, value) {
                      if ($.isPlainObject(name)) {
                          $.extend(true, module, name);
                      }
                      else if (value !== undefined) {
                          module[name] = value;
                      }
                      else {
                          return module[name];
                      }
                  },
                  debug: function () {
                      if (settings.debug) {
                          if (settings.performance) {
                              module.performance.log(arguments);
                          }
                          else {
                              module.debug = Function.prototype.bind.call(console.info, console, settings.name + ':');
                              module.debug.apply(console, arguments);
                          }
                      }
                  },
                  verbose: function () {
                      if (settings.verbose && settings.debug) {
                          if (settings.performance) {
                              module.performance.log(arguments);
                          }
                          else {
                              module.verbose = Function.prototype.bind.call(console.info, console, settings.name + ':');
                              module.verbose.apply(console, arguments);
                          }
                      }
                  },
                  error: function () {
                      module.error = Function.prototype.bind.call(console.error, console, settings.name + ':');
                      module.error.apply(console, arguments);
                  },
                  performance: {
                      log: function (message) {
                          var
                            currentTime,
                            executionTime,
                            previousTime
                          ;
                          if (settings.performance) {
                              currentTime = new Date().getTime();
                              previousTime = time || currentTime;
                              executionTime = currentTime - previousTime;
                              time = currentTime;
                              performance.push({
                                  'Name': message[0],
                                  'Arguments': [].slice.call(message, 1) || '',
                                  'Element': element,
                                  'Execution Time': executionTime
                              });
                          }
                          clearTimeout(module.performance.timer);
                          module.performance.timer = setTimeout(module.performance.display, 100);
                      },
                      display: function () {
                          var
                            title = settings.name + ':',
                            totalTime = 0
                          ;
                          time = false;
                          clearTimeout(module.performance.timer);
                          $.each(performance, function (index, data) {
                              totalTime += data['Execution Time'];
                          });
                          title += ' ' + totalTime + 'ms';
                          if (moduleSelector) {
                              title += ' \'' + moduleSelector + '\'';
                          }
                          if ($allModules.length > 1) {
                              title += ' ' + '(' + $allModules.length + ')';
                          }
                          if ((console.group !== undefined || console.table !== undefined) && performance.length > 0) {
                              console.groupCollapsed(title);
                              if (console.table) {
                                  console.table(performance);
                              }
                              else {
                                  $.each(performance, function (index, data) {
                                      console.log(data['Name'] + ': ' + data['Execution Time'] + 'ms');
                                  });
                              }
                              console.groupEnd();
                          }
                          performance = [];
                      }
                  },
                  invoke: function (query, passedArguments, context) {
                      var
                        object = instance,
                        maxDepth,
                        found,
                        response
                      ;
                      passedArguments = passedArguments || queryArguments;
                      context = element || context;
                      if (typeof query == 'string' && object !== undefined) {
                          query = query.split(/[\. ]/);
                          maxDepth = query.length - 1;
                          $.each(query, function (depth, value) {
                              var camelCaseValue = (depth != maxDepth)
                                ? value + query[depth + 1].charAt(0).toUpperCase() + query[depth + 1].slice(1)
                                : query
                              ;
                              if ($.isPlainObject(object[camelCaseValue]) && (depth != maxDepth)) {
                                  object = object[camelCaseValue];
                              }
                              else if (object[camelCaseValue] !== undefined) {
                                  found = object[camelCaseValue];
                                  return false;
                              }
                              else if ($.isPlainObject(object[value]) && (depth != maxDepth)) {
                                  object = object[value];
                              }
                              else if (object[value] !== undefined) {
                                  found = object[value];
                                  return false;
                              }
                              else {
                                  return false;
                              }
                          });
                      }
                      if ($.isFunction(found)) {
                          response = found.apply(context, passedArguments);
                      }
                      else if (found !== undefined) {
                          response = found;
                      }
                      if ($.isArray(returnedValue)) {
                          returnedValue.push(response);
                      }
                      else if (returnedValue !== undefined) {
                          returnedValue = [returnedValue, response];
                      }
                      else if (response !== undefined) {
                          returnedValue = response;
                      }
                      return found;
                  }
              };
              if (methodInvoked) {
                  if (instance === undefined) {
                      module.initialize();
                  }
                  module.invoke(query);
              }
              else {
                  if (instance !== undefined) {
                      instance.invoke('destroy');
                  }
                  module.initialize();
              }

          })
        ;

        return (returnedValue !== undefined)
          ? returnedValue
          : this
        ;
    };

    $.fn.search.settings = {

        name: 'Search Module',
        namespace: 'search',

        debug: false,
        verbose: true,
        performance: true,

        type: 'standard',
        minCharacters: 1,

        // api config
        apiSettings: false,

        source: false,
        searchFields: [
          'title',
          'description'
        ],
        searchFullText: true,

        automatic: 'true',
        hideDelay: 0,
        searchDelay: 100,
        maxResults: 7,
        cache: true,

        transition: 'scale',
        duration: 300,
        easing: 'easeOutExpo',

        onSelect: false,
        onResultsAdd: false,

        onSearchQuery: function () { },
        onResults: function (response) { },

        onResultsOpen: function () { },
        onResultsClose: function () { },

        className: {
            active: 'active',
            empty: 'empty',
            focus: 'focus',
            loading: 'loading',
            pressed: 'down'
        },

        error: {
            source: 'Cannot search. No source used, and Semantic API module was not included',
            noResults: 'Your search returned no results',
            logging: 'Error in debug logging, exiting.',
            noEndpoint: 'No search endpoint was specified',
            noTemplate: 'A valid template name was not specified.',
            serverError: 'There was an issue with querying the server.',
            maxResults: 'Results must be an array to use maxResults setting',
            method: 'The method you called is not defined.'
        },

        metadata: {
            cache: 'cache',
            results: 'results'
        },

        regExp: {
            escape: /[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g,
            exact: '(?:\s|^)'
        },

        selector: {
            prompt: '.prompt',
            searchButton: '.search.button',
            results: '.results',
            category: '.category',
            result: '.result',
            title: '.title, .name'
        },

        templates: {
            escape: function (string) {
                var
                  badChars = /[&<>"'`]/g,
                  shouldEscape = /[&<>"'`]/,
                  escape = {
                      "&": "&amp;",
                      "<": "&lt;",
                      ">": "&gt;",
                      '"': "&quot;",
                      "'": "&#x27;",
                      "`": "&#x60;"
                  },
                  escapedChar = function (chr) {
                      return escape[chr];
                  }
                ;
                if (shouldEscape.test(string)) {
                    return string.replace(badChars, escapedChar);
                }
                return string;
            },
            message: function (message, type) {
                var
                  html = ''
                ;
                if (message !== undefined && type !== undefined) {
                    html += ''
                      + '<div class="message ' + type + '">'
                    ;
                    // message type
                    if (type == 'empty') {
                        html += ''
                          + '<div class="header">No Results</div class="header">'
                          + '<div class="description">' + message + '</div class="description">'
                        ;
                    }
                    else {
                        html += ' <div class="description">' + message + '</div>';
                    }
                    html += '</div>';
                }
                return html;
            },
            category: function (response) {
                var
                  html = '',
                  escape = $.fn.search.settings.templates.escape
                ;
                if (response.results !== undefined) {
                    // each category
                    $.each(response.results, function (index, category) {
                        if (category.results !== undefined && category.results.length > 0) {
                            html += ''
                              + '<div class="category">'
                              + '<div class="name">' + category.name + '</div>'
                            ;
                            // each item inside category
                            $.each(category.results, function (index, result) {
                                html += '<div class="result">';
                                if (result.url) {
                                    html += '<a href="' + result.url + '"></a>';
                                }
                                if (result.image !== undefined) {
                                    result.image = escape(result.image);
                                    html += ''
                                      + '<div class="image">'
                                      + ' <img src="' + result.image + '" alt="">'
                                      + '</div>'
                                    ;
                                }
                                html += '<div class="content">';
                                if (result.price !== undefined) {
                                    result.price = escape(result.price);
                                    html += '<div class="price">' + result.price + '</div>';
                                }
                                if (result.title !== undefined) {
                                    result.title = escape(result.title);
                                    html += '<div class="title">' + result.title + '</div>';
                                }
                                if (result.description !== undefined) {
                                    html += '<div class="description">' + result.description + '</div>';
                                }
                                html += ''
                                  + '</div>'
                                  + '</div>'
                                ;
                            });
                            html += ''
                              + '</div>'
                            ;
                        }
                    });
                    if (response.action) {
                        html += ''
                        + '<a href="' + response.action.url + '" class="action">'
                        + response.action.text
                        + '</a>';
                    }
                    return html;
                }
                return false;
            },
            standard: function (response) {
                var
                  html = ''
                ;
                if (response.results !== undefined) {

                    // each result
                    $.each(response.results, function (index, result) {
                        if (result.url) {
                            html += '<a class="result" href="' + result.url + '">';
                        }
                        else {
                            html += '<a class="result">';
                        }
                        if (result.image !== undefined) {
                            html += ''
                              + '<div class="image">'
                              + ' <img src="' + result.image + '">'
                              + '</div>'
                            ;
                        }
                        html += '<div class="content">';
                        if (result.price !== undefined) {
                            html += '<div class="price">' + result.price + '</div>';
                        }
                        if (result.title !== undefined) {
                            html += '<div class="title">' + result.title + '</div>';
                        }
                        if (result.description !== undefined) {
                            html += '<div class="description">' + result.description + '</div>';
                        }
                        html += ''
                          + '</div>'
                        ;
                        html += '</a>';
                    });

                    if (response.action) {
                        html += ''
                        + '<a href="' + response.action.url + '" class="action">'
                        + response.action.text
                        + '</a>';
                    }
                    return html;
                }
                return false;
            }
        }
    };

})(jQuery, window, document);

/*!
 * # Semantic UI 1.12.1 - Shape
 * http://github.com/semantic-org/semantic-ui/
 *
 *
 * Copyright 2014 Contributors
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 *
 */

; (function ($, window, document, undefined) {

    "use strict";

    $.fn.shape = function (parameters) {
        var
          $allModules = $(this),
          $body = $('body'),

          time = new Date().getTime(),
          performance = [],

          query = arguments[0],
          methodInvoked = (typeof query == 'string'),
          queryArguments = [].slice.call(arguments, 1),

          requestAnimationFrame = window.requestAnimationFrame
            || window.mozRequestAnimationFrame
            || window.webkitRequestAnimationFrame
            || window.msRequestAnimationFrame
            || function (callback) { setTimeout(callback, 0); },

          returnedValue
        ;

        $allModules
          .each(function () {
              var
                moduleSelector = $allModules.selector || '',
                settings = $.extend(true, {}, $.fn.shape.settings, parameters),

                // internal aliases
                namespace = settings.namespace,
                selector = settings.selector,
                error = settings.error,
                className = settings.className,

                // define namespaces for modules
                eventNamespace = '.' + namespace,
                moduleNamespace = 'module-' + namespace,

                // selector cache
                $module = $(this),
                $sides = $module.find(selector.sides),
                $side = $module.find(selector.side),

                // private variables
                nextIndex = false,
                $activeSide,
                $nextSide,

                // standard module
                element = this,
                instance = $module.data(moduleNamespace),
                module
              ;

              module = {

                  initialize: function () {
                      module.verbose('Initializing module for', element);
                      module.set.defaultSide();
                      module.instantiate();
                  },

                  instantiate: function () {
                      module.verbose('Storing instance of module', module);
                      instance = module;
                      $module
                        .data(moduleNamespace, instance)
                      ;
                  },

                  destroy: function () {
                      module.verbose('Destroying previous module for', element);
                      $module
                        .removeData(moduleNamespace)
                        .off(eventNamespace)
                      ;
                  },

                  refresh: function () {
                      module.verbose('Refreshing selector cache for', element);
                      $module = $(element);
                      $sides = $(this).find(selector.shape);
                      $side = $(this).find(selector.side);
                  },

                  repaint: function () {
                      module.verbose('Forcing repaint event');
                      var
                        shape = $sides.get(0) || document.createElement('div'),
                        fakeAssignment = shape.offsetWidth
                      ;
                  },

                  animate: function (propertyObject, callback) {
                      module.verbose('Animating box with properties', propertyObject);
                      callback = callback || function (event) {
                          module.verbose('Executing animation callback');
                          if (event !== undefined) {
                              event.stopPropagation();
                          }
                          module.reset();
                          module.set.active();
                      };
                      settings.beforeChange.call($nextSide.get());
                      if (module.get.transitionEvent()) {
                          module.verbose('Starting CSS animation');
                          $module
                            .addClass(className.animating)
                          ;
                          $sides
                            .css(propertyObject)
                            .one(module.get.transitionEvent(), callback)
                          ;
                          module.set.duration(settings.duration);
                          requestAnimationFrame(function () {
                              $module
                                .addClass(className.animating)
                              ;
                              $activeSide
                                .addClass(className.hidden)
                              ;
                          });
                      }
                      else {
                          callback();
                      }
                  },

                  queue: function (method) {
                      module.debug('Queueing animation of', method);
                      $sides
                        .one(module.get.transitionEvent(), function () {
                            module.debug('Executing queued animation');
                            setTimeout(function () {
                                $module.shape(method);
                            }, 0);
                        })
                      ;
                  },

                  reset: function () {
                      module.verbose('Animating states reset');
                      $module
                        .removeClass(className.animating)
                        .attr('style', '')
                        .removeAttr('style')
                      ;
                      // removeAttr style does not consistently work in safari
                      $sides
                        .attr('style', '')
                        .removeAttr('style')
                      ;
                      $side
                        .attr('style', '')
                        .removeAttr('style')
                        .removeClass(className.hidden)
                      ;
                      $nextSide
                        .removeClass(className.animating)
                        .attr('style', '')
                        .removeAttr('style')
                      ;
                  },

                  is: {
                      complete: function () {
                          return ($side.filter('.' + className.active)[0] == $nextSide[0]);
                      },
                      animating: function () {
                          return $module.hasClass(className.animating);
                      }
                  },

                  set: {

                      defaultSide: function () {
                          $activeSide = $module.find('.' + settings.className.active);
                          $nextSide = ($activeSide.next(selector.side).length > 0)
                            ? $activeSide.next(selector.side)
                            : $module.find(selector.side).first()
                          ;
                          nextIndex = false;
                          module.verbose('Active side set to', $activeSide);
                          module.verbose('Next side set to', $nextSide);
                      },

                      duration: function (duration) {
                          duration = duration || settings.duration;
                          duration = (typeof duration == 'number')
                            ? duration + 'ms'
                            : duration
                          ;
                          module.verbose('Setting animation duration', duration);
                          $sides.add($side)
                            .css({
                                '-webkit-transition-duration': duration,
                                '-moz-transition-duration': duration,
                                '-ms-transition-duration': duration,
                                '-o-transition-duration': duration,
                                'transition-duration': duration
                            })
                          ;
                      },

                      stageSize: function () {
                          var
                            $clone = $module.clone().addClass(className.loading),
                            $activeSide = $clone.find('.' + settings.className.active),
                            $nextSide = (nextIndex)
                              ? $clone.find(selector.side).eq(nextIndex)
                              : ($activeSide.next(selector.side).length > 0)
                                ? $activeSide.next(selector.side)
                                : $clone.find(selector.side).first(),
                            newSize = {}
                          ;
                          $activeSide.removeClass(className.active);
                          $nextSide.addClass(className.active);
                          $clone.insertAfter($module);
                          newSize = {
                              width: $nextSide.outerWidth(),
                              height: $nextSide.outerHeight()
                          };
                          $clone.remove();
                          $module
                            .css(newSize)
                          ;
                          module.verbose('Resizing stage to fit new content', newSize);
                      },

                      nextSide: function (selector) {
                          nextIndex = selector;
                          $nextSide = $side.filter(selector);
                          nextIndex = $side.index($nextSide);
                          if ($nextSide.length === 0) {
                              module.set.defaultSide();
                              module.error(error.side);
                          }
                          module.verbose('Next side manually set to', $nextSide);
                      },

                      active: function () {
                          module.verbose('Setting new side to active', $nextSide);
                          $side
                            .removeClass(className.active)
                          ;
                          $nextSide
                            .addClass(className.active)
                          ;
                          settings.onChange.call($nextSide.get());
                          module.set.defaultSide();
                      }
                  },

                  flip: {

                      up: function () {
                          if (module.is.complete() && !module.is.animating() && !settings.allowRepeats) {
                              module.debug('Side already visible', $nextSide);
                              return;
                          }
                          if (!module.is.animating()) {
                              module.debug('Flipping up', $nextSide);
                              module.set.stageSize();
                              module.stage.above();
                              module.animate(module.get.transform.up());
                          }
                          else {
                              module.queue('flip up');
                          }
                      },

                      down: function () {
                          if (module.is.complete() && !module.is.animating() && !settings.allowRepeats) {
                              module.debug('Side already visible', $nextSide);
                              return;
                          }
                          if (!module.is.animating()) {
                              module.debug('Flipping down', $nextSide);
                              module.set.stageSize();
                              module.stage.below();
                              module.animate(module.get.transform.down());
                          }
                          else {
                              module.queue('flip down');
                          }
                      },

                      left: function () {
                          if (module.is.complete() && !module.is.animating() && !settings.allowRepeats) {
                              module.debug('Side already visible', $nextSide);
                              return;
                          }
                          if (!module.is.animating()) {
                              module.debug('Flipping left', $nextSide);
                              module.set.stageSize();
                              module.stage.left();
                              module.animate(module.get.transform.left());
                          }
                          else {
                              module.queue('flip left');
                          }
                      },

                      right: function () {
                          if (module.is.complete() && !module.is.animating() && !settings.allowRepeats) {
                              module.debug('Side already visible', $nextSide);
                              return;
                          }
                          if (!module.is.animating()) {
                              module.debug('Flipping right', $nextSide);
                              module.set.stageSize();
                              module.stage.right();
                              module.animate(module.get.transform.right());
                          }
                          else {
                              module.queue('flip right');
                          }
                      },

                      over: function () {
                          if (module.is.complete() && !module.is.animating() && !settings.allowRepeats) {
                              module.debug('Side already visible', $nextSide);
                              return;
                          }
                          if (!module.is.animating()) {
                              module.debug('Flipping over', $nextSide);
                              module.set.stageSize();
                              module.stage.behind();
                              module.animate(module.get.transform.over());
                          }
                          else {
                              module.queue('flip over');
                          }
                      },

                      back: function () {
                          if (module.is.complete() && !module.is.animating() && !settings.allowRepeats) {
                              module.debug('Side already visible', $nextSide);
                              return;
                          }
                          if (!module.is.animating()) {
                              module.debug('Flipping back', $nextSide);
                              module.set.stageSize();
                              module.stage.behind();
                              module.animate(module.get.transform.back());
                          }
                          else {
                              module.queue('flip back');
                          }
                      }

                  },

                  get: {

                      transform: {
                          up: function () {
                              var
                                translate = {
                                    y: -(($activeSide.outerHeight() - $nextSide.outerHeight()) / 2),
                                    z: -($activeSide.outerHeight() / 2)
                                }
                              ;
                              return {
                                  transform: 'translateY(' + translate.y + 'px) translateZ(' + translate.z + 'px) rotateX(-90deg)'
                              };
                          },

                          down: function () {
                              var
                                translate = {
                                    y: -(($activeSide.outerHeight() - $nextSide.outerHeight()) / 2),
                                    z: -($activeSide.outerHeight() / 2)
                                }
                              ;
                              return {
                                  transform: 'translateY(' + translate.y + 'px) translateZ(' + translate.z + 'px) rotateX(90deg)'
                              };
                          },

                          left: function () {
                              var
                                translate = {
                                    x: -(($activeSide.outerWidth() - $nextSide.outerWidth()) / 2),
                                    z: -($activeSide.outerWidth() / 2)
                                }
                              ;
                              return {
                                  transform: 'translateX(' + translate.x + 'px) translateZ(' + translate.z + 'px) rotateY(90deg)'
                              };
                          },

                          right: function () {
                              var
                                translate = {
                                    x: -(($activeSide.outerWidth() - $nextSide.outerWidth()) / 2),
                                    z: -($activeSide.outerWidth() / 2)
                                }
                              ;
                              return {
                                  transform: 'translateX(' + translate.x + 'px) translateZ(' + translate.z + 'px) rotateY(-90deg)'
                              };
                          },

                          over: function () {
                              var
                                translate = {
                                    x: -(($activeSide.outerWidth() - $nextSide.outerWidth()) / 2)
                                }
                              ;
                              return {
                                  transform: 'translateX(' + translate.x + 'px) rotateY(180deg)'
                              };
                          },

                          back: function () {
                              var
                                translate = {
                                    x: -(($activeSide.outerWidth() - $nextSide.outerWidth()) / 2)
                                }
                              ;
                              return {
                                  transform: 'translateX(' + translate.x + 'px) rotateY(-180deg)'
                              };
                          }
                      },

                      transitionEvent: function () {
                          var
                            element = document.createElement('element'),
                            transitions = {
                                'transition': 'transitionend',
                                'OTransition': 'oTransitionEnd',
                                'MozTransition': 'transitionend',
                                'WebkitTransition': 'webkitTransitionEnd'
                            },
                            transition
                          ;
                          for (transition in transitions) {
                              if (element.style[transition] !== undefined) {
                                  return transitions[transition];
                              }
                          }
                      },

                      nextSide: function () {
                          return ($activeSide.next(selector.side).length > 0)
                            ? $activeSide.next(selector.side)
                            : $module.find(selector.side).first()
                          ;
                      }

                  },

                  stage: {

                      above: function () {
                          var
                            box = {
                                origin: (($activeSide.outerHeight() - $nextSide.outerHeight()) / 2),
                                depth: {
                                    active: ($nextSide.outerHeight() / 2),
                                    next: ($activeSide.outerHeight() / 2)
                                }
                            }
                          ;
                          module.verbose('Setting the initial animation position as above', $nextSide, box);
                          $activeSide
                            .css({
                                'transform': 'rotateY(0deg) translateZ(' + box.depth.active + 'px)'
                            })
                          ;
                          $nextSide
                            .addClass(className.animating)
                            .css({
                                'display': 'block',
                                'top': box.origin + 'px',
                                'transform': 'rotateX(90deg) translateZ(' + box.depth.next + 'px)'
                            })
                          ;
                      },

                      below: function () {
                          var
                            box = {
                                origin: (($activeSide.outerHeight() - $nextSide.outerHeight()) / 2),
                                depth: {
                                    active: ($nextSide.outerHeight() / 2),
                                    next: ($activeSide.outerHeight() / 2)
                                }
                            }
                          ;
                          module.verbose('Setting the initial animation position as below', $nextSide, box);
                          $activeSide
                            .css({
                                'transform': 'rotateY(0deg) translateZ(' + box.depth.active + 'px)'
                            })
                          ;
                          $nextSide
                            .addClass(className.animating)
                            .css({
                                'display': 'block',
                                'top': box.origin + 'px',
                                'transform': 'rotateX(-90deg) translateZ(' + box.depth.next + 'px)'
                            })
                          ;
                      },

                      left: function () {
                          var
                            box = {
                                origin: (($activeSide.outerWidth() - $nextSide.outerWidth()) / 2),
                                depth: {
                                    active: ($nextSide.outerWidth() / 2),
                                    next: ($activeSide.outerWidth() / 2)
                                }
                            }
                          ;
                          module.verbose('Setting the initial animation position as left', $nextSide, box);
                          $activeSide
                            .css({
                                'transform': 'rotateY(0deg) translateZ(' + box.depth.active + 'px)'
                            })
                          ;
                          $nextSide
                            .addClass(className.animating)
                            .css({
                                'display': 'block',
                                'left': box.origin + 'px',
                                'transform': 'rotateY(-90deg) translateZ(' + box.depth.next + 'px)'
                            })
                          ;
                      },

                      right: function () {
                          var
                            box = {
                                origin: (($activeSide.outerWidth() - $nextSide.outerWidth()) / 2),
                                depth: {
                                    active: ($nextSide.outerWidth() / 2),
                                    next: ($activeSide.outerWidth() / 2)
                                }
                            }
                          ;
                          module.verbose('Setting the initial animation position as left', $nextSide, box);
                          $activeSide
                            .css({
                                'transform': 'rotateY(0deg) translateZ(' + box.depth.active + 'px)'
                            })
                          ;
                          $nextSide
                            .addClass(className.animating)
                            .css({
                                'display': 'block',
                                'left': box.origin + 'px',
                                'transform': 'rotateY(90deg) translateZ(' + box.depth.next + 'px)'
                            })
                          ;
                      },

                      behind: function () {
                          var
                            box = {
                                origin: (($activeSide.outerWidth() - $nextSide.outerWidth()) / 2),
                                depth: {
                                    active: ($nextSide.outerWidth() / 2),
                                    next: ($activeSide.outerWidth() / 2)
                                }
                            }
                          ;
                          module.verbose('Setting the initial animation position as behind', $nextSide, box);
                          $activeSide
                            .css({
                                'transform': 'rotateY(0deg)'
                            })
                          ;
                          $nextSide
                            .addClass(className.animating)
                            .css({
                                'display': 'block',
                                'left': box.origin + 'px',
                                'transform': 'rotateY(-180deg)'
                            })
                          ;
                      }
                  },
                  setting: function (name, value) {
                      module.debug('Changing setting', name, value);
                      if ($.isPlainObject(name)) {
                          $.extend(true, settings, name);
                      }
                      else if (value !== undefined) {
                          settings[name] = value;
                      }
                      else {
                          return settings[name];
                      }
                  },
                  internal: function (name, value) {
                      if ($.isPlainObject(name)) {
                          $.extend(true, module, name);
                      }
                      else if (value !== undefined) {
                          module[name] = value;
                      }
                      else {
                          return module[name];
                      }
                  },
                  debug: function () {
                      if (settings.debug) {
                          if (settings.performance) {
                              module.performance.log(arguments);
                          }
                          else {
                              module.debug = Function.prototype.bind.call(console.info, console, settings.name + ':');
                              module.debug.apply(console, arguments);
                          }
                      }
                  },
                  verbose: function () {
                      if (settings.verbose && settings.debug) {
                          if (settings.performance) {
                              module.performance.log(arguments);
                          }
                          else {
                              module.verbose = Function.prototype.bind.call(console.info, console, settings.name + ':');
                              module.verbose.apply(console, arguments);
                          }
                      }
                  },
                  error: function () {
                      module.error = Function.prototype.bind.call(console.error, console, settings.name + ':');
                      module.error.apply(console, arguments);
                  },
                  performance: {
                      log: function (message) {
                          var
                            currentTime,
                            executionTime,
                            previousTime
                          ;
                          if (settings.performance) {
                              currentTime = new Date().getTime();
                              previousTime = time || currentTime;
                              executionTime = currentTime - previousTime;
                              time = currentTime;
                              performance.push({
                                  'Name': message[0],
                                  'Arguments': [].slice.call(message, 1) || '',
                                  'Element': element,
                                  'Execution Time': executionTime
                              });
                          }
                          clearTimeout(module.performance.timer);
                          module.performance.timer = setTimeout(module.performance.display, 100);
                      },
                      display: function () {
                          var
                            title = settings.name + ':',
                            totalTime = 0
                          ;
                          time = false;
                          clearTimeout(module.performance.timer);
                          $.each(performance, function (index, data) {
                              totalTime += data['Execution Time'];
                          });
                          title += ' ' + totalTime + 'ms';
                          if (moduleSelector) {
                              title += ' \'' + moduleSelector + '\'';
                          }
                          if ($allModules.length > 1) {
                              title += ' ' + '(' + $allModules.length + ')';
                          }
                          if ((console.group !== undefined || console.table !== undefined) && performance.length > 0) {
                              console.groupCollapsed(title);
                              if (console.table) {
                                  console.table(performance);
                              }
                              else {
                                  $.each(performance, function (index, data) {
                                      console.log(data['Name'] + ': ' + data['Execution Time'] + 'ms');
                                  });
                              }
                              console.groupEnd();
                          }
                          performance = [];
                      }
                  },
                  invoke: function (query, passedArguments, context) {
                      var
                        object = instance,
                        maxDepth,
                        found,
                        response
                      ;
                      passedArguments = passedArguments || queryArguments;
                      context = element || context;
                      if (typeof query == 'string' && object !== undefined) {
                          query = query.split(/[\. ]/);
                          maxDepth = query.length - 1;
                          $.each(query, function (depth, value) {
                              var camelCaseValue = (depth != maxDepth)
                                ? value + query[depth + 1].charAt(0).toUpperCase() + query[depth + 1].slice(1)
                                : query
                              ;
                              if ($.isPlainObject(object[camelCaseValue]) && (depth != maxDepth)) {
                                  object = object[camelCaseValue];
                              }
                              else if (object[camelCaseValue] !== undefined) {
                                  found = object[camelCaseValue];
                                  return false;
                              }
                              else if ($.isPlainObject(object[value]) && (depth != maxDepth)) {
                                  object = object[value];
                              }
                              else if (object[value] !== undefined) {
                                  found = object[value];
                                  return false;
                              }
                              else {
                                  return false;
                              }
                          });
                      }
                      if ($.isFunction(found)) {
                          response = found.apply(context, passedArguments);
                      }
                      else if (found !== undefined) {
                          response = found;
                      }
                      if ($.isArray(returnedValue)) {
                          returnedValue.push(response);
                      }
                      else if (returnedValue !== undefined) {
                          returnedValue = [returnedValue, response];
                      }
                      else if (response !== undefined) {
                          returnedValue = response;
                      }
                      return found;
                  }
              };

              if (methodInvoked) {
                  if (instance === undefined) {
                      module.initialize();
                  }
                  module.invoke(query);
              }
              else {
                  if (instance !== undefined) {
                      instance.invoke('destroy');
                  }
                  module.initialize();
              }
          })
        ;

        return (returnedValue !== undefined)
          ? returnedValue
          : this
        ;
    };

    $.fn.shape.settings = {

        // module info
        name: 'Shape',

        // debug content outputted to console
        debug: false,

        // verbose debug output
        verbose: true,

        // performance data output
        performance: true,

        // event namespace
        namespace: 'shape',

        // callback occurs on side change
        beforeChange: function () { },
        onChange: function () { },

        // allow animation to same side
        allowRepeats: false,

        // animation duration
        duration: 700,

        // possible errors
        error: {
            side: 'You tried to switch to a side that does not exist.',
            method: 'The method you called is not defined'
        },

        // classnames used
        className: {
            animating: 'animating',
            hidden: 'hidden',
            loading: 'loading',
            active: 'active'
        },

        // selectors used
        selector: {
            sides: '.sides',
            side: '.side'
        }

    };


})(jQuery, window, document);
/*!
 * # Semantic UI 1.12.1 - Sidebar
 * http://github.com/semantic-org/semantic-ui/
 *
 *
 * Copyright 2014 Contributors
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 *
 */

; (function ($, window, document, undefined) {

    "use strict";

    $.fn.sidebar = function (parameters) {
        var
          $allModules = $(this),
          $window = $(window),
          $document = $(document),
          $html = $('html'),
          $head = $('head'),

          moduleSelector = $allModules.selector || '',

          time = new Date().getTime(),
          performance = [],

          query = arguments[0],
          methodInvoked = (typeof query == 'string'),
          queryArguments = [].slice.call(arguments, 1),

          requestAnimationFrame = window.requestAnimationFrame
            || window.mozRequestAnimationFrame
            || window.webkitRequestAnimationFrame
            || window.msRequestAnimationFrame
            || function (callback) { setTimeout(callback, 0); },

          returnedValue
        ;

        $allModules
          .each(function () {
              var
                settings = ($.isPlainObject(parameters))
                  ? $.extend(true, {}, $.fn.sidebar.settings, parameters)
                  : $.extend({}, $.fn.sidebar.settings),

                selector = settings.selector,
                className = settings.className,
                namespace = settings.namespace,
                regExp = settings.regExp,
                error = settings.error,

                eventNamespace = '.' + namespace,
                moduleNamespace = 'module-' + namespace,

                $module = $(this),
                $context = $(settings.context),

                $sidebars = $module.children(selector.sidebar),
                $fixed = $context.children(selector.fixed),
                $pusher = $context.children(selector.pusher),
                $style,

                element = this,
                instance = $module.data(moduleNamespace),

                elementNamespace,
                id,
                currentScroll,
                transitionEvent,

                module
              ;

              module = {

                  initialize: function () {
                      module.debug('Initializing sidebar', parameters);

                      module.create.id();

                      transitionEvent = module.get.transitionEvent();

                      // cache on initialize
                      if ((settings.useLegacy == 'auto' && module.is.legacy()) || settings.useLegacy === true) {
                          settings.transition = 'overlay';
                          settings.useLegacy = true;
                      }

                      if (module.is.ios()) {
                          module.set.ios();
                      }

                      // avoids locking rendering if initialized in onReady
                      if (settings.delaySetup) {
                          requestAnimationFrame(module.setup.layout);
                      }
                      else {
                          module.setup.layout();
                      }

                      module.instantiate();
                  },

                  instantiate: function () {
                      module.verbose('Storing instance of module', module);
                      instance = module;
                      $module
                        .data(moduleNamespace, module)
                      ;
                  },

                  create: {
                      id: function () {
                          id = (Math.random().toString(16) + '000000000').substr(2, 8);
                          elementNamespace = '.' + id;
                          module.verbose('Creating unique id for element', id);
                      }
                  },

                  destroy: function () {
                      module.verbose('Destroying previous module for', $module);
                      module.remove.direction();
                      $module
                        .off(eventNamespace)
                        .removeData(moduleNamespace)
                      ;
                      // bound by uuid
                      $context.off(elementNamespace);
                      $window.off(elementNamespace);
                      $document.off(elementNamespace);
                  },

                  event: {
                      clickaway: function (event) {
                          var
                            clickedInPusher = ($pusher.find(event.target).length > 0 || $pusher.is(event.target)),
                            clickedContext = ($context.is(event.target))
                          ;
                          if (clickedInPusher) {
                              module.verbose('User clicked on dimmed page');
                              module.hide();
                          }
                          if (clickedContext) {
                              module.verbose('User clicked on dimmable context (scaled out page)');
                              module.hide();
                          }
                      },
                      touch: function (event) {
                          //event.stopPropagation();
                      },
                      containScroll: function (event) {
                          if (element.scrollTop <= 0) {
                              element.scrollTop = 1;
                          }
                          if ((element.scrollTop + element.offsetHeight) >= element.scrollHeight) {
                              element.scrollTop = element.scrollHeight - element.offsetHeight - 1;
                          }
                      },
                      scroll: function (event) {
                          if ($(event.target).closest(selector.sidebar).length === 0) {
                              event.preventDefault();
                          }
                      }
                  },

                  bind: {
                      clickaway: function () {
                          module.verbose('Adding clickaway events to context', $context);
                          if (settings.closable) {
                              $context
                                .on('click' + elementNamespace, module.event.clickaway)
                                .on('touchend' + elementNamespace, module.event.clickaway)
                              ;
                          }
                      },
                      scrollLock: function () {
                          if (settings.scrollLock) {
                              module.debug('Disabling page scroll');
                              $window
                                .on('DOMMouseScroll' + elementNamespace, module.event.scroll)
                              ;
                          }
                          module.verbose('Adding events to contain sidebar scroll');
                          $document
                            .on('touchmove' + elementNamespace, module.event.touch)
                          ;
                          $module
                            .on('scroll' + eventNamespace, module.event.containScroll)
                          ;
                      }
                  },
                  unbind: {
                      clickaway: function () {
                          module.verbose('Removing clickaway events from context', $context);
                          $context.off(elementNamespace);
                      },
                      scrollLock: function () {
                          module.verbose('Removing scroll lock from page');
                          $document.off(elementNamespace);
                          $window.off(elementNamespace);
                          $module.off('scroll' + eventNamespace);
                      }
                  },

                  add: {
                      bodyCSS: function () {
                          var
                            width = $module.outerWidth(),
                            height = $module.outerHeight(),
                            direction = module.get.direction(),
                            distance = {
                                left: width,
                                right: -width,
                                top: height,
                                bottom: -height
                            },
                            style
                          ;
                          if (module.is.rtl()) {
                              module.verbose('RTL detected, flipping widths');
                              distance.left = -width;
                              distance.right = width;
                          }

                          style = '<style title="' + namespace + '">';

                          if (direction === 'left' || direction === 'right') {
                              module.debug('Adding CSS rules for animation distance', width);
                              style += ''
                                + ' .ui.visible.' + direction + '.sidebar ~ .fixed,'
                                + ' .ui.visible.' + direction + '.sidebar ~ .pusher {'
                                + '   -webkit-transform: translate3d(' + distance[direction] + 'px, 0, 0);'
                                + '           transform: translate3d(' + distance[direction] + 'px, 0, 0);'
                                + ' }'
                              ;
                          }
                          else if (direction === 'top' || direction == 'bottom') {
                              style += ''
                                + ' .ui.visible.' + direction + '.sidebar ~ .fixed,'
                                + ' .ui.visible.' + direction + '.sidebar ~ .pusher {'
                                + '   -webkit-transform: translate3d(0, ' + distance[direction] + 'px, 0);'
                                + '           transform: translate3d(0, ' + distance[direction] + 'px, 0);'
                                + ' }'
                              ;
                          }

                          /* IE is only browser not to create context with transforms */
                          /* https://www.w3.org/Bugs/Public/show_bug.cgi?id=16328 */
                          if (module.is.ie()) {
                              if (direction === 'left' || direction === 'right') {
                                  module.debug('Adding CSS rules for animation distance', width);
                                  style += ''
                                    + ' body.pushable > .ui.visible.' + direction + '.sidebar ~ .pusher:after {'
                                    + '   -webkit-transform: translate3d(' + distance[direction] + 'px, 0, 0);'
                                    + '           transform: translate3d(' + distance[direction] + 'px, 0, 0);'
                                    + ' }'
                                  ;
                              }
                              else if (direction === 'top' || direction == 'bottom') {
                                  style += ''
                                    + ' body.pushable > .ui.visible.' + direction + '.sidebar ~ .pusher:after {'
                                    + '   -webkit-transform: translate3d(0, ' + distance[direction] + 'px, 0);'
                                    + '           transform: translate3d(0, ' + distance[direction] + 'px, 0);'
                                    + ' }'
                                  ;
                              }
                              /* opposite sides visible forces content overlay */
                              style += ''
                                + ' body.pushable > .ui.visible.left.sidebar ~ .ui.visible.right.sidebar ~ .pusher:after,'
                                + ' body.pushable > .ui.visible.right.sidebar ~ .ui.visible.left.sidebar ~ .pusher:after {'
                                + '   -webkit-transform: translate3d(0px, 0, 0);'
                                + '           transform: translate3d(0px, 0, 0);'
                                + ' }'
                              ;
                          }
                          style += '</style>';
                          $head.append(style);
                          $style = $('style[title=' + namespace + ']');
                          module.debug('Adding sizing css to head', $style);
                      }
                  },

                  refresh: function () {
                      module.verbose('Refreshing selector cache');
                      $context = $(settings.context);
                      $sidebars = $context.children(selector.sidebar);
                      $pusher = $context.children(selector.pusher);
                      $fixed = $context.children(selector.fixed);
                  },

                  refreshSidebars: function () {
                      module.verbose('Refreshing other sidebars');
                      $sidebars = $context.children(selector.sidebar);
                  },

                  repaint: function () {
                      module.verbose('Forcing repaint event');
                      element.style.display = 'none';
                      element.offsetHeight;
                      element.scrollTop = element.scrollTop;
                      element.style.display = '';
                  },

                  setup: {
                      layout: function () {
                          if ($context.children(selector.pusher).length === 0) {
                              module.debug('Adding wrapper element for sidebar');
                              module.error(error.pusher);
                              $pusher = $('<div class="pusher" />');
                              $context
                                .children()
                                  .not(selector.omitted)
                                  .not($sidebars)
                                  .wrapAll($pusher)
                              ;
                              module.refresh();
                          }
                          if ($module.nextAll(selector.pusher).length === 0 || $module.nextAll(selector.pusher)[0] !== $pusher[0]) {
                              module.debug('Moved sidebar to correct parent element');
                              module.error(error.movedSidebar, element);
                              $module.detach().prependTo($context);
                              module.refresh();
                          }
                          module.set.pushable();
                          module.set.direction();
                      }
                  },

                  attachEvents: function (selector, event) {
                      var
                        $toggle = $(selector)
                      ;
                      event = $.isFunction(module[event])
                        ? module[event]
                        : module.toggle
                      ;
                      if ($toggle.length > 0) {
                          module.debug('Attaching sidebar events to element', selector, event);
                          $toggle
                            .on('click' + eventNamespace, event)
                          ;
                      }
                      else {
                          module.error(error.notFound, selector);
                      }
                  },

                  show: function (callback) {
                      var
                        animateMethod = (settings.useLegacy === true)
                          ? module.legacyPushPage
                          : module.pushPage
                      ;
                      callback = $.isFunction(callback)
                        ? callback
                        : function () { }
                      ;
                      if (module.is.hidden()) {
                          module.refreshSidebars();
                          if (settings.overlay) {
                              module.error(error.overlay);
                              settings.transition = 'overlay';
                          }
                          module.refresh();
                          if (module.othersActive()) {
                              module.debug('Other sidebars currently visible');
                              if (settings.exclusive) {
                                  // if not overlay queue animation after hide
                                  if (settings.transition != 'overlay') {
                                      module.hideOthers(module.show);
                                      return;
                                  }
                                  else {
                                      module.hideOthers();
                                  }
                              }
                              else {
                                  settings.transition = 'overlay';
                              }
                          }
                          animateMethod(function () {
                              callback.call(element);
                              settings.onShow.call(element);
                          });
                          settings.onChange.call(element);
                          settings.onVisible.call(element);
                      }
                      else {
                          module.debug('Sidebar is already visible');
                      }
                  },

                  hide: function (callback) {
                      var
                        animateMethod = (settings.useLegacy === true)
                          ? module.legacyPullPage
                          : module.pullPage
                      ;
                      callback = $.isFunction(callback)
                        ? callback
                        : function () { }
                      ;
                      if (module.is.visible() || module.is.animating()) {
                          module.debug('Hiding sidebar', callback);
                          module.refreshSidebars();
                          animateMethod(function () {
                              callback.call(element);
                              settings.onHidden.call(element);
                          });
                          settings.onChange.call(element);
                          settings.onHide.call(element);
                      }
                  },

                  othersAnimating: function () {
                      return ($sidebars.not($module).filter('.' + className.animating).length > 0);
                  },
                  othersVisible: function () {
                      return ($sidebars.not($module).filter('.' + className.visible).length > 0);
                  },
                  othersActive: function () {
                      return (module.othersVisible() || module.othersAnimating());
                  },

                  hideOthers: function (callback) {
                      var
                        $otherSidebars = $sidebars.not($module).filter('.' + className.visible),
                        sidebarCount = $otherSidebars.length,
                        callbackCount = 0
                      ;
                      callback = callback || function () { };
                      $otherSidebars
                        .sidebar('hide', function () {
                            callbackCount++;
                            if (callbackCount == sidebarCount) {
                                callback();
                            }
                        })
                      ;
                  },

                  toggle: function () {
                      module.verbose('Determining toggled direction');
                      if (module.is.hidden()) {
                          module.show();
                      }
                      else {
                          module.hide();
                      }
                  },

                  pushPage: function (callback) {
                      var
                        transition = module.get.transition(),
                        $transition = (transition == 'safe')
                          ? $context
                          : (transition === 'overlay' || module.othersActive())
                            ? $module
                            : $pusher,
                        animate,
                        transitionEnd
                      ;
                      callback = $.isFunction(callback)
                        ? callback
                        : function () { }
                      ;
                      if (settings.transition == 'scale down') {
                          module.scrollToTop();
                      }
                      module.set.transition(transition);
                      module.repaint();
                      animate = function () {
                          module.bind.clickaway();
                          module.add.bodyCSS();
                          module.set.animating();
                          module.set.visible();
                          if (!module.othersVisible()) {
                              if (settings.dimPage) {
                                  $pusher.addClass(className.dimmed);
                              }
                          }
                      };
                      transitionEnd = function (event) {
                          if (event.target == $transition[0]) {
                              $transition.off(transitionEvent + elementNamespace, transitionEnd);
                              module.remove.animating();
                              module.bind.scrollLock();
                              callback.call(element);
                          }
                      };
                      $transition.off(transitionEvent + elementNamespace);
                      $transition.on(transitionEvent + elementNamespace, transitionEnd);
                      requestAnimationFrame(animate);
                  },

                  pullPage: function (callback) {
                      var
                        transition = module.get.transition(),
                        $transition = (transition == 'safe')
                          ? $context
                          : (transition == 'overlay' || module.othersActive())
                            ? $module
                            : $pusher,
                        animate,
                        transitionEnd
                      ;
                      callback = $.isFunction(callback)
                        ? callback
                        : function () { }
                      ;
                      module.verbose('Removing context push state', module.get.direction());

                      module.set.transition(transition);
                      module.unbind.clickaway();
                      module.unbind.scrollLock();

                      animate = function () {
                          module.set.animating();
                          module.remove.visible();
                          if (settings.dimPage && !module.othersVisible()) {
                              $pusher.removeClass(className.dimmed);
                          }
                      };
                      transitionEnd = function (event) {
                          if (event.target == $transition[0]) {
                              $transition.off(transitionEvent + elementNamespace, transitionEnd);
                              module.remove.animating();
                              module.remove.transition();
                              module.remove.bodyCSS();
                              if (transition == 'scale down' || (settings.returnScroll && module.is.mobile())) {
                                  module.scrollBack();
                              }
                              callback.call(element);
                          }
                      };
                      $transition.off(transitionEvent + elementNamespace);
                      $transition.on(transitionEvent + elementNamespace, transitionEnd);
                      requestAnimationFrame(animate);
                  },

                  legacyPushPage: function (callback) {
                      var
                        distance = $module.width(),
                        direction = module.get.direction(),
                        properties = {}
                      ;
                      distance = distance || $module.width();
                      callback = $.isFunction(callback)
                        ? callback
                        : function () { }
                      ;
                      properties[direction] = distance;
                      module.debug('Using javascript to push context', properties);
                      module.set.visible();
                      module.set.transition();
                      module.set.animating();
                      if (settings.dimPage) {
                          $pusher.addClass(className.dimmed);
                      }
                      $context
                        .css('position', 'relative')
                        .animate(properties, settings.duration, settings.easing, function () {
                            module.remove.animating();
                            module.bind.clickaway();
                            callback.call(element);
                        })
                      ;
                  },
                  legacyPullPage: function (callback) {
                      var
                        distance = 0,
                        direction = module.get.direction(),
                        properties = {}
                      ;
                      distance = distance || $module.width();
                      callback = $.isFunction(callback)
                        ? callback
                        : function () { }
                      ;
                      properties[direction] = '0px';
                      module.debug('Using javascript to pull context', properties);
                      module.unbind.clickaway();
                      module.set.animating();
                      module.remove.visible();
                      if (settings.dimPage && !module.othersActive()) {
                          $pusher.removeClass(className.dimmed);
                      }
                      $context
                        .css('position', 'relative')
                        .animate(properties, settings.duration, settings.easing, function () {
                            module.remove.animating();
                            callback.call(element);
                        })
                      ;
                  },

                  scrollToTop: function () {
                      module.verbose('Scrolling to top of page to avoid animation issues');
                      currentScroll = $(window).scrollTop();
                      $module.scrollTop(0);
                      window.scrollTo(0, 0);
                  },

                  scrollBack: function () {
                      module.verbose('Scrolling back to original page position');
                      window.scrollTo(0, currentScroll);
                  },

                  set: {
                      // html
                      ios: function () {
                          $html.addClass(className.ios);
                      },

                      // container
                      pushed: function () {
                          $context.addClass(className.pushed);
                      },
                      pushable: function () {
                          $context.addClass(className.pushable);
                      },

                      // sidebar
                      active: function () {
                          $module.addClass(className.active);
                      },
                      animating: function () {
                          $module.addClass(className.animating);
                      },
                      transition: function (transition) {
                          transition = transition || module.get.transition();
                          $module.addClass(transition);
                      },
                      direction: function (direction) {
                          direction = direction || module.get.direction();
                          $module.addClass(className[direction]);
                      },
                      visible: function () {
                          $module.addClass(className.visible);
                      },
                      overlay: function () {
                          $module.addClass(className.overlay);
                      }
                  },
                  remove: {

                      bodyCSS: function () {
                          module.debug('Removing body css styles', $style);
                          if ($style && $style.length > 0) {
                              $style.remove();
                          }
                      },

                      // context
                      pushed: function () {
                          $context.removeClass(className.pushed);
                      },
                      pushable: function () {
                          $context.removeClass(className.pushable);
                      },

                      // sidebar
                      active: function () {
                          $module.removeClass(className.active);
                      },
                      animating: function () {
                          $module.removeClass(className.animating);
                      },
                      transition: function (transition) {
                          transition = transition || module.get.transition();
                          $module.removeClass(transition);
                      },
                      direction: function (direction) {
                          direction = direction || module.get.direction();
                          $module.removeClass(className[direction]);
                      },
                      visible: function () {
                          $module.removeClass(className.visible);
                      },
                      overlay: function () {
                          $module.removeClass(className.overlay);
                      }
                  },

                  get: {
                      direction: function () {
                          if ($module.hasClass(className.top)) {
                              return className.top;
                          }
                          else if ($module.hasClass(className.right)) {
                              return className.right;
                          }
                          else if ($module.hasClass(className.bottom)) {
                              return className.bottom;
                          }
                          return className.left;
                      },
                      transition: function () {
                          var
                            direction = module.get.direction(),
                            transition
                          ;
                          transition = (module.is.mobile())
                            ? (settings.mobileTransition == 'auto')
                              ? settings.defaultTransition.mobile[direction]
                              : settings.mobileTransition
                            : (settings.transition == 'auto')
                              ? settings.defaultTransition.computer[direction]
                              : settings.transition
                          ;
                          module.verbose('Determined transition', transition);
                          return transition;
                      },
                      transitionEvent: function () {
                          var
                            element = document.createElement('element'),
                            transitions = {
                                'transition': 'transitionend',
                                'OTransition': 'oTransitionEnd',
                                'MozTransition': 'transitionend',
                                'WebkitTransition': 'webkitTransitionEnd'
                            },
                            transition
                          ;
                          for (transition in transitions) {
                              if (element.style[transition] !== undefined) {
                                  return transitions[transition];
                              }
                          }
                      }
                  },

                  is: {

                      ie: function () {
                          var
                            isIE11 = (!(window.ActiveXObject) && 'ActiveXObject' in window),
                            isIE = ('ActiveXObject' in window)
                          ;
                          return (isIE11 || isIE);
                      },

                      legacy: function () {
                          var
                            element = document.createElement('div'),
                            transforms = {
                                'webkitTransform': '-webkit-transform',
                                'OTransform': '-o-transform',
                                'msTransform': '-ms-transform',
                                'MozTransform': '-moz-transform',
                                'transform': 'transform'
                            },
                            has3D
                          ;

                          // Add it to the body to get the computed style.
                          document.body.insertBefore(element, null);
                          for (var transform in transforms) {
                              if (element.style[transform] !== undefined) {
                                  element.style[transform] = "translate3d(1px,1px,1px)";
                                  has3D = window.getComputedStyle(element).getPropertyValue(transforms[transform]);
                              }
                          }
                          document.body.removeChild(element);
                          return !(has3D !== undefined && has3D.length > 0 && has3D !== 'none');
                      },
                      ios: function () {
                          var
                            userAgent = navigator.userAgent,
                            isIOS = userAgent.match(regExp.ios)
                          ;
                          if (isIOS) {
                              module.verbose('Browser was found to be iOS', userAgent);
                              return true;
                          }
                          else {
                              return false;
                          }
                      },
                      mobile: function () {
                          var
                            userAgent = navigator.userAgent,
                            isMobile = userAgent.match(regExp.mobile)
                          ;
                          if (isMobile) {
                              module.verbose('Browser was found to be mobile', userAgent);
                              return true;
                          }
                          else {
                              module.verbose('Browser is not mobile, using regular transition', userAgent);
                              return false;
                          }
                      },
                      hidden: function () {
                          return !module.is.visible();
                      },
                      visible: function () {
                          return $module.hasClass(className.visible);
                      },
                      // alias
                      open: function () {
                          return module.is.visible();
                      },
                      closed: function () {
                          return module.is.hidden();
                      },
                      vertical: function () {
                          return $module.hasClass(className.top);
                      },
                      animating: function () {
                          return $context.hasClass(className.animating);
                      },
                      rtl: function () {
                          return $module.css('direction') == 'rtl';
                      }
                  },

                  setting: function (name, value) {
                      module.debug('Changing setting', name, value);
                      if ($.isPlainObject(name)) {
                          $.extend(true, settings, name);
                      }
                      else if (value !== undefined) {
                          settings[name] = value;
                      }
                      else {
                          return settings[name];
                      }
                  },
                  internal: function (name, value) {
                      if ($.isPlainObject(name)) {
                          $.extend(true, module, name);
                      }
                      else if (value !== undefined) {
                          module[name] = value;
                      }
                      else {
                          return module[name];
                      }
                  },
                  debug: function () {
                      if (settings.debug) {
                          if (settings.performance) {
                              module.performance.log(arguments);
                          }
                          else {
                              module.debug = Function.prototype.bind.call(console.info, console, settings.name + ':');
                              module.debug.apply(console, arguments);
                          }
                      }
                  },
                  verbose: function () {
                      if (settings.verbose && settings.debug) {
                          if (settings.performance) {
                              module.performance.log(arguments);
                          }
                          else {
                              module.verbose = Function.prototype.bind.call(console.info, console, settings.name + ':');
                              module.verbose.apply(console, arguments);
                          }
                      }
                  },
                  error: function () {
                      module.error = Function.prototype.bind.call(console.error, console, settings.name + ':');
                      module.error.apply(console, arguments);
                  },
                  performance: {
                      log: function (message) {
                          var
                            currentTime,
                            executionTime,
                            previousTime
                          ;
                          if (settings.performance) {
                              currentTime = new Date().getTime();
                              previousTime = time || currentTime;
                              executionTime = currentTime - previousTime;
                              time = currentTime;
                              performance.push({
                                  'Name': message[0],
                                  'Arguments': [].slice.call(message, 1) || '',
                                  'Element': element,
                                  'Execution Time': executionTime
                              });
                          }
                          clearTimeout(module.performance.timer);
                          module.performance.timer = setTimeout(module.performance.display, 100);
                      },
                      display: function () {
                          var
                            title = settings.name + ':',
                            totalTime = 0
                          ;
                          time = false;
                          clearTimeout(module.performance.timer);
                          $.each(performance, function (index, data) {
                              totalTime += data['Execution Time'];
                          });
                          title += ' ' + totalTime + 'ms';
                          if (moduleSelector) {
                              title += ' \'' + moduleSelector + '\'';
                          }
                          if ((console.group !== undefined || console.table !== undefined) && performance.length > 0) {
                              console.groupCollapsed(title);
                              if (console.table) {
                                  console.table(performance);
                              }
                              else {
                                  $.each(performance, function (index, data) {
                                      console.log(data['Name'] + ': ' + data['Execution Time'] + 'ms');
                                  });
                              }
                              console.groupEnd();
                          }
                          performance = [];
                      }
                  },
                  invoke: function (query, passedArguments, context) {
                      var
                        object = instance,
                        maxDepth,
                        found,
                        response
                      ;
                      passedArguments = passedArguments || queryArguments;
                      context = element || context;
                      if (typeof query == 'string' && object !== undefined) {
                          query = query.split(/[\. ]/);
                          maxDepth = query.length - 1;
                          $.each(query, function (depth, value) {
                              var camelCaseValue = (depth != maxDepth)
                                ? value + query[depth + 1].charAt(0).toUpperCase() + query[depth + 1].slice(1)
                                : query
                              ;
                              if ($.isPlainObject(object[camelCaseValue]) && (depth != maxDepth)) {
                                  object = object[camelCaseValue];
                              }
                              else if (object[camelCaseValue] !== undefined) {
                                  found = object[camelCaseValue];
                                  return false;
                              }
                              else if ($.isPlainObject(object[value]) && (depth != maxDepth)) {
                                  object = object[value];
                              }
                              else if (object[value] !== undefined) {
                                  found = object[value];
                                  return false;
                              }
                              else {
                                  module.error(error.method, query);
                                  return false;
                              }
                          });
                      }
                      if ($.isFunction(found)) {
                          response = found.apply(context, passedArguments);
                      }
                      else if (found !== undefined) {
                          response = found;
                      }
                      if ($.isArray(returnedValue)) {
                          returnedValue.push(response);
                      }
                      else if (returnedValue !== undefined) {
                          returnedValue = [returnedValue, response];
                      }
                      else if (response !== undefined) {
                          returnedValue = response;
                      }
                      return found;
                  }
              }
              ;

              if (methodInvoked) {
                  if (instance === undefined) {
                      module.initialize();
                  }
                  module.invoke(query);
              }
              else {
                  if (instance !== undefined) {
                      module.invoke('destroy');
                  }
                  module.initialize();
              }
          });

        return (returnedValue !== undefined)
          ? returnedValue
          : this
        ;
    };

    $.fn.sidebar.settings = {

        name: 'Sidebar',
        namespace: 'sidebar',

        debug: false,
        verbose: true,
        performance: true,

        transition: 'auto',
        mobileTransition: 'auto',

        defaultTransition: {
            computer: {
                left: 'uncover',
                right: 'uncover',
                top: 'overlay',
                bottom: 'overlay'
            },
            mobile: {
                left: 'uncover',
                right: 'uncover',
                top: 'overlay',
                bottom: 'overlay'
            }
        },

        context: 'body',
        exclusive: false,
        closable: true,
        dimPage: true,
        scrollLock: false,
        returnScroll: false,
        delaySetup: false,

        useLegacy: 'auto',
        duration: 500,
        easing: 'easeInOutQuint',

        onChange: function () { },
        onShow: function () { },
        onHide: function () { },

        onHidden: function () { },
        onVisible: function () { },

        className: {
            active: 'active',
            animating: 'animating',
            dimmed: 'dimmed',
            ios: 'ios',
            pushable: 'pushable',
            pushed: 'pushed',
            right: 'right',
            top: 'top',
            left: 'left',
            bottom: 'bottom',
            visible: 'visible'
        },

        selector: {
            fixed: '.fixed',
            omitted: 'script, link, style, .ui.modal, .ui.dimmer, .ui.nag, .ui.fixed',
            pusher: '.pusher',
            sidebar: '.ui.sidebar'
        },

        regExp: {
            ios: /(iPad|iPhone|iPod)/g,
            mobile: /Mobile|iP(hone|od|ad)|Android|BlackBerry|IEMobile|Kindle|NetFront|Silk-Accelerated|(hpw|web)OS|Fennec|Minimo|Opera M(obi|ini)|Blazer|Dolfin|Dolphin|Skyfire|Zune/g
        },

        error: {
            method: 'The method you called is not defined.',
            pusher: 'Had to add pusher element. For optimal performance make sure body content is inside a pusher element',
            movedSidebar: 'Had to move sidebar. For optimal performance make sure sidebar and pusher are direct children of your body tag',
            overlay: 'The overlay setting is no longer supported, use animation: overlay',
            notFound: 'There were no elements that matched the specified selector'
        }

    };

    // Adds easing
    $.extend($.easing, {
        easeInOutQuint: function (x, t, b, c, d) {
            if ((t /= d / 2) < 1) return c / 2 * t * t * t * t * t + b;
            return c / 2 * ((t -= 2) * t * t * t * t + 2) + b;
        }
    });


})(jQuery, window, document);

/*!
 * # Semantic UI 1.12.1 - Sticky
 * http://github.com/semantic-org/semantic-ui/
 *
 *
 * Copyright 2014 Contributorss
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 *
 */

; (function ($, window, document, undefined) {

    "use strict";

    $.fn.sticky = function (parameters) {
        var
          $allModules = $(this),
          moduleSelector = $allModules.selector || '',

          time = new Date().getTime(),
          performance = [],

          query = arguments[0],
          methodInvoked = (typeof query == 'string'),
          queryArguments = [].slice.call(arguments, 1),
          returnedValue
        ;

        $allModules
          .each(function () {
              var
                settings = ($.isPlainObject(parameters))
                  ? $.extend(true, {}, $.fn.sticky.settings, parameters)
                  : $.extend({}, $.fn.sticky.settings),

                className = settings.className,
                namespace = settings.namespace,
                error = settings.error,

                eventNamespace = '.' + namespace,
                moduleNamespace = 'module-' + namespace,

                $module = $(this),
                $window = $(window),
                $container = $module.offsetParent(),
                $scroll = $(settings.scrollContext),
                $context,

                selector = $module.selector || '',
                instance = $module.data(moduleNamespace),

                requestAnimationFrame = window.requestAnimationFrame
                  || window.mozRequestAnimationFrame
                  || window.webkitRequestAnimationFrame
                  || window.msRequestAnimationFrame
                  || function (callback) { setTimeout(callback, 0); },

                element = this,
                observer,
                module
              ;

              module = {

                  initialize: function () {

                      module.determineContext();
                      module.verbose('Initializing sticky', settings, $container);

                      module.save.positions();
                      module.checkErrors();
                      module.bind.events();

                      if (settings.observeChanges) {
                          module.observeChanges();
                      }
                      module.instantiate();
                  },

                  instantiate: function () {
                      module.verbose('Storing instance of module', module);
                      instance = module;
                      $module
                        .data(moduleNamespace, module)
                      ;
                  },

                  destroy: function () {
                      module.verbose('Destroying previous instance');
                      module.reset();
                      if (observer) {
                          observer.disconnect();
                      }
                      $window
                        .off('load' + eventNamespace, module.event.load)
                        .off('resize' + eventNamespace, module.event.resize)
                      ;
                      $scroll
                        .off('scrollchange' + eventNamespace, module.event.scrollchange)
                      ;
                      $module.removeData(moduleNamespace);
                  },

                  observeChanges: function () {
                      var
                        context = $context[0]
                      ;
                      if ('MutationObserver' in window) {
                          observer = new MutationObserver(function (mutations) {
                              clearTimeout(module.timer);
                              module.timer = setTimeout(function () {
                                  module.verbose('DOM tree modified, updating sticky menu');
                                  module.refresh();
                              }, 100);
                          });
                          observer.observe(element, {
                              childList: true,
                              subtree: true
                          });
                          observer.observe(context, {
                              childList: true,
                              subtree: true
                          });
                          module.debug('Setting up mutation observer', observer);
                      }
                  },

                  determineContext: function () {
                      if (settings.context) {
                          $context = $(settings.context);
                      }
                      else {
                          $context = $container;
                      }
                      if ($context.length === 0) {
                          module.error(error.invalidContext, settings.context, $module);
                          return;
                      }
                  },

                  checkErrors: function () {
                      if (module.is.hidden()) {
                          module.error(error.visible, $module);
                      }
                      if (module.cache.element.height > module.cache.context.height) {
                          module.reset();
                          module.error(error.elementSize, $module);
                          return;
                      }
                  },

                  bind: {
                      events: function () {
                          $window
                            .on('load' + eventNamespace, module.event.load)
                            .on('resize' + eventNamespace, module.event.resize)
                          ;
                          // pub/sub pattern
                          $scroll
                            .off('scroll' + eventNamespace)
                            .on('scroll' + eventNamespace, module.event.scroll)
                            .on('scrollchange' + eventNamespace, module.event.scrollchange)
                          ;
                      }
                  },

                  event: {
                      load: function () {
                          module.verbose('Page contents finished loading');
                          requestAnimationFrame(module.refresh);
                      },
                      resize: function () {
                          module.verbose('Window resized');
                          requestAnimationFrame(module.refresh);
                      },
                      scroll: function () {
                          requestAnimationFrame(function () {
                              $scroll.trigger('scrollchange' + eventNamespace, $scroll.scrollTop());
                          });
                      },
                      scrollchange: function (event, scrollPosition) {
                          module.stick(scrollPosition);
                          settings.onScroll.call(element);
                      }
                  },

                  refresh: function (hardRefresh) {
                      module.reset();
                      if (hardRefresh) {
                          $container = $module.offsetParent();
                      }
                      module.save.positions();
                      module.stick();
                      settings.onReposition.call(element);
                  },

                  supports: {
                      sticky: function () {
                          var
                            $element = $('<div/>'),
                            element = $element.get()
                          ;
                          $element.addClass(className.supported);
                          return ($element.css('position').match('sticky'));
                      }
                  },

                  save: {
                      lastScroll: function (scroll) {
                          module.lastScroll = scroll;
                      },
                      positions: function () {
                          var
                            window = {
                                height: $window.height()
                            },
                            element = {
                                margin: {
                                    top: parseInt($module.css('margin-top'), 10),
                                    bottom: parseInt($module.css('margin-bottom'), 10),
                                },
                                offset: $module.offset(),
                                width: $module.outerWidth(),
                                height: $module.outerHeight()
                            },
                            context = {
                                offset: $context.offset(),
                                height: $context.outerHeight(),
                                bottomPadding: parseInt($context.css('padding-bottom'), 10)
                            }
                          ;
                          module.cache = {
                              fits: (element.height < window.height),
                              window: {
                                  height: window.height
                              },
                              element: {
                                  margin: element.margin,
                                  top: element.offset.top - element.margin.top,
                                  left: element.offset.left,
                                  width: element.width,
                                  height: element.height,
                                  bottom: element.offset.top + element.height
                              },
                              context: {
                                  top: context.offset.top,
                                  height: context.height,
                                  bottomPadding: context.bottomPadding,
                                  bottom: context.offset.top + context.height - context.bottomPadding
                              }
                          };
                          module.set.containerSize();
                          module.set.size();
                          module.stick();
                          module.debug('Caching element positions', module.cache);
                      }
                  },

                  get: {
                      direction: function (scroll) {
                          var
                            direction = 'down'
                          ;
                          scroll = scroll || $scroll.scrollTop();
                          if (module.lastScroll !== undefined) {
                              if (module.lastScroll < scroll) {
                                  direction = 'down';
                              }
                              else if (module.lastScroll > scroll) {
                                  direction = 'up';
                              }
                          }
                          return direction;
                      },
                      scrollChange: function (scroll) {
                          scroll = scroll || $scroll.scrollTop();
                          return (module.lastScroll)
                            ? (scroll - module.lastScroll)
                            : 0
                          ;
                      },
                      currentElementScroll: function () {
                          return (module.is.top())
                            ? Math.abs(parseInt($module.css('top'), 10)) || 0
                            : Math.abs(parseInt($module.css('bottom'), 10)) || 0
                          ;
                      },

                      elementScroll: function (scroll) {
                          scroll = scroll || $scroll.scrollTop();
                          var
                            element = module.cache.element,
                            window = module.cache.window,
                            delta = module.get.scrollChange(scroll),
                            maxScroll = (element.height - window.height + settings.offset),
                            elementScroll = module.get.currentElementScroll(),
                            possibleScroll = (elementScroll + delta),
                            elementScroll
                          ;
                          if (module.cache.fits || possibleScroll < 0) {
                              elementScroll = 0;
                          }
                          else if (possibleScroll > maxScroll) {
                              elementScroll = maxScroll;
                          }
                          else {
                              elementScroll = possibleScroll;
                          }
                          return elementScroll;
                      }
                  },

                  remove: {
                      offset: function () {
                          $module.css('margin-top', '');
                      }
                  },

                  set: {
                      offset: function () {
                          module.verbose('Setting offset on element', settings.offset);
                          $module.css('margin-top', settings.offset);
                      },
                      containerSize: function () {
                          var
                            tagName = $container.get(0).tagName
                          ;
                          if (tagName === 'HTML' || tagName == 'body') {
                              // this can trigger for too many reasons
                              //module.error(error.container, tagName, $module);
                              $container = $module.offsetParent();
                          }
                          else {
                              if (Math.abs($container.height() - module.cache.context.height) > 5) {
                                  module.debug('Context has padding, specifying exact height for container', module.cache.context.height);
                                  $container.css({
                                      height: module.cache.context.height
                                  });
                              }
                          }
                      },
                      scroll: function (scroll) {
                          module.debug('Setting scroll on element', scroll);
                          if (module.is.top()) {
                              $module
                                .css('bottom', '')
                                .css('top', -scroll)
                              ;
                          }
                          if (module.is.bottom()) {
                              $module
                                .css('top', '')
                                .css('bottom', scroll)
                              ;
                          }
                      },
                      size: function () {
                          if (module.cache.element.height !== 0 && module.cache.element.width !== 0) {
                              $module
                                .css({
                                    width: module.cache.element.width,
                                    height: module.cache.element.height
                                })
                              ;
                          }
                      }
                  },

                  is: {
                      top: function () {
                          return $module.hasClass(className.top);
                      },
                      bottom: function () {
                          return $module.hasClass(className.bottom);
                      },
                      initialPosition: function () {
                          return (!module.is.fixed() && !module.is.bound());
                      },
                      hidden: function () {
                          return (!$module.is(':visible'));
                      },
                      bound: function () {
                          return $module.hasClass(className.bound);
                      },
                      fixed: function () {
                          return $module.hasClass(className.fixed);
                      }
                  },

                  stick: function (scroll) {
                      var
                        cachedPosition = scroll || $scroll.scrollTop(),
                        cache = module.cache,
                        fits = cache.fits,
                        element = cache.element,
                        window = cache.window,
                        context = cache.context,
                        offset = (module.is.bottom() && settings.pushing)
                          ? settings.bottomOffset
                          : settings.offset,
                        scroll = {
                            top: cachedPosition + offset,
                            bottom: cachedPosition + offset + window.height
                        },
                        direction = module.get.direction(scroll.top),
                        elementScroll = (fits)
                          ? 0
                          : module.get.elementScroll(scroll.top),

                        // shorthand
                        doesntFit = !fits,
                        elementVisible = (element.height !== 0)
                      ;

                      // save current scroll for next run
                      module.save.lastScroll(scroll.top);

                      if (elementVisible) {

                          if (module.is.initialPosition()) {
                              if (scroll.top >= context.bottom) {
                                  module.debug('Element bottom of container');
                                  module.bindBottom();
                              }
                              else if (scroll.top >= element.top) {
                                  module.debug('Element passed, fixing element to page');
                                  module.fixTop();
                              }
                          }
                          else if (module.is.fixed()) {

                              // currently fixed top
                              if (module.is.top()) {
                                  if (scroll.top < element.top) {
                                      module.debug('Fixed element reached top of container');
                                      module.setInitialPosition();
                                  }
                                  else if ((element.height + scroll.top - elementScroll) > context.bottom) {
                                      module.debug('Fixed element reached bottom of container');
                                      module.bindBottom();
                                  }
                                      // scroll element if larger than screen
                                  else if (doesntFit) {
                                      module.set.scroll(elementScroll);
                                  }
                              }

                                  // currently fixed bottom
                              else if (module.is.bottom()) {

                                  // top edge
                                  if ((scroll.bottom - element.height) < element.top) {
                                      module.debug('Bottom fixed rail has reached top of container');
                                      module.setInitialPosition();
                                  }
                                      // bottom edge
                                  else if (scroll.bottom > context.bottom) {
                                      module.debug('Bottom fixed rail has reached bottom of container');
                                      module.bindBottom();
                                  }
                                      // scroll element if larger than screen
                                  else if (doesntFit) {
                                      module.set.scroll(elementScroll);
                                  }

                              }
                          }
                          else if (module.is.bottom()) {
                              if (settings.pushing) {
                                  if (module.is.bound() && scroll.bottom < context.bottom) {
                                      module.debug('Fixing bottom attached element to bottom of browser.');
                                      module.fixBottom();
                                  }
                              }
                              else {
                                  if (module.is.bound() && (scroll.top < context.bottom - element.height)) {
                                      module.debug('Fixing bottom attached element to top of browser.');
                                      module.fixTop();
                                  }
                              }
                          }
                      }
                  },

                  bindTop: function () {
                      module.debug('Binding element to top of parent container');
                      module.remove.offset();
                      $module
                        .css('left', '')
                        .css('top', '')
                        .css('margin-bottom', '')
                        .removeClass(className.fixed)
                        .removeClass(className.bottom)
                        .addClass(className.bound)
                        .addClass(className.top)
                      ;
                      settings.onTop.call(element);
                      settings.onUnstick.call(element);
                  },
                  bindBottom: function () {
                      module.debug('Binding element to bottom of parent container');
                      module.remove.offset();
                      $module
                        .css('left', '')
                        .css('top', '')
                        .css('margin-bottom', module.cache.context.bottomPadding)
                        .removeClass(className.fixed)
                        .removeClass(className.top)
                        .addClass(className.bound)
                        .addClass(className.bottom)
                      ;
                      settings.onBottom.call(element);
                      settings.onUnstick.call(element);
                  },

                  setInitialPosition: function () {
                      module.unfix();
                      module.unbind();
                  },


                  fixTop: function () {
                      module.debug('Fixing element to top of page');
                      module.set.offset();
                      $module
                        .css('left', module.cache.element.left)
                        .css('bottom', '')
                        .removeClass(className.bound)
                        .removeClass(className.bottom)
                        .addClass(className.fixed)
                        .addClass(className.top)
                      ;
                      settings.onStick.call(element);
                  },

                  fixBottom: function () {
                      module.debug('Sticking element to bottom of page');
                      module.set.offset();
                      $module
                        .css('left', module.cache.element.left)
                        .css('bottom', '')
                        .removeClass(className.bound)
                        .removeClass(className.top)
                        .addClass(className.fixed)
                        .addClass(className.bottom)
                      ;
                      settings.onStick.call(element);
                  },

                  unbind: function () {
                      module.debug('Removing absolute position on element');
                      module.remove.offset();
                      $module
                        .removeClass(className.bound)
                        .removeClass(className.top)
                        .removeClass(className.bottom)
                      ;
                  },

                  unfix: function () {
                      module.debug('Removing fixed position on element');
                      module.remove.offset();
                      $module
                        .removeClass(className.fixed)
                        .removeClass(className.top)
                        .removeClass(className.bottom)
                      ;
                      settings.onUnstick.call(element);
                  },

                  reset: function () {
                      module.debug('Reseting elements position');
                      module.unbind();
                      module.unfix();
                      module.resetCSS();
                      module.remove.offset();
                  },

                  resetCSS: function () {
                      $module
                        .css({
                            width: '',
                            height: ''
                        })
                      ;
                      $container
                        .css({
                            height: ''
                        })
                      ;
                  },

                  setting: function (name, value) {
                      if ($.isPlainObject(name)) {
                          $.extend(true, settings, name);
                      }
                      else if (value !== undefined) {
                          settings[name] = value;
                      }
                      else {
                          return settings[name];
                      }
                  },
                  internal: function (name, value) {
                      if ($.isPlainObject(name)) {
                          $.extend(true, module, name);
                      }
                      else if (value !== undefined) {
                          module[name] = value;
                      }
                      else {
                          return module[name];
                      }
                  },
                  debug: function () {
                      if (settings.debug) {
                          if (settings.performance) {
                              module.performance.log(arguments);
                          }
                          else {
                              module.debug = Function.prototype.bind.call(console.info, console, settings.name + ':');
                              module.debug.apply(console, arguments);
                          }
                      }
                  },
                  verbose: function () {
                      if (settings.verbose && settings.debug) {
                          if (settings.performance) {
                              module.performance.log(arguments);
                          }
                          else {
                              module.verbose = Function.prototype.bind.call(console.info, console, settings.name + ':');
                              module.verbose.apply(console, arguments);
                          }
                      }
                  },
                  error: function () {
                      module.error = Function.prototype.bind.call(console.error, console, settings.name + ':');
                      module.error.apply(console, arguments);
                  },
                  performance: {
                      log: function (message) {
                          var
                            currentTime,
                            executionTime,
                            previousTime
                          ;
                          if (settings.performance) {
                              currentTime = new Date().getTime();
                              previousTime = time || currentTime;
                              executionTime = currentTime - previousTime;
                              time = currentTime;
                              performance.push({
                                  'Name': message[0],
                                  'Arguments': [].slice.call(message, 1) || '',
                                  'Element': element,
                                  'Execution Time': executionTime
                              });
                          }
                          clearTimeout(module.performance.timer);
                          module.performance.timer = setTimeout(module.performance.display, 0);
                      },
                      display: function () {
                          var
                            title = settings.name + ':',
                            totalTime = 0
                          ;
                          time = false;
                          clearTimeout(module.performance.timer);
                          $.each(performance, function (index, data) {
                              totalTime += data['Execution Time'];
                          });
                          title += ' ' + totalTime + 'ms';
                          if (moduleSelector) {
                              title += ' \'' + moduleSelector + '\'';
                          }
                          if ((console.group !== undefined || console.table !== undefined) && performance.length > 0) {
                              console.groupCollapsed(title);
                              if (console.table) {
                                  console.table(performance);
                              }
                              else {
                                  $.each(performance, function (index, data) {
                                      console.log(data['Name'] + ': ' + data['Execution Time'] + 'ms');
                                  });
                              }
                              console.groupEnd();
                          }
                          performance = [];
                      }
                  },
                  invoke: function (query, passedArguments, context) {
                      var
                        object = instance,
                        maxDepth,
                        found,
                        response
                      ;
                      passedArguments = passedArguments || queryArguments;
                      context = element || context;
                      if (typeof query == 'string' && object !== undefined) {
                          query = query.split(/[\. ]/);
                          maxDepth = query.length - 1;
                          $.each(query, function (depth, value) {
                              var camelCaseValue = (depth != maxDepth)
                                ? value + query[depth + 1].charAt(0).toUpperCase() + query[depth + 1].slice(1)
                                : query
                              ;
                              if ($.isPlainObject(object[camelCaseValue]) && (depth != maxDepth)) {
                                  object = object[camelCaseValue];
                              }
                              else if (object[camelCaseValue] !== undefined) {
                                  found = object[camelCaseValue];
                                  return false;
                              }
                              else if ($.isPlainObject(object[value]) && (depth != maxDepth)) {
                                  object = object[value];
                              }
                              else if (object[value] !== undefined) {
                                  found = object[value];
                                  return false;
                              }
                              else {
                                  return false;
                              }
                          });
                      }
                      if ($.isFunction(found)) {
                          response = found.apply(context, passedArguments);
                      }
                      else if (found !== undefined) {
                          response = found;
                      }
                      if ($.isArray(returnedValue)) {
                          returnedValue.push(response);
                      }
                      else if (returnedValue !== undefined) {
                          returnedValue = [returnedValue, response];
                      }
                      else if (response !== undefined) {
                          returnedValue = response;
                      }
                      return found;
                  }
              };

              if (methodInvoked) {
                  if (instance === undefined) {
                      module.initialize();
                  }
                  module.invoke(query);
              }
              else {
                  if (instance !== undefined) {
                      instance.invoke('destroy');
                  }
                  module.initialize();
              }
          })
        ;

        return (returnedValue !== undefined)
          ? returnedValue
          : this
        ;
    };

    $.fn.sticky.settings = {

        name: 'Sticky',
        namespace: 'sticky',

        debug: false,
        verbose: false,
        performance: false,

        pushing: false,
        context: false,
        scrollContext: window,

        offset: 0,
        bottomOffset: 0,

        observeChanges: true,

        onReposition: function () { },
        onScroll: function () { },
        onStick: function () { },
        onUnstick: function () { },
        onTop: function () { },
        onBottom: function () { },

        error: {
            container: 'Sticky element must be inside a relative container',
            visible: 'Element is hidden, you must call refresh after element becomes visible',
            method: 'The method you called is not defined.',
            invalidContext: 'Context specified does not exist',
            elementSize: 'Sticky element is larger than its container, cannot create sticky.'
        },

        className: {
            bound: 'bound',
            fixed: 'fixed',
            supported: 'native',
            top: 'top',
            bottom: 'bottom'
        }

    };

})(jQuery, window, document);
/*!
 * # Semantic UI 1.12.1 - Tab
 * http://github.com/semantic-org/semantic-ui/
 *
 *
 * Copyright 2014 Contributorss
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 *
 */

; (function ($, window, document, undefined) {

    "use strict";

    $.fn.tab = function (parameters) {

        var
          // use window context if none specified
          $allModules = $.isFunction(this)
              ? $(window)
              : $(this),

          settings = ($.isPlainObject(parameters))
            ? $.extend(true, {}, $.fn.tab.settings, parameters)
            : $.extend({}, $.fn.tab.settings),

          moduleSelector = $allModules.selector || '',
          time = new Date().getTime(),
          performance = [],

          query = arguments[0],
          methodInvoked = (typeof query == 'string'),
          queryArguments = [].slice.call(arguments, 1),

          module,
          returnedValue
        ;

        $allModules
          .each(function () {
              var

                className = settings.className,
                metadata = settings.metadata,
                selector = settings.selector,
                error = settings.error,

                eventNamespace = '.' + settings.namespace,
                moduleNamespace = 'module-' + settings.namespace,

                $module = $(this),

                cache = {},
                firstLoad = true,
                recursionDepth = 0,

                $context,
                $tabs,
                activeTabPath,
                parameterArray,
                historyEvent,

                element = this,
                instance = $module.data(moduleNamespace)
              ;

              module = {

                  initialize: function () {
                      module.debug('Initializing tab menu item', $module);

                      module.determineTabs();
                      module.debug('Determining tabs', settings.context, $tabs);

                      // set up automatic routing
                      if (settings.auto) {
                          module.set.auto();
                      }

                      // attach events if navigation wasn't set to window
                      if (!$.isWindow(element)) {
                          module.debug('Attaching tab activation events to element', $module);
                          $module
                            .on('click' + eventNamespace, module.event.click)
                          ;
                      }
                      module.instantiate();
                  },

                  determineTabs: function () {
                      var
                        $reference
                      ;

                      // determine tab context
                      if (settings.context === 'parent') {
                          if ($module.closest(selector.ui).length > 0) {
                              $reference = $module.closest(selector.ui);
                              module.verbose('Using closest UI element for determining parent', $reference);
                          }
                          else {
                              $reference = $module;
                          }
                          $context = $reference.parent();
                          module.verbose('Determined parent element for creating context', $context);
                      }
                      else if (settings.context) {
                          $context = $(settings.context);
                          module.verbose('Using selector for tab context', settings.context, $context);
                      }
                      else {
                          $context = $('body');
                      }

                      // find tabs
                      if (settings.childrenOnly) {
                          $tabs = $context.children(selector.tabs);
                          module.debug('Searching tab context children for tabs', $context, $tabs);
                      }
                      else {
                          $tabs = $context.find(selector.tabs);
                          module.debug('Searching tab context for tabs', $context, $tabs);
                      }
                  },

                  initializeHistory: function () {
                      if (settings.history) {
                          module.debug('Initializing page state');
                          if ($.address === undefined) {
                              module.error(error.state);
                              return false;
                          }
                          else {
                              if (settings.historyType == 'state') {
                                  module.debug('Using HTML5 to manage state');
                                  if (settings.path !== false) {
                                      $.address
                                        .history(true)
                                        .state(settings.path)
                                      ;
                                  }
                                  else {
                                      module.error(error.path);
                                      return false;
                                  }
                              }
                              $.address
                                .bind('change', module.event.history.change)
                              ;
                          }
                      }
                  },

                  instantiate: function () {
                      module.verbose('Storing instance of module', module);
                      instance = module;
                      $module
                        .data(moduleNamespace, module)
                      ;
                  },

                  destroy: function () {
                      module.debug('Destroying tabs', $module);
                      $module
                        .removeData(moduleNamespace)
                        .off(eventNamespace)
                      ;
                  },

                  event: {
                      click: function (event) {
                          var
                            tabPath = $(this).data(metadata.tab)
                          ;
                          if (tabPath !== undefined) {
                              if (settings.history) {
                                  module.verbose('Updating page state', event);
                                  $.address.value(tabPath);
                              }
                              else {
                                  module.verbose('Changing tab', event);
                                  module.changeTab(tabPath);
                              }
                              event.preventDefault();
                          }
                          else {
                              module.debug('No tab specified');
                          }
                      },
                      history: {
                          change: function (event) {
                              var
                                tabPath = event.pathNames.join('/') || module.get.initialPath(),
                                pageTitle = settings.templates.determineTitle(tabPath) || false
                              ;
                              module.performance.display();
                              module.debug('History change event', tabPath, event);
                              historyEvent = event;
                              if (tabPath !== undefined) {
                                  module.changeTab(tabPath);
                              }
                              if (pageTitle) {
                                  $.address.title(pageTitle);
                              }
                          }
                      }
                  },

                  refresh: function () {
                      if (activeTabPath) {
                          module.debug('Refreshing tab', activeTabPath);
                          module.changeTab(activeTabPath);
                      }
                  },

                  cache: {

                      read: function (cacheKey) {
                          return (cacheKey !== undefined)
                            ? cache[cacheKey]
                            : false
                          ;
                      },
                      add: function (cacheKey, content) {
                          cacheKey = cacheKey || activeTabPath;
                          module.debug('Adding cached content for', cacheKey);
                          cache[cacheKey] = content;
                      },
                      remove: function (cacheKey) {
                          cacheKey = cacheKey || activeTabPath;
                          module.debug('Removing cached content for', cacheKey);
                          delete cache[cacheKey];
                      }
                  },

                  set: {
                      auto: function () {
                          var
                            url = (typeof settings.path == 'string')
                              ? settings.path.replace(/\/$/, '') + '/{$tab}'
                              : '/{$tab}'
                          ;
                          module.verbose('Setting up automatic tab retrieval from server', url);
                          if ($.isPlainObject(settings.apiSettings)) {
                              settings.apiSettings.url = url;
                          }
                          else {
                              settings.apiSettings = {
                                  url: url
                              };
                          }
                      },
                      state: function (state) {
                          $.address.value(state);
                      }
                  },

                  changeTab: function (tabPath) {
                      var
                        pushStateAvailable = (window.history && window.history.pushState),
                        shouldIgnoreLoad = (pushStateAvailable && settings.ignoreFirstLoad && firstLoad),
                        remoteContent = (settings.auto || $.isPlainObject(settings.apiSettings)),
                        // only get default path if not remote content
                        pathArray = (remoteContent && !shouldIgnoreLoad)
                          ? module.utilities.pathToArray(tabPath)
                          : module.get.defaultPathArray(tabPath)
                      ;
                      tabPath = module.utilities.arrayToPath(pathArray);
                      $.each(pathArray, function (index, tab) {
                          var
                            currentPathArray = pathArray.slice(0, index + 1),
                            currentPath = module.utilities.arrayToPath(currentPathArray),

                            isTab = module.is.tab(currentPath),
                            isLastIndex = (index + 1 == pathArray.length),

                            $tab = module.get.tabElement(currentPath),
                            $anchor,
                            nextPathArray,
                            nextPath,
                            isLastTab
                          ;
                          module.verbose('Looking for tab', tab);
                          if (isTab) {

                              module.verbose('Tab was found', tab);
                              // scope up
                              activeTabPath = currentPath;
                              parameterArray = module.utilities.filterArray(pathArray, currentPathArray);

                              if (isLastIndex) {
                                  isLastTab = true;
                              }
                              else {
                                  nextPathArray = pathArray.slice(0, index + 2);
                                  nextPath = module.utilities.arrayToPath(nextPathArray);
                                  isLastTab = (!module.is.tab(nextPath));
                                  if (isLastTab) {
                                      module.verbose('Tab parameters found', nextPathArray);
                                  }
                              }
                              if (isLastTab && remoteContent) {
                                  if (!shouldIgnoreLoad) {
                                      module.activate.navigation(currentPath);
                                      module.content.fetch(currentPath, tabPath);
                                  }
                                  else {
                                      module.debug('Ignoring remote content on first tab load', currentPath);
                                      firstLoad = false;
                                      module.cache.add(tabPath, $tab.html());
                                      module.activate.all(currentPath);
                                      settings.onTabInit.call($tab, currentPath, parameterArray, historyEvent);
                                      settings.onTabLoad.call($tab, currentPath, parameterArray, historyEvent);
                                  }
                                  return false;
                              }
                              else {
                                  module.debug('Opened local tab', currentPath);
                                  module.activate.all(currentPath);
                                  if (!module.cache.read(currentPath)) {
                                      module.cache.add(currentPath, true);
                                      module.debug('First time tab loaded calling tab init');
                                      settings.onTabInit.call($tab, currentPath, parameterArray, historyEvent);
                                  }
                                  settings.onTabLoad.call($tab, currentPath, parameterArray, historyEvent);
                              }
                          }
                          else if (tabPath.search('/') == -1 && tabPath !== '') {
                              // look for in page anchor
                              $anchor = $('#' + tabPath + ', a[name="' + tabPath + '"]'),
                              currentPath = $anchor.closest('[data-tab]').data('tab');
                              $tab = module.get.tabElement(currentPath);
                              // if anchor exists use parent tab
                              if ($anchor && $anchor.length > 0 && currentPath) {
                                  module.debug('No tab found, but deep anchor link present, opening parent tab');
                                  module.activate.all(currentPath);
                                  if (!module.cache.read(currentPath)) {
                                      module.cache.add(currentPath, true);
                                      module.debug('First time tab loaded calling tab init');
                                      settings.onTabInit.call($tab, currentPath, parameterArray, historyEvent);
                                  }
                                  return false;
                              }
                          }
                          else {
                              module.error(error.missingTab, $module, $context, currentPath);
                              return false;
                          }
                      });
                  },

                  content: {

                      fetch: function (tabPath, fullTabPath) {
                          var
                            $tab = module.get.tabElement(tabPath),
                            apiSettings = {
                                dataType: 'html',
                                on: 'now',
                                onSuccess: function (response) {
                                    module.cache.add(fullTabPath, response);
                                    module.content.update(tabPath, response);
                                    if (tabPath == activeTabPath) {
                                        module.debug('Content loaded', tabPath);
                                        module.activate.tab(tabPath);
                                    }
                                    else {
                                        module.debug('Content loaded in background', tabPath);
                                    }
                                    settings.onTabInit.call($tab, tabPath, parameterArray, historyEvent);
                                    settings.onTabLoad.call($tab, tabPath, parameterArray, historyEvent);
                                },
                                urlData: { tab: fullTabPath }
                            },
                            request = $tab.api('get request') || false,
                            existingRequest = (request && request.state() === 'pending'),
                            requestSettings,
                            cachedContent
                          ;

                          fullTabPath = fullTabPath || tabPath;
                          cachedContent = module.cache.read(fullTabPath);


                          module.activate.tab(tabPath);

                          if (settings.cache && cachedContent) {
                              module.debug('Showing existing content', fullTabPath);
                              module.content.update(tabPath, cachedContent);
                              settings.onTabLoad.call($tab, tabPath, parameterArray, historyEvent);
                          }
                          else if (existingRequest) {
                              module.debug('Content is already loading', fullTabPath);
                              $tab.addClass(className.loading);
                          }
                          else if ($.api !== undefined) {
                              requestSettings = $.extend(true, {
                                  headers: { 'X-Remote': true }
                              }, settings.apiSettings, apiSettings);
                              module.debug('Retrieving remote content', fullTabPath, requestSettings);
                              $tab.api(requestSettings);
                          }
                          else {
                              module.error(error.api);
                          }
                      },

                      update: function (tabPath, html) {
                          module.debug('Updating html for', tabPath);
                          var
                            $tab = module.get.tabElement(tabPath)
                          ;
                          $tab
                            .html(html)
                          ;
                      }
                  },

                  activate: {
                      all: function (tabPath) {
                          module.activate.tab(tabPath);
                          module.activate.navigation(tabPath);
                      },
                      tab: function (tabPath) {
                          var
                            $tab = module.get.tabElement(tabPath)
                          ;
                          module.verbose('Showing tab content for', $tab);
                          $tab
                            .addClass(className.active)
                            .siblings($tabs)
                              .removeClass(className.active + ' ' + className.loading)
                          ;
                      },
                      navigation: function (tabPath) {
                          var
                            $navigation = module.get.navElement(tabPath)
                          ;
                          module.verbose('Activating tab navigation for', $navigation, tabPath);
                          $navigation
                            .addClass(className.active)
                            .siblings($allModules)
                              .removeClass(className.active + ' ' + className.loading)
                          ;
                      }
                  },

                  deactivate: {
                      all: function () {
                          module.deactivate.navigation();
                          module.deactivate.tabs();
                      },
                      navigation: function () {
                          $allModules
                            .removeClass(className.active)
                          ;
                      },
                      tabs: function () {
                          $tabs
                            .removeClass(className.active + ' ' + className.loading)
                          ;
                      }
                  },

                  is: {
                      tab: function (tabName) {
                          return (tabName !== undefined)
                            ? (module.get.tabElement(tabName).length > 0)
                            : false
                          ;
                      }
                  },

                  get: {
                      initialPath: function () {
                          return $allModules.eq(0).data(metadata.tab) || $tabs.eq(0).data(metadata.tab);
                      },
                      path: function () {
                          return $.address.value();
                      },
                      // adds default tabs to tab path
                      defaultPathArray: function (tabPath) {
                          return module.utilities.pathToArray(module.get.defaultPath(tabPath));
                      },
                      defaultPath: function (tabPath) {
                          var
                            $defaultNav = $allModules.filter('[data-' + metadata.tab + '^="' + tabPath + '/"]').eq(0),
                            defaultTab = $defaultNav.data(metadata.tab) || false
                          ;
                          if (defaultTab) {
                              module.debug('Found default tab', defaultTab);
                              if (recursionDepth < settings.maxDepth) {
                                  recursionDepth++;
                                  return module.get.defaultPath(defaultTab);
                              }
                              module.error(error.recursion);
                          }
                          else {
                              module.debug('No default tabs found for', tabPath, $tabs);
                          }
                          recursionDepth = 0;
                          return tabPath;
                      },
                      navElement: function (tabPath) {
                          tabPath = tabPath || activeTabPath;
                          return $allModules.filter('[data-' + metadata.tab + '="' + tabPath + '"]');
                      },
                      tabElement: function (tabPath) {
                          var
                            $fullPathTab,
                            $simplePathTab,
                            tabPathArray,
                            lastTab
                          ;
                          tabPath = tabPath || activeTabPath;
                          tabPathArray = module.utilities.pathToArray(tabPath);
                          lastTab = module.utilities.last(tabPathArray);
                          $fullPathTab = $tabs.filter('[data-' + metadata.tab + '="' + lastTab + '"]');
                          $simplePathTab = $tabs.filter('[data-' + metadata.tab + '="' + tabPath + '"]');
                          return ($fullPathTab.length > 0)
                            ? $fullPathTab
                            : $simplePathTab
                          ;
                      },
                      tab: function () {
                          return activeTabPath;
                      }
                  },

                  utilities: {
                      filterArray: function (keepArray, removeArray) {
                          return $.grep(keepArray, function (keepValue) {
                              return ($.inArray(keepValue, removeArray) == -1);
                          });
                      },
                      last: function (array) {
                          return $.isArray(array)
                            ? array[array.length - 1]
                            : false
                          ;
                      },
                      pathToArray: function (pathName) {
                          if (pathName === undefined) {
                              pathName = activeTabPath;
                          }
                          return typeof pathName == 'string'
                            ? pathName.split('/')
                            : [pathName]
                          ;
                      },
                      arrayToPath: function (pathArray) {
                          return $.isArray(pathArray)
                            ? pathArray.join('/')
                            : false
                          ;
                      }
                  },

                  setting: function (name, value) {
                      module.debug('Changing setting', name, value);
                      if ($.isPlainObject(name)) {
                          $.extend(true, settings, name);
                      }
                      else if (value !== undefined) {
                          settings[name] = value;
                      }
                      else {
                          return settings[name];
                      }
                  },
                  internal: function (name, value) {
                      if ($.isPlainObject(name)) {
                          $.extend(true, module, name);
                      }
                      else if (value !== undefined) {
                          module[name] = value;
                      }
                      else {
                          return module[name];
                      }
                  },
                  debug: function () {
                      if (settings.debug) {
                          if (settings.performance) {
                              module.performance.log(arguments);
                          }
                          else {
                              module.debug = Function.prototype.bind.call(console.info, console, settings.name + ':');
                              module.debug.apply(console, arguments);
                          }
                      }
                  },
                  verbose: function () {
                      if (settings.verbose && settings.debug) {
                          if (settings.performance) {
                              module.performance.log(arguments);
                          }
                          else {
                              module.verbose = Function.prototype.bind.call(console.info, console, settings.name + ':');
                              module.verbose.apply(console, arguments);
                          }
                      }
                  },
                  error: function () {
                      module.error = Function.prototype.bind.call(console.error, console, settings.name + ':');
                      module.error.apply(console, arguments);
                  },
                  performance: {
                      log: function (message) {
                          var
                            currentTime,
                            executionTime,
                            previousTime
                          ;
                          if (settings.performance) {
                              currentTime = new Date().getTime();
                              previousTime = time || currentTime;
                              executionTime = currentTime - previousTime;
                              time = currentTime;
                              performance.push({
                                  'Name': message[0],
                                  'Arguments': [].slice.call(message, 1) || '',
                                  'Element': element,
                                  'Execution Time': executionTime
                              });
                          }
                          clearTimeout(module.performance.timer);
                          module.performance.timer = setTimeout(module.performance.display, 100);
                      },
                      display: function () {
                          var
                            title = settings.name + ':',
                            totalTime = 0
                          ;
                          time = false;
                          clearTimeout(module.performance.timer);
                          $.each(performance, function (index, data) {
                              totalTime += data['Execution Time'];
                          });
                          title += ' ' + totalTime + 'ms';
                          if (moduleSelector) {
                              title += ' \'' + moduleSelector + '\'';
                          }
                          if ((console.group !== undefined || console.table !== undefined) && performance.length > 0) {
                              console.groupCollapsed(title);
                              if (console.table) {
                                  console.table(performance);
                              }
                              else {
                                  $.each(performance, function (index, data) {
                                      console.log(data['Name'] + ': ' + data['Execution Time'] + 'ms');
                                  });
                              }
                              console.groupEnd();
                          }
                          performance = [];
                      }
                  },
                  invoke: function (query, passedArguments, context) {
                      var
                        object = instance,
                        maxDepth,
                        found,
                        response
                      ;
                      passedArguments = passedArguments || queryArguments;
                      context = element || context;
                      if (typeof query == 'string' && object !== undefined) {
                          query = query.split(/[\. ]/);
                          maxDepth = query.length - 1;
                          $.each(query, function (depth, value) {
                              var camelCaseValue = (depth != maxDepth)
                                ? value + query[depth + 1].charAt(0).toUpperCase() + query[depth + 1].slice(1)
                                : query
                              ;
                              if ($.isPlainObject(object[camelCaseValue]) && (depth != maxDepth)) {
                                  object = object[camelCaseValue];
                              }
                              else if (object[camelCaseValue] !== undefined) {
                                  found = object[camelCaseValue];
                                  return false;
                              }
                              else if ($.isPlainObject(object[value]) && (depth != maxDepth)) {
                                  object = object[value];
                              }
                              else if (object[value] !== undefined) {
                                  found = object[value];
                                  return false;
                              }
                              else {
                                  module.error(error.method, query);
                                  return false;
                              }
                          });
                      }
                      if ($.isFunction(found)) {
                          response = found.apply(context, passedArguments);
                      }
                      else if (found !== undefined) {
                          response = found;
                      }
                      if ($.isArray(returnedValue)) {
                          returnedValue.push(response);
                      }
                      else if (returnedValue !== undefined) {
                          returnedValue = [returnedValue, response];
                      }
                      else if (response !== undefined) {
                          returnedValue = response;
                      }
                      return found;
                  }
              };
              if (methodInvoked) {
                  if (instance === undefined) {
                      module.initialize();
                  }
                  module.invoke(query);
              }
              else {
                  if (instance !== undefined) {
                      instance.invoke('destroy');
                  }
                  module.initialize();
              }
          })
        ;
        if (module && !methodInvoked) {
            module.initializeHistory();
        }
        return (returnedValue !== undefined)
          ? returnedValue
          : this
        ;

    };

    // shortcut for tabbed content with no defined navigation
    $.tab = function () {
        $(window).tab.apply(this, arguments);
    };

    $.fn.tab.settings = {

        name: 'Tab',
        namespace: 'tab',

        debug: false,
        verbose: true,
        performance: true,

        auto: false,  // uses pjax style endpoints fetching content from same url with remote-content headers
        history: false,  // use browser history
        historyType: 'hash', // #/ or html5 state
        path: false,  // base path of url

        context: false,  // specify a context that tabs must appear inside
        childrenOnly: false,  // use only tabs that are children of context
        maxDepth: 25,     // max depth a tab can be nested

        alwaysRefresh: false,  // load tab content new every tab click
        cache: true,   // cache the content requests to pull locally
        ignoreFirstLoad: false,  // don't load remote content on first load
        apiSettings: false,  // settings for api call

        onTabInit: function (tabPath, parameterArray, historyEvent) { }, // called first time loaded
        onTabLoad: function (tabPath, parameterArray, historyEvent) { }, // called on every load

        templates: {
            determineTitle: function (tabArray) { } // returns page title for path
        },

        error: {
            api: 'You attempted to load content without API module',
            method: 'The method you called is not defined',
            missingTab: 'Activated tab cannot be found for this context.',
            noContent: 'The tab you specified is missing a content url.',
            path: 'History enabled, but no path was specified',
            recursion: 'Max recursive depth reached',
            state: 'History requires Asual\'s Address library <https://github.com/asual/jquery-address>'
        },

        metadata: {
            tab: 'tab',
            loaded: 'loaded',
            promise: 'promise'
        },

        className: {
            loading: 'loading',
            active: 'active'
        },

        selector: {
            tabs: '.ui.tab',
            ui: '.ui'
        }

    };

})(jQuery, window, document);
/*!
 * # Semantic UI 1.12.1 - Transition
 * http://github.com/semantic-org/semantic-ui/
 *
 *
 * Copyright 2014 Contributors
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 *
 */

; (function ($, window, document, undefined) {

    "use strict";

    $.fn.transition = function () {
        var
          $allModules = $(this),
          moduleSelector = $allModules.selector || '',

          time = new Date().getTime(),
          performance = [],

          moduleArguments = arguments,
          query = moduleArguments[0],
          queryArguments = [].slice.call(arguments, 1),
          methodInvoked = (typeof query === 'string'),

          requestAnimationFrame = window.requestAnimationFrame
            || window.mozRequestAnimationFrame
            || window.webkitRequestAnimationFrame
            || window.msRequestAnimationFrame
            || function (callback) { setTimeout(callback, 0); },

          returnedValue
        ;
        $allModules
          .each(function (index) {
              var
                $module = $(this),
                element = this,

                // set at run time
                settings,
                instance,

                error,
                className,
                metadata,
                animationStart,
                animationEnd,
                animationName,

                namespace,
                moduleNamespace,
                eventNamespace,
                module
              ;

              module = {

                  initialize: function () {

                      // get full settings
                      settings = module.get.settings.apply(element, moduleArguments);

                      // shorthand
                      className = settings.className;
                      error = settings.error;
                      metadata = settings.metadata;

                      // define namespace
                      eventNamespace = '.' + settings.namespace;
                      moduleNamespace = 'module-' + settings.namespace;
                      instance = $module.data(moduleNamespace) || module;

                      // get vendor specific events
                      animationEnd = module.get.animationEndEvent();
                      animationName = module.get.animationName();
                      animationStart = module.get.animationStartEvent();

                      if (methodInvoked) {
                          methodInvoked = module.invoke(query);
                      }

                      // method not invoked, lets run an animation
                      if (methodInvoked === false) {
                          module.verbose('Converted arguments into settings object', settings);
                          if (settings.interval) {
                              module.delay(settings.animate);
                          }
                          else {
                              module.animate();
                          }
                          module.instantiate();
                      }
                  },

                  instantiate: function () {
                      module.verbose('Storing instance of module', module);
                      instance = module;
                      $module
                        .data(moduleNamespace, instance)
                      ;
                  },

                  destroy: function () {
                      module.verbose('Destroying previous module for', element);
                      $module
                        .removeData(moduleNamespace)
                      ;
                  },

                  refresh: function () {
                      module.verbose('Refreshing display type on next animation');
                      delete module.displayType;
                  },

                  forceRepaint: function () {
                      module.verbose('Forcing element repaint');
                      var
                        $parentElement = $module.parent(),
                        $nextElement = $module.next()
                      ;
                      if ($nextElement.length === 0) {
                          $module.detach().appendTo($parentElement);
                      }
                      else {
                          $module.detach().insertBefore($nextElement);
                      }
                  },

                  repaint: function () {
                      module.verbose('Repainting element');
                      var
                        fakeAssignment = element.offsetWidth
                      ;
                  },

                  delay: function (interval) {
                      var
                        isReverse = (settings.reverse === true),
                        shouldReverse = (settings.reverse == 'auto' && module.get.direction() == className.outward),
                        delay
                      ;
                      interval = (typeof interval !== undefined)
                        ? interval
                        : settings.interval
                      ;
                      delay = (isReverse || shouldReverse)
                        ? ($allModules.length - index) * settings.interval
                        : index * settings.interval
                      ;
                      module.debug('Delaying animation by', delay);
                      setTimeout(module.animate, delay);
                  },

                  animate: function (overrideSettings) {
                      settings = overrideSettings || settings;
                      if (!module.is.supported()) {
                          module.error(error.support);
                          return false;
                      }
                      module.debug('Preparing animation', settings.animation);
                      if (module.is.animating()) {
                          if (settings.queue) {
                              if (!settings.allowRepeats && module.has.direction() && module.is.occurring() && module.queuing !== true) {
                                  module.debug('Animation is currently occurring, preventing queueing same animation', settings.animation);
                              }
                              else {
                                  module.queue(settings.animation);
                              }
                              return false;
                          }
                          else if (!settings.allowRepeats && module.is.occurring()) {
                              module.debug('Animation is already occurring, will not execute repeated animation', settings.animation);
                              return false;
                          }
                          else {
                              module.debug('New animation started, completing previous early', settings.animation);
                              module.complete();
                          }
                      }
                      if (module.can.animate()) {
                          module.set.animating(settings.animation);
                      }
                      else {
                          module.error(error.noAnimation, settings.animation, element);
                      }
                  },

                  reset: function () {
                      module.debug('Resetting animation to beginning conditions');
                      module.remove.animationCallbacks();
                      module.restore.conditions();
                      module.remove.animating();
                  },

                  queue: function (animation) {
                      module.debug('Queueing animation of', animation);
                      module.queuing = true;
                      $module
                        .one(animationEnd + '.queue' + eventNamespace, function () {
                            module.queuing = false;
                            module.repaint();
                            module.animate.apply(this, settings);
                        })
                      ;
                  },

                  complete: function (event) {
                      module.debug('Animation complete', settings.animation);
                      module.remove.completeCallback();
                      module.remove.failSafe();
                      if (!module.is.looping()) {
                          if (module.is.outward()) {
                              module.verbose('Animation is outward, hiding element');
                              module.restore.conditions();
                              module.hide();
                              settings.onHide.call(this);
                          }
                          else if (module.is.inward()) {
                              module.verbose('Animation is outward, showing element');
                              module.restore.conditions();
                              module.show();
                              settings.onShow.call(this);
                          }
                          else {
                              module.restore.conditions();
                          }
                          module.remove.animation();
                          module.remove.animating();
                      }
                      settings.onComplete.call(this);
                  },

                  has: {
                      direction: function (animation) {
                          var
                            hasDirection = false
                          ;
                          animation = animation || settings.animation;
                          if (typeof animation === 'string') {
                              animation = animation.split(' ');
                              $.each(animation, function (index, word) {
                                  if (word === className.inward || word === className.outward) {
                                      hasDirection = true;
                                  }
                              });
                          }
                          return hasDirection;
                      },
                      inlineDisplay: function () {
                          var
                            style = $module.attr('style') || ''
                          ;
                          return $.isArray(style.match(/display.*?;/, ''));
                      }
                  },

                  set: {
                      animating: function (animation) {
                          animation = animation || settings.animation;
                          if (!module.is.animating()) {
                              module.save.conditions();
                          }
                          module.remove.direction();
                          module.remove.completeCallback();
                          if (module.can.transition() && !module.has.direction()) {
                              module.set.direction();
                          }
                          module.remove.hidden();
                          module.set.display();
                          $module
                            .addClass(className.animating + ' ' + className.transition + ' ' + animation)
                            .addClass(animation)
                            .one(animationEnd + '.complete' + eventNamespace, module.complete)
                          ;
                          if (settings.useFailSafe) {
                              module.add.failSafe();
                          }
                          module.set.duration(settings.duration);
                          settings.onStart.call(this);
                          module.debug('Starting tween', animation, $module.attr('class'));
                      },
                      duration: function (animationName, duration) {
                          duration = duration || settings.duration;
                          duration = (typeof duration == 'number')
                            ? duration + 'ms'
                            : duration
                          ;
                          if (duration || duration === 0) {
                              module.verbose('Setting animation duration', duration);
                              $module
                                .css({
                                    '-webkit-animation-duration': duration,
                                    '-moz-animation-duration': duration,
                                    '-ms-animation-duration': duration,
                                    '-o-animation-duration': duration,
                                    'animation-duration': duration
                                })
                              ;
                          }
                      },
                      display: function () {
                          var
                            style = module.get.style(),
                            displayType = module.get.displayType(),
                            overrideStyle = style + 'display: ' + displayType + ' !important;'
                          ;
                          $module.css('display', '');
                          module.refresh();
                          if ($module.css('display') !== displayType) {
                              module.verbose('Setting inline visibility to', displayType);
                              $module
                                .attr('style', overrideStyle)
                              ;
                          }
                      },
                      direction: function () {
                          if ($module.is(':visible') && !module.is.hidden()) {
                              module.debug('Automatically determining the direction of animation', 'Outward');
                              $module
                                .removeClass(className.inward)
                                .addClass(className.outward)
                              ;
                          }
                          else {
                              module.debug('Automatically determining the direction of animation', 'Inward');
                              $module
                                .removeClass(className.outward)
                                .addClass(className.inward)
                              ;
                          }
                      },
                      looping: function () {
                          module.debug('Transition set to loop');
                          $module
                            .addClass(className.looping)
                          ;
                      },
                      hidden: function () {
                          if (!module.is.hidden()) {
                              $module
                                .addClass(className.transition)
                                .addClass(className.hidden)
                              ;
                          }
                          if ($module.css('display') !== 'none') {
                              module.verbose('Overriding default display to hide element');
                              $module
                                .css('display', 'none')
                              ;
                          }
                      },
                      visible: function () {
                          $module
                            .addClass(className.transition)
                            .addClass(className.visible)
                          ;
                      }
                  },

                  save: {
                      displayType: function (displayType) {
                          $module.data(metadata.displayType, displayType);
                      },
                      transitionExists: function (animation, exists) {
                          $.fn.transition.exists[animation] = exists;
                          module.verbose('Saving existence of transition', animation, exists);
                      },
                      conditions: function () {
                          var
                            clasName = $module.attr('class') || false,
                            style = $module.attr('style') || ''
                          ;
                          $module.removeClass(settings.animation);
                          module.remove.direction();
                          module.cache = {
                              className: $module.attr('class'),
                              style: module.get.style()
                          };
                          module.verbose('Saving original attributes', module.cache);
                      }
                  },

                  restore: {
                      conditions: function () {
                          if (module.cache === undefined) {
                              return false;
                          }
                          if (module.cache.className) {
                              $module.attr('class', module.cache.className);
                          }
                          else {
                              $module.removeAttr('class');
                          }
                          if (module.cache.style) {
                              module.verbose('Restoring original style attribute', module.cache.style);
                              $module.attr('style', module.cache.style);
                          }
                          else {
                              module.verbose('Clearing style attribute');
                              $module.removeAttr('style');
                          }
                          module.verbose('Restoring original attributes', module.cache);
                      }
                  },

                  add: {
                      failSafe: function () {
                          var
                            duration = module.get.duration()
                          ;
                          module.timer = setTimeout(function () {
                              $module.trigger(animationEnd);
                          }, duration + settings.failSafeDelay);
                          module.verbose('Adding fail safe timer', module.timer);
                      }
                  },

                  remove: {
                      animating: function () {
                          $module.removeClass(className.animating);
                      },
                      animation: function () {
                          $module
                            .css({
                                '-webkit-animation': '',
                                '-moz-animation': '',
                                '-ms-animation': '',
                                '-o-animation': '',
                                'animation': ''
                            })
                          ;
                      },
                      animationCallbacks: function () {
                          module.remove.queueCallback();
                          module.remove.completeCallback();
                      },
                      queueCallback: function () {
                          $module.off('.queue' + eventNamespace)
                      },
                      completeCallback: function () {
                          $module.off('.complete' + eventNamespace);
                      },
                      display: function () {
                          $module.css('display', '');
                      },
                      direction: function () {
                          $module
                            .removeClass(className.inward)
                            .removeClass(className.outward)
                          ;
                      },
                      failSafe: function () {
                          module.verbose('Removing fail safe timer', module.timer);
                          if (module.timer) {
                              clearTimeout(module.timer);
                          }
                      },
                      hidden: function () {
                          $module.removeClass(className.hidden);
                      },
                      visible: function () {
                          $module.removeClass(className.visible);
                      },
                      looping: function () {
                          module.debug('Transitions are no longer looping');
                          if (module.is.looping()) {
                              module.reset();
                              $module
                                .removeClass(className.looping)
                              ;
                          }
                      },
                      transition: function () {
                          $module
                            .removeClass(className.visible)
                            .removeClass(className.hidden)
                          ;
                      }
                  },
                  get: {
                      settings: function (animation, duration, onComplete) {
                          // single settings object
                          if (typeof animation == 'object') {
                              return $.extend(true, {}, $.fn.transition.settings, animation);
                          }
                              // all arguments provided
                          else if (typeof onComplete == 'function') {
                              return $.extend({}, $.fn.transition.settings, {
                                  animation: animation,
                                  onComplete: onComplete,
                                  duration: duration
                              });
                          }
                              // only duration provided
                          else if (typeof duration == 'string' || typeof duration == 'number') {
                              return $.extend({}, $.fn.transition.settings, {
                                  animation: animation,
                                  duration: duration
                              });
                          }
                              // duration is actually settings object
                          else if (typeof duration == 'object') {
                              return $.extend({}, $.fn.transition.settings, duration, {
                                  animation: animation
                              });
                          }
                              // duration is actually callback
                          else if (typeof duration == 'function') {
                              return $.extend({}, $.fn.transition.settings, {
                                  animation: animation,
                                  onComplete: duration
                              });
                          }
                              // only animation provided
                          else {
                              return $.extend({}, $.fn.transition.settings, {
                                  animation: animation
                              });
                          }
                          return $.fn.transition.settings;
                      },
                      direction: function (animation) {
                          // quickest manually specified direction
                          animation = animation || settings.animation;
                          if (typeof animation === 'string') {
                              animation = animation.split(' ');
                              $.each(animation, function (index, word) {
                                  if (word === className.inward) {
                                      return className.inward;
                                  }
                                  else if (word === className.outward) {
                                      return className.outward;
                                  }
                              });
                          }
                          // slower backup
                          if (!module.can.transition()) {
                              return 'static';
                          }
                          if ($module.is(':visible') && !module.is.hidden()) {
                              return className.outward;
                          }
                          else {
                              return className.inward;
                          }
                      },
                      duration: function (duration) {
                          duration = duration || settings.duration;
                          if (duration === false) {
                              duration = $module.css('animation-duration') || 0;
                          }
                          return (typeof duration === 'string')
                            ? (duration.indexOf('ms') > -1)
                              ? parseFloat(duration)
                              : parseFloat(duration) * 1000
                            : duration
                          ;
                      },
                      displayType: function () {
                          if (settings.displayType) {
                              return settings.displayType;
                          }
                          if ($module.data(metadata.displayType) === undefined) {
                              // create fake element to determine display state
                              module.can.transition(true);
                          }
                          return $module.data(metadata.displayType);
                      },
                      style: function () {
                          var
                            style = $module.attr('style') || ''
                          ;
                          return style.replace(/display.*?;/, '');
                      },
                      transitionExists: function (animation) {
                          return $.fn.transition.exists[animation];
                      },
                      animationName: function () {
                          var
                            element = document.createElement('div'),
                            animations = {
                                'animation': 'animationName',
                                'OAnimation': 'oAnimationName',
                                'MozAnimation': 'mozAnimationName',
                                'WebkitAnimation': 'webkitAnimationName'
                            },
                            animation
                          ;
                          for (animation in animations) {
                              if (element.style[animation] !== undefined) {
                                  return animations[animation];
                              }
                          }
                          return false;
                      },
                      animationStartEvent: function () {
                          var
                            element = document.createElement('div'),
                            animations = {
                                'animation': 'animationstart',
                                'OAnimation': 'oAnimationStart',
                                'MozAnimation': 'mozAnimationStart',
                                'WebkitAnimation': 'webkitAnimationStart'
                            },
                            animation
                          ;
                          for (animation in animations) {
                              if (element.style[animation] !== undefined) {
                                  return animations[animation];
                              }
                          }
                          return false;
                      },
                      animationEndEvent: function () {
                          var
                            element = document.createElement('div'),
                            animations = {
                                'animation': 'animationend',
                                'OAnimation': 'oAnimationEnd',
                                'MozAnimation': 'mozAnimationEnd',
                                'WebkitAnimation': 'webkitAnimationEnd'
                            },
                            animation
                          ;
                          for (animation in animations) {
                              if (element.style[animation] !== undefined) {
                                  return animations[animation];
                              }
                          }
                          return false;
                      }

                  },

                  can: {
                      transition: function (forced) {
                          var
                            elementClass = $module.attr('class'),
                            tagName = $module.prop('tagName'),
                            animation = settings.animation,
                            transitionExists = module.get.transitionExists(animation),
                            $clone,
                            currentAnimation,
                            inAnimation,
                            directionExists,
                            displayType
                          ;
                          if (transitionExists === undefined || forced) {
                              module.verbose('Determining whether animation exists');
                              $clone = $('<' + tagName + ' />').addClass(elementClass).insertAfter($module);
                              currentAnimation = $clone
                                .addClass(animation)
                                .removeClass(className.inward)
                                .removeClass(className.outward)
                                .addClass(className.animating)
                                .addClass(className.transition)
                                .css(animationName)
                              ;
                              inAnimation = $clone
                                .addClass(className.inward)
                                .css(animationName)
                              ;
                              displayType = $clone
                                .attr('class', elementClass)
                                .removeAttr('style')
                                .removeClass(className.hidden)
                                .removeClass(className.visible)
                                .show()
                                .css('display')
                              ;
                              module.verbose('Determining final display state', displayType);
                              module.save.displayType(displayType);

                              $clone.remove();
                              if (currentAnimation != inAnimation) {
                                  module.debug('Direction exists for animation', animation);
                                  directionExists = true;
                              }
                              else if (currentAnimation == 'none' || !currentAnimation) {
                                  module.debug('No animation defined in css', animation);
                                  return;
                              }
                              else {
                                  module.debug('Static animation found', animation, displayType);
                                  directionExists = false;
                              }
                              module.save.transitionExists(animation, directionExists);
                          }
                          return (transitionExists !== undefined)
                            ? transitionExists
                            : directionExists
                          ;
                      },
                      animate: function () {
                          // can transition does not return a value if animation does not exist
                          return (module.can.transition() !== undefined);
                      }
                  },

                  is: {
                      animating: function () {
                          return $module.hasClass(className.animating);
                      },
                      inward: function () {
                          return $module.hasClass(className.inward);
                      },
                      outward: function () {
                          return $module.hasClass(className.outward);
                      },
                      looping: function () {
                          return $module.hasClass(className.looping);
                      },
                      occurring: function (animation) {
                          animation = animation || settings.animation;
                          animation = '.' + animation.replace(' ', '.');
                          return ($module.filter(animation).length > 0);
                      },
                      visible: function () {
                          return $module.is(':visible');
                      },
                      hidden: function () {
                          return $module.css('visibility') === 'hidden';
                      },
                      supported: function () {
                          return (animationName !== false && animationEnd !== false);
                      }
                  },

                  hide: function () {
                      module.verbose('Hiding element');
                      if (module.is.animating()) {
                          module.reset();
                      }
                      module.remove.display();
                      module.remove.visible();
                      module.set.hidden();
                      module.repaint();
                  },

                  show: function (display) {
                      module.verbose('Showing element', display);
                      module.remove.hidden();
                      module.set.visible();
                      module.set.display();
                      module.repaint();
                  },

                  toggle: function () {
                      if (module.is.visible()) {
                          module.hide();
                      }
                      else {
                          module.show();
                      }
                  },

                  stop: function () {
                      module.debug('Stopping current animation');
                      $module.trigger(animationEnd);
                  },

                  stopAll: function () {
                      module.debug('Stopping all animation');
                      module.remove.queueCallback();
                      $module.trigger(animationEnd);
                  },

                  clear: {
                      queue: function () {
                          module.debug('Clearing animation queue')
                          module.remove.queueCallback();
                      }
                  },

                  enable: function () {
                      module.verbose('Starting animation');
                      $module.removeClass(className.disabled);
                  },

                  disable: function () {
                      module.debug('Stopping animation');
                      $module.addClass(className.disabled);
                  },

                  setting: function (name, value) {
                      module.debug('Changing setting', name, value);
                      if ($.isPlainObject(name)) {
                          $.extend(true, settings, name);
                      }
                      else if (value !== undefined) {
                          settings[name] = value;
                      }
                      else {
                          return settings[name];
                      }
                  },
                  internal: function (name, value) {
                      if ($.isPlainObject(name)) {
                          $.extend(true, module, name);
                      }
                      else if (value !== undefined) {
                          module[name] = value;
                      }
                      else {
                          return module[name];
                      }
                  },
                  debug: function () {
                      if (settings.debug) {
                          if (settings.performance) {
                              module.performance.log(arguments);
                          }
                          else {
                              module.debug = Function.prototype.bind.call(console.info, console, settings.name + ':');
                              module.debug.apply(console, arguments);
                          }
                      }
                  },
                  verbose: function () {
                      if (settings.verbose && settings.debug) {
                          if (settings.performance) {
                              module.performance.log(arguments);
                          }
                          else {
                              module.verbose = Function.prototype.bind.call(console.info, console, settings.name + ':');
                              module.verbose.apply(console, arguments);
                          }
                      }
                  },
                  error: function () {
                      module.error = Function.prototype.bind.call(console.error, console, settings.name + ':');
                      module.error.apply(console, arguments);
                  },
                  performance: {
                      log: function (message) {
                          var
                            currentTime,
                            executionTime,
                            previousTime
                          ;
                          if (settings.performance) {
                              currentTime = new Date().getTime();
                              previousTime = time || currentTime;
                              executionTime = currentTime - previousTime;
                              time = currentTime;
                              performance.push({
                                  'Name': message[0],
                                  'Arguments': [].slice.call(message, 1) || '',
                                  'Element': element,
                                  'Execution Time': executionTime
                              });
                          }
                          clearTimeout(module.performance.timer);
                          module.performance.timer = setTimeout(module.performance.display, 100);
                      },
                      display: function () {
                          var
                            title = settings.name + ':',
                            totalTime = 0
                          ;
                          time = false;
                          clearTimeout(module.performance.timer);
                          $.each(performance, function (index, data) {
                              totalTime += data['Execution Time'];
                          });
                          title += ' ' + totalTime + 'ms';
                          if (moduleSelector) {
                              title += ' \'' + moduleSelector + '\'';
                          }
                          if ($allModules.length > 1) {
                              title += ' ' + '(' + $allModules.length + ')';
                          }
                          if ((console.group !== undefined || console.table !== undefined) && performance.length > 0) {
                              console.groupCollapsed(title);
                              if (console.table) {
                                  console.table(performance);
                              }
                              else {
                                  $.each(performance, function (index, data) {
                                      console.log(data['Name'] + ': ' + data['Execution Time'] + 'ms');
                                  });
                              }
                              console.groupEnd();
                          }
                          performance = [];
                      }
                  },
                  // modified for transition to return invoke success
                  invoke: function (query, passedArguments, context) {
                      var
                        object = instance,
                        maxDepth,
                        found,
                        response
                      ;
                      passedArguments = passedArguments || queryArguments;
                      context = element || context;
                      if (typeof query == 'string' && object !== undefined) {
                          query = query.split(/[\. ]/);
                          maxDepth = query.length - 1;
                          $.each(query, function (depth, value) {
                              var camelCaseValue = (depth != maxDepth)
                                ? value + query[depth + 1].charAt(0).toUpperCase() + query[depth + 1].slice(1)
                                : query
                              ;
                              if ($.isPlainObject(object[camelCaseValue]) && (depth != maxDepth)) {
                                  object = object[camelCaseValue];
                              }
                              else if (object[camelCaseValue] !== undefined) {
                                  found = object[camelCaseValue];
                                  return false;
                              }
                              else if ($.isPlainObject(object[value]) && (depth != maxDepth)) {
                                  object = object[value];
                              }
                              else if (object[value] !== undefined) {
                                  found = object[value];
                                  return false;
                              }
                              else {
                                  return false;
                              }
                          });
                      }
                      if ($.isFunction(found)) {
                          response = found.apply(context, passedArguments);
                      }
                      else if (found !== undefined) {
                          response = found;
                      }

                      if ($.isArray(returnedValue)) {
                          returnedValue.push(response);
                      }
                      else if (returnedValue !== undefined) {
                          returnedValue = [returnedValue, response];
                      }
                      else if (response !== undefined) {
                          returnedValue = response;
                      }
                      return (found !== undefined)
                        ? found
                        : false
                      ;
                  }
              };
              module.initialize();
          })
        ;
        return (returnedValue !== undefined)
          ? returnedValue
          : this
        ;
    };

    // Records if CSS transition is available
    $.fn.transition.exists = {};

    $.fn.transition.settings = {

        // module info
        name: 'Transition',

        // debug content outputted to console
        debug: false,

        // verbose debug output
        verbose: true,

        // performance data output
        performance: true,

        // event namespace
        namespace: 'transition',

        // delay between animations in group
        interval: 0,

        // whether group animations should be reversed
        reverse: 'auto',

        // animation callback event
        onStart: function () { },
        onComplete: function () { },
        onShow: function () { },
        onHide: function () { },

        // whether timeout should be used to ensure callback fires in cases animationend does not
        useFailSafe: true,

        // delay in ms for fail safe
        failSafeDelay: 100,

        // whether EXACT animation can occur twice in a row
        allowRepeats: false,

        // Override final display type on visible
        displayType: false,

        // animation duration
        animation: 'fade',
        duration: false,

        // new animations will occur after previous ones
        queue: true,

        metadata: {
            displayType: 'display'
        },

        className: {
            animating: 'animating',
            disabled: 'disabled',
            hidden: 'hidden',
            inward: 'in',
            loading: 'loading',
            looping: 'looping',
            outward: 'out',
            transition: 'transition',
            visible: 'visible'
        },

        // possible errors
        error: {
            noAnimation: 'There is no css animation matching the one you specified.',
            repeated: 'That animation is already occurring, cancelling repeated animation',
            method: 'The method you called is not defined',
            support: 'This browser does not support CSS animations'
        }

    };


})(jQuery, window, document);

/*!
 * # Semantic UI 1.12.1 - Video
 * http://github.com/semantic-org/semantic-ui/
 *
 *
 * Copyright 2014 Contributorss
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 *
 */

; (function ($, window, document, undefined) {

    "use strict";

    $.fn.video = function (parameters) {

        var
          $allModules = $(this),

          moduleSelector = $allModules.selector || '',

          time = new Date().getTime(),
          performance = [],

          query = arguments[0],
          methodInvoked = (typeof query == 'string'),
          queryArguments = [].slice.call(arguments, 1),

          requestAnimationFrame = window.requestAnimationFrame
            || window.mozRequestAnimationFrame
            || window.webkitRequestAnimationFrame
            || window.msRequestAnimationFrame
            || function (callback) { setTimeout(callback, 0); },

          returnedValue
        ;

        $allModules
          .each(function () {
              var
                settings = ($.isPlainObject(parameters))
                  ? $.extend(true, {}, $.fn.video.settings, parameters)
                  : $.extend({}, $.fn.video.settings),

                selector = settings.selector,
                className = settings.className,
                error = settings.error,
                metadata = settings.metadata,
                namespace = settings.namespace,
                templates = settings.templates,

                eventNamespace = '.' + namespace,
                moduleNamespace = 'module-' + namespace,

                $window = $(window),
                $module = $(this),
                $placeholder = $module.find(selector.placeholder),
                $playButton = $module.find(selector.playButton),
                $embed = $module.find(selector.embed),

                element = this,
                instance = $module.data(moduleNamespace),
                module
              ;

              module = {

                  initialize: function () {
                      module.debug('Initializing video');
                      module.create();
                      $placeholder
                        .on('click' + eventNamespace, module.play)
                      ;
                      $playButton
                        .on('click' + eventNamespace, module.play)
                      ;
                      module.instantiate();
                  },

                  instantiate: function () {
                      module.verbose('Storing instance of module', module);
                      instance = module;
                      $module
                        .data(moduleNamespace, module)
                      ;
                  },

                  create: function () {
                      var
                        image = $module.data(metadata.image),
                        html = templates.video(image)
                      ;
                      $module.html(html);
                      module.refresh();
                      if (!image) {
                          module.play();
                      }
                      module.debug('Creating html for video element', html);
                  },

                  destroy: function () {
                      module.verbose('Destroying previous instance of video');
                      module.reset();
                      $module
                        .removeData(moduleNamespace)
                        .off(eventNamespace)
                      ;
                      $placeholder
                        .off(eventNamespace)
                      ;
                      $playButton
                        .off(eventNamespace)
                      ;
                  },

                  refresh: function () {
                      module.verbose('Refreshing selector cache');
                      $placeholder = $module.find(selector.placeholder);
                      $playButton = $module.find(selector.playButton);
                      $embed = $module.find(selector.embed);
                  },

                  // sets new video
                  change: function (source, id, url) {
                      module.debug('Changing video to ', source, id, url);
                      $module
                        .data(metadata.source, source)
                        .data(metadata.id, id)
                        .data(metadata.url, url)
                      ;
                      settings.onChange();
                  },

                  // clears video embed
                  reset: function () {
                      module.debug('Clearing video embed and showing placeholder');
                      $module
                        .removeClass(className.active)
                      ;
                      $embed
                        .html(' ')
                      ;
                      $placeholder
                        .show()
                      ;
                      settings.onReset();
                  },

                  // plays current video
                  play: function () {
                      module.debug('Playing video');
                      var
                        source = $module.data(metadata.source) || false,
                        url = $module.data(metadata.url) || false,
                        id = $module.data(metadata.id) || false
                      ;
                      $embed
                        .html(module.generate.html(source, id, url))
                      ;
                      $module
                        .addClass(className.active)
                      ;
                      settings.onPlay();
                  },

                  get: {
                      source: function (url) {
                          if (typeof url !== 'string') {
                              return false;
                          }
                          if (url.search('youtube.com') !== -1) {
                              return 'youtube';
                          }
                          else if (url.search('vimeo.com') !== -1) {
                              return 'vimeo';
                          }
                          return false;
                      },
                      id: function (url) {
                          if (url.match(settings.regExp.youtube)) {
                              return url.match(settings.regExp.youtube)[1];
                          }
                          else if (url.match(settings.regExp.vimeo)) {
                              return url.match(settings.regExp.vimeo)[2];
                          }
                          return false;
                      }
                  },

                  generate: {
                      // generates iframe html
                      html: function (source, id, url) {
                          module.debug('Generating embed html');
                          var
                            html
                          ;
                          // allow override of settings
                          source = source || settings.source;
                          id = id || settings.id;
                          if ((source && id) || url) {
                              if (!source || !id) {
                                  source = module.get.source(url);
                                  id = module.get.id(url);
                              }
                              if (source == 'vimeo') {
                                  html = ''
                                    + '<iframe src="//player.vimeo.com/video/' + id + '?=' + module.generate.url(source) + '"'
                                    + ' width="100%" height="100%"'
                                    + ' frameborder="0" webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe>'
                                  ;
                              }
                              else if (source == 'youtube') {
                                  html = ''
                                    + '<iframe src="//www.youtube.com/embed/' + id + '?=' + module.generate.url(source) + '"'
                                    + ' width="100%" height="100%"'
                                    + ' frameborder="0" webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe>'
                                  ;
                              }
                          }
                          else {
                              module.error(error.noVideo);
                          }
                          return html;
                      },

                      // generate url parameters
                      url: function (source) {
                          var
                            api = (settings.api)
                              ? 1
                              : 0,
                            autoplay = (settings.autoplay === 'auto')
                              ? ($module.data('image') !== undefined)
                              : settings.autoplay,
                            hd = (settings.hd)
                              ? 1
                              : 0,
                            showUI = (settings.showUI)
                              ? 1
                              : 0,
                            // opposite used for some params
                            hideUI = !(settings.showUI)
                              ? 1
                              : 0,
                            url = ''
                          ;
                          if (source == 'vimeo') {
                              url = ''
                                + 'api=' + api
                                + '&amp;title=' + showUI
                                + '&amp;byline=' + showUI
                                + '&amp;portrait=' + showUI
                                + '&amp;autoplay=' + autoplay
                              ;
                              if (settings.color) {
                                  url += '&amp;color=' + settings.color;
                              }
                          }
                          if (source == 'ustream') {
                              url = ''
                                + 'autoplay=' + autoplay
                              ;
                              if (settings.color) {
                                  url += '&amp;color=' + settings.color;
                              }
                          }
                          else if (source == 'youtube') {
                              url = ''
                                + 'enablejsapi=' + api
                                + '&amp;autoplay=' + autoplay
                                + '&amp;autohide=' + hideUI
                                + '&amp;hq=' + hd
                                + '&amp;modestbranding=1'
                              ;
                              if (settings.color) {
                                  url += '&amp;color=' + settings.color;
                              }
                          }
                          return url;
                      }
                  },

                  setting: function (name, value) {
                      module.debug('Changing setting', name, value);
                      if ($.isPlainObject(name)) {
                          $.extend(true, settings, name);
                      }
                      else if (value !== undefined) {
                          settings[name] = value;
                      }
                      else {
                          return settings[name];
                      }
                  },
                  internal: function (name, value) {
                      if ($.isPlainObject(name)) {
                          $.extend(true, module, name);
                      }
                      else if (value !== undefined) {
                          module[name] = value;
                      }
                      else {
                          return module[name];
                      }
                  },
                  debug: function () {
                      if (settings.debug) {
                          if (settings.performance) {
                              module.performance.log(arguments);
                          }
                          else {
                              module.debug = Function.prototype.bind.call(console.info, console, settings.name + ':');
                              module.debug.apply(console, arguments);
                          }
                      }
                  },
                  verbose: function () {
                      if (settings.verbose && settings.debug) {
                          if (settings.performance) {
                              module.performance.log(arguments);
                          }
                          else {
                              module.verbose = Function.prototype.bind.call(console.info, console, settings.name + ':');
                              module.verbose.apply(console, arguments);
                          }
                      }
                  },
                  error: function () {
                      module.error = Function.prototype.bind.call(console.error, console, settings.name + ':');
                      module.error.apply(console, arguments);
                  },
                  performance: {
                      log: function (message) {
                          var
                            currentTime,
                            executionTime,
                            previousTime
                          ;
                          if (settings.performance) {
                              currentTime = new Date().getTime();
                              previousTime = time || currentTime;
                              executionTime = currentTime - previousTime;
                              time = currentTime;
                              performance.push({
                                  'Name': message[0],
                                  'Arguments': [].slice.call(message, 1) || '',
                                  'Element': element,
                                  'Execution Time': executionTime
                              });
                          }
                          clearTimeout(module.performance.timer);
                          module.performance.timer = setTimeout(module.performance.display, 100);
                      },
                      display: function () {
                          var
                            title = settings.name + ':',
                            totalTime = 0
                          ;
                          time = false;
                          clearTimeout(module.performance.timer);
                          $.each(performance, function (index, data) {
                              totalTime += data['Execution Time'];
                          });
                          title += ' ' + totalTime + 'ms';
                          if (moduleSelector) {
                              title += ' \'' + moduleSelector + '\'';
                          }
                          if ($allModules.length > 1) {
                              title += ' ' + '(' + $allModules.length + ')';
                          }
                          if ((console.group !== undefined || console.table !== undefined) && performance.length > 0) {
                              console.groupCollapsed(title);
                              if (console.table) {
                                  console.table(performance);
                              }
                              else {
                                  $.each(performance, function (index, data) {
                                      console.log(data['Name'] + ': ' + data['Execution Time'] + 'ms');
                                  });
                              }
                              console.groupEnd();
                          }
                          performance = [];
                      }
                  },
                  invoke: function (query, passedArguments, context) {
                      var
                        object = instance,
                        maxDepth,
                        found,
                        response
                      ;
                      passedArguments = passedArguments || queryArguments;
                      context = element || context;
                      if (typeof query == 'string' && object !== undefined) {
                          query = query.split(/[\. ]/);
                          maxDepth = query.length - 1;
                          $.each(query, function (depth, value) {
                              var camelCaseValue = (depth != maxDepth)
                                ? value + query[depth + 1].charAt(0).toUpperCase() + query[depth + 1].slice(1)
                                : query
                              ;
                              if ($.isPlainObject(object[camelCaseValue]) && (depth != maxDepth)) {
                                  object = object[camelCaseValue];
                              }
                              else if (object[camelCaseValue] !== undefined) {
                                  found = object[camelCaseValue];
                                  return false;
                              }
                              else if ($.isPlainObject(object[value]) && (depth != maxDepth)) {
                                  object = object[value];
                              }
                              else if (object[value] !== undefined) {
                                  found = object[value];
                                  return false;
                              }
                              else {
                                  module.error(error.method, query);
                                  return false;
                              }
                          });
                      }
                      if ($.isFunction(found)) {
                          response = found.apply(context, passedArguments);
                      }
                      else if (found !== undefined) {
                          response = found;
                      }
                      if ($.isArray(returnedValue)) {
                          returnedValue.push(response);
                      }
                      else if (returnedValue !== undefined) {
                          returnedValue = [returnedValue, response];
                      }
                      else if (response !== undefined) {
                          returnedValue = response;
                      }
                      return found;
                  }
              };

              if (methodInvoked) {
                  if (instance === undefined) {
                      module.initialize();
                  }
                  module.invoke(query);
              }
              else {
                  if (instance !== undefined) {
                      instance.invoke('destroy');
                  }
                  module.initialize();
              }
          })
        ;
        return (returnedValue !== undefined)
          ? returnedValue
          : this
        ;
    };

    $.fn.video.settings = {

        name: 'Video',
        namespace: 'video',

        debug: false,
        verbose: true,
        performance: true,

        metadata: {
            id: 'id',
            image: 'image',
            source: 'source',
            url: 'url'
        },

        source: false,
        url: false,
        id: false,

        aspectRatio: (16 / 9),

        onPlay: function () { },
        onReset: function () { },
        onChange: function () { },

        // callbacks not coded yet (needs to use jsapi)
        onPause: function () { },
        onStop: function () { },

        width: 'auto',
        height: 'auto',

        autoplay: 'auto',
        color: '#442359',
        hd: true,
        showUI: false,
        api: true,

        regExp: {
            youtube: /^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/,
            vimeo: /http:\/\/(www\.)?vimeo.com\/(\d+)($|\/)/
        },

        error: {
            noVideo: 'No video specified',
            method: 'The method you called is not defined'
        },

        className: {
            active: 'active'
        },

        selector: {
            embed: '.embed',
            placeholder: '.placeholder',
            playButton: '.play'
        }
    };

    $.fn.video.settings.templates = {
        video: function (image) {
            var
              html = ''
            ;
            if (image) {
                html += ''
                  + '<i class="video play icon"></i>'
                  + '<img class="placeholder" src="' + image + '">'
                ;
            }
            html += '<div class="embed"></div>';
            return html;
        }
    };


})(jQuery, window, document);

/*!
 * # Semantic UI 1.12.1 - API
 * http://github.com/semantic-org/semantic-ui/
 *
 *
 * Copyright 2014 Contributors
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 *
 */

; (function ($, window, document, undefined) {

    "use strict";

    $.api = $.fn.api = function (parameters) {

        var
          // use window context if none specified
          $allModules = $.isFunction(this)
              ? $(window)
              : $(this),
          moduleSelector = $allModules.selector || '',
          time = new Date().getTime(),
          performance = [],

          query = arguments[0],
          methodInvoked = (typeof query == 'string'),
          queryArguments = [].slice.call(arguments, 1),

          returnedValue
        ;

        $allModules
          .each(function () {
              var
                settings = ($.isPlainObject(parameters))
                  ? $.extend(true, {}, $.fn.api.settings, parameters)
                  : $.extend({}, $.fn.api.settings),

                // internal aliases
                namespace = settings.namespace,
                metadata = settings.metadata,
                selector = settings.selector,
                error = settings.error,
                className = settings.className,

                // define namespaces for modules
                eventNamespace = '.' + namespace,
                moduleNamespace = 'module-' + namespace,

                // element that creates request
                $module = $(this),
                $form = $module.closest(selector.form),

                // context used for state
                $context = (settings.stateContext)
                  ? $(settings.stateContext)
                  : $module,

                // request details
                ajaxSettings,
                requestSettings,
                url,
                data,

                // standard module
                element = this,
                context = $context.get(),
                instance = $module.data(moduleNamespace),
                module
              ;

              module = {

                  initialize: function () {
                      var
                        triggerEvent = module.get.event()
                      ;
                      // bind events
                      if (!methodInvoked) {
                          if (triggerEvent) {
                              module.debug('Attaching API events to element', triggerEvent);
                              $module
                                .on(triggerEvent + eventNamespace, module.event.trigger)
                              ;
                          }
                          else if (settings.on == 'now') {
                              module.debug('Querying API now', triggerEvent);
                              module.query();
                          }
                      }
                      module.instantiate();
                  },

                  instantiate: function () {
                      module.verbose('Storing instance of module', module);
                      instance = module;
                      $module
                        .data(moduleNamespace, instance)
                      ;
                  },

                  destroy: function () {
                      module.verbose('Destroying previous module for', element);
                      $module
                        .removeData(moduleNamespace)
                        .off(eventNamespace)
                      ;
                  },

                  query: function () {

                      if (module.is.disabled()) {
                          module.debug('Element is disabled API request aborted');
                          return;
                      }
                      // determine if an api event already occurred
                      if (module.is.loading() && settings.throttle === 0) {
                          module.debug('Cancelling request, previous request is still pending');
                          return;
                      }

                      // pass element metadata to url (value, text)
                      if (settings.defaultData) {
                          $.extend(true, settings.urlData, module.get.defaultData());
                      }

                      // Add form content
                      if (settings.serializeForm !== false || $context.is('form')) {
                          if (settings.serializeForm == 'json') {
                              $.extend(true, settings.data, module.get.formData());
                          }
                          else {
                              settings.data = module.get.formData();
                          }
                      }

                      // call beforesend and get any settings changes
                      requestSettings = module.get.settings();

                      // check if before send cancelled request
                      if (requestSettings === false) {
                          module.cancelled = true;
                          module.error(error.beforeSend);
                          return;
                      }
                      else {
                          module.cancelled = false;
                      }

                      if (settings.url) {
                          // override with url if specified
                          module.debug('Using specified url', url);
                          url = module.add.urlData(settings.url);
                      }
                      else {
                          // otherwise find url from api endpoints
                          url = module.add.urlData(module.get.templateURL());
                          module.debug('Added URL Data to url', url);
                      }

                      // exit conditions reached, missing url parameters
                      if (!url) {
                          if (module.is.form()) {
                              url = $module.attr('action') || '';
                              module.debug('No url or action specified, defaulting to form action', url);
                          }
                          else {
                              module.error(error.missingURL, settings.action);
                              return;
                          }
                      }

                      // add loading state
                      module.set.loading();

                      // look for jQuery ajax parameters in settings
                      ajaxSettings = $.extend(true, {}, settings, {
                          type: settings.method || settings.type,
                          data: data,
                          url: settings.base + url,
                          beforeSend: settings.beforeXHR,
                          success: function () { },
                          failure: function () { },
                          complete: function () { }
                      });

                      module.debug('Querying URL', ajaxSettings.url);
                      module.debug('Sending data', data, ajaxSettings.method);
                      module.verbose('Using AJAX settings', ajaxSettings);

                      if (module.is.loading()) {
                          // throttle additional requests
                          module.timer = setTimeout(function () {
                              module.request = module.create.request();
                              module.xhr = module.create.xhr();
                              settings.onRequest.call(context, module.request, module.xhr);
                          }, settings.throttle);
                      }
                      else {
                          // immediately on first request
                          module.request = module.create.request();
                          module.xhr = module.create.xhr();
                          settings.onRequest.call(context, module.request, module.xhr);
                      }

                  },


                  is: {
                      disabled: function () {
                          return ($module.filter(settings.filter).length > 0);
                      },
                      form: function () {
                          return $module.is('form');
                      },
                      input: function () {
                          return $module.is('input');
                      },
                      loading: function () {
                          return (module.request && module.request.state() == 'pending');
                      }
                  },

                  was: {
                      cancelled: function () {
                          return (module.cancelled || false);
                      },
                      succesful: function () {
                          return (module.request && module.request.state() == 'resolved');
                      },
                      failure: function () {
                          return (module.request && module.request.state() == 'rejected');
                      },
                      complete: function () {
                          return (module.request && (module.request.state() == 'resolved' || module.request.state() == 'rejected'));
                      }
                  },

                  add: {
                      urlData: function (url, urlData) {
                          var
                            requiredVariables,
                            optionalVariables
                          ;
                          if (url) {
                              requiredVariables = url.match(settings.regExp.required);
                              optionalVariables = url.match(settings.regExp.optional);
                              urlData = urlData || settings.urlData;
                              if (requiredVariables) {
                                  module.debug('Looking for required URL variables', requiredVariables);
                                  $.each(requiredVariables, function (index, templatedString) {
                                      var
                                        // allow legacy {$var} style
                                        variable = (templatedString.indexOf('$') !== -1)
                                          ? templatedString.substr(2, templatedString.length - 3)
                                          : templatedString.substr(1, templatedString.length - 2),
                                        value = ($.isPlainObject(urlData) && urlData[variable] !== undefined)
                                          ? urlData[variable]
                                          : ($module.data(variable) !== undefined)
                                            ? $module.data(variable)
                                            : ($context.data(variable) !== undefined)
                                              ? $context.data(variable)
                                              : urlData[variable]
                                      ;
                                      // remove value
                                      if (value === undefined) {
                                          module.error(error.requiredParameter, variable, url);
                                          url = false;
                                          return false;
                                      }
                                      else {
                                          module.verbose('Found required variable', variable, value);
                                          url = url.replace(templatedString, value);
                                      }
                                  });
                              }
                              if (optionalVariables) {
                                  module.debug('Looking for optional URL variables', requiredVariables);
                                  $.each(optionalVariables, function (index, templatedString) {
                                      var
                                        // allow legacy {/$var} style
                                        variable = (templatedString.indexOf('$') !== -1)
                                          ? templatedString.substr(3, templatedString.length - 4)
                                          : templatedString.substr(2, templatedString.length - 3),
                                        value = ($.isPlainObject(urlData) && urlData[variable] !== undefined)
                                          ? urlData[variable]
                                          : ($module.data(variable) !== undefined)
                                            ? $module.data(variable)
                                            : ($context.data(variable) !== undefined)
                                              ? $context.data(variable)
                                              : urlData[variable]
                                      ;
                                      // optional replacement
                                      if (value !== undefined) {
                                          module.verbose('Optional variable Found', variable, value);
                                          url = url.replace(templatedString, value);
                                      }
                                      else {
                                          module.verbose('Optional variable not found', variable);
                                          // remove preceding slash if set
                                          if (url.indexOf('/' + templatedString) !== -1) {
                                              url = url.replace('/' + templatedString, '');
                                          }
                                          else {
                                              url = url.replace(templatedString, '');
                                          }
                                      }
                                  });
                              }
                          }
                          return url;
                      }
                  },

                  event: {
                      trigger: function (event) {
                          module.query();
                          if (event.type == 'submit' || event.type == 'click') {
                              event.preventDefault();
                          }
                      },
                      xhr: {
                          always: function () {
                              // calculate if loading time was below minimum threshold
                          },
                          done: function (response) {
                              var
                                context = this,
                                elapsedTime = (new Date().getTime() - time),
                                timeLeft = (settings.loadingDuration - elapsedTime)
                              ;
                              timeLeft = (timeLeft > 0)
                                ? timeLeft
                                : 0
                              ;
                              setTimeout(function () {
                                  module.request.resolveWith(context, [response]);
                              }, timeLeft);
                          },
                          fail: function (xhr, status, httpMessage) {
                              var
                                context = this,
                                elapsedTime = (new Date().getTime() - time),
                                timeLeft = (settings.loadingDuration - elapsedTime)
                              ;
                              timeLeft = (timeLeft > 0)
                                ? timeLeft
                                : 0
                              ;
                              // page triggers abort on navigation, dont show error
                              setTimeout(function () {
                                  if (status !== 'abort') {
                                      module.request.rejectWith(context, [xhr, status, httpMessage]);
                                  }
                                  else {
                                      module.reset();
                                  }
                              }, timeLeft);
                          }
                      },
                      request: {
                          complete: function (response) {
                              module.remove.loading();
                              settings.onComplete.call(context, response, $module);
                          },
                          done: function (response) {
                              module.debug('API Response Received', response);
                              if (settings.dataType == 'json') {
                                  if ($.isFunction(settings.successTest)) {
                                      module.debug('Checking JSON returned success', settings.successTest, response);
                                      if (settings.successTest(response)) {
                                          settings.onSuccess.call(context, response, $module);
                                      }
                                      else {
                                          module.debug('JSON test specified by user and response failed', response);
                                          settings.onFailure.call(context, response, $module);
                                      }
                                  }
                                  else {
                                      settings.onSuccess.call(context, response, $module);
                                  }
                              }
                              else {
                                  settings.onSuccess.call(context, response, $module);
                              }
                          },
                          error: function (xhr, status, httpMessage) {
                              var
                                errorMessage = (settings.error[status] !== undefined)
                                  ? settings.error[status]
                                  : httpMessage,
                                response
                              ;
                              // let em know unless request aborted
                              if (xhr !== undefined) {
                                  // readyState 4 = done, anything less is not really sent
                                  if (xhr.readyState !== undefined && xhr.readyState == 4) {

                                      // if http status code returned and json returned error, look for it
                                      if (xhr.status != 200 && httpMessage !== undefined && httpMessage !== '') {
                                          module.error(error.statusMessage + httpMessage, ajaxSettings.url);
                                      }
                                      else {
                                          if (status == 'error' && settings.dataType == 'json') {
                                              try {
                                                  response = $.parseJSON(xhr.responseText);
                                                  if (response && response.error !== undefined) {
                                                      errorMessage = response.error;
                                                  }
                                              }
                                              catch (e) {
                                                  module.error(error.JSONParse);
                                              }
                                          }
                                      }
                                      module.remove.loading();
                                      module.set.error();
                                      // show error state only for duration specified in settings
                                      if (settings.errorDuration) {
                                          setTimeout(module.remove.error, settings.errorDuration);
                                      }
                                      module.debug('API Request error:', errorMessage);
                                      settings.onError.call(context, errorMessage, $module);
                                  }
                                  else {
                                      settings.onAbort.call(context, errorMessage, $module);
                                      module.debug('Request Aborted (Most likely caused by page change or CORS Policy)', status, httpMessage);
                                  }
                              }
                          }
                      }
                  },

                  create: {
                      request: function () {
                          return $.Deferred()
                            .always(module.event.request.complete)
                            .done(module.event.request.done)
                            .fail(module.event.request.error)
                          ;
                      },
                      xhr: function () {
                          return $.ajax(ajaxSettings)
                            .always(module.event.xhr.always)
                            .done(module.event.xhr.done)
                            .fail(module.event.xhr.fail)
                          ;
                      }
                  },

                  set: {
                      error: function () {
                          module.verbose('Adding error state to element', $context);
                          $context.addClass(className.error);
                      },
                      loading: function () {
                          module.verbose('Adding loading state to element', $context);
                          $context.addClass(className.loading);
                      }
                  },

                  remove: {
                      error: function () {
                          module.verbose('Removing error state from element', $context);
                          $context.removeClass(className.error);
                      },
                      loading: function () {
                          module.verbose('Removing loading state from element', $context);
                          $context.removeClass(className.loading);
                      }
                  },

                  get: {
                      request: function () {
                          return module.request || false;
                      },
                      xhr: function () {
                          return module.xhr || false;
                      },
                      settings: function () {
                          var
                            runSettings
                          ;
                          runSettings = settings.beforeSend.call($module, settings);
                          if (runSettings) {
                              if (runSettings.success !== undefined) {
                                  module.debug('Legacy success callback detected', runSettings);
                                  module.error(error.legacyParameters, runSettings.success);
                                  runSettings.onSuccess = runSettings.success;
                              }
                              if (runSettings.failure !== undefined) {
                                  module.debug('Legacy failure callback detected', runSettings);
                                  module.error(error.legacyParameters, runSettings.failure);
                                  runSettings.onFailure = runSettings.failure;
                              }
                              if (runSettings.complete !== undefined) {
                                  module.debug('Legacy complete callback detected', runSettings);
                                  module.error(error.legacyParameters, runSettings.complete);
                                  runSettings.onComplete = runSettings.complete;
                              }
                          }
                          if (runSettings === undefined) {
                              module.error(error.noReturnedValue);
                          }
                          return (runSettings !== undefined)
                            ? runSettings
                            : settings
                          ;
                      },
                      defaultData: function () {
                          var
                            data = {}
                          ;
                          if (!$.isWindow(element)) {
                              if (module.is.input()) {
                                  data.value = $module.val();
                              }
                              else if (!module.is.form()) {

                              }
                              else {
                                  data.text = $module.text();
                              }
                          }
                          return data;
                      },
                      event: function () {
                          if ($.isWindow(element) || settings.on == 'now') {
                              module.debug('API called without element, no events attached');
                              return false;
                          }
                          else if (settings.on == 'auto') {
                              if ($module.is('input')) {
                                  return (element.oninput !== undefined)
                                    ? 'input'
                                    : (element.onpropertychange !== undefined)
                                      ? 'propertychange'
                                      : 'keyup'
                                  ;
                              }
                              else if ($module.is('form')) {
                                  return 'submit';
                              }
                              else {
                                  return 'click';
                              }
                          }
                          else {
                              return settings.on;
                          }
                      },
                      formData: function () {
                          var
                            formData
                          ;
                          if ($module.serializeObject !== undefined) {
                              formData = $form.serializeObject();
                          }
                          else {
                              module.error(error.missingSerialize);
                              formData = $form.serialize();
                          }
                          module.debug('Retrieved form data', formData);
                          return formData;
                      },
                      templateURL: function (action) {
                          var
                            url
                          ;
                          action = action || $module.data(metadata.action) || settings.action || false;
                          if (action) {
                              module.debug('Looking up url for action', action, settings.api);
                              if (settings.api[action] !== undefined) {
                                  url = settings.api[action];
                                  module.debug('Found template url', url);
                              }
                              else if (!module.is.form()) {
                                  module.error(error.missingAction, settings.action, settings.api);
                              }
                          }
                          return url;
                      }
                  },

                  abort: function () {
                      var
                        xhr = module.get.xhr()
                      ;
                      if (xhr && xhr.state() !== 'resolved') {
                          module.debug('Cancelling API request');
                          xhr.abort();
                          module.request.rejectWith(settings.apiSettings);
                      }
                  },

                  // reset state
                  reset: function () {
                      module.remove.error();
                      module.remove.loading();
                  },

                  setting: function (name, value) {
                      module.debug('Changing setting', name, value);
                      if ($.isPlainObject(name)) {
                          $.extend(true, settings, name);
                      }
                      else if (value !== undefined) {
                          settings[name] = value;
                      }
                      else {
                          return settings[name];
                      }
                  },
                  internal: function (name, value) {
                      if ($.isPlainObject(name)) {
                          $.extend(true, module, name);
                      }
                      else if (value !== undefined) {
                          module[name] = value;
                      }
                      else {
                          return module[name];
                      }
                  },
                  debug: function () {
                      if (settings.debug) {
                          if (settings.performance) {
                              module.performance.log(arguments);
                          }
                          else {
                              module.debug = Function.prototype.bind.call(console.info, console, settings.name + ':');
                              module.debug.apply(console, arguments);
                          }
                      }
                  },
                  verbose: function () {
                      if (settings.verbose && settings.debug) {
                          if (settings.performance) {
                              module.performance.log(arguments);
                          }
                          else {
                              module.verbose = Function.prototype.bind.call(console.info, console, settings.name + ':');
                              module.verbose.apply(console, arguments);
                          }
                      }
                  },
                  error: function () {
                      module.error = Function.prototype.bind.call(console.error, console, settings.name + ':');
                      module.error.apply(console, arguments);
                  },
                  performance: {
                      log: function (message) {
                          var
                            currentTime,
                            executionTime,
                            previousTime
                          ;
                          if (settings.performance) {
                              currentTime = new Date().getTime();
                              previousTime = time || currentTime;
                              executionTime = currentTime - previousTime;
                              time = currentTime;
                              performance.push({
                                  'Name': message[0],
                                  'Arguments': [].slice.call(message, 1) || '',
                                  //'Element'        : element,
                                  'Execution Time': executionTime
                              });
                          }
                          clearTimeout(module.performance.timer);
                          module.performance.timer = setTimeout(module.performance.display, 100);
                      },
                      display: function () {
                          var
                            title = settings.name + ':',
                            totalTime = 0
                          ;
                          time = false;
                          clearTimeout(module.performance.timer);
                          $.each(performance, function (index, data) {
                              totalTime += data['Execution Time'];
                          });
                          title += ' ' + totalTime + 'ms';
                          if (moduleSelector) {
                              title += ' \'' + moduleSelector + '\'';
                          }
                          if ((console.group !== undefined || console.table !== undefined) && performance.length > 0) {
                              console.groupCollapsed(title);
                              if (console.table) {
                                  console.table(performance);
                              }
                              else {
                                  $.each(performance, function (index, data) {
                                      console.log(data['Name'] + ': ' + data['Execution Time'] + 'ms');
                                  });
                              }
                              console.groupEnd();
                          }
                          performance = [];
                      }
                  },
                  invoke: function (query, passedArguments, context) {
                      var
                        object = instance,
                        maxDepth,
                        found,
                        response
                      ;
                      passedArguments = passedArguments || queryArguments;
                      context = element || context;
                      if (typeof query == 'string' && object !== undefined) {
                          query = query.split(/[\. ]/);
                          maxDepth = query.length - 1;
                          $.each(query, function (depth, value) {
                              var camelCaseValue = (depth != maxDepth)
                                ? value + query[depth + 1].charAt(0).toUpperCase() + query[depth + 1].slice(1)
                                : query
                              ;
                              if ($.isPlainObject(object[camelCaseValue]) && (depth != maxDepth)) {
                                  object = object[camelCaseValue];
                              }
                              else if (object[camelCaseValue] !== undefined) {
                                  found = object[camelCaseValue];
                                  return false;
                              }
                              else if ($.isPlainObject(object[value]) && (depth != maxDepth)) {
                                  object = object[value];
                              }
                              else if (object[value] !== undefined) {
                                  found = object[value];
                                  return false;
                              }
                              else {
                                  module.error(error.method, query);
                                  return false;
                              }
                          });
                      }
                      if ($.isFunction(found)) {
                          response = found.apply(context, passedArguments);
                      }
                      else if (found !== undefined) {
                          response = found;
                      }
                      if ($.isArray(returnedValue)) {
                          returnedValue.push(response);
                      }
                      else if (returnedValue !== undefined) {
                          returnedValue = [returnedValue, response];
                      }
                      else if (response !== undefined) {
                          returnedValue = response;
                      }
                      return found;
                  }
              };

              if (methodInvoked) {
                  if (instance === undefined) {
                      module.initialize();
                  }
                  module.invoke(query);
              }
              else {
                  if (instance !== undefined) {
                      instance.invoke('destroy');
                  }
                  module.initialize();
              }
          })
        ;

        return (returnedValue !== undefined)
          ? returnedValue
          : this
        ;
    };

    $.api.settings = {

        name: 'API',
        namespace: 'api',

        debug: true,
        verbose: false,
        performance: true,

        // event binding
        on: 'auto',
        filter: '.disabled',
        stateContext: false,

        // state
        loadingDuration: 0,
        errorDuration: 2000,

        // templating
        action: false,
        url: false,
        base: '',

        // data
        urlData: {},

        // ui
        defaultData: true,
        serializeForm: false,
        throttle: 0,

        // jQ ajax
        method: 'get',
        data: {},
        dataType: 'json',

        // callbacks
        beforeSend: function (settings) { return settings; },
        beforeXHR: function (xhr) { },

        onRequest: function (promise, xhr) { },
        onSuccess: function (response, $module) { },
        onComplete: function (response, $module) { },
        onFailure: function (errorMessage, $module) { },
        onError: function (errorMessage, $module) { },
        onAbort: function (errorMessage, $module) { },

        successTest: false,

        // errors
        error: {
            beforeSend: 'The before send function has aborted the request',
            error: 'There was an error with your request',
            exitConditions: 'API Request Aborted. Exit conditions met',
            JSONParse: 'JSON could not be parsed during error handling',
            legacyParameters: 'You are using legacy API success callback names',
            method: 'The method you called is not defined',
            missingAction: 'API action used but no url was defined',
            missingSerialize: 'Required dependency jquery-serialize-object missing, using basic serialize',
            missingURL: 'No URL specified for api event',
            noReturnedValue: 'The beforeSend callback must return a settings object, beforeSend ignored.',
            parseError: 'There was an error parsing your request',
            requiredParameter: 'Missing a required URL parameter: ',
            statusMessage: 'Server gave an error: ',
            timeout: 'Your request timed out'
        },

        regExp: {
            required: /\{\$*[A-z0-9]+\}/g,
            optional: /\{\/\$*[A-z0-9]+\}/g,
        },

        className: {
            loading: 'loading',
            error: 'error'
        },

        selector: {
            form: 'form'
        },

        metadata: {
            action: 'action'
        }
    };


    $.api.settings.api = {};


})(jQuery, window, document);
/*!
 * # Semantic UI 1.12.1 - State
 * http://github.com/semantic-org/semantic-ui/
 *
 *
 * Copyright 2014 Contributors
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 *
 */

; (function ($, window, document, undefined) {

    "use strict";

    $.fn.state = function (parameters) {
        var
          $allModules = $(this),

          moduleSelector = $allModules.selector || '',

          hasTouch = ('ontouchstart' in document.documentElement),
          time = new Date().getTime(),
          performance = [],

          query = arguments[0],
          methodInvoked = (typeof query == 'string'),
          queryArguments = [].slice.call(arguments, 1),

          returnedValue
        ;
        $allModules
          .each(function () {
              var
                settings = ($.isPlainObject(parameters))
                  ? $.extend(true, {}, $.fn.state.settings, parameters)
                  : $.extend({}, $.fn.state.settings),

                error = settings.error,
                metadata = settings.metadata,
                className = settings.className,
                namespace = settings.namespace,
                states = settings.states,
                text = settings.text,

                eventNamespace = '.' + namespace,
                moduleNamespace = namespace + '-module',

                $module = $(this),

                element = this,
                instance = $module.data(moduleNamespace),

                module
              ;
              module = {

                  initialize: function () {
                      module.verbose('Initializing module');

                      // allow module to guess desired state based on element
                      if (settings.automatic) {
                          module.add.defaults();
                      }

                      // bind events with delegated events
                      if (settings.context && moduleSelector !== '') {
                          $(settings.context)
                            .on(moduleSelector, 'mouseenter' + eventNamespace, module.change.text)
                            .on(moduleSelector, 'mouseleave' + eventNamespace, module.reset.text)
                            .on(moduleSelector, 'click' + eventNamespace, module.toggle.state)
                          ;
                      }
                      else {
                          $module
                            .on('mouseenter' + eventNamespace, module.change.text)
                            .on('mouseleave' + eventNamespace, module.reset.text)
                            .on('click' + eventNamespace, module.toggle.state)
                          ;
                      }
                      module.instantiate();
                  },

                  instantiate: function () {
                      module.verbose('Storing instance of module', module);
                      instance = module;
                      $module
                        .data(moduleNamespace, module)
                      ;
                  },

                  destroy: function () {
                      module.verbose('Destroying previous module', instance);
                      $module
                        .off(eventNamespace)
                        .removeData(moduleNamespace)
                      ;
                  },

                  refresh: function () {
                      module.verbose('Refreshing selector cache');
                      $module = $(element);
                  },

                  add: {
                      defaults: function () {
                          var
                            userStates = parameters && $.isPlainObject(parameters.states)
                              ? parameters.states
                              : {}
                          ;
                          $.each(settings.defaults, function (type, typeStates) {
                              if (module.is[type] !== undefined && module.is[type]()) {
                                  module.verbose('Adding default states', type, element);
                                  $.extend(settings.states, typeStates, userStates);
                              }
                          });
                      }
                  },

                  is: {

                      active: function () {
                          return $module.hasClass(className.active);
                      },
                      loading: function () {
                          return $module.hasClass(className.loading);
                      },
                      inactive: function () {
                          return !($module.hasClass(className.active));
                      },
                      state: function (state) {
                          if (className[state] === undefined) {
                              return false;
                          }
                          return $module.hasClass(className[state]);
                      },

                      enabled: function () {
                          return !($module.is(settings.filter.active));
                      },
                      disabled: function () {
                          return ($module.is(settings.filter.active));
                      },
                      textEnabled: function () {
                          return !($module.is(settings.filter.text));
                      },

                      // definitions for automatic type detection
                      button: function () {
                          return $module.is('.button:not(a, .submit)');
                      },
                      input: function () {
                          return $module.is('input');
                      },
                      progress: function () {
                          return $module.is('.ui.progress');
                      }
                  },

                  allow: function (state) {
                      module.debug('Now allowing state', state);
                      states[state] = true;
                  },
                  disallow: function (state) {
                      module.debug('No longer allowing', state);
                      states[state] = false;
                  },

                  allows: function (state) {
                      return states[state] || false;
                  },

                  enable: function () {
                      $module.removeClass(className.disabled);
                  },

                  disable: function () {
                      $module.addClass(className.disabled);
                  },

                  setState: function (state) {
                      if (module.allows(state)) {
                          $module.addClass(className[state]);
                      }
                  },

                  removeState: function (state) {
                      if (module.allows(state)) {
                          $module.removeClass(className[state]);
                      }
                  },

                  toggle: {
                      state: function () {
                          var
                            apiRequest,
                            requestCancelled
                          ;
                          if (module.allows('active') && module.is.enabled()) {
                              module.refresh();
                              if ($.fn.api !== undefined) {
                                  apiRequest = $module.api('get request');
                                  requestCancelled = $module.api('was cancelled');
                                  if (requestCancelled) {
                                      module.debug('API Request cancelled by beforesend');
                                      settings.activateTest = function () { return false; };
                                      settings.deactivateTest = function () { return false; };
                                  }
                                  else if (apiRequest) {
                                      module.listenTo(apiRequest);
                                      return;
                                  }
                              }
                              module.change.state();
                          }
                      }
                  },

                  listenTo: function (apiRequest) {
                      module.debug('API request detected, waiting for state signal', apiRequest);
                      if (apiRequest) {
                          if (text.loading) {
                              module.update.text(text.loading);
                          }
                          $.when(apiRequest)
                            .then(function () {
                                if (apiRequest.state() == 'resolved') {
                                    module.debug('API request succeeded');
                                    settings.activateTest = function () { return true; };
                                    settings.deactivateTest = function () { return true; };
                                }
                                else {
                                    module.debug('API request failed');
                                    settings.activateTest = function () { return false; };
                                    settings.deactivateTest = function () { return false; };
                                }
                                module.change.state();
                            })
                          ;
                      }
                  },

                  // checks whether active/inactive state can be given
                  change: {

                      state: function () {
                          module.debug('Determining state change direction');
                          // inactive to active change
                          if (module.is.inactive()) {
                              module.activate();
                          }
                          else {
                              module.deactivate();
                          }
                          if (settings.sync) {
                              module.sync();
                          }
                          settings.onChange.call(element);
                      },

                      text: function () {
                          if (module.is.textEnabled()) {
                              if (module.is.disabled()) {
                                  module.verbose('Changing text to disabled text', text.hover);
                                  module.update.text(text.disabled);
                              }
                              else if (module.is.active()) {
                                  if (text.hover) {
                                      module.verbose('Changing text to hover text', text.hover);
                                      module.update.text(text.hover);
                                  }
                                  else if (text.deactivate) {
                                      module.verbose('Changing text to deactivating text', text.deactivate);
                                      module.update.text(text.deactivate);
                                  }
                              }
                              else {
                                  if (text.hover) {
                                      module.verbose('Changing text to hover text', text.hover);
                                      module.update.text(text.hover);
                                  }
                                  else if (text.activate) {
                                      module.verbose('Changing text to activating text', text.activate);
                                      module.update.text(text.activate);
                                  }
                              }
                          }
                      }

                  },

                  activate: function () {
                      if (settings.activateTest.call(element)) {
                          module.debug('Setting state to active');
                          $module
                            .addClass(className.active)
                          ;
                          module.update.text(text.active);
                          settings.onActivate.call(element);
                      }
                  },

                  deactivate: function () {
                      if (settings.deactivateTest.call(element)) {
                          module.debug('Setting state to inactive');
                          $module
                            .removeClass(className.active)
                          ;
                          module.update.text(text.inactive);
                          settings.onDeactivate.call(element);
                      }
                  },

                  sync: function () {
                      module.verbose('Syncing other buttons to current state');
                      if (module.is.active()) {
                          $allModules
                            .not($module)
                              .state('activate');
                      }
                      else {
                          $allModules
                            .not($module)
                              .state('deactivate')
                          ;
                      }
                  },

                  get: {
                      text: function () {
                          return (settings.selector.text)
                            ? $module.find(settings.selector.text).text()
                            : $module.html()
                          ;
                      },
                      textFor: function (state) {
                          return text[state] || false;
                      }
                  },

                  flash: {
                      text: function (text, duration, callback) {
                          var
                            previousText = module.get.text()
                          ;
                          module.debug('Flashing text message', text, duration);
                          text = text || settings.text.flash;
                          duration = duration || settings.flashDuration;
                          callback = callback || function () { };
                          module.update.text(text);
                          setTimeout(function () {
                              module.update.text(previousText);
                              callback.call(element);
                          }, duration);
                      }
                  },

                  reset: {
                      // on mouseout sets text to previous value
                      text: function () {
                          var
                            activeText = text.active || $module.data(metadata.storedText),
                            inactiveText = text.inactive || $module.data(metadata.storedText)
                          ;
                          if (module.is.textEnabled()) {
                              if (module.is.active() && activeText) {
                                  module.verbose('Resetting active text', activeText);
                                  module.update.text(activeText);
                              }
                              else if (inactiveText) {
                                  module.verbose('Resetting inactive text', activeText);
                                  module.update.text(inactiveText);
                              }
                          }
                      }
                  },

                  update: {
                      text: function (text) {
                          var
                            currentText = module.get.text()
                          ;
                          if (text && text !== currentText) {
                              module.debug('Updating text', text);
                              if (settings.selector.text) {
                                  $module
                                    .data(metadata.storedText, text)
                                    .find(settings.selector.text)
                                      .text(text)
                                  ;
                              }
                              else {
                                  $module
                                    .data(metadata.storedText, text)
                                    .html(text)
                                  ;
                              }
                          }
                          else {
                              module.debug('Text is already set, ignoring update', text);
                          }
                      }
                  },

                  setting: function (name, value) {
                      module.debug('Changing setting', name, value);
                      if ($.isPlainObject(name)) {
                          $.extend(true, settings, name);
                      }
                      else if (value !== undefined) {
                          settings[name] = value;
                      }
                      else {
                          return settings[name];
                      }
                  },
                  internal: function (name, value) {
                      if ($.isPlainObject(name)) {
                          $.extend(true, module, name);
                      }
                      else if (value !== undefined) {
                          module[name] = value;
                      }
                      else {
                          return module[name];
                      }
                  },
                  debug: function () {
                      if (settings.debug) {
                          if (settings.performance) {
                              module.performance.log(arguments);
                          }
                          else {
                              module.debug = Function.prototype.bind.call(console.info, console, settings.name + ':');
                              module.debug.apply(console, arguments);
                          }
                      }
                  },
                  verbose: function () {
                      if (settings.verbose && settings.debug) {
                          if (settings.performance) {
                              module.performance.log(arguments);
                          }
                          else {
                              module.verbose = Function.prototype.bind.call(console.info, console, settings.name + ':');
                              module.verbose.apply(console, arguments);
                          }
                      }
                  },
                  error: function () {
                      module.error = Function.prototype.bind.call(console.error, console, settings.name + ':');
                      module.error.apply(console, arguments);
                  },
                  performance: {
                      log: function (message) {
                          var
                            currentTime,
                            executionTime,
                            previousTime
                          ;
                          if (settings.performance) {
                              currentTime = new Date().getTime();
                              previousTime = time || currentTime;
                              executionTime = currentTime - previousTime;
                              time = currentTime;
                              performance.push({
                                  'Name': message[0],
                                  'Arguments': [].slice.call(message, 1) || '',
                                  'Element': element,
                                  'Execution Time': executionTime
                              });
                          }
                          clearTimeout(module.performance.timer);
                          module.performance.timer = setTimeout(module.performance.display, 100);
                      },
                      display: function () {
                          var
                            title = settings.name + ':',
                            totalTime = 0
                          ;
                          time = false;
                          clearTimeout(module.performance.timer);
                          $.each(performance, function (index, data) {
                              totalTime += data['Execution Time'];
                          });
                          title += ' ' + totalTime + 'ms';
                          if (moduleSelector) {
                              title += ' \'' + moduleSelector + '\'';
                          }
                          if ((console.group !== undefined || console.table !== undefined) && performance.length > 0) {
                              console.groupCollapsed(title);
                              if (console.table) {
                                  console.table(performance);
                              }
                              else {
                                  $.each(performance, function (index, data) {
                                      console.log(data['Name'] + ': ' + data['Execution Time'] + 'ms');
                                  });
                              }
                              console.groupEnd();
                          }
                          performance = [];
                      }
                  },
                  invoke: function (query, passedArguments, context) {
                      var
                        object = instance,
                        maxDepth,
                        found,
                        response
                      ;
                      passedArguments = passedArguments || queryArguments;
                      context = element || context;
                      if (typeof query == 'string' && object !== undefined) {
                          query = query.split(/[\. ]/);
                          maxDepth = query.length - 1;
                          $.each(query, function (depth, value) {
                              var camelCaseValue = (depth != maxDepth)
                                ? value + query[depth + 1].charAt(0).toUpperCase() + query[depth + 1].slice(1)
                                : query
                              ;
                              if ($.isPlainObject(object[camelCaseValue]) && (depth != maxDepth)) {
                                  object = object[camelCaseValue];
                              }
                              else if (object[camelCaseValue] !== undefined) {
                                  found = object[camelCaseValue];
                                  return false;
                              }
                              else if ($.isPlainObject(object[value]) && (depth != maxDepth)) {
                                  object = object[value];
                              }
                              else if (object[value] !== undefined) {
                                  found = object[value];
                                  return false;
                              }
                              else {
                                  module.error(error.method, query);
                                  return false;
                              }
                          });
                      }
                      if ($.isFunction(found)) {
                          response = found.apply(context, passedArguments);
                      }
                      else if (found !== undefined) {
                          response = found;
                      }
                      if ($.isArray(returnedValue)) {
                          returnedValue.push(response);
                      }
                      else if (returnedValue !== undefined) {
                          returnedValue = [returnedValue, response];
                      }
                      else if (response !== undefined) {
                          returnedValue = response;
                      }
                      return found;
                  }
              };

              if (methodInvoked) {
                  if (instance === undefined) {
                      module.initialize();
                  }
                  module.invoke(query);
              }
              else {
                  if (instance !== undefined) {
                      instance.invoke('destroy');
                  }
                  module.initialize();
              }
          })
        ;

        return (returnedValue !== undefined)
          ? returnedValue
          : this
        ;
    };

    $.fn.state.settings = {

        // module info
        name: 'State',

        // debug output
        debug: false,

        // verbose debug output
        verbose: true,

        // namespace for events
        namespace: 'state',

        // debug data includes performance
        performance: true,

        // callback occurs on state change
        onActivate: function () { },
        onDeactivate: function () { },
        onChange: function () { },

        // state test functions
        activateTest: function () { return true; },
        deactivateTest: function () { return true; },

        // whether to automatically map default states
        automatic: true,

        // activate / deactivate changes all elements instantiated at same time
        sync: false,

        // default flash text duration, used for temporarily changing text of an element
        flashDuration: 1000,

        // selector filter
        filter: {
            text: '.loading, .disabled',
            active: '.disabled'
        },

        context: false,

        // error
        error: {
            beforeSend: 'The before send function has cancelled state change',
            method: 'The method you called is not defined.'
        },

        // metadata
        metadata: {
            promise: 'promise',
            storedText: 'stored-text'
        },

        // change class on state
        className: {
            active: 'active',
            disabled: 'disabled',
            error: 'error',
            loading: 'loading',
            success: 'success',
            warning: 'warning'
        },

        selector: {
            // selector for text node
            text: false
        },

        defaults: {
            input: {
                disabled: true,
                loading: true,
                active: true
            },
            button: {
                disabled: true,
                loading: true,
                active: true,
            },
            progress: {
                active: true,
                success: true,
                warning: true,
                error: true
            }
        },

        states: {
            active: true,
            disabled: true,
            error: true,
            loading: true,
            success: true,
            warning: true
        },

        text: {
            disabled: false,
            flash: false,
            hover: false,
            active: false,
            inactive: false,
            activate: false,
            deactivate: false
        }

    };



})(jQuery, window, document);

/*!
 * # Semantic UI 1.12.1 - Visibility
 * http://github.com/semantic-org/semantic-ui/
 *
 *
 * Copyright 2014 Contributors
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 *
 */

; (function ($, window, document, undefined) {

    "use strict";

    $.fn.visibility = function (parameters) {
        var
          $allModules = $(this),
          moduleSelector = $allModules.selector || '',

          time = new Date().getTime(),
          performance = [],

          query = arguments[0],
          methodInvoked = (typeof query == 'string'),
          queryArguments = [].slice.call(arguments, 1),
          returnedValue
        ;

        $allModules
          .each(function () {
              var
                settings = ($.isPlainObject(parameters))
                  ? $.extend(true, {}, $.fn.visibility.settings, parameters)
                  : $.extend({}, $.fn.visibility.settings),

                className = settings.className,
                namespace = settings.namespace,
                error = settings.error,

                eventNamespace = '.' + namespace,
                moduleNamespace = 'module-' + namespace,

                $window = $(window),

                $module = $(this),
                $context = $(settings.context),
                selector = $module.selector || '',

                instance = $module.data(moduleNamespace),

                requestAnimationFrame = window.requestAnimationFrame
                  || window.mozRequestAnimationFrame
                  || window.webkitRequestAnimationFrame
                  || window.msRequestAnimationFrame
                  || function (callback) { setTimeout(callback, 0); },

                element = this,
                observer,
                module
              ;

              module = {

                  initialize: function () {
                      module.debug('Initializing', settings);

                      module.setup.cache();
                      module.save.position();

                      if (module.should.trackChanges()) {
                          module.bind.events();
                          if (settings.type == 'image') {
                              module.setup.image();
                          }
                          if (settings.type == 'fixed') {
                              module.setup.fixed();
                          }
                          if (settings.observeChanges) {
                              module.observeChanges();
                          }
                          if (!module.is.visible()) {
                              module.error(error.visible, $module);
                          }
                      }
                      if (settings.initialCheck) {
                          module.checkVisibility();
                      }
                      module.instantiate();
                  },

                  instantiate: function () {
                      module.debug('Storing instance', module);
                      $module
                        .data(moduleNamespace, module)
                      ;
                      instance = module;
                  },

                  destroy: function () {
                      module.verbose('Destroying previous module');
                      if (observer) {
                          observer.disconnect();
                      }
                      $window
                        .off('load' + eventNamespace, module.event.load)
                        .off('resize' + eventNamespace, module.event.resize)
                      ;
                      $context.off('scrollchange' + eventNamespace, module.event.scrollchange);
                      $module
                        .off(eventNamespace)
                        .removeData(moduleNamespace)
                      ;
                  },

                  observeChanges: function () {
                      var
                        context = $context[0]
                      ;
                      if ('MutationObserver' in window) {
                          observer = new MutationObserver(function (mutations) {
                              module.verbose('DOM tree modified, updating visibility calculations');
                              module.timer = setTimeout(function () {
                                  module.verbose('DOM tree modified, updating sticky menu');
                                  module.refresh();
                              }, 100);
                          });
                          observer.observe(element, {
                              childList: true,
                              subtree: true
                          });
                          module.debug('Setting up mutation observer', observer);
                      }
                  },

                  bind: {
                      events: function () {
                          module.verbose('Binding visibility events to scroll and resize');
                          $window
                            .on('load' + eventNamespace, module.event.load)
                            .on('resize' + eventNamespace, module.event.resize)
                          ;
                          // pub/sub pattern
                          $context
                            .off('scroll' + eventNamespace)
                            .on('scroll' + eventNamespace, module.event.scroll)
                            .on('scrollchange' + eventNamespace, module.event.scrollchange)
                          ;
                      },
                      imageLoad: function () {
                          var
                            $images = $module.find('img'),
                            imageCount = $images.length,
                            index = imageCount,
                            loadedCount = 0,
                            images = [],
                            cache = [],
                            cacheImage = document.createElement('img'),
                            handleLoad = function () {
                                loadedCount++;
                                if (loadedCount >= imageCount) {
                                    module.debug('Images finished loading inside element, refreshing position');
                                    module.refresh();
                                }
                            }
                          ;
                          if (imageCount > 0) {
                              $images
                                .each(function () {
                                    images.push($(this).attr('src'));
                                })
                              ;
                              while (index--) {
                                  cacheImage = document.createElement('img');
                                  cacheImage.onload = handleLoad;
                                  cacheImage.onerror = handleLoad;
                                  cacheImage.src = images[index];
                                  cache.push(cacheImage);
                              }
                          }
                      }
                  },

                  event: {
                      resize: function () {
                          module.debug('Window resized');
                          requestAnimationFrame(module.refresh);
                      },
                      load: function () {
                          module.debug('Page finished loading');
                          requestAnimationFrame(module.refresh);
                      },
                      // publishes scrollchange event on one scroll
                      scroll: function () {
                          if (settings.throttle) {
                              clearTimeout(module.timer);
                              module.timer = setTimeout(function () {
                                  $context.trigger('scrollchange' + eventNamespace, [$context.scrollTop()]);
                              }, settings.throttle);
                          }
                          else {
                              requestAnimationFrame(function () {
                                  $context.trigger('scrollchange' + eventNamespace, [$context.scrollTop()]);
                              });
                          }
                      },
                      // subscribes to scrollchange
                      scrollchange: function (event, scrollPosition) {
                          module.checkVisibility(scrollPosition);
                      },
                  },

                  precache: function (images, callback) {
                      if (!(images instanceof Array)) {
                          images = [images];
                      }
                      var
                        imagesLength = images.length,
                        loadedCounter = 0,
                        cache = [],
                        cacheImage = document.createElement('img'),
                        handleLoad = function () {
                            loadedCounter++;
                            if (loadedCounter >= images.length) {
                                if ($.isFunction(callback)) {
                                    callback();
                                }
                            }
                        }
                      ;
                      while (imagesLength--) {
                          cacheImage = document.createElement('img');
                          cacheImage.onload = handleLoad;
                          cacheImage.onerror = handleLoad;
                          cacheImage.src = images[imagesLength];
                          cache.push(cacheImage);
                      }
                  },

                  should: {
                      trackChanges: function () {
                          if (methodInvoked) {
                              module.debug('One time query, no need to bind events');
                              return false;
                          }
                          module.debug('Callbacks being attached');
                          return true;
                      }
                  },

                  setup: {
                      cache: function () {
                          module.cache = {
                              occurred: {},
                              screen: {},
                              element: {},
                          };
                      },
                      image: function () {
                          var
                            src = $module.data('src')
                          ;
                          if (src) {
                              module.verbose('Lazy loading image', src);
                              settings.observeChanges = false;
                              // show when top visible
                              module.topVisible(function () {
                                  module.debug('Image top visible', element);
                                  module.precache(src, function () {
                                      module.set.image(src);
                                      settings.onTopVisible = false;
                                  });
                              });
                          }
                      },
                      fixed: function () {
                          module.verbose('Setting up fixed on element pass');
                          settings.once = false;
                          settings.onTopPassed = function () {
                              $module
                                .addClass(className.fixed)
                                .css({
                                    top: settings.offset + 'px'
                                })
                              ;
                              if (settings.transition) {
                                  if ($.fn.transition !== undefined) {
                                      $module.transition(settings.transition, settings.duration);
                                  }
                              }
                          };
                          settings.onTopPassedReverse = function () {
                              $module
                                .removeClass(className.fixed)
                                .css({
                                    position: '',
                                    top: ''
                                })
                              ;
                          };
                      }
                  },

                  set: {
                      image: function (src) {
                          var
                            offScreen = (module.cache.screen.bottom < module.cache.element.top)
                          ;
                          $module
                            .attr('src', src)
                          ;
                          if (offScreen) {
                              module.verbose('Image outside browser, no show animation');
                              $module.show();
                          }
                          else {
                              if (settings.transition) {
                                  if ($.fn.transition !== undefined) {
                                      $module.transition(settings.transition, settings.duration);
                                  }
                                  else {
                                      $module.fadeIn(settings.duration);
                                  }
                              }
                              else {
                                  $module.show();
                              }
                          }
                      }
                  },

                  is: {
                      visible: function () {
                          if (module.cache && module.cache.element) {
                              return (module.cache.element.width > 0);
                          }
                          return false;
                      }
                  },

                  refresh: function () {
                      module.debug('Refreshing constants (width/height)');
                      module.reset();
                      module.save.position();
                      module.checkVisibility();
                      settings.onRefresh.call(element);
                  },

                  reset: function () {
                      module.verbose('Reseting all cached values');
                      if ($.isPlainObject(module.cache)) {
                          module.cache.screen = {};
                          module.cache.element = {};
                      }
                  },

                  checkVisibility: function (scroll) {
                      module.verbose('Checking visibility of element', module.cache.element);

                      if (module.is.visible()) {

                          // save scroll position
                          module.save.scroll(scroll);

                          // update calculations derived from scroll
                          module.save.calculations();

                          // percentage
                          module.passed();

                          // reverse (must be first)
                          module.passingReverse();
                          module.topVisibleReverse();
                          module.bottomVisibleReverse();
                          module.topPassedReverse();
                          module.bottomPassedReverse();

                          // one time
                          module.passing();
                          module.topVisible();
                          module.bottomVisible();
                          module.topPassed();
                          module.bottomPassed();

                          // on update callback
                          if (settings.onUpdate) {
                              settings.onUpdate.call(element, module.get.elementCalculations());
                          }
                      }
                  },

                  passed: function (amount, newCallback) {
                      var
                        calculations = module.get.elementCalculations(),
                        amountInPixels
                      ;
                      // assign callback
                      if (amount !== undefined && newCallback !== undefined) {
                          settings.onPassed[amount] = newCallback;
                      }
                      else if (amount !== undefined) {
                          return (module.get.pixelsPassed(amount) > calculations.pixelsPassed);
                      }
                      else if (calculations.passing) {
                          $.each(settings.onPassed, function (amount, callback) {
                              if (calculations.bottomVisible || calculations.pixelsPassed > module.get.pixelsPassed(amount)) {
                                  module.execute(callback, amount);
                              }
                              else if (!settings.once) {
                                  module.remove.occurred(callback);
                              }
                          });
                      }
                  },

                  passing: function (newCallback) {
                      var
                        calculations = module.get.elementCalculations(),
                        callback = newCallback || settings.onPassing,
                        callbackName = 'passing'
                      ;
                      if (newCallback) {
                          module.debug('Adding callback for passing', newCallback);
                          settings.onPassing = newCallback;
                      }
                      if (calculations.passing) {
                          module.execute(callback, callbackName);
                      }
                      else if (!settings.once) {
                          module.remove.occurred(callbackName);
                      }
                      if (newCallback !== undefined) {
                          return calculations.passing;
                      }
                  },


                  topVisible: function (newCallback) {
                      var
                        calculations = module.get.elementCalculations(),
                        callback = newCallback || settings.onTopVisible,
                        callbackName = 'topVisible'
                      ;
                      if (newCallback) {
                          module.debug('Adding callback for top visible', newCallback);
                          settings.onTopVisible = newCallback;
                      }
                      if (calculations.topVisible) {
                          module.execute(callback, callbackName);
                      }
                      else if (!settings.once) {
                          module.remove.occurred(callbackName);
                      }
                      if (newCallback === undefined) {
                          return calculations.topVisible;
                      }
                  },

                  bottomVisible: function (newCallback) {
                      var
                        calculations = module.get.elementCalculations(),
                        callback = newCallback || settings.onBottomVisible,
                        callbackName = 'bottomVisible'
                      ;
                      if (newCallback) {
                          module.debug('Adding callback for bottom visible', newCallback);
                          settings.onBottomVisible = newCallback;
                      }
                      if (calculations.bottomVisible) {
                          module.execute(callback, callbackName);
                      }
                      else if (!settings.once) {
                          module.remove.occurred(callbackName);
                      }
                      if (newCallback === undefined) {
                          return calculations.bottomVisible;
                      }
                  },

                  topPassed: function (newCallback) {
                      var
                        calculations = module.get.elementCalculations(),
                        callback = newCallback || settings.onTopPassed,
                        callbackName = 'topPassed'
                      ;
                      if (newCallback) {
                          module.debug('Adding callback for top passed', newCallback);
                          settings.onTopPassed = newCallback;
                      }
                      if (calculations.topPassed) {
                          module.execute(callback, callbackName);
                      }
                      else if (!settings.once) {
                          module.remove.occurred(callbackName);
                      }
                      if (newCallback === undefined) {
                          return calculations.topPassed;
                      }
                  },

                  bottomPassed: function (newCallback) {
                      var
                        calculations = module.get.elementCalculations(),
                        callback = newCallback || settings.onBottomPassed,
                        callbackName = 'bottomPassed'
                      ;
                      if (newCallback) {
                          module.debug('Adding callback for bottom passed', newCallback);
                          settings.onBottomPassed = newCallback;
                      }
                      if (calculations.bottomPassed) {
                          module.execute(callback, callbackName);
                      }
                      else if (!settings.once) {
                          module.remove.occurred(callbackName);
                      }
                      if (newCallback === undefined) {
                          return calculations.bottomPassed;
                      }
                  },

                  passingReverse: function (newCallback) {
                      var
                        calculations = module.get.elementCalculations(),
                        callback = newCallback || settings.onPassingReverse,
                        callbackName = 'passingReverse'
                      ;
                      if (newCallback) {
                          module.debug('Adding callback for passing reverse', newCallback);
                          settings.onPassingReverse = newCallback;
                      }
                      if (!calculations.passing) {
                          if (module.get.occurred('passing')) {
                              module.execute(callback, callbackName);
                          }
                      }
                      else if (!settings.once) {
                          module.remove.occurred(callbackName);
                      }
                      if (newCallback !== undefined) {
                          return !calculations.passing;
                      }
                  },


                  topVisibleReverse: function (newCallback) {
                      var
                        calculations = module.get.elementCalculations(),
                        callback = newCallback || settings.onTopVisibleReverse,
                        callbackName = 'topVisibleReverse'
                      ;
                      if (newCallback) {
                          module.debug('Adding callback for top visible reverse', newCallback);
                          settings.onTopVisibleReverse = newCallback;
                      }
                      if (!calculations.topVisible) {
                          if (module.get.occurred('topVisible')) {
                              module.execute(callback, callbackName);
                          }
                      }
                      else if (!settings.once) {
                          module.remove.occurred(callbackName);
                      }
                      if (newCallback === undefined) {
                          return !calculations.topVisible;
                      }
                  },

                  bottomVisibleReverse: function (newCallback) {
                      var
                        calculations = module.get.elementCalculations(),
                        callback = newCallback || settings.onBottomVisibleReverse,
                        callbackName = 'bottomVisibleReverse'
                      ;
                      if (newCallback) {
                          module.debug('Adding callback for bottom visible reverse', newCallback);
                          settings.onBottomVisibleReverse = newCallback;
                      }
                      if (!calculations.bottomVisible) {
                          if (module.get.occurred('bottomVisible')) {
                              module.execute(callback, callbackName);
                          }
                      }
                      else if (!settings.once) {
                          module.remove.occurred(callbackName);
                      }
                      if (newCallback === undefined) {
                          return !calculations.bottomVisible;
                      }
                  },

                  topPassedReverse: function (newCallback) {
                      var
                        calculations = module.get.elementCalculations(),
                        callback = newCallback || settings.onTopPassedReverse,
                        callbackName = 'topPassedReverse'
                      ;
                      if (newCallback) {
                          module.debug('Adding callback for top passed reverse', newCallback);
                          settings.onTopPassedReverse = newCallback;
                      }
                      if (!calculations.topPassed) {
                          if (module.get.occurred('topPassed')) {
                              module.execute(callback, callbackName);
                          }
                      }
                      else if (!settings.once) {
                          module.remove.occurred(callbackName);
                      }
                      if (newCallback === undefined) {
                          return !calculations.onTopPassed;
                      }
                  },

                  bottomPassedReverse: function (newCallback) {
                      var
                        calculations = module.get.elementCalculations(),
                        callback = newCallback || settings.onBottomPassedReverse,
                        callbackName = 'bottomPassedReverse'
                      ;
                      if (newCallback) {
                          module.debug('Adding callback for bottom passed reverse', newCallback);
                          settings.onBottomPassedReverse = newCallback;
                      }
                      if (!calculations.bottomPassed) {
                          if (module.get.occurred('bottomPassed')) {
                              module.execute(callback, callbackName);
                          }
                      }
                      else if (!settings.once) {
                          module.remove.occurred(callbackName);
                      }
                      if (newCallback === undefined) {
                          return !calculations.bottomPassed;
                      }
                  },

                  execute: function (callback, callbackName) {
                      var
                        calculations = module.get.elementCalculations(),
                        screen = module.get.screenCalculations()
                      ;
                      callback = callback || false;
                      if (callback) {
                          if (settings.continuous) {
                              module.debug('Callback being called continuously', callbackName, calculations);
                              callback.call(element, calculations, screen);
                          }
                          else if (!module.get.occurred(callbackName)) {
                              module.debug('Conditions met', callbackName, calculations);
                              callback.call(element, calculations, screen);
                          }
                      }
                      module.save.occurred(callbackName);
                  },

                  remove: {
                      occurred: function (callback) {
                          if (callback) {
                              if (module.cache.occurred[callback] !== undefined && module.cache.occurred[callback] === true) {
                                  module.debug('Callback can now be called again', callback);
                                  module.cache.occurred[callback] = false;
                              }
                          }
                          else {
                              module.cache.occurred = {};
                          }
                      }
                  },

                  save: {
                      calculations: function () {
                          module.verbose('Saving all calculations necessary to determine positioning');
                          module.save.direction();
                          module.save.screenCalculations();
                          module.save.elementCalculations();
                      },
                      occurred: function (callback) {
                          if (callback) {
                              if (module.cache.occurred[callback] === undefined || (module.cache.occurred[callback] !== true)) {
                                  module.verbose('Saving callback occurred', callback);
                                  module.cache.occurred[callback] = true;
                              }
                          }
                      },
                      scroll: function (scrollPosition) {
                          scrollPosition = scrollPosition + settings.offset || $context.scrollTop() + settings.offset;
                          module.cache.scroll = scrollPosition;
                      },
                      direction: function () {
                          var
                            scroll = module.get.scroll(),
                            lastScroll = module.get.lastScroll(),
                            direction
                          ;
                          if (scroll > lastScroll && lastScroll) {
                              direction = 'down';
                          }
                          else if (scroll < lastScroll && lastScroll) {
                              direction = 'up';
                          }
                          else {
                              direction = 'static';
                          }
                          module.cache.direction = direction;
                          return module.cache.direction;
                      },
                      elementPosition: function () {
                          var
                            element = module.cache.element,
                            screen = module.get.screenSize()
                          ;
                          module.verbose('Saving element position');
                          // (quicker than $.extend)
                          element.fits = (element.height < screen.height);
                          element.offset = $module.offset();
                          element.width = $module.outerWidth();
                          element.height = $module.outerHeight();
                          // store
                          module.cache.element = element;
                          return element;
                      },
                      elementCalculations: function () {
                          var
                            screen = module.get.screenCalculations(),
                            element = module.get.elementPosition()
                          ;
                          // offset
                          if (settings.includeMargin) {
                              element.margin = {};
                              element.margin.top = parseInt($module.css('margin-top'), 10);
                              element.margin.bottom = parseInt($module.css('margin-bottom'), 10);
                              element.top = element.offset.top - element.margin.top;
                              element.bottom = element.offset.top + element.height + element.margin.bottom;
                          }
                          else {
                              element.top = element.offset.top;
                              element.bottom = element.offset.top + element.height;
                          }

                          // visibility
                          element.topVisible = (screen.bottom >= element.top);
                          element.topPassed = (screen.top >= element.top);
                          element.bottomVisible = (screen.bottom >= element.bottom);
                          element.bottomPassed = (screen.top >= element.bottom);
                          element.pixelsPassed = 0;
                          element.percentagePassed = 0;

                          // meta calculations
                          element.visible = (element.topVisible || element.bottomVisible);
                          element.passing = (element.topPassed && !element.bottomPassed);
                          element.hidden = (!element.topVisible && !element.bottomVisible);

                          // passing calculations
                          if (element.passing) {
                              element.pixelsPassed = (screen.top - element.top);
                              element.percentagePassed = (screen.top - element.top) / element.height;
                          }
                          module.cache.element = element;
                          module.verbose('Updated element calculations', element);
                          return element;
                      },
                      screenCalculations: function () {
                          var
                            scroll = module.get.scroll()
                          ;
                          module.save.direction();
                          module.cache.screen.top = scroll;
                          module.cache.screen.bottom = scroll + module.cache.screen.height;
                          return module.cache.screen;
                      },
                      screenSize: function () {
                          module.verbose('Saving window position');
                          module.cache.screen = {
                              height: $context.height()
                          };
                      },
                      position: function () {
                          module.save.screenSize();
                          module.save.elementPosition();
                      }
                  },

                  get: {
                      pixelsPassed: function (amount) {
                          var
                            element = module.get.elementCalculations()
                          ;
                          if (amount.search('%') > -1) {
                              return (element.height * (parseInt(amount, 10) / 100));
                          }
                          return parseInt(amount, 10);
                      },
                      occurred: function (callback) {
                          return (module.cache.occurred !== undefined)
                            ? module.cache.occurred[callback] || false
                            : false
                          ;
                      },
                      direction: function () {
                          if (module.cache.direction === undefined) {
                              module.save.direction();
                          }
                          return module.cache.direction;
                      },
                      elementPosition: function () {
                          if (module.cache.element === undefined) {
                              module.save.elementPosition();
                          }
                          return module.cache.element;
                      },
                      elementCalculations: function () {
                          if (module.cache.element === undefined) {
                              module.save.elementCalculations();
                          }
                          return module.cache.element;
                      },
                      screenCalculations: function () {
                          if (module.cache.screen === undefined) {
                              module.save.screenCalculations();
                          }
                          return module.cache.screen;
                      },
                      screenSize: function () {
                          if (module.cache.screen === undefined) {
                              module.save.screenSize();
                          }
                          return module.cache.screen;
                      },
                      scroll: function () {
                          if (module.cache.scroll === undefined) {
                              module.save.scroll();
                          }
                          return module.cache.scroll;
                      },
                      lastScroll: function () {
                          if (module.cache.screen === undefined) {
                              module.debug('First scroll event, no last scroll could be found');
                              return false;
                          }
                          return module.cache.screen.top;
                      }
                  },

                  setting: function (name, value) {
                      if ($.isPlainObject(name)) {
                          $.extend(true, settings, name);
                      }
                      else if (value !== undefined) {
                          settings[name] = value;
                      }
                      else {
                          return settings[name];
                      }
                  },
                  internal: function (name, value) {
                      if ($.isPlainObject(name)) {
                          $.extend(true, module, name);
                      }
                      else if (value !== undefined) {
                          module[name] = value;
                      }
                      else {
                          return module[name];
                      }
                  },
                  debug: function () {
                      if (settings.debug) {
                          if (settings.performance) {
                              module.performance.log(arguments);
                          }
                          else {
                              module.debug = Function.prototype.bind.call(console.info, console, settings.name + ':');
                              module.debug.apply(console, arguments);
                          }
                      }
                  },
                  verbose: function () {
                      if (settings.verbose && settings.debug) {
                          if (settings.performance) {
                              module.performance.log(arguments);
                          }
                          else {
                              module.verbose = Function.prototype.bind.call(console.info, console, settings.name + ':');
                              module.verbose.apply(console, arguments);
                          }
                      }
                  },
                  error: function () {
                      module.error = Function.prototype.bind.call(console.error, console, settings.name + ':');
                      module.error.apply(console, arguments);
                  },
                  performance: {
                      log: function (message) {
                          var
                            currentTime,
                            executionTime,
                            previousTime
                          ;
                          if (settings.performance) {
                              currentTime = new Date().getTime();
                              previousTime = time || currentTime;
                              executionTime = currentTime - previousTime;
                              time = currentTime;
                              performance.push({
                                  'Name': message[0],
                                  'Arguments': [].slice.call(message, 1) || '',
                                  'Element': element,
                                  'Execution Time': executionTime
                              });
                          }
                          clearTimeout(module.performance.timer);
                          module.performance.timer = setTimeout(module.performance.display, 500);
                      },
                      display: function () {
                          var
                            title = settings.name + ':',
                            totalTime = 0
                          ;
                          time = false;
                          clearTimeout(module.performance.timer);
                          $.each(performance, function (index, data) {
                              totalTime += data['Execution Time'];
                          });
                          title += ' ' + totalTime + 'ms';
                          if (moduleSelector) {
                              title += ' \'' + moduleSelector + '\'';
                          }
                          if ((console.group !== undefined || console.table !== undefined) && performance.length > 0) {
                              console.groupCollapsed(title);
                              if (console.table) {
                                  console.table(performance);
                              }
                              else {
                                  $.each(performance, function (index, data) {
                                      console.log(data['Name'] + ': ' + data['Execution Time'] + 'ms');
                                  });
                              }
                              console.groupEnd();
                          }
                          performance = [];
                      }
                  },
                  invoke: function (query, passedArguments, context) {
                      var
                        object = instance,
                        maxDepth,
                        found,
                        response
                      ;
                      passedArguments = passedArguments || queryArguments;
                      context = element || context;
                      if (typeof query == 'string' && object !== undefined) {
                          query = query.split(/[\. ]/);
                          maxDepth = query.length - 1;
                          $.each(query, function (depth, value) {
                              var camelCaseValue = (depth != maxDepth)
                                ? value + query[depth + 1].charAt(0).toUpperCase() + query[depth + 1].slice(1)
                                : query
                              ;
                              if ($.isPlainObject(object[camelCaseValue]) && (depth != maxDepth)) {
                                  object = object[camelCaseValue];
                              }
                              else if (object[camelCaseValue] !== undefined) {
                                  found = object[camelCaseValue];
                                  return false;
                              }
                              else if ($.isPlainObject(object[value]) && (depth != maxDepth)) {
                                  object = object[value];
                              }
                              else if (object[value] !== undefined) {
                                  found = object[value];
                                  return false;
                              }
                              else {
                                  module.error(error.method, query);
                                  return false;
                              }
                          });
                      }
                      if ($.isFunction(found)) {
                          response = found.apply(context, passedArguments);
                      }
                      else if (found !== undefined) {
                          response = found;
                      }
                      if ($.isArray(returnedValue)) {
                          returnedValue.push(response);
                      }
                      else if (returnedValue !== undefined) {
                          returnedValue = [returnedValue, response];
                      }
                      else if (response !== undefined) {
                          returnedValue = response;
                      }
                      return found;
                  }
              };

              if (methodInvoked) {
                  if (instance === undefined) {
                      module.initialize();
                  }
                  module.invoke(query);
              }
              else {
                  if (instance !== undefined) {
                      instance.invoke('destroy');
                  }
                  module.initialize();
              }
          })
        ;

        return (returnedValue !== undefined)
          ? returnedValue
          : this
        ;
    };

    $.fn.visibility.settings = {

        name: 'Visibility',
        namespace: 'visibility',

        debug: false,
        verbose: false,
        performance: true,

        // whether to use mutation observers to follow changes
        observeChanges: true,

        // whether to refresh calculations after all page images load
        refreshOnLoad: true,

        // callback should only occur one time
        once: true,

        // callback should fire continuously whe evaluates to true
        continuous: false,

        // offset to use with scroll top
        offset: 0,

        // whether to include margin in elements position
        includeMargin: false,

        // scroll context for visibility checks
        context: window,

        // check position immediately on init
        initialCheck: true,

        // visibility check delay in ms (defaults to animationFrame)
        throttle: false,

        // special visibility type (image, fixed)
        type: false,

        // image only animation settings
        transition: false,
        duration: 1000,

        // array of callbacks for percentage
        onPassed: {},

        // standard callbacks
        onPassing: false,
        onTopVisible: false,
        onBottomVisible: false,
        onTopPassed: false,
        onBottomPassed: false,

        // reverse callbacks
        onPassingReverse: false,
        onTopVisibleReverse: false,
        onBottomVisibleReverse: false,
        onTopPassedReverse: false,
        onBottomPassedReverse: false,

        // utility callbacks
        onUpdate: false, // disabled by default for performance
        onRefresh: function () { },

        className: {
            fixed: 'fixed'
        },

        error: {
            method: 'The method you called is not defined.',
            visible: 'Element is hidden, you must call refresh after element becomes visible'
        }

    };

})(jQuery, window, document);
/**
 * sidebarEffects.js v1.0.0
 * http://www.codrops.com
 *
 * Licensed under the MIT license.
 * http://www.opensource.org/licenses/mit-license.php
 * 
 * Copyright 2013, Codrops
 * http://www.codrops.com
 */
(function () {

    window.SidebarMenuEffects = function () {

        function hasParentClass(e, classname) {
            if (e === document) return false;
            if (classie.has(e, classname)) {
                return true;
            }
            return e.parentNode && hasParentClass(e.parentNode, classname);
        }

        // http://coveroverflow.com/a/11381730/989439
        function mobilecheck() {
            var check = false;
            (function (a) { if (/(android|ipad|playbook|silk|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true })(navigator.userAgent || navigator.vendor || window.opera);
            return check;
        }

        function init() {
            var container = document.getElementById('st-container'),
                body = document.getElementById('body'),
                // event type (if mobile use touch events)
                eventtype = mobilecheck() ? 'touchstart' : 'click',
                resetMenu = function () {
                    classie.remove(container, 'st-menu-open');
                    classie.remove(body, 'overflow-hidden');
                },
                bodyClickFn = function (evt) {
                    if (!hasParentClass(evt.target, 'st-menu')) {
                        resetMenu();
                        document.removeEventListener(eventtype, bodyClickFn);
                    }
                },
                openPanel = function (evt) {
                    evt.stopPropagation();
                    evt.preventDefault();
                    var effect = $(this).data('effect');
                    container.className = 'st-container'; // clear
                    classie.add(container, effect);
                    setTimeout(function () {
                        classie.add(container, 'st-menu-open');
                        classie.add(body, 'overflow-hidden');
                    }, 25);
                    document.addEventListener(eventtype, bodyClickFn);
                };

            $('.js-st-trigger-effects').each(function (i, ele) {
                var $ele = $(ele);
                $ele.off(eventtype, openPanel).on(eventtype, openPanel);
            });

            $('.st-menu-content').off('click', '#st-apply, #st-cancel', resetMenu).on('click', '#st-apply, #st-cancel', resetMenu);

        }

        init();

    };

    SidebarMenuEffects();

}());
/* =========================================================
 * bootstrap-slider.js v2.0.0
 * http://www.eyecon.ro/bootstrap-slider
 * =========================================================
 * Copyright 2012 Stefan Petre
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * ========================================================= */
 
!function( $ ) {

	var Slider = function(element, options) {
		this.element = $(element);
		this.picker = $('<div class="slider">'+
							'<div class="slider-track">'+
								'<div class="slider-selection"></div>'+
								'<div class="slider-handle"></div>'+
								'<div class="slider-handle"></div>'+
							'</div>'+
							'<div class="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>'+
						'</div>')
							.insertBefore(this.element)
							.append(this.element);
		this.id = this.element.data('slider-id')||options.id;
		if (this.id) {
			this.picker[0].id = this.id;
		}

		if (typeof Modernizr !== 'undefined' && Modernizr.touch) {
			this.touchCapable = true;
		}

		var tooltip = this.element.data('slider-tooltip')||options.tooltip;

		this.tooltip = this.picker.find('.tooltip');
		this.tooltipInner = this.tooltip.find('div.tooltip-inner');

		this.orientation = this.element.data('slider-orientation')||options.orientation;
		switch(this.orientation) {
			case 'vertical':
				this.picker.addClass('slider-vertical');
				this.stylePos = 'top';
				this.mousePos = 'pageY';
				this.sizePos = 'offsetHeight';
				this.tooltip.addClass('right')[0].style.left = '100%';
				break;
			default:
				this.picker
					.addClass('slider-horizontal')
					.css('width', this.element.outerWidth());
				this.orientation = 'horizontal';
				this.stylePos = 'left';
				this.mousePos = 'pageX';
				this.sizePos = 'offsetWidth';
				this.tooltip.addClass('top')[0].style.top = -this.tooltip.outerHeight() - 14 + 'px';
				break;
		}

		this.min = this.element.data('slider-min')||options.min;
		this.max = this.element.data('slider-max')||options.max;
		this.step = this.element.data('slider-step')||options.step;
		this.value = this.element.data('slider-value')||options.value;
		if (this.value[1]) {
			this.range = true;
		}

		this.selection = this.element.data('slider-selection')||options.selection;
		this.selectionEl = this.picker.find('.slider-selection');
		if (this.selection === 'none') {
			this.selectionEl.addClass('hide');
		}
		this.selectionElStyle = this.selectionEl[0].style;


		this.handle1 = this.picker.find('.slider-handle:first');
		this.handle1Stype = this.handle1[0].style;
		this.handle2 = this.picker.find('.slider-handle:last');
		this.handle2Stype = this.handle2[0].style;

		var handle = this.element.data('slider-handle')||options.handle;
		switch(handle) {
			case 'round':
				this.handle1.addClass('round');
				this.handle2.addClass('round');
				break
			case 'triangle':
				this.handle1.addClass('triangle');
				this.handle2.addClass('triangle');
				break
		}

		if (this.range) {
			this.value[0] = Math.max(this.min, Math.min(this.max, this.value[0]));
			this.value[1] = Math.max(this.min, Math.min(this.max, this.value[1]));
		} else {
			this.value = [ Math.max(this.min, Math.min(this.max, this.value))];
			this.handle2.addClass('hide');
			if (this.selection == 'after') {
				this.value[1] = this.max;
			} else {
				this.value[1] = this.min;
			}
		}
		this.diff = this.max - this.min;
		this.percentage = [
			(this.value[0]-this.min)*100/this.diff,
			(this.value[1]-this.min)*100/this.diff,
			this.step*100/this.diff
		];

		this.offset = this.picker.offset();
		this.size = this.picker[0][this.sizePos];

		this.formater = options.formater;

		this.layout();

		if (this.touchCapable) {
			// Touch: Bind touch events:
			this.picker.on({
				touchstart: $.proxy(this.mousedown, this)
			});
		} else {
			this.picker.on({
				mousedown: $.proxy(this.mousedown, this)
			});
		}

		if (tooltip === 'show') {
			this.picker.on({
				mouseenter: $.proxy(this.showTooltip, this),
				mouseleave: $.proxy(this.hideTooltip, this)
			});
		} else {
			this.tooltip.addClass('hide');
		}
	};

	Slider.prototype = {
		constructor: Slider,

		over: false,
		inDrag: false,
		
		showTooltip: function(){
			this.tooltip.addClass('in');
			//var left = Math.round(this.percent*this.width);
			//this.tooltip.css('left', left - this.tooltip.outerWidth()/2);
			this.over = true;
		},
		
		hideTooltip: function(){
			if (this.inDrag === false) {
				this.tooltip.removeClass('in');
			}
			this.over = false;
		},

		layout: function(){
			this.handle1Stype[this.stylePos] = this.percentage[0]+'%';
			this.handle2Stype[this.stylePos] = this.percentage[1]+'%';
			if (this.orientation == 'vertical') {
				this.selectionElStyle.top = Math.min(this.percentage[0], this.percentage[1]) +'%';
				this.selectionElStyle.height = Math.abs(this.percentage[0] - this.percentage[1]) +'%';
			} else {
				this.selectionElStyle.left = Math.min(this.percentage[0], this.percentage[1]) +'%';
				this.selectionElStyle.width = Math.abs(this.percentage[0] - this.percentage[1]) +'%';
			}
			if (this.range) {
				this.tooltipInner.text(
					this.formater(this.value[0]) + 
					' : ' + 
					this.formater(this.value[1])
				);
				this.tooltip[0].style[this.stylePos] = this.size * (this.percentage[0] + (this.percentage[1] - this.percentage[0])/2)/100 - (this.orientation === 'vertical' ? this.tooltip.outerHeight()/2 : this.tooltip.outerWidth()/2) +'px';
			} else {
				this.tooltipInner.text(
					this.formater(this.value[0])
				);
				this.tooltip[0].style[this.stylePos] = this.size * this.percentage[0]/100 - (this.orientation === 'vertical' ? this.tooltip.outerHeight()/2 : this.tooltip.outerWidth()/2) +'px';
			}
		},

		mousedown: function(ev) {

			// Touch: Get the original event:
			if (this.touchCapable && ev.type === 'touchstart') {
				ev = ev.originalEvent;
			}

			this.offset = this.picker.offset();
			this.size = this.picker[0][this.sizePos];

			var percentage = this.getPercentage(ev);

			if (this.range) {
				var diff1 = Math.abs(this.percentage[0] - percentage);
				var diff2 = Math.abs(this.percentage[1] - percentage);
				this.dragged = (diff1 < diff2) ? 0 : 1;
			} else {
				this.dragged = 0;
			}

			this.percentage[this.dragged] = percentage;
			this.layout();

			if (this.touchCapable) {
				// Touch: Bind touch events:
				$(document).on({
					touchmove: $.proxy(this.mousemove, this),
					touchend: $.proxy(this.mouseup, this)
				});
			} else {
				$(document).on({
					mousemove: $.proxy(this.mousemove, this),
					mouseup: $.proxy(this.mouseup, this)
				});
			}

			this.inDrag = true;
			var val = this.calculateValue();
			this.element.trigger({
					type: 'slideStart',
					value: val
				}).trigger({
					type: 'slide',
					value: val
				});
			return false;
		},

		mousemove: function(ev) {
			
			// Touch: Get the original event:
			if (this.touchCapable && ev.type === 'touchmove') {
				ev = ev.originalEvent;
			}

			var percentage = this.getPercentage(ev);
			if (this.range) {
				if (this.dragged === 0 && this.percentage[1] < percentage) {
					this.percentage[0] = this.percentage[1];
					this.dragged = 1;
				} else if (this.dragged === 1 && this.percentage[0] > percentage) {
					this.percentage[1] = this.percentage[0];
					this.dragged = 0;
				}
			}
			this.percentage[this.dragged] = percentage;
			this.layout();
			var val = this.calculateValue();
			this.element
				.trigger({
					type: 'slide',
					value: val
				})
				.data('value', val)
				.prop('value', val);
			return false;
		},

		mouseup: function(ev) {
			if (this.touchCapable) {
				// Touch: Bind touch events:
				$(document).off({
					touchmove: this.mousemove,
					touchend: this.mouseup
				});
			} else {
				$(document).off({
					mousemove: this.mousemove,
					mouseup: this.mouseup
				});
			}

			this.inDrag = false;
			if (this.over == false) {
				this.hideTooltip();
			}
			this.element;
			var val = this.calculateValue();
			this.element
				.trigger({
					type: 'slideStop',
					value: val
				})
				.data('value', val)
				.prop('value', val);
			return false;
		},

		calculateValue: function() {
			var val;
			if (this.range) {
				val = [
					(this.min + Math.round((this.diff * this.percentage[0]/100)/this.step)*this.step),
					(this.min + Math.round((this.diff * this.percentage[1]/100)/this.step)*this.step)
				];
				this.value = val;
			} else {
				val = (this.min + Math.round((this.diff * this.percentage[0]/100)/this.step)*this.step);
				this.value = [val, this.value[1]];
			}
			return val;
		},

		getPercentage: function(ev) {
			if (this.touchCapable) {
				ev = ev.touches[0];
			}
			var percentage = (ev[this.mousePos] - this.offset[this.stylePos])*100/this.size;
			percentage = Math.round(percentage/this.percentage[2])*this.percentage[2];
			return Math.max(0, Math.min(100, percentage));
		},

		getValue: function() {
			if (this.range) {
				return this.value;
			}
			return this.value[0];
		},

		setValue: function(val) {
			this.value = val;

			if (this.range) {
				this.value[0] = Math.max(this.min, Math.min(this.max, this.value[0]));
				this.value[1] = Math.max(this.min, Math.min(this.max, this.value[1]));
			} else {
				this.value = [ Math.max(this.min, Math.min(this.max, this.value))];
				this.handle2.addClass('hide');
				if (this.selection == 'after') {
					this.value[1] = this.max;
				} else {
					this.value[1] = this.min;
				}
			}
			this.diff = this.max - this.min;
			this.percentage = [
				(this.value[0]-this.min)*100/this.diff,
				(this.value[1]-this.min)*100/this.diff,
				this.step*100/this.diff
			];
			this.layout();
		}
	};

	$.fn.slider = function ( option, val ) {
		return this.each(function () {
			var $this = $(this),
				data = $this.data('slider'),
				options = typeof option === 'object' && option;
			if (!data)  {
				$this.data('slider', (data = new Slider(this, $.extend({}, $.fn.slider.defaults,options))));
			}
			if (typeof option == 'string') {
				data[option](val);
			}
		})
	};

	$.fn.slider.defaults = {
		min: 0,
		max: 10,
		step: 1,
		orientation: 'horizontal',
		value: 5,
		selection: 'before',
		tooltip: 'show',
		handle: 'round',
		formater: function(value) {
			return value;
		}
	};

	$.fn.slider.Constructor = Slider;

}( window.jQuery );
/*!
 * # Semantic UI 1.12.1 - Dropdown
 * http://github.com/semantic-org/semantic-ui/
 *
 *
 * Copyright 2014 Contributors
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 *
 */

; (function ($, window, document, undefined) {

    "use strict";

    $.fn.dropdown = function (parameters) {
        var
          $allModules = $(this),
          $document = $(document),

          moduleSelector = $allModules.selector || '',

          hasTouch = ('ontouchstart' in document.documentElement),
          time = new Date().getTime(),
          performance = [],

          query = arguments[0],
          methodInvoked = (typeof query == 'string'),
          queryArguments = [].slice.call(arguments, 1),
          returnedValue
        ;

        $allModules
          .each(function () {
              var
                settings = ($.isPlainObject(parameters))
                  ? $.extend(true, {}, $.fn.dropdown.settings, parameters)
                  : $.extend({}, $.fn.dropdown.settings),

                className = settings.className,
                metadata = settings.metadata,
                namespace = settings.namespace,
                selector = settings.selector,
                error = settings.error,

                eventNamespace = '.' + namespace,
                moduleNamespace = 'module-' + namespace,

                $module = $(this),
                $text = $module.find(selector.text),
                $search = $module.find(selector.search),
                $input = $module.find(selector.input),

                $combo = ($module.prev().find(selector.text).length > 0)
                  ? $module.prev().find(selector.text)
                  : $module.prev(),

                $menu = $module.children(selector.menu),
                $item = $menu.find(selector.item),

                activated = false,
                itemActivated = false,
                element = this,
                instance = $module.data(moduleNamespace),

                elementNamespace,
                id,
                observer,
                module
              ;

              module = {

                  initialize: function () {
                      module.debug('Initializing dropdown', settings);

                      if (module.is.alreadySetup()) {
                          module.setup.reference();
                      }
                      else {
                          module.setup.layout();

                          module.save.defaults();
                          module.set.selected();

                          module.create.id();

                          if (hasTouch) {
                              module.bind.touchEvents();
                          }
                          module.bind.mouseEvents();
                          module.bind.keyboardEvents();

                          module.observeChanges();
                          module.instantiate();
                      }
                  },

                  instantiate: function () {
                      module.verbose('Storing instance of dropdown', module);
                      instance = module;
                      $module
                        .data(moduleNamespace, module)
                      ;
                  },

                  destroy: function () {
                      module.verbose('Destroying previous dropdown for', $module);
                      module.remove.tabbable();
                      $module
                        .off(eventNamespace)
                        .removeData(moduleNamespace)
                      ;
                      $menu
                        .off(eventNamespace)
                      ;
                      $document
                        .off(elementNamespace)
                      ;
                  },

                  observeChanges: function () {
                      if ('MutationObserver' in window) {
                          observer = new MutationObserver(function (mutations) {
                              if (module.is.selectMutation(mutations)) {
                                  module.debug('<select> modified, recreating menu');
                                  module.setup.select();
                              }
                              else {
                                  module.debug('DOM tree modified, updating selector cache');
                                  module.refresh();
                              }
                          });
                          observer.observe(element, {
                              childList: true,
                              subtree: true
                          });
                          module.debug('Setting up mutation observer', observer);
                      }
                  },

                  create: {
                      id: function () {
                          id = (Math.random().toString(16) + '000000000').substr(2, 8);
                          elementNamespace = '.' + id;
                          module.verbose('Creating unique id for element', id);
                      }
                  },

                  search: function () {
                      var
                        query
                      ;
                      query = $search.val();

                      module.verbose('Searching for query', query);
                      module.filter(query);
                      if (module.is.searchSelection() && module.can.show()) {
                          module.show();
                      }
                  },

                  setup: {
                      layout: function () {
                          if ($module.is('select')) {
                              module.setup.select();
                          }
                          if (module.is.search() && !module.is.searchable()) {
                              $search = $('<input />')
                                .addClass(className.search)
                                .insertBefore($text)
                              ;
                          }
                          if (settings.allowTab) {
                              module.set.tabbable();
                          }
                      },
                      select: function () {
                          var
                            selectValues = module.get.selectValues()
                          ;
                          module.debug('Dropdown initialized on a select', selectValues);
                          if ($module.is('select')) {
                              $input = $module;
                          }
                          // see if select is placed correctly already
                          if ($input.parent(selector.dropdown).length > 0) {
                              module.debug('UI dropdown already exists. Creating dropdown menu only');
                              $module = $input.closest(selector.dropdown);
                              $menu = $module.children(selector.menu);
                              if ($menu.length === 0) {
                                  $menu = $('<div />')
                                    .addClass(className.menu)
                                    .appendTo($module)
                                  ;
                              }
                              $menu.html(settings.templates.menu(selectValues));
                          }
                          else {
                              module.debug('Creating entire dropdown from select');
                              $module = $('<div />')
                                .attr('class', $input.attr('class'))
                                .addClass(className.selection)
                                .addClass(className.dropdown)
                                .html(settings.templates.dropdown(selectValues))
                                .insertBefore($input)
                              ;
                              $input
                                .removeAttr('class')
                                .prependTo($module)
                              ;
                          }
                          module.refresh();
                      },
                      reference: function () {
                          var
                            index = $allModules.index($module),
                            $firstModules,
                            $lastModules
                          ;
                          module.debug('Dropdown behavior was called on select, replacing with closest dropdown');
                          // replace module reference
                          $module = $module.parent(selector.dropdown);
                          module.refresh();
                          // adjust all modules
                          $firstModules = $allModules.slice(0, index);
                          $lastModules = $allModules.slice(index + 1);
                          $allModules = $firstModules.add($module).add($lastModules);
                          // invoke method in context of current instance
                          if (methodInvoked) {
                              instance = module;
                              module.invoke(query);
                          }
                      }
                  },

                  refresh: function () {
                      module.verbose('Refreshing selector cache');
                      $text = $module.find(selector.text);
                      $search = $module.find(selector.search);
                      $input = $module.find(selector.input);
                      $combo = ($module.prev().find(selector.text).length > 0)
                        ? $module.prev().find(selector.text)
                        : $module.prev()
                      ;
                      $menu = $module.children(selector.menu);
                      $item = $menu.find(selector.item);
                  },

                  toggle: function () {
                      module.verbose('Toggling menu visibility');
                      if (!module.is.active()) {
                          module.show();
                      }
                      else {
                          module.hide();
                      }
                  },

                  show: function (callback) {
                      callback = $.isFunction(callback)
                        ? callback
                        : function () { }
                      ;
                      if (module.is.searchSelection() && module.is.allFiltered()) {
                          return;
                      }
                      if (module.can.show() && !module.is.active()) {
                          module.debug('Showing dropdown');
                          module.animate.show(function () {
                              if (module.can.click()) {
                                  module.bind.intent();
                              }
                              module.fixOffset();
                              module.set.visible();
                              callback.call(element);
                          });
                          settings.onShow.call(element);
                      }
                  },

                  hide: function (callback) {
                      callback = $.isFunction(callback)
                        ? callback
                        : function () { }
                      ;
                      if (module.is.active()) {
                          module.debug('Hiding dropdown');
                          module.animate.hide(function () {
                              module.remove.visible();
                              callback.call(element);
                          });
                          settings.onHide.call(element);
                      }
                  },

                  hideOthers: function () {
                      module.verbose('Finding other dropdowns to hide');
                      $allModules
                        .not($module)
                          .has(selector.menu + ':visible:not(.' + className.animating + ')')
                            .dropdown('hide')
                      ;
                  },

                  hideSubMenus: function () {
                      var
                        $subMenus = $menu.find(selector.menu)
                      ;
                      $subMenus.transition('hide');
                  },

                  bind: {
                      keyboardEvents: function () {
                          module.debug('Binding keyboard events');
                          $module
                            .on('keydown' + eventNamespace, module.event.keydown)
                          ;
                          if (module.is.searchable()) {
                              $module
                                .on(module.get.inputEvent(), selector.search, module.event.input)
                              ;
                          }
                      },
                      touchEvents: function () {
                          module.debug('Touch device detected binding additional touch events');
                          if (module.is.searchSelection()) {
                              // do nothing special yet
                          }
                          else {
                              $module
                                .on('touchstart' + eventNamespace, module.event.test.toggle)
                              ;
                          }
                          $menu
                            .on('touchstart' + eventNamespace, selector.item, module.event.item.mouseenter)
                          ;
                      },
                      mouseEvents: function () {
                          module.verbose('Mouse detected binding mouse events');
                          if (module.is.searchSelection()) {
                              $module
                                .on('mousedown' + eventNamespace, selector.menu, module.event.menu.activate)
                                .on('mouseup' + eventNamespace, selector.menu, module.event.menu.deactivate)
                                .on('click' + eventNamespace, selector.search, module.show)
                                .on('focus' + eventNamespace, selector.search, module.event.searchFocus)
                                .on('blur' + eventNamespace, selector.search, module.event.searchBlur)
                                .on('click' + eventNamespace, selector.text, module.event.searchTextFocus)
                              ;
                          }
                          else {
                              if (settings.on == 'click') {
                                  $module
                                    .on('click' + eventNamespace, module.event.test.toggle)
                                  ;
                              }
                              else if (settings.on == 'hover') {
                                  $module
                                    .on('mouseenter' + eventNamespace, module.delay.show)
                                    .on('mouseleave' + eventNamespace, module.delay.hide)
                                  ;
                              }
                              else {
                                  $module
                                    .on(settings.on + eventNamespace, module.toggle)
                                  ;
                              }
                              $module
                                .on('mousedown' + eventNamespace, module.event.mousedown)
                                .on('mouseup' + eventNamespace, module.event.mouseup)
                                .on('focus' + eventNamespace, module.event.focus)
                                .on('blur' + eventNamespace, module.event.blur)
                              ;
                          }
                          $menu
                            .on('mouseenter' + eventNamespace, selector.item, module.event.item.mouseenter)
                            .on('mouseleave' + eventNamespace, selector.item, module.event.item.mouseleave)
                            .on('click' + eventNamespace, selector.item, module.event.item.click)
                          ;
                      },
                      intent: function () {
                          module.verbose('Binding hide intent event to document');
                          if (hasTouch) {
                              $document
                                .on('touchstart' + elementNamespace, module.event.test.touch)
                                .on('touchmove' + elementNamespace, module.event.test.touch)
                              ;
                          }
                          $document
                            .on('click' + elementNamespace, module.event.test.hide)
                          ;
                      }
                  },

                  unbind: {
                      intent: function () {
                          module.verbose('Removing hide intent event from document');
                          if (hasTouch) {
                              $document
                                .off('touchstart' + elementNamespace)
                                .off('touchmove' + elementNamespace)
                              ;
                          }
                          $document
                            .off('click' + elementNamespace)
                          ;
                      }
                  },

                  filter: function (searchTerm) {
                      var
                        $results = $(),
                        escapedTerm = module.escape.regExp(searchTerm),
                        exactRegExp = new RegExp('^' + escapedTerm, 'igm'),
                        fullTextRegExp = new RegExp(escapedTerm, 'ig'),
                        allItemsFiltered
                      ;
                      module.verbose('Searching for matching values');
                      $item
                        .each(function () {
                            var
                              $choice = $(this),
                              text = String(module.get.choiceText($choice, false)),
                              value = String(module.get.choiceValue($choice, text))
                            ;
                            if (text.match(exactRegExp) || value.match(exactRegExp)) {
                                $results = $results.add($choice);
                            }
                            else if (settings.fullTextSearch) {
                                if (text.match(fullTextRegExp) || value.match(fullTextRegExp)) {
                                    $results = $results.add($choice);
                                }
                            }
                        })
                      ;

                      module.debug('Setting filter', searchTerm);
                      module.remove.filteredItem();
                      $item
                        .not($results)
                        .addClass(className.filtered)
                      ;

                      module.verbose('Selecting first non-filtered element');
                      module.remove.selectedItem();
                      $item
                        .not('.' + className.filtered)
                          .eq(0)
                          .addClass(className.selected)
                      ;
                      if (module.is.allFiltered()) {
                          module.debug('All items filtered, hiding dropdown', searchTerm);
                          if (module.is.searchSelection()) {
                              module.hide();
                          }
                          settings.onNoResults.call(element, searchTerm);
                      }
                  },

                  focusSearch: function () {
                      if (module.is.search()) {
                          $search
                            .focus()
                          ;
                      }
                  },

                  forceSelection: function () {
                      var
                        $currentlySelected = $item.not(className.filtered).filter('.' + className.selected).eq(0),
                        $activeItem = $item.filter('.' + className.active).eq(0),
                        $selectedItem = ($currentlySelected.length > 0)
                          ? $currentlySelected
                          : $activeItem,
                        hasSelected = ($selectedItem.size() > 0)
                      ;
                      if (hasSelected) {
                          module.event.item.click.call($selectedItem);
                          module.remove.filteredItem();
                      }
                      else {
                          module.hide();
                      }
                  },

                  event: {
                      // prevents focus callback from occuring on mousedown
                      mousedown: function () {
                          activated = true;
                      },
                      mouseup: function () {
                          activated = false;
                      },
                      focus: function () {
                          if (!activated && module.is.hidden()) {
                              module.show();
                          }
                      },
                      blur: function (event) {
                          var
                            pageLostFocus = (document.activeElement === this)
                          ;
                          if (!activated && !pageLostFocus) {
                              module.hide();
                          }
                      },
                      searchFocus: function () {
                          activated = true;
                          module.show();
                      },
                      searchBlur: function (event) {
                          var
                            pageLostFocus = (document.activeElement === this)
                          ;
                          if (!itemActivated && !pageLostFocus) {
                              if (settings.forceSelection) {
                                  module.forceSelection();
                              }
                              else {
                                  module.hide();
                              }
                          }
                      },
                      searchTextFocus: function (event) {
                          activated = true;
                          $search.focus();
                      },
                      input: function (event) {
                          if (module.is.searchSelection()) {
                              module.set.filtered();
                          }
                          clearTimeout(module.timer);
                          module.timer = setTimeout(module.search, settings.delay.search);
                      },
                      keydown: function (event) {
                          var
                            $currentlySelected = $item.not(className.filtered).filter('.' + className.selected).eq(0),
                            $activeItem = $menu.children('.' + className.active).eq(0),
                            $selectedItem = ($currentlySelected.length > 0)
                              ? $currentlySelected
                              : $activeItem,
                            $visibleItems = ($selectedItem.length > 0)
                              ? $selectedItem.siblings(':not(.' + className.filtered + ')').andSelf()
                              : $menu.children(':not(.' + className.filtered + ')'),
                            $subMenu = $selectedItem.children(selector.menu),
                            $parentMenu = $selectedItem.closest(selector.menu),
                            isSubMenuItem = $parentMenu[0] !== $menu[0],
                            inVisibleMenu = $parentMenu.is(':visible'),
                            pressedKey = event.which,
                            keys = {
                                enter: 13,
                                escape: 27,
                                leftArrow: 37,
                                upArrow: 38,
                                rightArrow: 39,
                                downArrow: 40
                            },
                            hasSubMenu = ($subMenu.length > 0),
                            hasSelectedItem = ($selectedItem.length > 0),
                            lastVisibleIndex = ($visibleItems.size() - 1),
                            $nextItem,
                            newIndex
                          ;
                          // visible menu keyboard shortcuts
                          if (module.is.visible()) {
                              // enter (select or sub-menu)
                              if (pressedKey == keys.enter && hasSelectedItem) {
                                  if (hasSubMenu && !settings.allowCategorySelection) {
                                      module.verbose('Pressed enter on unselectable category, opening sub menu');
                                      pressedKey = keys.rightArrow;
                                  }
                                  else {
                                      module.verbose('Enter key pressed, choosing selected item');
                                      module.event.item.click.call($selectedItem, event);
                                  }
                              }
                              // left arrow (hide sub-menu)
                              if (pressedKey == keys.leftArrow) {
                                  if (isSubMenuItem) {
                                      module.verbose('Left key pressed, closing sub-menu');
                                      module.animate.hide(false, $parentMenu);
                                      $selectedItem
                                        .removeClass(className.selected)
                                      ;
                                      $parentMenu
                                        .closest(selector.item)
                                          .addClass(className.selected)
                                      ;
                                  }
                                  event.preventDefault();
                              }
                              // right arrow (show sub-menu)
                              if (pressedKey == keys.rightArrow) {
                                  if (hasSubMenu) {
                                      module.verbose('Right key pressed, opening sub-menu');
                                      module.animate.show(false, $subMenu);
                                      $selectedItem
                                        .removeClass(className.selected)
                                      ;
                                      $subMenu
                                        .find(selector.item).eq(0)
                                          .addClass(className.selected)
                                      ;
                                  }
                                  event.preventDefault();
                              }
                              // up arrow (traverse menu up)
                              if (pressedKey == keys.upArrow) {
                                  $nextItem = (hasSelectedItem && inVisibleMenu)
                                    ? $selectedItem.prevAll(selector.item + ':not(.' + className.filtered + ')').eq(0)
                                    : $item.eq(0)
                                  ;
                                  if ($visibleItems.index($nextItem) < 0) {
                                      module.verbose('Up key pressed but reached top of current menu');
                                      return;
                                  }
                                  else {
                                      module.verbose('Up key pressed, changing active item');
                                      $selectedItem
                                        .removeClass(className.selected)
                                      ;
                                      $nextItem
                                        .addClass(className.selected)
                                      ;
                                      module.set.scrollPosition($nextItem);
                                  }
                                  event.preventDefault();
                              }
                              // down arrow (traverse menu down)
                              if (pressedKey == keys.downArrow) {
                                  $nextItem = (hasSelectedItem && inVisibleMenu)
                                    ? $nextItem = $selectedItem.nextAll(selector.item + ':not(.' + className.filtered + ')').eq(0)
                                    : $item.eq(0)
                                  ;
                                  if ($nextItem.length === 0) {
                                      module.verbose('Down key pressed but reached bottom of current menu');
                                      return;
                                  }
                                  else {
                                      module.verbose('Down key pressed, changing active item');
                                      $item
                                        .removeClass(className.selected)
                                      ;
                                      $nextItem
                                        .addClass(className.selected)
                                      ;
                                      module.set.scrollPosition($nextItem);
                                  }
                                  event.preventDefault();
                              }
                          }
                          else {
                              // enter (open menu)
                              if (pressedKey == keys.enter) {
                                  module.verbose('Enter key pressed, showing dropdown');
                                  module.show();
                              }
                              // escape (close menu)
                              if (pressedKey == keys.escape) {
                                  module.verbose('Escape key pressed, closing dropdown');
                                  module.hide();
                              }
                              // down arrow (open menu)
                              if (pressedKey == keys.downArrow) {
                                  module.verbose('Down key pressed, showing dropdown');
                                  module.show();
                              }
                          }
                      },
                      test: {
                          toggle: function (event) {
                              if (module.determine.eventInMenu(event, module.toggle)) {
                                  event.preventDefault();
                              }
                          },
                          touch: function (event) {
                              module.determine.eventInMenu(event, function () {
                                  if (event.type == 'touchstart') {
                                      module.timer = setTimeout(module.hide, settings.delay.touch);
                                  }
                                  else if (event.type == 'touchmove') {
                                      clearTimeout(module.timer);
                                  }
                              });
                              event.stopPropagation();
                          },
                          hide: function (event) {
                              module.determine.eventInModule(event, module.hide);
                          }
                      },

                      menu: {
                          activate: function () {
                              itemActivated = true;
                          },
                          deactivate: function () {
                              itemActivated = false;
                          }
                      },
                      item: {
                          mouseenter: function (event) {
                              var
                                $subMenu = $(this).children(selector.menu),
                                $otherMenus = $(this).siblings(selector.item).children(selector.menu)
                              ;
                              if ($subMenu.length > 0) {
                                  clearTimeout(module.itemTimer);
                                  module.itemTimer = setTimeout(function () {
                                      module.verbose('Showing sub-menu', $subMenu);
                                      $.each($otherMenus, function () {
                                          module.animate.hide(false, $(this));
                                      });
                                      module.animate.show(false, $subMenu);
                                  }, settings.delay.show);
                                  event.preventDefault();
                              }
                          },
                          mouseleave: function (event) {
                              var
                                $subMenu = $(this).children(selector.menu)
                              ;
                              if ($subMenu.length > 0) {
                                  clearTimeout(module.itemTimer);
                                  module.itemTimer = setTimeout(function () {
                                      module.verbose('Hiding sub-menu', $subMenu);
                                      module.animate.hide(false, $subMenu);
                                  }, settings.delay.hide);
                              }
                          },
                          click: function (event) {
                              var
                                $choice = $(this),
                                $target = (event)
                                  ? $(event.target)
                                  : $(''),
                                $subMenu = $choice.find(selector.menu),
                                text = module.get.choiceText($choice),
                                value = module.get.choiceValue($choice, text),
                                callback = function () {
                                    module.remove.searchTerm();
                                    module.determine.selectAction(text, value);
                                },
                                hasSubMenu = ($subMenu.length > 0),
                                isBubbledEvent = ($subMenu.find($target).length > 0)
                              ;
                              if (!isBubbledEvent && (!hasSubMenu || settings.allowCategorySelection)) {
                                  callback();
                              }
                          }
                      },
                      resetStyle: function () {
                          $(this).removeAttr('style');
                      }
                  },

                  determine: {
                      selectAction: function (text, value) {
                          module.verbose('Determining action', settings.action);
                          if ($.isFunction(module.action[settings.action])) {
                              module.verbose('Triggering preset action', settings.action, text, value);
                              module.action[settings.action](text, value);
                          }
                          else if ($.isFunction(settings.action)) {
                              module.verbose('Triggering user action', settings.action, text, value);
                              settings.action(text, value);
                          }
                          else {
                              module.error(error.action, settings.action);
                          }
                      },
                      eventInModule: function (event, callback) {
                          callback = $.isFunction(callback)
                            ? callback
                            : function () { }
                          ;
                          if ($(event.target).closest($module).length === 0) {
                              module.verbose('Triggering event', callback);
                              callback();
                              return true;
                          }
                          else {
                              module.verbose('Event occurred in dropdown, canceling callback');
                              return false;
                          }
                      },
                      eventInMenu: function (event, callback) {
                          callback = $.isFunction(callback)
                            ? callback
                            : function () { }
                          ;
                          if ($(event.target).closest($menu).length === 0) {
                              module.verbose('Triggering event', callback);
                              callback();
                              return true;
                          }
                          else {
                              module.verbose('Event occurred in dropdown menu, canceling callback');
                              return false;
                          }
                      }
                  },

                  action: {

                      nothing: function () { },

                      activate: function (text, value) {
                          value = (value !== undefined)
                            ? value
                            : text
                          ;
                          module.set.selected(value);
                          module.hide(function () {
                              module.remove.filteredItem();
                          });
                      },

                      select: function (text, value) {
                          value = (value !== undefined)
                            ? value
                            : text
                          ;
                          module.set.selected(value);
                          module.hide(function () {
                              module.remove.filteredItem();
                          });
                      },

                      combo: function (text, value) {
                          value = (value !== undefined)
                            ? value
                            : text
                          ;
                          module.set.selected(value);
                          module.hide(function () {
                              module.remove.filteredItem();
                          });
                      },

                      hide: function () {
                          module.hide(function () {
                              module.remove.filteredItem();
                          });
                      }

                  },

                  get: {
                      id: function () {
                          return id;
                      },
                      text: function () {
                          return $text.text();
                      },
                      value: function () {
                          return ($input.length > 0)
                            ? $input.val()
                            : $module.data(metadata.value)
                          ;
                      },
                      choiceText: function ($choice, preserveHTML) {
                          preserveHTML = (preserveHTML !== undefined)
                            ? preserveHTML
                            : settings.preserveHTML
                          ;
                          if ($choice !== undefined) {
                              if ($choice.find(selector.menu).length > 0) {
                                  module.verbose('Retreiving text of element with sub-menu');
                                  $choice = $choice.clone();
                                  $choice.find(selector.menu).remove();
                                  $choice.find(selector.menuIcon).remove();
                              }
                              return ($choice.data(metadata.text) !== undefined)
                                ? $choice.data(metadata.text)
                                : (preserveHTML)
                                  ? $choice.html().trim()
                                  : $choice.text().trim()
                              ;
                          }
                      },
                      choiceValue: function ($choice, choiceText) {
                          choiceText = choiceText || module.get.choiceText($choice);
                          return ($choice.data(metadata.value) !== undefined)
                            ? $choice.data(metadata.value)
                            : (typeof choiceText === 'string')
                              ? choiceText.toLowerCase().trim()
                              : choiceText.trim()
                          ;
                      },
                      inputEvent: function () {
                          var
                            input = $search[0]
                          ;
                          if (input) {
                              return (input.oninput !== undefined)
                                ? 'input'
                                : (input.onpropertychange !== undefined)
                                  ? 'propertychange'
                                  : 'keyup'
                              ;
                          }
                          return false;
                      },
                      selectValues: function () {
                          var
                            select = {}
                          ;
                          select.values = (settings.sortSelect)
                            ? {} // properties will be sorted in object when re-accessed
                            : [] // properties will keep original order in array
                          ;
                          $module
                            .find('option')
                              .each(function () {
                                  var
                                    name = $(this).html(),
                                    value = ($(this).attr('value') !== undefined)
                                      ? $(this).attr('value')
                                      : name
                                  ;
                                  if (value === '') {
                                      select.placeholder = name;
                                  }
                                  else {
                                      if (settings.sortSelect) {
                                          select.values[value] = {
                                              name: name,
                                              value: value
                                          };
                                      }
                                      else {
                                          select.values.push({
                                              name: name,
                                              value: value
                                          });
                                      }
                                  }
                              })
                          ;
                          if (settings.sortSelect) {
                              module.debug('Retrieved and sorted values from select', select);
                          }
                          else {
                              module.debug('Retreived values from select', select);
                          }
                          return select;
                      },
                      activeItem: function () {
                          return $item.filter('.' + className.active);
                      },
                      item: function (value, strict) {
                          var
                            $selectedItem = false
                          ;
                          value = (value !== undefined)
                            ? value
                            : (module.get.value() !== undefined)
                              ? module.get.value()
                              : module.get.text()
                          ;
                          strict = (value === '' || value === 0)
                            ? true
                            : strict || false
                          ;
                          if (value !== undefined) {
                              $item
                                .each(function () {
                                    var
                                      $choice = $(this),
                                      optionText = module.get.choiceText($choice),
                                      optionValue = module.get.choiceValue($choice, optionText)
                                    ;
                                    if (strict) {
                                        module.verbose('Ambiguous dropdown value using strict type check', $choice, value);
                                        if (optionValue === value) {
                                            $selectedItem = $(this);
                                            return true;
                                        }
                                        else if (!$selectedItem && optionText === value) {
                                            $selectedItem = $(this);
                                            return true;
                                        }
                                    }
                                    else {
                                        if (optionValue == value) {
                                            module.verbose('Found select item by value', optionValue, value);
                                            $selectedItem = $(this);
                                            return true;
                                        }
                                        else if (!$selectedItem && optionText == value) {
                                            module.verbose('Found select item by text', optionText, value);
                                            $selectedItem = $(this);
                                            return true;
                                        }
                                    }
                                })
                              ;
                          }
                          else {
                              value = module.get.text();
                          }
                          return $selectedItem || false;
                      }
                  },

                  restore: {
                      defaults: function () {
                          module.restore.defaultText();
                          module.restore.defaultValue();
                      },
                      defaultText: function () {
                          var
                            defaultText = $module.data(metadata.defaultText)
                          ;
                          module.debug('Restoring default text', defaultText);
                          module.set.text(defaultText);
                          $text.addClass(className.placeholder);
                      },
                      defaultValue: function () {
                          var
                            defaultValue = $module.data(metadata.defaultValue)
                          ;
                          if (defaultValue !== undefined) {
                              module.debug('Restoring default value', defaultValue);
                              if (defaultValue.length) {
                                  module.set.selected(defaultValue);
                              }
                              else {
                                  module.remove.activeItem();
                                  module.remove.selectedItem();
                              }
                          }
                      }
                  },

                  save: {
                      defaults: function () {
                          module.save.defaultText();
                          module.save.placeholderText();
                          module.save.defaultValue();
                      },
                      defaultValue: function () {
                          $module.data(metadata.defaultValue, module.get.value());
                      },
                      defaultText: function () {
                          $module.data(metadata.defaultText, $text.text());
                      },
                      placeholderText: function () {
                          if ($text.hasClass(className.placeholder)) {
                              $module.data(metadata.placeholderText, $text.text());
                          }
                      }
                  },

                  clear: function () {
                      var
                        placeholderText = $module.data(metadata.placeholderText)
                      ;
                      module.set.text(placeholderText);
                      module.set.value('');
                      module.remove.activeItem();
                      module.remove.selectedItem();
                      $text.addClass(className.placeholder);
                  },

                  set: {
                      filtered: function () {
                          var
                            searchValue = $search.val(),
                            hasSearchValue = (typeof searchValue === 'string' && searchValue.length > 0)
                          ;
                          if (hasSearchValue) {
                              $text.addClass(className.filtered);
                          }
                          else {
                              $text.removeClass(className.filtered);
                          }
                      },
                      tabbable: function () {
                          if (module.is.searchable()) {
                              module.debug('Searchable dropdown initialized');
                              $search
                                .val('')
                                .attr('tabindex', 0)
                              ;
                              $menu
                                .attr('tabindex', '-1')
                              ;
                          }
                          else {
                              module.debug('Simple selection dropdown initialized');
                              if (!$module.attr('tabindex')) {
                                  $module
                                    .attr('tabindex', 0)
                                  ;
                                  $menu
                                    .attr('tabindex', '-1')
                                  ;
                              }
                          }
                      },
                      scrollPosition: function ($item, forceScroll) {
                          var
                            edgeTolerance = 5,
                            hasActive,
                            offset,
                            itemHeight,
                            itemOffset,
                            menuOffset,
                            menuScroll,
                            menuHeight,
                            abovePage,
                            belowPage
                          ;

                          $item = $item || module.get.activeItem();
                          hasActive = ($item && $item.length > 0);
                          forceScroll = (forceScroll !== undefined)
                            ? forceScroll
                            : false
                          ;

                          if ($item && hasActive) {

                              if (!$menu.hasClass(className.visible)) {
                                  $menu.addClass(className.loading);
                              }

                              menuHeight = $menu.height();
                              itemHeight = $item.height();
                              menuScroll = $menu.scrollTop();
                              menuOffset = $menu.offset().top;
                              itemOffset = $item.offset().top;
                              offset = menuScroll - menuOffset + itemOffset;
                              belowPage = menuScroll + menuHeight < (offset + edgeTolerance);
                              abovePage = ((offset - edgeTolerance) < menuScroll);
                              module.debug('Scrolling to active item', offset);
                              if (abovePage || belowPage || forceScroll) {
                                  $menu
                                    .scrollTop(offset)
                                    .removeClass(className.loading)
                                  ;
                              }
                          }
                      },
                      text: function (text) {
                          if (settings.action == 'combo') {
                              module.debug('Changing combo button text', text, $combo);
                              if (settings.preserveHTML) {
                                  $combo.html(text);
                              }
                              else {
                                  $combo.text(text);
                              }
                          }
                          else if (settings.action !== 'select') {
                              module.debug('Changing text', text, $text);
                              $text
                                .removeClass(className.filtered)
                                .removeClass(className.placeholder)
                              ;
                              if (settings.preserveHTML) {
                                  $text.html(text);
                              }
                              else {
                                  $text.text(text);
                              }
                          }
                      },
                      value: function (value) {
                          module.debug('Adding selected value to hidden input', value, $input);
                          if ($input.length > 0) {
                              $input
                                .val(value)
                                .trigger('change')
                              ;
                          }
                          else {
                              $module.data(metadata.value, value);
                          }
                      },
                      active: function () {
                          $module
                            .addClass(className.active)
                          ;
                      },
                      visible: function () {
                          $module.addClass(className.visible);
                      },
                      selected: function (value) {
                          var
                            $selectedItem = module.get.item(value),
                            selectedText,
                            selectedValue
                          ;
                          if ($selectedItem && !$selectedItem.hasClass(className.active)) {
                              module.debug('Setting selected menu item to', $selectedItem);
                              module.remove.activeItem();
                              module.remove.selectedItem();
                              $selectedItem
                                .addClass(className.active)
                                .addClass(className.selected)
                              ;
                              selectedText = module.get.choiceText($selectedItem);
                              selectedValue = module.get.choiceValue($selectedItem, selectedText);
                              module.set.text(selectedText);
                              module.set.value(selectedValue);
                              settings.onChange.call(element, value, selectedText, $selectedItem);
                          }
                      }
                  },

                  remove: {
                      active: function () {
                          $module.removeClass(className.active);
                      },
                      visible: function () {
                          $module.removeClass(className.visible);
                      },
                      activeItem: function () {
                          $item.removeClass(className.active);
                      },
                      filteredItem: function () {
                          $item.removeClass(className.filtered);
                      },
                      searchTerm: function () {
                          $search.val('');
                      },
                      selectedItem: function () {
                          $item.removeClass(className.selected);
                      },
                      tabbable: function () {
                          if (module.is.searchable()) {
                              module.debug('Searchable dropdown initialized');
                              $search
                                .attr('tabindex', '-1')
                              ;
                              $menu
                                .attr('tabindex', '-1')
                              ;
                          }
                          else {
                              module.debug('Simple selection dropdown initialized');
                              $module
                                .attr('tabindex', '-1')
                              ;
                              $menu
                                .attr('tabindex', '-1')
                              ;
                          }
                      }
                  },

                  is: {
                      active: function () {
                          return $module.hasClass(className.active);
                      },
                      alreadySetup: function () {
                          return ($module.is('select') && $module.parent(selector.dropdown).length > 0);
                      },
                      animating: function ($subMenu) {
                          return ($subMenu)
                            ? $subMenu.is(':animated') || $subMenu.transition && $subMenu.transition('is animating')
                            : $menu.is(':animated') || $menu.transition && $menu.transition('is animating')
                          ;
                      },
                      allFiltered: function () {
                          return ($item.filter('.' + className.filtered).length === $item.length);
                      },
                      hidden: function ($subMenu) {
                          return ($subMenu)
                            ? $subMenu.is(':hidden')
                            : $menu.is(':hidden')
                          ;
                      },
                      selectMutation: function (mutations) {
                          var
                            selectChanged = false
                          ;
                          $.each(mutations, function (index, mutation) {
                              if (mutation.target && $(mutation.target).is('select')) {
                                  selectChanged = true;
                                  return true;
                              }
                          });
                          return selectChanged;
                      },
                      search: function () {
                          return $module.hasClass(className.search);
                      },
                      searchable: function () {
                          return ($search.length > 0);
                      },
                      searchSelection: function () {
                          return (module.is.searchable() && $search.parent().is($module));
                      },
                      selection: function () {
                          return $module.hasClass(className.selection);
                      },
                      upward: function () {
                          return $module.hasClass(className.upward);
                      },
                      visible: function ($subMenu) {
                          return ($subMenu)
                            ? $subMenu.is(':visible')
                            : $menu.is(':visible')
                          ;
                      }
                  },

                  can: {
                      click: function () {
                          return (hasTouch || settings.on == 'click');
                      },
                      show: function () {
                          return !$module.hasClass(className.disabled);
                      }
                  },

                  animate: {
                      show: function (callback, $subMenu) {
                          var
                            $currentMenu = $subMenu || $menu,
                            start = ($subMenu)
                              ? function () {
                                  module.fixOffset();
                              }
                              : function () {
                                  module.hideSubMenus();
                                  module.hideOthers();
                                  module.set.active();
                                  module.fixOffset();
                              }
                          ;
                          callback = $.isFunction(callback)
                            ? callback
                            : function () { }
                          ;
                          module.set.scrollPosition(module.get.activeItem(), true);
                          module.verbose('Doing menu show animation', $currentMenu);
                          if (module.is.hidden($currentMenu) || module.is.animating($currentMenu)) {      
                              if (settings.transition == 'auto') {
                                  settings.transition = module.is.upward()
                                    ? 'slide up'
                                    : 'slide down'
                                  ;
                                  module.verbose('Automatically determining animation based on animation direction', settings.transition);
                              }
                              if (settings.transition == 'none') {
                                  callback.call(element);
                              }
                              else if ($.fn.transition !== undefined && $module.transition('is supported')) {
                                  $currentMenu
                                    .transition({
                                        animation: settings.transition + ' in',
                                        debug: settings.debug,
                                        verbose: settings.verbose,
                                        duration: settings.duration,
                                        queue: true,
                                        onStart: start,
                                        onComplete: function () {
                                            callback.call(element);
                                        }
                                    })
                                  ;
                              }
                              else if (settings.transition == 'slide down') {
                                  start();
                                  $currentMenu
                                    .hide()
                                    .clearQueue()
                                    .children()
                                      .clearQueue()
                                      .css('opacity', 0)
                                      .delay(50)
                                      .animate({
                                          opacity: 1
                                      }, settings.duration, 'easeOutQuad', module.event.resetStyle)
                                      .end()
                                    .slideDown(100, 'easeOutQuad', function () {
                                        module.event.resetStyle.call(this);
                                        callback.call(element);
                                    })
                                  ;
                              }
                              else if (settings.transition == 'fade') {
                                  start();
                                  $currentMenu
                                    .hide()
                                    .clearQueue()
                                    .fadeIn(settings.duration, function () {
                                        module.event.resetStyle.call(this);
                                        callback.call(element);
                                    })
                                  ;
                              }
                              else {
                                  module.error(error.transition, settings.transition);
                              }
                          }
                      },
                      hide: function (callback, $subMenu) {
                          var
                            $currentMenu = $subMenu || $menu,
                            duration = ($subMenu)
                              ? (settings.duration * 0.9)
                              : settings.duration,
                            start = ($subMenu)
                              ? function () { }
                              : function () {
                                  if (module.can.click()) {
                                      module.unbind.intent();
                                  }
                                  module.focusSearch();
                                  module.remove.active();
                              }
                          ;
                          callback = $.isFunction(callback)
                            ? callback
                            : function () { }
                          ;
                          if (module.is.visible($currentMenu) || module.is.animating($currentMenu)) {
                              module.verbose('Doing menu hide animation', $currentMenu);

                              if (settings.transition == 'auto') {
                                  settings.transition = module.is.upward()
                                    ? 'slide up'
                                    : 'slide down'
                                  ;
                              }

                              $input.trigger('blur');

                              if (settings.transition == 'none') {
                                  callback.call(element);
                              }
                              else if ($.fn.transition !== undefined && $module.transition('is supported')) {
                                  $currentMenu
                                    .transition({
                                        animation: settings.transition + ' out',
                                        duration: settings.duration,
                                        debug: settings.debug,
                                        verbose: settings.verbose,
                                        queue: true,
                                        onStart: start,
                                        onComplete: function () {
                                            callback.call(element);
                                        }
                                    })
                                  ;
                              }
                              else if (settings.transition == 'slide down') {
                                  start();
                                  $currentMenu
                                    .show()
                                    .clearQueue()
                                    .children()
                                      .clearQueue()
                                      .css('opacity', 1)
                                      .animate({
                                          opacity: 0
                                      }, 100, 'easeOutQuad', module.event.resetStyle)
                                      .end()
                                    .delay(50)
                                    .slideUp(100, 'easeOutQuad', function () {
                                        module.event.resetStyle.call(this);
                                        callback.call(element);
                                    })
                                  ;
                              }
                              else if (settings.transition == 'fade') {
                                  start();
                                  $currentMenu
                                    .show()
                                    .clearQueue()
                                    .fadeOut(150, function () {
                                        module.event.resetStyle.call(this);
                                        callback.call(element);
                                    })
                                  ;
                              }
                              else {
                                  module.error(error.transition);
                              }
                          }
                      }
                  },

                  delay: {
                      show: function () {
                          module.verbose('Delaying show event to ensure user intent');
                          clearTimeout(module.timer);
                          module.timer = setTimeout(module.show, settings.delay.show);
                      },
                      hide: function () {
                          module.verbose('Delaying hide event to ensure user intent');
                          clearTimeout(module.timer);
                          module.timer = setTimeout(module.hide, settings.delay.hide);
                      }
                  },

                  escape: {
                      regExp: function (text) {
                          text = String(text);
                          return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
                      }
                  },

                  setting: function (name, value) {
                      module.debug('Changing setting', name, value);
                      if ($.isPlainObject(name)) {
                          $.extend(true, settings, name);
                      }
                      else if (value !== undefined) {
                          settings[name] = value;
                      }
                      else {
                          return settings[name];
                      }
                  },
                  internal: function (name, value) {
                      if ($.isPlainObject(name)) {
                          $.extend(true, module, name);
                      }
                      else if (value !== undefined) {
                          module[name] = value;
                      }
                      else {
                          return module[name];
                      }
                  },
                  debug: function () {
                      if (settings.debug) {
                          if (settings.performance) {
                              module.performance.log(arguments);
                          }
                          else {
                              module.debug = Function.prototype.bind.call(console.info, console, settings.name + ':');
                              module.debug.apply(console, arguments);
                          }
                      }
                  },
                  fixOffset: function () {
                      var menuOffset = $(window).width() - ($menu.offset().left + $menu.outerWidth() + 8);
                      if (menuOffset < 0) {
                          $menu.css('left', menuOffset + 'px');
                      }
                  },
                  verbose: function () {
                      if (settings.verbose && settings.debug) {
                          if (settings.performance) {
                              module.performance.log(arguments);
                          }
                          else {
                              module.verbose = Function.prototype.bind.call(console.info, console, settings.name + ':');
                              module.verbose.apply(console, arguments);
                          }
                      }
                  },
                  error: function () {
                      module.error = Function.prototype.bind.call(console.error, console, settings.name + ':');
                      module.error.apply(console, arguments);
                  },
                  performance: {
                      log: function (message) {
                          var
                            currentTime,
                            executionTime,
                            previousTime
                          ;
                          if (settings.performance) {
                              currentTime = new Date().getTime();
                              previousTime = time || currentTime;
                              executionTime = currentTime - previousTime;
                              time = currentTime;
                              performance.push({
                                  'Name': message[0],
                                  'Arguments': [].slice.call(message, 1) || '',
                                  'Element': element,
                                  'Execution Time': executionTime
                              });
                          }
                          clearTimeout(module.performance.timer);
                          module.performance.timer = setTimeout(module.performance.display, 500);
                      },
                      display: function () {
                          var
                            title = settings.name + ':',
                            totalTime = 0
                          ;
                          time = false;
                          clearTimeout(module.performance.timer);
                          $.each(performance, function (index, data) {
                              totalTime += data['Execution Time'];
                          });
                          title += ' ' + totalTime + 'ms';
                          if (moduleSelector) {
                              title += ' \'' + moduleSelector + '\'';
                          }
                          if ((console.group !== undefined || console.table !== undefined) && performance.length > 0) {
                              console.groupCollapsed(title);
                              if (console.table) {
                                  console.table(performance);
                              }
                              else {
                                  $.each(performance, function (index, data) {
                                      console.log(data['Name'] + ': ' + data['Execution Time'] + 'ms');
                                  });
                              }
                              console.groupEnd();
                          }
                          performance = [];
                      }
                  },
                  invoke: function (query, passedArguments, context) {
                      var
                        object = instance,
                        maxDepth,
                        found,
                        response
                      ;
                      passedArguments = passedArguments || queryArguments;
                      context = element || context;
                      if (typeof query == 'string' && object !== undefined) {
                          query = query.split(/[\. ]/);
                          maxDepth = query.length - 1;
                          $.each(query, function (depth, value) {
                              var camelCaseValue = (depth != maxDepth)
                                ? value + query[depth + 1].charAt(0).toUpperCase() + query[depth + 1].slice(1)
                                : query
                              ;
                              if ($.isPlainObject(object[camelCaseValue]) && (depth != maxDepth)) {
                                  object = object[camelCaseValue];
                              }
                              else if (object[camelCaseValue] !== undefined) {
                                  found = object[camelCaseValue];
                                  return false;
                              }
                              else if ($.isPlainObject(object[value]) && (depth != maxDepth)) {
                                  object = object[value];
                              }
                              else if (object[value] !== undefined) {
                                  found = object[value];
                                  return false;
                              }
                              else {
                                  module.error(error.method, query);
                                  return false;
                              }
                          });
                      }
                      if ($.isFunction(found)) {
                          response = found.apply(context, passedArguments);
                      }
                      else if (found !== undefined) {
                          response = found;
                      }
                      if ($.isArray(returnedValue)) {
                          returnedValue.push(response);
                      }
                      else if (returnedValue !== undefined) {
                          returnedValue = [returnedValue, response];
                      }
                      else if (response !== undefined) {
                          returnedValue = response;
                      }
                      return found;
                  }
              };

              if (methodInvoked) {
                  if (instance === undefined) {
                      module.initialize();
                  }
                  module.invoke(query);
              }
              else {
                  if (instance !== undefined) {
                      instance.invoke('destroy');
                  }
                  module.initialize();
              }
          })
        ;
        return (returnedValue !== undefined)
          ? returnedValue
          : $allModules
        ;
    };

    $.fn.dropdown.settings = {

        debug: false,
        verbose: true,
        performance: true,

        on: 'click',
        action: 'activate',

        allowTab: true,
        fullTextSearch: false,
        preserveHTML: true,
        sortSelect: false,

        allowCategorySelection: false,

        delay: {
            hide: 300,
            show: 200,
            search: 50,
            touch: 50
        },

        forceSelection: true,

        transition: 'auto',
        duration: 250,

        /* Callbacks */
        onNoResults: function (searchTerm) { },
        onChange: function (value, text) { },
        onShow: function () { },
        onHide: function () { },

        /* Component */

        name: 'Dropdown',
        namespace: 'dropdown',

        error: {
            action: 'You called a dropdown action that was not defined',
            alreadySetup: 'Once a select has been initialized behaviors must be called on the created ui dropdown',
            method: 'The method you called is not defined.',
            transition: 'The requested transition was not found'
        },

        metadata: {
            defaultText: 'defaultText',
            defaultValue: 'defaultValue',
            placeholderText: 'placeholderText',
            text: 'text',
            value: 'value'
        },

        selector: {
            dropdown: '.ui.dropdown',
            input: '> input[type="hidden"], > select',
            item: '.item',
            menu: '.menu',
            menuIcon: '.dropdown.icon',
            search: '> input.search, .menu > .search > input, .menu > input.search',
            text: '> .text:not(.icon)'
        },

        className: {
            active: 'active',
            animating: 'animating',
            disabled: 'disabled',
            dropdown: 'ui dropdown',
            filtered: 'filtered',
            loading: 'loading',
            menu: 'menu',
            placeholder: 'default',
            search: 'search',
            selected: 'selected',
            selection: 'selection',
            upward: 'upward',
            visible: 'visible'
        }

    };

    /* Templates */
    $.fn.dropdown.settings.templates = {
        menu: function (select) {
            var
              placeholder = select.placeholder || false,
              values = select.values || {},
              html = ''
            ;
            $.each(select.values, function (index, option) {
                html += '<div class="item" data-value="' + option.value + '">' + option.name + '</div>';
            });
            return html;
        },
        dropdown: function (select) {
            var
              placeholder = select.placeholder || false,
              values = select.values || {},
              html = ''
            ;
            html += '<i class="dropdown icon"></i>';
            if (select.placeholder) {
                html += '<div class="default text">' + placeholder + '</div>';
            }
            else {
                html += '<div class="text"></div>';
            }
            html += '<div class="menu">';
            $.each(select.values, function (index, option) {
                html += '<div class="item" data-value="' + option.value + '">' + option.name + '</div>';
            });
            html += '</div>';
            return html;
        }
    };


    /* Dependencies */
    $.extend($.easing, {
        easeOutQuad: function (x, t, b, c, d) {
            return -c * (t /= d) * (t - 2) + b;
        },
    });


})(jQuery, window, document);

/*! Tablesaw - v1.0.4 - 2015-02-19
* https://github.com/filamentgroup/tablesaw
* Copyright (c) 2015 Filament Group; Licensed MIT */
;(function( $ ) {
	var div = document.createElement('div'),
		all = div.getElementsByTagName('i'),
		$doc = $( document.documentElement );

	div.innerHTML = '<!--[if lte IE 8]><i></i><![endif]-->';
	if( all[ 0 ] ) {
		$doc.addClass( 'ie-lte8' );
	}

	// Cut the mustard
	if( !( 'querySelector' in document ) ||
			( window.blackberry && !window.WebKitPoint ) ||
			window.operamini ) {
		return;
	} else {
		$doc.addClass( 'tablesaw-enhanced' );

		// DOM-ready auto-init of plugins.
		// Many plugins bind to an "enhance" event to init themselves on dom ready, or when new markup is inserted into the DOM
		$( function(){
			$( document ).trigger( "enhance.tablesaw" );
		});
	}

})( jQuery );
/*
* tablesaw: A set of plugins for responsive tables
* Stack and Column Toggle tables
* Copyright (c) 2013 Filament Group, Inc.
* MIT License
*/

if( typeof Tablesaw === "undefined" ) {
	Tablesaw = {
		i18n: {
			modes: [ 'Stack', 'Swipe', 'Toggle' ],
			columns: 'Col<span class=\"a11y-sm\">umn</span>s',
			columnBtnText: 'Columns',
			columnsDialogError: 'No eligible columns.',
			sort: 'Sort by'
		}
	};
}
if( !Tablesaw.config ) {
	Tablesaw.config = {};
}

;(function( $ ) {
	var pluginName = "table",
		classes = {
			toolbar: "tablesaw-bar"
		},
		events = {
			create: "tablesawcreate",
			destroy: "tablesawdestroy",
			refresh: "tablesawrefresh"
		},
		defaultMode = "stack",
		initSelector = "table[data-tablesaw-mode],table[data-tablesaw-sortable]";

	var Table = function( element ) {
		if( !element ) {
			throw new Error( "Tablesaw requires an element." );
		}

		this.table = element;
		this.$table = $( element );

		this.mode = this.$table.attr( "data-tablesaw-mode" ) || defaultMode;

		this.init();
	};

	Table.prototype.init = function() {
		// assign an id if there is none
		if ( !this.$table.attr( "id" ) ) {
			this.$table.attr( "id", pluginName + "-" + Math.round( Math.random() * 10000 ) );
		}

		this.createToolbar();

		var colstart = this._initCells();

		this.$table.trigger( events.create, [ this, colstart ] );
	};

	Table.prototype._initCells = function() {
		var colstart,
			thrs = this.table.querySelectorAll( "thead tr" ),
			self = this;

		$( thrs ).each( function(){
			var coltally = 0;

			$( this ).children().each( function(){
				var span = parseInt( this.getAttribute( "colspan" ), 10 ),
					sel = ":nth-child(" + ( coltally + 1 ) + ")";

				colstart = coltally + 1;

				if( span ){
					for( var k = 0; k < span - 1; k++ ){
						coltally++;
						sel += ", :nth-child(" + ( coltally + 1 ) + ")";
					}
				}

				// Store "cells" data on header as a reference to all cells in the same column as this TH
				this.cells = self.$table.find("tr").not( $( thrs ).eq( 0 ) ).not( this ).children( sel );
				coltally++;
			});
		});

		return colstart;
	};

	Table.prototype.refresh = function() {
		this._initCells();

		this.$table.trigger( events.refresh );
	};

	Table.prototype.createToolbar = function() {
		// Insert the toolbar
		// TODO move this into a separate component
		var $toolbar = this.$table.prev( '.' + classes.toolbar );
		if( !$toolbar.length ) {
			$toolbar = $( '<div>' )
				.addClass( classes.toolbar )
				.insertBefore( this.$table );
		}
		this.$toolbar = $toolbar;

		if( this.mode ) {
			this.$toolbar.addClass( 'mode-' + this.mode );
		}
	};

	Table.prototype.destroy = function() {
		// Don’t remove the toolbar. Some of the table features are not yet destroy-friendly.
		this.$table.prev( '.' + classes.toolbar ).each(function() {
			this.className = this.className.replace( /\bmode\-\w*\b/gi, '' );
		});

		var tableId = this.$table.attr( 'id' );
		$( document ).unbind( "." + tableId );
		$( window ).unbind( "." + tableId );

		// other plugins
		this.$table.trigger( events.destroy, [ this ] );

		this.$table.removeAttr( 'data-tablesaw-mode' );

		this.$table.removeData( pluginName );
	};

	// Collection method.
	$.fn[ pluginName ] = function() {
		return this.each( function() {
			var $t = $( this );

			if( $t.data( pluginName ) ){
				return;
			}

			var table = new Table( this );
			$t.data( pluginName, table );
		});
	};

	$( document ).on( "enhance.tablesaw", function( e ) {
		$( e.target ).find( initSelector )[ pluginName ]();
	});

}( jQuery ));

;(function( win, $, undefined ){

	var classes = {
		stackTable: 'tablesaw-stack',
		cellLabels: 'tablesaw-cell-label',
		cellContentLabels: 'tablesaw-cell-content'
	};

	var data = {
		obj: 'tablesaw-stack'
	};

	var attrs = {
		labelless: 'data-tablesaw-no-labels',
		hideempty: 'data-tablesaw-hide-empty'
	};

	var Stack = function( element ) {

		this.$table = $( element );

		this.labelless = this.$table.is( '[' + attrs.labelless + ']' );
		this.hideempty = this.$table.is( '[' + attrs.hideempty + ']' );

		if( !this.labelless ) {
			// allHeaders references headers, plus all THs in the thead, which may include several rows, or not
			this.allHeaders = this.$table.find( "th" );
		}

		this.$table.data( data.obj, this );
	};

	Stack.prototype.init = function( colstart ) {
		this.$table.addClass( classes.stackTable );

		if( this.labelless ) {
			return;
		}

		// get headers in reverse order so that top-level headers are appended last
		var reverseHeaders = $( this.allHeaders );
		var hideempty = this.hideempty;
		
		// create the hide/show toggles
		reverseHeaders.each(function(){
			var $t = $( this ),
				$cells = $( this.cells ).filter(function() {
					return !$( this ).parent().is( "[" + attrs.labelless + "]" ) && ( !hideempty || !$( this ).is( ":empty" ) );
				}),
				hierarchyClass = $cells.not( this ).filter( "thead th" ).length && " tablesaw-cell-label-top",
				// TODO reduce coupling with sortable
				$sortableButton = $t.find( ".tablesaw-sortable-btn" ),
				html = $sortableButton.length ? $sortableButton.html() : $t.html();

			if( html !== "" ){
				if( hierarchyClass ){
					var iteration = parseInt( $( this ).attr( "colspan" ), 10 ),
						filter = "";

					if( iteration ){
						filter = "td:nth-child("+ iteration +"n + " + ( colstart ) +")";
					}
					$cells.filter( filter ).prepend( "<b class='" + classes.cellLabels + hierarchyClass + "'>" + html + "</b>"  );
				} else {
					$cells.wrapInner( "<span class='" + classes.cellContentLabels + "'></span>" );
					$cells.prepend( "<b class='" + classes.cellLabels + "'>" + html + "</b>"  );
				}
			}
		});
	};

	Stack.prototype.destroy = function() {
		this.$table.removeClass( classes.stackTable );
		this.$table.find( '.' + classes.cellLabels ).remove();
		this.$table.find( '.' + classes.cellContentLabels ).each(function() {
			$( this ).replaceWith( this.childNodes );
		});
	};

	// on tablecreate, init
	$( document ).on( "tablesawcreate", function( e, Tablesaw, colstart ){
		if( Tablesaw.mode === 'stack' ){
			var table = new Stack( Tablesaw.table );
			table.init( colstart );
		}

	} );

	$( document ).on( "tablesawdestroy", function( e, Tablesaw ){

		if( Tablesaw.mode === 'stack' ){
			$( Tablesaw.table ).data( data.obj ).destroy();
		}

	} );

}( this, jQuery ));
;(function( $ ) {
	var pluginName = "tablesawbtn",
		initSelector = ".btn",
		methods = {
			_create: function(){
				return $( this ).each(function() {
					$( this )
						.trigger( "beforecreate." + pluginName )
						[ pluginName ]( "_init" )
						.trigger( "create." + pluginName );
				});
			},
			_init: function(){
				var oEl = $( this ),
					sel = this.getElementsByTagName( "select" )[ 0 ];

				if( sel ) {
					$( this )
						.addClass( "btn-select" )
						[ pluginName ]( "_select", sel );
				}
				return oEl;
			},
			_select: function( sel ) {
				var update = function( oEl, sel ) {
					var opts = $( sel ).find( "option" ),
						label, el, children;

					opts.each(function() {
						var opt = this;
						if( opt.selected ) {
							label = document.createTextNode( opt.text );
						}
					});

					children = oEl.childNodes;
					if( opts.length > 0 ){
						for( var i = 0, l = children.length; i < l; i++ ) {
							el = children[ i ];

							if( el && el.nodeType === 3 ) {
								oEl.replaceChild( label, el );
							}
						}
					}
				};

				update( this, sel );
				$( this ).bind( "change refresh", function() {
					update( this, sel );
				});
			}
		};

	// Collection method.
	$.fn[ pluginName ] = function( arrg, a, b, c ) {
		return this.each(function() {

		// if it's a method
		if( arrg && typeof( arrg ) === "string" ){
			return $.fn[ pluginName ].prototype[ arrg ].call( this, a, b, c );
		}

		// don't re-init
		if( $( this ).data( pluginName + "active" ) ){
			return $( this );
		}

		// otherwise, init

		$( this ).data( pluginName + "active", true );
			$.fn[ pluginName ].prototype._create.call( this );
		});
	};

	// add methods
	$.extend( $.fn[ pluginName ].prototype, methods );

	$( document ).on( "enhance", function( e ) {
		$( initSelector, e.target )[ pluginName ]();
	});

}( jQuery ));
;(function( win, $, undefined ){

	var ColumnToggle = function( element ) {

		this.$table = $( element );

		this.classes = {
			columnToggleTable: 'tablesaw-columntoggle',
			columnBtnContain: 'tablesaw-columntoggle-btnwrap tablesaw-advance',
			columnBtn: 'tablesaw-columntoggle-btn tablesaw-nav-btn down',
			popup: 'tablesaw-columntoggle-popup',
			priorityPrefix: 'tablesaw-priority-',
			// TODO duplicate class, also in tables.js
			toolbar: 'tablesaw-bar'
		};

		// Expose headers and allHeaders properties on the widget
		// headers references the THs within the first TR in the table
		this.headers = this.$table.find( 'tr:first > th' );

		this.$table.data( 'tablesaw-coltoggle', this );
	};

	ColumnToggle.prototype.init = function() {

		var tableId,
			id,
			$menuButton,
			$popup,
			$menu,
			$btnContain,
			self = this;

		this.$table.addClass( this.classes.columnToggleTable );

		tableId = this.$table.attr( "id" );
		id = tableId + "-popup";
		$btnContain = $( "<div class='" + this.classes.columnBtnContain + "'></div>" );
		$menuButton = $( "<a href='#" + id + "' class='btn btn-micro " + this.classes.columnBtn +"' data-popup-link>" +
										"<span>" + Tablesaw.i18n.columnBtnText + "</span></a>" );
		$popup = $( "<div class='dialog-table-coltoggle " + this.classes.popup + "' id='" + id + "'></div>" );
		$menu = $( "<div class='btn-group'></div>" );

		var hasNonPersistentHeaders = false;
		$( this.headers ).not( "td" ).each( function() {
			var $this = $( this ),
				priority = $this.attr("data-tablesaw-priority"),
				$cells = $this.add( this.cells );

			if( priority && priority !== "persist" ) {
				$cells.addClass( self.classes.priorityPrefix + priority );

				$("<label><input type='checkbox' checked>" + $this.text() + "</label>" )
					.appendTo( $menu )
					.children( 0 )
					.data( "cells", $cells );

				hasNonPersistentHeaders = true;
			}
		});

		if( !hasNonPersistentHeaders ) {
			$menu.append( '<label>' + Tablesaw.i18n.columnsDialogError + '</label>' );
		}

		$menu.appendTo( $popup );

		// bind change event listeners to inputs - TODO: move to a private method?
		$menu.find( 'input[type="checkbox"]' ).on( "change", function(e) {
			var checked = e.target.checked;

			$( e.target ).data( "cells" )
				.toggleClass( "tablesaw-cell-hidden", !checked )
				.toggleClass( "tablesaw-cell-visible", checked );

			self.$table.trigger( 'tablesawcolumns' );
		});

		$menuButton.appendTo( $btnContain );
		$btnContain.appendTo( this.$table.prev( '.' + this.classes.toolbar ) );

		var closeTimeout;
		function openPopup() {
			$btnContain.addClass( 'visible' );
			$menuButton.removeClass( 'down' ).addClass( 'up' );

			$( document ).unbind( 'click.' + tableId, closePopup );

			window.clearTimeout( closeTimeout );
			closeTimeout = window.setTimeout(function() {
				$( document ).one( 'click.' + tableId, closePopup );
			}, 15 );
		}

		function closePopup( event ) {
			// Click came from inside the popup, ignore.
			if( event && $( event.target ).closest( "." + self.classes.popup ).length ) {
				return;
			}

			$( document ).unbind( 'click.' + tableId );
			$menuButton.removeClass( 'up' ).addClass( 'down' );
			$btnContain.removeClass( 'visible' );
		}

		$menuButton.on( "click.tablesaw", function( event ) {
			event.preventDefault();

			if( !$btnContain.is( ".visible" ) ) {
				openPopup();
			} else {
				closePopup();
			}
		});

		$popup.appendTo( $btnContain );

		this.$menu = $menu;

		$(window).on( "resize." + tableId, function(){
			self.refreshToggle();
		});

		this.refreshToggle();
	};

	ColumnToggle.prototype.refreshToggle = function() {
		this.$menu.find( "input" ).each( function() {
			var $this = $( this );

			this.checked = $this.data( "cells" ).eq( 0 ).css( "display" ) === "table-cell";
		});
	};

	ColumnToggle.prototype.refreshPriority = function(){
		var self = this;
		$(this.headers).not( "td" ).each( function() {
			var $this = $( this ),
				priority = $this.attr("data-tablesaw-priority"),
				$cells = $this.add( this.cells );

			if( priority && priority !== "persist" ) {
				$cells.addClass( self.classes.priorityPrefix + priority );
			}
		});
	};

	ColumnToggle.prototype.destroy = function() {
		// table toolbars, document and window .tableId events
		// removed in parent tables.js destroy method

		this.$table.removeClass( this.classes.columnToggleTable );
		this.$table.find( 'th, td' ).each(function() {
			var $cell = $( this );
			$cell.removeClass( 'tablesaw-cell-hidden' )
				.removeClass( 'tablesaw-cell-visible' );

			this.className = this.className.replace( /\bui\-table\-priority\-\d\b/g, '' );
		});
	};

	// on tablecreate, init
	$( document ).on( "tablesawcreate", function( e, Tablesaw ){

		if( Tablesaw.mode === 'columntoggle' ){
			var table = new ColumnToggle( Tablesaw.table );
			table.init();
		}

	} );

	$( document ).on( "tablesawdestroy", function( e, Tablesaw ){
		if( Tablesaw.mode === 'columntoggle' ){
			$( Tablesaw.table ).data( 'tablesaw-coltoggle' ).destroy();
		}
	} );

}( this, jQuery ));
;(function( win, $, undefined ){

	$.extend( Tablesaw.config, {
		swipe: {
			horizontalThreshold: 15,
			verticalThreshold: 30
		}
	});

	function createSwipeTable( $table ){

		var $btns = $( "<div class='tablesaw-advance'></div>" ),
			$prevBtn = $( "<a href='#' class='tablesaw-nav-btn btn btn-micro left' title='Previous Column'></a>" ).appendTo( $btns ),
			$nextBtn = $( "<a href='#' class='tablesaw-nav-btn btn btn-micro right' title='Next Column'></a>" ).appendTo( $btns ),
			hideBtn = 'disabled',
			persistWidths = 'tablesaw-fix-persist',
			$headerCells = $table.find( "thead th" ),
			$headerCellsNoPersist = $headerCells.not( '[data-tablesaw-priority="persist"]' ),
			headerWidths = [],
			$head = $( document.head || 'head' ),
			tableId = $table.attr( 'id' ),
			// TODO switch this to an nth-child feature test
			isIE8 = $( 'html' ).is( '.ie-lte8' );

		if( !$headerCells.length ) {
			throw new Error( "tablesaw swipe: no header cells found. Are you using <th> inside of <thead>?" );
		}

		// Calculate initial widths
		$table.css('width', 'auto');
		$headerCells.each(function() {
			headerWidths.push( $( this ).outerWidth() );
		});
		$table.css( 'width', '' );

		$btns.appendTo( $table.prev( '.tablesaw-bar' ) );

		$table.addClass( "tablesaw-swipe" );

		if( !tableId ) {
			tableId = 'tableswipe-' + Math.round( Math.random() * 10000 );
			$table.attr( 'id', tableId );
		}

		function $getCells( headerCell ) {
			return $( headerCell.cells ).add( headerCell );
		}

		function showColumn( headerCell ) {
			$getCells( headerCell ).removeClass( 'tablesaw-cell-hidden' );
		}

		function hideColumn( headerCell ) {
			$getCells( headerCell ).addClass( 'tablesaw-cell-hidden' );
		}

		function persistColumn( headerCell ) {
			$getCells( headerCell ).addClass( 'tablesaw-cell-persist' );
		}

		function isPersistent( headerCell ) {
			return $( headerCell ).is( '[data-tablesaw-priority="persist"]' );
		}

		function unmaintainWidths() {
			$table.removeClass( persistWidths );
			$( '#' + tableId + '-persist' ).remove();
		}

		function maintainWidths() {
			var prefix = '#' + tableId + '.tablesaw-swipe ',
				styles = [],
				tableWidth = $table.width(),
				hash = [],
				newHash;

			$headerCells.each(function( index ) {
				var width;
				if( isPersistent( this ) ) {
					width = $( this ).outerWidth();

					// Only save width on non-greedy columns (take up less than 75% of table width)
					if( width < tableWidth * 0.75 ) {
						hash.push( index + '-' + width );
						styles.push( prefix + ' .tablesaw-cell-persist:nth-child(' + ( index + 1 ) + ') { width: ' + width + 'px; }' );
					}
				}
			});
			newHash = hash.join( '_' );

			$table.addClass( persistWidths );

			var $style = $( '#' + tableId + '-persist' );
			// If style element not yet added OR if the widths have changed
			if( !$style.length || $style.data( 'hash' ) !== newHash ) {
				// Remove existing
				$style.remove();

				if( styles.length ) {
					$( '<style>' + styles.join( "\n" ) + '</style>' )
						.attr( 'id', tableId + '-persist' )
						.data( 'hash', newHash )
						.appendTo( $head );
				}
			}
		}

		function getNext(){
			var next = [],
				checkFound;

			$headerCellsNoPersist.each(function( i ) {
				var $t = $( this ),
					isHidden = $t.css( "display" ) === "none" || $t.is( ".tablesaw-cell-hidden" );

				if( !isHidden && !checkFound ) {
					checkFound = true;
					next[ 0 ] = i;
				} else if( isHidden && checkFound ) {
					next[ 1 ] = i;

					return false;
				}
			});

			return next;
		}

		function getPrev(){
			var next = getNext();
			return [ next[ 1 ] - 1 , next[ 0 ] - 1 ];
		}

		function nextpair( fwd ){
			return fwd ? getNext() : getPrev();
		}

		function canAdvance( pair ){
			return pair[ 1 ] > -1 && pair[ 1 ] < $headerCellsNoPersist.length;
		}

		function matchesMedia() {
			var matchMedia = $table.attr( "data-tablesaw-swipe-media" );
			return !matchMedia || ( "matchMedia" in win ) && win.matchMedia( matchMedia ).matches;
		}

		function fakeBreakpoints() {
			if( !matchesMedia() ) {
				return;
			}

			var extraPaddingPixels = 20,
				containerWidth = $table.parent().width(),
				persist = [],
				sum = 0,
				sums = [],
				visibleNonPersistantCount = $headerCells.length;

			$headerCells.each(function( index ) {
				var $t = $( this ),
					isPersist = $t.is( '[data-tablesaw-priority="persist"]' );

				persist.push( isPersist );

				sum += headerWidths[ index ] + ( isPersist ? 0 : extraPaddingPixels );
				sums.push( sum );

				// is persistent or is hidden
				if( isPersist || sum > containerWidth ) {
					visibleNonPersistantCount--;
				}
			});

			var needsNonPersistentColumn = visibleNonPersistantCount === 0;

			$headerCells.each(function( index ) {
				if( persist[ index ] ) {

					// for visual box-shadow
					persistColumn( this );
					return;
				}

				if( sums[ index ] <= containerWidth || needsNonPersistentColumn ) {
					needsNonPersistentColumn = false;
					showColumn( this );
				} else {
					hideColumn( this );
				}
			});

			if( !isIE8 ) {
				unmaintainWidths();
			}
			$table.trigger( 'tablesawcolumns' );
		}

		function advance( fwd ){
			var pair = nextpair( fwd );
			if( canAdvance( pair ) ){
				if( isNaN( pair[ 0 ] ) ){
					if( fwd ){
						pair[0] = 0;
					}
					else {
						pair[0] = $headerCellsNoPersist.length - 1;
					}
				}

				if( !isIE8 ) {
					maintainWidths();
				}

				hideColumn( $headerCellsNoPersist.get( pair[ 0 ] ) );
				showColumn( $headerCellsNoPersist.get( pair[ 1 ] ) );

				$table.trigger( 'tablesawcolumns' );
			}
		}

		$prevBtn.add( $nextBtn ).click(function( e ){
			advance( !!$( e.target ).closest( $nextBtn ).length );
			e.preventDefault();
		});

		function getCoord( event, key ) {
			return ( event.touches || event.originalEvent.touches )[ 0 ][ key ];
		}

		$table
			.bind( "touchstart.swipetoggle", function( e ){
				var originX = getCoord( e, 'pageX' ),
					originY = getCoord( e, 'pageY' ),
					x,
					y;

				$( win ).off( "resize", fakeBreakpoints );

				$( this )
					.bind( "touchmove", function( e ){
						x = getCoord( e, 'pageX' );
						y = getCoord( e, 'pageY' );
						var cfg = Tablesaw.config.swipe;
						if( Math.abs( x - originX ) > cfg.horizontalThreshold && Math.abs( y - originY ) < cfg.verticalThreshold ) {
							e.preventDefault();
						}
					})
					.bind( "touchend.swipetoggle", function(){
						var cfg = Tablesaw.config.swipe;
						if( Math.abs( y - originY ) < cfg.verticalThreshold ) {
							if( x - originX < -1 * cfg.horizontalThreshold ){
								advance( true );
							}
							if( x - originX > cfg.horizontalThreshold ){
								advance( false );
							}
						}

						window.setTimeout(function() {
							$( win ).on( "resize", fakeBreakpoints );
						}, 300);
						$( this ).unbind( "touchmove touchend" );
					});

			})
			.bind( "tablesawcolumns.swipetoggle", function(){
				$prevBtn[ canAdvance( getPrev() ) ? "removeClass" : "addClass" ]( hideBtn );
				$nextBtn[ canAdvance( getNext() ) ? "removeClass" : "addClass" ]( hideBtn );
			})
			.bind( "tablesawnext.swipetoggle", function(){
				advance( true );
			} )
			.bind( "tablesawprev.swipetoggle", function(){
				advance( false );
			} )
			.bind( "tablesawdestroy.swipetoggle", function(){
				var $t = $( this );

				$t.removeClass( 'tablesaw-swipe' );
				$t.prev( '.tablesaw-bar' ).find( '.tablesaw-advance' ).remove();
				$( win ).off( "resize", fakeBreakpoints );

				$t.unbind( ".swipetoggle" );
			});

		fakeBreakpoints();
		$( win ).on( "resize", fakeBreakpoints );
	}



	// on tablecreate, init
	$( document ).on( "tablesawcreate", function( e, Tablesaw ){

		if( Tablesaw.mode === 'swipe' ){
			createSwipeTable( Tablesaw.$table );
		}

	} );

}( this, jQuery ));

;(function( $ ) {
	function getSortValue( cell ) {
		return $.map( cell.childNodes, function( el ) {
				var $el = $( el );
				if( $el.is( 'input, select' ) ) {
					return $el.val();
				} else if( $el.hasClass( 'tablesaw-cell-label' ) ) {
					return;
				}
				return $.trim( $el.text() );
			}).join( '' );
	}

	var pluginName = "tablesaw-sortable",
		initSelector = "table[data-" + pluginName + "]",
		sortableSwitchSelector = "[data-" + pluginName + "-switch]",
		attrs = {
			defaultCol: "data-tablesaw-sortable-default-col"
		},
		classes = {
			head: pluginName + "-head",
			ascend: pluginName + "-ascending",
			descend: pluginName + "-descending",
			switcher: pluginName + "-switch",
			tableToolbar: 'tablesaw-toolbar',
			sortButton: pluginName + "-btn"
		},
		methods = {
			_create: function( o ){
				return $( this ).each(function() {
					var init = $( this ).data( "init" + pluginName );
					if( init ) {
						return false;
					}
					$( this )
						.data( "init"+ pluginName, true )
						.trigger( "beforecreate." + pluginName )
						[ pluginName ]( "_init" , o )
						.trigger( "create." + pluginName );
				});
			},
			_init: function(){
				var el = $( this ),
					heads,
					$switcher;

				var addClassToTable = function(){
						el.addClass( pluginName );
					},
					addClassToHeads = function( h ){
						$.each( h , function( i , v ){
							$( v ).addClass( classes.head );
						});
					},
					makeHeadsActionable = function( h , fn ){
						$.each( h , function( i , v ){
							var b = $( "<button class='" + classes.sortButton + "'/>" );
							b.bind( "click" , { col: v } , fn );
							$( v ).wrapInner( b );
						});
					},
					clearOthers = function( sibs ){
						$.each( sibs , function( i , v ){
							var col = $( v );
							col.removeAttr( attrs.defaultCol );
							col.removeClass( classes.ascend );
							col.removeClass( classes.descend );
						});
					},
					headsOnAction = function( e ){
						if( $( e.target ).is( 'a[href]' ) ) {
							return;
						}

						e.stopPropagation();
						var head = $( this ).parent(),
							v = e.data.col,
							newSortValue = heads.index( head );

						clearOthers( head.siblings() );
						if( head.hasClass( classes.descend ) ){
							el[ pluginName ]( "sortBy" , v , true);
							newSortValue += '_asc';
						} else {
							el[ pluginName ]( "sortBy" , v );
							newSortValue += '_desc';
						}
						if( $switcher ) {
							$switcher.find( 'select' ).val( newSortValue ).trigger( 'refresh' );
						}

						e.preventDefault();
					},
					handleDefault = function( heads ){
						$.each( heads , function( idx , el ){
							var $el = $( el );
							if( $el.is( "[" + attrs.defaultCol + "]" ) ){
								if( !$el.hasClass( classes.descend ) ) {
									$el.addClass( classes.ascend );
								}
							}
						});
					},
					addSwitcher = function( heads ){
						$switcher = $( '<div>' ).addClass( classes.switcher ).addClass( classes.tableToolbar ).html(function() {
							var html = [ '<label>' + Tablesaw.i18n.sort + ':' ];

							html.push( '<span class="btn btn-small">&#160;<select>' );
							heads.each(function( j ) {
								var $t = $( this ),
									isDefaultCol = $t.is( "[" + attrs.defaultCol + "]" ),
									isDescending = $t.hasClass( classes.descend ),
									isNumeric = false;

								// Check only the first three rows to see if the column is numbers.
								$( this.cells ).slice( 0, 3 ).each(function() {
									if( !isNaN( parseInt( getSortValue( this ), 10 ) ) ) {
										isNumeric = true;
										return false;
									}
								});

								html.push( '<option' + ( isDefaultCol && !isDescending ? ' selected' : '' ) + ' value="' + j + '_asc">' + $t.text() + ' ' + ( isNumeric ? '↑' : '(A-Z)' ) + '</option>' );
								html.push( '<option' + ( isDefaultCol && isDescending ? ' selected' : '' ) + ' value="' + j + '_desc">' + $t.text() + ' ' + ( isNumeric ? '↓' : '(Z-A)' ) + '</option>' );
							});
							html.push( '</select></span></label>' );

							return html.join('');
						});

						var $toolbar = el.prev( '.tablesaw-bar' ),
							$firstChild = $toolbar.children().eq( 0 );

						if( $firstChild.length ) {
							$switcher.insertBefore( $firstChild );
						} else {
							$switcher.appendTo( $toolbar );
						}
						$switcher.find( '.btn' ).tablesawbtn();
						$switcher.find( 'select' ).on( 'change', function() {
							var val = $( this ).val().split( '_' ),
								head = heads.eq( val[ 0 ] );

							clearOthers( head.siblings() );
							el[ pluginName ]( 'sortBy', head.get( 0 ), val[ 1 ] === 'asc' );
						});
					};

					addClassToTable();
					heads = el.find( "thead th[data-" + pluginName + "-col]" );
					addClassToHeads( heads );
					makeHeadsActionable( heads , headsOnAction );
					handleDefault( heads );

					if( el.is( sortableSwitchSelector ) ) {
						addSwitcher( heads, el.find('tbody tr:nth-child(-n+3)') );
					}
			},
			getColumnNumber: function( col ){
				return $( col ).prevAll().length;
			},
			getTableRows: function(){
				return $( this ).find( "tbody tr" );
			},
			sortRows: function( rows , colNum , ascending, col ){
				var cells, fn, sorted;
				var getCells = function( rows ){
						var cells = [];
						$.each( rows , function( i , r ){
							cells.push({
								cell: getSortValue( $( r ).children().get( colNum ) ),
								rowNum: i
							});
						});
						return cells;
					},
					getSortFxn = function( ascending, forceNumeric ){
						var fn,
							regex = /[^\-\+\d\.]/g;
						if( ascending ){
							fn = function( a , b ){
								if( forceNumeric || !isNaN( parseFloat( a.cell ) ) ) {
									return parseFloat( a.cell.replace( regex, '' ) ) - parseFloat( b.cell.replace( regex, '' ) );
								} else {
									return a.cell.toLowerCase() > b.cell.toLowerCase() ? 1 : -1;
								}
							};
						} else {
							fn = function( a , b ){
								if( forceNumeric || !isNaN( parseFloat( a.cell ) ) ) {
									return parseFloat( b.cell.replace( regex, '' ) ) - parseFloat( a.cell.replace( regex, '' ) );
								} else {
									return a.cell.toLowerCase() < b.cell.toLowerCase() ? 1 : -1;
								}
							};
						}
						return fn;
					},
					applyToRows = function( sorted , rows ){
						var newRows = [], i, l, cur;
						for( i = 0, l = sorted.length ; i < l ; i++ ){
							cur = sorted[ i ].rowNum;
							newRows.push( rows[cur] );
						}
						return newRows;
					};

				cells = getCells( rows );
				var customFn = $( col ).data( 'tablesaw-sort' );
				fn = ( customFn && typeof customFn === "function" ? customFn( ascending ) : false ) ||
					getSortFxn( ascending, $( col ).is( '[data-sortable-numeric]' ) );
				sorted = cells.sort( fn );
				rows = applyToRows( sorted , rows );
				return rows;
			},
			replaceTableRows: function( rows ){
				var el = $( this ),
					body = el.find( "tbody" );
				body.html( rows );
			},
			makeColDefault: function( col , a ){
				var c = $( col );
				c.attr( attrs.defaultCol , "true" );
				if( a ){
					c.removeClass( classes.descend );
					c.addClass( classes.ascend );
				} else {
					c.removeClass( classes.ascend );
					c.addClass( classes.descend );
				}
			},
			sortBy: function( col , ascending ){
				var el = $( this ), colNum, rows;

				colNum = el[ pluginName ]( "getColumnNumber" , col );
				rows = el[ pluginName ]( "getTableRows" );
				rows = el[ pluginName ]( "sortRows" , rows , colNum , ascending, col );
				el[ pluginName ]( "replaceTableRows" , rows );
				el[ pluginName ]( "makeColDefault" , col , ascending );
			}
		};

	// Collection method.
	$.fn[ pluginName ] = function( arrg ) {
		var args = Array.prototype.slice.call( arguments , 1),
			returnVal;

		// if it's a method
		if( arrg && typeof( arrg ) === "string" ){
			returnVal = $.fn[ pluginName ].prototype[ arrg ].apply( this[0], args );
			return (typeof returnVal !== "undefined")? returnVal:$(this);
		}
		// check init
		if( !$( this ).data( pluginName + "data" ) ){
			$( this ).data( pluginName + "active", true );
			$.fn[ pluginName ].prototype._create.call( this , arrg );
		}
		return $(this);
	};
	// add methods
	$.extend( $.fn[ pluginName ].prototype, methods );

	$( document ).on( "tablesawcreate", function( e, Tablesaw ) {
		if( Tablesaw.$table.is( initSelector ) ) {
			Tablesaw.$table[ pluginName ]();
		}
	});

}( jQuery ));

;(function( win, $, undefined ){

	var MM = {
		attr: {
			init: 'data-tablesaw-minimap'
		}
	};

	function createMiniMap( $table ){

		var $btns = $( '<div class="tablesaw-advance minimap">' ),
			$dotNav = $( '<ul class="tablesaw-advance-dots">' ).appendTo( $btns ),
			hideDot = 'tablesaw-advance-dots-hide',
			$headerCells = $table.find( 'thead th' );

		// populate dots
		$headerCells.each(function(){
			$dotNav.append( '<li><i></i></li>' );
		});

		$btns.appendTo( $table.prev( '.tablesaw-bar' ) );

		function showMinimap( $table ) {
			var mq = $table.attr( MM.attr.init );
			return !mq || win.matchMedia && win.matchMedia( mq ).matches;
		}

		function showHideNav(){
			if( !showMinimap( $table ) ) {
				$btns.hide();
				return;
			}
			$btns.show();

			// show/hide dots
			var dots = $dotNav.find( "li" ).removeClass( hideDot );
			$table.find( "thead th" ).each(function(i){
				if( $( this ).css( "display" ) === "none" ){
					dots.eq( i ).addClass( hideDot );
				}
			});
		}

		// run on init and resize
		showHideNav();
		$( win ).on( "resize", showHideNav );


		$table
			.bind( "tablesawcolumns.minimap", function(){
				showHideNav();
			})
			.bind( "tablesawdestroy.minimap", function(){
				var $t = $( this );

				$t.prev( '.tablesaw-bar' ).find( '.tablesaw-advance' ).remove();
				$( win ).off( "resize", showHideNav );

				$t.unbind( ".minimap" );
			});
	}



	// on tablecreate, init
	$( document ).on( "tablesawcreate", function( e, Tablesaw ){

		if( ( Tablesaw.mode === 'swipe' || Tablesaw.mode === 'columntoggle' ) && Tablesaw.$table.is( '[ ' + MM.attr.init + ']' ) ){
			createMiniMap( Tablesaw.$table );
		}

	} );

}( this, jQuery ));

;(function( win, $ ) {

	var S = {
		selectors: {
			init: 'table[data-tablesaw-mode-switch]'
		},
		attributes: {
			excludeMode: 'data-tablesaw-mode-exclude'
		},
		classes: {
			main: 'tablesaw-modeswitch',
			toolbar: 'tablesaw-toolbar'
		},
		modes: [ 'stack', 'swipe', 'columntoggle' ],
		init: function( table ) {
			var $table = $( table ),
				ignoreMode = $table.attr( S.attributes.excludeMode ),
				$toolbar = $table.prev( '.tablesaw-bar' ),
				modeVal = '',
				$switcher = $( '<div>' ).addClass( S.classes.main + ' ' + S.classes.toolbar ).html(function() {
					var html = [ '<label>' + Tablesaw.i18n.columns + ':' ],
						dataMode = $table.attr( 'data-tablesaw-mode' ),
						isSelected;

					html.push( '<span class="btn btn-small">&#160;<select>' );
					for( var j=0, k = S.modes.length; j<k; j++ ) {
						if( ignoreMode && ignoreMode.toLowerCase() === S.modes[ j ] ) {
							continue;
						}

						isSelected = dataMode === S.modes[ j ];

						if( isSelected ) {
							modeVal = S.modes[ j ];
						}

						html.push( '<option' +
							( isSelected ? ' selected' : '' ) +
							' value="' + S.modes[ j ] + '">' + Tablesaw.i18n.modes[ j ] + '</option>' );
					}
					html.push( '</select></span></label>' );

					return html.join('');
				});

			var $otherToolbarItems = $toolbar.find( '.tablesaw-advance' ).eq( 0 );
			if( $otherToolbarItems.length ) {
				$switcher.insertBefore( $otherToolbarItems );
			} else {
				$switcher.appendTo( $toolbar );
			}

			$switcher.find( '.btn' ).tablesawbtn();
			$switcher.find( 'select' ).bind( 'change', S.onModeChange );
		},
		onModeChange: function() {
			var $t = $( this ),
				$switcher = $t.closest( '.' + S.classes.main ),
				$table = $t.closest( '.tablesaw-bar' ).nextUntil( $table ).eq( 0 ),
				val = $t.val();

			$switcher.remove();
			$table.data( 'table' ).destroy();

			$table.attr( 'data-tablesaw-mode', val );
			$table.table();
		}
	};

	$( win.document ).on( "tablesawcreate", function( e, Tablesaw ) {
		if( Tablesaw.$table.is( S.selectors.init ) ) {
			S.init( Tablesaw.table );
		}
	});

})( this, jQuery );